var $8zHUo$reactjsxruntime = require("react/jsx-runtime");
var $8zHUo$react = require("react");
var $8zHUo$nextlink = require("next/link");
var $8zHUo$reacthottoast = require("react-hot-toast");
var $8zHUo$nextrouter = require("next/router");
var $8zHUo$axios = require("axios");
var $8zHUo$cookiesnext = require("cookies-next");
var $8zHUo$radixuireacttooltip = require("@radix-ui/react-tooltip");
var $8zHUo$reactintl = require("react-intl");
var $8zHUo$nextimage = require("next/image");
var $8zHUo$nexthead = require("next/head");
var $8zHUo$tanstackreactquery = require("@tanstack/react-query");
var $8zHUo$html2canvas = require("html2canvas");
var $8zHUo$reactselect = require("react-select");
var $8zHUo$reactselectasync = require("react-select/async");
var $8zHUo$yup = require("yup");
var $8zHUo$formik = require("formik");
var $8zHUo$crypto = require("crypto");
var $8zHUo$antdlibtableTable = require("antd/lib/table/Table");
var $8zHUo$monacoeditorreact = require("@monaco-editor/react");
var $8zHUo$tinymcetinymcereact = require("@tinymce/tinymce-react");
var $8zHUo$antd = require("antd");
var $8zHUo$reactjoyride = require("react-joyride");
var $8zHUo$nextdistclientrouter = require("next/dist/client/router");
var $8zHUo$tanstackreactquerydevtools = require("@tanstack/react-query-devtools");

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "Login", () => $d916a442134b0b1f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Status", () => $b8f3178562702f6a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Feedback", () => $2d29678395c15724$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackIframe", () => $ba56bb58a40c98c6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Button", () => $5fdb2d257c0eb8fa$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LinkButton", () => $57a30357babe1d4b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Select", () => $acfe242336feac07$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TestContainerAsyncSelect", () => $9332f8245db3249e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Dropdown", () => $4614f04a29cdaba6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownThreedots", () => $9cbcf03b1d9fcebb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Breadcrumb", () => $d931a28748357de7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BreadcrumbItem", () => $f5cf44f19e560728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BreadcrumbWrapper", () => $914ff39ce18c573d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Input", () => $ce350b8ddb52fbc0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Card", () => $c72cc7078ff265fd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CopyButton", () => $ffe80b878f95bd4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Tooltip", () => $44038773e462e3e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Table", () => $297cf2030b5a81ff$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TableSidebox", () => $3269c668a5bedaa4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Expander", () => $cd8d8c08d73cec8e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Header", () => $5dfea0bb116ddcc5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Footer", () => $bd4a4726b6240f52$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Modal", () => $c6ca657a0ac608c7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TestContainerModal", () => $1a5096178588becb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TextArea", () => $fb3e40c1425686ec$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CodeEditor", () => $370bcc888ab41098$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RichTextEditor", () => $1461237555295b62$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DemoRich", () => $aecc8624ff6c67d5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DemoIDE", () => $10f76c162c1d212a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Toggle", () => $29684f8cc6c5104d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Logo", () => $59ff00cb4a4db4e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Tour", () => $e99b308431b3fe4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TourTestContainer", () => $2ccd6e4903b02b82$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TourControlledTest", () => $0dd51487be0e45df$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TourBasicInteractive", () => $105abc3b490cb9f5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TourBasicChained", () => $c7ed335d56a3ffe6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TourMultiplePage1", () => $1a4e641a86266fe1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TourMultiplePage2", () => $ed9993b237e0ea73$export$2e2bcd8739ae039);
$parcel$export(module.exports, "WithSkeletonLoader", () => $af67bda176efb977$export$2e2bcd8739ae039);
$parcel$export(module.exports, "HomeSkeleton", () => $af2f8657ba9541a3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LoginSkeleton", () => $78144f1d8a648789$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PageLayout", () => $347e58672d17cf52$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Sidebar", () => $5a923ab70f6d5e4c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackModal", () => $8945e51c91a55fa1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackLegacy", () => $afff8ad084a50781$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FrameContainer", () => $b5d8fc0c2957cad4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Loader", () => $9d897b2068c8ec05$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AppContextProvider", () => $c022715bc9d219e1$export$2e2bcd8739ae039);
// components views





var $89c98702a6323988$exports = {};

$parcel$export($89c98702a6323988$exports, "IconDashboard", () => $89c98702a6323988$export$a757f1a0a0906316);
$parcel$export($89c98702a6323988$exports, "IconBulb", () => $89c98702a6323988$export$9ad93805e560c2d);
$parcel$export($89c98702a6323988$exports, "IconProducts", () => $89c98702a6323988$export$c7ce57ead3e133a6);
$parcel$export($89c98702a6323988$exports, "IconTenant", () => $89c98702a6323988$export$5b3b0fb57cca60d0);
$parcel$export($89c98702a6323988$exports, "IconHostname", () => $89c98702a6323988$export$a4db87d1108b814e);
$parcel$export($89c98702a6323988$exports, "IconChevronDown", () => $89c98702a6323988$export$59f995884fc5e26a);
$parcel$export($89c98702a6323988$exports, "IconMagnifier", () => $89c98702a6323988$export$318011e1c5c2ad59);
$parcel$export($89c98702a6323988$exports, "IconDuplicate", () => $89c98702a6323988$export$62b5e6d9957cff7b);
$parcel$export($89c98702a6323988$exports, "IconChevronUp", () => $89c98702a6323988$export$744aedc8c31adee6);
$parcel$export($89c98702a6323988$exports, "IconXCirle", () => $89c98702a6323988$export$2d4c0e26be08b272);
$parcel$export($89c98702a6323988$exports, "IconClipboard", () => $89c98702a6323988$export$ae118f79ed05e2c0);
$parcel$export($89c98702a6323988$exports, "IconCheck", () => $89c98702a6323988$export$41713cd023818a26);
$parcel$export($89c98702a6323988$exports, "IconParameter", () => $89c98702a6323988$export$77a99f4d7c4f431b);
$parcel$export($89c98702a6323988$exports, "IconLogout", () => $89c98702a6323988$export$e567233157f95aa8);
$parcel$export($89c98702a6323988$exports, "IconMenu", () => $89c98702a6323988$export$94155298424a8522);
$parcel$export($89c98702a6323988$exports, "IconClose", () => $89c98702a6323988$export$e04bcc6127e699bf);
$parcel$export($89c98702a6323988$exports, "IconAdd", () => $89c98702a6323988$export$4176b1d4e95be624);
$parcel$export($89c98702a6323988$exports, "IconAddCircle", () => $89c98702a6323988$export$608ad8729163be64);
$parcel$export($89c98702a6323988$exports, "IconMailFilled", () => $89c98702a6323988$export$63d8b75acbf91639);
$parcel$export($89c98702a6323988$exports, "IconLockFilled", () => $89c98702a6323988$export$d751189d0d6ceeb2);
$parcel$export($89c98702a6323988$exports, "IconArrowUp", () => $89c98702a6323988$export$3577c0003511ce2d);
$parcel$export($89c98702a6323988$exports, "IconArrowDown", () => $89c98702a6323988$export$403194946ee83bdf);
$parcel$export($89c98702a6323988$exports, "IconPlay", () => $89c98702a6323988$export$4b2505a64d1f53bd);
$parcel$export($89c98702a6323988$exports, "IconFilter", () => $89c98702a6323988$export$625671e92c10ce58);
$parcel$export($89c98702a6323988$exports, "IconLightning", () => $89c98702a6323988$export$d4827f8a395c29f4);
$parcel$export($89c98702a6323988$exports, "IconSearch", () => $89c98702a6323988$export$2be804e19c04baed);
$parcel$export($89c98702a6323988$exports, "IconReport", () => $89c98702a6323988$export$8617ab0e4aa15e01);
$parcel$export($89c98702a6323988$exports, "IconThreeDotsHorizontal", () => $89c98702a6323988$export$73be7394595c1628);
$parcel$export($89c98702a6323988$exports, "IconThreeDotsVertical", () => $89c98702a6323988$export$18bb29f4c87c802c);
$parcel$export($89c98702a6323988$exports, "IconRefresh", () => $89c98702a6323988$export$e8ec8c95cde4bd24);
$parcel$export($89c98702a6323988$exports, "IconPrint", () => $89c98702a6323988$export$61207fb985d79449);
$parcel$export($89c98702a6323988$exports, "IconEdit", () => $89c98702a6323988$export$b51dd496211ae105);
$parcel$export($89c98702a6323988$exports, "IconTrash", () => $89c98702a6323988$export$d8c7204c1f47773e);
$parcel$export($89c98702a6323988$exports, "IconManageTenants", () => $89c98702a6323988$export$d791817809bc808f);


const $89c98702a6323988$export$a757f1a0a0906316 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 13H10C10.55 13 11 12.55 11 12V4C11 3.45 10.55 3 10 3H4C3.45 3 3 3.45 3 4V12C3 12.55 3.45 13 4 13ZM4 21H10C10.55 21 11 20.55 11 20V16C11 15.45 10.55 15 10 15H4C3.45 15 3 15.45 3 16V20C3 20.55 3.45 21 4 21ZM14 21H20C20.55 21 21 20.55 21 20V12C21 11.45 20.55 11 20 11H14C13.45 11 13 11.45 13 12V20C13 20.55 13.45 21 14 21ZM13 4V8C13 8.55 13.45 9 14 9H20C20.55 9 21 8.55 21 8V4C21 3.45 20.55 3 20 3H14C13.45 3 13 3.45 13 4Z",
            fill: "currentColor"
        })
    });
const $89c98702a6323988$export$9ad93805e560c2d = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18"
        })
    });
const $89c98702a6323988$export$c7ce57ead3e133a6 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
        })
    });
const $89c98702a6323988$export$5b3b0fb57cca60d0 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
        })
    });
const $89c98702a6323988$export$a4db87d1108b814e = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
        })
    });
const $89c98702a6323988$export$59f995884fc5e26a = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M19 9l-7 7-7-7"
        })
    });
const $89c98702a6323988$export$318011e1c5c2ad59 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
        })
    });
const $89c98702a6323988$export$62b5e6d9957cff7b = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
        })
    });
const $89c98702a6323988$export$744aedc8c31adee6 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className + ` transform rotate-180`,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M19 9l-7 7-7-7"
        })
    });
const $89c98702a6323988$export$2d4c0e26be08b272 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        className: className,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })
    });
const $89c98702a6323988$export$ae118f79ed05e2c0 = ({ className: className , ...options })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "none",
        stroke: "currentColor",
        className: className,
        ...options,
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M7 3.5A1.5 1.5 0 018.5 2h3.879a1.5 1.5 0 011.06.44l3.122 3.12A1.5 1.5 0 0117 6.622V12.5a1.5 1.5 0 01-1.5 1.5h-1v-3.379a3 3 0 00-.879-2.121L10.5 5.379A3 3 0 008.379 4.5H7v-1z"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M4.5 6A1.5 1.5 0 003 7.5v9A1.5 1.5 0 004.5 18h7a1.5 1.5 0 001.5-1.5v-5.879a1.5 1.5 0 00-.44-1.06L9.44 6.439A1.5 1.5 0 008.378 6H4.5z"
            })
        ]
    });
const $89c98702a6323988$export$41713cd023818a26 = ({ className: className , ...options })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "none",
        stroke: "currentColor",
        className: className,
        ...options,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            d: "M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z",
            clipRule: "evenodd"
        })
    });
const $89c98702a6323988$export$77a99f4d7c4f431b = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.57 5.11 19.4 5.02 19.22 5.02C19.16 5.02 19.1 5.03 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H10C9.75002 2 9.54002 2.18 9.51002 2.42L9.13002 5.07C8.52002 5.32 7.96002 5.66 7.44002 6.05L4.95002 5.05C4.89002 5.03 4.83002 5.02 4.77002 5.02C4.60002 5.02 4.43002 5.11 4.34002 5.27L2.34002 8.73C2.21002 8.95 2.27002 9.22 2.46002 9.37L4.57002 11.02C4.53002 11.34 4.50002 11.67 4.50002 12C4.50002 12.33 4.53002 12.66 4.57002 12.98L2.46002 14.63C2.27002 14.78 2.22002 15.05 2.34002 15.27L4.34002 18.73C4.43002 18.89 4.60002 18.98 4.78002 18.98C4.84002 18.98 4.90002 18.97 4.95002 18.95L7.44002 17.95C7.96002 18.35 8.52002 18.68 9.13002 18.93L9.51002 21.58C9.54002 21.82 9.75002 22 10 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.11 18.97 19.17 18.98 19.23 18.98C19.4 18.98 19.57 18.89 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM17.45 11.27C17.49 11.58 17.5 11.79 17.5 12C17.5 12.21 17.48 12.43 17.45 12.73L17.31 13.86L18.2 14.56L19.28 15.4L18.58 16.61L17.31 16.1L16.27 15.68L15.37 16.36C14.94 16.68 14.53 16.92 14.12 17.09L13.06 17.52L12.9 18.65L12.7 20H11.3L11.11 18.65L10.95 17.52L9.89002 17.09C9.46002 16.91 9.06002 16.68 8.66002 16.38L7.75002 15.68L6.69002 16.11L5.42002 16.62L4.72002 15.41L5.80002 14.57L6.69002 13.87L6.55002 12.74C6.52002 12.43 6.50002 12.2 6.50002 12C6.50002 11.8 6.52002 11.57 6.55002 11.27L6.69002 10.14L5.80002 9.44L4.72002 8.6L5.42002 7.39L6.69002 7.9L7.73002 8.32L8.63002 7.64C9.06002 7.32 9.47002 7.08 9.88002 6.91L10.94 6.48L11.1 5.35L11.3 4H12.69L12.88 5.35L13.04 6.48L14.1 6.91C14.53 7.09 14.93 7.32 15.33 7.62L16.24 8.32L17.3 7.89L18.57 7.38L19.27 8.59L18.2 9.44L17.31 10.14L17.45 11.27ZM12 8C9.79002 8 8.00002 9.79 8.00002 12C8.00002 14.21 9.79002 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z",
            fill: "currentColor"
        })
    });
const $89c98702a6323988$export$e567233157f95aa8 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z",
            fill: "currentColor "
        })
    });
const $89c98702a6323988$export$94155298424a8522 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M4 6h16M4 12h16M4 18h16"
        })
    });
const $89c98702a6323988$export$e04bcc6127e699bf = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M6 18L18 6M6 6l12 12"
        })
    });
const $89c98702a6323988$export$4176b1d4e95be624 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M12 4v16m8-8H4"
        })
    });
const $89c98702a6323988$export$608ad8729163be64 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
        })
    });
const $89c98702a6323988$export$63d8b75acbf91639 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
            })
        ]
    });
const $89c98702a6323988$export$d751189d0d6ceeb2 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        viewBox: "0 0 20 20",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
            clipRule: "evenodd"
        })
    });
const $89c98702a6323988$export$3577c0003511ce2d = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
        })
    });
const $89c98702a6323988$export$403194946ee83bdf = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className + "transform rotate-180",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
        })
    });
const $89c98702a6323988$export$4b2505a64d1f53bd = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            })
        ]
    });
const $89c98702a6323988$export$625671e92c10ce58 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
        })
    });
const $89c98702a6323988$export$d4827f8a395c29f4 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M13 10V3L4 14h7v7l9-11h-7z"
        })
    });
const $89c98702a6323988$export$2be804e19c04baed = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })
    });
const $89c98702a6323988$export$8617ab0e4aa15e01 = ({ className: className  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })
    });
const $89c98702a6323988$export$73be7394595c1628 = ({ className: className , onClick: onClick  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        onClick: onClick,
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
        })
    });
const $89c98702a6323988$export$18bb29f4c87c802c = ({ className: className , onClick: onClick  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        onClick: onClick,
        className: className + "transform rotate-180",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
        })
    });
const $89c98702a6323988$export$e8ec8c95cde4bd24 = ({ className: className , onClick: onClick  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        onClick: onClick,
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
        })
    });
const $89c98702a6323988$export$61207fb985d79449 = ({ className: className , onClick: onClick  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        onClick: onClick,
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
        })
    });
const $89c98702a6323988$export$b51dd496211ae105 = ({ className: className , onClick: onClick  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        onClick: onClick,
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
        })
    });
const $89c98702a6323988$export$d8c7204c1f47773e = ({ className: className , onClick: onClick  })=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        onClick: onClick,
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })
    });
const $89c98702a6323988$export$d791817809bc808f = ()=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
        className: " w-60 h-20 object-cover",
        viewBox: "0 0 108 119",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.24",
                        d: "M97.0751 21.4205C96.364 11.7768 88.9394 3.0381 79.5952 0.834877C71.1574 -1.15693 62.3364 1.80667 53.696 1.14274C50.343 0.883096 47.0379 0.078215 43.6738 -0.00709504C39.9761 -0.0734735 36.3128 0.716874 32.9669 2.30287C29.621 3.88886 26.6822 6.22804 24.3775 9.13962C18.9979 16.046 15.2912 24.6067 14.3774 33.3343C11.5771 60.1327 1.66175 66.8277 0.471621 74.4611C-4.13047 103.949 25.9397 117.717 49.8456 118.93C71.6475 120.043 100.774 106.159 104.437 101.452C109.732 94.635 108.192 77.5286 105.819 69.2127C103.917 62.5363 100.97 55.9117 100.406 48.9386C99.9417 43.156 100.487 39.7474 98.2247 34.0205C96.6403 30.0331 97.3846 25.6156 97.0751 21.4205Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M31.5294 92.6912L12.9699 97.9952L5.43488 71.2895L5.84755 70.6664L19.6502 67.2243L22.6679 68.2295L24.9486 69.3682L31.9421 92.068L31.5294 92.6912Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M99.1274 44.4577C99.1288 46.3655 98.7566 48.2549 98.032 50.0178C97.3074 51.7808 96.2446 53.3826 94.9045 54.7316C93.5643 56.0807 91.9731 57.1505 90.2219 57.8799C88.4706 58.6094 86.5937 58.9841 84.6984 58.9826H30.7445C26.951 59.0272 23.2927 57.5657 20.562 54.9146C17.8313 52.2636 16.248 48.6363 16.1549 44.8185C16.0619 41.0006 17.4667 37.2996 20.065 34.5169C22.6632 31.7342 26.2459 30.0939 30.037 29.9513C30.6022 26.7128 32.2817 23.778 34.7812 21.6613C37.2807 19.5446 40.4407 18.3812 43.707 18.3751H45.5493C48.776 18.3769 51.9019 19.5071 54.3924 21.5723C55.8067 17.9181 58.4465 14.8772 61.8542 12.9766C65.262 11.076 69.2229 10.4355 73.0505 11.1662C76.8781 11.8968 80.3312 13.9525 82.8112 16.977C85.2913 20.0014 86.6419 23.8041 86.6292 27.7258C86.6365 28.5091 86.5711 29.2914 86.4339 30.0625C89.932 30.4851 93.1551 32.1831 95.494 34.8355C97.8329 37.4879 99.1255 40.911 99.1274 44.4577Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M99.1274 44.4577C99.1288 46.3655 98.7566 48.2549 98.032 50.0178C97.3074 51.7808 96.2446 53.3826 94.9045 54.7316C93.5643 56.0807 91.9731 57.1505 90.2219 57.8799C88.4706 58.6094 86.5937 58.9841 84.6984 58.9826H30.7445C26.951 59.0272 23.2927 57.5657 20.562 54.9146C17.8313 52.2636 16.248 48.6363 16.1549 44.8185C16.0619 41.0006 17.4667 37.2996 20.065 34.5169C22.6632 31.7342 26.2459 30.0939 30.037 29.9513C30.6022 26.7128 32.2817 23.778 34.7812 21.6613C37.2807 19.5446 40.4407 18.3812 43.707 18.3751H45.5493C48.776 18.3769 51.9019 19.5071 54.3924 21.5723C55.8067 17.9181 58.4465 14.8772 61.8542 12.9766C65.262 11.076 69.2229 10.4355 73.0505 11.1662C76.8781 11.8968 80.3312 13.9525 82.8112 16.977C85.2913 20.0014 86.6419 23.8041 86.6292 27.7258C86.6365 28.5091 86.5711 29.2914 86.4339 30.0625C89.932 30.4851 93.1551 32.1831 95.494 34.8355C97.8329 37.4879 99.1255 40.911 99.1274 44.4577Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M98.9211 40.2774C98.9203 42.119 98.5482 43.9413 97.8275 45.634C97.1068 47.3267 96.0523 48.8546 94.728 50.1251C92.0035 52.756 88.3706 54.2188 84.5953 54.2052H31.0246C23.0952 54.2052 16.6729 47.9887 16.6729 40.2848C16.675 38.4428 17.0476 36.6203 17.7682 34.9272C18.4888 33.2341 19.5426 31.7054 20.866 30.4334C23.42 27.9655 26.7834 26.5246 30.3208 26.383C30.8129 23.6475 32.1547 21.1397 34.1528 19.2207C36.7718 16.6872 40.2664 15.2774 43.8986 15.289H45.7409C48.9253 15.2855 52.0177 16.3636 54.5177 18.349C56.9127 12.3662 62.8929 8.12666 69.9305 8.12666C79.0942 8.12666 86.5113 15.3335 86.5113 24.2391C86.5179 24.9856 86.4525 25.7309 86.316 26.4646C93.42 27.2992 98.9211 33.1633 98.9211 40.2774Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M30.6486 77.6024H21.496C21.2028 77.6024 20.9217 77.4852 20.7144 77.2765C20.5071 77.0678 20.3906 76.7848 20.3906 76.4897C20.3906 76.1945 20.5071 75.9115 20.7144 75.7028C20.9217 75.4941 21.2028 75.3769 21.496 75.3769H30.6486C31.3268 75.3769 31.9772 75.1057 32.4568 74.623C32.9363 74.1402 33.2057 73.4855 33.2057 72.8028V56.9425C33.2057 56.6474 33.3222 56.3644 33.5295 56.1557C33.7368 55.947 34.0179 55.8298 34.3111 55.8298C34.6043 55.8298 34.8854 55.947 35.0927 56.1557C35.3 56.3644 35.4165 56.6474 35.4165 56.9425V72.8139C35.4145 74.0852 34.9112 75.3037 34.0172 76.2016C33.1231 77.0995 31.9115 77.6034 30.6486 77.6024Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M85.2807 77.6024H76.1281C74.8665 77.6014 73.6567 77.0967 72.7643 76.199C71.8718 75.3013 71.3695 74.0839 71.3676 72.8139V56.9425C71.3676 56.6474 71.484 56.3644 71.6913 56.1557C71.8986 55.947 72.1798 55.8298 72.4729 55.8298C72.7661 55.8298 73.0473 55.947 73.2546 56.1557C73.4619 56.3644 73.5783 56.6474 73.5783 56.9425V72.8139C73.5783 73.4966 73.8477 74.1513 74.3273 74.6341C74.8069 75.1168 75.4573 75.388 76.1355 75.388H85.2881C85.5812 75.388 85.8624 75.5053 86.0697 75.7139C86.277 75.9226 86.3934 76.2057 86.3934 76.5008C86.3934 76.7959 86.277 77.0789 86.0697 77.2876C85.8624 77.4963 85.5812 77.6135 85.2881 77.6135L85.2807 77.6024Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.8345 98.1287C54.5414 98.1287 54.2602 98.0115 54.0529 97.8028C53.8456 97.5942 53.7291 97.3111 53.7291 97.016V58.1888C53.7291 57.8937 53.8456 57.6107 54.0529 57.402C54.2602 57.1933 54.5414 57.0761 54.8345 57.0761C55.1277 57.0761 55.4089 57.1933 55.6162 57.402C55.8235 57.6107 55.9399 57.8937 55.9399 58.1888V97.0197C55.9389 97.3142 55.822 97.5963 55.6149 97.8041C55.4077 98.012 55.1271 98.1287 54.8345 98.1287Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.5141 18.3491L58.2797 22.2697C58.2797 22.2697 60.6195 8.12304 75.3617 9.09484C75.3617 9.09484 61.4927 4.1654 54.5141 18.3491Z",
                        fill: "url(#paint1_linear)"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M30.3208 26.3831C30.3208 26.3831 32.9995 26.0826 35.5492 29.2057C35.5492 29.2057 36.0983 16.5947 46.7395 16.3758C46.7395 16.3758 42.3805 13.5717 36.3046 17.5183C30.8624 21.0493 30.3208 26.3831 30.3208 26.3831Z",
                        fill: "url(#paint2_linear)"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M31.9419 92.068L13.3825 97.372L5.84741 70.6663L20.0627 66.6011L23.0804 67.6025L25.3612 68.745L31.9419 92.068Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M20.0038 66.6011L23.2094 70.6811L25.4202 68.6708C25.4202 68.6708 22.4835 67.1463 20.0038 66.6011Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.1",
                        d: "M23.2094 70.67C23.2094 70.67 24.499 70.1767 24.9375 70.5662C25.376 70.9556 30.984 92.3573 30.984 92.3573L31.942 92.0643L25.4055 68.6597L23.2094 70.67Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M10.2542 75.6774L22.9772 72.2835L23.2351 73.0995L10.5269 76.549L10.2542 75.6774Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M11.0796 78.5371L23.8026 75.1433L24.0605 75.9593L11.3523 79.4088L11.0796 78.5371Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M11.9087 81.4005L24.628 78.0067L24.8896 78.819L12.1776 82.2684L11.9087 81.4005Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M12.734 84.2603L25.457 80.8664L25.715 81.6787L13.0067 85.1282L12.734 84.2603Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M44.2118 92.4835L64.9268 95.588L61.43 114.775L40.4535 111.103L44.2118 92.4835Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M44.0239 92.105L64.7389 95.2096L61.2422 114.397L40.2656 110.725L44.0239 92.105Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M44.2118 92.4835L64.363 95.6436L60.8958 113.922L40.623 110.347L44.2118 92.4835Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M45.6413 94.338L43.6111 105.692L52.8595 101.493L55.903 105.807L53.7622 107.735L58.5375 104.631L60.6783 107.431L62.8227 97.2905L45.6413 94.338Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M88.6188 89.4011L82.2112 80.4621L89.9489 68.4037L97.7308 78.9525C97.7308 78.9525 99.7205 82.7877 97.8229 84.5459C95.9254 86.304 93.9725 84.0637 94.0941 83.2403C94.2157 82.4168 96.7433 79.1602 96.7433 79.1602L92.1965 73.0995L85.4721 83.0474L90.4316 90.3766C91.537 92.3833 90.9216 95.0242 88.8988 96.0887C88.521 96.3073 88.0977 96.4339 87.6626 96.4584C87.2276 96.4829 86.7929 96.4045 86.3932 96.2296C83.9982 95.1837 88.6188 89.4011 88.6188 89.4011Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M88.9284 89.2973L82.5209 80.3583L90.2586 68.2999L98.0405 78.8487C98.0405 78.8487 100.03 82.6839 98.1326 84.442C96.235 86.2002 94.2822 83.9599 94.4038 83.1364C94.5254 82.313 97.053 79.0564 97.053 79.0564L92.5172 72.9994L85.7928 82.9473L90.756 90.2765C91.8614 92.2831 91.2424 94.924 89.2195 95.9886C88.8418 96.2072 88.4184 96.3338 87.9834 96.3583C87.5483 96.3827 87.1136 96.3044 86.714 96.1295C84.3116 95.0798 88.9284 89.2973 88.9284 89.2973Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M89.3743 89.2306L82.9704 80.2879L90.7081 68.2332L98.49 78.7782C98.49 78.7782 100.476 82.6135 98.5822 84.3753C96.6883 86.1371 94.7317 83.8931 94.8533 83.066C94.9749 82.2389 97.5026 78.9859 97.5026 78.9859L92.9557 72.9252L86.2276 82.8731L91.1908 90.2024C92.2962 92.2127 91.6809 94.8499 89.6543 95.9144C89.2775 96.1338 88.8547 96.2609 88.4201 96.2854C87.9855 96.3099 87.5512 96.2311 87.1525 96.0554C84.7574 95.0094 89.3743 89.2306 89.3743 89.2306Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.9046 77.2946C56.8073 77.2946 58.3497 75.7419 58.3497 73.8266C58.3497 71.9112 56.8073 70.3585 54.9046 70.3585C53.0019 70.3585 51.4595 71.9112 51.4595 73.8266C51.4595 75.7419 53.0019 77.2946 54.9046 77.2946Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.9046 78.3999C54.0051 78.4006 53.1255 78.1327 52.3772 77.6301C51.6289 77.1274 51.0455 76.4126 50.7009 75.5761C50.3563 74.7396 50.266 73.819 50.4413 72.9308C50.6166 72.0426 51.0498 71.2267 51.6859 70.5864C52.322 69.946 53.1325 69.51 54.0148 69.3335C54.8972 69.1571 55.8117 69.248 56.6427 69.5949C57.4736 69.9418 58.1837 70.529 58.683 71.2823C59.1824 72.0355 59.4485 72.921 59.4478 73.8265C59.4458 75.0389 58.9666 76.201 58.115 77.0582C57.2634 77.9155 56.109 78.3979 54.9046 78.3999ZM54.9046 71.4675C54.4412 71.4675 53.9881 71.6059 53.6027 71.8651C53.2173 72.1243 52.917 72.4927 52.7396 72.9238C52.5622 73.3549 52.5158 73.8292 52.6062 74.2868C52.6967 74.7444 52.9199 75.1647 53.2476 75.4946C53.5753 75.8245 53.9929 76.0492 54.4475 76.1402C54.902 76.2313 55.3732 76.1845 55.8014 76.006C56.2296 75.8274 56.5956 75.5251 56.8531 75.1371C57.1106 74.7492 57.2481 74.2931 57.2481 73.8265C57.2481 73.2009 57.0012 72.6009 56.5617 72.1585C56.1222 71.7161 55.5262 71.4675 54.9046 71.4675Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M72.6756 71.7494C74.5783 71.7494 76.1207 70.1967 76.1207 68.2814C76.1207 66.366 74.5783 64.8134 72.6756 64.8134C70.7729 64.8134 69.2304 66.366 69.2304 68.2814C69.2304 70.1967 70.7729 71.7494 72.6756 71.7494Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M72.6755 72.8547C71.7762 72.8547 70.8972 72.5863 70.1494 72.0833C69.4017 71.5804 68.8189 70.8656 68.4748 70.0292C68.1307 69.1929 68.0406 68.2726 68.2161 67.3847C68.3915 66.4969 68.8245 65.6813 69.4604 65.0412C70.0963 64.4011 70.9065 63.9651 71.7885 63.7885C72.6705 63.6119 73.5847 63.7026 74.4155 64.049C75.2463 64.3954 75.9565 64.9821 76.4561 65.7348C76.9557 66.4875 77.2224 67.3724 77.2224 68.2777C77.2214 69.4913 76.742 70.6549 75.8895 71.513C75.037 72.3712 73.8811 72.8537 72.6755 72.8547ZM72.6755 65.9187C72.212 65.9187 71.759 66.057 71.3736 66.3162C70.9882 66.5754 70.6879 66.9439 70.5105 67.3749C70.3331 67.806 70.2867 68.2803 70.3771 68.7379C70.4676 69.1955 70.6907 69.6158 71.0185 69.9457C71.3462 70.2756 71.7638 70.5003 72.2183 70.5913C72.6729 70.6824 73.1441 70.6356 73.5723 70.4571C74.0005 70.2785 74.3665 69.9762 74.624 69.5883C74.8815 69.2003 75.0189 68.7442 75.0189 68.2777C75.0151 67.6542 74.7666 67.0576 74.3276 66.6179C73.8887 66.1781 73.2948 65.9307 72.6755 65.9298V65.9187Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M34.3775 71.7494C36.2802 71.7494 37.8227 70.1967 37.8227 68.2814C37.8227 66.366 36.2802 64.8134 34.3775 64.8134C32.4749 64.8134 30.9324 66.366 30.9324 68.2814C30.9324 70.1967 32.4749 71.7494 34.3775 71.7494Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M34.3775 72.8547C33.4781 72.8554 32.5987 72.5876 31.8505 72.0851C31.1022 71.5827 30.5189 70.8681 30.1742 70.0318C29.8295 69.1955 29.7389 68.2751 29.9139 67.387C30.089 66.4989 30.5217 65.683 31.1575 65.0425C31.7932 64.402 32.6034 63.9657 33.4855 63.7888C34.3676 63.6119 35.282 63.7023 36.113 64.0486C36.944 64.395 37.6544 64.9816 38.1541 65.7344C38.6539 66.4872 38.9207 67.3722 38.9207 68.2777C38.9187 69.4903 38.4396 70.6528 37.5881 71.5107C36.7366 72.3685 35.5822 72.8518 34.3775 72.8547ZM34.3775 65.9187C33.9141 65.9187 33.461 66.057 33.0756 66.3162C32.6902 66.5754 32.3899 66.9439 32.2125 67.3749C32.0351 67.806 31.9887 68.2803 32.0791 68.7379C32.1696 69.1955 32.3928 69.6158 32.7205 69.9457C33.0482 70.2756 33.4658 70.5003 33.9204 70.5913C34.3749 70.6824 34.8461 70.6356 35.2743 70.4571C35.7025 70.2785 36.0685 69.9762 36.326 69.5883C36.5835 69.2003 36.721 68.7442 36.721 68.2777C36.7171 67.6542 36.4686 67.0576 36.0296 66.6179C35.5907 66.1781 34.9968 65.9307 34.3775 65.9298V65.9187Z",
                        fill: "#687EFD"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "57.5317",
                        y1: "37.3324",
                        x2: "61.7172",
                        y2: "202.087",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                offset: "0.95"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("linearGradient", {
                        id: "paint1_linear",
                        x1: "5065.86",
                        y1: "535.505",
                        x2: "3163.62",
                        y2: "2027.2",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                offset: "0.95"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("linearGradient", {
                        id: "paint2_linear",
                        x1: "2899.65",
                        y1: "798.882",
                        x2: "1435.84",
                        y2: "1716.7",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                offset: "0.95"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                            width: "108",
                            height: "119",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });






const $44038773e462e3e4$var$sides = {
    "top": 1,
    "right": 2,
    "bottom": 3,
    "left": 4
};
const $44038773e462e3e4$var$aligns = {
    "center": 1,
    "start": 2,
    "end": 3
};
function $44038773e462e3e4$export$28c660c63b792dea(props) {
    const { children: children , content: content , open: open , defaultOpen: defaultOpen , onOpenChange: onOpenChange , side: side = "top" , align: align = "center" , delayDuration: delayDuration = 150  } = props;
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)($8zHUo$radixuireacttooltip.Provider, {
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)($8zHUo$radixuireacttooltip.Root, {
            open: open,
            defaultOpen: defaultOpen,
            onOpenChange: onOpenChange,
            delayDuration: delayDuration,
            "data-testid": "tooltip",
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)($8zHUo$radixuireacttooltip.Trigger, {
                    asChild: true,
                    children: children
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)($8zHUo$radixuireacttooltip.Content, {
                    className: "bg-gray-200 text-text-100 rounded-sm px-2 py-1 text-xs font-medium",
                    side: side,
                    sideOffset: 3,
                    align: align,
                    children: [
                        content,
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)($8zHUo$radixuireacttooltip.Arrow, {
                            className: "fill-gray-300 text-gray-100",
                            width: 11,
                            height: 5
                        })
                    ]
                })
            ]
        })
    });
}
var $44038773e462e3e4$export$2e2bcd8739ae039 = $44038773e462e3e4$export$28c660c63b792dea;


var $c8eba5c6dda84b94$export$2e2bcd8739ae039 = (0, $44038773e462e3e4$export$2e2bcd8739ae039);



const $82c7348de3dc7374$var$useTranslation = ()=>{
    const trans = (0, $8zHUo$reactintl.useIntl)();
    const t = (id)=>trans.messages[id];
    return {
        t: (id)=>trans.messages[id] ? trans.messages[id].toString() : id,
        ...trans
    };
};
var $82c7348de3dc7374$export$2e2bcd8739ae039 = $82c7348de3dc7374$var$useTranslation;


const $ce350b8ddb52fbc0$var$sizes = {
    xlarge: "w-80 lg:w-96   py-4 text-lg",
    "xl-full": "w-full   py-4 text-lg",
    large: " w-80 lg:w-80  py-3 text-base ",
    medium: " w-80 lg:w-60  py-2 text-sm ",
    small: " w-80 lg:w-40  py-1  text-sm ",
    xsmall: " w-80 lg:w-28   py-1 text-xs "
};
const $ce350b8ddb52fbc0$var$borders = {
    primary: "focus:border-blue-500 focus:outline-none",
    urgent: "focus:outline-none border-red-500"
};
const $ce350b8ddb52fbc0$var$right_className = (size, px)=>({
        default: `  border border-gray-300 rounded-lg  py-3 ${px ? px : "px-5"} w-full    rounded-8 text-primary-100 placeholder-primary-300   `,
        disabled: ` border border-gray-100 bg-gray-200 disabled cursor-not-allowed rounded-lg  py-3 ${px ? px : "px-5"} w-full  ${$ce350b8ddb52fbc0$var$sizes[size]}  rounded-xl  `,
        error: ` border border-red-500    rounded-lg  py-3 ${px ? px : "px-5"} w-full  ${$ce350b8ddb52fbc0$var$sizes[size]}  rounded-xl  `,
        success: ` border border-green-500   rounded-lg  py-3 ${px ? px : "px-5"} w-full  ${$ce350b8ddb52fbc0$var$sizes[size]}  rounded-xl  `
    });
const $ce350b8ddb52fbc0$var$Input = /*#__PURE__*/ (0, ($parcel$interopDefault($8zHUo$react))).forwardRef(({ state: state = "default" , size: size = "medium" , icon: icon , iconPosition: iconPosition = "left" , message: message , label: label , inputRef: inputRef , handleClearField: handleClearField , isClearable: isClearable , border: border = "primary" , ...props }, ref)=>{
    //translate
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: `input-components  flex flex-col space-y-1 ${label && "text-left "}  ${$ce350b8ddb52fbc0$var$sizes[size]}`,
        children: [
            label && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("label", {
                className: "text-sm text-gray-700 ",
                children: [
                    " ",
                    label
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: " relative text-gray-800 focus-within:text-gray-900 block ",
                children: [
                    icon && iconPosition == "left" && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        "data-testid": "input-icon-left",
                        className: "pointer-events-none absolute top-1/2 transform -translate-y-1/2 left-3",
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("input", {
                        //MODIFY THIS LINE
                        ref: inputRef,
                        disabled: state == "disabled",
                        className: ` placeholder-gray-400 ${$ce350b8ddb52fbc0$var$borders[border]} ${$ce350b8ddb52fbc0$var$right_className(size, icon && iconPosition == "left" ? "px-8 " : null)[state]}   ${icon && iconPosition == "left" && "px-10"}`,
                        ...props
                    }),
                    icon && iconPosition == "right" && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        "data-testid": "input-icon-right",
                        className: "pointer-events-none absolute top-1/2 transform -translate-y-1/2 right-3",
                        children: icon
                    }),
                    isClearable && handleClearField && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $c8eba5c6dda84b94$export$2e2bcd8739ae039), {
                        content: t("clear"),
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            onClick: handleClearField,
                            className: "cursor-pointer absolute top-1/4 right-2 hover:text-gray-900 ",
                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$2d4c0e26be08b272), {
                                className: " w-6 h-6 text-gray-500"
                            })
                        })
                    })
                ]
            }),
            message && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                "data-testid": "input-message",
                className: `font-medium ${state == "error" ? "text-red-600 " : "text-gray-700"}`,
                children: message
            })
        ]
    });
});
$ce350b8ddb52fbc0$var$Input.displayName = "Input";
var $ce350b8ddb52fbc0$export$2e2bcd8739ae039 = $ce350b8ddb52fbc0$var$Input;






const $59ff00cb4a4db4e4$var$LogoPhpr = (props)=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: " ",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextimage))), {
            src: "/phpr/PNG/2Couleurs/SurFondPale/logoPHPC_MADube_C1.png",
            width: "100",
            height: "40",
            alt: "logo"
        })
    });
};
var $59ff00cb4a4db4e4$export$2e2bcd8739ae039 = $59ff00cb4a4db4e4$var$LogoPhpr;





const $df71ccfe9d9e2b03$var$SpinnerLoading = (props)=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
        "data-testid": "button_spinner",
        className: `w-5 h-5 animate-spin`,
        viewBox: "0 0 50 50",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "25",
                cy: "10",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".3",
                cx: "25",
                cy: "40",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".3",
                cx: "32.5",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".3",
                cx: "17.5",
                cy: "38",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".93",
                cx: "17.5",
                cy: "12",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".3",
                cx: "32.5",
                cy: "38",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".65",
                cx: "10",
                cy: "25",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".3",
                cx: "40",
                cy: "25",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".86",
                cx: "12",
                cy: "17.5",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".3",
                cx: "38",
                cy: "32.5",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".44",
                cx: "12",
                cy: "32.5",
                r: "2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                opacity: ".3",
                cx: "38",
                cy: "17.5",
                r: "2"
            })
        ]
    });
};
var $df71ccfe9d9e2b03$export$2e2bcd8739ae039 = $df71ccfe9d9e2b03$var$SpinnerLoading;



const $5fdb2d257c0eb8fa$var$sizes = {
    xlarge: "px-10 py-3 text-lg font-meduim",
    large: "px-7 py-2 text-base font-meduim ",
    medium: "px-4 py-2 text-sm font-meduim ",
    small: "px-4 py-2  text-sm font-meduim ",
    xsmall: "px-[0.6rem] py-[0.4rem] text-xs  font-meduim"
};
const $5fdb2d257c0eb8fa$var$generateBgColor = (variant)=>{
    switch(variant){
        case "primary":
            return "bg-blue-phpr";
        case "secondary":
            return "bg-gray-900";
        case "neutral":
            return "bg-neutral-500";
        case "urgent":
            return "bg-red-500";
        default:
            return "";
    }
};
const $5fdb2d257c0eb8fa$var$generateTextColor = (variant)=>{
    switch(variant){
        case "primary":
            return "text-white";
        case "secondary":
            return "text-white";
        case "neutral":
            return "text-white";
        case "urgent":
            return "text-white";
        default:
            return "";
    }
};
const $5fdb2d257c0eb8fa$var$generateClassName = (baseClass, { disabled: disabled , isRounded: isRounded , size: size , color: color , variant: variant , bgcolor: bgcolor , hoverbgcolor: hoverbgcolor , hovercolor: hovercolor , borderWidth: borderWidth , bordercolor: bordercolor , isLoading: isLoading  })=>{
    const disabledClass = disabled || isLoading ? "opacity-70 disabled:cursor-not-allowed" : "hover:opacity-90";
    const roundedClass = isRounded ? "rounded-xl" : "";
    const textColorClass = color ? `text-${color}` : $5fdb2d257c0eb8fa$var$generateTextColor(variant);
    const bgColorClass = bgcolor ? `bg-${bgcolor}` : $5fdb2d257c0eb8fa$var$generateBgColor(variant);
    const hoverColorClass = hovercolor ? `hover:text-${hovercolor}` : "";
    const hoverBgColorClass = hoverbgcolor ? `hover:bg-${hoverbgcolor}` : "";
    const borderWidthClass = borderWidth ? `border-${borderWidth}` : "";
    const borderColorClass = bordercolor ? `border-${bordercolor}` : "";
    return `${baseClass} flex font-medium items-center justify-center space-x-2 ${bgColorClass} ${textColorClass} ${hoverColorClass} ${hoverBgColorClass} ${borderWidthClass} ${borderColorClass} ${disabledClass} ${roundedClass} ${$5fdb2d257c0eb8fa$var$sizes[size || "medium"]} disabled:text-accent-disabled disabled:bg-accent-hover transition-all duration-200 ease-linear`;
};
const $5fdb2d257c0eb8fa$var$Button = ({ title: title , variant: variant = "primary" , isLoading: isLoading = false , size: size = "medium" , disabled: disabled = false , isRounded: isRounded = true , icon: icon , color: color , hovercolor: hovercolor , bgcolor: bgcolor , hoverbgcolor: hoverbgcolor , labelLoading: labelLoading , bordercolor: bordercolor , borderWidth: borderWidth , className: className = "" , tooltipTitle: tooltipTitle = "" , ...props })=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("button", {
        disabled: disabled || isLoading,
        className: $5fdb2d257c0eb8fa$var$generateClassName(className, {
            disabled: disabled,
            isRounded: isRounded,
            size: size,
            color: color,
            variant: variant,
            bgcolor: bgcolor,
            hoverbgcolor: hoverbgcolor,
            hovercolor: hovercolor,
            borderWidth: borderWidth,
            bordercolor: bordercolor,
            isLoading: isLoading
        }),
        ...props,
        title: tooltipTitle,
        children: [
            (icon || isLoading) && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: ``,
                "data-testid": "button-icon",
                children: isLoading ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $df71ccfe9d9e2b03$export$2e2bcd8739ae039), {}) : icon
            }),
            (isLoading || title) && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                className: "flex ",
                "data-testid": "button-title",
                children: isLoading && labelLoading ? labelLoading : title
            })
        ]
    });
};
var $5fdb2d257c0eb8fa$export$2e2bcd8739ae039 = $5fdb2d257c0eb8fa$var$Button;





const $af67bda176efb977$var$WithSkeletonLoader = ({ skeleton: skeleton , pageTitle: pageTitle , children: children , isLoading: isLoading  })=>{
    if (isLoading) return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, $8zHUo$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nexthead))), {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("title", {
                    children: pageTitle
                })
            }),
            skeleton
        ]
    });
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, $8zHUo$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nexthead))), {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("title", {
                    children: pageTitle
                })
            }),
            children
        ]
    });
};
var $af67bda176efb977$export$2e2bcd8739ae039 = $af67bda176efb977$var$WithSkeletonLoader;





const $78144f1d8a648789$var$LoginSkeleton = (props)=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "p-5 md:p-10 flex flex-col items-center my-4 md:my-10",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $59ff00cb4a4db4e4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("main", {
                className: "__Main flex-auto w-full h-full flex flex-col items-center animate-pulse p-4 space-y-5",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-96 h-3 rounded bg-gray-200"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "__Boxes md:p-4 py-10 p-2 w-full flex flex-col items-center",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("section", {
                            className: "w-96 md:w-2/5 flex flex-col items-center space-y-5 p-5 pb-20 pt-6 rounded border-2 border-gray-300 ",
                            children: [
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                    className: "w-72 h-3 my-2 bg-gray-400 rounded-lg "
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                    className: "w-full h-2 bg-gray-300 rounded-lg "
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                    className: "w-full h-2 mb-10 bg-gray-300 rounded-lg "
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                    className: "flex flex-col items-start w-full space-y-5 py-10 p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                            className: "w-32 h-2 bg-gray-300 rounded-lg "
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                            className: "w-full h-14 bg-gray-300 rounded-sm "
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                            className: "w-32 h-2 bg-gray-300 rounded-lg "
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                            className: "w-full h-14 bg-gray-300 rounded-sm "
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                    className: "w-60 mt-4 h-12 bg-gray-300 rounded-lg"
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                    className: "w-80 h-1 mb-10 bg-gray-200 rounded-lg "
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $78144f1d8a648789$export$2e2bcd8739ae039 = $78144f1d8a648789$var$LoginSkeleton;







const $ffe80b878f95bd4c$var$CopyToClipboard = ({ content: content  })=>{
    const [isCopied, setIsCopied] = (0, $8zHUo$react.useState)(false);
    (0, $8zHUo$react.useEffect)(()=>{
        if (isCopied) setTimeout(()=>{
            setIsCopied(false);
        }, 1000);
    }, [
        isCopied
    ]);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $c8eba5c6dda84b94$export$2e2bcd8739ae039), {
        content: "Copy Credentials",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("button", {
            onClick: ()=>{
                setIsCopied(true);
                navigator.clipboard.writeText(content);
                (0, ($parcel$interopDefault($8zHUo$reacthottoast)))("Credentials copied", {
                    position: "bottom-right",
                    // icon: '👏',
                    style: {
                        borderRadius: "10px",
                        background: "#333",
                        color: "#fff"
                    }
                });
            },
            children: [
                !isCopied && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$ae118f79ed05e2c0), {
                    className: "w-5 h-5 text-gray-400 "
                }),
                isCopied && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$41713cd023818a26), {
                    className: "w-5 h-5 text-gray-400 "
                })
            ]
        })
    });
};
var $ffe80b878f95bd4c$export$2e2bcd8739ae039 = $ffe80b878f95bd4c$var$CopyToClipboard;


var $355f333c554f9d5c$exports = {};

$parcel$export($355f333c554f9d5c$exports, "LoginSvg", () => $355f333c554f9d5c$export$cdca941d70bf0aea);

const $355f333c554f9d5c$export$cdca941d70bf0aea = ()=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 1",
        viewBox: "0 0 942.54724 631.43903",
        xlinkHref: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M879.59026,413.72015l2.79791-22.42655a30.28454,30.28454,0,0,1,60.10315,7.4984l-2.79791,22.42654a4.07267,4.07267,0,0,1-4.5404,3.53316l-52.02959-6.49115A4.07266,4.07266,0,0,1,879.59026,413.72015Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#2f2e41"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "775.78648",
                cy: "263.92678",
                r: "22.20356",
                fill: "#ffb8b8"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M875.05486,392.20076a23.98352,23.98352,0,0,1,26.73792-20.80636l4.48553.55961a23.98334,23.98334,0,0,1,20.80614,26.73789l-.056.44853-9.47894-1.18258-2.10358-9.45631L913.67,397.47385l-4.8988-.61117-1.06132-4.77116-.89618,4.52695-31.81482-3.96918Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#2f2e41"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M795.91611,477.41149a10.22784,10.22784,0,0,0,15.28426,3.51477L831.3673,492.74l10.16823-10.50441-28.71392-16.28326a10.28328,10.28328,0,0,0-16.9055,11.45917Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#ffb8b8"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M862.01251,498.63944c-14.87549,0-41.052-6.65918-42.50146-7.03125l-.45777-.11719,4.11988-20.85889,39.98193,7.897,21.7207-30.58692,24.93726-2.53515-.69605.916c-.32422.42676-32.46972,42.74317-37.47241,49.8418C870.38214,497.95585,866.77618,498.63944,862.01251,498.63944Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M866.00055,576.92752l-.59522-.28417c-.12671-.06055-12.76513-6.208-19.31128-18.209-6.51489-11.94434,23.98316-62.6123,26.1167-66.12793l.031-16.09082L883.213,446.59452l13.9917-7.90821L885.19171,466.7161Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("polygon", {
                points: "723.257 615.591 709.885 615.59 703.523 564.011 723.259 564.012 723.257 615.591",
                fill: "#ffb8b8"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M855.39347,762.83333l-43.11785-.00159v-.54537A16.78359,16.78359,0,0,1,829.05829,745.504h.00107l26.33491.00107Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#2f2e41"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("polygon", {
                points: "866.891 603.872 854.184 608.035 832.077 561.002 850.832 554.857 866.891 603.872",
                fill: "#ffb8b8"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M1002.89464,749.40842,961.92,762.83333l-.16982-.51825a16.78358,16.78358,0,0,1,10.72241-21.174l.001-.00033,25.02593-8.1994Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#2f2e41"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M969.72638,729.71952l-38.1205-63.64087L899.4256,598.08573l-28.95826,60.06054-11.50366,77.78809-40.343.56055.15893-.63086L880.51715,490.5535l48.352,7.22363-2.20093,31.916,1.31079,1.86426c10.92261,15.5166,22.21607,31.55957,15.73877,48.85351l18.36231,54.52246,40.64624,90.78614Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#2f2e41"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M882.72638,543.71952c-7.00635,0-15-8-10.853-21.65821l-.26855-.19433,9.96069-44.00781c-8.69263-12.43165,2.76807-22.69141,3.842-23.60791l5.4707-9.84717,24.1377-15.30811L927.22882,530.5701l-.18066.17285C918.2276,539.18241,888.60358,543.71952,882.72638,543.71952Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M932.15948,566.617a11.88134,11.88134,0,0,1-2.85131-.30176c-.93873-.23535-2.4585-1.43066-4.80689-9.07715-9.33618-30.39746-20.35913-121.86035-12.35083-130.81055l.18335-.20507,13.14893,2.1914c1.093-.80664,6.82861-4.81054,12.12133-4.11425a8.033,8.033,0,0,1,5.49659,3.249l.09057.11865,4.189,59.59424,15.34619,70.13086-.36792.167C961.46564,557.96561,942.303,566.617,932.15948,566.617Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M923.31655,543.32446a10.22788,10.22788,0,0,0,9.66238-12.35317l19.24856-13.25752-5.20361-13.66228-26.91975,19.104a10.28328,10.28328,0,0,0,3.21242,20.169Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#ffb8b8"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M945.876,528.3367l-17.14551-12.57324,24.10083-32.86426L934.33624,450.261l8.27466-23.66113.53467,1.019c.249.47461,24.94824,47.52686,29.25683,55.06738,4.48267,7.84375-24.97,43.76075-26.22583,45.28516Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M560.20614,676.255l-14.5923-6.1443-10.01026-73.15138H402.299L391.4486,669.81186l-13.05511,6.52746a3.10016,3.10016,0,0,0,1.38657,5.873H559.00349A3.1,3.1,0,0,0,560.20614,676.255Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#e6e6e6"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M797.09757,606.69181H142.26837a12.97344,12.97344,0,0,1-12.9443-12.97332V501.379h680.7178v92.33952A12.97357,12.97357,0,0,1,797.09757,606.69181Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#ccc"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M810.72638,545.02084h-682V149.91957A15.65719,15.65719,0,0,1,144.366,134.28048H795.08655a15.65736,15.65736,0,0,1,15.63983,15.63909Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M769.99322,516.34435H169.45954a12.07024,12.07024,0,0,1-12.057-12.05667v-329.274a12.07088,12.07088,0,0,1,12.057-12.05741H769.99322a12.07088,12.07088,0,0,1,12.057,12.05741v329.274A12.07024,12.07024,0,0,1,769.99322,516.34435Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M638.14638,682.97542l-337.44822,0a1.56681,1.56681,0,0,1-1.53908-1.13363,1.52911,1.52911,0,0,1,1.47725-1.91893l337.385,0a1.61535,1.61535,0,0,1,1.61617,1.19368A1.52819,1.52819,0,0,1,638.14638,682.97542Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#ccc"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                x: "489.85973",
                y: "81.90943",
                width: "144.99594",
                height: "110.7733",
                fill: "#f2f2f2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                x: "497.0645",
                y: "87.41369",
                width: "130.58641",
                height: "99.76477",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M693.37738,295.69477q.02592.00028.05185-.00109a34.81675,34.81675,0,0,0,.779-69.48892.79424.79424,0,0,0-.60112.20836.78592.78592,0,0,0-.25678.57553l-.7612,67.902a.79707.79707,0,0,0,.78826.80412Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M666.072,237.43291a1.02524,1.02524,0,0,1,.71962.30735l23.37584,23.90588a1.01418,1.01418,0,0,1,.29094.72511l-.36424,32.49143a1.01059,1.01059,0,0,1-.33018.73985,1.026,1.026,0,0,1-.77126.26782,35.04446,35.04446,0,0,1-23.69951-58.09062,1.02636,1.02636,0,0,1,.74091-.34658Q666.05306,237.4327,666.072,237.43291Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#e6e6e6"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M689.84193,225.9272a1.02931,1.02931,0,0,1,.69948.28585,1.01135,1.01135,0,0,1,.31394.74786l-.32864,29.31578a1.02077,1.02077,0,0,1-1.75041.70223L668.378,236.11808a1.02291,1.02291,0,0,1,.05493-1.48163,35.11806,35.11806,0,0,1,21.34564-8.708C689.79961,225.92739,689.82088,225.927,689.84193,225.9272Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M679.33353,309.77539a6.25343,6.25343,0,1,1-6.18294-6.32313A6.26054,6.26054,0,0,1,679.33353,309.77539Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M697.19935,309.97567a6.25343,6.25343,0,1,1-6.18294-6.32313A6.26056,6.26056,0,0,1,697.19935,309.97567Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M715.06516,310.176a6.25343,6.25343,0,1,1-6.18294-6.32314A6.26054,6.26054,0,0,1,715.06516,310.176Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#e6e6e6"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                x: "488.33346",
                y: "210.11637",
                width: "144.99594",
                height: "110.7733",
                fill: "#f2f2f2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                x: "495.53823",
                y: "215.62063",
                width: "130.58641",
                height: "99.76477",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "517.69473",
                cy: "242.98812",
                r: "5.42203",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M733.53881,373.0493a3.67713,3.67713,0,1,1,0,7.35425H676.51323a3.67712,3.67712,0,1,1,0-7.35425h57.02558m0-.9006H676.51323a4.57773,4.57773,0,1,0,0,9.15545h57.02558a4.57773,4.57773,0,1,0,0-9.15545Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M711.03754,381.30414h-42.9283a4.57772,4.57772,0,1,1,0-9.15544h42.9283a4.57772,4.57772,0,0,1,0,9.15544Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "517.69473",
                cy: "265.50302",
                r: "5.42203",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M733.53881,395.5642a3.67713,3.67713,0,1,1,0,7.35425H676.51323a3.67712,3.67712,0,1,1,0-7.35425h57.02558m0-.9006H676.51323a4.57772,4.57772,0,1,0,0,9.15545h57.02558a4.57772,4.57772,0,1,0,0-9.15545Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M727.24826,403.819h-59.139a4.57772,4.57772,0,1,1,0-9.15544h59.139a4.57772,4.57772,0,0,1,0,9.15544Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "517.69473",
                cy: "288.01792",
                r: "5.42203",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M733.53881,418.0791a3.67713,3.67713,0,1,1,0,7.35425H676.51323a3.67712,3.67712,0,1,1,0-7.35425h57.02558m0-.9006H676.51323a4.57772,4.57772,0,1,0,0,9.15545h57.02558a4.57772,4.57772,0,1,0,0-9.15545Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M692.125,426.33393H668.10924a4.57772,4.57772,0,1,1,0-9.15543H692.125a4.57772,4.57772,0,0,1,0,9.15543Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                x: "51.18842",
                y: "101.50782",
                width: "405.09331",
                height: "207.61032",
                fill: "#f2f2f2"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                x: "64.69153",
                y: "111.82386",
                width: "378.08709",
                height: "186.97824",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M524.61425,404.55724H248.996a.8626.8626,0,0,1-.86256-.86256V271.59086a.86256.86256,0,1,1,1.72512,0V402.83212H524.61425a.86256.86256,0,0,1,0,1.72512Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M307.88363,395.06909H282.81508a2.56336,2.56336,0,0,1-2.56051-2.5603V357.95166a2.56337,2.56337,0,0,1,2.56051-2.5603h25.06855a2.56337,2.56337,0,0,1,2.56051,2.5603v34.55713A2.56336,2.56336,0,0,1,307.88363,395.06909Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M353.59927,395.06909H328.53072a2.56336,2.56336,0,0,1-2.56051-2.5603V325.17441a2.56336,2.56336,0,0,1,2.56051-2.5603h25.06855a2.56336,2.56336,0,0,1,2.56051,2.5603v67.33438A2.56336,2.56336,0,0,1,353.59927,395.06909Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M399.31491,395.06909H374.24636a2.56337,2.56337,0,0,1-2.56051-2.5603V357.95166a2.56337,2.56337,0,0,1,2.56051-2.5603h25.06855a2.56337,2.56337,0,0,1,2.56052,2.5603v34.55713A2.56337,2.56337,0,0,1,399.31491,395.06909Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M445.03056,395.06909H419.962a2.50734,2.50734,0,0,1-2.56052-2.44431V312.12a2.50734,2.50734,0,0,1,2.56052-2.44431h25.06855a2.50734,2.50734,0,0,1,2.56051,2.44431v80.50475A2.50734,2.50734,0,0,1,445.03056,395.06909Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M490.7462,395.06909H465.67765a2.56336,2.56336,0,0,1-2.56051-2.5603V288.94692a2.56336,2.56336,0,0,1,2.56051-2.5603H490.7462a2.56336,2.56336,0,0,1,2.56051,2.5603V392.50879A2.56336,2.56336,0,0,1,490.7462,395.06909Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#6c63ff"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "166.62298",
                cy: "205.58481",
                r: "5.17536",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "212.33862",
                cy: "171.945",
                r: "5.17536",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "258.05426",
                cy: "205.58481",
                r: "5.17536",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "303.7699",
                cy: "155.55637",
                r: "5.17536",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("circle", {
                cx: "349.48555",
                cy: "136.58007",
                r: "5.17536",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("polygon", {
                points: "258.163 206.744 212.339 172.421 167.14 206.275 166.106 204.895 212.339 170.265 257.945 204.425 303.266 154.83 303.447 154.756 349.163 136.337 349.808 137.937 304.274 156.283 258.163 206.744",
                fill: "#3f3d56"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                d: "M1070.27362,765.71952h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
                transform: "translate(-128.72638 -134.28048)",
                fill: "#ccc"
            })
        ]
    });







const $35515d2b18f14e87$export$30dba1e0a1cb02c9 = {
    crud: "",
    auth: "",
    status: "",
    documentation: ""
};
const $35515d2b18f14e87$export$c5a13a81cd4fc74d = (endpoints)=>{
    $35515d2b18f14e87$export$30dba1e0a1cb02c9.crud = endpoints.crud;
    $35515d2b18f14e87$export$30dba1e0a1cb02c9.auth = endpoints.auth;
    $35515d2b18f14e87$export$30dba1e0a1cb02c9.status = endpoints.status;
    $35515d2b18f14e87$export$30dba1e0a1cb02c9.documentation = endpoints.documentation;
};



const $d8558f4cea2fd4d3$export$584b2531a4ea43a = async ({ username: username , password: password  })=>await (0, ($parcel$interopDefault($8zHUo$axios))).post((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).auth, {
        username: username,
        password: password
    }).then((res)=>res.data);
function $d8558f4cea2fd4d3$export$2e2bcd8739ae039(redirectURL) {
    const router = (0, $8zHUo$nextrouter.useRouter)();
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return (0, $8zHUo$tanstackreactquery.useMutation)([
        "login"
    ], (credentials)=>{
        const processedFormValues = {
            username: credentials.username.trim(),
            password: credentials.password.trim()
        };
        return $d8558f4cea2fd4d3$export$584b2531a4ea43a(processedFormValues);
    }, {
        onSuccess: (data)=>{
            (0, $8zHUo$cookiesnext.setCookie)("token", data.token);
            let toastId = (0, ($parcel$interopDefault($8zHUo$reacthottoast))).success(t("Authenticated"), {
                position: "bottom-right"
            });
            setTimeout(()=>{
                (0, ($parcel$interopDefault($8zHUo$reacthottoast))).remove(toastId);
                router.push(router.query.from ? router.query.from.toString() : `/${redirectURL}`);
            }, 1000);
        },
        onError: (err)=>{
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).error(t("Wrong Data"));
        }
    });
}
function $d8558f4cea2fd4d3$export$f6e31faba1d0ca28() {
    const router = (0, $8zHUo$nextrouter.useRouter)();
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return (0, $8zHUo$tanstackreactquery.useMutation)([
        "login"
    ], (credentials)=>{
        const processedFormValues = {
            username: credentials.username.trim(),
            password: credentials.password.trim()
        };
        return $d8558f4cea2fd4d3$export$584b2531a4ea43a(processedFormValues);
    }, {
        onSuccess: (data)=>{
            (0, $8zHUo$cookiesnext.setCookie)("token", data);
            let taostId = (0, ($parcel$interopDefault($8zHUo$reacthottoast))).success("Success!");
            setTimeout(()=>{
                (0, ($parcel$interopDefault($8zHUo$reacthottoast))).remove(taostId);
            }, 1000);
        },
        onError: ()=>{
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).error(t("Wrong Data"));
        }
    });
} //remove consolelog cedentials








// eslint-disable-next-line import/no-unresolved

// default




const $c6ca657a0ac608c7$var$Modal = ({ isOpen: isOpen = false , isDanger: isDanger = false , isTitled: isTitled = true , isCanfirmable: isCanfirmable = true , isCancelable: isCancelable = true , handleClose: handleClose , title: title , children: children , labelConfirm: labelConfirm , labelCancel: labelCancel , isButtonOkLoading: isButtonOkLoading = false , handleCancel: handleCancel , hanldleOK: hanldleOK , ...props })=>{
    //translate
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: ` ${isOpen ? " " : "hidden"}   
                 fixed z-50  -top-2 right-0 left-0 bottom-0 
                 flex justify-center items-center 
                 backdrop-brightness-75 rounded-md print:hidden`,
        onClick: ()=>{
            handleClose();
        },
        children: isOpen && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
            onClick: (e)=>e.stopPropagation(),
            "data-testid": "modal",
            ...props,
            className: ` ${isOpen ? " modal__opened" : "hidden"} flex flex-col  border  rounded-xl p-3  h-auto bg-white    `,
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                    className: "flex w-full h-auto justify-end items-center mt-3",
                    children: [
                        isTitled && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: "flex w-10/12 h-auto justify-center items-center text-base md:text-xl font-bold",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                            "data-testid": "modal_close",
                            onClick: handleClose,
                            className: "flex w-1/12 h-auto justify-center cursor-pointer",
                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "#847f7f",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                className: "feather feather-x",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    className: "flex w-full h-auto p-3 justify-center items-center rounded text-center text-gray-500",
                    children: children
                }),
                (isCancelable || isCanfirmable) && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                    className: "flex justify-center space-x-2 p-3 ",
                    children: [
                        isCancelable && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                            "data-testid": "modal_cancel",
                            onClick: ()=>handleCancel(),
                            variant: "secondary",
                            title: labelConfirm ? labelConfirm : t("Cancel")
                        }),
                        isCanfirmable && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                            onClick: ()=>hanldleOK(),
                            "data-testid": "modal_ok",
                            isLoading: isButtonOkLoading,
                            variant: isDanger ? "urgent" : "primary",
                            title: labelConfirm ? labelConfirm : t("Confirm")
                        })
                    ]
                })
            ]
        })
    });
};
var $c6ca657a0ac608c7$export$2e2bcd8739ae039 = $c6ca657a0ac608c7$var$Modal;


var $93036c7aac8c1e67$export$2e2bcd8739ae039 = (0, $c6ca657a0ac608c7$export$2e2bcd8739ae039);








const $9d897b2068c8ec05$var$Loader = ({ isLoading: isLoading = false  })=>{
    if (!isLoading) return null;
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        "data-testid": "loading-screen",
        style: {
            zIndex: 1
        },
        className: " absolute top-0 right-0 left-0 bottom-0 flex flex-col space-x-2 items-center w-full h-full ",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
            className: "flex flex-col items-center justify-center space-y-4 absolute top-1/4",
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                    className: " flex items-center justify-center space-x-3",
                    children: [
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: "w-6 h-6 rounded-lg bg-blue-phpr animate-bounce"
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: "w-6 h-6 rounded-lg bg-blue-phpr animate-bounce",
                            style: {
                                animationDelay: "200ms"
                            }
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: "w-6 h-6 rounded-lg bg-blue-phpr animate-bounce",
                            style: {
                                animationDelay: "400ms"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                    className: "text-gray-400 font-bold text-xl",
                    children: "Loading..."
                })
            ]
        })
    });
};
var $9d897b2068c8ec05$export$2e2bcd8739ae039 = $9d897b2068c8ec05$var$Loader;


const $df41288989706f48$var$FEEDBACK_URL = "https://dev.ticket-feedback-form.phpr.link";
const $df41288989706f48$var$FeedbackModal = ()=>{
    const [pageUrl, setPageUrl] = (0, $8zHUo$react.useState)("");
    const [isLoading, setIsLoading] = (0, $8zHUo$react.useState)(true);
    const [screenshotData, setScreenshotData] = (0, $8zHUo$react.useState)("");
    const { locale: locale  } = (0, $8zHUo$reactintl.useIntl)();
    const handleLoad = ()=>{
        setIsLoading(false);
    };
    const captureScreenshot = ()=>{
        (0, ($parcel$interopDefault($8zHUo$html2canvas)))(document.body, {
            logging: true,
            onclone: (doc)=>{
                const formElement = doc.getElementById("feedback__form");
                if (formElement) formElement.style.visibility = "hidden";
            }
        }).then((canvas)=>{
            const screenshotDataUrl = canvas.toDataURL("image/png");
            setScreenshotData(screenshotDataUrl);
        });
    };
    (0, $8zHUo$react.useEffect)(()=>{
        if (screenshotData) {
            const iframe = document.getElementById("feedbackIframe");
            if (iframe?.contentWindow) iframe.contentWindow.postMessage({
                screenshot: screenshotData,
                url: pageUrl
            }, $df41288989706f48$var$FEEDBACK_URL);
        }
    }, [
        screenshotData,
        pageUrl
    ]);
    (0, $8zHUo$react.useEffect)(()=>{
        setPageUrl(window.location.href);
        captureScreenshot();
    }, []);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, $8zHUo$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $9d897b2068c8ec05$export$2e2bcd8739ae039), {
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "w-full h-full",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("iframe", {
                    src: `${$df41288989706f48$var$FEEDBACK_URL}/${locale == "en" || locale == "fr" ? locale : "en"}/feedback`,
                    className: `w-full h-full ${isLoading ? "hidden" : ""}`,
                    id: "feedbackIframe",
                    onLoad: handleLoad
                })
            })
        ]
    });
};
var $df41288989706f48$export$2e2bcd8739ae039 = $df41288989706f48$var$FeedbackModal;



const $8945e51c91a55fa1$var$FeedbackModal = ({ isOpen: isOpen , handleClose: handleClose  })=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        id: "feedback__form",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $93036c7aac8c1e67$export$2e2bcd8739ae039), {
            handleCancel: handleClose,
            handleClose: handleClose,
            hanldleOK: ()=>console.log("not existent"),
            isOpen: isOpen,
            isCancelable: false,
            isCanfirmable: false,
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "flex justify-center overflow-x-hidden md:w-[800px] w-96 h-[780px]",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $df41288989706f48$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $8945e51c91a55fa1$export$2e2bcd8739ae039 = $8945e51c91a55fa1$var$FeedbackModal;












const $4614f04a29cdaba6$var$sizes = {
    xlarge: "md:w-96  py-4 text-lg",
    large: " md:w-80  py-3 text-base ",
    medium: " md:w-60  py-2 text-sm ",
    small: " md:w-40  py-1  text-sm ",
    xsmall: " md:w-28  py-1 text-xs "
};
const $4614f04a29cdaba6$var$rightClassName = (position, size, isVisible, isOpen)=>{
    return `absolute  top-12  z-50  ${position.includes("left") ? "left-0" : "right-0"}    bg-white 
                     border  rounded-md  border-gray-300 shadow-xl ${$4614f04a29cdaba6$var$sizes[size]}  
                    transition-all duration-300 ease-in-out tranform   ${isVisible || isOpen ? "opacity-100 scale-105 " : "opacity-0"} `;
};
const $4614f04a29cdaba6$var$DropDownGhost = ({ children: children , icon: icon , title: title , useChevron: useChevron = true , size: size = "medium" , position: position = "left" , isOpen: isOpen , bgcolor: bgcolor = "bg-white" , textcolor: textcolor = "text-gray-800" , ...props })=>{
    const [isVisible, setIsVisible] = (0, $8zHUo$react.useState)(false);
    const menueRef = (0, $8zHUo$react.useRef)(null);
    const ButtonRef = (0, $8zHUo$react.useRef)(null);
    //translate
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    (0, $8zHUo$react.useEffect)(()=>{
        document.addEventListener("mousedown", (event)=>{
            // @ts-ignore
            if (menueRef.current && // @ts-ignore
            // click should not be indside the dropdown menu
            !menueRef.current?.contains(event.target) && ButtonRef.current && // @ts-ignore
            // click should not be inside the button
            !ButtonRef.current?.contains(event.target)) setIsVisible(false);
            return;
        });
    }, []);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "relative inline-block text-left dropdown ",
        id: "dropdown",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("button", {
                ref: ButtonRef,
                ...props,
                className: `flex  bg-${bgcolor} text-${textcolor} border border-gray-300 hover:opacity-80  space-x-2 items-center justify-between p-2  rounded-lg

            ${isVisible && " ring-2 ring-blue-500"}
            
            `,
                type: "button",
                onClick: ()=>setIsVisible(!isVisible),
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "flex-1 ",
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("span", {
                        className: "flex-auto",
                        children: [
                            t(title),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        children: useChevron && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$59f995884fc5e26a), {
                            className: `w-3 h-3 text-${textcolor}`
                        })
                    })
                ]
            }),
            (isVisible || isOpen) && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                ref: menueRef,
                className: $4614f04a29cdaba6$var$rightClassName(position, size, isVisible, isOpen),
                children: children
            })
        ]
    });
};
var $4614f04a29cdaba6$export$2e2bcd8739ae039 = $4614f04a29cdaba6$var$DropDownGhost;






const $acfe242336feac07$var$sizes = {
    xlarge: "w-80 lg:w-96 my-6 text-lg",
    large: " w-80 lg:w-80  my-4 text-base ",
    medium: "w-80  lg:w-60  my-3 text-sm ",
    small: "w-80 lg:w-40  my-2  text-xs ",
    xsmall: "w-80 lg:w-28  my-1 text-xs "
};
const $acfe242336feac07$var$borders = {
    primary: {
        control: (baseStyles)=>({
                ...baseStyles,
                boxShadow: "none",
                "&:hover": {
                    border: ""
                }
            })
    },
    urgent: {
        control: (baseStyles, state)=>({
                ...baseStyles,
                borderColor: "red",
                boxShadow: "none",
                "&:hover": {
                    border: ""
                }
            }),
        option: (baseStyles, state)=>({
                ...baseStyles,
                backgroundColor: [
                    state.isFocused ? "lightpink" : "",
                    state.isSelected ? "red" : ""
                ]
            })
    }
};
const $acfe242336feac07$var$right_className = (size)=>({
        default: `    ${$acfe242336feac07$var$sizes[size]}  `,
        disabled: `    ${$acfe242336feac07$var$sizes[size]}`
    });
function $acfe242336feac07$var$DropdownSelect({ variant: variant = "normal" , state: state = "default" , size: size = "medium" , icon: icon , border: border = "primary" , ...props }) {
    if (variant === "async") return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$reactselectasync))), {
        isDisabled: state == "disabled",
        className: `select-components ${$acfe242336feac07$var$right_className(size)[state]}`,
        ...props,
        styles: $acfe242336feac07$var$borders[border]
    });
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$reactselect))), {
            isDisabled: state == "disabled",
            className: `select-components ${$acfe242336feac07$var$right_className(size)[state]}`,
            styles: $acfe242336feac07$var$borders[border],
            ...props
        })
    });
}
var $acfe242336feac07$export$2e2bcd8739ae039 = $acfe242336feac07$var$DropdownSelect;








const $9cbcf03b1d9fcebb$var$DropDownThreedots = ({ children: children , orientation: orientation , className: className  })=>{
    const [isVisible, setIsVisible] = (0, $8zHUo$react.useState)(false);
    const menueRef = (0, $8zHUo$react.useRef)(null);
    const ButtonRef = (0, $8zHUo$react.useRef)(null);
    (0, $8zHUo$react.useEffect)(()=>{
        document.addEventListener("mousedown", (event)=>{
            // @ts-ignore
            if (menueRef.current && // @ts-ignore
            // click should not be indside the dropdown menu
            !menueRef.current?.contains(event.target) && ButtonRef.current && // @ts-ignore
            // click should not be inside the button
            !ButtonRef.current?.contains(event.target)) setIsVisible(false);
            return;
        });
    }, []);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "relative inline-block text-left dropdown ",
        id: "dropdown",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                ref: ButtonRef,
                className: "",
                type: "button",
                onClick: ()=>setIsVisible(!isVisible),
                children: orientation == "horizontal" ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$73be7394595c1628), {
                    className: `${className ? className : "w-5 h- text-gray-500"} ${isVisible && "text-blue-500"}`
                }) : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$18bb29f4c87c802c), {
                    className: className ? className : "w-5 h-5 text-gray-500"
                })
            }),
            isVisible && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                ref: menueRef,
                className: `absolute z-50 top-6 right-0  bg-white  rounded-md border border-gray-200 shadow-md transition-all duration-300 ease-in-out tranform   ${isVisible ? "opacity-100 scale-105" : "opacity-0"} `,
                children: children
            })
        ]
    });
};
var $9cbcf03b1d9fcebb$export$2e2bcd8739ae039 = $9cbcf03b1d9fcebb$var$DropDownThreedots;







const $4b45582cae2595be$var$languages = [
    {
        label: "Fran\xe7ais",
        value: "fr"
    },
    {
        label: "English",
        value: "en"
    },
    {
        label: "Bilingue / Bilingual",
        value: "bi"
    }
];
const $4b45582cae2595be$var$LangSelector = (props)=>{
    const router = (0, $8zHUo$nextrouter.useRouter)();
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        children: [
            " ",
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $acfe242336feac07$export$2e2bcd8739ae039), {
                value: $4b45582cae2595be$var$languages.filter((l)=>l.value == router.locale),
                size: "small",
                menuPlacement: "top",
                placeholder: t(`choose a language`),
                options: $4b45582cae2595be$var$languages,
                onChange: (newValue)=>{
                    const asPath = router.asPath;
                    router.push({
                        pathname: router.pathname,
                        query: router.query
                    }, asPath, {
                        locale: newValue.value
                    });
                },
                isSearchable: false
            })
        ]
    });
};
var $4b45582cae2595be$export$2e2bcd8739ae039 = $4b45582cae2595be$var$LangSelector;


const $0e35b39efb2fe16d$var$FooterLogin = ({ id: id  })=>{
    const [isOpen, setIsOpen] = (0, $8zHUo$react.useState)(false);
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("footer", {
        id: id,
        className: "__bottom h-full flex flex-col items-center space-y-3 justify-end",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                id: id + "-languageSelector",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $4b45582cae2595be$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                        id: id + "-report-button",
                        size: "xsmall",
                        title: t(`Report a problem`),
                        onClick: ()=>setIsOpen(true),
                        variant: "neutral"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8945e51c91a55fa1$export$2e2bcd8739ae039), {
                        isOpen: isOpen,
                        handleClose: ()=>setIsOpen(false)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("span", {
                className: "text-sm text-gray-500",
                children: [
                    t(`Powered`),
                    " ",
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("b", {
                        children: " PHPCreation Inc."
                    })
                ]
            })
        ]
    });
};
var $0e35b39efb2fe16d$export$2e2bcd8739ae039 = $0e35b39efb2fe16d$var$FooterLogin;


var $61b035b0815ca324$exports = {};
$61b035b0815ca324$exports = JSON.parse('{"Indicator":"pfqcn","Application":"phpconfig","Bundle":{"app":"appBundle","current":"configBundle","security":"securityBundle"}}');


/**
 * @see  {@link path http://localhost:3000/dev/quality_assurance/naming-convention-pfqcn }
 * @param bui Bundle unit interface object
 * @param Part part of the doc
 * @param Element element belonging to the part of the doc
 * @returns return the fqcn as a string in the format 'pfqnc_phprconfig_appBundle_main_menu_links'
 */ const $14899fc8b120af69$export$c11f7f0cac96af2a = (bui, Part, Element)=>{
    let fqcn = `${(0, (/*@__PURE__*/$parcel$interopDefault($61b035b0815ca324$exports))).Indicator}:${(0, (/*@__PURE__*/$parcel$interopDefault($61b035b0815ca324$exports))).Application}:${bui.Bundle}:${bui.Unit}:${bui.Interface}${Part ? ":" + Part : ""}${Element ? ":" + Element : ""}`;
    return fqcn;
};
/**
 * Goal: workaround Joyride not support of dot '.' and double dots ":" inside target.[since it is using css selectors]
 * Replaces the `property` value of each object in `arrayObjects` that matches the `searchValue`
 * with the `replaceValue`.
 * @param {object[]} arrayObjects - An array of objects to be modified.
 * @param {string} property - The property name to be modified in each object.
 * @returns {any[]} An array of modified values of the specified `property`.
 */ function $14899fc8b120af69$export$5ef1c346a2bc96ea(arrayObjects, property) {
    return arrayObjects.map((i)=>{
        // destruct i so we can have the values, not the reference copy (doing newObj=i give the reference !!)
        let newObj = {
            ...i
        };
        newObj[property] = i[property].toString().replace(/[.]/g, "\\.").replace(/[:]/g, "\\:");
        return newObj;
    });
}
const $14899fc8b120af69$export$6dcf99043c7108a7 = (item)=>{
    return item.replace(/[.]/g, "\\.").replace(/[:]/g, "\\:");
};



const $d916a442134b0b1f$var$Login = ({ fqcn_bui: fqcn_bui , devUsername: devUsername , devPassword: devPassword , sampleResource: sampleResource , appEnv: appEnv , redirectPage: redirectPage  })=>{
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    const router = (0, $8zHUo$nextrouter.useRouter)();
    const { query: query , isReady: isReady  } = router;
    const InputRef = (0, $8zHUo$react.useRef)(null);
    const InputPasswordRef = (0, $8zHUo$react.useRef)(null);
    const [isAutoTested, setIsAutoTested] = (0, $8zHUo$react.useState)(false);
    const [isLoadingToken, setIsLoadingToken] = (0, $8zHUo$react.useState)(false);
    const [formData, setFormData] = (0, $8zHUo$react.useState)({
        username: "",
        password: ""
    });
    const { mutate: login , isLoading: isLoading , isError: isError , isSuccess: isSuccess , data: data  } = (0, $d8558f4cea2fd4d3$export$2e2bcd8739ae039)(redirectPage);
    const { mutate: login_auto , isLoading: isLoading_query_auto , isError: isError_auto , isSuccess: isSuccess_auto , data: data_auto  } = (0, $d8558f4cea2fd4d3$export$2e2bcd8739ae039)(redirectPage);
    (0, $8zHUo$react.useEffect)(()=>{
        if (isReady) {
            if (query.username) {
                setIsLoadingToken(true);
                setFormData({
                    username: query.username.toString(),
                    password: query.password ? query.password.toString() : ""
                });
                login_auto({
                    username: query.username.toString(),
                    password: query.password ? query.password.toString() : ""
                });
                setTimeout(()=>{
                    setIsAutoTested(true);
                }, 500);
            }
            // check if the token is valid
            if (query.token) {
                setIsLoadingToken(true);
                (0, ($parcel$interopDefault($8zHUo$axios))).get((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud + sampleResource + "s", {
                    headers: {
                        Authorization: `Bearer ` + query.token
                    }
                }).then((data)=>{
                    setIsAutoTested(true);
                    setIsLoadingToken(false);
                    (0, $8zHUo$cookiesnext.setCookie)("token", query.token, {
                        sameSite: "none",
                        secure: true
                    });
                    (0, ($parcel$interopDefault($8zHUo$reacthottoast))).success("Redirecting...");
                    setTimeout(()=>{
                        router.push(`/${redirectPage}`);
                    }, 800);
                }).catch((e)=>{
                    setTimeout(()=>{
                        setIsAutoTested(true);
                        setIsLoadingToken(false);
                    }, 1000);
                    setTimeout(()=>(0, ($parcel$interopDefault($8zHUo$reacthottoast))).error("Invalid Token"), 1300);
                });
            }
        }
    }, [
        isReady
    ]);
    // Password input focus on error
    (0, $8zHUo$react.useEffect)(()=>{
        // if (InputRef.current) InputRef.current.focus();
        if (InputRef.current) {
            InputRef.current.value = "";
            InputRef.current.focus();
        }
    }, []);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $af67bda176efb977$export$2e2bcd8739ae039), {
        pageTitle: t(`Log in`),
        isLoading: (isLoadingToken || isLoading_query_auto) && !isAutoTested,
        //   isLoading={true}
        skeleton: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $78144f1d8a648789$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "", ""),
            className: "grid md:grid-cols-2 grid-cols-1 min-h-screen ",
            style: {
                fontFamily: "Roboto"
            },
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$reacthottoast.Toaster), {}),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("main", {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "main", ""),
                    className: "flex flex-col items-center space-y-2 p-5 md:p-7 md:py-10 bg-white shadow-lg rounded-xl text-gray-700",
                    children: [
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "main", "leftside-authform-logo-image"),
                            className: "__LOGO w-full py-1 flex items-start",
                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                                href: "/",
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                    className: "transform scale-75 hover:scale-[0.78] px-2 py-2 mb-3 transition-transform ease-linear border-l border-gray-200 hover:border-blue-600 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $59ff00cb4a4db4e4$export$2e2bcd8739ae039), {})
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "leftside-authform", ""),
                            className: "__Center lg:pt-10 pt-5",
                            children: [
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("h2", {
                                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "leftside-authform", "login-title"),
                                    className: "text-2xl md:text-4xl text-gray-900 font-semibold",
                                    children: t(`Log in`)
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("form", {
                                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "leftside-authform"),
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        login(formData);
                                    },
                                    className: "flex flex-col items-center w-full ",
                                    children: [
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ce350b8ddb52fbc0$export$2e2bcd8739ae039), {
                                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "leftside-authform", "username-input"),
                                            label: t(`Username`),
                                            inputRef: InputRef,
                                            state: isError ? "error" : "default",
                                            // size="large"
                                            value: formData.username,
                                            required: true,
                                            name: "username",
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    username: e.target.value
                                                }),
                                            placeholder: t(`Username`),
                                            icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$63d8b75acbf91639), {
                                                className: "w-4 h-4"
                                            }),
                                            iconPosition: "right"
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ce350b8ddb52fbc0$export$2e2bcd8739ae039), {
                                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "leftside-authform", "password-input"),
                                            label: t(`Password`),
                                            inputRef: InputPasswordRef,
                                            state: isError ? "error" : "default",
                                            message: isError ? "Invalid Credentials!" : "",
                                            // size="large"
                                            required: true,
                                            type: "password",
                                            name: "password",
                                            value: formData.password,
                                            onChange: (e)=>setFormData({
                                                    ...formData,
                                                    password: e.target.value
                                                }),
                                            placeholder: t(`Password`),
                                            icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$d751189d0d6ceeb2), {
                                                className: "w-4 h-4"
                                            }),
                                            iconPosition: "right"
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                            className: "__Form__Submit flex flex-col space-y-4 w-full",
                                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                                className: "flex-1",
                                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                                                    className: "w-full",
                                                    isLoading: isLoading,
                                                    labelLoading: t(`Loading...`),
                                                    variant: "primary",
                                                    size: "large",
                                                    title: t("Log in"),
                                                    type: "submit",
                                                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "leftside-authform", "login-button")
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        devPassword && devUsername && appEnv && appEnv == "dev" && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "leftside-devnote"),
                            className: "__DEFAULTS flex flex-col items-baseline w-96 p-8 rounded-lg",
                            children: [
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                    className: "text-xs font-medium text-gray-500 text-center py-4 ",
                                    children: t(`For dev`)
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full space-x-2 p-1 rounded-lg ",
                                    children: [
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("label", {
                                            className: "text-xs font-medium text-gray-600 flex-1",
                                            children: t(`Username`)
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                            className: "font-medium text-xs flex-1 flex justify-center",
                                            children: devUsername
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                            className: "flex-1 flex justify-end",
                                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ffe80b878f95bd4c$export$2e2bcd8739ae039), {
                                                content: devUsername
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full space-x-2 p-1 rounded-lg ",
                                    children: [
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("label", {
                                            className: "text-xs font-medium text-gray-600 flex-1",
                                            children: t(`Password`)
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                            className: "font-medium text-xs flex flex-1 justify-center",
                                            children: devPassword
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                            className: "flex-1 flex justify-end",
                                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ffe80b878f95bd4c$export$2e2bcd8739ae039), {
                                                content: devPassword
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            style: {
                                zIndex: 1
                            },
                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $0e35b39efb2fe16d$export$2e2bcd8739ae039), {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    className: "Left-side md:block hidden bg-gradient-to-r from-blue-500 to-blue-500 justify-center items-center",
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-full h-full flex justify-center items-center ",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                            className: "w-3/5 h-3/5 ",
                            children: [
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                    className: " bg-white w-28 px-5 py-2 rounded-lg ml-20 my-2",
                                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $59ff00cb4a4db4e4$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $355f333c554f9d5c$export$cdca941d70bf0aea), {})
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $d916a442134b0b1f$export$2e2bcd8739ae039 = $d916a442134b0b1f$var$Login;





var $dc63f80450721a53$exports = {};

$parcel$export($dc63f80450721a53$exports, "IconGlyphGlass", () => $78d04100a78ce301$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMagicWand", () => $de9d818529904f3c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVectorPathEdit", () => $1b60da1fa10622b6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMemoryCardEject", () => $30c8bcef58f1ef8e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCeleriac", () => $880c812ceeee79e8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCelery", () => $f7be66ae0f33798c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLupin", () => $87ef33f6cfde735e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMustard", () => $27fb4879b213ee1f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSesame", () => $7e364dea33fa0f9d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPeanuts", () => $0ce1c90def0e6bf8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInvoicePlus", () => $3aa4c59a3709719c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInvoiceMinus", () => $e8b96fa3d3c15246$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInvoiceAlert", () => $a12be3bf6107e1da$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphText", () => $ab6f53e9c319ab76$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInvoiceCheck", () => $692248798fe4353f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMolluscs", () => $6666d1ee7f56af7b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPercentSign", () => $2f6f99f279b965c0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneScan", () => $5ded200588592314$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneNfc", () => $e4c83fa7ebaa50f8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneCharger", () => $0ed591c40a7da7d2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIrisScan", () => $8c0dc42c4fc2e2fd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFaceScan", () => $9b345e9d2274a989$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVoiceScan", () => $04057342086e0880$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserVoice", () => $2c48e643455f7e73$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphItalic", () => $fb43c2598a802261$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeadVoice", () => $0322b902827a7c7a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShadows", () => $10d2ea9527a13018$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHighlights", () => $04741d592d622565$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVignetting", () => $d85214bb85f2948d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCorrectionSkewed", () => $1f883d7d182b06ee$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCorrectionSkewedAlt", () => $300a950ba40ebb0b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCorrectionTilted", () => $7da8ad4099841565$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCorrectionAuto", () => $dbf78ed60c11fed0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSafeOpen", () => $48c48631a2300713$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSafe", () => $2e9b37bcd2a5d8ff$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBold", () => $c9b4ac393b3fc660$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSafeDigital", () => $6a762a33fa827e88$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStatsOneDay", () => $cf7e91564f24dd4d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStatsBarsOneDay", () => $7a4bca23db1deebe$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStatsCircleOneDay", () => $2c20f3b96442918c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDisinfectionSpray", () => $4d885d5ffe2fdc25$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDisinfectionSpraySmall", () => $c1a93864c6356f01$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDisinfectionSoap", () => $72c291c9c8a4ede2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSidebar", () => $ee39f7af43a79b8f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSidebarRight", () => $a838e4d53e9f7f4f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphToiletPaper", () => $710f6120a94f1736$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUnderline", () => $aa780a7d8fa78821$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphToiletPaperAlt", () => $1acad781319413ea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGloves", () => $231babbada759590$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTongue", () => $4ce3f835b4b9cd98$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTongueOff", () => $64d4182b674a2bb5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNose", () => $45e7a8ceb3f8a4ed$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNoseOff", () => $8366933221a3a777$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFactoryOff", () => $4f7f8ac13499bdc3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGovernmentOff", () => $1cfc296d847cc5cf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBlackboardOff", () => $7c485769ba167a0f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCartOff", () => $522611f4390ba99c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStrikethrough", () => $14e085d673b7d432$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDumbbellOff", () => $1d70645f6e745770$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFaceMaskGasFull", () => $31a1c90ab3511c4a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDoorHandle", () => $92daa29de532b5ab$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCursor", () => $52ed1a429eda6b24$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDock", () => $3c4ff1f79c42add2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDockLeft", () => $3327c2a7fbd13ae0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDockRight", () => $b07014c434882dfc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSocketB", () => $d8c9a22dbdafe450$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSocketE", () => $1a1a37651a074b3b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSocketI", () => $a9b9c3b06c76b887$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTextHeight", () => $8ee848f2679d1a8a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSocketG", () => $f2e9c1c7eb8ac616$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTextWidth", () => $3a6f60587f42447b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTextResize", () => $5620f0f5be50beee$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIndentLeft", () => $9c85819ec3029883$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelope", () => $7f95bdcf545c6dcb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIndentRight", () => $cfdf6945c0b83b24$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphParagraphLeft", () => $1257f9fdcbeda48c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphParagraphCenter", () => $e5c314079bdb2337$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphParagraphRight", () => $c7b6aa55f20d562d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphParagraphJustify", () => $30264fc30ac07d1b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphList", () => $2b252a61255d0959$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTextSmaller", () => $3ab6bd95e9e0ca28$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTextBigger", () => $284df3913277dc1e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTerminalIsolated", () => $26182bd27c0a9ff5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCode", () => $e3a7d1d5751b06ef$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCamera", () => $46ebc7a03a1a8efa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTable", () => $879348f5a3252ded$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeFull", () => $f9f0c04d602471ae$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeEmpty", () => $fed373bb0d10f67a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeDown", () => $386ea5992c69b43b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeUp", () => $518674a1a9a95a86$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopePlus", () => $93728be86e83b55b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeMinus", () => $073fa9a2668ac387$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeNo", () => $663ca1a7961f839d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeFlag", () => $553e2f167b26244c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeLock", () => $cb4dae3bf4d724d8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeart", () => $2c6bb21c20717a17$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEnvelopeStar", () => $c3be581d3912a024$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInbox", () => $1d2c2c97f1f63ae7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInboxPlus", () => $88d2cd0121ca79e9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInboxMinus", () => $0e775541914447ec$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInboxLock", () => $cc2ee9917dcf0328$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInboxDown", () => $811a9ce5d1b50cb4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInboxUp", () => $71e50ad8c1a330a4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCogwheel", () => $fa2b875bff702098$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCogwheels", () => $188845dc26b87281$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCurves", () => $ba287a9439991d71$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBeachUmbrella", () => $a63189c084085f4e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAdjust", () => $348964e5cbf73944$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDatabase", () => $898695db943e2388$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDatabasePlus", () => $cac9b95a5b5d8adb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDatabaseMinus", () => $b63a8d12570e4323$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDatabaseSearch", () => $b482c18067696a29$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderOpen", () => $bfa52eea19dd88b5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderPlus", () => $09e6cb98cc586c8d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderMinus", () => $cc9ee88a14ed87a2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderRefresh", () => $88664fdd9daddb86$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderCheck", () => $0290c20c6af323d9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTrain", () => $32f6014e7034ee22$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderStar", () => $1a7ada628865f8e0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEdit", () => $7f222d9caa6d5614$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareNewWindow", () => $62a357131ea9393e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareCheckbox", () => $678bd28d50b418d9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmpty", () => $fac3744beb9e32c2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareSelected", () => $bbd2a4717c1a07f6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareIndeterminate", () => $1e153c0ec548d6c3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphThumbnails", () => $f951051a92cd5794$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphThumbnailsSmall", () => $bcbd128d569ba9eb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphThumbnailsList", () => $d659d4bf13bc5885$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPrint", () => $acad9d10c49bd361$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPlaylist", () => $3526533fb217accb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphComputerAllInOne", () => $a6ab394e99bab9b4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphComputerPcTower", () => $b93605b3268ce8c5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphComputer", () => $e70dceb6996dc265$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNotebook", () => $dbd4c9ffb64593e4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTablet", () => $58c73b9820928fe7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhone", () => $74d0fb4b6a21a112$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneOff", () => $a45044c852f55dd7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneVibrations", () => $0b1073677fc60e1f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneShaking", () => $0cc99a2ae063730f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBin", () => $d8e13759ed34e688$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEarphones", () => $7dfc05b725ef7a56$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSkipToPrevious", () => $4e8c99063572445d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSkipToStart", () => $97a1f2a41e583565$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRewind", () => $b8541eab608a2294$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPause", () => $89b3a2f5d3e8eec7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPlay", () => $d47cac4837d9cccd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStop", () => $26134af6c26b22ba$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForward", () => $c5d568188893ec5b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSkipToEnd", () => $95512a612b765a32$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSkipToNext", () => $1a8097b29dccd119$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMusic", () => $6f1c719f791d71ab$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEject", () => $55d5a28531d570f3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVideo", () => $3e3ee7893b561fdf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVideoOff", () => $a28be104ef86cef7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVolumeBluetooth", () => $885ddef6473f11c0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVolumeOff", () => $54943b86849f817b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVolumeDown", () => $b490ab4e5ac70fa1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVolumeUp", () => $426fb72a410234f8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVolumeMax", () => $ac6cdcf152a0aea2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCd", () => $1fd40a9a49267759$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMc", () => $192f117d1b677cc6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMusicAlt", () => $3d9fb5fc763c4d93$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLp", () => $f41905b832727344$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyPlus", () => $c1f5a7aa080cb922$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyMinus", () => $aa6e0b964c24ea0d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyRemove", () => $079aeff35658d6bd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyCheck", () => $63caa76d55c2085c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyQuestion", () => $e55ec97ea5b020e6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyInfo", () => $1b71da081c64c66d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyAlert", () => $5367ad947e11193d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphOpen", () => $dbd9107b734ff5c6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSave", () => $f36453b1415bf108$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLeaf", () => $d2e76a5857156b40$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeartEmpty", () => $9954ccc795d9b590$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSaveAs", () => $b9a55f50ee1af8bb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCart", () => $122f010447310344$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCartIn", () => $27157c885ba4c9db$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCartOut", () => $ce1d32f10145efb9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCartCheckout", () => $2b37f9cf2d5cca69$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCartCheck", () => $b9cda3f9465edd1a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyPlay", () => $15873354000ba0f5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyDown", () => $05486342827b973c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyUp", () => $c68976d089c07e0f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyLeft", () => $9aa50276187279af$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHome", () => $b9844ce1e395729a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmptyRight", () => $ffd85f22d1bbfe82$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowDown", () => $d0354ee655fb369a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowUp", () => $89a23d644354cb7a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowLeft", () => $24ee13999ae3eade$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowRight", () => $1b32ee92c166bd97$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFullscreenOff", () => $7dc00110d85a655f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFullscreen", () => $5c9874c41e72a2e0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLock", () => $7b2e231ff5d06c3e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLockOpen", () => $5ae32b7492e3d468$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCoins", () => $b1a61cbb96347d77$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSnowflake", () => $68c2cd419f0d853f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBanknotes", () => $124da0bf5b3adda6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronDown", () => $67a6d83111ae6b32$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronUp", () => $c934f91559a45195$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronLeft", () => $c459c47c63a8f2ea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronRight", () => $843b93157390ca20$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBitcoin", () => $0218feebc4384bd8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEuro", () => $ad09770d5fdfe35a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDollar", () => $cd85ba76c1516e84$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPound", () => $30cda53062431f93$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphYen", () => $99618be16976742a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFire", () => $cbebe2d8b94a9623$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRuble", () => $a88eb73fb393ce46$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMoon", () => $9ce20de1fa01d156$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSun", () => $53c5da3ed080fcf3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLasso", () => $177fb6ab5526941c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCalculator", () => $1005fdd2e8b00969$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChatConversation", () => $cf327f5b66cbd318$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChatConversationOff", () => $feb29b230e2b2357$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChatConversationLock", () => $79b74cb591073f00$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChatMessage", () => $629c8c1f40441674$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChatMessageLock", () => $65a3b3ce586b782a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMagnet", () => $33c1a9361bbad51b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChatMessageCheck", () => $254162daf480a9e5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBrush", () => $53ab0752e4b4a0e3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMarker", () => $7a6e56f925747165$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPen", () => $89953d913ce4b61a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpray", () => $8d6f38ee0a4f3914$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFill", () => $e0e2f3b270cc326d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphClean", () => $b7a491506f29156d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDropOff", () => $1dc65d8e1baba6fc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPalette", () => $dc391b78fda35762$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDiamond", () => $bbfaf4acd1efde47$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserParents", () => $a5c9013d9903a040$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEraser", () => $0d6c9b312b66e2ea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDivingFree", () => $dc548f306d120191$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDivingScuba", () => $3581c0d5d0402b0e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBoat", () => $c1475ff90669b856$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSwimmingPool", () => $685861058d3612a8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBuoy", () => $8a75beb28f23ecb3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphOxygenBottles", () => $547aac7ce5c7a659$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFins", () => $d1323620843a0543$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAnchor", () => $424caf893c58bc52$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFishes", () => $334234008f475ddc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBinoculars", () => $784009ed01ff5711$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFishesBait", () => $ad9ba5487262a4a5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDirection", () => $8b2a7db755f63fd8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDirectionEmpty", () => $65df965f66e3d297$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDirectionFull", () => $7eb75b41cb43b892$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlagWaving", () => $17c755553fc5b01c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlag", () => $aeaa6ddf6df345d2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlagTriangle", () => $9db82c61a6ce82f4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphComments", () => $e1c34e85e4be8150$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCommentsOff", () => $5656b264e856c6f9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCommentsLock", () => $c2888363d4b7f51e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRoad", () => $b310f7b1f7d6e0f4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCake", () => $e49311aa97e9d05c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSetWine", () => $1fbf11df465449bd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGlassWine", () => $9b5de7bca7e312fd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCoffeeMug", () => $eefda52a41b97534$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDrink", () => $3d16e991d24cf0e1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBeer", () => $a8fc6e77d3e77cb5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBeerAlt", () => $7eb705f302df5859$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFastFood", () => $7f75a3d76efd4552$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCutlery", () => $01a0f3557c57ce11$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBlender", () => $75b9c124bd960760$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSearch", () => $d1ea98dafa1751ff$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPizza", () => $68f7b19bfc66f412$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCoffeeToGo", () => $ddc1629292516db4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTeaPot", () => $adc73bd0bda2a1ad$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTeaMug", () => $269c216193251ec4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCoffeeBeans", () => $f6e0fda3f8fdb98a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTeaLeaves", () => $d2f10879982da9c4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFrenchPress", () => $794bada51c0e797f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPot", () => $413f405cf3dd48ea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKettle", () => $6deb3217161b06af$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGrater", () => $bb7f25a4b35c54b0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCars", () => $d0f35fa19a52c35b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCooksHat", () => $8fa1afb214fad6f9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyPlus", () => $0a4a07b53d99966c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyMinus", () => $ed0df52bd1fce529$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyRemove", () => $1558bcf25de42805$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyCheck", () => $a937d4db59e50121$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyQuestion", () => $77de731e96afce01$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyInfo", () => $fc369373bb726da3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyAlert", () => $4b43cb685e86e20e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleEmpty", () => $a189c61f18b4ca5c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleSelected", () => $c1bc38cb114b2b6b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDog", () => $3d0a9a09cd237532$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphClipboard", () => $c0f25e5843a6b5c7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAsianFood", () => $b13f2545b5beebb3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareUpload", () => $e359bde704f9b58a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareDownload", () => $25e5ea00456fda30$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVerifyEmpty", () => $f4b19b2754a5c42d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVerifyCheck", () => $41fa60ec10b59478$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNoSymbol", () => $a2133bfb230821d9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyPlay", () => $4a5910c887a42d9e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyDownload", () => $5b825b914371e7ce$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyUpload", () => $832ff90a8de5508d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyLeft", () => $414a556ce45cd211$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPencil", () => $aaf542a1d3c717ab$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmptyRight", () => $a04a99f4723be141$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpade", () => $87b45723538e8c14$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSaw", () => $f241c63a5d15221f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphClawHammer", () => $f8219286fdcf04d8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHammer", () => $4ac47ef705cfd8f8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphScrewdriver", () => $a7a8abb21019a365$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWrench", () => $1e751b39527b76ee$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAx", () => $cc61ee5308c7f866$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBlacksmith", () => $d422c232b20e3c0f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSawBlade", () => $fab42a4fa59d8592$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBus", () => $a1c89f17ae4938f1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCertificate", () => $e58be2fbbcca1c3b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUsers", () => $5e3cff78da2cfae3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShieldCheck", () => $c6120c1a4994b0f3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShieldHalf", () => $2f830a60c3e7d800$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShieldEmptyStar", () => $5b025195ebf2ed8f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShieldQuarter", () => $96f3d25a7ed32be4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShieldStar", () => $e7402e46d57228d5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphContactlessLock", () => $8b97bf8cfb0ba6be$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphContactless", () => $3334bb54d70bbe34$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCreditCard", () => $f9b221c2b7b8b18f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAccessPoint", () => $7b37aabd40cfc187$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCreditCardOff", () => $ef88fff78e4d4cf5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphQuadBike", () => $c12a16c36450b633$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMotorbike", () => $bedb1a3791a5d579$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquares", () => $3394a6f9f2897970$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBrightnessUp", () => $1f1f8fb9e1d1c80c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBrightnessDown", () => $3d8286a3d193943c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolder", () => $150a73bbeea8eb42$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderCogwheel", () => $dad232f18e84a6ad$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderAlert", () => $c4aec530be05fa11$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderLock", () => $30e7dc61643b862c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLuggage", () => $ff198129aff5d076$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFolderNo", () => $8076a50ebaf4848b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMic", () => $eb45ee7ed6e08298$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMicOff", () => $142ac40fe9f85996$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRepeat", () => $c1b9faa2b7cbd8b1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRepeatOnce", () => $c04e163a70cdabf3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphElectricCord", () => $17b9b3d66b474818$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSelfWindingCord", () => $8a04c1cd58cfdbc3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIdBadge", () => $e5dbbd47a8b12d21$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIdBadgeVertical", () => $a1805f41d0876d4e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIdBinder", () => $1d9a7e45c3da04a6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserIncognito", () => $4fc10ff478a9548c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLockOff", () => $6287924da417ce7e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLink", () => $6d12b2c4b39e351b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLinkRemove", () => $094678927b9ccdf4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBank", () => $5c9239055a22c7c6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphScissorsCutting", () => $da4631627f97c043$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMouse", () => $3e03599ff592eec7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMouseWireless", () => $00b40af949c7d62c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKeyboard", () => $93f47e4c850d44fb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKeyboardWireless", () => $edc1dbee358ccce1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGraphicTablet", () => $f7dead5bb6a8bbb4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserFemale", () => $586c2792d19b2311$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGraphicTabletWireless", () => $6c3803ec9092ce35$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTShirt", () => $7c8ab648d29a355b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTShirtV", () => $ae38a4a641d45547$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTShirtSleeves", () => $1331025dce149bd9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShirt", () => $9c9ba73907572dc3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTie", () => $6bfe0f71898ff422$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTrousers", () => $56f93fe239c6864a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDress", () => $c033accdae7f0cdc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUnderwear", () => $a616dcc57b2fc4b1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFabric", () => $9bea3c7a71b38517$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFile", () => $fb1411d6c2c57e7c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLeather", () => $5cf5dc3ffc161180$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPlus", () => $464b3fd36ff0bd1a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMinus", () => $158d7a26243dbb39$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTimes", () => $dceed6addde58781$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDivision", () => $44ee57a349c8efd2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEquals", () => $becd13b922513759$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHanger", () => $7943d1ebb279b68b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlower", () => $b8a9636f1e27eafe$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPlant", () => $ef1e6cf839ccf180$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTreeConifer", () => $45e034c428347e43$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPicture", () => $931071e957291e25$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTreeDeciduous", () => $af77e7a66dae513d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBowling", () => $f4d5dad42a686c54$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRugby", () => $8a91e9592ed4a2f2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTableTennis", () => $e13de8a51f42da5e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBasketball", () => $7a8ad13f291e8ae8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVolleyball", () => $c202d66c8b798bcb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFootball", () => $e45f7c17967c1aaa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBaseball", () => $ad19f9adff4094a2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHockey", () => $5ba9510e15de43f0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGolf", () => $13c0eb931be01f25$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAirplane", () => $cf507154190949d7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGolfGreen", () => $cf3f527afb9073f1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWinners", () => $4621d8e52eb24c48$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWinnersStars", () => $a1d7834fba54113a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMedal", () => $fb8295234e4f912a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDumbbell", () => $f18e74f8587d107e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilter", () => $cdfc8602ec22de0e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilterPlus", () => $5b2452b9f76464e2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilterMinus", () => $7d9c70de537281c4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilterCogwheel", () => $c68a4fd02d923599$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphImport", () => $9a230dbde7da0c56$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUser", () => $8ed7ed5dd5cd5ae4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNotes", () => $969a7287fb200f84$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphExport", () => $2666f5463fe2e2dd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHardDrive", () => $04a31dc5bb002e94$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHardDriveCogwheel", () => $00c015478d6f0127$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHardDriveLock", () => $4c41442ba7579b92$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHardDriveEject", () => $0d351985491c0129$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTurtle", () => $550ccdfa9ee6b936$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRabbit", () => $b1e2eb9527972814$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCat", () => $8eb537c331d4e170$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSailboat", () => $df0244c66c0cd3d3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWebcam", () => $0f9bb13b55f224ae$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStats", () => $387bbcadd72d78bd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphProjector", () => $e07cd6f2fdcd6369$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShoppingBag", () => $211a209e9c5bceed$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDice", () => $caf212cb72fd1aa2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGameController", () => $a39c138e1f3b6f98$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGameControllerWireless", () => $f29f94d2f7272ee3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPushPin", () => $eb27a69e41fdd6e2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIdBadgeLanyard", () => $b4818d172784a2cb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGlobe", () => $c80c26e6db335c2e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWorldWest", () => $a4860b0285ad96c8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWorldEast", () => $6adc03054bc75913$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStatsBars", () => $3d708429dc79a2bf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVases", () => $65a4cfc92089a54f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookPlay", () => $4d79622a8765eeda$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookLibrary", () => $3017b5611a7c55ba$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBriefcaseAlt", () => $afbc16040d255466$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBlackboard", () => $3865b333d2cdaef1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCrown", () => $820f7514b2012eab$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHomeFlag", () => $8e7ebcf3501e4178$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareTriangleDown", () => $44a7984d288bad51$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareTriangleUp", () => $3aa70e95f8d54777$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareTriangleLeft", () => $303d0eeaa58c1637$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStatsCircle", () => $c21f18a00b70d0a4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareTriangleRight", () => $14ea0e8d1079f7ab$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLogIn", () => $3ad1cbb3d8986786$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLogOut", () => $209242c9d93df68b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReply", () => $5843469d2629b933$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReplyAll", () => $e094529ba8a438da$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForwardEmail", () => $40ebaa87df1082a8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArchive", () => $8cb763f055e78508$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPlaylistMusic", () => $d65e5d90c01272f9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPlaylistVideo", () => $5904a1d016a49f1f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVideoPlayEmpty", () => $7c119e86eb9fe253$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserGroup", () => $1b78aa284a65bd41$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVideoPlay", () => $eab895a7e9caaaf7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBell", () => $e3963bae5bbb5f83$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBellOff", () => $cb365c74d617e9a0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBellRinging", () => $adec886c8f2da51f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSampler", () => $fc63872215f6633a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWallet", () => $c49944cb3b63f2bb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWalletPlus", () => $8e0bb21206686f24$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWalletMinus", () => $8858c414b8db2216$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWalletLock", () => $61b1983b7a6b3d43$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWalletCogwheel", () => $95538eae72fd4ef3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKey", () => $4cbadf05c9ef2abd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWalletCheck", () => $66318f3ef9532d61$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandLike", () => $ee7acc441864b772$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandDislike", () => $daad5414920f411e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandPointingRight", () => $b266c11ec9e24760$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandPointingLeft", () => $8886cd466a5271ec$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandPointingUp", () => $2b7f16c32ee2c884$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandPointingDown", () => $04b5c1ff0ba3d8f8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandOpen", () => $b10a74996331ce6f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandOpenAlt", () => $5871ee705aa1d433$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandOk", () => $fe3c08f8a3179b65$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCalendar", () => $2e665cf8df210589$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBriefcase", () => $7951879cff219a47$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSend", () => $1886aa0a073b67de$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFootprints", () => $803a623c1e0cd926$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphConstructionCone", () => $95fa4f4130fa8bf9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPhoneOld", () => $c621c088191d8a83$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCall", () => $009debcef2ac665a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFax", () => $5e7ae1d2faacf186$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShredder", () => $aec5556705a5d8a3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMultifunctionPrinter", () => $451c3de8554c3061$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphScanner", () => $7c776f83a9812ad9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRouter", () => $368aa59675801648$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSecurityCamera", () => $f6eb2a2b685c1035$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSort", () => $510732b7432045fd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSortAlphabetically", () => $1f97f72776a586fb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSortAlphabeticallyAlt", () => $b24c2634f32f06a2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSortNumerically", () => $6acc71549beefc60$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSortNumericallyAlt", () => $33d99f4de66791df$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSortAttributes", () => $08243d895cfc90ca$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSortAttributesAlt", () => $c6ce726741612000$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSwitch", () => $a5aeaa12c8513006$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserScam", () => $d9ebf8ed88ca76e0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVideoCamera", () => $db1c9f587632474c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserScamAlt", () => $ad9f01f62a3cc1a8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShopWindow", () => $57474ed773b1b221$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShopDoor", () => $9e54fc707433c993$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKiosk", () => $2c9e3a19e86affec$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKioskWheels", () => $e1ca56bf649b3fdb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKioskImmobile", () => $3936ee44c6011a13$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKioskFood", () => $05c0fe4b69e825a1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphExchange", () => $e124a18a37717e17$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBullets", () => $4d531a3ab39b6fe1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGun", () => $c59ded435fb8d40d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStar", () => $7f1571bbaa4422f5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGunOff", () => $1643f4605dbc4152$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChargingStation", () => $2aeb5f110ee0e479$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGasStation", () => $bc14aa41a1f9e97c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRotate", () => $dc37afa04d91d849$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRotateHorizontal", () => $8e4fed0734180cfd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRotateVertical", () => $b7c1100c0009556e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPodcast", () => $ce954a6c21627c32$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMore", () => $08140fe4a3d38549$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMoreVertical", () => $a1c740ef78072cb3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSkullCrossbones", () => $869f970e18f0a762$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSettings", () => $801c92e14ff50229$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStarEmpty", () => $30efc1c145e55dea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSkull", () => $cddee6523cd1f4ae$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServer", () => $dc553b37db60f487$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerPlus", () => $0b3f043acb65ffbc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerMinus", () => $1bfd77fc7716011d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerNo", () => $b9ae5e95575485d4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerCheck", () => $139c26b6857fa8b3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerLock", () => $da07b94025bf62f5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerRefresh", () => $70eca28c1953da7e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerFlag", () => $729c8b7f6144c0b3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphServerCogwheel", () => $71c5e4890641645f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPulse", () => $f52b1b234b3d212d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLightBeacon", () => $55b8cd4cab4427fb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBed", () => $4a228e50a67924fd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBedSingle", () => $88c56a31b97568e0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCot", () => $e24f670bb7feb9f6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPersonalHygiene", () => $01a2c54721c2f732$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHairdresser", () => $5674f464f941388b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBedSleeping", () => $1ce6460eaebb58df$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFoodService", () => $d86c977388f85623$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLampTable", () => $f91ea2c8681b09d4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLamp", () => $7ff8c41522d40133$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEye", () => $cbca32a1dc9c558c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHourglass", () => $6e1bcc86dd2377e1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMonitor", () => $6340a5ca2e18f641$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMonitors", () => $ecedfd37b0822888$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMonitorRotate", () => $81fea2bc047aff72$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMonitorVertical", () => $80769cb2b0a22e67$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPhoneToHorizontal", () => $f36ccfb2e28d7dce$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPhoneRotate", () => $80e8f0c9c3849dc0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPhoneHorizontal", () => $0222ba720c2d1531$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShower", () => $5198fc3375e100d7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShowerAlt", () => $5d817314f41d52d4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEyeOff", () => $c789d1a16e70a25c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBath", () => $b680ab6f45562492$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserParentsAlt", () => $040ebdcb42efabf5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserFamily", () => $ea4ae1e9c149d918$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserChild", () => $950a2ef653e0d438$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserBoy", () => $751104a66e091028$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserGirl", () => $7f51458572017e23$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpeakers", () => $8f1959bc963b234f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphProgress", () => $597ea9ef733b2d6d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTasks", () => $068caeaba262e045$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBarcode", () => $a44983cd1155f044$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAlarm", () => $f33346d0485a20cc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphQrCode", () => $7e80f633419886c7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCreditEmpty", () => $823492300bff5596$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCredit", () => $897c6ad247279757$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStarHalf", () => $7e696b185d121242$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloud", () => $fb05c820afdce076$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloudUpload", () => $d0b85fc8d05edfb7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloudDownload", () => $fb2854415518a95c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloudRefresh", () => $583b479813a95cd8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloudAlert", () => $935279f973530aa3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloudPause", () => $9f2bbd6ac3905422$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphClock", () => $bf6abbcdffcfe777$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloudCheck", () => $81549cc927a29248$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBag", () => $8e46e35d8ed18e6d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandDonate", () => $0bad8767464e28f9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandHeart", () => $5b3b3869035554c9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandshake", () => $9a8cb1bda0e296c8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHandPraying", () => $4e28e976c46c59de$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlash", () => $287d6160fef5f185$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlashAutomatic", () => $6adb6a2e2a9b0564$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlashNo", () => $f7f74a37a009fea3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTarget", () => $0c14f8d8cc5886c3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStopwatch", () => $d1298660d5035ded$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMarriage", () => $a6760b40fb540636$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShoes", () => $a2a085c6b37b56dc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShoesOff", () => $67386ff679a65fbf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCardHearts", () => $a646ed4171c0b7b6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCardSpades", () => $f97c7177e2b5bc70$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCardDiamonds", () => $a4e92c9c68365d02$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCardClubs", () => $9a2ac6c77bb6cd9d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBringForward", () => $e46675d71cde845e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBringToFront", () => $002048bce79fbd5a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSendBackward", () => $643dd38d95ab045d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphScissorsHorizontal", () => $c2a3adba82356610$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSendToBack", () => $c4acacf6483115fa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWashingMachine", () => $8ea0fa06d08daf7a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDryer", () => $d5a5cd7128ab8f02$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDishwasher", () => $ca046d5e4908560f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphOven", () => $8eefe6a32a5c7c41$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHob", () => $24a0eb6802a73add$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMicrowave", () => $8cb9e2242ebe2d61$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCluster", () => $9b7222dbec3f30d3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphShare", () => $379e63cad9a4df74$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTranslateAlt", () => $a0220f226bc935ed$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHistory", () => $977aec84731c4216$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTranslate", () => $af9ec7b132a7f5c5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDirections", () => $f0dfd04a6cbf0f1c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDirectionsArrow", () => $6e590f2303229227$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFinishLine", () => $340a25fb7c93e1a2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRadio", () => $392e4ed0334e91e9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStart", () => $75b794eee67aeae3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBomb", () => $6ce2c5165dc4672a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBug", () => $2d2bcde06949c22b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookOpenText", () => $3c9493eea39100db$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookOpen", () => $2ec1cd982bec3b95$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTruck", () => $a50ab3a6773fc2e4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNewspaper", () => $358439cf0cb7fbbb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMapMarker", () => $c035ffa49fb0d773$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMap", () => $bef90a56ad254518$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRoute", () => $c24b523acf3bc69c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNearby", () => $f100067fd616b8ba$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNearbyAlt", () => $a284c76da451cf7b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPiggyBank", () => $2dd73eb1ef62d575$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPiggyBankCoins", () => $c59b1d3b6493f208$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSoundSurround", () => $6c1e971f0cbaebcb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMenuClose", () => $c7a8408ad80b1330$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCar", () => $b778d4f1137058a1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTimer", () => $d1e645c08651e69d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMenu", () => $ec7d266974f3e11f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserNo", () => $7e512016439c0b74$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserLock", () => $cf3b3c38afc89caf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserFlag", () => $a1aa5bb50a75af7c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserStar", () => $2ce355753c56e0eb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserAlert", () => $38e82c133177a81e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserChat", () => $c3dbba9019a0a45f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserCheck", () => $f6581f4ab9d25c93$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareHospital", () => $6d16f187a092eb6a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleRedCross", () => $803cad4457b43828$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCompass", () => $9d3c9e41b820d996$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStarOfLife", () => $5d9d85dfdf99546e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCopyDuplicate", () => $68c7a1f9c8cd8616$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphScissors", () => $6ff588ae609d5835$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPaste", () => $0ae553c05b5f6058$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCopy", () => $3c7fb392aee6ec7c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBalanceScales", () => $b4980006b7bcc8fa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCourtGavel", () => $8c05bb0eff3b4555$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCourtGavelAlt", () => $b62b5ee839c09c34$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleHospital", () => $8f5e53e3785e0050$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareRedCross", () => $70f49f5f992d1fb4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPresentation", () => $dc24c2ed89b035df$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStarOfLifeEmpty", () => $c55feed84fad455f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphScalePersonal", () => $28b50e25740028de$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphScaleKitchen", () => $3c581373a1c6e83b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFireworks", () => $b2530ccfbf0c00a2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFireworksAlt", () => $0caf94ae7a7410f9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChemistry", () => $5c35ac059b3ab2b6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChemistryAlt", () => $5e5e5fd60d583afd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSyringeEmpty", () => $7d8560094d6bd92e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSyringe", () => $453fe637b8df9e8c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeartbeat", () => $64439050a9999205$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPaperclip", () => $b51074dfebfe5b6e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeartBroken", () => $4dec784e1e762b6a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCirclePlus", () => $63a93657d7806e43$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleMinus", () => $3722f276aca67af4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleRemove", () => $a91a47abd167f77c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleCheck", () => $024b4e8eb0e70117$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleQuestion", () => $c03908b1723299ee$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleInfo", () => $a5ddbfde1160a7cd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleAlert", () => $36e1e23e2ac210cd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTriangleAlert", () => $53545763b8d91b7c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphOctagonRemoveEmpty", () => $9d66e0b8b5e8afea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPower", () => $12b95a45734418b3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphOctagonRemove", () => $3fa19e098711c8aa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTriangleRadioactive", () => $2488876c7785efc7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRadioactive", () => $4cc324a84660cf0a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCompound", () => $f3a25751c5764c60$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDna", () => $a4b7568cd06f3fd7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBiohazard", () => $944e141f6dbfd80f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCirclePlay", () => $f9af44ac3cc8fded$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleDown", () => $4cd7a6b411feb638$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleUp", () => $f490ec4b6336f441$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleLeft", () => $5d2fb940c0c73727$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLightbulb", () => $64d3fd73e1eff99d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleRight", () => $997977e4a5966eac$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKing", () => $045833b76db3d8d4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphQueen", () => $5faa6b3006db6e5a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRook", () => $d203daf1caa1167e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBishop", () => $972165ba5755125c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKnight", () => $eec0c95271ef36a4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPawn", () => $7a2d3a5a823c11d6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDoor", () => $03eee656541254fd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBicycle", () => $fe456fc80859887f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphId", () => $c43b3cd50b87f384$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTag", () => $796d9287548d34b1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPayment", () => $234d41b2f941af78$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLegalSectionSign", () => $fde500b33c576d29$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVoicemail", () => $bd0853ca36dd2bf5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEqualizerDots", () => $632ddb58b74e71eb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEqualizerBars", () => $3360716cb4b84e97$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTaxi", () => $3ae45e82dec6c03a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTransportMixed", () => $beed7be8805a7475$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMetro", () => $8837ba367fc49eef$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCarRental", () => $7f996e9ca16524ca$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTram", () => $9f91c74c024738d2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTags", () => $1ba3ae6d59f73c7d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDashboard", () => $5332d8c1b1cb3ae1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMountains", () => $84426e335e9bde1b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForest", () => $bf3da30bc3736444$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCableway", () => $dc06495cff1de605$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCanister", () => $a75789371fcf8eb2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMotorOil", () => $6960b491a94b0098$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCarBattery", () => $3f2b7658cb48cdbe$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCarWheel", () => $026577a5bcbbe64a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCarWheelDefect", () => $403a1d4afaf9e728$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCarWheelWrench", () => $0c759a8f74a75109$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEducation", () => $8dfa3a15685394b3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCarWheelWrenchAlt", () => $af6808f03ea048e0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSuitcaseDoctor", () => $f05d0aafe3946bcf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTent", () => $ed7ae0563a8bef23$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKeyRounded", () => $ecb73906bea80967$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFlashlight", () => $7f87c50e838bcb4c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBackpack", () => $700a331d9414a79f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWatch", () => $096b2a00f1220bc3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWatchSquared", () => $faef1d6d0ab64c87$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSmartBracelet", () => $d2675476eff723a0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLighter", () => $8cd8118e46c510ea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRuler", () => $23669c15952d7916$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMultifunctionKnife", () => $30fc4c9cf0add945$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTextUnderline", () => $5862b6e98e3601c9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFont", () => $7960cb6f078de19f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSuperscript", () => $b59232b042f4a3a8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSubscript", () => $4503f90bfdd5e917$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTextBackground", () => $34b57da8aae179fa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeader", () => $bda6b3ad7986678a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDirectionsSign", () => $0317a4078e309b83$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBarbedWire", () => $05f46a47c8242041$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTractor", () => $8a8ef6a83ff79a8f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserPlus", () => $b672579fdfd22802$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGift", () => $5361cd3c63f57e65$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFence", () => $bde69fd26c2febc2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIceCream", () => $bdc77d1ca65e0543$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIceCreamOff", () => $a7e386af53d064a1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRemoteControl", () => $fba6af1ce614ac43$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPills", () => $1b0f36b527fd8e96$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMedicine", () => $3da31b8d447a4be3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPark", () => $0678e942ee75e6f0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDogTags", () => $8798f681ec8c12c4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLuggageAlt", () => $4bf2a1618d1f97ab$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLawnMower", () => $38418fa0e8144dc6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUmbrella", () => $1d4a6e78f5e399af$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBrickWall", () => $ec21d2ef8bf3299b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVotingUrn", () => $8f62f5b380fff67a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGovernment", () => $6b41be15fe10a80e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAnnouncement", () => $9d7a5dcabfb82c82$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDustbin", () => $2b2949926fc8d250$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFeather", () => $ef94a1c05d8fbc01$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRecycling", () => $7e256743de4a8020$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHomeFire", () => $5e4ac5bb964eaf41$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHomeFlood", () => $f34d28a0d9844ed5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWater", () => $1c14308c92940f87$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBook", () => $f1a9abb3a8775c87$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHomeForSale", () => $0a8dedc95044372b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCampfire", () => $afc156cb30d18b6f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFireplace", () => $fd93f4875813f12b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBasket", () => $00c34fe04340b700$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBasketIn", () => $af029475ada6460a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBasketOut", () => $e2605a0dc841b71c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBasketCheckout", () => $e630732bb785221c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBasketCheck", () => $bed418614c8db35d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFirefighters", () => $bcd76765f8945e72$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPolice", () => $f674651fcbb8acb9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookmark", () => $c4ebaab91d10a8d9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAmbulance", () => $c1a920682864a8e2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEar", () => $1b65e5f8fb9d97d9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEarOff", () => $29663ae7d72fccd8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTheaterMasks", () => $02dbd515d9f366d4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphKettlebell", () => $0b4093f6cd505be1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTicket", () => $214f3a2cdeb18f22$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTicketParking", () => $dd12f58ec7be21bc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphParkingMeter", () => $ecb84f04849b2df5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphParking", () => $1e7ddd5f92191e8e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCheck", () => $d112d3a9e8dea936$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWifi", () => $ac2c3326b8ec58a9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHash", () => $42d4fdc7e48ef092$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAlignTop", () => $897eaa24073b59a3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAlignBottom", () => $b00abaaad5b16127$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAlignHorizontal", () => $6600cd0799c4826e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAlignLeft", () => $f4575ce44041ce54$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAlignVertical", () => $fc4d85f2b4bab7e8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAlignRight", () => $793d0e48f09b5f7c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReflectY", () => $144235d8954528f7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReflectX", () => $76de35a40e6ac143$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphResizeHorizontal", () => $4079dff3cb040259$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCup", () => $3d0646cca8e8ae7f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphResizeVertical", () => $ad4f474f2a99b890$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallRedirect", () => $ecf4d77ab3f582ea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallIp", () => $8a35dd81783d8260$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallRecord", () => $46fe0e8db4d255bf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallMusic", () => $a469906da540a66f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallData", () => $dd8554c857e3c525$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallPause", () => $6abcf13139b82e8b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallIncoming", () => $7c70b4bfe3d8e5ad$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallOutgoing", () => $c4da3362883208f9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallVideo", () => $e46a5c02732480ba$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStroller", () => $40fb218e56443fd4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCallLock", () => $5871b079587ba96e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSync", () => $5a2964e31abfd56a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSyncAlert", () => $d1b237aaaaeebc52$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSyncCheck", () => $4e1535dda682a6bb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphModalWindow", () => $972776479f6a3961$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGas", () => $0ee8fd63883361e1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWastePipe", () => $ce6ef28531121793$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWastePipeEnd", () => $f37c9a2014ed6281$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphToilet", () => $b081607f07b70f6c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDrinkingWater", () => $334516b8094d4270$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeadphones", () => $32b60f0ea67fbd29$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDrinkingWaterOff", () => $e385a38ab76eb4d2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphApple", () => $985bebe7806ac47b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNeighborhood", () => $08abbaedc001b336$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTemperature", () => $aaddf367bcf6f39e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTemperatureAlert", () => $5f487a4a0e0c3377$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTemperatureSet", () => $a8d484f8801b1f0e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTemperatureLow", () => $5785f0a2068dd5ee$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTemperatureHigh", () => $da131bc52817658c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTornado", () => $cdb08c1fa51c4c72$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIceLolly", () => $34e9d375870e043f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeadset", () => $e8cc67ac3a82fd71$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIceLollyEaten", () => $5d6dd889308cfd80$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMilk", () => $c188e72cd632eac1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEgg", () => $28259d9fc7192217$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWheat", () => $2f73a4bcb4d33573$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCorn", () => $64ac57ec594a96cb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSoya", () => $6e3c4a67ee87e65e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphNuts", () => $be2662964c2c1b22$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCarrot", () => $88b67b76cadd4044$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMeat", () => $5872812f352bd6e4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSeafood", () => $8eef32891506835a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTriangleEmptyAlert", () => $7da6c9ee3e14188e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFish", () => $5a8a8b1b3db0a3aa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareEmail", () => $608ee7522e63e7fe$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEmail", () => $d97c8cbc76ab7501$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPaired", () => $c42f07fe233a0025$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPairedOff", () => $c05a40c249334f5c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSet", () => $11f17674862e690a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSetDown", () => $ecccd3bdeb88c1bd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronLastDown", () => $50fe0ae1cf9739cc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronLastUp", () => $63eb4aff13ab4d95$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronLastLeft", () => $90060ca24e3800ee$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserMinus", () => $a02d4bd0612d7f14$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBars", () => $e688e37e3375a5ae$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChevronLastRight", () => $361e1784f0ad3a3c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilePlus", () => $e99027a38d3ceaf0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFileMinus", () => $5eec0641d542d363$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFileRefresh", () => $7a0045439c124dc3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFileLock", () => $42a2bac44fedc22d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFileCloud", () => $1330bdeb8fe334cc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserRounded", () => $272944df52b1bb3e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserSquared", () => $0731c19a9db2d714$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDropDown", () => $4d353c28ffee80f2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDropPlus", () => $acf0a845745d1eee$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRetweet", () => $132edac20d040f42$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBlockMove", () => $08cd67fd9688e39d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFingerprintScan", () => $fb0a0404e1cfe092$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFingerprint", () => $bc5a9e72f8c489cf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFingerprintLock", () => $467acee4e259812e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFingerprintCheck", () => $2e9f26aca0aabdcc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFingerprintRemove", () => $6e86f8befe099434$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSatellite", () => $0874024b8fd45c38$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSatelliteDish", () => $a05ef91db72be3de$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSatelliteDishAlt", () => $194107e4c8c49d32$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRobot", () => $c54367086e3615f8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRefresh", () => $08754fdb712d5bac$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRadar", () => $cd6e0e5dc9bf7d6c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBatteryCharging", () => $90e86423cbccddfe$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBatteryCharged", () => $0141e22139c6d823$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBatteryThreeQuarters", () => $5f53514b9c80a2fd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBatteryHalf", () => $4381ce4ab309a3ce$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBatteryQuarter", () => $d88a2b16705fe245$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBatteryLow", () => $d0f7a6806c3c314b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowThinDown", () => $513e0d01bde4ba08$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowThinUp", () => $0842df720f849d44$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowThinLeft", () => $5aa69d829e2372da$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRoundabout", () => $1aa1254d2b410613$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArrowThinRight", () => $9ce94b84106f3f7d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMale", () => $d5655a4aa7fcb8b9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFemale", () => $7355db1fcc4dbb7f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVirginFemale", () => $954a4f6f008b203a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphIntersex", () => $88656c1ba0c47dea$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTransgender", () => $58ee02e1ed237497$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLesbian", () => $5e0c2a717a89b249$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGay", () => $801e612dcc38bbb0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHetero", () => $ce325b6b54ebf63f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphOther", () => $9a101602904ccbfb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRandom", () => $2d97e5654f96c170$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUnknown", () => $e05473745707d96e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquarePlus", () => $c4b1aa4fa8467292$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareMinus", () => $0ff2e32a37920f7d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareRemove", () => $1cc86020c9810652$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareCheck", () => $c362e54d0183d148$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareQuestion", () => $bdb7913f79835b52$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareInfo", () => $87ee00ee94790fe5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareAlert", () => $df6af8aee6f3a927$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSubtitles", () => $fc74b0a27451bb00$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphComputerNetwork", () => $a1a353d4e3cc9e51$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHeating", () => $c799fb724d8e0584$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphComputerNetworkAlt", () => $e96ce62195143d46$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSubtitlesOff", () => $ab2a606ae62ffc23$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSubtitlesPlus", () => $33d74fb52e45565e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSubtitlesMinus", () => $d989e5b262d584e1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAudioDescriptionD", () => $56ccd67343c2662c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAudioDescription", () => $d40d5d51519e0aef$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquarePlay", () => $00fe4b955e3a1d55$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareDown", () => $b10c7124ec619f4a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareUp", () => $5c8097319a80945c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareLeft", () => $689c15a7cee65ba0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReload", () => $c0c35c16052e9f99$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareRight", () => $2077d4928894a146$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVrInside", () => $265becc94a985484$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVr", () => $34ad639e081bf291$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserVr", () => $2f1f0967240f4e8d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserVrPlus", () => $e1ae0986e8b2b61a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserVrMinus", () => $e070bb42d1ce67cf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphViewFull", () => $f866f1ac44855e23$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphViewHalf", () => $a185790af6433480$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPuzzle", () => $633674e569bfd3c8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDoorOpen", () => $07e035cf3635c8bc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTv", () => $08573f99e23c279c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDoorClose", () => $3018c9e8884be977$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPackage", () => $4c60f44bc9d84b0b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphOneDayDelivery", () => $52898fad6113d16d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForklift", () => $e9aff2e75e71112e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTransportTrolley", () => $9fd259405cc18a38$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSimpleTrolley", () => $9798a94b393b9f02$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPalettePackage", () => $b6255ed7e2cb18c6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWarehouse", () => $e42cce689b0810c8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphThisSideUp", () => $e4610e2b3dd1cd0f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTerminalEmpty", () => $77dfd5ec59a19a1e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookLog", () => $d9e1184385d5b6b6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTerminal", () => $096c1b2039de1eb3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCandle", () => $28d03289d4eda628$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBalloon", () => $26d33b5b14f5d099$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBalloons", () => $dc26c7a75f5b4643$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMissile", () => $da468d83b504b330$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStepBack", () => $cb06d5f83f05ce92$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphStepForward", () => $c0fd570131c21f61$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUndo", () => $cb0486ae2e0f3296$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRedo", () => $03f1c4e1789e3562$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphThreeDimensional", () => $200758ec6ae82b21$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookAddress", () => $9b1bb59fe3a243f6$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphThreeDimensionalFull", () => $bbf118f263a91e80$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFactory", () => $7a872d9d8d2a0703$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFactoryAlt", () => $88e7c8d7613f8176$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUserWorker", () => $30756d31931edd2d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBarrel", () => $c81bbcadddf75851$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDiceOne", () => $f0833454f96a201d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDiceTwo", () => $4bd010afe59d948a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDiceThree", () => $375efc673bd66bb2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDiceFour", () => $8fb80baf49cce994$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDiceFive", () => $8aad33a033e3df24$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilm", () => $b1366a905054ade1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBuilding", () => $9b2b4caa4f9176d5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDiceSix", () => $466279c8c5dd10fc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSlightlySmiling", () => $c0725d6b0880632f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSlightlyFrowning", () => $4bcfd88228be33bc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPool", () => $1c727252b8ac52a2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTennis", () => $f6c44e73b4291934$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBadminton", () => $4ebd767c822d31e9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRestart", () => $d17e7da226f015a5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReplay", () => $8cf0d5b70ba02da4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHoneycombs", () => $e453371275f71512$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHoneybee", () => $3b38eaf6d5b6a673$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphEyedropper", () => $459be536fdfbd951$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHoney", () => $d5dd7acf6190c9e9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFan", () => $b5a9b0682ced1a0a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWind", () => $a90a67831de3de47$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRechargeable", () => $6146889e78f4d6e1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneLock", () => $d4760f4e728285f0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneCheck", () => $4b60419f3afc96ba$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneCogwheel", () => $e6fc16bb8dd64138$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMobilePhoneAlert", () => $a2ec5e6c098ab957$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPowerPlantWind", () => $a7a8ee2087c71495$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPowerPlantSolar", () => $2705813beac9af5f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphContrast", () => $fe58764786105a4d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPowerPlantWater", () => $8b90f376ad0cbee0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRewindFive", () => $0e87668d336586d8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRewindTen", () => $b64eee5b2ff38074$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRewindFifteen", () => $39268ed771636d02$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRewindThirty", () => $99dcfb0fe825c137$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForwardFive", () => $218d55adc610fd5f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForwardTen", () => $c89253352204f1fe$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForwardFifteen", () => $0447b3f41e76f8a0$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphForwardThirty", () => $e11ed9977000d038$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPassport", () => $770f373b022e967f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDrop", () => $d35f11cc3e4aed5c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPassportAlt", () => $63dcfab713e6ac45$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpeechBubbleQuestion", () => $4042a064e89da912$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpeechBubbleInfo", () => $1aa02108484d9ed8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpeechBubbleAlert", () => $61053a4b8516670a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReloadAlt", () => $c7efd87c794ab733$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPowerCordPlug", () => $dbb6f5a034faf267$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphPowerCordPlugOff", () => $37a80cf66e92e060$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphWirelessCharging", () => $caf932bcb7bebd36$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTvStreaming", () => $c276a242c3b318e4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCheque", () => $7a6aa98240c2853b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCrop", () => $241d7f223882877e$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphChequeOff", () => $52f8e9ae9bab8a39$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBuildingsMixed", () => $823c5561b320ec62$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBuildingsCity", () => $28611fb99e7e52be$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBuildingsPark", () => $10bdcaeded46250c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHighway", () => $83b6ccdc5fe1536c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTrafficLights", () => $56a79e59cb5c84d1$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTrafficLightsOff", () => $9e8416c406c75ee3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleMore", () => $8ad56762b8b66455$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareMore", () => $5de06b1b85d4bc86$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCircleMenu", () => $4df7feeb045550aa$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVectorPath", () => $4b00a4634fb42602$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSquareMenu", () => $01620e0665951448$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphListLetters", () => $d850313033b2f3f5$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphListNumbers", () => $ff003a29113b17dc$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInitialLetter", () => $30d37fc089a6aeb7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBrain", () => $3a147d0937885da7$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBrainAi", () => $1fccb0fc80648000$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphArtificialIntelligence", () => $ef3766e3532b1048$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMicrochip", () => $ef489cbc6fde5b26$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilterOff", () => $59c632d15d02223a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphBookLibrarySearch", () => $9a4bde592fc506ed$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVectorPathCircle", () => $b733eed2ccfabd0f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphFilesQueue", () => $06f9cec9b0dceb8c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCloudOff", () => $9f039d6d917efb55$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphTrending", () => $b5a6f4ad29e7e114$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphDisappearing", () => $c794f770bf1853c4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLayers", () => $56259810bb96ade9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLayersPlus", () => $25ed1b93b13b361f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLayersMinus", () => $4d75775530d72a71$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLayersLock", () => $9fef1567a601050b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLayersDown", () => $2812c1bfa0e9bef4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLayersUp", () => $1c2399e4e53552eb$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVectorPathPentagon", () => $49605780bd923541$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphLayersCogwheel", () => $54ea854ec9451fa9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAxesThreeDimensional", () => $9089eaccac1703f4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphAxesTwoDimensional", () => $cae790c97da8a0d3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphRulers", () => $0c47f9c1d236dc6b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpellCheck", () => $1480103c9cc209c2$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSpellCheckCheck", () => $0147cd51a7b1a8bf$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphGlobeData", () => $41d26e23e984c31a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMapSatellite", () => $b3c4602958c1ebbd$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMapCadastral", () => $780c15c337722e3a$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMapAerial", () => $8697c5b9253bfab4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVectorPathLine", () => $cfc15205092cbf00$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMapTourist", () => $6fa5a978d1016925$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCookie", () => $86e851d54a31173d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCookieAlt", () => $547c84e2dbfa9d64$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCookies", () => $7ab8851a4658acf9$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCashRegister", () => $549227679c7f8ab4$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphCashRegisterAlt", () => $fa4b26494309ed70$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphHardDriveNo", () => $64f94a611db138b3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSwitchOff", () => $0036e3a323a8da06$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphSwitchOn", () => $993cfdfb04fbdf90$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphReceipt", () => $6e8234614bac513c$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphVectorPathCurve", () => $e6168fd55fa37abe$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphInvoice", () => $e6a3d01a45355165$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUsbDevice", () => $96edf2f90ddaf8b3$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUsbDeviceLock", () => $4f489c28aa9adb2b$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUsbDeviceNo", () => $e43e201af8d60786$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUsbDeviceCogwheel", () => $3cf07fbef24487f8$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphUsbDeviceEject", () => $85780142eb4a1207$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMemoryCard", () => $f969aa32e102f57f$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMemoryCardLock", () => $1b74f1862603858d$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMemoryCardNo", () => $4877796e43b2b664$export$2e2bcd8739ae039);
$parcel$export($dc63f80450721a53$exports, "IconGlyphMemoryCardCogwheel", () => $7f4f2951a7e9bf87$export$2e2bcd8739ae039);


const $78d04100a78ce301$var$SvgGlyphiconsBasic1Glass = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17 17v8l4.644 1.393a.5.5 0 0 1 .356.48v.627a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-.628a.5.5 0 0 1 .356-.479L14 25v-8L4.62 4.805A.5.5 0 0 1 5.014 4h20.97a.5.5 0 0 1 .396.805Z"
        })
    });
var $78d04100a78ce301$export$2e2bcd8739ae039 = $78d04100a78ce301$var$SvgGlyphiconsBasic1Glass;




const $de9d818529904f3c$var$SvgGlyphiconsBasic10MagicWand = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 12a1 1 0 0 1 1-1h1a1 1 0 0 1 0 2h-1a1 1 0 0 1-1-1Zm3.243-3.343a1 1 0 0 0 1.414-1.415l-.9-.9a1 1 0 0 0-1.414 1.416Zm8.807.293a.998.998 0 0 0 .707-.293l.9-.9a1 1 0 0 0-1.414-1.414l-.9.9a1 1 0 0 0 .707 1.707ZM20 7a1 1 0 0 0 1-1V5a1 1 0 0 0-2 0v1a1 1 0 0 0 1 1Zm0 10a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1Zm4.757-1.657a1 1 0 0 0-1.414 1.415l.9.9a1 1 0 0 0 1.414-1.416ZM27 11h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm-4.186-.4-1.415-1.414a1 1 0 0 0-1.414 0l-3.192 3.193 2.828 2.828 3.193-3.192a1 1 0 0 0 0-1.414ZM4.686 24.486a1 1 0 0 0 0 1.414l1.415 1.415a1 1 0 0 0 1.414 0L18.207 16.62l-2.828-2.828Z"
        })
    });
var $de9d818529904f3c$export$2e2bcd8739ae039 = $de9d818529904f3c$var$SvgGlyphiconsBasic10MagicWand;




const $1b60da1fa10622b6$var$SvgGlyphiconsBasic100VectorPathEdit = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 4H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM9 9H6V6h3Zm5.166 14h3.667v3h-3.667Zm.001-17h3.667v3h-3.667ZM10 21H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm-1 5H6v-3h3Zm0-11.833v3.667H6v-3.667Zm17 0v3.666h-3v-3.666ZM27 21h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm-1 5h-3v-3h3Zm1-22h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1 5h-3V6h3Z"
        })
    });
var $1b60da1fa10622b6$export$2e2bcd8739ae039 = $1b60da1fa10622b6$var$SvgGlyphiconsBasic100VectorPathEdit;




const $30c8bcef58f1ef8e$var$SvgGlyphiconsBasic1000MemoryCardEject = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 12A2.5 2.5 0 0 1 21 9.5V5.282A1.778 1.778 0 0 1 21.55 4H11.5A1.5 1.5 0 0 0 10 5.5v6l-3.4 2.55a1.5 1.5 0 0 0-.6 1.2V26.5A1.5 1.5 0 0 0 7.5 28h17a1.5 1.5 0 0 0 1.5-1.5V12ZM15 11h-2V6h2Zm4 0h-2V6h2Zm11.5-1h-7a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5Zm.332-4.817L27.387.973a.5.5 0 0 0-.774 0l-3.445 4.21a.5.5 0 0 0 .387.817h6.89a.5.5 0 0 0 .387-.817Z"
        })
    });
var $30c8bcef58f1ef8e$export$2e2bcd8739ae039 = $30c8bcef58f1ef8e$var$SvgGlyphiconsBasic1000MemoryCardEject;




const $880c812ceeee79e8$var$SvgGlyphiconsBasic1001Celeriac = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.563 8.348a.994.994 0 0 0-1.245-.67l-2.265.683 1.846-1.846A1 1 0 0 0 25.485 5.1L23.64 6.947l.682-2.265a1 1 0 1 0-1.914-.577L21.3 7.782a10.743 10.743 0 0 1 2.919 2.919l3.677-1.108a.998.998 0 0 0 .668-1.245Zm-12.425-.325a8.495 8.495 0 0 0-8.75 5.954 7.7 7.7 0 0 0-.32 2.224l-.057 7.374-1.68 1.68a1.038 1.038 0 0 0-.002 1.486 1 1 0 0 0 1.378-.034l1.718-1.718 3.917-.03a.5.5 0 0 0 .35-.854l-.86-.858a1.038 1.038 0 0 1-.076-1.415 1 1 0 0 1 1.451-.039l2.949 2.949a.497.497 0 0 0 .394.145 7.115 7.115 0 0 0 1.495-.282 8.513 8.513 0 0 0 4.787-3.818.505.505 0 0 0-.074-.615l-1.925-1.925a1.038 1.038 0 0 1-.077-1.415 1 1 0 0 1 1.451-.039l.893.893a.501.501 0 0 0 .852-.308 8.486 8.486 0 0 0-7.814-9.355Zm2.569 13.684a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 0 1 1.414-1.414l1.5 1.5a1 1 0 0 1 0 1.414Zm1-6a1 1 0 0 1-1.414 0l-.5-.5a1 1 0 0 1 1.414-1.414l.5.5a1 1 0 0 1 0 1.414Z"
        })
    });
var $880c812ceeee79e8$export$2e2bcd8739ae039 = $880c812ceeee79e8$var$SvgGlyphiconsBasic1001Celeriac;




const $f7be66ae0f33798c$var$SvgGlyphiconsBasic1002Celery = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.053 8.105A.5.5 0 0 1 17 7.882V5.207a.5.5 0 0 1 .854-.354l1.957 1.958a.5.5 0 0 1 .137.451l-.662 3.309a.5.5 0 0 1-.938.125Zm8.136 4.084a.5.5 0 0 0-.451-.137l-3.309.662a.5.5 0 0 0-.126.938l2.591 1.295a.5.5 0 0 0 .224.053h2.675a.5.5 0 0 0 .353-.854Zm1.894-4.023a.5.5 0 0 1-.038-.345l.753-3.013a.5.5 0 0 0-.606-.606l-3.013.753a.499.499 0 0 1-.344-.038L22.62 4.31a.5.5 0 0 0-.718.377l-.808 5.653a.5.5 0 0 0 .566.566l5.653-.808a.5.5 0 0 0 .377-.719Zm-7.815 5.688a.5.5 0 0 0-.708 0l-9.853 9.853a1.012 1.012 0 0 1-1.414 0 .991.991 0 0 1 0-1.414s9.634-9.636 9.867-9.867-.032-.57-.229-.643a1.99 1.99 0 0 0-2.113.45l-9.433 9.433a3.673 3.673 0 0 0-1.058 1.91 3.506 3.506 0 0 0 4.096 4.097 3.674 3.674 0 0 0 1.911-1.058l9.434-9.433a2 2 0 0 0 0-2.828Z"
        })
    });
var $f7be66ae0f33798c$export$2e2bcd8739ae039 = $f7be66ae0f33798c$var$SvgGlyphiconsBasic1002Celery;




const $87ef33f6cfde735e$var$SvgGlyphiconsBasic1003Lupin = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.553 11.98-.111-1.004a4 4 0 0 0-4.418-3.534l-1.466.162A4 4 0 0 0 18 11.58v1a4 4 0 0 0 4.398 3.98l1.578-.158a4 4 0 0 0 3.577-4.422Zm-4.61-.892a2.216 2.216 0 0 0-.844.016 1.041 1.041 0 0 1-.204.021 1 1 0 0 1-.203-1.98 4.303 4.303 0 0 1 1.581-.03 1 1 0 1 1-.33 1.973ZM17 17h-1.38a4 4 0 0 0-3.98 3.602l-.2 2A4 4 0 0 0 15.42 27H17a4 4 0 0 0 4-4v-2a4 4 0 0 0-4-4Zm-.057 4.088a2.236 2.236 0 0 0-.844.016 1.041 1.041 0 0 1-.204.021 1 1 0 0 1-.203-1.98 4.304 4.304 0 0 1 1.581-.03 1 1 0 1 1-.33 1.973Zm-1.548-8.646.154-1.386a4 4 0 0 0-3.613-4.425l-2.112-.193a4 4 0 0 0-4.342 4.382l.158 1.578A4 4 0 0 0 9.62 16h1.8a4 4 0 0 0 3.975-3.558Zm-4.452-2.354a2.235 2.235 0 0 0-.844.016 1.041 1.041 0 0 1-.204.021 1 1 0 0 1-.203-1.98 4.303 4.303 0 0 1 1.581-.03 1 1 0 1 1-.33 1.973Z"
        })
    });
var $87ef33f6cfde735e$export$2e2bcd8739ae039 = $87ef33f6cfde735e$var$SvgGlyphiconsBasic1003Lupin;




const $27fb4879b213ee1f$var$SvgGlyphiconsBasic1004Mustard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 10V8a1 1 0 0 1 1-1h1.286l.591-4.141a1 1 0 0 1 .99-.859h.266a1 1 0 0 1 .99.859L17.714 7H19a1 1 0 0 1 1 1v2Zm8 2h-8a2.003 2.003 0 0 0-2 2v12a2.003 2.003 0 0 0 2 2h8a2.003 2.003 0 0 0 2-2V14a2.003 2.003 0 0 0-2-2Z"
        })
    });
var $27fb4879b213ee1f$export$2e2bcd8739ae039 = $27fb4879b213ee1f$var$SvgGlyphiconsBasic1004Mustard;




const $7e364dea33fa0f9d$var$SvgGlyphiconsBasic1005Sesame = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.017 8.056a5.811 5.811 0 0 1 .685-2.052c.18-.406.346-1.004.798-1.004s.618.598.798 1.004a5.811 5.811 0 0 1 .685 2.052c.063.859-.107 2.935-1.483 2.94-1.376-.005-1.546-2.081-1.483-2.94ZM24.5 17c-1.376.005-1.546 2.082-1.483 2.94a5.811 5.811 0 0 0 .685 2.052c.18.406.346 1.004.798 1.004s.618-.598.798-1.004a5.811 5.811 0 0 0 .685-2.052c.063-.858-.107-2.935-1.483-2.94Zm1.096-5.573c-.976-.979-2.565.382-3.127 1.04a5.891 5.891 0 0 0-.967 1.955c-.16.418-.465.963-.146 1.286s.86.015 1.274-.147a5.79 5.79 0 0 0 1.936-.976c.651-.568 2-2.172 1.03-3.158ZM6.47 19.467a5.891 5.891 0 0 0-.967 1.955c-.16.418-.465.963-.146 1.286s.86.015 1.274-.147a5.79 5.79 0 0 0 1.936-.976c.651-.568 2-2.172 1.03-3.158-.976-.979-2.565.382-3.127 1.04ZM12.48 7.665a5.89 5.89 0 0 0 .967-1.954c.16-.419.465-.964.146-1.287s-.86-.014-1.275.147a5.79 5.79 0 0 0-1.935.977c-.652.567-2 2.172-1.03 3.158.976.978 2.565-.383 3.127-1.04Zm1.093 5.895a5.893 5.893 0 0 0-1.954-.967c-.419-.16-.964-.465-1.287-.145-.323.32-.014.86.147 1.274a5.789 5.789 0 0 0 .976 1.935c.568.652 2.173 2 3.158 1.03.979-.976-.382-2.564-1.04-3.127Zm5.043.125c.323-.32.014-.86-.147-1.274a5.79 5.79 0 0 0-.976-1.936c-.568-.651-2.173-2-3.158-1.03-.98.976.382 2.565 1.04 3.127a5.889 5.889 0 0 0 1.954.967c.419.16.964.465 1.287.146Zm-.915 3.319a5.811 5.811 0 0 0-.685 2.052c-.063.859.107 2.935 1.483 2.94 1.376-.005 1.546-2.081 1.483-2.94a5.811 5.811 0 0 0-.685-2.052c-.18-.406-.346-1.004-.798-1.004s-.618.598-.798 1.004ZM6.5 15.996c1.376-.005 1.546-2.081 1.483-2.94a5.811 5.811 0 0 0-.685-2.052C7.118 10.598 6.952 10 6.5 10s-.618.598-.798 1.004a5.811 5.811 0 0 0-.685 2.052c-.063.859.107 2.935 1.483 2.94Zm6.798 4.008c-.18-.406-.346-1.004-.798-1.004s-.618.598-.798 1.004a5.811 5.811 0 0 0-.685 2.052c-.063.859.107 2.935 1.483 2.94 1.376-.005 1.546-2.081 1.483-2.94a5.811 5.811 0 0 0-.685-2.052Zm5.758 4.013a5.815 5.815 0 0 0-2.052.685c-.406.18-1.004.346-1.004.798s.598.618 1.004.798a5.815 5.815 0 0 0 2.052.685c.859.063 2.935-.108 2.94-1.483-.005-1.375-2.081-1.546-2.94-1.483Z"
        })
    });
var $7e364dea33fa0f9d$export$2e2bcd8739ae039 = $7e364dea33fa0f9d$var$SvgGlyphiconsBasic1005Sesame;




const $0ce1c90def0e6bf8$var$SvgGlyphiconsBasic1006Peanuts = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.287 13.29a7.457 7.457 0 0 0 1.627-1.073A4.889 4.889 0 0 0 12 5.303a7.448 7.448 0 0 0-1.112 1.72 5.868 5.868 0 0 1-3.319 2.824 5.426 5.426 0 0 0-2.718 1.506 5.667 5.667 0 0 0 8.013 8.013 5.426 5.426 0 0 0 1.506-2.719 5.896 5.896 0 0 1 2.917-3.358Zm-8.534.379a2.636 2.636 0 0 0-1.072.51 1.657 1.657 0 0 0-.488 1.18 1.678 1.678 0 0 0 .1.577 1 1 0 1 1-1.879.683 3.681 3.681 0 0 1 .852-3.852 4.381 4.381 0 0 1 1.848-.994 1 1 0 0 1 .639 1.896Zm5.829-5.114a1 1 0 0 1-1.867-.715 2.956 2.956 0 0 1 2.742-1.969 1 1 0 0 1 0 2 .969.969 0 0 0-.875.684Zm14.346 8.562a.502.502 0 0 1-.816.216l-3.449-3.12a.526.526 0 0 0-.742.743l3.224 3.563a.504.504 0 0 1-.172.801 2.864 2.864 0 0 1-3.15-.537l-.16-.16a5.524 5.524 0 0 0-2.605-2.988 3.146 3.146 0 0 1 .654-3.418 3.213 3.213 0 0 1 4.541.086s.907.907 2.025 2.025a2.799 2.799 0 0 1 .65 2.789ZM22 20.5v3a3.478 3.478 0 0 1-1.874 3.084.504.504 0 0 1-.74-.41l-.355-5.675a.532.532 0 0 0-1.062 0l-.355 5.675a.504.504 0 0 1-.74.41A3.478 3.478 0 0 1 15 23.5v-2.853A3.597 3.597 0 0 1 18.392 17 3.5 3.5 0 0 1 22 20.5Z"
        })
    });
var $0ce1c90def0e6bf8$export$2e2bcd8739ae039 = $0ce1c90def0e6bf8$var$SvgGlyphiconsBasic1006Peanuts;




const $3aa4c59a3709719c$var$SvgGlyphiconsBasic1007InvoicePlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 13.93V26a2.003 2.003 0 0 1-2 2H7a2.003 2.003 0 0 1-2-2V6a2.003 2.003 0 0 1 2-2h11.263A7.96 7.96 0 0 0 18 6H7v20h18.002l-.001-12.07a7.24 7.24 0 0 0 1.999 0ZM15 16.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm5 7a1 1 0 0 0 1-1v-.712A2.498 2.498 0 0 0 20 17h-.5a.5.5 0 0 1 0-1H21a1 1 0 0 0 0-2v-.5a1 1 0 0 0-2 0v.55a2.5 2.5 0 0 0 .5 4.95h.5a.5.5 0 0 1 0 1h-1.5a1 1 0 0 0 0 2h.5v.5a1 1 0 0 0 1 1Zm-5-11a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm-.5 7.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM15 8.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $3aa4c59a3709719c$export$2e2bcd8739ae039 = $3aa4c59a3709719c$var$SvgGlyphiconsBasic1007InvoicePlus;




const $e8b96fa3d3c15246$var$SvgGlyphiconsBasic1008InvoiceMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 14.05v-.55a1 1 0 0 1 2 0v.5a1 1 0 0 1 0 2h-1.5a.5.5 0 0 0 0 1h.5a2.498 2.498 0 0 1 1 4.788v.712a1 1 0 0 1-2 0V22h-.5a1 1 0 0 1 0-2H20a.5.5 0 0 0 0-1h-.5a2.5 2.5 0 0 1-.5-4.95Zm6-.12L25.003 26H7V6h11a7.96 7.96 0 0 1 .263-2H7a2.003 2.003 0 0 0-2 2v20a2.003 2.003 0 0 0 2 2h18a2.003 2.003 0 0 0 2-2V13.93a7.24 7.24 0 0 1-2 0ZM15 16.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm0-4a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm-.5 7.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM15 8.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $e8b96fa3d3c15246$export$2e2bcd8739ae039 = $e8b96fa3d3c15246$var$SvgGlyphiconsBasic1008InvoiceMinus;




const $a12be3bf6107e1da$var$SvgGlyphiconsBasic1009InvoiceAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 13.93V26a2.003 2.003 0 0 1-2 2H7a2.003 2.003 0 0 1-2-2V6a2.003 2.003 0 0 1 2-2h11.263A7.963 7.963 0 0 0 18 6H7v20h18.002l-.001-12.07a7.24 7.24 0 0 0 1.999 0ZM15 16.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm5 7a1 1 0 0 0 1-1v-.712A2.498 2.498 0 0 0 20 17h-.5a.5.5 0 0 1 0-1H21a1 1 0 0 0 0-2v-.5a1 1 0 0 0-2 0v.55a2.5 2.5 0 0 0 .5 4.95h.5a.5.5 0 0 1 0 1h-1.5a1 1 0 0 0 0 2h.5v.5a1 1 0 0 0 1 1Zm-5-15a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm0 4a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm-.5 7.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-5 2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm0-6a.502.502 0 0 0-.5-.5h-1a.502.502 0 0 0-.5.5v2a3.943 3.943 0 0 0 .149.978l.399 1.283a.362.362 0 0 0 .324.239h.256a.362.362 0 0 0 .324-.239l.4-1.283A3.943 3.943 0 0 0 27 4.5Z"
        })
    });
var $a12be3bf6107e1da$export$2e2bcd8739ae039 = $a12be3bf6107e1da$var$SvgGlyphiconsBasic1009InvoiceAlert;




const $ab6f53e9c319ab76$var$SvgGlyphiconsBasic101Text = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 5v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V7h-5v18h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1V7H9v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Z"
        })
    });
var $ab6f53e9c319ab76$export$2e2bcd8739ae039 = $ab6f53e9c319ab76$var$SvgGlyphiconsBasic101Text;




const $692248798fe4353f$var$SvgGlyphiconsBasic1010InvoiceCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 13.93V26a2.003 2.003 0 0 1-2 2H7a2.003 2.003 0 0 1-2-2V6a2.003 2.003 0 0 1 2-2h11.263A7.963 7.963 0 0 0 18 6H7v20h18.002l-.001-12.07a7.24 7.24 0 0 0 1.999 0ZM15 16.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm5 7a1 1 0 0 0 1-1v-.712A2.498 2.498 0 0 0 20 17h-.5a.5.5 0 0 1 0-1H21a1 1 0 0 0 0-2v-.5a1 1 0 0 0-2 0v.55a2.5 2.5 0 0 0 .5 4.95h.5a.5.5 0 0 1 0 1h-1.5a1 1 0 0 0 0 2h.5v.5a1 1 0 0 0 1 1Zm-5-11a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm-.5 7.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM15 8.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-2.852-2.234-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.095l-.433.555a.297.297 0 0 0 .027.377l2.233 2.236a.83.83 0 0 0 1.298-.1L29.2 4.118a.254.254 0 0 0-.052-.352Z"
        })
    });
var $692248798fe4353f$export$2e2bcd8739ae039 = $692248798fe4353f$var$SvgGlyphiconsBasic1010InvoiceCheck;




const $6666d1ee7f56af7b$var$SvgGlyphiconsBasic1011Molluscs = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.124 11.742a.497.497 0 0 0-.588.138l-3.905 4.7a1 1 0 0 1-1.606-1.193l3.95-5.315a.949.949 0 0 0 .196-.699 3.454 3.454 0 0 0-2.121-2.71 4.142 4.142 0 0 0-2.089-.164.493.493 0 0 0-.4.379l-1.51 7.51a1 1 0 0 1-.98.805.97.97 0 0 1-.196-.02 1 1 0 0 1-.785-1.175l1.29-7.75a1.004 1.004 0 0 0-.347-.977 3.424 3.424 0 0 0-4.328-.001 1.004 1.004 0 0 0-.348.977l1.291 7.751a1 1 0 0 1-.785 1.176.97.97 0 0 1-.196.02 1 1 0 0 1-.98-.805l-1.51-7.51a.493.493 0 0 0-.402-.378 4.086 4.086 0 0 0-2.087.161 3.495 3.495 0 0 0-2.12 2.712.948.948 0 0 0 .194.698l3.95 5.315a1 1 0 0 1-1.605 1.193l-3.905-4.7a.497.497 0 0 0-.589-.138 2.269 2.269 0 0 0-.685.458 3.618 3.618 0 0 0 .195 5.004l4.195 4.235a1.5 1.5 0 0 1-.005 2.116l-.151.152a1 1 0 0 0-.293.707V25a1 1 0 0 0 1 1h3.697a1 1 0 0 1 .555.168l2.193 1.462a1 1 0 0 0 1.11 0l2.193-1.462a1 1 0 0 1 .555-.168h3.697a1 1 0 0 0 1-1v-.586a1 1 0 0 0-.293-.707l-.151-.152a1.5 1.5 0 0 1-.006-2.116l4.198-4.238a3.615 3.615 0 0 0 .191-5.002 2.266 2.266 0 0 0-.684-.457Z"
        })
    });
var $6666d1ee7f56af7b$export$2e2bcd8739ae039 = $6666d1ee7f56af7b$var$SvgGlyphiconsBasic1011Molluscs;




const $2f6f99f279b965c0$var$SvgGlyphiconsBasic1012PercentSign = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8.5 15A4.505 4.505 0 0 1 4 10.5v-2a4.5 4.5 0 0 1 9 0v2A4.505 4.505 0 0 1 8.5 15Zm0-8A1.502 1.502 0 0 0 7 8.5v2a1.5 1.5 0 0 0 3 0v-2A1.502 1.502 0 0 0 8.5 7Zm15 21a4.505 4.505 0 0 1-4.5-4.5v-2a4.5 4.5 0 0 1 9 0v2a4.505 4.505 0 0 1-4.5 4.5Zm0-8a1.502 1.502 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 3 0v-2a1.502 1.502 0 0 0-1.5-1.5Zm-.88-15.418L5.504 26.71A.8.8 0 0 0 6.135 28h2.058a1.5 1.5 0 0 0 1.186-.582L26.497 5.29A.8.8 0 0 0 25.865 4h-2.058a1.5 1.5 0 0 0-1.186.582Z"
        })
    });
var $2f6f99f279b965c0$export$2e2bcd8739ae039 = $2f6f99f279b965c0$var$SvgGlyphiconsBasic1012PercentSign;




const $5ded200588592314$var$SvgGlyphiconsBasic1013MobilePhoneScan = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M32 7v2a1 1 0 0 1-1 1h-2a1 1 0 0 1 0-2h1V7a1 1 0 0 1 2 0Zm-1-7h-2a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1Zm-6 0h-2a1 1 0 0 0-1 1v1.05a4.47 4.47 0 0 1 2 .712V2h1a1 1 0 0 0 0-2Zm-1 6.5v19a2.503 2.503 0 0 1-2.5 2.5h-11A2.503 2.503 0 0 1 8 25.5v-19A2.503 2.503 0 0 1 10.5 4h11A2.503 2.503 0 0 1 24 6.5Zm-7 18a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5ZM21 7H11v15h10Z"
        })
    });
var $5ded200588592314$export$2e2bcd8739ae039 = $5ded200588592314$var$SvgGlyphiconsBasic1013MobilePhoneScan;




const $e4c83fa7ebaa50f8$var$SvgGlyphiconsBasic1014MobilePhoneNfc = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 16a1 1 0 0 1 0-2 5.5 5.5 0 1 0-2.708-10.283 1 1 0 1 1-.988-1.738A7.498 7.498 0 1 1 24.5 16ZM28 8.5a3.45 3.45 0 0 0-3.871-3.467 1 1 0 0 0 .228 1.987 2.681 2.681 0 0 1 .28-.006A1.481 1.481 0 0 1 26 8.5a1.502 1.502 0 0 1-1.5 1.5 1 1 0 0 0 0 2A3.504 3.504 0 0 0 28 8.5Zm-6-1v19a2.503 2.503 0 0 1-2.5 2.5h-11A2.503 2.503 0 0 1 6 26.5v-19A2.503 2.503 0 0 1 8.5 5h11A2.503 2.503 0 0 1 22 7.5Zm-7 18a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5ZM19 8H9v15h10Z"
        })
    });
var $e4c83fa7ebaa50f8$export$2e2bcd8739ae039 = $e4c83fa7ebaa50f8$var$SvgGlyphiconsBasic1014MobilePhoneNfc;




const $0ed591c40a7da7d2$var$SvgGlyphiconsBasic1015MobilePhoneCharger = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.5 4h-11A2.503 2.503 0 0 0 6 6.5v19A2.503 2.503 0 0 0 8.5 28h11a2.503 2.503 0 0 0 2.5-2.5v-19A2.503 2.503 0 0 0 19.5 4ZM15 25.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4-3.5H9V7h10ZM32 5v3a3 3 0 0 1-3 3v4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h2v-3a3 3 0 0 1-3-3V5a1 1 0 0 1 1-1V2a1 1 0 0 1 2 0v2h2V2a1 1 0 0 1 2 0v2a1 1 0 0 1 1 1Z"
        })
    });
var $0ed591c40a7da7d2$export$2e2bcd8739ae039 = $0ed591c40a7da7d2$var$SvgGlyphiconsBasic1015MobilePhoneCharger;




const $8c0dc42c4fc2e2fd$var$SvgGlyphiconsBasic1016IrisScan = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M2 6V3a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H4v2a1 1 0 0 1-2 0Zm4 22H4v-2a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2ZM29 2h-3a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Zm0 23a1 1 0 0 0-1 1v2h-2a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Zm-12.956-2c-5.35 0-8.903-4.138-10.183-5.916a1.856 1.856 0 0 1 0-2.167C7.14 13.137 10.693 9 16.043 9c4.652 0 8.564 4.057 10.03 5.8a1.858 1.858 0 0 1 0 2.4c-1.466 1.743-5.378 5.8-10.03 5.8ZM20 16a4 4 0 1 0-4 4 4.004 4.004 0 0 0 4-4Zm-8.951 3.383a5.98 5.98 0 0 1 0-6.766A14.472 14.472 0 0 0 7.546 16a14.47 14.47 0 0 0 3.503 3.383ZM24.469 16a19.374 19.374 0 0 0-3.33-3.08 5.943 5.943 0 0 1 0 6.16A19.383 19.383 0 0 0 24.47 16ZM16 14a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
        })
    });
var $8c0dc42c4fc2e2fd$export$2e2bcd8739ae039 = $8c0dc42c4fc2e2fd$var$SvgGlyphiconsBasic1016IrisScan;




const $9b345e9d2274a989$var$SvgGlyphiconsBasic1017FaceScan = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 3a1 1 0 0 1-1 1H4v2a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1ZM6 28H4v-2a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2Zm18.37-11.05-.876 2.193a3.17 3.17 0 0 1-1.698 1.623l-.668 3.087A3.974 3.974 0 0 1 17.253 27h-2.505a3.974 3.974 0 0 1-3.874-3.147l-.646-2.986a3.07 3.07 0 0 1-1.9-1.75l-.765-2.14a1.321 1.321 0 0 1 1.327-1.883H9v-3.661c0-3.851 2.545-6.42 7-6.42s7 2.569 7 6.42v3.66h.112a1.262 1.262 0 0 1 1.258 1.858ZM13 15a1 1 0 1 0-1-1 1 1 0 0 0 1 1Zm5.457 5.73a1.007 1.007 0 0 0-1.229-.693 5.234 5.234 0 0 1-1.228.11 5.437 5.437 0 0 1-1.228-.109 1 1 0 0 0-.555 1.921 6.698 6.698 0 0 0 1.783.188 6.698 6.698 0 0 0 1.783-.188.995.995 0 0 0 .674-1.229ZM20 14a1 1 0 1 0-1 1 1 1 0 0 0 1-1Zm9-12h-3a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Zm0 23a1 1 0 0 0-1 1v2h-2a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Z"
        })
    });
var $9b345e9d2274a989$export$2e2bcd8739ae039 = $9b345e9d2274a989$var$SvgGlyphiconsBasic1017FaceScan;




const $04057342086e0880$var$SvgGlyphiconsBasic1018VoiceScan = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.36 8.04A1.935 1.935 0 0 1 17 6.95 3.765 3.765 0 0 0 16.89 6H6v20h5a1 1 0 0 1 1-1h1a3.983 3.983 0 0 0 3.9-3.206.495.495 0 0 0-.34-.553l-3.876-1.293a1 1 0 0 1 .152-1.934l3.746-.625a.5.5 0 0 0 .418-.493V15h2.197a1.5 1.5 0 0 0 1.248-2.332ZM12.5 11A1.5 1.5 0 1 1 14 9.5a1.5 1.5 0 0 1-1.5 1.5ZM7 29a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v2h2a1 1 0 0 1 1 1ZM2 6V3a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H4v2a1 1 0 0 1-2 0Zm28 20v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 2 0Zm-3.26-4.327a9.397 9.397 0 0 0-.495-5.889 1 1 0 1 1 1.84-.783 11.396 11.396 0 0 1 .602 7.129 1 1 0 0 1-.973.771 1.022 1.022 0 0 1-.23-.026 1 1 0 0 1-.745-1.202ZM25 19.5a7.49 7.49 0 0 1-.203 1.712 1 1 0 0 1-.973.77 1.037 1.037 0 0 1-.23-.026 1.001 1.001 0 0 1-.744-1.203 5.435 5.435 0 0 0-.285-3.4 1 1 0 0 1 1.842-.779A7.458 7.458 0 0 1 25 19.5ZM30 3v3a1 1 0 0 1-2 0V4h-2a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1Zm-9.27 15.15a3.436 3.436 0 0 1 .175 2.138 1 1 0 0 1-1.949-.451A1.506 1.506 0 0 0 19 19.5a1.49 1.49 0 0 0-.116-.578 1 1 0 1 1 1.845-.772Z"
        })
    });
var $04057342086e0880$export$2e2bcd8739ae039 = $04057342086e0880$var$SvgGlyphiconsBasic1018VoiceScan;




const $2c48e643455f7e73$var$SvgGlyphiconsBasic1019UserVoice = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.368 16.5a3.481 3.481 0 0 1 0 4 1 1 0 0 1-1.639-1.146 1.482 1.482 0 0 0 0-1.707 1 1 0 0 1 1.64-1.147ZM20.7 14.375A1 1 0 0 1 19.92 16H19v1a.5.5 0 0 1-.5.5H17a1 1 0 0 0-.196 1.98l1.794.36a.5.5 0 0 1 .402.49V21a2 2 0 0 1-2 2h-1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-.516a3.002 3.002 0 0 1 .152-.943l1.754-5.296a3 3 0 0 0-.726-3.065l-.423-.423A6 6 0 0 1 5 12.515V11a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v.9a1 1 0 0 0 .22.624ZM17 12a1 1 0 1 0-1 1 1 1 0 0 0 1-1Zm12.873-.15a1 1 0 1 0-1.63 1.159 9.456 9.456 0 0 1 0 10.982 1 1 0 0 0 1.63 1.158 11.457 11.457 0 0 0 0-13.298Zm-4.647 2.086a.999.999 0 0 0-.238 1.393 5.475 5.475 0 0 1 0 6.342 1 1 0 1 0 1.631 1.156 7.47 7.47 0 0 0 0-8.654.998.998 0 0 0-1.393-.237Z"
        })
    });
var $2c48e643455f7e73$export$2e2bcd8739ae039 = $2c48e643455f7e73$var$SvgGlyphiconsBasic1019UserVoice;




const $fb43c2598a802261$var$SvgGlyphiconsBasic102Italic = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 5v1a1 1 0 0 1-1 1h-1.614l-3.681 18H17a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1.205l3.681-18H14a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1Z"
        })
    });
var $fb43c2598a802261$export$2e2bcd8739ae039 = $fb43c2598a802261$var$SvgGlyphiconsBasic102Italic;




const $0322b902827a7c7a$var$SvgGlyphiconsBasic1020HeadVoice = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.445 12.668-3.11-4.664A1.84 1.84 0 0 1 17 6.963 3.789 3.789 0 0 0 16.6 5.2L16 4H5v24h6v-2a1 1 0 0 1 1-1h1a3.986 3.986 0 0 0 3.935-3.381.5.5 0 0 0-.31-.525l-4.01-1.671A1 1 0 0 1 12 18.5V18a1 1 0 0 1 1-1h3.5a.5.5 0 0 0 .5-.5V15h2.197a1.5 1.5 0 0 0 1.248-2.332ZM12.5 10A1.5 1.5 0 1 1 14 8.5a1.5 1.5 0 0 1-1.5 1.5Zm9.868 7.5a3.481 3.481 0 0 1 0 4 1 1 0 0 1-1.639-1.146 1.482 1.482 0 0 0 0-1.707 1 1 0 0 1 1.64-1.147Zm8.632 2a11.42 11.42 0 0 1-2.127 6.65 1 1 0 1 1-1.63-1.159 9.456 9.456 0 0 0 0-10.982 1 1 0 1 1 1.63-1.158A11.42 11.42 0 0 1 31 19.5Zm-5.38-4.327a7.47 7.47 0 0 1 0 8.654 1 1 0 0 1-1.632-1.156 5.475 5.475 0 0 0 0-6.342 1 1 0 0 1 1.631-1.156Z"
        })
    });
var $0322b902827a7c7a$export$2e2bcd8739ae039 = $0322b902827a7c7a$var$SvgGlyphiconsBasic1020HeadVoice;




const $10d2ea9527a13018$var$SvgGlyphiconsBasic1021Shadows = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm-7.478 7H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H7.525a8.976 8.976 0 0 1 .997-2ZM16 15.5v1a.5.5 0 0 1-.5.5H7.059a8.501 8.501 0 0 1 0-2H15.5a.5.5 0 0 1 .5.5ZM8.522 21a8.976 8.976 0 0 1-.997-2H15.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5ZM16 8.5a.5.5 0 0 1-.5.5h-5.144A8.952 8.952 0 0 1 16 7ZM10.356 23H15.5a.5.5 0 0 1 .5.5V25a8.952 8.952 0 0 1-5.644-2Z"
        })
    });
var $10d2ea9527a13018$export$2e2bcd8739ae039 = $10d2ea9527a13018$var$SvgGlyphiconsBasic1021Shadows;




const $04741d592d622565$var$SvgGlyphiconsBasic1022Highlights = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21v-1.5a.5.5 0 0 0-.5-.5h-5.144a9.069 9.069 0 0 1-1.834-2H15.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.525a8.911 8.911 0 0 1-.466-2H15.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H7.059a8.911 8.911 0 0 1 .466-2H15.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H8.522a9.069 9.069 0 0 1 1.834-2H15.5a.5.5 0 0 0 .5-.5V7a9 9 0 0 1 0 18Z"
        })
    });
var $04741d592d622565$export$2e2bcd8739ae039 = $04741d592d622565$var$SvgGlyphiconsBasic1022Highlights;




const $d85214bb85f2948d$var$SvgGlyphiconsBasic1023Vignetting = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.5 5h-23A1.5 1.5 0 0 0 3 6.5v19A1.5 1.5 0 0 0 4.5 27h23a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 27.5 5ZM16 24c-5.514 0-10-3.589-10-8s4.486-8 10-8 10 3.589 10 8-4.486 8-10 8Z"
        })
    });
var $d85214bb85f2948d$export$2e2bcd8739ae039 = $d85214bb85f2948d$var$SvgGlyphiconsBasic1023Vignetting;




const $1f883d7d182b06ee$var$SvgGlyphiconsBasic1024CorrectionSkewed = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7.5 5H13v3H8.781L6.256 24H13v3H4.5a1.5 1.5 0 0 1-1.481-1.734l3-19A1.5 1.5 0 0 1 7.5 5Zm21.481 20.266-3-19A1.5 1.5 0 0 0 24.5 5H19v3h4.219l2.525 16H19v3h8.5a1.5 1.5 0 0 0 1.481-1.734ZM16.5 21h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 8h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-8h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-12h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
        })
    });
var $1f883d7d182b06ee$export$2e2bcd8739ae039 = $1f883d7d182b06ee$var$SvgGlyphiconsBasic1024CorrectionSkewed;




const $300a950ba40ebb0b$var$SvgGlyphiconsBasic1025CorrectionSkewedAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.475 4.36A1.503 1.503 0 0 1 27 5.5V13h-3V7.256L8 9.78V13H5V8.5a1.5 1.5 0 0 1 1.266-1.481l19-3a1.497 1.497 0 0 1 1.209.34ZM24 24.743 8 22.22V19H5v4.5a1.5 1.5 0 0 0 1.266 1.481l19 3A1.459 1.459 0 0 0 25.5 28a1.5 1.5 0 0 0 1.5-1.5V19h-3ZM14.5 17a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm-12-2h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm3 2h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm5 0a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm16-2h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm4 0h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-8 2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm-4 0a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Z"
        })
    });
var $300a950ba40ebb0b$export$2e2bcd8739ae039 = $300a950ba40ebb0b$var$SvgGlyphiconsBasic1025CorrectionSkewedAlt;




const $7da8ad4099841565$var$SvgGlyphiconsBasic1026CorrectionTilted = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M1.548 8.902a1.501 1.501 0 0 1 1.217-1.738l22.65-3.994a1.502 1.502 0 0 1 1.738 1.217L28.672 13h-3.047L24.46 6.385 4.763 9.858 5.317 13H2.27ZM29.73 19h-3.047l.554 3.142-19.696 3.473L6.375 19H3.328l1.519 8.613a1.501 1.501 0 0 0 1.477 1.24 1.567 1.567 0 0 0 .261-.023l22.65-3.994a1.501 1.501 0 0 0 1.217-1.738ZM21 15.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm-4 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm8 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm4 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm-16 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm-12 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm4 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm4 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Z"
        })
    });
var $7da8ad4099841565$export$2e2bcd8739ae039 = $7da8ad4099841565$var$SvgGlyphiconsBasic1026CorrectionTilted;




const $dbf78ed60c11fed0$var$SvgGlyphiconsBasic1027CorrectionAuto = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18.5 15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5Zm-7.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm12 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-20 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm25 0h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-21 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-6.5.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5ZM26 24H6v-5H3v6.5A1.5 1.5 0 0 0 4.5 27h23a1.5 1.5 0 0 0 1.5-1.5V19h-3ZM6 8h14.536a2.982 2.982 0 0 1 .23-1.156L21.537 5H4.5A1.5 1.5 0 0 0 3 6.5V13h3Zm23 2.947a3.006 3.006 0 0 1-.537.053H26v2h3Zm-6.388-3.333 2.464-5.9a1 1 0 0 1 1.846 0l2.464 5.9a1 1 0 0 1-1.846.772L26.962 7h-1.925l-.579 1.386a1 1 0 0 1-1.846-.772ZM25.668 5.5h.661L26 4.573Z"
        })
    });
var $dbf78ed60c11fed0$export$2e2bcd8739ae039 = $dbf78ed60c11fed0$var$SvgGlyphiconsBasic1027CorrectionAuto;




const $48c48631a2300713$var$SvgGlyphiconsBasic1028SafeOpen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 26v.5a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5V26ZM6 26v.5A1.5 1.5 0 0 0 7.5 28h2a1.5 1.5 0 0 0 1.5-1.5V26Zm22-16V7.5A1.5 1.5 0 0 0 26.5 6h-21A1.5 1.5 0 0 0 4 7.5v15A1.5 1.5 0 0 0 5.5 24h21a1.5 1.5 0 0 0 1.5-1.5V20l2-2v-6Zm-5 11H8a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h15Zm3-2a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm0-5a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
        })
    });
var $48c48631a2300713$export$2e2bcd8739ae039 = $48c48631a2300713$var$SvgGlyphiconsBasic1028SafeOpen;




const $2e9b37bcd2a5d8ff$var$SvgGlyphiconsBasic1029Safe = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 15a1 1 0 0 0 1 1h2.816a3 3 0 1 1 0-2H19a1 1 0 0 0-1 1Zm10-7.5v15a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 4 22.5v-15A1.5 1.5 0 0 1 5.5 6h21A1.5 1.5 0 0 1 28 7.5ZM24 15a5 5 0 1 0-5 5 5.006 5.006 0 0 0 5-5Zm2 11v.5a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5V26Zm-15 0v.5A1.5 1.5 0 0 1 9.5 28h-2A1.5 1.5 0 0 1 6 26.5V26Z"
        })
    });
var $2e9b37bcd2a5d8ff$export$2e2bcd8739ae039 = $2e9b37bcd2a5d8ff$var$SvgGlyphiconsBasic1029Safe;




const $c9b4ac393b3fc660$var$SvgGlyphiconsBasic103Bold = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.839 15.517A6.992 6.992 0 0 0 16.5 4c-.139 0-.28.008-.42.016C16.051 4.014 16.027 4 16 4H8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v18H8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h9a.93.93 0 0 0 .1-.02c.133.007.267.02.4.02a6.993 6.993 0 0 0 4.339-12.483ZM13 8h3.5a3 3 0 0 1 0 6H13Zm4.5 16H13v-6h4.5a3 3 0 0 1 0 6Z"
        })
    });
var $c9b4ac393b3fc660$export$2e2bcd8739ae039 = $c9b4ac393b3fc660$var$SvgGlyphiconsBasic103Bold;




const $6a762a33fa827e88$var$SvgGlyphiconsBasic1030SafeDigital = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.5 6h-21A1.5 1.5 0 0 0 4 7.5v15A1.5 1.5 0 0 0 5.5 24h21a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 26.5 6ZM16 19.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4 8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4 8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM21 26v.5a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5V26ZM6 26v.5A1.5 1.5 0 0 0 7.5 28h2a1.5 1.5 0 0 0 1.5-1.5V26Z"
        })
    });
var $6a762a33fa827e88$export$2e2bcd8739ae039 = $6a762a33fa827e88$var$SvgGlyphiconsBasic1030SafeDigital;




const $cf7e91564f24dd4d$var$SvgGlyphiconsBasic1031StatsOneDay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m15.291 15.76 3.723-1.395A2.493 2.493 0 0 1 21.5 12c.043 0 .083.01.126.013l1.96-3.922A2.49 2.49 0 1 1 25.5 9c-.043 0-.083-.01-.126-.013l-1.96 3.922a2.492 2.492 0 0 1-3.705 3.33l-3.723 1.397a2.46 2.46 0 0 1-3.098 2.28l-2.099 2.698a1 1 0 1 1-1.578-1.228l2.1-2.7A2.472 2.472 0 0 1 11 17.5a2.497 2.497 0 0 1 4.291-1.74ZM27.5 24h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4v15a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-2.5a.5.5 0 0 0-.5-.5ZM2.605 4.622a1.001 1.001 0 0 1-.12-1.41A3.169 3.169 0 0 1 4.964 2a2.718 2.718 0 0 1 2.715 2.714c0 1.81-1.791 2.447-2.38 2.657A1.359 1.359 0 0 0 4.55 8H7a1 1 0 0 1 0 2H3.321a1 1 0 0 1-.999-.947 3.615 3.615 0 0 1 2.306-3.567c1.05-.373 1.05-.653 1.05-.772A.715.715 0 0 0 4.965 4a1.202 1.202 0 0 0-.95.502 1.002 1.002 0 0 1-1.409.12ZM13 6V3a1 1 0 0 0-1.8-.6l-3 4A1 1 0 0 0 9 8h2v1a1 1 0 0 0 2 0V8a1 1 0 0 0 0-2Zm-2 0h-.455L11 5.414Z"
        })
    });
var $cf7e91564f24dd4d$export$2e2bcd8739ae039 = $cf7e91564f24dd4d$var$SvgGlyphiconsBasic1031StatsOneDay;




const $7a4bca23db1deebe$var$SvgGlyphiconsBasic1032StatsBarsOneDay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 26v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h2v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9h2V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v20h2V12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v13h1a1 1 0 0 1 1 1ZM4.015 4.502A1.202 1.202 0 0 1 4.964 4a.715.715 0 0 1 .715.714c0 .119 0 .4-1.051.772a3.615 3.615 0 0 0-2.306 3.567 1 1 0 0 0 1 .947H7a1 1 0 0 0 0-2H4.55a1.359 1.359 0 0 1 .749-.629c.589-.21 2.38-.847 2.38-2.657A2.718 2.718 0 0 0 4.964 2a3.169 3.169 0 0 0-2.479 1.213 1 1 0 1 0 1.53 1.289ZM14 7a1 1 0 0 1-1 1v1a1 1 0 0 1-2 0V8H9a1 1 0 0 1-.8-1.6l3-4A1 1 0 0 1 13 3v3a1 1 0 0 1 1 1Zm-3-1.586L10.545 6H11Z"
        })
    });
var $7a4bca23db1deebe$export$2e2bcd8739ae039 = $7a4bca23db1deebe$var$SvgGlyphiconsBasic1032StatsBarsOneDay;




const $2c20f3b96442918c$var$SvgGlyphiconsBasic1033StatsCircleOneDay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m19.074 4.637-2.949 2.949V4.05a12.944 12.944 0 0 1 2.949.586ZM21.71 16l4.949-4.949a12.986 12.986 0 0 0-1.674-2.498L17.539 16Zm6.363 0a12.92 12.92 0 0 0-.586-2.949L24.539 16Zm-7-10.535-4.949 4.95v4.17l7.447-7.446a12.972 12.972 0 0 0-2.498-1.674ZM14.125 17v-5.897a2.983 2.983 0 0 1-4.625-.447A3 3 0 0 1 7 12H5.327a10.999 10.999 0 0 0 16.835 13.452l-7.744-7.745a.996.996 0 0 1-.293-.707Zm10.866 8.452A12.928 12.928 0 0 0 28.074 18H17.54ZM2.605 4.622a1.001 1.001 0 0 1-.12-1.41A3.169 3.169 0 0 1 4.964 2a2.718 2.718 0 0 1 2.715 2.714c0 1.81-1.791 2.447-2.38 2.657A1.359 1.359 0 0 0 4.55 8H7a1 1 0 0 1 0 2H3.321a1 1 0 0 1-.999-.947 3.615 3.615 0 0 1 2.306-3.567c1.05-.373 1.05-.653 1.05-.772A.715.715 0 0 0 4.965 4a1.202 1.202 0 0 0-.95.502 1.002 1.002 0 0 1-1.409.12ZM13 6V3a1 1 0 0 0-1.8-.6l-3 4A1 1 0 0 0 9 8h2v1a1 1 0 0 0 2 0V8a1 1 0 0 0 0-2Zm-2 0h-.455L11 5.414Z"
        })
    });
var $2c20f3b96442918c$export$2e2bcd8739ae039 = $2c20f3b96442918c$var$SvgGlyphiconsBasic1033StatsCircleOneDay;




const $4d885d5ffe2fdc25$var$SvgGlyphiconsBasic1034DisinfectionSpray = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.25 18.4A2 2 0 0 1 22 19.96V26a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v.039a2 2 0 0 0 .75 1.562ZM25 3.5a.998.998 0 0 0 .316-.052l3-1a1 1 0 0 0-.632-1.896l-3 1A1 1 0 0 0 25 3.5ZM30 5h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2Zm-1.684 4.552-3-1a1 1 0 0 0-.632 1.896l3 1a1 1 0 1 0 .632-1.896ZM10 10h4l2.093-2.093a.988.988 0 0 0 .2.3l2.75 2.75a1 1 0 0 0 1.414-1.414L17.914 7H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-8.5a3 3 0 0 0-2.4 1.2L8.04 5.612a2 2 0 0 0 .187 2.615Z"
        })
    });
var $4d885d5ffe2fdc25$export$2e2bcd8739ae039 = $4d885d5ffe2fdc25$var$SvgGlyphiconsBasic1034DisinfectionSpray;




const $c1a93864c6356f01$var$SvgGlyphiconsBasic1035DisinfectionSpraySmall = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 14v12a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2Zm-2-6h-1a1 1 0 0 1 0-2h1V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5h6Zm8-2h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm-4-1.5a.998.998 0 0 0 .316-.052l3-1a1 1 0 0 0-.632-1.896l-3 1A1 1 0 0 0 21 4.5Zm3.316 6.052-3-1a1 1 0 0 0-.632 1.896l3 1a1 1 0 1 0 .632-1.896Z"
        })
    });
var $c1a93864c6356f01$export$2e2bcd8739ae039 = $c1a93864c6356f01$var$SvgGlyphiconsBasic1035DisinfectionSpraySmall;




const $72c291c9c8a4ede2$var$SvgGlyphiconsBasic1036DisinfectionSoap = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 14v12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Zm4.447-6.895-2-1A1 1 0 0 0 24 6h-6V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5h6V8h5.764l1.789.895a1 1 0 0 0 .894-1.79Z"
        })
    });
var $72c291c9c8a4ede2$export$2e2bcd8739ae039 = $72c291c9c8a4ede2$var$SvgGlyphiconsBasic1036DisinfectionSoap;




const $ee39f7af43a79b8f$var$SvgGlyphiconsBasic1037Sidebar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5ZM14.5 23h-5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5Z"
        })
    });
var $ee39f7af43a79b8f$export$2e2bcd8739ae039 = $ee39f7af43a79b8f$var$SvgGlyphiconsBasic1037Sidebar;




const $a838e4d53e9f7f4f$var$SvgGlyphiconsBasic1038SidebarRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28ZM7 7.5a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5v17a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5ZM22.5 23h-5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5Z"
        })
    });
var $a838e4d53e9f7f4f$export$2e2bcd8739ae039 = $a838e4d53e9f7f4f$var$SvgGlyphiconsBasic1038SidebarRight;




const $710f6120a94f1736$var$SvgGlyphiconsBasic1039ToiletPaper = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 13c4.56 0 8-1.72 8-4 0-2.28-3.44-4-8-4S6 6.72 6 9c0 2.28 3.44 4 8 4Zm0-5.2c2.25 0 3 .793 3 1.2s-.75 1.2-3 1.2-3-.793-3-1.2.75-1.2 3-1.2ZM27.5 13h-.579a27.232 27.232 0 0 0-4.29.345 17.569 17.569 0 0 0-3.187.795 14.806 14.806 0 0 1-3.467.748A.935.935 0 0 1 16 15v1a1 1 0 0 1-2 0v-1c-3.422 0-6.236-.838-8-2.23V23c0 2.85 3.44 5 8 5v-1a1 1 0 0 1 2 0v.832a21.949 21.949 0 0 0 3.229-.755A29.576 29.576 0 0 1 26.92 26h.579a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5ZM16 24a1 1 0 0 1-2 0v-1a1 1 0 0 1 2 0Zm0-4a1 1 0 0 1-2 0v-1a1 1 0 0 1 2 0Z"
        })
    });
var $710f6120a94f1736$export$2e2bcd8739ae039 = $710f6120a94f1736$var$SvgGlyphiconsBasic1039ToiletPaper;




const $aa780a7d8fa78821$var$SvgGlyphiconsBasic104Underline = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 5v1a1 1 0 0 1-1 1h-1v9a7.654 7.654 0 0 1-8 8 7.654 7.654 0 0 1-8-8V7H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v9a3.715 3.715 0 0 0 4 4 3.715 3.715 0 0 0 4-4V7h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm-.5 21h-19a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
        })
    });
var $aa780a7d8fa78821$export$2e2bcd8739ae039 = $aa780a7d8fa78821$var$SvgGlyphiconsBasic104Underline;




const $1acad781319413ea$var$SvgGlyphiconsBasic1040ToiletPaperAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 15a1 1 0 0 1 1-1h1v-1c0-3.422.838-6.236 2.23-8H9c-2.85 0-5 3.44-5 8v1h1a1 1 0 0 1 0 2H4v10.5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V16h-1a1 1 0 0 1-1-1Zm-6 1H8a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2Zm4 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2ZM23 5c-2.28 0-4 3.44-4 8s1.72 8 4 8 4-3.44 4-8-1.72-8-4-8Zm0 11c-.407 0-1.2-.75-1.2-3s.793-3 1.2-3 1.2.75 1.2 3-.793 3-1.2 3Z"
        })
    });
var $1acad781319413ea$export$2e2bcd8739ae039 = $1acad781319413ea$var$SvgGlyphiconsBasic1040ToiletPaperAlt;




const $231babbada759590$var$SvgGlyphiconsBasic1041Gloves = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m23 13 .507-4.139a1.5 1.5 0 1 1 2.986.278l-.44 4.234a3.223 3.223 0 0 0-.642-.071 3.178 3.178 0 0 0-1.12.203l-1.409.515s.1-.852.118-1.02Zm8.482 4.964a1.197 1.197 0 0 0-1.49-.586l-.678.254-1.056.557a3.467 3.467 0 0 1-.837 1.084L22 23.92 21.999 27a2.976 2.976 0 0 1-.78 2h2.78a1 1 0 0 0 1-1L25 25l6.12-5.246a1.484 1.484 0 0 0 .362-1.79Zm-5.362-.21L20 23v4a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-4.003l-3.914-9.999a1.5 1.5 0 0 1 2.83-.996c.285.775.356 1.621 1.323 1.575a.875.875 0 0 0 .809-1.048l-.488-6.321a1.5 1.5 0 0 1 2.99-.236s.422 4.344.451 4.692c.053.748.312 1.336 1 1.336a1 1 0 0 0 1-1V4.5a1.5 1.5 0 0 1 3 0V11a1 1 0 0 0 1 1 1.044 1.044 0 0 0 1-1l.507-4.139a1.5 1.5 0 1 1 2.986.278l-.871 8.386a1.13 1.13 0 0 0 1.643 1.188l2.049-1.08.677-.255a1.197 1.197 0 0 1 1.49.586 1.484 1.484 0 0 1-.36 1.79Z"
        })
    });
var $231babbada759590$export$2e2bcd8739ae039 = $231babbada759590$var$SvgGlyphiconsBasic1041Gloves;




const $4ce3f835b4b9cd98$var$SvgGlyphiconsBasic1042Tongue = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.786 14.729a24.209 24.209 0 0 0-9.324-8.187 3.481 3.481 0 0 0-2.798-.143L16 7.398l-2.744-1.029a3.409 3.409 0 0 0-2.578.045c-5.466 2.38-9.267 8.015-9.426 8.254a1.5 1.5 0 0 0-.085 1.52 17.178 17.178 0 0 0 5.186 5.613l-.424-3.526a6.477 6.477 0 0 1-.043-.767 14.373 14.373 0 0 1-1.584-1.932c1.156-1.506 4.013-4.861 7.573-6.411a.463.463 0 0 1 .328.013l3.27 1.226a1.492 1.492 0 0 0 1.053 0l3.192-1.196a.493.493 0 0 1 .386.009 22.279 22.279 0 0 1 7.609 6.337 14.35 14.35 0 0 1-1.599 1.954 6.476 6.476 0 0 1-.043.767l-.423 3.526a17.179 17.179 0 0 0 5.185-5.613 1.5 1.5 0 0 0-.047-1.46ZM19.618 13h-7.236a4.5 4.5 0 0 0-4.468 5.036l.645 5.362a7.495 7.495 0 0 0 14.882 0l.645-5.36A4.5 4.5 0 0 0 19.618 13Zm1.49 4.679-.645 5.362a4.495 4.495 0 0 1-8.926 0l-.644-5.363A1.5 1.5 0 0 1 12.382 16H15v6a1 1 0 0 0 2 0v-6h2.618a1.5 1.5 0 0 1 1.49 1.679Z"
        })
    });
var $4ce3f835b4b9cd98$export$2e2bcd8739ae039 = $4ce3f835b4b9cd98$var$SvgGlyphiconsBasic1042Tongue;




const $64d4182b674a2bb5$var$SvgGlyphiconsBasic1043TongueOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 22v-1.033l2-2V22a1 1 0 0 1-2 0Zm7.163-8.196-2.229 2.229a1.503 1.503 0 0 1 1.173 1.646l-.644 5.362a4.483 4.483 0 0 1-8.633 1.096l-2.24 2.24a7.49 7.49 0 0 0 13.851-2.978l.645-5.362a4.412 4.412 0 0 0-1.923-4.233Zm8.623.925a22.16 22.16 0 0 0-4.53-5.019l-2.134 2.135a21.702 21.702 0 0 1 3.59 3.709 14.357 14.357 0 0 1-1.598 1.954 6.476 6.476 0 0 1-.043.767l-.423 3.526a17.177 17.177 0 0 0 5.185-5.613 1.5 1.5 0 0 0-.047-1.46ZM27.215 5.06 5.06 27.215a1.5 1.5 0 0 1-2.122-2.121l3.344-3.344a17.185 17.185 0 0 1-5.116-5.562 1.5 1.5 0 0 1 .085-1.52c.16-.239 3.96-5.874 9.426-8.254a3.409 3.409 0 0 1 2.578-.045L16 7.398l2.664-.999a3.481 3.481 0 0 1 2.798.143l.02.01 3.612-3.613a1.5 1.5 0 0 1 2.12 2.122ZM6.34 21.694l1.798-1.798-.224-1.86A4.5 4.5 0 0 1 12.382 13h2.651l3.257-3.257-1.764.661a1.492 1.492 0 0 1-1.052 0l-3.27-1.226a.463.463 0 0 0-.329-.013c-3.56 1.55-6.417 4.905-7.573 6.41a14.38 14.38 0 0 0 1.584 1.933 6.476 6.476 0 0 0 .043.767Z"
        })
    });
var $64d4182b674a2bb5$export$2e2bcd8739ae039 = $64d4182b674a2bb5$var$SvgGlyphiconsBasic1043TongueOff;




const $45e7a8ceb3f8a4ed$var$SvgGlyphiconsBasic1044Nose = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 20.985v.515a7.501 7.501 0 0 1-7.5 7.5 1.5 1.5 0 0 1 0-3 4.5 4.5 0 0 0 4.5-4.5v-.515a4.47 4.47 0 0 0-1.318-3.182l-2.336-2.336a5.473 5.473 0 0 1-1.536-2.984l-1.29-7.737a1.5 1.5 0 0 1 2.96-.492l1.289 7.735a2.493 2.493 0 0 0 .698 1.357l2.336 2.336A7.452 7.452 0 0 1 28 20.985ZM11.5 26A4.5 4.5 0 0 1 7 21.5v-.515a4.47 4.47 0 0 1 1.318-3.182l2.336-2.336a5.472 5.472 0 0 0 1.536-2.986l1.29-7.735a1.5 1.5 0 0 0-2.96-.492l-1.289 7.733a2.492 2.492 0 0 1-.698 1.359l-2.336 2.336A7.452 7.452 0 0 0 4 20.985v.515a7.502 7.502 0 0 0 7.5 7.5 1.5 1.5 0 0 0 0-3Zm8.276-3.02a1.484 1.484 0 0 0 .193.02H21.5a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5h-.852a3.513 3.513 0 0 0-3.024 1.737l-.328.565a1.5 1.5 0 0 1-2.59 0l-.331-.566A3.512 3.512 0 0 0 11.352 19H10.5A1.5 1.5 0 0 0 9 20.5v1a1.5 1.5 0 0 0 1.5 1.5h1.531a1.488 1.488 0 0 0 .194-.02 4.483 4.483 0 0 0 7.55 0Z"
        })
    });
var $45e7a8ceb3f8a4ed$export$2e2bcd8739ae039 = $45e7a8ceb3f8a4ed$var$SvgGlyphiconsBasic1044Nose;




const $8366933221a3a777$var$SvgGlyphiconsBasic1045NoseOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 20.985v.515a7.501 7.501 0 0 1-7.5 7.5 1.5 1.5 0 0 1 0-3 4.5 4.5 0 0 0 4.5-4.5v-.515a4.47 4.47 0 0 0-1.318-3.182l-2.336-2.336a5.491 5.491 0 0 1-.39-.456l2.144-2.145a2.493 2.493 0 0 0 .367.48l2.336 2.336A7.452 7.452 0 0 1 28 20.985Zm-8.224 1.995a1.484 1.484 0 0 0 .193.02H21.5a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5h-.852a3.513 3.513 0 0 0-3.024 1.737l-.328.565a1.5 1.5 0 0 1-2.59 0l-.016-.025-2.145 2.145a4.485 4.485 0 0 0 7.23-.442ZM11.5 26a4.49 4.49 0 0 1-1.325-.208L7.9 28.066a7.535 7.535 0 0 0 3.6.934 1.5 1.5 0 0 0 0-3ZM27.215 2.94a1.5 1.5 0 0 0-2.121 0l-3.286 3.285-.328-1.971a1.5 1.5 0 0 0-2.96.492l.681 4.086L7 21.033v-.048a4.47 4.47 0 0 1 1.318-3.182l2.336-2.336a5.472 5.472 0 0 0 1.536-2.986l1.29-7.735a1.5 1.5 0 0 0-2.96-.492l-1.289 7.733a2.492 2.492 0 0 1-.698 1.359l-2.336 2.336A7.452 7.452 0 0 0 4 20.985v.515a7.361 7.361 0 0 0 .35 2.183l-1.41 1.41a1.5 1.5 0 1 0 2.12 2.122L27.216 5.06a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $8366933221a3a777$export$2e2bcd8739ae039 = $8366933221a3a777$var$SvgGlyphiconsBasic1045NoseOff;




const $4f7f8ac13499bdc3$var$SvgGlyphiconsBasic1046FactoryOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06a1.5 1.5 0 0 0-2.121-2.12L16 12.032V4.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V14h2.033l-2 2H4.5a.5.5 0 0 0-.5.5V24h.033L2.94 25.094a1.5 1.5 0 1 0 2.122 2.12ZM6.25 20a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25v.783L8.033 20ZM10 14H6V8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm18 6.5v7a.5.5 0 0 1-.5.5H9v-1.033l7.063-7.064a.24.24 0 0 0 .187.097h2.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25h-.783l2-2H21.5a.5.5 0 0 1 .5.5V23h2v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Z"
        })
    });
var $4f7f8ac13499bdc3$export$2e2bcd8739ae039 = $4f7f8ac13499bdc3$var$SvgGlyphiconsBasic1046FactoryOff;




const $1cfc296d847cc5cf$var$SvgGlyphiconsBasic1047GovernmentOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 18h-4v-2a1 1 0 0 0-1-1h-1.033L17 18.967V23.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2.533l-2 2v.533a.5.5 0 0 1-.5.5h-.533l-4 4H27a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Zm-6 5.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm5 1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm1.215-19.44a1.5 1.5 0 0 0-2.121-2.12l-6.69 6.689A4.876 4.876 0 0 0 17 9.1V7h2.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v4.6a5 5 0 0 0-3.89 3.9h3.923l-2 2H10a1 1 0 0 0-1 1v2H5a1 1 0 0 0-1 1v5.033l-1.06 1.06a1.5 1.5 0 1 0 2.12 2.122ZM6 22.034V20.5a.5.5 0 0 1 .5-.5h1a.494.494 0 0 1 .367.166Z"
        })
    });
var $1cfc296d847cc5cf$export$2e2bcd8739ae039 = $1cfc296d847cc5cf$var$SvgGlyphiconsBasic1047GovernmentOff;




const $7c485769ba167a0f$var$SvgGlyphiconsBasic1048BlackboardOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06 5.06 27.216a1.5 1.5 0 0 1-2.122-2.121L8.033 20H5.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4.533l2-2H6V5a1 1 0 0 1 1-1h17.033l1.06-1.06a1.5 1.5 0 0 1 2.122 2.12ZM19.967 16H26V9.967Zm6.533 2h-8.533l-2 2h1.322l1.556 2h-4.878l-2 2H20.4l2.81 3.614a1 1 0 1 0 1.58-1.228L19.821 20H26.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
        })
    });
var $7c485769ba167a0f$export$2e2bcd8739ae039 = $7c485769ba167a0f$var$SvgGlyphiconsBasic1048BlackboardOff;




const $522611f4390ba99c$var$SvgGlyphiconsBasic1049CartOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06a1.5 1.5 0 0 0-2.121-2.12L21.034 7H9.143l-.179-.82A1.5 1.5 0 0 0 7.5 5H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.292L8.76 19.274l-5.82 5.82a1.5 1.5 0 1 0 2.122 2.12l4.46-4.459ZM11.114 16 9.8 10h8.232l-6 6ZM13 26.5a1.5 1.5 0 0 1-3 0 1.485 1.485 0 0 1 .198-.731l.571-.571A1.482 1.482 0 0 1 11.5 25a1.5 1.5 0 0 1 1.5 1.5ZM27.964 8.825l-2 9A1.5 1.5 0 0 1 24.5 19h-7.533l3-3h3.33l.951-4.281 3.673-3.673a1.49 1.49 0 0 1 .043.78ZM24 22v1a1 1 0 0 1-1 1H11.967l3-3H23a1 1 0 0 1 1 1Zm-1 4.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5Z"
        })
    });
var $522611f4390ba99c$export$2e2bcd8739ae039 = $522611f4390ba99c$var$SvgGlyphiconsBasic1049CartOff;




const $14e085d673b7d432$var$SvgGlyphiconsBasic105Strikethrough = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 25v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-5h4v5h1a1 1 0 0 1 1 1Zm4-16h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7h5v8H6.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H18V7h5v1a1 1 0 0 0 1 1Z"
        })
    });
var $14e085d673b7d432$export$2e2bcd8739ae039 = $14e085d673b7d432$var$SvgGlyphiconsBasic105Strikethrough;




const $1d70645f6e745770$var$SvgGlyphiconsBasic1050DumbbellOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.06 27.215a1.5 1.5 0 0 1-2.12-2.121L6.032 22H5a1 1 0 0 1-1-1v-3H2.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H4v-3a1 1 0 0 1 1-1h3V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h2.033l11.06-11.06a1.5 1.5 0 0 1 2.122 2.12l-3.397 3.398ZM29.5 14H28v-3a1 1 0 0 0-1-1h-1.033l-8 8H20v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h3a1 1 0 0 0 1-1v-3h1.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5Z"
        })
    });
var $1d70645f6e745770$export$2e2bcd8739ae039 = $1d70645f6e745770$var$SvgGlyphiconsBasic1050DumbbellOff;




const $31a1c90ab3511c4a$var$SvgGlyphiconsBasic1051FaceMaskGasFull = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 14H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1ZM18 3.2V2a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.2a18.055 18.055 0 0 1 2-.12 18.056 18.056 0 0 1 2 .12ZM3.993 20.16a.998.998 0 0 0-.365 1.365L6.2 25.982a1.002 1.002 0 0 0 1.366.366l1.637-.946-3.556-6.2ZM29 10h-1v4h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM16 22a3 3 0 1 0 3 3 3.003 3.003 0 0 0-3-3Zm12.007-1.842-1.656-.956-3.556 6.2 1.638.946a1 1 0 0 0 1.366-.367l2.573-4.457a1 1 0 0 0-.365-1.366ZM21.34 24a.55.55 0 0 1-.537-.39 5 5 0 0 0-9.606 0 .545.545 0 0 1-.537.39.52.52 0 0 1-.502-.305l-3.543-6.828A5.193 5.193 0 0 1 6 14.635V8.618a1.486 1.486 0 0 1 .368-.967 1.987 1.987 0 0 1 1.091-.793l4.217-1.183a16.001 16.001 0 0 1 8.648 0l4.217 1.183a1.987 1.987 0 0 1 1.091.793 1.486 1.486 0 0 1 .368.967v5.845a5.018 5.018 0 0 1-.621 2.416l-3.537 6.816a.525.525 0 0 1-.502.305Zm-.584-7.396L23 14.793V9.755l-4.162-1.168a10.5 10.5 0 0 0-5.676 0L9 9.755v5.038l2.244 1.811a1 1 0 0 0 1.542-.372l.686-1.544A2 2 0 0 1 15.3 13.5h1.4a2 2 0 0 1 1.828 1.188l.686 1.544a1 1 0 0 0 1.542.372Z"
        })
    });
var $31a1c90ab3511c4a$export$2e2bcd8739ae039 = $31a1c90ab3511c4a$var$SvgGlyphiconsBasic1051FaceMaskGasFull;




const $92daa29de532b5ab$var$SvgGlyphiconsBasic1052DoorHandle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17 15a3.003 3.003 0 0 1-3-3v-2a3.003 3.003 0 0 1 3-3h5V5a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V15Zm0 7.723V25a1 1 0 0 1-2 0v-2.277a2 2 0 1 1 2 0ZM29 13H17a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1Z"
        })
    });
var $92daa29de532b5ab$export$2e2bcd8739ae039 = $92daa29de532b5ab$var$SvgGlyphiconsBasic1052DoorHandle;




const $52ed1a429eda6b24$var$SvgGlyphiconsBasic1053Cursor = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24.842 16.114-5.752.872 4.371 8.222a1 1 0 0 1-.413 1.352l-2.649 1.408a1 1 0 0 1-1.352-.413l-4.372-8.222-3.94 4.28A1 1 0 0 1 9 22.938V5.212a1 1 0 0 1 1.56-.829l14.691 9.913a1 1 0 0 1-.41 1.818Z"
        })
    });
var $52ed1a429eda6b24$export$2e2bcd8739ae039 = $52ed1a429eda6b24$var$SvgGlyphiconsBasic1053Cursor;




const $3c4ff1f79c42add2$var$SvgGlyphiconsBasic1054Dock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5ZM22 23H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Z"
        })
    });
var $3c4ff1f79c42add2$export$2e2bcd8739ae039 = $3c4ff1f79c42add2$var$SvgGlyphiconsBasic1054Dock;




const $3327c2a7fbd13ae0$var$SvgGlyphiconsBasic1055DockLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4h-17A3.504 3.504 0 0 0 4 7.5ZM24.5 7a.506.506 0 0 1 .5.5v17a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5ZM12 10v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z"
        })
    });
var $3327c2a7fbd13ae0$export$2e2bcd8739ae039 = $3327c2a7fbd13ae0$var$SvgGlyphiconsBasic1055DockLeft;




const $b07014c434882dfc$var$SvgGlyphiconsBasic1056DockRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 24.5v-17A3.504 3.504 0 0 0 24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5ZM7.5 25a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5v17a.506.506 0 0 1-.5.5ZM20 22V10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1Z"
        })
    });
var $b07014c434882dfc$export$2e2bcd8739ae039 = $b07014c434882dfc$var$SvgGlyphiconsBasic1056DockRight;




const $d8c9a22dbdafe450$var$SvgGlyphiconsBasic1057SocketB = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h17a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 24.5 4ZM18 21v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V21a2 2 0 0 1 4 0Zm2-11h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1Zm-9-1h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Z"
        })
    });
var $d8c9a22dbdafe450$export$2e2bcd8739ae039 = $d8c9a22dbdafe450$var$SvgGlyphiconsBasic1057SocketB;




const $1a1a37651a074b3b$var$SvgGlyphiconsBasic1058SocketE = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h17a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 24.5 4ZM21 19a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm-5-6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm-5 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $1a1a37651a074b3b$export$2e2bcd8739ae039 = $1a1a37651a074b3b$var$SvgGlyphiconsBasic1058SocketE;




const $a9b9c3b06c76b887$var$SvgGlyphiconsBasic1059SocketI = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h17a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 24.5 4Zm-9 14h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Zm5.53-2.752-2.555-3.832a1 1 0 0 1 .277-1.387l.832-.554a1 1 0 0 1 1.387.277l2.554 3.832a1 1 0 0 1-.277 1.387l-.832.554a1 1 0 0 1-1.387-.277Zm-11.446.277-.832-.554a1 1 0 0 1-.277-1.387l2.554-3.832a1 1 0 0 1 1.387-.277l.832.554a1 1 0 0 1 .277 1.387l-2.554 3.832a1 1 0 0 1-1.387.277Z"
        })
    });
var $a9b9c3b06c76b887$export$2e2bcd8739ae039 = $a9b9c3b06c76b887$var$SvgGlyphiconsBasic1059SocketI;




const $8ee848f2679d1a8a$var$SvgGlyphiconsBasic106TextHeight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 5v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V7h-5v17h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1V7h-5v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1ZM5.231 8a.5.5 0 0 0 .397-.804l-2.23-2.919a.5.5 0 0 0-.795 0L.372 7.197A.5.5 0 0 0 .769 8H2v15H.769a.5.5 0 0 0-.397.804l2.23 2.919a.5.5 0 0 0 .795 0l2.231-2.92A.5.5 0 0 0 5.231 23H4V8Z"
        })
    });
var $8ee848f2679d1a8a$export$2e2bcd8739ae039 = $8ee848f2679d1a8a$var$SvgGlyphiconsBasic106TextHeight;




const $f2e9c1c7eb8ac616$var$SvgGlyphiconsBasic1060SocketG = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.5 3.5 0 0 0 4 7.5v17A3.5 3.5 0 0 0 7.5 28h17a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 24.5 4ZM12 22h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm4.5-7h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1Zm5.5 7h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Z"
        })
    });
var $f2e9c1c7eb8ac616$export$2e2bcd8739ae039 = $f2e9c1c7eb8ac616$var$SvgGlyphiconsBasic1060SocketG;




const $3a6f60587f42447b$var$SvgGlyphiconsBasic107TextWidth = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m25.723 26.397-2.92 2.231a.5.5 0 0 1-.803-.397V27H10v1.231a.5.5 0 0 1-.804.397l-2.919-2.23a.5.5 0 0 1 0-.795l2.92-2.231a.5.5 0 0 1 .803.397V25h12v-1.231a.5.5 0 0 1 .804-.397l2.919 2.23a.5.5 0 0 1 0 .795ZM8 9h1a1 1 0 0 0 1-1V7H14v12h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1V7h4v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1Z"
        })
    });
var $3a6f60587f42447b$export$2e2bcd8739ae039 = $3a6f60587f42447b$var$SvgGlyphiconsBasic107TextWidth;




const $5620f0f5be50beee$var$SvgGlyphiconsBasic108TextResize = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 8v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1h-4v12h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1V10h-4v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1ZM4.5 15h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm3 2h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm8 0h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm4 0h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm-8 0h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm-3 22h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-4 0h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm24-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 8h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-12h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 20h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-16 4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm8 0h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm8 0h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-12 0h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm8-24h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 24h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
        })
    });
var $5620f0f5be50beee$export$2e2bcd8739ae039 = $5620f0f5be50beee$var$SvgGlyphiconsBasic108TextResize;




const $9c85819ec3029883$var$SvgGlyphiconsBasic109IndentLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 5v22a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm3 3h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm8 3h-8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-8 9h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm8 3h-8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1ZM7.804 13.372a.5.5 0 0 0-.804.397V15H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H7v1.231a.5.5 0 0 0 .804.397l2.919-2.23a.5.5 0 0 0 0-.795Z"
        })
    });
var $9c85819ec3029883$export$2e2bcd8739ae039 = $9c85819ec3029883$var$SvgGlyphiconsBasic109IndentLeft;




const $7f95bdcf545c6dcb$var$SvgGlyphiconsBasic11Envelope = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.693 17.707 3.986 7h24L17.279 17.707a1.153 1.153 0 0 1-.707.293H15.4a1.153 1.153 0 0 1-.707-.293ZM10.172 16 4 9.828v12.344Zm11.656 0L28 22.172V9.828ZM18.4 19.414a2.305 2.305 0 0 1-1.414.586h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414Z"
        })
    });
var $7f95bdcf545c6dcb$export$2e2bcd8739ae039 = $7f95bdcf545c6dcb$var$SvgGlyphiconsBasic11Envelope;




const $cfdf6945c0b83b24$var$SvgGlyphiconsBasic110IndentRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 15.5v1a.5.5 0 0 1-.5.5H25v1.231a.5.5 0 0 1-.804.397l-2.919-2.23a.5.5 0 0 1 0-.795l2.92-2.231a.5.5 0 0 1 .803.397V15h2.5a.5.5 0 0 1 .5.5ZM18 4h-1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM5 8h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm8 3H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-8 9h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm8 3H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $cfdf6945c0b83b24$export$2e2bcd8739ae039 = $cfdf6945c0b83b24$var$SvgGlyphiconsBasic110IndentRight;




const $1257f9fdcbeda48c$var$SvgGlyphiconsBasic111ParagraphLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 7V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Zm23 4H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1ZM5 20h13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm22 3H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $1257f9fdcbeda48c$export$2e2bcd8739ae039 = $1257f9fdcbeda48c$var$SvgGlyphiconsBasic111ParagraphLeft;




const $e5c314079bdb2337$var$SvgGlyphiconsBasic112ParagraphCenter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 7V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1Zm17 4H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-4 9a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm4 3H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $e5c314079bdb2337$export$2e2bcd8739ae039 = $e5c314079bdb2337$var$SvgGlyphiconsBasic112ParagraphCenter;




const $c7b6aa55f20d562d$var$SvgGlyphiconsBasic113ParagraphRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 6v1a1 1 0 0 1-1 1H16a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1Zm-1 5H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0 6H14a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0 6H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $c7b6aa55f20d562d$export$2e2bcd8739ae039 = $c7b6aa55f20d562d$var$SvgGlyphiconsBasic113ParagraphRight;




const $30264fc30ac07d1b$var$SvgGlyphiconsBasic114ParagraphJustify = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 24v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-1-7H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $30264fc30ac07d1b$export$2e2bcd8739ae039 = $30264fc30ac07d1b$var$SvgGlyphiconsBasic114ParagraphJustify;




const $2b252a61255d0959$var$SvgGlyphiconsBasic115List = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 24v1a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-1-7H11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM6 23H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $2b252a61255d0959$export$2e2bcd8739ae039 = $2b252a61255d0959$var$SvgGlyphiconsBasic115List;




const $3ab6bd95e9e0ca28$var$SvgGlyphiconsBasic116TextSmaller = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.628 12.804-2.23 2.919a.475.475 0 0 1-.795 0l-2.231-2.92c-.338-.441-.16-.803.397-.803H24V9.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V12h1.231c.556 0 .735.362.397.804ZM19.001 12H8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h2v9h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1v-9h2v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Z"
        })
    });
var $3ab6bd95e9e0ca28$export$2e2bcd8739ae039 = $3ab6bd95e9e0ca28$var$SvgGlyphiconsBasic116TextSmaller;




const $284df3913277dc1e$var$SvgGlyphiconsBasic117TextBigger = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.231 8H27v6.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V8h-1.231c-.556 0-.735-.362-.397-.804l2.23-2.919a.475.475 0 0 1 .795 0l2.231 2.92c.338.441.16.803-.397.803Zm-8.23-2H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9h4v15H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1V9h4v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Z"
        })
    });
var $284df3913277dc1e$export$2e2bcd8739ae039 = $284df3913277dc1e$var$SvgGlyphiconsBasic117TextBigger;




const $26182bd27c0a9ff5$var$SvgGlyphiconsBasic118TerminalIsolated = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 22.5v2a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5ZM16 12.145a.5.5 0 0 0-.284-.451l-11-5.274A.5.5 0 0 0 4 6.871V9.09a.5.5 0 0 0 .284.451L11.5 13l-7.217 3.46a.5.5 0 0 0-.284.45v2.219a.5.5 0 0 0 .716.45l11-5.273a.5.5 0 0 0 .284-.45Z"
        })
    });
var $26182bd27c0a9ff5$export$2e2bcd8739ae039 = $26182bd27c0a9ff5$var$SvgGlyphiconsBasic118TerminalIsolated;




const $e3a7d1d5751b06ef$var$SvgGlyphiconsBasic119Code = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.798 5.711 13.14 26.423a1 1 0 0 1-.906.577h-1.579a.5.5 0 0 1-.453-.711L19.86 5.577A1 1 0 0 1 20.766 5h1.579a.5.5 0 0 1 .453.711Zm8.945 9.002-8-4.458a.5.5 0 0 0-.743.436v2.29a.5.5 0 0 0 .257.436L27.89 16l-4.633 2.583a.5.5 0 0 0-.257.436v2.29a.5.5 0 0 0 .743.436l8-4.458A.554.554 0 0 0 32 16.85v-1.7a.554.554 0 0 0-.257-.437ZM8.257 10.255l-8 4.458A.554.554 0 0 0 0 15.15v1.7a.554.554 0 0 0 .257.437l8 4.458A.5.5 0 0 0 9 21.31v-2.29a.5.5 0 0 0-.257-.436L4.11 16l4.633-2.583A.5.5 0 0 0 9 12.981v-2.29a.5.5 0 0 0-.743-.436Z"
        })
    });
var $e3a7d1d5751b06ef$export$2e2bcd8739ae039 = $e3a7d1d5751b06ef$var$SvgGlyphiconsBasic119Code;




const $46ebc7a03a1a8efa$var$SvgGlyphiconsBasic12Camera = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 8h-2.875l-.315-1.08A2.833 2.833 0 0 0 19.25 5h-6.5a2.833 2.833 0 0 0-2.56 1.92L9.875 8H7a3.009 3.009 0 0 0-3 3v12a3.009 3.009 0 0 0 3 3h18a3.009 3.009 0 0 0 3-3V11a3.009 3.009 0 0 0-3-3Zm-9 15a6 6 0 1 1 6-6 6 6 0 0 1-6 6Zm10-11.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM20 17a4 4 0 1 1-4-4 4 4 0 0 1 4 4Z"
        })
    });
var $46ebc7a03a1a8efa$export$2e2bcd8739ae039 = $46ebc7a03a1a8efa$var$SvgGlyphiconsBasic12Camera;




const $879348f5a3252ded$var$SvgGlyphiconsBasic120Table = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 4H8a3.003 3.003 0 0 0-3 3v19a2.002 2.002 0 0 0 2 2h19a2.002 2.002 0 0 0 2-2V7a3.003 3.003 0 0 0-3-3ZM12 25.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm7 12a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm7 12a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-6a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Z"
        })
    });
var $879348f5a3252ded$export$2e2bcd8739ae039 = $879348f5a3252ded$var$SvgGlyphiconsBasic120Table;




const $f9f0c04d602471ae$var$SvgGlyphiconsBasic121EnvelopeFull = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8 11.014 3.986 7 14.582.294A2.28 2.28 0 0 1 16 0a2.062 2.062 0 0 1 1.39.294L27.986 7 24 10.986V7.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5ZM4 22.172 10.172 16 4 9.828ZM21.828 16 28 22.172V9.828Zm-9.842 1-8 8h24l-8-8Z"
        })
    });
var $f9f0c04d602471ae$export$2e2bcd8739ae039 = $f9f0c04d602471ae$var$SvgGlyphiconsBasic121EnvelopeFull;




const $fed373bb0d10f67a$var$SvgGlyphiconsBasic122EnvelopeEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m11.986 15-8-8L14.582.294A2.28 2.28 0 0 1 16 0a2.062 2.062 0 0 1 1.39.294L27.986 7l-8 8Zm0 2-8 8h24l-8-8Zm9.842-1L28 22.172V9.828Zm-11.656 0L4 9.828v12.344Z"
        })
    });
var $fed373bb0d10f67a$export$2e2bcd8739ae039 = $fed373bb0d10f67a$var$SvgGlyphiconsBasic122EnvelopeEmpty;




const $386ea5992c69b43b$var$SvgGlyphiconsBasic123EnvelopeDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 22.172V9.828L10.172 16ZM15.4 18h1.172a1.153 1.153 0 0 0 .707-.293l4.764-4.764A8.007 8.007 0 0 1 18.069 7H3.986l10.707 10.707A1.153 1.153 0 0 0 15.4 18Zm3 1.414a2.305 2.305 0 0 1-1.414.586h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414Zm5.673-5.659L21.828 16 28 22.172v-8.435a7.72 7.72 0 0 1-3.927.018ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3.852 0H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V6h-1.148a.5.5 0 0 0-.378.827l2.148 2.48a.5.5 0 0 0 .756 0l2.148-2.48A.5.5 0 0 0 28.148 6Z"
        })
    });
var $386ea5992c69b43b$export$2e2bcd8739ae039 = $386ea5992c69b43b$var$SvgGlyphiconsBasic123EnvelopeDown;




const $518674a1a9a95a86$var$SvgGlyphiconsBasic124EnvelopeUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 22.172V9.828L10.172 16ZM15.4 18h1.172a1.153 1.153 0 0 0 .707-.293l4.764-4.764A8.007 8.007 0 0 1 18.069 7H3.986l10.707 10.707A1.153 1.153 0 0 0 15.4 18Zm8.673-4.245L21.828 16 28 22.172v-8.435a7.72 7.72 0 0 1-3.927.018Zm-5.673 5.66a2.305 2.305 0 0 1-1.414.585h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3.474-.827-2.148-2.48a.5.5 0 0 0-.756 0l-2.148 2.48a.5.5 0 0 0 .378.827H25v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V6h1.148a.5.5 0 0 0 .378-.827Z"
        })
    });
var $518674a1a9a95a86$export$2e2bcd8739ae039 = $518674a1a9a95a86$var$SvgGlyphiconsBasic124EnvelopeUp;




const $93728be86e83b55b$var$SvgGlyphiconsBasic125EnvelopePlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 22.172V9.828L10.172 16ZM15.4 18h1.172a1.153 1.153 0 0 0 .707-.293l4.764-4.764A8.007 8.007 0 0 1 18.069 7H3.986l10.707 10.707A1.153 1.153 0 0 0 15.4 18Zm3 1.414a2.305 2.305 0 0 1-1.414.586h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414Zm5.673-5.659L21.828 16 28 22.172v-8.435a7.72 7.72 0 0 1-3.927.018ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $93728be86e83b55b$export$2e2bcd8739ae039 = $93728be86e83b55b$var$SvgGlyphiconsBasic125EnvelopePlus;




const $073fa9a2668ac387$var$SvgGlyphiconsBasic126EnvelopeMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 22.172V9.828L10.172 16ZM15.4 18h1.172a1.153 1.153 0 0 0 .707-.293l4.764-4.764A8.007 8.007 0 0 1 18.069 7H3.986l10.707 10.707A1.153 1.153 0 0 0 15.4 18Zm3 1.414a2.305 2.305 0 0 1-1.414.586h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414Zm5.673-5.659L21.828 16 28 22.172v-8.435a7.72 7.72 0 0 1-3.927.018ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $073fa9a2668ac387$export$2e2bcd8739ae039 = $073fa9a2668ac387$var$SvgGlyphiconsBasic126EnvelopeMinus;




const $663ca1a7961f839d$var$SvgGlyphiconsBasic127EnvelopeNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.693 17.707 3.986 7h14.083a8.007 8.007 0 0 0 3.974 5.943l-4.764 4.764a1.153 1.153 0 0 1-.707.293H15.4a1.153 1.153 0 0 1-.707-.293ZM10.172 16 4 9.828v12.344Zm13.9-2.245L21.829 16 28 22.172v-8.435a7.72 7.72 0 0 1-3.927.018Zm-5.672 5.66a2.305 2.305 0 0 1-1.414.585h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-9.433 2.019 5.452-5.452A3.954 3.954 0 0 0 26 2a4.005 4.005 0 0 0-4 4 3.955 3.955 0 0 0 .567 2.019ZM30 6a3.955 3.955 0 0 0-.567-2.02l-5.452 5.453A3.956 3.956 0 0 0 26 10a4.005 4.005 0 0 0 4-4Z"
        })
    });
var $663ca1a7961f839d$export$2e2bcd8739ae039 = $663ca1a7961f839d$var$SvgGlyphiconsBasic127EnvelopeNo;




const $553e2f167b26244c$var$SvgGlyphiconsBasic128EnvelopeFlag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 22.172V9.828L10.172 16ZM15.4 18h1.172a1.153 1.153 0 0 0 .707-.293l5.03-5.03A2.47 2.47 0 0 1 22 11.5V7H3.986l10.707 10.707A1.153 1.153 0 0 0 15.4 18Zm3 1.414a2.305 2.305 0 0 1-1.414.586h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414ZM30 0h-5a1 1 0 0 0-1 1v10.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7.417l4.526-1.259A.74.74 0 0 0 31 5.5V1a1 1 0 0 0-1-1Zm-4.5 14h-1a2.476 2.476 0 0 1-.593-.079L21.828 16 28 22.172V13h-.513a2.489 2.489 0 0 1-1.987 1Z"
        })
    });
var $553e2f167b26244c$export$2e2bcd8739ae039 = $553e2f167b26244c$var$SvgGlyphiconsBasic128EnvelopeFlag;




const $cb4dae3bf4d724d8$var$SvgGlyphiconsBasic129EnvelopeLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 22.172V9.828L10.172 16ZM15.4 18h1.172a1.153 1.153 0 0 0 .707-.293l3.85-3.85A2.994 2.994 0 0 1 19 11V7H3.986l10.707 10.707A1.153 1.153 0 0 0 15.4 18Zm3 1.414a2.305 2.305 0 0 1-1.414.586h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414ZM21.828 16 28 22.172V14h-4.172ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $cb4dae3bf4d724d8$export$2e2bcd8739ae039 = $cb4dae3bf4d724d8$var$SvgGlyphiconsBasic129EnvelopeLock;




const $2c6bb21c20717a17$var$SvgGlyphiconsBasic13Heart = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.781 11.926c0 4.826-6.135 8.681-11.037 14.068a1 1 0 0 1-1.488 0C10.354 20.607 4.22 16.752 4.22 11.926c0-5.53 7.536-9.487 11.575-3.826a.259.259 0 0 0 .42.006c4.266-5.67 11.567-1.711 11.567 3.82Z"
        })
    });
var $2c6bb21c20717a17$export$2e2bcd8739ae039 = $2c6bb21c20717a17$var$SvgGlyphiconsBasic13Heart;




const $c3be581d3912a024$var$SvgGlyphiconsBasic130EnvelopeStar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.693 17.707 3.986 7h13.133a2.424 2.424 0 0 0 .416.394l2.307 1.676-.88 2.708a2.402 2.402 0 0 0 1.3 2.947l-2.983 2.982a1.153 1.153 0 0 1-.707.293H15.4a1.153 1.153 0 0 1-.707-.293ZM10.172 16 4 9.828v12.344Zm8.228 3.414a2.305 2.305 0 0 1-1.414.586h-2a2.305 2.305 0 0 1-1.414-.586l-2-2L3.986 25h24L20.4 17.414Zm6.606-6.592L21.828 16 28 22.172v-7.329a2.442 2.442 0 0 1-.693-.351ZM31.045 5h-4.303l-.646-1.988-.684-2.105a.43.43 0 0 0-.816 0l-.684 2.105L23.267 5h-4.304a.43.43 0 0 0-.252.777l1.791 1.3 1.691 1.229-.645 1.987-.683 2.101a.43.43 0 0 0 .661.48l1.788-1.298 1.69-1.228 1.69 1.228 1.788 1.298a.43.43 0 0 0 .66-.48l-.682-2.1-.645-1.988 1.69-1.228 1.792-1.301A.43.43 0 0 0 31.045 5Z"
        })
    });
var $c3be581d3912a024$export$2e2bcd8739ae039 = $c3be581d3912a024$var$SvgGlyphiconsBasic130EnvelopeStar;




const $1d2c2c97f1f63ae7$var$SvgGlyphiconsBasic131Inbox = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 5h-19A2.503 2.503 0 0 0 4 7.5v18A2.503 2.503 0 0 0 6.5 28h19a2.503 2.503 0 0 0 2.5-2.5v-18A2.503 2.503 0 0 0 25.5 5ZM25 18h-4.09a.5.5 0 0 0-.49.402l-.84 4.196a.5.5 0 0 1-.49.402h-6.18a.5.5 0 0 1-.49-.402l-.84-4.196a.5.5 0 0 0-.49-.402H7V8h18Z"
        })
    });
var $1d2c2c97f1f63ae7$export$2e2bcd8739ae039 = $1d2c2c97f1f63ae7$var$SvgGlyphiconsBasic131Inbox;




const $88d2cd0121ca79e9$var$SvgGlyphiconsBasic132InboxPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.957 7.957 0 0 0 2-.263V25.5a2.503 2.503 0 0 1-2.5 2.5h-19A2.503 2.503 0 0 1 4 25.5v-18A2.503 2.503 0 0 1 6.5 5h11.57A8.009 8.009 0 0 0 18 6a7.96 7.96 0 0 0 .263 2H7v10h4.09a.5.5 0 0 1 .49.402l.84 4.196a.5.5 0 0 0 .49.402h6.18a.5.5 0 0 0 .49-.402l.84-4.196a.5.5 0 0 1 .49-.402H25v-4.07a8.02 8.02 0 0 0 1 .07Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $88d2cd0121ca79e9$export$2e2bcd8739ae039 = $88d2cd0121ca79e9$var$SvgGlyphiconsBasic132InboxPlus;




const $0e775541914447ec$var$SvgGlyphiconsBasic133InboxMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.957 7.957 0 0 0 2-.263V25.5a2.503 2.503 0 0 1-2.5 2.5h-19A2.503 2.503 0 0 1 4 25.5v-18A2.503 2.503 0 0 1 6.5 5h11.57A8.009 8.009 0 0 0 18 6a7.96 7.96 0 0 0 .263 2H7v10h4.09a.5.5 0 0 1 .49.402l.84 4.196a.5.5 0 0 0 .49.402h6.18a.5.5 0 0 0 .49-.402l.84-4.196a.5.5 0 0 1 .49-.402H25v-4.07a8.02 8.02 0 0 0 1 .07Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $0e775541914447ec$export$2e2bcd8739ae039 = $0e775541914447ec$var$SvgGlyphiconsBasic133InboxMinus;




const $cc2ee9917dcf0328$var$SvgGlyphiconsBasic134InboxLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 14h3v11.5a2.503 2.503 0 0 1-2.5 2.5h-19A2.503 2.503 0 0 1 4 25.5v-18A2.503 2.503 0 0 1 6.5 5H19v3H7v10h4.09a.5.5 0 0 1 .49.402l.84 4.196a.5.5 0 0 0 .49.402h6.18a.5.5 0 0 0 .49-.402l.84-4.196a.5.5 0 0 1 .49-.402H25Zm7-9v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $cc2ee9917dcf0328$export$2e2bcd8739ae039 = $cc2ee9917dcf0328$var$SvgGlyphiconsBasic134InboxLock;




const $811a9ce5d1b50cb4$var$SvgGlyphiconsBasic135InboxDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.957 7.957 0 0 0 2-.263V25.5a2.503 2.503 0 0 1-2.5 2.5h-19A2.503 2.503 0 0 1 4 25.5v-18A2.503 2.503 0 0 1 6.5 5h11.57A8.009 8.009 0 0 0 18 6a7.96 7.96 0 0 0 .263 2H7v10h4.09a.5.5 0 0 1 .49.402l.84 4.196a.5.5 0 0 0 .49.402h6.18a.5.5 0 0 0 .49-.402l.84-4.196a.5.5 0 0 1 .49-.402H25v-4.07a8.02 8.02 0 0 0 1 .07Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3.852 0H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V6h-1.148a.5.5 0 0 0-.378.827l2.148 2.48a.5.5 0 0 0 .756 0l2.148-2.48A.5.5 0 0 0 28.148 6Z"
        })
    });
var $811a9ce5d1b50cb4$export$2e2bcd8739ae039 = $811a9ce5d1b50cb4$var$SvgGlyphiconsBasic135InboxDown;




const $71e50ad8c1a330a4$var$SvgGlyphiconsBasic136InboxUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.957 7.957 0 0 0 2-.263V25.5a2.503 2.503 0 0 1-2.5 2.5h-19A2.503 2.503 0 0 1 4 25.5v-18A2.503 2.503 0 0 1 6.5 5h11.57A8.009 8.009 0 0 0 18 6a7.96 7.96 0 0 0 .263 2H7v10h4.09a.5.5 0 0 1 .49.402l.84 4.196a.5.5 0 0 0 .49.402h6.18a.5.5 0 0 0 .49-.402l.84-4.196a.5.5 0 0 1 .49-.402H25v-4.07a8.02 8.02 0 0 0 1 .07Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3.474-.827-2.148-2.48a.5.5 0 0 0-.756 0l-2.148 2.48a.5.5 0 0 0 .378.827H25v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V6h1.148a.5.5 0 0 0 .378-.827Z"
        })
    });
var $71e50ad8c1a330a4$export$2e2bcd8739ae039 = $71e50ad8c1a330a4$var$SvgGlyphiconsBasic136InboxUp;




const $fa2b875bff702098$var$SvgGlyphiconsBasic137Cogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.835 14.76a.504.504 0 0 0-.38-.432l-2.818-.705a8.943 8.943 0 0 0-.896-2.167l1.491-2.484a.507.507 0 0 0-.038-.58 11.976 11.976 0 0 0-1.682-1.682.507.507 0 0 0-.58-.038l-2.484 1.491a8.94 8.94 0 0 0-2.167-.895l-.705-2.818a.504.504 0 0 0-.431-.38 10.324 10.324 0 0 0-2.385 0 .504.504 0 0 0-.432.38l-.705 2.818a8.926 8.926 0 0 0-2.165.895L8.973 6.671a.507.507 0 0 0-.58.038 11.97 11.97 0 0 0-1.682 1.682.507.507 0 0 0-.038.58l1.491 2.484a8.898 8.898 0 0 0-.896 2.168l-2.818.705a.504.504 0 0 0-.38.432 10.333 10.333 0 0 0 0 2.385.504.504 0 0 0 .38.431l2.818.705a8.89 8.89 0 0 0 .896 2.167l-1.492 2.485a.507.507 0 0 0 .038.579 11.976 11.976 0 0 0 1.682 1.682.507.507 0 0 0 .58.038l2.484-1.49a8.94 8.94 0 0 0 2.167.895l.705 2.817a.504.504 0 0 0 .432.381 10.324 10.324 0 0 0 2.385 0 .504.504 0 0 0 .431-.38l.705-2.818a8.935 8.935 0 0 0 2.168-.897l2.486 1.491a.507.507 0 0 0 .579-.038 12 12 0 0 0 1.681-1.682.507.507 0 0 0 .038-.58l-1.492-2.484a8.936 8.936 0 0 0 .896-2.166l2.817-.705a.504.504 0 0 0 .381-.431 10.324 10.324 0 0 0 0-2.385Zm-11.883 5.373a4.18 4.18 0 1 1 4.18-4.18 4.181 4.181 0 0 1-4.18 4.18Z"
        })
    });
var $fa2b875bff702098$export$2e2bcd8739ae039 = $fa2b875bff702098$var$SvgGlyphiconsBasic137Cogwheel;




const $188845dc26b87281$var$SvgGlyphiconsBasic138Cogwheels = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.741 16.447a8.936 8.936 0 0 0 .896-2.166l2.817-.705a.504.504 0 0 0 .381-.431 10.324 10.324 0 0 0 0-2.385.504.504 0 0 0-.38-.432l-2.818-.705a8.943 8.943 0 0 0-.896-2.167l1.491-2.484a.507.507 0 0 0-.038-.58 11.976 11.976 0 0 0-1.682-1.682.507.507 0 0 0-.58-.038l-2.484 1.491a8.94 8.94 0 0 0-2.167-.895L13.576.45a.504.504 0 0 0-.431-.38 10.324 10.324 0 0 0-2.385 0 .504.504 0 0 0-.432.38l-.705 2.818a8.926 8.926 0 0 0-2.165.895L4.973 2.671a.507.507 0 0 0-.58.038 11.97 11.97 0 0 0-1.682 1.682.507.507 0 0 0-.038.58l1.491 2.484a8.898 8.898 0 0 0-.896 2.168l-2.818.705a.504.504 0 0 0-.381.432 10.333 10.333 0 0 0 0 2.385.504.504 0 0 0 .38.431l2.819.705a8.89 8.89 0 0 0 .896 2.167l-1.492 2.485a.507.507 0 0 0 .038.579 11.976 11.976 0 0 0 1.682 1.682.507.507 0 0 0 .58.038l2.484-1.49a8.94 8.94 0 0 0 2.167.895l.705 2.817a.504.504 0 0 0 .432.381 10.324 10.324 0 0 0 2.385 0 .504.504 0 0 0 .431-.38l.705-2.818a8.935 8.935 0 0 0 2.168-.897l2.486 1.491a.507.507 0 0 0 .579-.038 12 12 0 0 0 1.681-1.682.507.507 0 0 0 .038-.58Zm-7.789-.314a4.18 4.18 0 1 1 4.18-4.18 4.181 4.181 0 0 1-4.18 4.18Zm19.754 9.505a.498.498 0 0 0-.379-.472l-1.156-.289a4.414 4.414 0 0 0-.43-1.041l.618-1.031a.497.497 0 0 0-.043-.582 5.852 5.852 0 0 0-.542-.539.504.504 0 0 0-.586-.046l-1.029.617a4.324 4.324 0 0 0-1.04-.429l-.29-1.157a.497.497 0 0 0-.47-.379c-.221-.005-.49-.005-.715 0a.498.498 0 0 0-.472.379l-.29 1.157a4.348 4.348 0 0 0-1.04.429l-1.03-.618a.497.497 0 0 0-.581.042 5.793 5.793 0 0 0-.54.54.503.503 0 0 0-.047.587l.618 1.03a4.361 4.361 0 0 0-.43 1.041l-1.157.29a.497.497 0 0 0-.379.47c-.005.221-.006.49 0 .715a.498.498 0 0 0 .379.472l1.157.29a4.347 4.347 0 0 0 .429 1.04l-.619 1.03a.497.497 0 0 0 .043.581 5.817 5.817 0 0 0 .54.54.504.504 0 0 0 .588.047l1.029-.618a4.404 4.404 0 0 0 1.04.431l.29 1.156a.497.497 0 0 0 .47.38c.222.004.491.005.716 0a.498.498 0 0 0 .472-.38l.29-1.156a4.417 4.417 0 0 0 1.041-.432l1.03.62a.497.497 0 0 0 .582-.043 5.86 5.86 0 0 0 .539-.542.504.504 0 0 0 .046-.586l-.617-1.029a4.523 4.523 0 0 0 .43-1.04l1.156-.289a.497.497 0 0 0 .379-.47c.005-.222.006-.491 0-.716ZM26 28.143a2.147 2.147 0 1 1 2.148-2.149A2.15 2.15 0 0 1 26 28.143Z"
        })
    });
var $188845dc26b87281$export$2e2bcd8739ae039 = $188845dc26b87281$var$SvgGlyphiconsBasic138Cogwheels;




const $ba287a9439991d71$var$SvgGlyphiconsBasic139Curves = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 11.5v1a.5.5 0 0 1-.5.5H13v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H9.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V9.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 0 1 .5.5Zm13-4v17a3.504 3.504 0 0 1-3.5 3.5h-17A3.504 3.504 0 0 1 4 24.5v-17A3.504 3.504 0 0 1 7.5 4h17A3.504 3.504 0 0 1 28 7.5Zm-4 14a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm.852-14.352A.499.499 0 0 0 24.5 7h-17a.506.506 0 0 0-.5.5v17a.499.499 0 0 0 .148.352Z"
        })
    });
var $ba287a9439991d71$export$2e2bcd8739ae039 = $ba287a9439991d71$var$SvgGlyphiconsBasic139Curves;




const $a63189c084085f4e$var$SvgGlyphiconsBasic14BeachUmbrella = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 18h2v9a1 1 0 0 1-2 0Zm13-1a4.812 4.812 0 0 0-3-1 4.982 4.982 0 0 0-4.034 2.068 6.996 6.996 0 0 0-9.932 0A4.98 4.98 0 0 0 4 17 11.994 11.994 0 0 1 15 5.05V4a1 1 0 0 1 2 0v1.05A11.994 11.994 0 0 1 28 17ZM15.326 7.028a10.02 10.02 0 0 0-8.873 6.993q.272-.02.547-.021a6.954 6.954 0 0 1 3.211.793 11.999 11.999 0 0 1 5.115-7.765ZM25 14q.275 0 .547.021a10.02 10.02 0 0 0-8.873-6.993 11.999 11.999 0 0 1 5.115 7.765A6.954 6.954 0 0 1 25 14Z"
        })
    });
var $a63189c084085f4e$export$2e2bcd8739ae039 = $a63189c084085f4e$var$SvgGlyphiconsBasic14BeachUmbrella;




const $348964e5cbf73944$var$SvgGlyphiconsBasic140Adjust = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 25h3v2a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1ZM9 12H8V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1ZM5 27a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8H5Zm22-17h-1V5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v5h-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Zm-4 17a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V17h-3Zm-5-9h-1V5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v13h-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Z"
        })
    });
var $348964e5cbf73944$export$2e2bcd8739ae039 = $348964e5cbf73944$var$SvgGlyphiconsBasic140Adjust;




const $898695db943e2388$var$SvgGlyphiconsBasic141Database = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.775 23.395A.977.977 0 0 1 25 24v1c0 1.822-3.533 3-9 3s-9-1.178-9-3v-1a.977.977 0 0 1 .225-.605C9.073 24.445 12.038 25 16 25s6.927-.555 8.775-1.605ZM16 20c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 19v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1a.977.977 0 0 0-.225-.605C22.927 19.445 19.962 20 16 20Zm0-14c-5.467 0-9 1.178-9 3v1c0 1.822 3.533 3 9 3s9-1.178 9-3V9c0-1.822-3.533-3-9-3Zm0 9c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 14v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1a.977.977 0 0 0-.225-.605C22.927 14.445 19.962 15 16 15Z"
        })
    });
var $898695db943e2388$export$2e2bcd8739ae039 = $898695db943e2388$var$SvgGlyphiconsBasic141Database;




const $cac9b95a5b5d8adb$var$SvgGlyphiconsBasic142DatabasePlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.775 23.395A.977.977 0 0 1 25 24v1c0 1.822-3.533 3-9 3s-9-1.178-9-3v-1a.977.977 0 0 1 .225-.605C9.073 24.445 12.038 25 16 25s6.927-.555 8.775-1.605ZM16 13a25.385 25.385 0 0 0 5.36-.495 7.988 7.988 0 0 1-3.357-6.447Q17.052 6 16 6c-5.467 0-9 1.178-9 3v1c0 1.822 3.533 3 9 3Zm0 7c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 19v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1a.977.977 0 0 0-.225-.605C22.927 19.445 19.962 20 16 20Zm8.057-6.249A20.778 20.778 0 0 1 16 15c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 14v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1c0-.025-.012-.047-.014-.072a7.936 7.936 0 0 1-.929-.177ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $cac9b95a5b5d8adb$export$2e2bcd8739ae039 = $cac9b95a5b5d8adb$var$SvgGlyphiconsBasic142DatabasePlus;




const $b63a8d12570e4323$var$SvgGlyphiconsBasic143DatabaseMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.775 23.395A.977.977 0 0 1 25 24v1c0 1.822-3.533 3-9 3s-9-1.178-9-3v-1a.977.977 0 0 1 .225-.605C9.073 24.445 12.038 25 16 25s6.927-.555 8.775-1.605ZM16 13a25.385 25.385 0 0 0 5.36-.495 7.988 7.988 0 0 1-3.357-6.447Q17.052 6 16 6c-5.467 0-9 1.178-9 3v1c0 1.822 3.533 3 9 3Zm0 7c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 19v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1a.977.977 0 0 0-.225-.605C22.927 19.445 19.962 20 16 20Zm8.057-6.249A20.778 20.778 0 0 1 16 15c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 14v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1c0-.025-.012-.047-.014-.072a7.936 7.936 0 0 1-.929-.177ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $b63a8d12570e4323$export$2e2bcd8739ae039 = $b63a8d12570e4323$var$SvgGlyphiconsBasic143DatabaseMinus;




const $b482c18067696a29$var$SvgGlyphiconsBasic144DatabaseSearch = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 10V9c0-1.822 3.533-3 9-3 .734 0 1.43.023 2.09.064a7.01 7.01 0 0 0 5.354 5.756A18.363 18.363 0 0 1 16 13c-5.467 0-9-1.178-9-3Zm9 15c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 24v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1a.977.977 0 0 0-.225-.605C22.927 24.445 19.962 25 16 25Zm0-10c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 14v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1a.977.977 0 0 0-.225-.605C22.927 14.445 19.962 15 16 15Zm0 5c-3.962 0-6.927-.555-8.775-1.605A.977.977 0 0 0 7 19v1c0 1.822 3.533 3 9 3s9-1.178 9-3v-1a.977.977 0 0 0-.225-.605C22.927 19.445 19.962 20 16 20Zm15.622-9.21-.831.832a.5.5 0 0 1-.707 0L27.673 9.21A4.99 4.99 0 1 1 30 5a4.958 4.958 0 0 1-.79 2.673l2.412 2.41a.5.5 0 0 1 0 .708ZM28 5a3 3 0 1 0-3 3 3.003 3.003 0 0 0 3-3Z"
        })
    });
var $b482c18067696a29$export$2e2bcd8739ae039 = $b482c18067696a29$var$SvgGlyphiconsBasic144DatabaseSearch;




const $bfa52eea19dd88b5$var$SvgGlyphiconsBasic145FolderOpen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6.06 11.515 4 19.754V7a2 2 0 0 1 2-2h4.172a2 2 0 0 1 1.414.586L13 7h13a2 2 0 0 1 2 2v1H8a2 2 0 0 0-1.94 1.515ZM29.438 12H9.562a2 2 0 0 0-1.94 1.515L4 28h24l3.379-13.515A2 2 0 0 0 29.439 12Z"
        })
    });
var $bfa52eea19dd88b5$export$2e2bcd8739ae039 = $bfa52eea19dd88b5$var$SvgGlyphiconsBasic145FolderOpen;




const $09e6cb98cc586c8d$var$SvgGlyphiconsBasic146FolderPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.957 7.957 0 0 0 2-.263V26a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12h16.726A7.958 7.958 0 0 0 26 14Zm-7.93-7H13l-1.414-1.414A2 2 0 0 0 10.172 5H6a2 2 0 0 0-2 2v3h15.082a7.931 7.931 0 0 1-1.013-3ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $09e6cb98cc586c8d$export$2e2bcd8739ae039 = $09e6cb98cc586c8d$var$SvgGlyphiconsBasic146FolderPlus;




const $cc9ee88a14ed87a2$var$SvgGlyphiconsBasic147FolderMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.082 10H4V7a2 2 0 0 1 2-2h4.172a2 2 0 0 1 1.414.586L13 7h5.07a7.931 7.931 0 0 0 1.012 3Zm1.644 2H4v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V13.737A7.895 7.895 0 0 1 20.726 12ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $cc9ee88a14ed87a2$export$2e2bcd8739ae039 = $cc9ee88a14ed87a2$var$SvgGlyphiconsBasic147FolderMinus;




const $88664fdd9daddb86$var$SvgGlyphiconsBasic148FolderRefresh = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.16 10H4V7a2 2 0 0 1 2-2h4.172a2 2 0 0 1 1.414.586L13 7h3.645a2.45 2.45 0 0 0 .025.546Zm7.832 3.999a7.972 7.972 0 0 1-4.182-1.186A2.432 2.432 0 0 1 17.782 12H4v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V13.41a8 8 0 0 1-2.523.574c-.164.01-.325.015-.485.015Zm5.67-12.685a.445.445 0 0 0-.75-.227l-.686.686c-.084-.085-.155-.18-.245-.26a6.004 6.004 0 0 0-9.663 2.556.495.495 0 0 0 .383.631l1.009.202a.51.51 0 0 0 .573-.339 3.866 3.866 0 0 1 .727-1.217 3.972 3.972 0 0 1 2.752-1.337c.081-.005.163-.007.243-.007a3.966 3.966 0 0 1 2.649 1.008c.06.054.102.12.158.178l-.725.725a.445.445 0 0 0 .227.75l3.532.706a.445.445 0 0 0 .523-.523ZM30.299 7.3l-1.008-.202a.51.51 0 0 0-.573.339 3.866 3.866 0 0 1-.727 1.217 3.972 3.972 0 0 1-2.752 1.337 4.057 4.057 0 0 1-2.892-1c-.052-.05-.102-.122-.158-.179l.725-.725a.445.445 0 0 0-.227-.75l-3.532-.706a.444.444 0 0 0-.523.523l.706 3.532a.445.445 0 0 0 .75.227l.687-.686c.083.085.155.18.245.26a5.951 5.951 0 0 0 3.973 1.512c.121 0 .243-.004.365-.012a5.816 5.816 0 0 0 2.911-.944 6.122 6.122 0 0 0 2.414-3.112.496.496 0 0 0-.384-.631Z"
        })
    });
var $88664fdd9daddb86$export$2e2bcd8739ae039 = $88664fdd9daddb86$var$SvgGlyphiconsBasic148FolderRefresh;




const $0290c20c6af323d9$var$SvgGlyphiconsBasic149FolderCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.957 7.957 0 0 0 2-.263V26a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12h16.726A7.958 7.958 0 0 0 26 14Zm-7.93-7H13l-1.414-1.414A2 2 0 0 0 10.172 5H6a2 2 0 0 0-2 2v3h15.082a7.932 7.932 0 0 1-1.013-3ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-2.852-2.234-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.096l-.433.554a.297.297 0 0 0 .027.377l2.233 2.236a.83.83 0 0 0 1.298-.1L29.2 4.118a.254.254 0 0 0-.052-.352Z"
        })
    });
var $0290c20c6af323d9$export$2e2bcd8739ae039 = $0290c20c6af323d9$var$SvgGlyphiconsBasic149FolderCheck;




const $32f6014e7034ee22$var$SvgGlyphiconsBasic15Train = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10.379 26h2.9l-1.153 2.429a1 1 0 0 1-.903.571H8.23a.5.5 0 0 1-.325-.88Zm10.824 0h-2.9l1.153 2.429a1 1 0 0 0 .903.571h2.992a.5.5 0 0 0 .326-.88ZM25 9v13a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9a5.015 5.015 0 0 1 5-5h8a5.015 5.015 0 0 1 5 5Zm-12 8.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm10 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5ZM23 9a3.009 3.009 0 0 0-3-3h-8a3.009 3.009 0 0 0-3 3v3a1.003 1.003 0 0 0 1 1h12a1.003 1.003 0 0 0 1-1Z"
        })
    });
var $32f6014e7034ee22$export$2e2bcd8739ae039 = $32f6014e7034ee22$var$SvgGlyphiconsBasic15Train;




const $1a7ada628865f8e0$var$SvgGlyphiconsBasic150FolderStar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.54 10H4V7a2 2 0 0 1 2-2h4.172a2 2 0 0 1 1.414.586L13 7h4.12a2.424 2.424 0 0 0 .415.394l2.307 1.676Zm5.464 2.82-2.302 1.672a2.417 2.417 0 0 1-1.427.466A2.408 2.408 0 0 1 18.918 12H4v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V14.843a2.442 2.442 0 0 1-.693-.351ZM31.044 5h-4.302l-.646-1.988-.684-2.105a.43.43 0 0 0-.816 0l-.684 2.105L23.267 5h-4.304a.43.43 0 0 0-.252.777l1.791 1.3 1.691 1.229-.645 1.987-.683 2.101a.43.43 0 0 0 .661.48l1.788-1.298 1.69-1.228 1.69 1.228 1.788 1.298a.43.43 0 0 0 .66-.48l-.682-2.1-.645-1.988 1.69-1.228 1.792-1.301A.43.43 0 0 0 31.045 5Z"
        })
    });
var $1a7ada628865f8e0$export$2e2bcd8739ae039 = $1a7ada628865f8e0$var$SvgGlyphiconsBasic150FolderStar;




const $7f222d9caa6d5614$var$SvgGlyphiconsBasic151SquareEdit = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24 16.657 3-3V23.5a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h15a3.485 3.485 0 0 1 .756.087L21.343 8H8.5a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Zm-10.187 3.976c-.206.512.041.76.553.553 1.382-.558 3.82-1.545 3.841-1.565 0 0-2.829-2.828-2.857-2.8Zm12.894-9.512-2.828-2.828-7.086 7.085 2.828 2.829Zm2.925-3.632L27.51 5.37a.5.5 0 0 0-.707 0l-1.51 1.51 2.828 2.828 1.51-1.51a.5.5 0 0 0 0-.708Z"
        })
    });
var $7f222d9caa6d5614$export$2e2bcd8739ae039 = $7f222d9caa6d5614$var$SvgGlyphiconsBasic151SquareEdit;




const $62a357131ea9393e$var$SvgGlyphiconsBasic152SquareNewWindow = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24 15.573 3 3V23.5a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h4.928l3 3H8.5a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Zm-4.18-7.01-6.936 9.187a.5.5 0 0 0 .046.655l.665.665a.5.5 0 0 0 .655.046l9.186-6.936 2.126 2.126a.5.5 0 0 0 .847-.275l1.483-9.351a.5.5 0 0 0-.572-.572L17.97 5.59a.5.5 0 0 0-.275.847Z"
        })
    });
var $62a357131ea9393e$export$2e2bcd8739ae039 = $62a357131ea9393e$var$SvgGlyphiconsBasic152SquareNewWindow;




const $678bd28d50b418d9$var$SvgGlyphiconsBasic153SquareCheckbox = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24 15.75 3-3.324V23.5a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h15a3.47 3.47 0 0 1 1.404.3 2.45 2.45 0 0 0-.243.174L21.786 8H8.5a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Zm3.664-7.753-1-.999a.5.5 0 0 0-.683-.022l-10.648 9.357-3.638-1.819a.5.5 0 0 0-.614.135l-.81 1.011a.5.5 0 0 0 .028.656l4.624 4.897a1 1 0 0 0 1.47-.017l11.289-12.51a.5.5 0 0 0-.018-.689Z"
        })
    });
var $678bd28d50b418d9$export$2e2bcd8739ae039 = $678bd28d50b418d9$var$SvgGlyphiconsBasic153SquareCheckbox;




const $fac3744beb9e32c2$var$SvgGlyphiconsBasic154SquareEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 5h-15A3.504 3.504 0 0 0 5 8.5v15A3.504 3.504 0 0 0 8.5 27h15a3.504 3.504 0 0 0 3.5-3.5v-15A3.504 3.504 0 0 0 23.5 5Zm.5 18.5a.506.506 0 0 1-.5.5h-15a.506.506 0 0 1-.5-.5v-15a.506.506 0 0 1 .5-.5h15a.506.506 0 0 1 .5.5Z"
        })
    });
var $fac3744beb9e32c2$export$2e2bcd8739ae039 = $fac3744beb9e32c2$var$SvgGlyphiconsBasic154SquareEmpty;




const $bbd2a4717c1a07f6$var$SvgGlyphiconsBasic155SquareSelected = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 5h-15A3.504 3.504 0 0 0 5 8.5v15A3.504 3.504 0 0 0 8.5 27h15a3.504 3.504 0 0 0 3.5-3.5v-15A3.504 3.504 0 0 0 23.5 5Zm.5 18.5a.506.506 0 0 1-.5.5h-15a.506.506 0 0 1-.5-.5v-15a.506.506 0 0 1 .5-.5h15a.506.506 0 0 1 .5.5ZM21 12v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z"
        })
    });
var $bbd2a4717c1a07f6$export$2e2bcd8739ae039 = $bbd2a4717c1a07f6$var$SvgGlyphiconsBasic155SquareSelected;




const $1e153c0ec548d6c3$var$SvgGlyphiconsBasic156SquareIndeterminate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 5h-15A3.504 3.504 0 0 0 5 8.5v15A3.504 3.504 0 0 0 8.5 27h15a3.504 3.504 0 0 0 3.5-3.5v-15A3.504 3.504 0 0 0 23.5 5Zm.5 18.5a.506.506 0 0 1-.5.5h-15a.506.506 0 0 1-.5-.5v-15a.506.506 0 0 1 .5-.5h15a.506.506 0 0 1 .5.5ZM21 15v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z"
        })
    });
var $1e153c0ec548d6c3$export$2e2bcd8739ae039 = $1e153c0ec548d6c3$var$SvgGlyphiconsBasic156SquareIndeterminate;




const $f951051a92cd5794$var$SvgGlyphiconsBasic157Thumbnails = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 6v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1ZM14 17H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Zm0-12H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm12 12h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
        })
    });
var $f951051a92cd5794$export$2e2bcd8739ae039 = $f951051a92cd5794$var$SvgGlyphiconsBasic157Thumbnails;




const $bcbd128d569ba9eb$var$SvgGlyphiconsBasic158ThumbnailsSmall = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 22v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm-9-1H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm0-8H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm8 0h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-8-8H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm16 0h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm0 8h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm0 8h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM18 5h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $bcbd128d569ba9eb$export$2e2bcd8739ae039 = $bcbd128d569ba9eb$var$SvgGlyphiconsBasic158ThumbnailsSmall;




const $d659d4bf13bc5885$var$SvgGlyphiconsBasic159ThumbnailsList = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11 14v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1Zm-1 7H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm0-16H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm17 6H14a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H14a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm0 18H14a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H14a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $d659d4bf13bc5885$export$2e2bcd8739ae039 = $d659d4bf13bc5885$var$SvgGlyphiconsBasic159ThumbnailsList;




const $acad9d10c49bd361$var$SvgGlyphiconsBasic16Print = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 22h12v5a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1ZM23 5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v4h14Zm5 8v10a2.006 2.006 0 0 1-2 2h-2v-4a1.003 1.003 0 0 0-1-1H9a1.003 1.003 0 0 0-1 1v4H6a2.006 2.006 0 0 1-2-2V13a2.006 2.006 0 0 1 2-2h20a2.006 2.006 0 0 1 2 2Zm-2 .5a.5.5 0 0 0-.5-.5h-2.001a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $acad9d10c49bd361$export$2e2bcd8739ae039 = $acad9d10c49bd361$var$SvgGlyphiconsBasic16Print;




const $3526533fb217accb$var$SvgGlyphiconsBasic160Playlist = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30 7.618v3.764a1 1 0 0 1-1.447.894l-2.342-1.17a.99.99 0 0 0-.211-.05v12.778S26 25 25.983 25a2.81 2.81 0 0 1-2.472 2.57l-2.022.193A2.235 2.235 0 0 1 19 25.5a3.33 3.33 0 0 1 2.432-3.08l2.082-.502a.666.666 0 0 0 .486-.617V6a1 1 0 0 1 1-1h.764a1 1 0 0 1 .447.106l3.236 1.618a1 1 0 0 1 .553.894ZM6 8h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm0 6h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm0 6h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm10 3H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $3526533fb217accb$export$2e2bcd8739ae039 = $3526533fb217accb$var$SvgGlyphiconsBasic160Playlist;




const $a6ab394e99bab9b4$var$SvgGlyphiconsBasic161ComputerAllInOne = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 26v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm9-20.5v16a1.504 1.504 0 0 1-1.5 1.5h-23A1.504 1.504 0 0 1 3 21.5v-16A1.5 1.5 0 0 1 4.5 4h23A1.5 1.5 0 0 1 29 5.5Zm-12 14a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5ZM26 7H6v10h20Z"
        })
    });
var $a6ab394e99bab9b4$export$2e2bcd8739ae039 = $a6ab394e99bab9b4$var$SvgGlyphiconsBasic161ComputerAllInOne;




const $b93605b3268ce8c5$var$SvgGlyphiconsBasic162ComputerPcTower = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M2.5 8H17v3H4v9h13v3h-3v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1H2.5A1.5 1.5 0 0 1 1 21.5v-12A1.5 1.5 0 0 1 2.5 8ZM31 6.5v19a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-19A1.5 1.5 0 0 1 20.5 5h9A1.5 1.5 0 0 1 31 6.5Zm-5 15a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm2-13a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $b93605b3268ce8c5$export$2e2bcd8739ae039 = $b93605b3268ce8c5$var$SvgGlyphiconsBasic162ComputerPcTower;




const $e70dceb6996dc265$var$SvgGlyphiconsBasic163Computer = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.499 21H5.5A1.5 1.5 0 0 0 4 22.5v5A1.5 1.5 0 0 0 5.5 29h20.999a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5ZM13 25.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm13 1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM7.5 19h17a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 24.5 4h-17A1.5 1.5 0 0 0 6 5.5v12A1.5 1.5 0 0 0 7.5 19ZM9 7h14v9H9Z"
        })
    });
var $e70dceb6996dc265$export$2e2bcd8739ae039 = $e70dceb6996dc265$var$SvgGlyphiconsBasic163Computer;




const $dbd4c9ffb64593e4$var$SvgGlyphiconsBasic164Notebook = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.5 22H27V9.5A2.503 2.503 0 0 0 24.5 7h-18A2.503 2.503 0 0 0 4 9.5V22H2.5a.5.5 0 0 0-.5.5V24a1 1 0 0 0 1 1h25a1 1 0 0 0 1-1v-1.5a.5.5 0 0 0-.5-.5ZM24 21H7V10h17Z"
        })
    });
var $dbd4c9ffb64593e4$export$2e2bcd8739ae039 = $dbd4c9ffb64593e4$var$SvgGlyphiconsBasic164Notebook;




const $58c73b9820928fe7$var$SvgGlyphiconsBasic165Tablet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 3h-15A2.503 2.503 0 0 0 6 5.5v21A2.503 2.503 0 0 0 8.5 29h15a2.503 2.503 0 0 0 2.5-2.5v-21A2.503 2.503 0 0 0 23.5 3ZM17 26.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm6-3.5H9V6h14Z"
        })
    });
var $58c73b9820928fe7$export$2e2bcd8739ae039 = $58c73b9820928fe7$var$SvgGlyphiconsBasic165Tablet;




const $74d0fb4b6a21a112$var$SvgGlyphiconsBasic166MobilePhone = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.5 4h-11A2.503 2.503 0 0 0 8 6.5v19a2.503 2.503 0 0 0 2.5 2.5h11a2.503 2.503 0 0 0 2.5-2.5v-19A2.503 2.503 0 0 0 21.5 4ZM17 25.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4-3.5H11V7h10Z"
        })
    });
var $74d0fb4b6a21a112$export$2e2bcd8739ae039 = $74d0fb4b6a21a112$var$SvgGlyphiconsBasic166MobilePhone;




const $a45044c852f55dd7$var$SvgGlyphiconsBasic167MobilePhoneOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 2.94a1.5 1.5 0 0 0-2.121 0L23.282 4.75A2.49 2.49 0 0 0 21.5 4h-11A2.503 2.503 0 0 0 8 6.5v13.533l-5.06 5.06a1.5 1.5 0 1 0 2.12 2.121L27.216 5.061a1.5 1.5 0 0 0 0-2.122ZM21 7.032l-10 10V7h10ZM21 22h-7.033l-5.249 5.249A2.49 2.49 0 0 0 10.5 28h11a2.503 2.503 0 0 0 2.5-2.5V11.967l-3 3Zm-4 3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $a45044c852f55dd7$export$2e2bcd8739ae039 = $a45044c852f55dd7$var$SvgGlyphiconsBasic167MobilePhoneOff;




const $0b1073677fc60e1f$var$SvgGlyphiconsBasic168MobilePhoneVibrations = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.5 4h-11A2.503 2.503 0 0 0 8 6.5v19a2.503 2.503 0 0 0 2.5 2.5h11a2.503 2.503 0 0 0 2.5-2.5v-19A2.503 2.503 0 0 0 21.5 4ZM17 25.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4-3.5H11V7h10Zm8.85-5.158a1 1 0 0 1 0 1.321l-2.199 2.498a1 1 0 0 1-1.502-1.322l1.619-1.837-1.619-1.837a1 1 0 0 1 0-1.32l1.62-1.843-1.62-1.842a1 1 0 1 1 1.502-1.32l2.2 2.502a1 1 0 0 1 0 1.32l-1.619 1.842Zm-24-1.186-1.619 1.842 1.62 1.842a1 1 0 1 1-1.502 1.32l-2.2-2.502a1 1 0 0 1 0-1.32l1.619-1.842-1.619-1.838a1 1 0 0 1 0-1.321l2.2-2.498a1 1 0 0 1 1.502 1.322l-1.619 1.837 1.619 1.837a1 1 0 0 1 0 1.32Z"
        })
    });
var $0b1073677fc60e1f$export$2e2bcd8739ae039 = $0b1073677fc60e1f$var$SvgGlyphiconsBasic168MobilePhoneVibrations;




const $0cc99a2ae063730f$var$SvgGlyphiconsBasic169MobilePhoneShaking = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.5 4h-11A2.503 2.503 0 0 0 8 6.5v19a2.503 2.503 0 0 0 2.5 2.5h11a2.503 2.503 0 0 0 2.5-2.5v-19A2.503 2.503 0 0 0 21.5 4ZM17 25.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4-3.5H11V7h10ZM32 8v4a1 1 0 0 1-2 0V8a1 1 0 0 1 2 0Zm-4-1v7a1 1 0 0 1-2 0V7a1 1 0 0 1 2 0ZM2 19v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 2 0Zm4-2v7a1 1 0 0 1-2 0v-7a1 1 0 0 1 2 0Z"
        })
    });
var $0cc99a2ae063730f$export$2e2bcd8739ae039 = $0cc99a2ae063730f$var$SvgGlyphiconsBasic169MobilePhoneShaking;




const $d8e13759ed34e688$var$SvgGlyphiconsBasic17Bin = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 26a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V10H7Zm13-12a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0Zm-5 0a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0Zm-5 0a1 1 0 0 1 2 0v10a1 1 0 0 1-2 0Zm16-8v2H6V6a1 1 0 0 1 1-1h6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h6a1 1 0 0 1 1 1Z"
        })
    });
var $d8e13759ed34e688$export$2e2bcd8739ae039 = $d8e13759ed34e688$var$SvgGlyphiconsBasic17Bin;




const $7dfc05b725ef7a56$var$SvgGlyphiconsBasic170Earphones = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 9a5.993 5.993 0 0 1-3 5.19V20H9v-5a9.126 9.126 0 0 0-1.58-5.542.811.811 0 0 0-1.3.037 1.42 1.42 0 0 0-.024 1.566 7.527 7.527 0 0 1 .893 3.585A5.997 5.997 0 1 1 15 9ZM9 28h2v-6H9Zm11 0h2v-6h-2Zm2-25a5.997 5.997 0 0 0-3 11.19V20h3.125v-5a9.126 9.126 0 0 1 1.58-5.542A.818.818 0 0 1 25 9.5a1.45 1.45 0 0 1 .02 1.574 7.518 7.518 0 0 0-.882 3.517A5.991 5.991 0 0 0 22 3Z"
        })
    });
var $7dfc05b725ef7a56$export$2e2bcd8739ae039 = $7dfc05b725ef7a56$var$SvgGlyphiconsBasic170Earphones;




const $4e8c99063572445d$var$SvgGlyphiconsBasic171SkipToPrevious = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 9.462v13.076a.8.8 0 0 1-1.232.674l-10.216-6.538a.8.8 0 0 1 0-1.348l10.216-6.538A.8.8 0 0 1 23 9.462ZM10 8H9a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z"
        })
    });
var $4e8c99063572445d$export$2e2bcd8739ae039 = $4e8c99063572445d$var$SvgGlyphiconsBasic171SkipToPrevious;




const $97a1f2a41e583565$var$SvgGlyphiconsBasic172SkipToStart = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 9.462v13.076a.8.8 0 0 1-1.232.674l-10.216-6.538a.8.8 0 0 1 0-1.348l10.216-6.538A.8.8 0 0 1 28 9.462Zm-13.232-.674L4.552 15.326a.8.8 0 0 0 0 1.348l10.216 6.538A.8.8 0 0 0 16 22.538V9.462a.8.8 0 0 0-1.23-.674ZM3 8H2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z"
        })
    });
var $97a1f2a41e583565$export$2e2bcd8739ae039 = $97a1f2a41e583565$var$SvgGlyphiconsBasic172SkipToStart;




const $b8541eab608a2294$var$SvgGlyphiconsBasic173Rewind = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 9.462v13.076a.8.8 0 0 1-1.232.674l-10.216-6.538a.8.8 0 0 1 0-1.348l10.216-6.538A.8.8 0 0 1 28 9.462Zm-13.232-.674L4.552 15.326a.8.8 0 0 0 0 1.348l10.216 6.538A.8.8 0 0 0 16 22.538V9.462a.8.8 0 0 0-1.23-.674Z"
        })
    });
var $b8541eab608a2294$export$2e2bcd8739ae039 = $b8541eab608a2294$var$SvgGlyphiconsBasic173Rewind;




const $89b3a2f5d3e8eec7$var$SvgGlyphiconsBasic174Pause = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 7v18a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Zm9-1h-5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Z"
        })
    });
var $89b3a2f5d3e8eec7$export$2e2bcd8739ae039 = $89b3a2f5d3e8eec7$var$SvgGlyphiconsBasic174Pause;




const $d47cac4837d9cccd$var$SvgGlyphiconsBasic175Play = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.817 16.864 9.503 25.777A1 1 0 0 1 8 24.912V7.088a1 1 0 0 1 1.503-.865l15.314 8.913a1 1 0 0 1 0 1.728Z"
        })
    });
var $d47cac4837d9cccd$export$2e2bcd8739ae039 = $d47cac4837d9cccd$var$SvgGlyphiconsBasic175Play;




const $26134af6c26b22ba$var$SvgGlyphiconsBasic176Stop = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 8v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Z"
        })
    });
var $26134af6c26b22ba$export$2e2bcd8739ae039 = $26134af6c26b22ba$var$SvgGlyphiconsBasic176Stop;




const $c5d568188893ec5b$var$SvgGlyphiconsBasic177Forward = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.448 15.326a.8.8 0 0 1 0 1.348L5.232 23.212A.8.8 0 0 1 4 22.538V9.462a.8.8 0 0 1 1.23-.674Zm12 0L17.232 8.788A.8.8 0 0 0 16 9.462v13.076a.8.8 0 0 0 1.23.674l10.217-6.538a.8.8 0 0 0 0-1.348Z"
        })
    });
var $c5d568188893ec5b$export$2e2bcd8739ae039 = $c5d568188893ec5b$var$SvgGlyphiconsBasic177Forward;




const $95512a612b765a32$var$SvgGlyphiconsBasic178SkipToEnd = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.448 15.326a.8.8 0 0 1 0 1.348L5.232 23.212A.8.8 0 0 1 4 22.538V9.462a.8.8 0 0 1 1.23-.674Zm1.784-6.538A.8.8 0 0 0 16 9.462v13.076a.8.8 0 0 0 1.23.674l10.217-6.538a.8.8 0 0 0 0-1.348ZM30 8h-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z"
        })
    });
var $95512a612b765a32$export$2e2bcd8739ae039 = $95512a612b765a32$var$SvgGlyphiconsBasic178SkipToEnd;




const $1a8097b29dccd119$var$SvgGlyphiconsBasic179SkipToNext = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.448 15.326a.8.8 0 0 1 0 1.348l-10.216 6.538A.8.8 0 0 1 9 22.538V9.462a.8.8 0 0 1 1.23-.674ZM23 8h-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z"
        })
    });
var $1a8097b29dccd119$export$2e2bcd8739ae039 = $1a8097b29dccd119$var$SvgGlyphiconsBasic179SkipToNext;




const $6f1c719f791d71ab$var$SvgGlyphiconsBasic18Music = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5.237v16.596s0 .167-.017.167a2.81 2.81 0 0 1-2.472 2.57l-2.022.193A2.235 2.235 0 0 1 17 22.5a3.33 3.33 0 0 1 2.432-3.08l2.082-.502a.667.667 0 0 0 .486-.617v-7.872l-10 2.143v12.262s0 .166-.017.166a2.81 2.81 0 0 1-2.472 2.57l-2.022.193A2.235 2.235 0 0 1 5 25.5a3.33 3.33 0 0 1 2.432-3.08l2.082-.502a.667.667 0 0 0 .486-.617V7.808a1 1 0 0 1 .79-.977l12-2.572a1 1 0 0 1 1.21.978Z"
        })
    });
var $6f1c719f791d71ab$export$2e2bcd8739ae039 = $6f1c719f791d71ab$var$SvgGlyphiconsBasic18Music;




const $55d5a28531d570f3$var$SvgGlyphiconsBasic180Eject = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m8.069 16.693 7.312-8.936a.8.8 0 0 1 1.238 0l7.312 8.936a.8.8 0 0 1-.62 1.307H8.689a.8.8 0 0 1-.619-1.307ZM22.999 21H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $55d5a28531d570f3$export$2e2bcd8739ae039 = $55d5a28531d570f3$var$SvgGlyphiconsBasic180Eject;




const $3e3ee7893b561fdf$var$SvgGlyphiconsBasic181Video = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 11v9a1 1 0 0 1-1 1h-1l-5-3.437v-4.125L29 10h1a1 1 0 0 1 1 1ZM20 8H6a2.006 2.006 0 0 0-2 2v11a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2V10a2.006 2.006 0 0 0-2-2Z"
        })
    });
var $3e3ee7893b561fdf$export$2e2bcd8739ae039 = $3e3ee7893b561fdf$var$SvgGlyphiconsBasic181Video;




const $a28be104ef86cef7$var$SvgGlyphiconsBasic182VideoOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06 5.06 27.215a1.5 1.5 0 0 1-2.122-2.12l2.263-2.263A2.005 2.005 0 0 1 4 21V10a2.006 2.006 0 0 1 2-2h14l.03.003 5.064-5.064a1.5 1.5 0 0 1 2.12 2.122ZM30 10h-1l-5 3.438v4.125L29 21h1a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1ZM20 23a2.006 2.006 0 0 0 2-2v-7.033L12.967 23Z"
        })
    });
var $a28be104ef86cef7$export$2e2bcd8739ae039 = $a28be104ef86cef7$var$SvgGlyphiconsBasic182VideoOff;




const $885ddef6473f11c0$var$SvgGlyphiconsBasic183VolumeBluetooth = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 8.636v14.728a.8.8 0 0 1-1.291.63L9.577 20H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h4.577l5.132-3.995A.8.8 0 0 1 16 8.636Zm12.439 9.332a.5.5 0 0 1 .02.784l-5.639 4.7a.5.5 0 0 1-.82-.384V17.86l-1.933 1.45a1 1 0 0 1-1.2-1.6l2.948-2.211-2.948-2.212a1 1 0 0 1 1.2-1.6L22 13.139V7.933a.5.5 0 0 1 .82-.384l5.639 4.7a.5.5 0 0 1-.02.784l-3.29 2.468ZM24 13.86l1.722-1.291L24 11.135Zm1.722 4.57L24 17.138v2.726Z"
        })
    });
var $885ddef6473f11c0$export$2e2bcd8739ae039 = $885ddef6473f11c0$var$SvgGlyphiconsBasic183VolumeBluetooth;




const $54943b86849f817b$var$SvgGlyphiconsBasic184VolumeOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m13.17 22.797 2.83-2.83v3.397a.8.8 0 0 1-1.291.63ZM23.417 12.55a9.087 9.087 0 0 1-1.387 9.23.987.987 0 0 0 .074 1.324l.568.568a1.008 1.008 0 0 0 1.485-.07 11.883 11.883 0 0 0 1.363-13.154Zm-1.748 1.748-2.7 2.7a4.042 4.042 0 0 1-.54 1.252 1.013 1.013 0 0 0 .105 1.284l.573.574A1.001 1.001 0 0 0 20.623 20a6.752 6.752 0 0 0 1.046-5.703Zm5.546-11.359a1.5 1.5 0 0 0-2.121 0L16 12.033V8.636a.8.8 0 0 0-1.291-.63L9.577 12H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.033l-5.094 5.093a1.5 1.5 0 1 0 2.122 2.121L27.215 5.061a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $54943b86849f817b$export$2e2bcd8739ae039 = $54943b86849f817b$var$SvgGlyphiconsBasic184VolumeOff;




const $b490ab4e5ac70fa1$var$SvgGlyphiconsBasic185VolumeDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 8.636v14.728a.8.8 0 0 1-1.291.63L9.577 20H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h4.577l5.132-3.995A.8.8 0 0 1 16 8.636ZM20.623 12a1.001 1.001 0 0 0-1.516-.107l-.573.574a1.013 1.013 0 0 0-.105 1.284 4.11 4.11 0 0 1 0 4.5 1.013 1.013 0 0 0 .105 1.284l.573.574A1.001 1.001 0 0 0 20.623 20a6.905 6.905 0 0 0 0-8.002Z"
        })
    });
var $b490ab4e5ac70fa1$export$2e2bcd8739ae039 = $b490ab4e5ac70fa1$var$SvgGlyphiconsBasic185VolumeDown;




const $426fb72a410234f8$var$SvgGlyphiconsBasic186VolumeUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 8.636v14.728a.8.8 0 0 1-1.291.63L9.577 20H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h4.577l5.132-3.995A.8.8 0 0 1 16 8.636ZM20.623 12a1.001 1.001 0 0 0-1.516-.107l-.573.574a1.013 1.013 0 0 0-.105 1.284 4.11 4.11 0 0 1 0 4.5 1.013 1.013 0 0 0 .105 1.284l.573.574A1.001 1.001 0 0 0 20.623 20a6.905 6.905 0 0 0 0-8.002Zm3.534-3.601a1.008 1.008 0 0 0-1.485-.07l-.568.568a.987.987 0 0 0-.074 1.324 9.105 9.105 0 0 1 0 11.56.987.987 0 0 0 .074 1.324l.568.568a1.008 1.008 0 0 0 1.485-.07 11.904 11.904 0 0 0 0-15.204Z"
        })
    });
var $426fb72a410234f8$export$2e2bcd8739ae039 = $426fb72a410234f8$var$SvgGlyphiconsBasic186VolumeUp;




const $ac6cdcf152a0aea2$var$SvgGlyphiconsBasic187VolumeMax = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 8.636v14.727a.8.8 0 0 1-1.291.632L9.577 20H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h4.576l5.133-3.995A.8.8 0 0 1 16 8.636ZM20.623 12a1.001 1.001 0 0 0-1.516-.107l-.573.574a1.013 1.013 0 0 0-.105 1.284 4.11 4.11 0 0 1 0 4.5 1.013 1.013 0 0 0 .105 1.284l.573.574A1.001 1.001 0 0 0 20.623 20a6.905 6.905 0 0 0 0-8.002Zm3.534-3.601a1.008 1.008 0 0 0-1.485-.07l-.568.568a.987.987 0 0 0-.074 1.324 9.105 9.105 0 0 1 0 11.56.987.987 0 0 0 .074 1.324l.568.568a1.008 1.008 0 0 0 1.485-.07 11.904 11.904 0 0 0 0-15.204Zm3.502-3.596a.994.994 0 0 0-1.44-.022l-.587.587a.98.98 0 0 0-.022 1.347 14.102 14.102 0 0 1 0 18.572.98.98 0 0 0 .022 1.347l.588.587a.994.994 0 0 0 1.439-.022 16.9 16.9 0 0 0 0-22.396Z"
        })
    });
var $ac6cdcf152a0aea2$export$2e2bcd8739ae039 = $ac6cdcf152a0aea2$var$SvgGlyphiconsBasic187VolumeMax;




const $1fd40a9a49267759$var$SvgGlyphiconsBasic188Cd = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16.707 15.293a.999.999 0 0 1 0 1.414 1 1 0 0 1-1.414 0 1 1 0 0 1 1.414-1.414Zm7.778 9.192a12 12 0 1 1 0-16.97 11.961 11.961 0 0 1 0 16.97Zm-12.02-12.02a4.99 4.99 0 0 1 1.587-1.069L11.818 6.93a9.817 9.817 0 0 0-4.89 4.889l4.474 2.236a4.964 4.964 0 0 1 1.063-1.59Zm12.606 7.717-4.473-2.236a4.95 4.95 0 0 1-2.65 2.658l2.234 4.467a9.815 9.815 0 0 0 4.89-4.889ZM19 16a3 3 0 1 0-3 3 3 3 0 0 0 3-3Z"
        })
    });
var $1fd40a9a49267759$export$2e2bcd8739ae039 = $1fd40a9a49267759$var$SvgGlyphiconsBasic188Cd;




const $192f117d1b677cc6$var$SvgGlyphiconsBasic189Mc = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m21.382 22 1.5 3H9.118l1.5-3Zm.325-8.707Zm-10 0ZM29 8v16a1 1 0 0 1-1 1h-2.882l-2.223-4.447A1 1 0 0 0 22 20H10a1 1 0 0 0-.895.553L6.882 25H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h24a1 1 0 0 1 1 1Zm-15 6a3 3 0 1 0-3 3 3 3 0 0 0 3-3Zm10 0a3 3 0 1 0-3 3 3 3 0 0 0 3-3Z"
        })
    });
var $192f117d1b677cc6$export$2e2bcd8739ae039 = $192f117d1b677cc6$var$SvgGlyphiconsBasic189Mc;




const $3d9fb5fc763c4d93$var$SvgGlyphiconsBasic19MusicAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30 9.618v3.764a1 1 0 0 1-1.447.894l-2.342-1.17a.99.99 0 0 0-.211-.05v10.778S26 25 25.983 25a2.81 2.81 0 0 1-2.472 2.57l-2.022.193A2.235 2.235 0 0 1 19 25.5a3.33 3.33 0 0 1 2.432-3.08l2.082-.502a.666.666 0 0 0 .486-.617V8a1 1 0 0 1 1-1 4.235 4.235 0 0 1 1.894.447l2.553 1.277a1 1 0 0 1 .553.894ZM10 7a1.003 1.003 0 0 0-1 1v13.3a.666.666 0 0 1-.486.618l-2.082.503A3.33 3.33 0 0 0 4 25.5a2.235 2.235 0 0 0 2.489 2.263l2.022-.193A2.81 2.81 0 0 0 10.983 25C11 25 11 23.834 11 23.834V8a1.003 1.003 0 0 0-1-1Zm9 13.834S19 22 18.983 22a2.81 2.81 0 0 1-2.472 2.57l-2.022.193A2.235 2.235 0 0 1 12 22.5a3.33 3.33 0 0 1 2.432-3.08l2.082-.502a.666.666 0 0 0 .486-.617V5a1 1 0 0 1 2 0Zm-2 1-.01-.966-2.095.499A1.358 1.358 0 0 0 14 22.5c0 .125.044.274.253.274l2.07-.195a.818.818 0 0 0 .677-.745Z"
        })
    });
var $3d9fb5fc763c4d93$export$2e2bcd8739ae039 = $3d9fb5fc763c4d93$var$SvgGlyphiconsBasic19MusicAlt;




const $f41905b832727344$var$SvgGlyphiconsBasic190Lp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16.707 15.293a1 1 0 1 1-1.414 0 1 1 0 0 1 1.414 0Zm7.778 9.192a12 12 0 1 1 0-16.97 11.961 11.961 0 0 1 0 16.97ZM9 16a6.958 6.958 0 0 1 2.05-4.95 7.03 7.03 0 0 1 1.455-1.106 1 1 0 0 0-1.002-1.732A8.949 8.949 0 0 0 7 16a1 1 0 0 0 2 0Zm10.536 3.536a5 5 0 1 0-7.071 0 5 5 0 0 0 7.07 0ZM25 16a1 1 0 0 0-2 0 6.958 6.958 0 0 1-2.05 4.95 7.03 7.03 0 0 1-1.455 1.106 1 1 0 0 0 1.002 1.732A8.949 8.949 0 0 0 25 16Z"
        })
    });
var $f41905b832727344$export$2e2bcd8739ae039 = $f41905b832727344$var$SvgGlyphiconsBasic190Lp;




const $c1f5a7aa080cb922$var$SvgGlyphiconsBasic191CircleEmptyPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm6-10v2a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1Z"
        })
    });
var $c1f5a7aa080cb922$export$2e2bcd8739ae039 = $c1f5a7aa080cb922$var$SvgGlyphiconsBasic191CircleEmptyPlus;




const $aa6e0b964c24ea0d$var$SvgGlyphiconsBasic192CircleEmptyMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm6-10v2a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z"
        })
    });
var $aa6e0b964c24ea0d$export$2e2bcd8739ae039 = $aa6e0b964c24ea0d$var$SvgGlyphiconsBasic192CircleEmptyMinus;




const $079aeff35658d6bd$var$SvgGlyphiconsBasic193CircleEmptyRemove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm5.303-11.475L18.828 16l2.475 2.475a.5.5 0 0 1 0 .707l-2.121 2.121a.5.5 0 0 1-.707 0L16 18.828l-2.475 2.475a.5.5 0 0 1-.707 0l-2.121-2.121a.5.5 0 0 1 0-.707L13.172 16l-2.475-2.475a.5.5 0 0 1 0-.707l2.121-2.121a.5.5 0 0 1 .707 0L16 13.172l2.475-2.475a.5.5 0 0 1 .707 0l2.121 2.121a.5.5 0 0 1 0 .707Z"
        })
    });
var $079aeff35658d6bd$export$2e2bcd8739ae039 = $079aeff35658d6bd$var$SvgGlyphiconsBasic193CircleEmptyRemove;




const $63caa76d55c2085c$var$SvgGlyphiconsBasic194CircleEmptyCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm6.058-12.709a.5.5 0 0 1 .03.68l-6.81 8.057a1 1 0 0 1-1.507.025l-3.89-4.312a.5.5 0 0 1 .007-.677l1.137-1.215a.5.5 0 0 1 .633-.08l2.611 1.662 6.031-5.226a.5.5 0 0 1 .679.022Z"
        })
    });
var $63caa76d55c2085c$export$2e2bcd8739ae039 = $63caa76d55c2085c$var$SvgGlyphiconsBasic194CircleEmptyCheck;




const $e55ec97ea5b020e6$var$SvgGlyphiconsBasic195CircleEmptyQuestion = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm2-5v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm2.75-7v.114c0 1.38-.867 2.082-1.956 2.825a3.518 3.518 0 0 0-1.473 1.721.492.492 0 0 1-.472.34h-2.062a.502.502 0 0 1-.494-.58 3.268 3.268 0 0 1 .66-1.601 10.47 10.47 0 0 1 2.327-1.857 1.016 1.016 0 0 0 .47-.848V13a1.001 1.001 0 0 0-1-1h-1.5a1 1 0 0 0-1 1 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1 4 4 0 0 1 4-4h1.5c2.283 0 4 1.164 4 4Z"
        })
    });
var $e55ec97ea5b020e6$export$2e2bcd8739ae039 = $e55ec97ea5b020e6$var$SvgGlyphiconsBasic195CircleEmptyQuestion;




const $1b71da081c64c66d$var$SvgGlyphiconsBasic196CircleEmptyInfo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m18.903 9.582-.333 2a.5.5 0 0 1-.494.418H15.59a.5.5 0 0 1-.493-.582l.333-2A.5.5 0 0 1 15.924 9h2.486a.5.5 0 0 1 .493.582ZM28 16A12 12 0 1 1 16 4a12.013 12.013 0 0 1 12 12Zm-3 0a9 9 0 1 0-9 9 9.01 9.01 0 0 0 9-9Zm-8-3h-3.11a.5.5 0 0 0-.485.379l-.25 1a.5.5 0 0 0 .485.621h.76l-1.825 6.084A1.408 1.408 0 0 0 14 23h3.61a.5.5 0 0 0 .485-.379l.25-1A.5.5 0 0 0 17.86 21H16.6l1.825-6.084A1.408 1.408 0 0 0 17 13Z"
        })
    });
var $1b71da081c64c66d$export$2e2bcd8739ae039 = $1b71da081c64c66d$var$SvgGlyphiconsBasic196CircleEmptyInfo;




const $5367ad947e11193d$var$SvgGlyphiconsBasic197CircleEmptyAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm2-5v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm0-10v3l-.92 4.598a.5.5 0 0 1-.49.402h-1.18a.5.5 0 0 1-.491-.402L14 13v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Z"
        })
    });
var $5367ad947e11193d$export$2e2bcd8739ae039 = $5367ad947e11193d$var$SvgGlyphiconsBasic197CircleEmptyAlert;




const $dbd9107b734ff5c6$var$SvgGlyphiconsBasic198Open = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m9.63 11.419 5.556-7.78a1 1 0 0 1 1.628 0l5.557 7.78A1 1 0 0 1 21.557 13H19v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-6h-2.557a1 1 0 0 1-.814-1.581ZM27 22H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Z"
        })
    });
var $dbd9107b734ff5c6$export$2e2bcd8739ae039 = $dbd9107b734ff5c6$var$SvgGlyphiconsBasic198Open;




const $f36453b1415bf108$var$SvgGlyphiconsBasic199Save = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 23v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-12.814-3.64a1 1 0 0 0 1.628 0l5.557-7.779A1 1 0 0 0 21.557 10H19V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v6h-2.557a1 1 0 0 0-.814 1.581Z"
        })
    });
var $f36453b1415bf108$export$2e2bcd8739ae039 = $f36453b1415bf108$var$SvgGlyphiconsBasic199Save;




const $d2e76a5857156b40$var$SvgGlyphiconsBasic2Leaf = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.001 5.017c-.043 4.671-.915 23.442-17.272 17.73a15.294 15.294 0 0 0-4.024 4.304l-.263.425a1 1 0 0 1-1.376.326l-.85-.526A1 1 0 0 1 3.89 25.9l.262-.425c.338-.547 3.438-5.667 12.112-10.119a31.287 31.287 0 0 0 8.651-6.126 1 1 0 1 0-1.418-1.41 30.963 30.963 0 0 1-8.184 5.776 39.099 39.099 0 0 0-7.36 4.804.5.5 0 0 1-.827-.315C5.967 4.896 22.606 4.043 27.003 4.013a.99.99 0 0 1 .998 1.004Z"
        })
    });
var $d2e76a5857156b40$export$2e2bcd8739ae039 = $d2e76a5857156b40$var$SvgGlyphiconsBasic2Leaf;




const $9954ccc795d9b590$var$SvgGlyphiconsBasic20HeartEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.272 5.345a6.284 6.284 0 0 0-5.068 2.774.246.246 0 0 1-.4-.005 6.011 6.011 0 0 0-4.966-2.77 6.793 6.793 0 0 0-6.62 6.582c0 4.826 6.136 8.68 11.038 14.068a1 1 0 0 0 1.488 0c4.902-5.387 11.037-9.242 11.037-14.068a6.7 6.7 0 0 0-6.509-6.581Zm-1.987 14.463c-.966.91-1.953 1.84-2.932 2.827a.497.497 0 0 1-.706 0c-.978-.986-1.966-1.917-2.932-2.827-3.164-2.98-5.896-5.555-5.896-7.882a4.218 4.218 0 0 1 4.019-3.981 3.614 3.614 0 0 1 3.085 1.768 45.206 45.206 0 0 0 1.257 1.913 1 1 0 0 0 1.629.004 22.203 22.203 0 0 1 1.228-1.857 4.002 4.002 0 0 1 3.236-1.828 4.103 4.103 0 0 1 3.908 3.98c0 2.328-2.732 4.903-5.896 7.883Z"
        })
    });
var $9954ccc795d9b590$export$2e2bcd8739ae039 = $9954ccc795d9b590$var$SvgGlyphiconsBasic20HeartEmpty;




const $b9a55f50ee1af8bb$var$SvgGlyphiconsBasic200SaveAs = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.63 11.581A1 1 0 0 1 10.442 10H13V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6h2.557a1 1 0 0 1 .814 1.581l-5.557 7.78a1 1 0 0 1-1.628 0ZM28 23v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-15 1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm4 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm4 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z"
        })
    });
var $b9a55f50ee1af8bb$export$2e2bcd8739ae039 = $b9a55f50ee1af8bb$var$SvgGlyphiconsBasic200SaveAs;




const $122f010447310344$var$SvgGlyphiconsBasic201Cart = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 26.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5Zm8.5-1.5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm6.464-16.175-2 9A1.5 1.5 0 0 1 24.5 19H11.77l.438 2H23a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H11a1.5 1.5 0 0 1-1.465-1.18L6.292 8H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3.5a1.5 1.5 0 0 1 1.465 1.18l.18.82H26.5a1.5 1.5 0 0 1 1.464 1.825ZM24.63 10H9.8l1.313 6h12.183Z"
        })
    });
var $122f010447310344$export$2e2bcd8739ae039 = $122f010447310344$var$SvgGlyphiconsBasic201Cart;




const $27157c885ba4c9db$var$SvgGlyphiconsBasic202CartIn = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.337 8.795A.5.5 0 0 1 12.741 8h2.045l.653-4.57a.5.5 0 0 1 .495-.43h1.132a.5.5 0 0 1 .495.43L18.214 8h2.045a.5.5 0 0 1 .404.795l-3.76 5.151a.5.5 0 0 1-.807 0ZM21.5 25a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm5.671-18h-1.558a.653.653 0 0 0-.61.488L23.099 16H11.114L8.965 6.18A1.5 1.5 0 0 0 7.5 5H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.292l3.243 14.82A1.5 1.5 0 0 0 11 24h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H12.208l-.438-2h12.734a1.303 1.303 0 0 0 1.217-.976l2.233-10.048A.767.767 0 0 0 27.171 7ZM11.5 25a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Z"
        })
    });
var $27157c885ba4c9db$export$2e2bcd8739ae039 = $27157c885ba4c9db$var$SvgGlyphiconsBasic202CartIn;




const $ce1d32f10145efb9$var$SvgGlyphiconsBasic203CartOut = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m12.337 8.205 3.76-5.151a.5.5 0 0 1 .807 0l3.759 5.151a.5.5 0 0 1-.404.795h-2.045l-.653 4.57a.5.5 0 0 1-.495.43h-1.132a.5.5 0 0 1-.495-.43L14.786 9H12.74a.5.5 0 0 1-.404-.795ZM11.5 25a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5ZM27.171 7h-1.558a.653.653 0 0 0-.61.488L23.099 16H11.114L8.965 6.18A1.5 1.5 0 0 0 7.5 5H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.292l3.243 14.82A1.5 1.5 0 0 0 11 24h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H12.208l-.438-2h12.734a1.303 1.303 0 0 0 1.217-.976l2.233-10.048A.767.767 0 0 0 27.171 7ZM21.5 25a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Z"
        })
    });
var $ce1d32f10145efb9$export$2e2bcd8739ae039 = $ce1d32f10145efb9$var$SvgGlyphiconsBasic203CartOut;




const $2b37f9cf2d5cca69$var$SvgGlyphiconsBasic204CartCheckout = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 26.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5Zm8.5-1.5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm4.942-14.252-2.591 1.89L23.098 16H11.114L8.965 6.18A1.5 1.5 0 0 0 7.5 5H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.292l3.243 14.82A1.5 1.5 0 0 0 11 24h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H12.208l-.438-2h12.735a1.308 1.308 0 0 0 1.216-.976l1.503-6.764a.5.5 0 0 0-.782-.512ZM12.5 9H21v2.259a.5.5 0 0 0 .795.404l5.151-3.76a.5.5 0 0 0 0-.807l-5.151-3.759a.5.5 0 0 0-.795.404V6h-8.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5Z"
        })
    });
var $2b37f9cf2d5cca69$export$2e2bcd8739ae039 = $2b37f9cf2d5cca69$var$SvgGlyphiconsBasic204CartCheckout;




const $b9cda3f9465edd1a$var$SvgGlyphiconsBasic205CartCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 26.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5ZM11.5 25a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5ZM27.171 7h-1.558a.653.653 0 0 0-.61.488L23.099 16H11.114L8.965 6.18A1.5 1.5 0 0 0 7.5 5H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.292l3.243 14.82A1.5 1.5 0 0 0 11 24h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H12.208l-.438-2h12.734a1.303 1.303 0 0 0 1.217-.976l2.233-10.048A.767.767 0 0 0 27.171 7ZM15.98 12.398a1 1 0 0 0 1.509-.028l6.706-8.005a.5.5 0 0 0-.043-.688l-1.123-1.04a.5.5 0 0 0-.67-.01L16.5 7.75l-2.388-1.52a.5.5 0 0 0-.645.093l-1.174 1.342a.5.5 0 0 0 .005.665Z"
        })
    });
var $b9cda3f9465edd1a$export$2e2bcd8739ae039 = $b9cda3f9465edd1a$var$SvgGlyphiconsBasic205CartCheck;




const $15873354000ba0f5$var$SvgGlyphiconsBasic206CircleEmptyPlay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4.007a12 12 0 1 0 12 12 12.013 12.013 0 0 0-12-12Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm4.16-8.185-5.665 3.226a1 1 0 0 1-1.495-.87v-6.451a1 1 0 0 1 1.495-.87l5.665 3.227a1 1 0 0 1 0 1.738Z"
        })
    });
var $15873354000ba0f5$export$2e2bcd8739ae039 = $15873354000ba0f5$var$SvgGlyphiconsBasic206CircleEmptyPlay;




const $05486342827b973c$var$SvgGlyphiconsBasic207CircleEmptyDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm4.81-8.43-3.989 5.746a1 1 0 0 1-1.643 0L11.19 16.57A1 1 0 0 1 12.01 15H14v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4h1.989a1 1 0 0 1 .821 1.57Z"
        })
    });
var $05486342827b973c$export$2e2bcd8739ae039 = $05486342827b973c$var$SvgGlyphiconsBasic207CircleEmptyDown;




const $c68976d089c07e0f$var$SvgGlyphiconsBasic208CircleEmptyUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm4.81-9.57A1 1 0 0 1 19.99 17H18v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4h-1.989a1 1 0 0 1-.821-1.57l3.989-5.746a1 1 0 0 1 1.643 0Z"
        })
    });
var $c68976d089c07e0f$export$2e2bcd8739ae039 = $c68976d089c07e0f$var$SvgGlyphiconsBasic208CircleEmptyUp;




const $9aa50276187279af$var$SvgGlyphiconsBasic209CircleEmptyLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm6-10v2a1 1 0 0 1-1 1h-4v1.989a1 1 0 0 1-1.57.821l-5.746-3.989a1 1 0 0 1 0-1.643l5.746-3.988a1 1 0 0 1 1.57.821V14h4a1 1 0 0 1 1 1Z"
        })
    });
var $9aa50276187279af$export$2e2bcd8739ae039 = $9aa50276187279af$var$SvgGlyphiconsBasic209CircleEmptyLeft;




const $b9844ce1e395729a$var$SvgGlyphiconsBasic21Home = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.105 17H24v10.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V17H4.895a.785.785 0 0 1-.555-1.34L15.47 4.53a.75.75 0 0 1 1.06 0l11.13 11.13a.785.785 0 0 1-.555 1.34Z"
        })
    });
var $b9844ce1e395729a$export$2e2bcd8739ae039 = $b9844ce1e395729a$var$SvgGlyphiconsBasic21Home;




const $ffd85f22d1bbfe82$var$SvgGlyphiconsBasic210CircleEmptyRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm6.316-8.178L16.57 20.81A1 1 0 0 1 15 19.99V18h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4v-1.989a1 1 0 0 1 1.57-.821l5.746 3.989a1 1 0 0 1 0 1.643Z"
        })
    });
var $ffd85f22d1bbfe82$export$2e2bcd8739ae039 = $ffd85f22d1bbfe82$var$SvgGlyphiconsBasic210CircleEmptyRight;




const $d0354ee655fb369a$var$SvgGlyphiconsBasic211ArrowDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m23.299 17.573-6.48 9.257a1 1 0 0 1-1.638 0L8.7 17.573A1 1 0 0 1 9.521 16H13V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10h3.48a1 1 0 0 1 .819 1.573Z"
        })
    });
var $d0354ee655fb369a$export$2e2bcd8739ae039 = $d0354ee655fb369a$var$SvgGlyphiconsBasic211ArrowDown;




const $89a23d644354cb7a$var$SvgGlyphiconsBasic212ArrowUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.48 16H19v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V16H9.52a1 1 0 0 1-.819-1.573l6.48-9.257a1 1 0 0 1 1.638 0l6.48 9.257a1 1 0 0 1-.82 1.573Z"
        })
    });
var $89a23d644354cb7a$export$2e2bcd8739ae039 = $89a23d644354cb7a$var$SvgGlyphiconsBasic212ArrowUp;




const $24ee13999ae3eade$var$SvgGlyphiconsBasic213ArrowLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 14v4a1 1 0 0 1-1 1H16v3.48a1 1 0 0 1-1.573.819l-9.257-6.48a1 1 0 0 1 0-1.638l9.257-6.48a1 1 0 0 1 1.573.82V13h10a1 1 0 0 1 1 1Z"
        })
    });
var $24ee13999ae3eade$export$2e2bcd8739ae039 = $24ee13999ae3eade$var$SvgGlyphiconsBasic213ArrowLeft;




const $1b32ee92c166bd97$var$SvgGlyphiconsBasic214ArrowRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.83 16.82-9.257 6.479a1 1 0 0 1-1.573-.82V19H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h10V9.52a1 1 0 0 1 1.573-.819l9.257 6.48a1 1 0 0 1 0 1.638Z"
        })
    });
var $1b32ee92c166bd97$export$2e2bcd8739ae039 = $1b32ee92c166bd97$var$SvgGlyphiconsBasic214ArrowRight;




const $7dc00110d85a655f$var$SvgGlyphiconsBasic215FullscreenOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m13.667 7.484 1.208 6.811a.5.5 0 0 1-.58.58l-6.81-1.208a.5.5 0 0 1-.267-.845l1.329-1.329-2.269-3.56a.5.5 0 0 1 .068-.623l.964-.964a.5.5 0 0 1 .623-.068l3.56 2.269 1.329-1.329a.5.5 0 0 1 .845.266Zm4.037 7.391 6.811-1.208a.5.5 0 0 0 .267-.845l-1.329-1.329 2.269-3.56a.5.5 0 0 0-.068-.623l-.964-.964a.5.5 0 0 0-.623-.068l-3.56 2.269-1.329-1.329a.5.5 0 0 0-.845.266l-1.208 6.811a.5.5 0 0 0 .58.58Zm-3.409 2.25-6.81 1.208a.5.5 0 0 0-.267.845l1.329 1.329-2.269 3.56a.5.5 0 0 0 .068.623l.964.964a.5.5 0 0 0 .623.068l3.56-2.269 1.329 1.329a.5.5 0 0 0 .845-.266l1.208-6.811a.5.5 0 0 0-.58-.58Zm9.158 3.382 1.329-1.329a.5.5 0 0 0-.267-.845l-6.81-1.208a.5.5 0 0 0-.58.58l1.208 6.81a.5.5 0 0 0 .845.267l1.329-1.329 3.56 2.269a.5.5 0 0 0 .623-.068l.964-.964a.5.5 0 0 0 .068-.623Z"
        })
    });
var $7dc00110d85a655f$export$2e2bcd8739ae039 = $7dc00110d85a655f$var$SvgGlyphiconsBasic215FullscreenOff;




const $5c9874c41e72a2e0$var$SvgGlyphiconsBasic216Fullscreen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.722 12.067a.5.5 0 0 1-.069.623l-.963.963a.5.5 0 0 1-.622.068l-4.172-2.657-1.703 1.702a.5.5 0 0 1-.847-.275L4.108 4.68a.5.5 0 0 1 .572-.572l7.811 1.238a.5.5 0 0 1 .275.848l-1.702 1.702Zm5.588 1.586a.5.5 0 0 0 .622.068l4.172-2.657 1.703 1.702a.5.5 0 0 0 .847-.275l1.238-7.811a.5.5 0 0 0-.572-.572L19.51 5.346a.5.5 0 0 0-.275.848l1.702 1.702-2.658 4.171a.5.5 0 0 0 .069.623Zm-6.62 4.694a.5.5 0 0 0-.623-.068l-4.17 2.657-1.704-1.702a.5.5 0 0 0-.847.275L4.108 27.32a.5.5 0 0 0 .572.572l7.811-1.238a.5.5 0 0 0 .275-.848l-1.702-1.702 2.658-4.171a.5.5 0 0 0-.069-.623Zm13.117.887-1.703 1.702-4.171-2.657a.5.5 0 0 0-.623.068l-.963.963a.5.5 0 0 0-.069.623l2.658 4.171-1.702 1.702a.5.5 0 0 0 .275.848l7.811 1.238a.5.5 0 0 0 .572-.572l-1.238-7.811a.5.5 0 0 0-.847-.275Z"
        })
    });
var $5c9874c41e72a2e0$export$2e2bcd8739ae039 = $5c9874c41e72a2e0$var$SvgGlyphiconsBasic216Fullscreen;




const $7b2e231ff5d06c3e$var$SvgGlyphiconsBasic217Lock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 12h-1V9a5.006 5.006 0 0 0-5-5h-6a5.006 5.006 0 0 0-5 5v3H7a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V14a2.006 2.006 0 0 0-2-2Zm-8 8.723V23.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2.777a2 2 0 1 1 2 0ZM20 12h-8V9a1.013 1.013 0 0 1 1-1h6a1.013 1.013 0 0 1 1 1Z"
        })
    });
var $7b2e231ff5d06c3e$export$2e2bcd8739ae039 = $7b2e231ff5d06c3e$var$SvgGlyphiconsBasic217Lock;




const $5ae32b7492e3d468$var$SvgGlyphiconsBasic218LockOpen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 12h-1V5a5.006 5.006 0 0 0-5-5h-6a5.006 5.006 0 0 0-5 5v2h4V5a1.013 1.013 0 0 1 1-1h6a1.013 1.013 0 0 1 1 1v7H7a2.006 2.006 0 0 0-2 2v12a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V14a2.006 2.006 0 0 0-2-2Zm-8 8.723V23.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2.777a2 2 0 1 1 2 0Z"
        })
    });
var $5ae32b7492e3d468$export$2e2bcd8739ae039 = $5ae32b7492e3d468$var$SvgGlyphiconsBasic218LockOpen;




const $b1a61cbb96347d77$var$SvgGlyphiconsBasic219Coins = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.5 10.916a8.584 8.584 0 1 0 8.583 8.584 8.593 8.593 0 0 0-8.583-8.584Zm0 14.167a5.583 5.583 0 1 1 5.583-5.583 5.59 5.59 0 0 1-5.583 5.584ZM10.025 20a10.423 10.423 0 0 0 .588 3H6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1ZM6 10h10.057a10.55 10.55 0 0 0-3.787 3H6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1Zm-2 8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h7.028a10.4 10.4 0 0 0-.908 3Zm10.36 10H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6.573a10.566 10.566 0 0 0 2.787 3ZM4 7V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z"
        })
    });
var $b1a61cbb96347d77$export$2e2bcd8739ae039 = $b1a61cbb96347d77$var$SvgGlyphiconsBasic219Coins;




const $68c2cd419f0d853f$var$SvgGlyphiconsBasic22Snowflake = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.19 19.38a.5.5 0 0 1-.248.661l-2.484 1.13.263 2.718a.5.5 0 0 1-.45.546l-1.99.193a.5.5 0 0 1-.546-.45l-.292-3.015L17 18.598v5.13l2.465 1.76a.5.5 0 0 1 .116.698l-1.162 1.628a.5.5 0 0 1-.698.116L15.5 26.343l-2.221 1.587a.5.5 0 0 1-.698-.116l-1.162-1.628a.5.5 0 0 1 .116-.697L14 23.728v-5.13l-4.443 2.565-.292 3.015a.5.5 0 0 1-.546.45l-1.99-.193a.5.5 0 0 1-.45-.546l.263-2.717-2.484-1.13a.5.5 0 0 1-.248-.663l.828-1.82a.5.5 0 0 1 .662-.248l2.757 1.254L12.5 16l-4.443-2.565L5.3 14.689a.5.5 0 0 1-.662-.248l-.828-1.82a.5.5 0 0 1 .248-.662l2.484-1.13L6.28 8.11a.5.5 0 0 1 .45-.545l1.99-.194a.5.5 0 0 1 .546.45l.292 3.015L14 13.402v-5.13l-2.465-1.76a.5.5 0 0 1-.116-.698l1.162-1.628a.5.5 0 0 1 .698-.116L15.5 5.657l2.221-1.587a.5.5 0 0 1 .698.116l1.162 1.628a.5.5 0 0 1-.116.697L17 8.272v5.13l4.443-2.565.292-3.015a.5.5 0 0 1 .546-.45l1.99.193a.5.5 0 0 1 .45.546l-.263 2.717 2.484 1.13a.5.5 0 0 1 .248.663l-.828 1.82a.5.5 0 0 1-.662.248l-2.757-1.254L18.5 16l4.443 2.565 2.757-1.254a.5.5 0 0 1 .662.248Z"
        })
    });
var $68c2cd419f0d853f$export$2e2bcd8739ae039 = $68c2cd419f0d853f$var$SvgGlyphiconsBasic22Snowflake;




const $124da0bf5b3adda6$var$SvgGlyphiconsBasic220Banknotes = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.463 25.674 7.26 30.48a.987.987 0 0 1-.342.061 1 1 0 0 1-.94-.658l-.723-1.989c.016 0 .031.004.048.004a3.034 3.034 0 0 0 .523-.045l1.449-.256.24.662 3.756-1.367 9.09-1.602a.2.2 0 0 1 .103.384Zm-14.985.21 14.1-2.487a.2.2 0 0 0-.035-.397H10.31l-4.196.74-.13-.74H4c-.016 0-.03-.005-.047-.005l.366 2.077a1 1 0 0 0 .984.826 1.015 1.015 0 0 0 .175-.015ZM19 13.5a3.5 3.5 0 1 1-3.5-3.5 3.5 3.5 0 0 1 3.5 3.5Zm-2 0a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5Zm11-6.627v13.254a.873.873 0 0 1-.873.873H3.873A.873.873 0 0 1 3 20.127V6.873A.873.873 0 0 1 3.873 6h23.254a.873.873 0 0 1 .873.873ZM5 9.99a1.788 1.788 0 0 0 .182.009 2.005 2.005 0 0 0 .49-.063 1.791 1.791 0 0 0 1.264-1.263A1.932 1.932 0 0 0 6.991 8H5Zm1.937 8.336a1.791 1.791 0 0 0-1.263-1.263A2.005 2.005 0 0 0 5.182 17a1.789 1.789 0 0 0-.182.01V19h1.991a1.934 1.934 0 0 0-.054-.673ZM26 17.01a1.788 1.788 0 0 0-.182-.009 2.005 2.005 0 0 0-.49.063 1.791 1.791 0 0 0-1.264 1.263 1.932 1.932 0 0 0-.055.674H26Zm0-5.023c-.061.003-.12.014-.182.014a3.993 3.993 0 0 1-.984-.125 3.792 3.792 0 0 1-2.71-2.711A3.89 3.89 0 0 1 22.025 8H8.975a3.889 3.889 0 0 1-.1 1.166 3.792 3.792 0 0 1-2.711 2.71 3.995 3.995 0 0 1-.982.124c-.062 0-.12-.011-.182-.014v3.028c.061-.003.12-.014.182-.014a3.992 3.992 0 0 1 .984.125 3.792 3.792 0 0 1 2.71 2.711A3.89 3.89 0 0 1 8.975 19h13.05a3.889 3.889 0 0 1 .1-1.166 3.792 3.792 0 0 1 2.711-2.71 3.995 3.995 0 0 1 .982-.124c.062 0 .12.011.182.014ZM26 8h-1.991a1.934 1.934 0 0 0 .054.673 1.791 1.791 0 0 0 1.263 1.263 2.003 2.003 0 0 0 .492.064A1.786 1.786 0 0 0 26 9.99Z"
        })
    });
var $124da0bf5b3adda6$export$2e2bcd8739ae039 = $124da0bf5b3adda6$var$SvgGlyphiconsBasic220Banknotes;




const $67a6d83111ae6b32$var$SvgGlyphiconsBasic221ChevronDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.914 13.121 16.707 23.328a1 1 0 0 1-1.414 0L5.086 13.121a.5.5 0 0 1 0-.707l2.828-2.828a.5.5 0 0 1 .707 0L16 16.964l7.379-7.378a.5.5 0 0 1 .707 0l2.828 2.828a.5.5 0 0 1 0 .707Z"
        })
    });
var $67a6d83111ae6b32$export$2e2bcd8739ae039 = $67a6d83111ae6b32$var$SvgGlyphiconsBasic221ChevronDown;




const $c934f91559a45195$var$SvgGlyphiconsBasic222ChevronUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.914 19.586-2.828 2.828a.5.5 0 0 1-.707 0L16 15.036l-7.379 7.378a.5.5 0 0 1-.707 0l-2.828-2.828a.5.5 0 0 1 0-.707L15.293 8.672a1 1 0 0 1 1.414 0l10.207 10.207a.5.5 0 0 1 0 .707Z"
        })
    });
var $c934f91559a45195$export$2e2bcd8739ae039 = $c934f91559a45195$var$SvgGlyphiconsBasic222ChevronUp;




const $c459c47c63a8f2ea$var$SvgGlyphiconsBasic223ChevronLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.414 23.379a.5.5 0 0 1 0 .707l-2.828 2.828a.5.5 0 0 1-.707 0L8.672 16.707a1 1 0 0 1 0-1.414L18.879 5.086a.5.5 0 0 1 .707 0l2.828 2.828a.5.5 0 0 1 0 .707L15.036 16Z"
        })
    });
var $c459c47c63a8f2ea$export$2e2bcd8739ae039 = $c459c47c63a8f2ea$var$SvgGlyphiconsBasic223ChevronLeft;




const $843b93157390ca20$var$SvgGlyphiconsBasic224ChevronRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.328 16.707 13.121 26.914a.5.5 0 0 1-.707 0l-2.828-2.828a.5.5 0 0 1 0-.707L16.964 16 9.586 8.621a.5.5 0 0 1 0-.707l2.828-2.828a.5.5 0 0 1 .707 0l10.207 10.207a1 1 0 0 1 0 1.414Z"
        })
    });
var $843b93157390ca20$export$2e2bcd8739ae039 = $843b93157390ca20$var$SvgGlyphiconsBasic224ChevronRight;




const $0218feebc4384bd8$var$SvgGlyphiconsBasic225Bitcoin = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.897 15.475A5.827 5.827 0 0 0 24 12a5.792 5.792 0 0 0-4-5.585V4.977a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1V6h-3V4.977a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1V6H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v14H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h3v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.146A5.878 5.878 0 0 0 25 20a5.734 5.734 0 0 0-2.103-4.525ZM14 10h3.5c.417 0 2.5.096 2.5 2s-2.083 2-2.5 2H14Zm4.5 12H14v-4h4.5c.417 0 2.5.096 2.5 2s-2.083 2-2.5 2Z"
        })
    });
var $0218feebc4384bd8$export$2e2bcd8739ae039 = $0218feebc4384bd8$var$SvgGlyphiconsBasic225Bitcoin;




const $ad09770d5fdfe35a$var$SvgGlyphiconsBasic226Euro = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 10V9h-2.3a6.993 6.993 0 0 0-5.736 3H19a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-7.22a6.299 6.299 0 0 0 0 2H19a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6.036a6.993 6.993 0 0 0 5.736 3H21v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4.3a11.01 11.01 0 0 1-10.236-7H7a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.75c-.03-.33-.05-.662-.05-1s.02-.67.05-1H7a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1.464A11.01 11.01 0 0 1 18.7 5H23a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1Z"
        })
    });
var $ad09770d5fdfe35a$export$2e2bcd8739ae039 = $ad09770d5fdfe35a$var$SvgGlyphiconsBasic226Euro;




const $cd85ba76c1516e84$var$SvgGlyphiconsBasic227Dollar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.997 20.417c-.248 4.482-3.413 5.364-5.998 5.538V27a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H10a1 1 0 0 1-1-1v-3.983a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1V22h3.25c3.653 0 3.683-.528 3.753-1.805.086-1.548.11-1.965-3.066-2.503-2.501-.422-6.687-1.131-6.687-5.929 0-4.051 2.601-5.25 4.75-5.608V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h3.5v.017h.5a1 1 0 0 1 1 1V11a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1h-2.75c-3 0-3 .664-3 1.763 0 1.003 0 1.418 3.354 1.986 4.022.681 6.648 2.076 6.393 6.668Z"
        })
    });
var $cd85ba76c1516e84$export$2e2bcd8739ae039 = $cd85ba76c1516e84$var$SvgGlyphiconsBasic227Dollar;




const $30cda53062431f93$var$SvgGlyphiconsBasic228Pound = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 22v4a1 1 0 0 1-1 1H10a2 2 0 0 1-1.677-3.09c.88-1.36 2.277-4.168 2.277-5.91H8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1.475a7.044 7.044 0 0 1-.609-3c0-4.252 2.97-7 7.568-7h5.565a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V9h-3.565c-3.568 0-3.568 2.18-3.568 3a3.27 3.27 0 0 0 .599 2 11.007 11.007 0 0 1 .526 1H17a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2.4a13.051 13.051 0 0 1-1.268 5H20v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z"
        })
    });
var $30cda53062431f93$export$2e2bcd8739ae039 = $30cda53062431f93$var$SvgGlyphiconsBasic228Pound;




const $99618be16976742a$var$SvgGlyphiconsBasic229Yen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 6v1a1 1 0 0 1-1 1h-1.408l-3.576 6H22a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-3.772l-.228.383V19h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4v2h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-2h-4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h4v-1.617L13.772 17H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1.984L8.408 8H7a1 1 0 0 1-1-1V6a.993.993 0 0 1 .66-.932L6.62 5H13a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1l3 5.056L19 8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6.38l-.04.068A.993.993 0 0 1 26 6Z"
        })
    });
var $99618be16976742a$export$2e2bcd8739ae039 = $99618be16976742a$var$SvgGlyphiconsBasic229Yen;




const $cbebe2d8b94a9623$var$SvgGlyphiconsBasic23Fire = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.993 27.217a.496.496 0 0 1-.583-.752c.537-.745 1.797-2.854 1.797-4.12 0-2.345-1.921-3.178-2.518-5.464a.248.248 0 0 0-.471-.033c-1.287 2.945-3.941 3.734-4.986 5.81a4.428 4.428 0 0 0 .015 3.744.503.503 0 0 1-.565.788 8.25 8.25 0 0 1-5.479-7.624c0-3.483 2.695-5.325 2.023-8.93a.252.252 0 0 1 .361-.276 5.789 5.789 0 0 1 2.695 5.513.498.498 0 0 0 .833.445c3.217-3.28.738-8.08 5.024-11.767a.248.248 0 0 1 .412.226c-.873 4.631 5.715 8.733 6.23 14.424a7.975 7.975 0 0 1-4.788 8.016Z"
        })
    });
var $cbebe2d8b94a9623$export$2e2bcd8739ae039 = $cbebe2d8b94a9623$var$SvgGlyphiconsBasic23Fire;




const $a88eb73fb393ce46$var$SvgGlyphiconsBasic230Ruble = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18.5 17a5.803 5.803 0 0 0 6-6 5.803 5.803 0 0 0-6-6H10a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v6h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v2h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v2h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1v-2h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-6v-2ZM15 9h3.5a1.858 1.858 0 0 1 2 2 1.858 1.858 0 0 1-2 2H15Z"
        })
    });
var $a88eb73fb393ce46$export$2e2bcd8739ae039 = $a88eb73fb393ce46$var$SvgGlyphiconsBasic230Ruble;




const $9ce20de1fa01d156$var$SvgGlyphiconsBasic231Moon = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.296 20.868a1.048 1.048 0 0 0-.153.012A11.29 11.29 0 0 1 23.5 21a11.448 11.448 0 0 1-2.26-.227 11.567 11.567 0 0 1-9.096-9.448 11.447 11.447 0 0 1 .324-5.058 1.01 1.01 0 0 0-.95-1.302.988.988 0 0 0-.404.088 11.992 11.992 0 0 0 4.051 22.918c.28.02.56.029.835.029a11.985 11.985 0 0 0 10.149-5.621.994.994 0 0 0-.853-1.51ZM16 25c-.208 0-.42-.007-.63-.022a8.986 8.986 0 0 1-6.347-14.645q.043.728.158 1.46a14.537 14.537 0 0 0 11.455 11.919A8.934 8.934 0 0 1 16 25Z"
        })
    });
var $9ce20de1fa01d156$export$2e2bcd8739ae039 = $9ce20de1fa01d156$var$SvgGlyphiconsBasic231Moon;




const $53c5da3ed080fcf3$var$SvgGlyphiconsBasic232Sun = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6.308 8.429a1.5 1.5 0 0 1 2.121-2.121l1.505 1.505a9.54 9.54 0 0 0-2.121 2.121ZM17 6.129V4a1.5 1.5 0 0 0-3 0v2.13a8.735 8.735 0 0 1 3 0ZM6 15.5a9.521 9.521 0 0 1 .13-1.5H4a1.5 1.5 0 0 0 0 3h2.13A9.521 9.521 0 0 1 6 15.5Zm17.187-5.566 1.505-1.505a1.5 1.5 0 0 0-2.121-2.121l-1.505 1.505a9.54 9.54 0 0 1 2.121 2.121ZM27 14h-2.13a8.735 8.735 0 0 1 0 3H27a1.5 1.5 0 0 0 0-3ZM7.813 21.066l-1.505 1.505a1.5 1.5 0 0 0 2.121 2.121l1.505-1.505a9.54 9.54 0 0 1-2.121-2.121Zm15.374 0a9.54 9.54 0 0 1-2.121 2.121l1.505 1.505a1.5 1.5 0 0 0 2.121-2.121ZM14 24.87V27a1.5 1.5 0 0 0 3 0v-2.13a8.735 8.735 0 0 1-3 0Zm9-9.37A7.5 7.5 0 1 1 15.5 8a7.508 7.508 0 0 1 7.5 7.5Zm-3 0a4.5 4.5 0 1 0-4.5 4.5 4.505 4.505 0 0 0 4.5-4.5Z"
        })
    });
var $53c5da3ed080fcf3$export$2e2bcd8739ae039 = $53c5da3ed080fcf3$var$SvgGlyphiconsBasic232Sun;




const $177fb6ab5526941c$var$SvgGlyphiconsBasic233Lasso = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.747 10.128A8.168 8.168 0 0 0 22.4 4.704a14.594 14.594 0 0 0-8.8-.248 14.585 14.585 0 0 0-7.496 4.615 8.167 8.167 0 0 0-1.92 7.371 7.725 7.725 0 0 0 3.832 4.706 3.982 3.982 0 0 0 6.753 2.728 3.352 3.352 0 0 1 1.385 1.344 1.778 1.778 0 0 1 .005 1.61 1.5 1.5 0 1 0 2.684 1.34 4.783 4.783 0 0 0 .007-4.269 5.667 5.667 0 0 0-1.21-1.624c.23-.052.462-.1.693-.162a14.585 14.585 0 0 0 7.496-4.616 8.166 8.166 0 0 0 1.92-7.37ZM12 22a1 1 0 1 1 1-1 1.001 1.001 0 0 1-1 1Zm11.512-6.407a11.578 11.578 0 0 1-5.956 3.624 13.602 13.602 0 0 1-1.83.358 3.974 3.974 0 0 0-6.647-1.288 4.631 4.631 0 0 1-1.997-2.621 5.265 5.265 0 0 1 1.337-4.688 11.57 11.57 0 0 1 5.957-3.624 13.076 13.076 0 0 1 3.375-.457 10.268 10.268 0 0 1 3.596.616 5.267 5.267 0 0 1 3.502 3.392 5.265 5.265 0 0 1-1.337 4.688Z"
        })
    });
var $177fb6ab5526941c$export$2e2bcd8739ae039 = $177fb6ab5526941c$var$SvgGlyphiconsBasic233Lasso;




const $1005fdd2e8b00969$var$SvgGlyphiconsBasic234Calculator = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 4H8a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM10.5 26a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm5 10a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm5 10a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm1.5-5.5a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5Z"
        })
    });
var $1005fdd2e8b00969$export$2e2bcd8739ae039 = $1005fdd2e8b00969$var$SvgGlyphiconsBasic234Calculator;




const $cf327f5b66cbd318$var$SvgGlyphiconsBasic235ChatConversation = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 13.5v7a3.505 3.505 0 0 1-3 3.464V26.5a1.934 1.934 0 0 1-1.133 1.886 1.733 1.733 0 0 1-.665.133 2.094 2.094 0 0 1-1.47-.665L17.88 24H12.5a3.455 3.455 0 0 1-.5-.05L14.95 21h4.171L22 23.879V21h2.5a.506.506 0 0 0 .5-.5V10.05a3.495 3.495 0 0 1 3 3.45ZM14.121 19l-3.853 3.854a2.094 2.094 0 0 1-1.47.665 1.733 1.733 0 0 1-.665-.133A1.934 1.934 0 0 1 7 21.5v-2.536A3.505 3.505 0 0 1 4 15.5v-7A3.504 3.504 0 0 1 7.5 5h12A3.504 3.504 0 0 1 23 8.5v7a3.504 3.504 0 0 1-3.5 3.5Zm-1.242-3H19.5a.506.506 0 0 0 .5-.5v-7a.506.506 0 0 0-.5-.5h-12a.506.506 0 0 0-.5.5v7a.506.506 0 0 0 .5.5H10v2.879Z"
        })
    });
var $cf327f5b66cbd318$export$2e2bcd8739ae039 = $cf327f5b66cbd318$var$SvgGlyphiconsBasic235ChatConversation;




const $feb29b230e2b2357$var$SvgGlyphiconsBasic236ChatConversationOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 2.94a1.5 1.5 0 0 0-2.121 0l-3.105 3.104A3.487 3.487 0 0 0 19.5 5h-12A3.504 3.504 0 0 0 4 8.5v7a3.505 3.505 0 0 0 3 3.464v2.069l-4.06 4.06a1.5 1.5 0 1 0 2.12 2.121L27.216 5.061a1.5 1.5 0 0 0 0-2.122ZM10 18.032V16H7.5a.506.506 0 0 1-.5-.5v-7a.506.506 0 0 1 .5-.5h12a.495.495 0 0 1 .365.168ZM28 13.5v7a3.505 3.505 0 0 1-3 3.464V26.5a1.934 1.934 0 0 1-1.133 1.886 1.733 1.733 0 0 1-.665.133 2.094 2.094 0 0 1-1.47-.665L17.88 24H12.5a3.324 3.324 0 0 1-.484-.049L14.967 21h4.154L22 23.879V21h2.5a.506.506 0 0 0 .5-.5v-9.533l.723-.723A3.481 3.481 0 0 1 28 13.5ZM19.5 19h-2.533L23 12.967V15.5a3.504 3.504 0 0 1-3.5 3.5Z"
        })
    });
var $feb29b230e2b2357$export$2e2bcd8739ae039 = $feb29b230e2b2357$var$SvgGlyphiconsBasic236ChatConversationOff;




const $79b74cb591073f00$var$SvgGlyphiconsBasic237ChatConversationLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m14.121 19-3.853 3.854a2.094 2.094 0 0 1-1.47.665 1.733 1.733 0 0 1-.665-.133A1.934 1.934 0 0 1 7 21.5v-2.536A3.505 3.505 0 0 1 4 15.5v-7A3.504 3.504 0 0 1 7.5 5H19v3H7.5a.506.506 0 0 0-.5.5v7a.506.506 0 0 0 .5.5H10v2.879L12.879 16H19.5a.506.506 0 0 0 .5-.5v-2.28a2.977 2.977 0 0 0 2 .78h1v1.5a3.504 3.504 0 0 1-3.5 3.5ZM25 20.5a.506.506 0 0 1-.5.5H22v2.879L19.121 21H14.95L12 23.95a3.455 3.455 0 0 0 .5.05h5.379l3.853 3.854a2.094 2.094 0 0 0 1.47.665 1.733 1.733 0 0 0 .665-.133A1.934 1.934 0 0 0 25 26.5v-2.536a3.505 3.505 0 0 0 3-3.464V14h-3ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $79b74cb591073f00$export$2e2bcd8739ae039 = $79b74cb591073f00$var$SvgGlyphiconsBasic237ChatConversationLock;




const $629c8c1f40441674$var$SvgGlyphiconsBasic238ChatMessage = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 5h-17A3.504 3.504 0 0 0 4 8.5v11A3.504 3.504 0 0 0 7.5 23H9v3.5a1.934 1.934 0 0 0 1.133 1.886 1.733 1.733 0 0 0 .665.133 2.094 2.094 0 0 0 1.47-.665L17.12 23H24.5a3.504 3.504 0 0 0 3.5-3.5v-11A3.504 3.504 0 0 0 24.5 5Zm.5 14.5a.506.506 0 0 1-.5.5h-8.621L12 23.879V20H7.5a.506.506 0 0 1-.5-.5v-11a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5Z"
        })
    });
var $629c8c1f40441674$export$2e2bcd8739ae039 = $629c8c1f40441674$var$SvgGlyphiconsBasic238ChatMessage;




const $65a3b3ce586b782a$var$SvgGlyphiconsBasic239ChatMessageLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 14h3v5.5a3.504 3.504 0 0 1-3.5 3.5h-7.379l-4.853 4.854a2.094 2.094 0 0 1-1.47.665 1.733 1.733 0 0 1-.665-.133A1.934 1.934 0 0 1 9 26.5V23H7.5A3.504 3.504 0 0 1 4 19.5v-11A3.504 3.504 0 0 1 7.5 5H19v3H7.5a.506.506 0 0 0-.5.5v11a.506.506 0 0 0 .5.5H12v3.879L15.879 20H24.5a.506.506 0 0 0 .5-.5Zm7-9v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $65a3b3ce586b782a$export$2e2bcd8739ae039 = $65a3b3ce586b782a$var$SvgGlyphiconsBasic239ChatMessageLock;




const $33c1a9361bbad51b$var$SvgGlyphiconsBasic24Magnet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 11h5v7.5a8.51 8.51 0 0 1-8.5 8.5h-1A8.51 8.51 0 0 1 7 18.5V11h5v7.5a3.504 3.504 0 0 0 3.5 3.5h1a3.504 3.504 0 0 0 3.5-3.5Zm-8-5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3h5Zm12-1h-3a1 1 0 0 0-1 1v3h5V6a1 1 0 0 0-1-1Z"
        })
    });
var $33c1a9361bbad51b$export$2e2bcd8739ae039 = $33c1a9361bbad51b$var$SvgGlyphiconsBasic24Magnet;




const $254162daf480a9e5$var$SvgGlyphiconsBasic240ChatMessageCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.96 7.96 0 0 0 2-.263V19.5a3.504 3.504 0 0 1-3.5 3.5h-7.379l-4.853 4.854a2.094 2.094 0 0 1-1.47.665 1.733 1.733 0 0 1-.665-.133A1.934 1.934 0 0 1 9 26.5V23H7.5A3.504 3.504 0 0 1 4 19.5v-11A3.504 3.504 0 0 1 7.5 5h10.57A8.009 8.009 0 0 0 18 6a7.96 7.96 0 0 0 .263 2H7.5a.506.506 0 0 0-.5.5v11a.506.506 0 0 0 .5.5H12v3.879L15.879 20H24.5a.506.506 0 0 0 .5-.5v-5.57a8.009 8.009 0 0 0 1 .07Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-2.852-2.234-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.096l-.433.554a.297.297 0 0 0 .027.377l2.233 2.236a.83.83 0 0 0 1.298-.1L29.2 4.118a.254.254 0 0 0-.052-.352Z"
        })
    });
var $254162daf480a9e5$export$2e2bcd8739ae039 = $254162daf480a9e5$var$SvgGlyphiconsBasic240ChatMessageCheck;




const $53ab0752e4b4a0e3$var$SvgGlyphiconsBasic241Brush = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.256 23.17a2.806 2.806 0 0 1-.743 3.195C12.157 27.722 10.227 28 7.5 28h-4c-.524 0-1 .013-1-.5s1.24-.703 2.414-2.076c1.849-2.16 1.27-5.3 6.117-5.455l.01-.014Zm15.23-17.948-.708-.707a1.124 1.124 0 0 0-1.478-.07L14.882 14.716a8.204 8.204 0 0 0-1.326 1.47l-1.383 2.073 3.568 3.568 2.074-1.383a8.204 8.204 0 0 0 1.469-1.326L29.555 6.7a1.124 1.124 0 0 0-.07-1.478Z"
        })
    });
var $53ab0752e4b4a0e3$export$2e2bcd8739ae039 = $53ab0752e4b4a0e3$var$SvgGlyphiconsBasic241Brush;




const $7a6e56f925747165$var$SvgGlyphiconsBasic242Marker = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m8.344 19.258 4.397 4.397a24.257 24.257 0 0 1-5.285 3.558l-.628-.627-1.121 1.121a1 1 0 0 1-1.414-1.414l1.121-1.121-.628-.629a24.249 24.249 0 0 1 3.558-5.285ZM27.423 6.283l-1.707-1.707a2 2 0 0 0-2.829 0l-.899.9-.4-.401a3.005 3.005 0 0 0-4.243 0l-5.823 5.823a1 1 0 1 0 1.414 1.415l5.823-5.823a1.002 1.002 0 0 1 1.415 0l.4.4L9.689 17.774l4.535 4.535L27.423 9.112a2 2 0 0 0 0-2.829Z"
        })
    });
var $7a6e56f925747165$export$2e2bcd8739ae039 = $7a6e56f925747165$var$SvgGlyphiconsBasic242Marker;




const $89953d913ce4b61a$var$SvgGlyphiconsBasic243Pen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m12.466 11.265 8.269 8.269-3.316 6.157a1.071 1.071 0 0 1-.734.496l-10.64 1.182 6.383-6.383a2 2 0 1 0-1.414-1.414l-6.383 6.383 1.182-10.64a1.071 1.071 0 0 1 .495-.734Zm2.97-3.531a1.461 1.461 0 0 0-1.786 1.887l8.73 8.729a1.461 1.461 0 0 0 1.886-1.785Zm11.938 2.548-5.656-5.656a1 1 0 0 0-1.415 0L17.73 7.2l7.071 7.07 2.574-2.573a1 1 0 0 0 0-1.415Z"
        })
    });
var $89953d913ce4b61a$export$2e2bcd8739ae039 = $89953d913ce4b61a$var$SvgGlyphiconsBasic243Pen;




const $8d6f38ee0a4f3914$var$SvgGlyphiconsBasic244Spray = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17 13H6l3-3h5Zm-4-6.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5V8h3ZM5 27a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V15H5ZM30 7a3.493 3.493 0 0 0-2.033-3.168A2.474 2.474 0 0 0 28 3.5a2.5 2.5 0 0 0-5 0 2.454 2.454 0 0 0 .025.247l-6.58 2.31a1 1 0 0 0 0 1.886l6.58 2.31A2.454 2.454 0 0 0 23 10.5a2.5 2.5 0 0 0 5 0 2.474 2.474 0 0 0-.033-.332A3.493 3.493 0 0 0 30 7Z"
        })
    });
var $8d6f38ee0a4f3914$export$2e2bcd8739ae039 = $8d6f38ee0a4f3914$var$SvgGlyphiconsBasic244Spray;




const $e0e2f3b270cc326d$var$SvgGlyphiconsBasic245Fill = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.526 20.833h-3.36l-6.14 6.142a3.5 3.5 0 0 1-4.95 0l-6.05-6.05a3.5 3.5 0 0 1 0-4.95l7.717-7.718a.975.975 0 0 1 .257-.17v6.969a3 3 0 1 0 6 0V13.1l6.88 6.879a.5.5 0 0 1-.354.853Zm1.417 1.47a.496.496 0 0 0-.886 0c-.87 1.702-1.986 2.899-1.986 4.22a2.43 2.43 0 1 0 4.858 0c0-1.321-1.116-2.518-1.986-4.22ZM10 7.5a2.5 2.5 0 0 1 5 0V15a1 1 0 0 0 2 0V7.5a4.5 4.5 0 0 0-9 0v2.672l2-2Z"
        })
    });
var $e0e2f3b270cc326d$export$2e2bcd8739ae039 = $e0e2f3b270cc326d$var$SvgGlyphiconsBasic245Fill;




const $b7a491506f29156d$var$SvgGlyphiconsBasic246Clean = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m7.551 23.72-1.226.605-.604 1.226c-.122.248-.32.248-.442 0l-.604-1.226-1.226-.604c-.248-.122-.248-.32 0-.442l1.226-.604.604-1.226c.122-.248.32-.248.442 0l.604 1.226 1.226.604c.248.122.248.32 0 .442ZM27 18a3.009 3.009 0 0 0-3-3h-2V4h-4v11h-2a3.009 3.009 0 0 0-3 3v1h14Zm-16.564-.915-1.795-.726-.726-1.795c-.223-.55-.586-.55-.809 0l-.726 1.795-1.795.726c-.55.223-.55.586 0 .809l1.795.726.726 1.795c.223.55.586.55.809 0l.726-1.795 1.795-.726c.55-.223.55-.586 0-.809ZM27 21H13l-2.701 6.303a.5.5 0 0 0 .46.697h1.439a1 1 0 0 0 .919-.606L15 23v4a1 1 0 0 0 1 1h11.424a.5.5 0 0 0 .494-.57Z"
        })
    });
var $b7a491506f29156d$export$2e2bcd8739ae039 = $b7a491506f29156d$var$SvgGlyphiconsBasic246Clean;




const $1dc65d8e1baba6fc$var$SvgGlyphiconsBasic247DropOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06 5.06 27.215a1.5 1.5 0 0 1-2.122-2.12l4.456-4.456A7.657 7.657 0 0 1 7.2 19c0-4.598 4.443-7.922 7.394-13.93a1.003 1.003 0 0 1 1.812 0 33.795 33.795 0 0 0 2.442 4.115l6.246-6.246a1.5 1.5 0 0 1 2.12 2.122Zm-16.66 20.353A8.504 8.504 0 0 0 15.5 27a8.151 8.151 0 0 0 8.3-8 9.688 9.688 0 0 0-1.726-5.107Z"
        })
    });
var $1dc65d8e1baba6fc$export$2e2bcd8739ae039 = $1dc65d8e1baba6fc$var$SvgGlyphiconsBasic247DropOff;




const $dc391b78fda35762$var$SvgGlyphiconsBasic248Palette = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m31.007 14.217-5.385 6.93a8.2 8.2 0 0 1-1.469 1.325l-1.135.757-2.747-2.747.757-1.135a8.207 8.207 0 0 1 1.326-1.47l6.929-5.384a1.124 1.124 0 0 1 1.477.07l.177.177a1.124 1.124 0 0 1 .07 1.477ZM18.961 22c-3.287.244-2.931 2.498-4.275 4.068-.882 1.03-1.811 1.173-1.811 1.557s.357.375.75.375h3c2.045 0 3.493-.208 4.51-1.226a2.147 2.147 0 0 0 .696-1.904Zm-5.795 2.769a3.19 3.19 0 0 1-.826.655 2.699 2.699 0 0 0-1.432 1.852 11.523 11.523 0 0 1-2.862-1.49 12.005 12.005 0 0 1 12.14-20.611 4.503 4.503 0 0 1 1.227 7.233l-3.054 3.06a1.753 1.753 0 0 0 0 2.477 1.802 1.802 0 0 0 .885.472l-1.114 1.67a5.404 5.404 0 0 0-4.35 3.585 4.883 4.883 0 0 1-.614 1.097Zm1.127-15.133a2 2 0 1 0 0-2.828 2 2 0 0 0 0 2.828Zm-6.364 2.121a2 2 0 1 0 0-2.828 2 2 0 0 0 0 2.828Zm.707 6.364a2 2 0 1 0-2.828 0 2 2 0 0 0 2.828 0Zm2.829 2.829a2 2 0 1 0 0 2.828 2 2 0 0 0 0-2.828Z"
        })
    });
var $dc391b78fda35762$export$2e2bcd8739ae039 = $dc391b78fda35762$var$SvgGlyphiconsBasic248Palette;




const $bbfaf4acd1efde47$var$SvgGlyphiconsBasic249Diamond = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.754 11.349-5.238-6.006a.986.986 0 0 0-.296-.222.954.954 0 0 0-.084-.038 1 1 0 0 0-.367-.081H10.23a1 1 0 0 0-.367.08.968.968 0 0 0-.084.04.986.986 0 0 0-.296.22L4.246 11.35a1.235 1.235 0 0 0-.239.683.851.851 0 0 0 .187.567l11 14.946a1 1 0 0 0 1.612 0l11-14.946a.78.78 0 0 0 .187-.56 1.204 1.204 0 0 0-.24-.69Zm-5.467-2.543.1-.568 2.414 2.768h-2.897ZM20.572 7l-.367 2.101-.09.521L18.055 7Zm-1.915 4.006h-5.314L16 7.62ZM13.944 7l-2.058 2.622-.091-.521L11.428 7Zm-4.33 1.238.099.568.383 2.2H7.2Zm-2.636 4.768h3.575l2.681 8.5ZM16 23.626l-3.35-10.62h6.7Zm2.766-2.12 2.681-8.5h3.575Z"
        })
    });
var $bbfaf4acd1efde47$export$2e2bcd8739ae039 = $bbfaf4acd1efde47$var$SvgGlyphiconsBasic249Diamond;




const $a5c9013d9903a040$var$SvgGlyphiconsBasic25UserParents = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.17 24.678a2.157 2.157 0 0 1 .83 1.559V27.5a.5.5 0 0 1-.5.5h-7.55a2.5 2.5 0 0 0 .05-.5v-1.263a3.487 3.487 0 0 0-.78-2.352 4.268 4.268 0 0 0 .937.115h.686a4.883 4.883 0 0 0 3.807-1.978c.906.965 2.162 2.298 2.52 2.656Zm1.086-6.974C26.522 13.755 29.57 6 24 6a5.159 5.159 0 0 0-7.154.004A7.041 7.041 0 0 1 18 10v1.67a3.354 3.354 0 0 1 .509 3.402l-.279.75a4.726 4.726 0 0 1-1.394 1.941l-.452 2.07a20.408 20.408 0 0 0 2.238.386A2.893 2.893 0 0 0 21.157 22h.686a2.893 2.893 0 0 0 2.536-1.784 16.843 16.843 0 0 0 4.396-1.055.992.992 0 0 0 .481-1.457ZM18.17 24.678c-.435-.33-1.828-1.48-2.951-2.412A5.015 5.015 0 0 1 11.448 24H9.552a5.014 5.014 0 0 1-3.776-1.742c-1.15.947-2.574 2.12-2.946 2.42A1.86 1.86 0 0 0 2 26.237V27.5a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-1.263a1.658 1.658 0 0 0-.83-1.559ZM4.645 15.126a2.991 2.991 0 0 0 1.31 1.462l.666 3.051A3 3 0 0 0 9.552 22h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a2.991 2.991 0 0 0 1.311-1.462l.28-.752A1.275 1.275 0 0 0 16 12.63V10c0-3-2-5-5.5-5S5 7 5 10v2.63a1.275 1.275 0 0 0-.635 1.744Z"
        })
    });
var $a5c9013d9903a040$export$2e2bcd8739ae039 = $a5c9013d9903a040$var$SvgGlyphiconsBasic25UserParents;




const $0d6c9b312b66e2ea$var$SvgGlyphiconsBasic250Eraser = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m13.98 26 2 2H7a1 1 0 0 1 0-2Zm13.126-3.257L21.85 28h-3.041L4.894 14.086a2.002 2.002 0 0 1 0-2.829l5.364-5.363a2.001 2.001 0 0 1 2.828 0l14.02 14.02a2.002 2.002 0 0 1 0 2.829Zm-8.777-8.779-6.657-6.656-5.364 5.363 6.656 6.657Z"
        })
    });
var $0d6c9b312b66e2ea$export$2e2bcd8739ae039 = $0d6c9b312b66e2ea$var$SvgGlyphiconsBasic250Eraser;




const $dc548f306d120191$var$SvgGlyphiconsBasic251DivingFree = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 5.423a7.557 7.557 0 0 0-3-1.97V0h3ZM24 25.5a1.502 1.502 0 0 1-1.5 1.5h-1a3.286 3.286 0 0 1-1.5-.31V25a2 2 0 0 0 2-2v-1a1 1 0 0 0-2 0v.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V22a1 1 0 0 0-2 0v1a2 2 0 0 0 2 2v2c0 1.738 1.893 3 4.5 3h1a4.505 4.505 0 0 0 4.5-4.5v-6.916a7.514 7.514 0 0 1-3 1.984ZM29 10v2a1 1 0 0 1-1 1h-1v.5a5.507 5.507 0 0 1-5.5 5.5h-12A5.507 5.507 0 0 1 4 13.5V13H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1.213A5.506 5.506 0 0 1 9.5 5h12a5.506 5.506 0 0 1 5.287 4H28a1 1 0 0 1 1 1Zm-5 .5A2.503 2.503 0 0 0 21.5 8h-12A2.503 2.503 0 0 0 7 10.5v3A2.503 2.503 0 0 0 9.5 16a3.907 3.907 0 0 0 3.558-2.412c.597-2.092 1.658-2.531 2.442-2.531s1.845.439 2.442 2.53A3.907 3.907 0 0 0 21.5 16a2.503 2.503 0 0 0 2.5-2.5Z"
        })
    });
var $dc548f306d120191$export$2e2bcd8739ae039 = $dc548f306d120191$var$SvgGlyphiconsBasic251DivingFree;




const $3581c0d5d0402b0e$var$SvgGlyphiconsBasic252DivingScuba = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.31 16.627a7.516 7.516 0 0 1-1.073 1.693A3.566 3.566 0 0 1 29 21.5a3.283 3.283 0 0 1-3 3.5h-2a1 1 0 0 0-1-1h-3.424a5 5 0 1 0 0 4H23a1 1 0 0 0 1-1h2a5.274 5.274 0 0 0 5-5.5 5.591 5.591 0 0 0-2.69-4.873ZM15 28a2 2 0 1 1 2-2 2.002 2.002 0 0 1-2 2Zm6.5-9a5.507 5.507 0 0 0 5.5-5.5V13h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1.213A5.506 5.506 0 0 0 21.5 5h-12a5.506 5.506 0 0 0-5.287 4H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v.5A5.507 5.507 0 0 0 9.5 19Zm-12-3A2.503 2.503 0 0 1 7 13.5v-3A2.503 2.503 0 0 1 9.5 8h12a2.503 2.503 0 0 1 2.5 2.5v3a2.503 2.503 0 0 1-2.5 2.5 3.907 3.907 0 0 1-3.558-2.412c-.597-2.092-1.658-2.531-2.442-2.531s-1.845.439-2.442 2.53A3.907 3.907 0 0 1 9.5 16Z"
        })
    });
var $3581c0d5d0402b0e$export$2e2bcd8739ae039 = $3581c0d5d0402b0e$var$SvgGlyphiconsBasic252DivingScuba;




const $c1475ff90669b856$var$SvgGlyphiconsBasic253Boat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m8.994 18.128 1.006.67 2.237-1.491a1.406 1.406 0 0 1 1.526 0L16 18.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L22 18.798l1.006-.67 1.813-4.662a.473.473 0 0 0-.293-.624l-1.06-.353-1.381-6.217A1.656 1.656 0 0 0 20.5 5h-.833l-.35-1.051A1.485 1.485 0 0 0 18 3h-4a1.485 1.485 0 0 0-1.316.949L12.334 5H11.5a1.656 1.656 0 0 0-1.585 1.271L8.533 12.49l-1.059.353a.473.473 0 0 0-.293.624ZM11.803 7h8.394l1.057 4.751-4.78-1.593a1.758 1.758 0 0 0-.948 0l-4.78 1.593ZM3.168 22.555a1 1 0 0 1 .277-1.387l2.792-1.861a1.406 1.406 0 0 1 1.526 0L10 20.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L16 20.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L22 20.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0l2.792 1.861a1 1 0 1 1-1.11 1.664L25 21.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L19 21.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L13 21.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L7 21.202l-2.445 1.63a1 1 0 0 1-1.387-.277Zm25.387 3.613a1 1 0 1 1-1.11 1.664L25 26.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L19 26.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L13 26.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L7 26.202l-2.445 1.63a1 1 0 1 1-1.11-1.664l2.792-1.861a1.406 1.406 0 0 1 1.526 0L10 25.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L16 25.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L22 25.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0Z"
        })
    });
var $c1475ff90669b856$export$2e2bcd8739ae039 = $c1475ff90669b856$var$SvgGlyphiconsBasic253Boat;




const $685861058d3612a8$var$SvgGlyphiconsBasic254SwimmingPool = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 17h6v1.798l2-1.333V9a2 2 0 0 1 3.414-1.414 1 1 0 0 0 1.414-1.414A4 4 0 0 0 16 9v2h-6V9a2 2 0 0 1 3.414-1.414 1 1 0 0 0 1.414-1.414A4 4 0 0 0 8 9v8.465l2 1.333Zm0-4h6v2h-6Zm-6.832 9.555a1 1 0 0 1 .277-1.387l2.792-1.861a1.406 1.406 0 0 1 1.526 0L10 20.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L16 20.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L22 20.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0l2.792 1.861a1 1 0 1 1-1.11 1.664L25 21.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L19 21.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L13 21.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L7 21.202l-2.445 1.63a1 1 0 0 1-1.387-.277Zm25.387 3.613a1 1 0 1 1-1.11 1.664L25 26.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L19 26.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L13 26.202l-2.237 1.491a1.406 1.406 0 0 1-1.526 0L7 26.202l-2.445 1.63a1 1 0 1 1-1.11-1.664l2.792-1.861a1.406 1.406 0 0 1 1.526 0L10 25.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L16 25.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0L22 25.798l2.237-1.491a1.406 1.406 0 0 1 1.526 0Z"
        })
    });
var $685861058d3612a8$export$2e2bcd8739ae039 = $685861058d3612a8$var$SvgGlyphiconsBasic254SwimmingPool;




const $8a75beb28f23ecb3$var$SvgGlyphiconsBasic255Buoy = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m12.237 17.307-2.226 1.484A5.995 5.995 0 0 1 15 13.09V5.387a1 1 0 0 1 1.316-.948l5.5 1.833a1 1 0 0 1 .684.949v.558a1 1 0 0 1-.684.949L17 10.333v2.756a5.995 5.995 0 0 1 4.99 5.702l-2.227-1.484a1.406 1.406 0 0 0-1.526 0L16 18.798l-2.237-1.491a1.406 1.406 0 0 0-1.526 0Zm-7.682 5.525L7 21.202l2.237 1.491a1.406 1.406 0 0 0 1.526 0L13 21.202l2.237 1.491a1.406 1.406 0 0 0 1.526 0L19 21.202l2.237 1.491a1.406 1.406 0 0 0 1.526 0L25 21.202l2.445 1.63a1 1 0 0 0 1.11-1.664l-2.792-1.861a1.406 1.406 0 0 0-1.526 0L22 20.798l-2.237-1.491a1.406 1.406 0 0 0-1.526 0L16 20.798l-2.237-1.491a1.406 1.406 0 0 0-1.526 0L10 20.798l-2.237-1.491a1.406 1.406 0 0 0-1.526 0l-2.792 1.861a1 1 0 1 0 1.11 1.664Zm21.208 1.475a1.406 1.406 0 0 0-1.526 0L22 25.798l-2.237-1.491a1.406 1.406 0 0 0-1.526 0L16 25.798l-2.237-1.491a1.406 1.406 0 0 0-1.526 0L10 25.798l-2.237-1.491a1.406 1.406 0 0 0-1.526 0l-2.792 1.861a1 1 0 1 0 1.11 1.664L7 26.202l2.237 1.491a1.406 1.406 0 0 0 1.526 0L13 26.202l2.237 1.491a1.406 1.406 0 0 0 1.526 0L19 26.202l2.237 1.491a1.406 1.406 0 0 0 1.526 0L25 26.202l2.445 1.63a1 1 0 0 0 1.11-1.664Z"
        })
    });
var $8a75beb28f23ecb3$export$2e2bcd8739ae039 = $8a75beb28f23ecb3$var$SvgGlyphiconsBasic255Buoy;




const $547aac7ce5c7a659$var$SvgGlyphiconsBasic256OxygenBottles = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5 15h10v7H5Zm12 7h10v-7H17Zm6-13.9V6h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v2.1a5.001 5.001 0 0 0-4 4.9h10a5.001 5.001 0 0 0-4-4.9Zm-12 0V6h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v2.1A5.001 5.001 0 0 0 5 13h10a5.001 5.001 0 0 0-4-4.9ZM17 27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3H17ZM5 27a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3H5Z"
        })
    });
var $547aac7ce5c7a659$export$2e2bcd8739ae039 = $547aac7ce5c7a659$var$SvgGlyphiconsBasic256OxygenBottles;




const $d1323620843a0543$var$SvgGlyphiconsBasic257Fins = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10.536 4H9.464A3.474 3.474 0 0 0 6 7.464L3 26v1a.714.714 0 0 0 .962.725L10 27l6.038.725A.714.714 0 0 0 17 27v-1L14 7.464A3.474 3.474 0 0 0 10.536 4ZM12 10a2 2 0 0 1-4 0V8a2 2 0 0 1 4 0Zm14-2.536A3.474 3.474 0 0 0 22.536 4h-1.072A3.474 3.474 0 0 0 18 7.464l-.987 6.123L19 25.839V27a2.95 2.95 0 0 1-.033.364L22 27l6.038.725A.714.714 0 0 0 29 27v-1ZM24 10a2 2 0 0 1-4 0V8a2 2 0 0 1 4 0Z"
        })
    });
var $d1323620843a0543$export$2e2bcd8739ae039 = $d1323620843a0543$var$SvgGlyphiconsBasic257Fins;




const $424caf893c58bc52$var$SvgGlyphiconsBasic258Anchor = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.287 17.13-5.767 1.06a.5.5 0 0 0-.264.844l.94.94L22 21.173A3.66 3.66 0 0 1 20 22h-2V11.444a4 4 0 1 0-4 0V22h-2a3.664 3.664 0 0 1-2-.828l-1.197-1.197.94-.94a.5.5 0 0 0-.263-.846l-5.767-1.058a.5.5 0 0 0-.582.582l1.058 5.767a.5.5 0 0 0 .846.264l.94-.94 1.196 1.195A7.493 7.493 0 0 0 12 26h1.6l2.01 2.512a.5.5 0 0 0 .78 0L18.4 26H20a7.49 7.49 0 0 0 4.828-2l1.197-1.197.94.94a.5.5 0 0 0 .846-.263l1.058-5.767a.5.5 0 0 0-.582-.582ZM16 9a1 1 0 1 1 1-1 1.001 1.001 0 0 1-1 1Z"
        })
    });
var $424caf893c58bc52$export$2e2bcd8739ae039 = $424caf893c58bc52$var$SvgGlyphiconsBasic258Anchor;




const $334234008f475ddc$var$SvgGlyphiconsBasic259Fishes = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.272 19.898a.265.265 0 0 0 .34-.122l.276-.552a.404.404 0 0 0-.053-.412l-2.047-2.34 1.998-2.284a.404.404 0 0 0 .053-.412l-.276-.552a.265.265 0 0 0-.34-.122l-3.83 1.702a8.477 8.477 0 0 0-5.043-1.746 8.01 8.01 0 0 0-6.166 3.047.675.675 0 0 0 0 .79 8.01 8.01 0 0 0 6.166 3.047 8.48 8.48 0 0 0 5.06-1.76ZM7.5 16.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm10.85-5.558a8.48 8.48 0 0 0 5.06-1.76l3.862 1.716a.265.265 0 0 0 .34-.122l.276-.552a.404.404 0 0 0-.053-.412l-2.047-2.34 1.998-2.284a.404.404 0 0 0 .053-.412l-.276-.552a.265.265 0 0 0-.34-.122l-3.83 1.702a8.477 8.477 0 0 0-5.043-1.746 8.01 8.01 0 0 0-6.166 3.047.675.675 0 0 0 0 .79 8.01 8.01 0 0 0 6.166 3.047ZM15.5 5.5a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm10.288 19.972 1.998-2.284a.404.404 0 0 0 .053-.412l-.276-.552a.265.265 0 0 0-.34-.122l-3.83 1.702a8.477 8.477 0 0 0-5.043-1.746 8.01 8.01 0 0 0-6.166 3.047.675.675 0 0 0 0 .79 8.01 8.01 0 0 0 6.166 3.047 8.48 8.48 0 0 0 5.06-1.76l3.862 1.716a.265.265 0 0 0 .34-.122l.276-.552a.404.404 0 0 0-.053-.412ZM15.5 25.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
        })
    });
var $334234008f475ddc$export$2e2bcd8739ae039 = $334234008f475ddc$var$SvgGlyphiconsBasic259Fishes;




const $784009ed01ff5711$var$SvgGlyphiconsBasic26Binoculars = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 7h-4V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm12 13v3h-7v-2a1.003 1.003 0 0 0-1-1h-6a1.003 1.003 0 0 0-1 1v2H5v-3a3.891 3.891 0 0 1 .555-1.832l2.89-4.336A3.891 3.891 0 0 0 9 12v-2a1.003 1.003 0 0 1 1-1h12a1.003 1.003 0 0 1 1 1v2a3.891 3.891 0 0 0 .555 1.832l2.89 4.336A3.891 3.891 0 0 1 27 20Zm-12-7.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm4 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5ZM21 5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2h4Zm-1 22a1.003 1.003 0 0 0 1 1h5a1.003 1.003 0 0 0 1-1v-2h-7ZM5 27a1.003 1.003 0 0 0 1 1h5a1.003 1.003 0 0 0 1-1v-2H5Z"
        })
    });
var $784009ed01ff5711$export$2e2bcd8739ae039 = $784009ed01ff5711$var$SvgGlyphiconsBasic26Binoculars;




const $ad9ba5487262a4a5$var$SvgGlyphiconsBasic260FishesBait = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 18.5a4.004 4.004 0 0 1-4-4v-3.414l2.707 2.707L4 14.5a2 2 0 0 0 4 0v-3.777a1.984 1.984 0 0 1 0-3.446V2h2v5.277a1.984 1.984 0 0 1 0 3.446V14.5a4.004 4.004 0 0 1-4 4Zm20.613 8.026a.403.403 0 0 1 .053.412l-.42.838a.265.265 0 0 1-.34.122l-5.029-2.235a10.903 10.903 0 0 1-6.507 2.262A10.036 10.036 0 0 1 7.354 25H9a.501.501 0 0 0 .5-.5v-.1a.724.724 0 0 0-.477-.649l-2.552-.793a10.284 10.284 0 0 1 7.899-3.883 10.899 10.899 0 0 1 6.484 2.244l4.99-2.217a.265.265 0 0 1 .34.122l.419.838a.404.404 0 0 1-.053.412l-2.616 2.99ZM11.5 22.5a1 1 0 1 0-1 1 1 1 0 0 0 1-1Zm17.388-6.276-.276.552a.265.265 0 0 1-.34.122l-3.861-1.715a8.48 8.48 0 0 1-5.061 1.759 8.01 8.01 0 0 1-6.166-3.047.675.675 0 0 1 0-.79 8.01 8.01 0 0 1 6.166-3.047 8.477 8.477 0 0 1 5.043 1.746l3.83-1.702a.265.265 0 0 1 .34.122l.276.552a.404.404 0 0 1-.053.412l-1.998 2.284 2.047 2.34a.404.404 0 0 1 .053.412ZM17.5 12.5a1 1 0 1 0-1 1 1 1 0 0 0 1-1Z"
        })
    });
var $ad9ba5487262a4a5$export$2e2bcd8739ae039 = $ad9ba5487262a4a5$var$SvgGlyphiconsBasic260FishesBait;




const $8b2a7db755f63fd8$var$SvgGlyphiconsBasic261Direction = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.08 4.261 5.13 13.905a.5.5 0 0 0 .07.94l9.418 2.537 2.536 9.418a.5.5 0 0 0 .94.071l9.645-21.95a.5.5 0 0 0-.66-.66ZM17.065 14.934l-4.228-1.138 9.572-4.205Z"
        })
    });
var $8b2a7db755f63fd8$export$2e2bcd8739ae039 = $8b2a7db755f63fd8$var$SvgGlyphiconsBasic261Direction;




const $65df965f66e3d297$var$SvgGlyphiconsBasic262DirectionEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.08 4.261 5.13 13.905a.5.5 0 0 0 .07.94l9.418 2.537 2.536 9.418a.5.5 0 0 0 .94.071l9.645-21.95a.5.5 0 0 0-.66-.66Zm-8.875 14.903-1.14-4.23-4.228-1.138L22.41 9.59Z"
        })
    });
var $65df965f66e3d297$export$2e2bcd8739ae039 = $65df965f66e3d297$var$SvgGlyphiconsBasic262DirectionEmpty;




const $7eb75b41cb43b892$var$SvgGlyphiconsBasic263DirectionFull = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.739 4.92-9.644 21.951a.5.5 0 0 1-.94-.071l-2.537-9.418L5.2 14.846a.5.5 0 0 1-.07-.94L27.08 4.26a.5.5 0 0 1 .659.66Z"
        })
    });
var $7eb75b41cb43b892$export$2e2bcd8739ae039 = $7eb75b41cb43b892$var$SvgGlyphiconsBasic263DirectionFull;




const $17c755553fc5b01c$var$SvgGlyphiconsBasic264FlagWaving = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.612 10.329-1.333 8A2 2 0 0 1 24.306 20H18a2 2 0 0 1-2-2h-5v8a1 1 0 0 1 1 1v1H7v-1a1 1 0 0 1 1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h7a2.006 2.006 0 0 1 2 2h5.64a2 2 0 0 1 1.972 2.329Z"
        })
    });
var $17c755553fc5b01c$export$2e2bcd8739ae039 = $17c755553fc5b01c$var$SvgGlyphiconsBasic264FlagWaving;




const $aeaa6ddf6df345d2$var$SvgGlyphiconsBasic265Flag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 7v11a1 1 0 0 1-1 1H11v7a1 1 0 0 1 1 1v1H7v-1a1 1 0 0 1 1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h14a1 1 0 0 1 1 1Z"
        })
    });
var $aeaa6ddf6df345d2$export$2e2bcd8739ae039 = $aeaa6ddf6df345d2$var$SvgGlyphiconsBasic265Flag;




const $9db82c61a6ce82f4$var$SvgGlyphiconsBasic266FlagTriangle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.503 13.436 11 18.875V26a1 1 0 0 1 1 1v1H7v-1a1 1 0 0 1 1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.125l14.503 5.439a1 1 0 0 1 0 1.872Z"
        })
    });
var $9db82c61a6ce82f4$export$2e2bcd8739ae039 = $9db82c61a6ce82f4$var$SvgGlyphiconsBasic266FlagTriangle;




const $e1c34e85e4be8150$var$SvgGlyphiconsBasic267Comments = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.95 8H7.5a.506.506 0 0 0-.5.5v10.45a3.495 3.495 0 0 1-3-3.45v-7A3.504 3.504 0 0 1 7.5 5h12a3.495 3.495 0 0 1 3.45 3ZM28 13.5v7a3.504 3.504 0 0 1-3.5 3.5h-5.379l-3.853 3.854a2.094 2.094 0 0 1-1.47.665 1.733 1.733 0 0 1-.665-.133A1.934 1.934 0 0 1 12 26.5v-2.536A3.505 3.505 0 0 1 9 20.5v-7a3.504 3.504 0 0 1 3.5-3.5h12a3.504 3.504 0 0 1 3.5 3.5Zm-3 0a.506.506 0 0 0-.5-.5h-12a.506.506 0 0 0-.5.5v7a.506.506 0 0 0 .5.5H15v2.879L17.879 21H24.5a.506.506 0 0 0 .5-.5Z"
        })
    });
var $e1c34e85e4be8150$export$2e2bcd8739ae039 = $e1c34e85e4be8150$var$SvgGlyphiconsBasic267Comments;




const $5656b264e856c6f9$var$SvgGlyphiconsBasic268CommentsOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 13.5v7a3.504 3.504 0 0 1-3.5 3.5h-5.379l-3.853 3.854a2.094 2.094 0 0 1-1.47.665 1.733 1.733 0 0 1-.665-.133A1.934 1.934 0 0 1 12 26.5v-2.533L14.967 21H15v2.879L17.879 21H24.5a.506.506 0 0 0 .5-.5v-7a.506.506 0 0 0-.5-.5h-1.533l2.765-2.765A3.497 3.497 0 0 1 28 13.5Zm-.785-8.44L5.06 27.215a1.5 1.5 0 0 1-2.122-2.12L9 19.032V13.5a3.504 3.504 0 0 1 3.5-3.5h5.533l2-2H7.5a.506.506 0 0 0-.5.5v10.45a3.495 3.495 0 0 1-3-3.45v-7A3.504 3.504 0 0 1 7.5 5h12a3.447 3.447 0 0 1 2.476 1.058l3.118-3.119a1.5 1.5 0 0 1 2.12 2.122ZM15.033 13H12.5a.506.506 0 0 0-.5.5v2.533Z"
        })
    });
var $5656b264e856c6f9$export$2e2bcd8739ae039 = $5656b264e856c6f9$var$SvgGlyphiconsBasic268CommentsOff;




const $c2888363d4b7f51e$var$SvgGlyphiconsBasic269CommentsLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 8H7.5a.506.506 0 0 0-.5.5v10.45a3.495 3.495 0 0 1-3-3.45v-7A3.504 3.504 0 0 1 7.5 5H19Zm6 12.5a.506.506 0 0 1-.5.5h-6.621L15 23.879V21h-2.5a.506.506 0 0 1-.5-.5v-7a.506.506 0 0 1 .5-.5h7.28a2.977 2.977 0 0 1-.78-2v-1h-6.5A3.504 3.504 0 0 0 9 13.5v7a3.505 3.505 0 0 0 3 3.464V26.5a1.934 1.934 0 0 0 1.133 1.886 1.733 1.733 0 0 0 .665.133 2.094 2.094 0 0 0 1.47-.665L19.12 24H24.5a3.504 3.504 0 0 0 3.5-3.5V14h-3ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $c2888363d4b7f51e$export$2e2bcd8739ae039 = $c2888363d4b7f51e$var$SvgGlyphiconsBasic269CommentsLock;




const $b310f7b1f7d6e0f4$var$SvgGlyphiconsBasic27Road = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.971 25.689-6.545-20a1 1 0 0 0-.95-.689h-4.351l.375 3h-3l.375-3h-4.35a1 1 0 0 0-.95.689l-6.546 20A1 1 0 0 0 3.979 27h8.146l1.125-9h5.5l1.125 9h8.146a1 1 0 0 0 .95-1.311ZM13.625 15l.625-5h3.5l.625 5Z"
        })
    });
var $b310f7b1f7d6e0f4$export$2e2bcd8739ae039 = $b310f7b1f7d6e0f4$var$SvgGlyphiconsBasic27Road;




const $e49311aa97e9d05c$var$SvgGlyphiconsBasic270Cake = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 5.138a6.395 6.395 0 0 1 1.617-3.708.495.495 0 0 1 .766 0A6.395 6.395 0 0 1 18 5.138a2.005 2.005 0 0 1-4 0Zm12 12.434-.1.104a3.16 3.16 0 0 1-5.144 0c-.44-.48-.638-.676-1.098-.676-.458 0-.655.195-1.096.676a3.155 3.155 0 0 1-5.14 0c-.44-.481-.636-.676-1.094-.676-.457 0-.653.195-1.094.675A3.27 3.27 0 0 1 8.665 19a3.272 3.272 0 0 1-2.57-1.325l-.095-.1V23h20ZM7.57 16.324c.44.48.637.676 1.095.676s.654-.195 1.095-.676a3.154 3.154 0 0 1 5.137 0c.44.48.638.676 1.096.676s.654-.195 1.095-.675a3.158 3.158 0 0 1 5.141-.001c.443.48.64.676 1.1.676s.657-.195 1.098-.676A3.837 3.837 0 0 1 26 15.166V13a2.006 2.006 0 0 0-2-2h-6V9.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V11H8a2.006 2.006 0 0 0-2 2v2.166a3.824 3.824 0 0 1 1.57 1.158ZM27 25H5a1 1 0 0 0-1 1v1a1.003 1.003 0 0 0 1 1h22a1.003 1.003 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $e49311aa97e9d05c$export$2e2bcd8739ae039 = $e49311aa97e9d05c$var$SvgGlyphiconsBasic270Cake;




const $1fbf11df465449bd$var$SvgGlyphiconsBasic271SetWine = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 15.333V27a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V15.333a4 4 0 0 1 .8-2.4l1.8-2.4a2 2 0 0 0 .4-1.2V7h4v2.333a2 2 0 0 0 .4 1.2l1.8 2.4a4 4 0 0 1 .8 2.4ZM24 4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1h4ZM13.493 14.023H6.507a.5.5 0 0 0-.5.5v2.695c0 2.335 1.292 3.85 2.993 4.186V26.5l-1.515.379A.673.673 0 0 0 7 27.5v.5h6v-.5a.673.673 0 0 0-.485-.621L11 26.5v-5.096c1.701-.336 2.993-1.85 2.993-4.186v-2.695a.5.5 0 0 0-.5-.5Z"
        })
    });
var $1fbf11df465449bd$export$2e2bcd8739ae039 = $1fbf11df465449bd$var$SvgGlyphiconsBasic271SetWine;




const $9b5de7bca7e312fd$var$SvgGlyphiconsBasic272GlassWine = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 17.922V25l4.644 1.393a.5.5 0 0 1 .356.479v.628a.5.5 0 0 1-.5.5h-12a.5.5 0 0 1-.5-.5v-.628a.5.5 0 0 1 .356-.479L15 25v-7.078c-3.38-.476-6-3.364-6-7.922V5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v5c0 4.558-2.62 7.446-6 7.922Z"
        })
    });
var $9b5de7bca7e312fd$export$2e2bcd8739ae039 = $9b5de7bca7e312fd$var$SvgGlyphiconsBasic272GlassWine;




const $eefda52a41b97534$var$SvgGlyphiconsBasic273CoffeeMug = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10.871 3.884C10.644 1.971 13.008.88 13.278.762a1 1 0 0 1 .803 1.832 2.493 2.493 0 0 0-1.22.998 5.348 5.348 0 0 0 .735.607c.67.495 1.43 1.057 1.534 1.921.227 1.912-2.139 3-2.41 3.118a1 1 0 0 1-.798-1.834 2.5 2.5 0 0 0 1.218-.991 5.358 5.358 0 0 0-.734-.606c-.67-.496-1.431-1.059-1.535-1.923ZM27 15v2a2.786 2.786 0 0 1-1.447 2.342l-3.213 1.606A7.042 7.042 0 0 1 20.863 23H10.11A6.976 6.976 0 0 1 8 18v-5.75A1.251 1.251 0 0 1 9.25 11h12.5A1.251 1.251 0 0 1 23 12.25V13h2a2.002 2.002 0 0 1 2 2Zm-2 0h-2v3c0 .132-.013.261-.02.392l1.678-.84A.815.815 0 0 0 25 17Zm-7.594-9.193a5.358 5.358 0 0 1 .734.606 2.5 2.5 0 0 1-1.218.991 1 1 0 1 0 .799 1.834c.27-.117 2.636-1.206 2.409-3.118-.104-.864-.864-1.426-1.534-1.921a5.348 5.348 0 0 1-.735-.607 2.493 2.493 0 0 1 1.22-.998 1 1 0 0 0-.803-1.832c-.27.118-2.634 1.21-2.407 3.122.104.864.864 1.427 1.535 1.923ZM25.131 25H6.87a1 1 0 0 0-.833 1.555L7 28h18l.964-1.445A1 1 0 0 0 25.13 25Z"
        })
    });
var $eefda52a41b97534$export$2e2bcd8739ae039 = $eefda52a41b97534$var$SvgGlyphiconsBasic273CoffeeMug;




const $3d16e991d24cf0e1$var$SvgGlyphiconsBasic274Drink = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.658 26.386 17 25.5V23h2a1 1 0 0 0 .98-.804l3-15A1 1 0 0 0 22 6h-3.82l.214-1.28 4.477-1.791-.742-1.858-5 2a1.001 1.001 0 0 0-.615.764L16.153 6H9a1 1 0 0 0-.98 1.196l3 15A1 1 0 0 0 12 23h2v2.5l-2.658.886a.5.5 0 0 0-.342.474v.64a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-.64a.5.5 0 0 0-.342-.474ZM17.847 8h2.933l-.4 2h-2.866Zm-2.36 2H10.62l-.4-2h5.6Z"
        })
    });
var $3d16e991d24cf0e1$export$2e2bcd8739ae039 = $3d16e991d24cf0e1$var$SvgGlyphiconsBasic274Drink;




const $a8fc6e77d3e77cb5$var$SvgGlyphiconsBasic275Beer = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 12h-2V9a.997.997 0 0 0-.088-.411 2.765 2.765 0 0 0-2.446-2.08A5.091 5.091 0 0 0 15 4a5.122 5.122 0 0 0-4.216 2.105A2.951 2.951 0 0 0 10 6a3.003 3.003 0 0 0-3 3v17a2.002 2.002 0 0 0 2 2h11a2.002 2.002 0 0 0 2-2v-2.798l2.723-1.815A3.066 3.066 0 0 0 26 19v-5a2.002 2.002 0 0 0-2-2Zm-4-2H9V9a.99.99 0 0 1 1.604-.788 1 1 0 0 0 1.546-.442A2.969 2.969 0 0 1 15 6a2.958 2.958 0 0 1 2.882 1.862 1.003 1.003 0 0 0 1.19.664.794.794 0 0 1 .178-.026.749.749 0 0 1 .734.643c.004.027.01.054.016.08Zm4 9a1.131 1.131 0 0 1-.387.723L22 20.798V14h2Z"
        })
    });
var $a8fc6e77d3e77cb5$export$2e2bcd8739ae039 = $a8fc6e77d3e77cb5$var$SvgGlyphiconsBasic275Beer;




const $7eb705f302df5859$var$SvgGlyphiconsBasic276BeerAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.912 7.589a2.765 2.765 0 0 0-2.446-2.08 5.25 5.25 0 0 0-8.682-.404A2.951 2.951 0 0 0 11 5a3.003 3.003 0 0 0-3 3v4a11.549 11.549 0 0 0 1.605 5.447A9.808 9.808 0 0 1 11 22a11.32 11.32 0 0 1-.895 4.553A1 1 0 0 0 11 28h9a1 1 0 0 0 .895-1.447A11.137 11.137 0 0 1 20 22a9.808 9.808 0 0 1 1.395-4.553A11.549 11.549 0 0 0 23 12V8a.997.997 0 0 0-.088-.411ZM21 9H10V8a.99.99 0 0 1 1.604-.788 1 1 0 0 0 1.546-.442A2.969 2.969 0 0 1 16 5a2.958 2.958 0 0 1 2.882 1.862 1.001 1.001 0 0 0 1.19.664.794.794 0 0 1 .178-.026.749.749 0 0 1 .734.643c.004.027.01.054.016.08Z"
        })
    });
var $7eb705f302df5859$export$2e2bcd8739ae039 = $7eb705f302df5859$var$SvgGlyphiconsBasic276BeerAlt;




const $7f75a3d76efd4552$var$SvgGlyphiconsBasic277FastFood = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 25.5V27a1.003 1.003 0 0 1-1 1H5a1.003 1.003 0 0 1-1-1v-1.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5Zm.5-4.5h-16a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-15-2h14a.5.5 0 0 0 .5-.5v-1a3.786 3.786 0 0 0-4-3.5H8a3.786 3.786 0 0 0-4 3.5v1a.5.5 0 0 0 .5.5ZM29 6h-3.938l.432-3.89-1.988-.22L23.049 6H16a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm-12.657 6.144A5.635 5.635 0 0 1 21 17.5v1a2.471 2.471 0 0 1-.251 1.073 2.98 2.98 0 0 1 0 4.854A2.471 2.471 0 0 1 21 25.5V27a2.965 2.965 0 0 1-.184 1H26a1 1 0 0 0 .994-.89L28.784 11H16.216Z"
        })
    });
var $7f75a3d76efd4552$export$2e2bcd8739ae039 = $7f75a3d76efd4552$var$SvgGlyphiconsBasic277FastFood;




const $01a0f3557c57ce11$var$SvgGlyphiconsBasic278Cutlery = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 5v6.392a4 4 0 0 1-.57 2.058l-1.86 3.1a4 4 0 0 0-.57 2.058V27a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-8.392a4 4 0 0 0-.57-2.058l-1.86-3.1A4 4 0 0 1 5 11.392V5a1 1 0 0 1 2 0v4.5a1 1 0 0 0 2 0V5a1 1 0 0 1 2 0v4.5a1 1 0 0 0 2 0V5a1 1 0 0 1 2 0Zm9-1h-2a4.012 4.012 0 0 0-4 4v9a2.006 2.006 0 0 0 2 2h1.5a.5.5 0 0 1 .5.5V27a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a2.006 2.006 0 0 0-2-2Z"
        })
    });
var $01a0f3557c57ce11$export$2e2bcd8739ae039 = $01a0f3557c57ce11$var$SvgGlyphiconsBasic278Cutlery;




const $75b9c124bd960760$var$SvgGlyphiconsBasic279Blender = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.895 20.553A1 1 0 0 0 21 20H11a1 1 0 0 0-.895.553l-2 4A1 1 0 0 0 8 25v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2a1 1 0 0 0-.105-.447ZM16 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm9-22H7.586a1 1 0 0 0-.707 1.707L9 7.828V15a1 1 0 0 0 .105.447l1 2A1 1 0 0 0 11 18h10a1 1 0 0 0 .895-.553l1-2A1 1 0 0 0 23 15V6h2v5a1 1 0 0 0 2 0V6a2.002 2.002 0 0 0-2-2Zm-4 11.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H19v-2h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H19V8h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Z"
        })
    });
var $75b9c124bd960760$export$2e2bcd8739ae039 = $75b9c124bd960760$var$SvgGlyphiconsBasic279Blender;




const $d1ea98dafa1751ff$var$SvgGlyphiconsBasic28Search = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.207 24.379-6.596-6.597a9.03 9.03 0 1 0-2.829 2.829l6.597 6.596a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414ZM13 19a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6Z"
        })
    });
var $d1ea98dafa1751ff$export$2e2bcd8739ae039 = $d1ea98dafa1751ff$var$SvgGlyphiconsBasic28Search;




const $68f7b19bfc66f412$var$SvgGlyphiconsBasic280Pizza = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 3.023v3.014l-.053.002A22.645 22.645 0 0 0 6.216 17.13l-.011.019-2.836-1.638a.995.995 0 0 1-.35-1.388A25.977 25.977 0 0 1 23.976 2.02.998.998 0 0 1 25 3.023Zm0 6.018V29.5a1.5 1.5 0 0 1-3 0v-2.074a2.006 2.006 0 0 0-1.003-1.737l-.498-.288c-.276-.159-.499.023-.499.406v.693a1.5 1.5 0 0 1-3 0v-1.964a2 2 0 0 0-1-1.732l-.5-.289c-.276-.16-.5-.276-.5-.015a1.5 1.5 0 0 1-3 0v-.847a2.012 2.012 0 0 0-1.006-1.74l-2.19-1.264A19.66 19.66 0 0 1 25 9.04ZM20 14.5a1.5 1.5 0 1 0 1.5-1.5 1.5 1.5 0 0 0-1.5 1.5Zm-1 6a1.5 1.5 0 1 0 1.5-1.5 1.5 1.5 0 0 0-1.5 1.5Zm-5-3a1.5 1.5 0 1 0 1.5-1.5 1.5 1.5 0 0 0-1.5 1.5Z"
        })
    });
var $68f7b19bfc66f412$export$2e2bcd8739ae039 = $68f7b19bfc66f412$var$SvgGlyphiconsBasic280Pizza;




const $ddc1629292516db4$var$SvgGlyphiconsBasic281CoffeeToGo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11.871 3.884C11.644 1.971 14.008.88 14.278.762a1 1 0 0 1 .803 1.832 2.493 2.493 0 0 0-1.22.998 5.348 5.348 0 0 0 .735.607c.67.495 1.43 1.057 1.534 1.921.227 1.912-2.139 3-2.41 3.118a1 1 0 0 1-.798-1.834 2.5 2.5 0 0 0 1.218-.991 5.358 5.358 0 0 0-.734-.606c-.67-.496-1.431-1.059-1.535-1.923Zm6.535 1.923a5.358 5.358 0 0 1 .734.606 2.5 2.5 0 0 1-1.218.991 1 1 0 1 0 .799 1.834c.27-.117 2.636-1.206 2.409-3.118-.104-.864-.864-1.426-1.534-1.921a5.348 5.348 0 0 1-.735-.607 2.493 2.493 0 0 1 1.22-.998 1 1 0 0 0-.803-1.832c-.27.118-2.634 1.21-2.407 3.122.104.864.864 1.427 1.535 1.923ZM10.504 27.09a1 1 0 0 0 .996.91h9a1 1 0 0 0 .996-.91L22.32 18H9.677ZM23 13h-1.132l-1.036-1.555A1 1 0 0 0 20 11h-8a1 1 0 0 0-.832.445L10.132 13H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $ddc1629292516db4$export$2e2bcd8739ae039 = $ddc1629292516db4$var$SvgGlyphiconsBasic281CoffeeToGo;




const $adc73bd0bda2a1ad$var$SvgGlyphiconsBasic282TeaPot = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 11a2 2 0 0 1 2 2v1H11v-1a2 2 0 0 1 2-2h1a2 2 0 0 1 4 0ZM9 11a5.006 5.006 0 0 1 5-5h4a5.006 5.006 0 0 1 5 5v2.063a13.072 13.072 0 0 1 2 1.578V11a7.008 7.008 0 0 0-7-7h-4a7.008 7.008 0 0 0-7 7v3.77a13.22 13.22 0 0 1 2-1.63Zm14.537 5H8.607a11.38 11.38 0 0 0-1.657 1.95L3 17l-1 2 3.196 3.275A11.54 11.54 0 0 0 5 24.365V25a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-1a10.952 10.952 0 0 0-3.463-8Z"
        })
    });
var $adc73bd0bda2a1ad$export$2e2bcd8739ae039 = $adc73bd0bda2a1ad$var$SvgGlyphiconsBasic282TeaPot;




const $269c216193251ec4$var$SvgGlyphiconsBasic283TeaMug = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10.871 3.884C10.644 1.971 13.008.88 13.278.762a1 1 0 0 1 .803 1.832 2.493 2.493 0 0 0-1.22.998 5.348 5.348 0 0 0 .735.607c.67.495 1.43 1.057 1.534 1.921.227 1.912-2.139 3-2.41 3.118a1 1 0 0 1-.798-1.834 2.5 2.5 0 0 0 1.218-.991 5.358 5.358 0 0 0-.734-.606c-.67-.496-1.431-1.059-1.535-1.923Zm6.535 1.923a5.358 5.358 0 0 1 .734.606 2.5 2.5 0 0 1-1.218.991 1 1 0 1 0 .799 1.834c.27-.117 2.636-1.206 2.409-3.118-.104-.864-.864-1.426-1.534-1.921a5.348 5.348 0 0 1-.735-.607 2.493 2.493 0 0 1 1.22-.998 1 1 0 0 0-.803-1.832c-.27.118-2.634 1.21-2.407 3.122.104.864.864 1.427 1.535 1.923ZM25.131 25H6.87a1 1 0 0 0-.833 1.555L7 28h18l.964-1.445A1 1 0 0 0 25.13 25ZM27 15v2a2.786 2.786 0 0 1-1.447 2.342l-3.213 1.606A7.042 7.042 0 0 1 20.863 23H10.11A6.976 6.976 0 0 1 8 18v-5.75A1.251 1.251 0 0 1 9.25 11H17v3l-1 1.333V17a1.001 1.001 0 0 0 1 1h2a1.001 1.001 0 0 0 1-1v-1.666L19 14v-3h2.75A1.251 1.251 0 0 1 23 12.25V13h2a2.002 2.002 0 0 1 2 2Zm-2 0h-2v3c0 .132-.013.261-.02.392l1.678-.84A.815.815 0 0 0 25 17Z"
        })
    });
var $269c216193251ec4$export$2e2bcd8739ae039 = $269c216193251ec4$var$SvgGlyphiconsBasic283TeaMug;




const $f6e0fda3f8fdb98a$var$SvgGlyphiconsBasic284CoffeeBeans = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 15a5 5 0 0 0-10 0v3a5 5 0 0 0 10 0Zm-4.071 5.128a1 1 0 1 1-1.858.744 8.03 8.03 0 0 1-.054-4.55 6.496 6.496 0 0 0 .054-3.45 1 1 0 0 1 1.858-.744 8.03 8.03 0 0 1 .054 4.55 6.496 6.496 0 0 0-.054 3.45Zm7.596-6.032a5 5 0 1 0 7.071-7.07l-2.121-2.122a5 5 0 0 0-7.071 7.07Zm-1.272-7.819a1 1 0 0 1 1.313-.525 8.03 8.03 0 0 1 3.256 3.179 6.493 6.493 0 0 0 2.4 2.479 1 1 0 1 1-.788 1.838 8.03 8.03 0 0 1-3.256-3.179 6.493 6.493 0 0 0-2.4-2.479 1 1 0 0 1-.525-1.313Zm1.272 12.627-2.121 2.121a5 5 0 1 0 7.07 7.071l2.122-2.121a5 5 0 1 0-7.07-7.071Zm6.222 2.161a8.028 8.028 0 0 1-3.178 3.257 6.495 6.495 0 0 0-2.478 2.4 1 1 0 0 1-1.838-.787 8.028 8.028 0 0 1 3.178-3.257 6.495 6.495 0 0 0 2.478-2.4 1 1 0 0 1 1.838.787Z"
        })
    });
var $f6e0fda3f8fdb98a$export$2e2bcd8739ae039 = $f6e0fda3f8fdb98a$var$SvgGlyphiconsBasic284CoffeeBeans;




const $d2f10879982da9c4$var$SvgGlyphiconsBasic285TeaLeaves = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.049 11.267c3.048 3.048 4.917 8.356 2.783 11.809L7.414 9.479a.518.518 0 0 0-.717.01l-.207.208a.518.518 0 0 0-.01.717l13.627 14.45c-3.346 2.306-8.151.874-11.84-2.815-4.75-4.75-4.282-12.593-4.104-14.392a.464.464 0 0 1 .419-.422c1.807-.192 9.715-.72 14.467 4.032Zm8.796-3.734a.475.475 0 0 0-.436-.432 16.648 16.648 0 0 0-8.499 1.415 13.854 13.854 0 0 1 1.553 1.337 14.749 14.749 0 0 1 1.542 1.825l3.123-2.763a.538.538 0 0 1 .728.022l.207.207a.525.525 0 0 1 .014.72l-3.101 3.36a13.932 13.932 0 0 1 1.71 5.352c.02-.018.04-.034.057-.052 3.56-3.561 3.255-9.432 3.102-10.99Z"
        })
    });
var $d2f10879982da9c4$export$2e2bcd8739ae039 = $d2f10879982da9c4$var$SvgGlyphiconsBasic285TeaLeaves;




const $794bada51c0e797f$var$SvgGlyphiconsBasic286FrenchPress = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 10H9a3 3 0 0 1 3-3h3V5h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H17v2h3a3 3 0 0 1 3 3Zm2 2H7.586a1 1 0 0 0-.707 1.707L9 15.828V26a2.002 2.002 0 0 0 2 2h10a2.002 2.002 0 0 0 2-2V14h2v5a1 1 0 0 0 2 0v-5a2.002 2.002 0 0 0-2-2Z"
        })
    });
var $794bada51c0e797f$export$2e2bcd8739ae039 = $794bada51c0e797f$var$SvgGlyphiconsBasic286FrenchPress;




const $413f405cf3dd48ea$var$SvgGlyphiconsBasic287Pot = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 10H6a3 3 0 0 1 3-3h4V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a3 3 0 0 1 3 3Zm2 4h-2v-2H6v2H4a1 1 0 0 0 0 2h2v10a2.002 2.002 0 0 0 2 2h16a2.002 2.002 0 0 0 2-2V16h2a1 1 0 0 0 0-2Z"
        })
    });
var $413f405cf3dd48ea$export$2e2bcd8739ae039 = $413f405cf3dd48ea$var$SvgGlyphiconsBasic287Pot;




const $6deb3217161b06af$var$SvgGlyphiconsBasic288Kettle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 7H9a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3ZM8 26a2.002 2.002 0 0 0 2 2h12a2.002 2.002 0 0 0 2-2v-1H8Zm19-15v5a1 1 0 0 1-2 0v-5h-2v12H9V12.828l-2.121-2.121A1 1 0 0 1 7.586 9H25a2.002 2.002 0 0 1 2 2Zm-7 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H18v2h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H18v2h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Z"
        })
    });
var $6deb3217161b06af$export$2e2bcd8739ae039 = $6deb3217161b06af$var$SvgGlyphiconsBasic288Kettle;




const $bb7f25a4b35c54b0$var$SvgGlyphiconsBasic289Grater = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.688 9H9.675l.083-.907A4.479 4.479 0 0 1 14.239 4h3.522a4.479 4.479 0 0 1 4.481 4.093l.083.907h-3.013l-.058-.636A1.492 1.492 0 0 0 17.76 7h-3.522a1.492 1.492 0 0 0-1.493 1.364Zm12.189 17.89a1 1 0 0 1-.994 1.11H8.117a1 1 0 0 1-.994-1.11L9 11h14ZM13 23.5a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm0-4a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm0-4a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm4 8a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm0-4a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm0-4a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm4 8a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm0-4a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Zm0-4a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.501.501 0 0 0 .5.5h1a.501.501 0 0 0 .5-.5Z"
        })
    });
var $bb7f25a4b35c54b0$export$2e2bcd8739ae039 = $bb7f25a4b35c54b0$var$SvgGlyphiconsBasic289Grater;




const $d0f35fa19a52c35b$var$SvgGlyphiconsBasic29Cars = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 11v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a3.994 3.994 0 0 0-1.092-2.74L25.57 13h2.93a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-3.466l-.41-1.527c-.038-.162-.104-.315-.157-.473h3.327l-1.068-3.627A1.967 1.967 0 0 0 25 4H14a1.993 1.993 0 0 0-1.57 1h-2.125l.02-.077A3.962 3.962 0 0 1 14 2h11a3.962 3.962 0 0 1 3.675 2.923l1.141 4.257A2.004 2.004 0 0 1 31 11Zm-6 6v10a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2H6v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V17a2 2 0 0 1 .868-1.644l1.457-5.433A3.962 3.962 0 0 1 8 7h11a3.962 3.962 0 0 1 3.675 2.923l1.457 5.433A2 2 0 0 1 25 17ZM5.206 14h16.588l-1.068-3.627A1.967 1.967 0 0 0 19 9H8a1.967 1.967 0 0 0-1.726 1.373ZM8 17.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm15 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Z"
        })
    });
var $d0f35fa19a52c35b$export$2e2bcd8739ae039 = $d0f35fa19a52c35b$var$SvgGlyphiconsBasic29Cars;




const $8fa1afb214fad6f9$var$SvgGlyphiconsBasic290CooksHat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 13.5c0 2.577-2.13 4.734-5 5.33V23H9v-3.009C6.227 19.943 4 18.55 4 16a4.102 4.102 0 0 1 3.066-3.654A6.07 6.07 0 0 1 7 11.5 6.764 6.764 0 0 1 14 5a7.114 7.114 0 0 1 5.978 3.131A7.879 7.879 0 0 1 21.4 8c3.645 0 6.6 2.462 6.6 5.5ZM9 27a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2H9Z"
        })
    });
var $8fa1afb214fad6f9$export$2e2bcd8739ae039 = $8fa1afb214fad6f9$var$SvgGlyphiconsBasic290CooksHat;




const $0a4a07b53d99966c$var$SvgGlyphiconsBasic291SquareEmptyPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5ZM22 15v2a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1Z"
        })
    });
var $0a4a07b53d99966c$export$2e2bcd8739ae039 = $0a4a07b53d99966c$var$SvgGlyphiconsBasic291SquareEmptyPlus;




const $ed0df52bd1fce529$var$SvgGlyphiconsBasic292SquareEmptyMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5ZM22 15v2a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z"
        })
    });
var $ed0df52bd1fce529$export$2e2bcd8739ae039 = $ed0df52bd1fce529$var$SvgGlyphiconsBasic292SquareEmptyMinus;




const $1558bcf25de42805$var$SvgGlyphiconsBasic293SquareEmptyRemove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5Zm-3.697-10.975L18.828 16l2.475 2.475a.5.5 0 0 1 0 .707l-2.121 2.121a.5.5 0 0 1-.707 0L16 18.828l-2.475 2.475a.5.5 0 0 1-.707 0l-2.121-2.121a.5.5 0 0 1 0-.707L13.172 16l-2.475-2.475a.5.5 0 0 1 0-.707l2.121-2.121a.5.5 0 0 1 .707 0L16 13.172l2.475-2.475a.5.5 0 0 1 .707 0l2.121 2.121a.5.5 0 0 1 0 .707Z"
        })
    });
var $1558bcf25de42805$export$2e2bcd8739ae039 = $1558bcf25de42805$var$SvgGlyphiconsBasic293SquareEmptyRemove;




const $a937d4db59e50121$var$SvgGlyphiconsBasic294SquareEmptyCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5Zm-2.468-12.785a.5.5 0 0 1 .038.686l-7.292 8.627a1 1 0 0 1-1.507.025l-3.89-4.312a.5.5 0 0 1 .007-.677l1.137-1.215a.5.5 0 0 1 .633-.08l2.611 1.662 6.573-5.695a.5.5 0 0 1 .671.015Z"
        })
    });
var $a937d4db59e50121$export$2e2bcd8739ae039 = $a937d4db59e50121$var$SvgGlyphiconsBasic294SquareEmptyCheck;




const $77de731e96afce01$var$SvgGlyphiconsBasic295SquareEmptyQuestion = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5ZM18 20v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm2.75-7v.114c0 1.38-.867 2.082-1.956 2.825a3.518 3.518 0 0 0-1.473 1.721.492.492 0 0 1-.472.34h-2.062a.502.502 0 0 1-.494-.58 3.268 3.268 0 0 1 .66-1.601 10.47 10.47 0 0 1 2.327-1.857 1.016 1.016 0 0 0 .47-.848V13a1.001 1.001 0 0 0-1-1h-1.5a1 1 0 0 0-1 1 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1 4 4 0 0 1 4-4h1.5c2.283 0 4 1.164 4 4Z"
        })
    });
var $77de731e96afce01$export$2e2bcd8739ae039 = $77de731e96afce01$var$SvgGlyphiconsBasic295SquareEmptyQuestion;




const $fc369373bb726da3$var$SvgGlyphiconsBasic296SquareEmptyInfo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5ZM18.903 9.582l-.333 2a.5.5 0 0 1-.494.418H15.59a.5.5 0 0 1-.493-.582l.333-2A.5.5 0 0 1 15.924 9h2.486a.5.5 0 0 1 .493.582Zm-.478 5.334L16.6 21h1.26a.5.5 0 0 1 .485.621l-.25 1a.5.5 0 0 1-.485.379H14a1.408 1.408 0 0 1-1.425-1.916L14.4 15h-.76a.5.5 0 0 1-.485-.621l.25-1A.5.5 0 0 1 13.89 13H17a1.408 1.408 0 0 1 1.425 1.916Z"
        })
    });
var $fc369373bb726da3$export$2e2bcd8739ae039 = $fc369373bb726da3$var$SvgGlyphiconsBasic296SquareEmptyInfo;




const $4b43cb685e86e20e$var$SvgGlyphiconsBasic297SquareEmptyAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 20v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1ZM17 9h-2a1 1 0 0 0-1 1v3l.919 4.598a.5.5 0 0 0 .49.402h1.18a.5.5 0 0 0 .49-.402L18 13 18 10a1 1 0 0 0-1-1Zm11-1.5v17a3.504 3.504 0 0 1-3.5 3.5h-17A3.504 3.504 0 0 1 4 24.5v-17A3.504 3.504 0 0 1 7.5 4h17A3.504 3.504 0 0 1 28 7.5Zm-3 0a.506.506 0 0 0-.5-.5h-17a.506.506 0 0 0-.5.5v17a.506.506 0 0 0 .5.5h17a.506.506 0 0 0 .5-.5Z"
        })
    });
var $4b43cb685e86e20e$export$2e2bcd8739ae039 = $4b43cb685e86e20e$var$SvgGlyphiconsBasic297SquareEmptyAlert;




const $a189c61f18b4ca5c$var$SvgGlyphiconsBasic298CircleEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 5a11 11 0 1 0 11 11A11.012 11.012 0 0 0 16 5Zm0 19a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8Z"
        })
    });
var $a189c61f18b4ca5c$export$2e2bcd8739ae039 = $a189c61f18b4ca5c$var$SvgGlyphiconsBasic298CircleEmpty;




const $c1bc38cb114b2b6b$var$SvgGlyphiconsBasic299CircleSelected = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 5a11 11 0 1 0 11 11A11.012 11.012 0 0 0 16 5Zm0 19a8 8 0 1 1 8-8 8.01 8.01 0 0 1-8 8Zm5-8a5 5 0 1 1-5-5 5 5 0 0 1 5 5Z"
        })
    });
var $c1bc38cb114b2b6b$export$2e2bcd8739ae039 = $c1bc38cb114b2b6b$var$SvgGlyphiconsBasic299CircleSelected;




const $3d0a9a09cd237532$var$SvgGlyphiconsBasic3Dog = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.013 9.427 24 14.414V27a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-6.427l-9.128-2.163L9 22v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8.44a3.999 3.999 0 0 1 .154-1.099l1.008-3.528-4.32-2.356a1 1 0 0 1-.398-1.356l.479-.878a1 1 0 0 1 1.356-.4l3.76 2.051Zm12.31-1.103L28 5V2.19a.5.5 0 0 0-.85-.358l-2.595 2.543-3.883 3.882 4.242 4.243 1.252-1.251a1 1 0 0 1 1.053-.231l1.88.694a.5.5 0 0 0 .542-.132l1.714-1.874a1 1 0 0 0-.031-1.382Z"
        })
    });
var $3d0a9a09cd237532$export$2e2bcd8739ae039 = $3d0a9a09cd237532$var$SvgGlyphiconsBasic3Dog;




const $c0f25e5843a6b5c7$var$SvgGlyphiconsBasic30Clipboard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 18.5v1a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5Zm-.5 3.5h-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-8h-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm4.5-4v16a2.002 2.002 0 0 1-2 2H8a2.002 2.002 0 0 1-2-2V10a2.002 2.002 0 0 1 2-2h2V7a1 1 0 0 1 1-1h2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2h2a1 1 0 0 1 1 1v1h2a2.002 2.002 0 0 1 2 2Zm-1.999 16L24 10h-2v1a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-1H8v16Z"
        })
    });
var $c0f25e5843a6b5c7$export$2e2bcd8739ae039 = $c0f25e5843a6b5c7$var$SvgGlyphiconsBasic30Clipboard;




const $b13f2545b5beebb3$var$SvgGlyphiconsBasic300AsianFood = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 16a11.982 11.982 0 0 1-5 9.727V27a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1.273A11.982 11.982 0 0 1 4 16a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1ZM25.177 4.098a.5.5 0 0 0-.114-.707l-1.615-1.137a.5.5 0 0 0-.703.132L15.664 13h2.908Zm3.037 4.463-1.408-1.384a.5.5 0 0 0-.715.015L20.659 13h3.705l3.848-3.723a.5.5 0 0 0 .002-.716Z"
        })
    });
var $b13f2545b5beebb3$export$2e2bcd8739ae039 = $b13f2545b5beebb3$var$SvgGlyphiconsBasic300AsianFood;




const $e359bde704f9b58a$var$SvgGlyphiconsBasic301SquareUpload = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 8.5v15a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h2.636L9.548 7.288A3.009 3.009 0 0 0 9.185 8H8.5a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5v-15a.506.506 0 0 0-.5-.5h-.685a3.008 3.008 0 0 0-.362-.71L20.864 5H23.5A3.504 3.504 0 0 1 27 8.5ZM12.011 10h1.742l1.209 9.541a.5.5 0 0 0 .498.459h1.08a.5.5 0 0 0 .498-.459L18.247 10h1.742a1 1 0 0 0 .821-1.57l-3.988-5.746a1 1 0 0 0-1.643 0l-3.99 5.746a1 1 0 0 0 .822 1.57Z"
        })
    });
var $e359bde704f9b58a$export$2e2bcd8739ae039 = $e359bde704f9b58a$var$SvgGlyphiconsBasic301SquareUpload;




const $25e5ea00456fda30$var$SvgGlyphiconsBasic302SquareDownload = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 8.5v15a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h4.133l-.407 3H8.5a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5v-15a.506.506 0 0 0-.5-.5h-3.726l-.407-3H23.5A3.504 3.504 0 0 1 27 8.5Zm-15.81 5.324 3.989 5.746a1 1 0 0 0 1.642 0l3.99-5.746a1 1 0 0 0-.822-1.57h-1.742l-1.209-9.542a.5.5 0 0 0-.498-.458h-1.08a.5.5 0 0 0-.498.458l-1.209 9.542h-1.742a1 1 0 0 0-.821 1.57Z"
        })
    });
var $25e5ea00456fda30$export$2e2bcd8739ae039 = $25e5ea00456fda30$var$SvgGlyphiconsBasic302SquareDownload;




const $f4b19b2754a5c42d$var$SvgGlyphiconsBasic303VerifyEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.147 18.53 27.127 16l1.02-2.528a2.118 2.118 0 0 0-.831-2.562l-2.313-1.447-.66-2.644a2.11 2.11 0 0 0-2.18-1.585l-2.72.191-2.09-1.756a2.116 2.116 0 0 0-2.694.002l-2.088 1.755-2.72-.193a2.094 2.094 0 0 0-2.182 1.584l-.657 2.647-2.314 1.445a2.122 2.122 0 0 0-.833 2.562l1.022 2.528-1.02 2.53a2.12 2.12 0 0 0 .831 2.562l2.313 1.446.66 2.649a2.134 2.134 0 0 0 2.18 1.58l2.72-.191 2.086 1.753a2.116 2.116 0 0 0 2.697.001l2.088-1.755 2.722.193a2.106 2.106 0 0 0 2.18-1.584l.658-2.647 2.313-1.445a2.118 2.118 0 0 0 .832-2.562Zm-3.065.42-2.7 1.684-.766 3.087-3.174-.225-2.435 2.047-2.434-2.045-3.176.222-.77-3.085-2.695-1.686 1.19-2.95-1.191-2.948 2.7-1.685.766-3.087 3.174.225 2.436-2.047 2.433 2.045 3.175-.222.77 3.085 2.697 1.686-1.19 2.95Z"
        })
    });
var $f4b19b2754a5c42d$export$2e2bcd8739ae039 = $f4b19b2754a5c42d$var$SvgGlyphiconsBasic303VerifyEmpty;




const $41fa60ec10b59478$var$SvgGlyphiconsBasic304VerifyCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.147 18.53 27.127 16l1.02-2.528a2.118 2.118 0 0 0-.831-2.562l-2.313-1.447-.66-2.644a2.105 2.105 0 0 0-2.18-1.585l-2.72.191-2.09-1.756a2.116 2.116 0 0 0-2.694.002l-2.088 1.755-2.72-.193a2.093 2.093 0 0 0-2.182 1.584l-.657 2.647-2.314 1.445a2.122 2.122 0 0 0-.833 2.562l1.022 2.528-1.02 2.53a2.12 2.12 0 0 0 .831 2.562l2.313 1.446.66 2.649a2.131 2.131 0 0 0 2.18 1.58l2.72-.191 2.086 1.753a2.116 2.116 0 0 0 2.697.001l2.088-1.755 2.722.193a2.108 2.108 0 0 0 2.18-1.584l.658-2.647 2.313-1.445a2.118 2.118 0 0 0 .832-2.562Zm-6.459-5.678-6.713 7.58a1 1 0 0 1-1.476.023l-3.2-3.389a.5.5 0 0 1-.027-.655l.475-.595a.5.5 0 0 1 .614-.135L14 17l6.399-5.45a.5.5 0 0 1 .677.026l.591.591a.5.5 0 0 1 .021.685Z"
        })
    });
var $41fa60ec10b59478$export$2e2bcd8739ae039 = $41fa60ec10b59478$var$SvgGlyphiconsBasic304VerifyCheck;




const $a2133bfb230821d9$var$SvgGlyphiconsBasic305NoSymbol = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4ZM7 16a8.994 8.994 0 0 1 14.002-7.477L8.523 21.003A8.947 8.947 0 0 1 7 16Zm9 9a8.947 8.947 0 0 1-5.002-1.523l12.479-12.48A8.994 8.994 0 0 1 16 25Z"
        })
    });
var $a2133bfb230821d9$export$2e2bcd8739ae039 = $a2133bfb230821d9$var$SvgGlyphiconsBasic305NoSymbol;




const $4a5910c887a42d9e$var$SvgGlyphiconsBasic306SquareEmptyPlay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5Zm-4.84-7.678-5.665 3.226a1 1 0 0 1-1.495-.87v-6.451a1 1 0 0 1 1.495-.87l5.665 3.227a1 1 0 0 1 0 1.738Z"
        })
    });
var $4a5910c887a42d9e$export$2e2bcd8739ae039 = $4a5910c887a42d9e$var$SvgGlyphiconsBasic306SquareEmptyPlay;




const $5b825b914371e7ce$var$SvgGlyphiconsBasic307SquareEmptyDownload = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5Zm-4.19-7.93-3.989 5.746a1 1 0 0 1-1.643 0L11.19 16.57A1 1 0 0 1 12.01 15H14v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4h1.989a1 1 0 0 1 .821 1.57Z"
        })
    });
var $5b825b914371e7ce$export$2e2bcd8739ae039 = $5b825b914371e7ce$var$SvgGlyphiconsBasic307SquareEmptyDownload;




const $832ff90a8de5508d$var$SvgGlyphiconsBasic308SquareEmptyUpload = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5Zm-4.19-9.07A1 1 0 0 1 19.99 17H18v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4h-1.989a1 1 0 0 1-.821-1.57l3.989-5.746a1 1 0 0 1 1.643 0Z"
        })
    });
var $832ff90a8de5508d$export$2e2bcd8739ae039 = $832ff90a8de5508d$var$SvgGlyphiconsBasic308SquareEmptyUpload;




const $414a556ce45cd211$var$SvgGlyphiconsBasic309SquareEmptyLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5ZM22 15v2a1 1 0 0 1-1 1h-4v1.989a1 1 0 0 1-1.57.821l-5.746-3.989a1 1 0 0 1 0-1.643l5.746-3.988a1 1 0 0 1 1.57.821V14h4a1 1 0 0 1 1 1Z"
        })
    });
var $414a556ce45cd211$export$2e2bcd8739ae039 = $414a556ce45cd211$var$SvgGlyphiconsBasic309SquareEmptyLeft;




const $aaf542a1d3c717ab$var$SvgGlyphiconsBasic31Pencil = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.414 8.828-2.086 2.086-4.242-4.242 2.086-2.086a1 1 0 0 1 1.414 0l2.828 2.828a1 1 0 0 1 0 1.414ZM8.086 19.672l4.242 4.242 11.586-11.586-4.242-4.242Zm-3.81 7.427a.5.5 0 0 0 .625.624l5.928-2.48-4.072-4.072Z"
        })
    });
var $aaf542a1d3c717ab$export$2e2bcd8739ae039 = $aaf542a1d3c717ab$var$SvgGlyphiconsBasic31Pencil;




const $a04a99f4723be141$var$SvgGlyphiconsBasic310SquareEmptyRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm.5 20.5a.506.506 0 0 1-.5.5h-17a.506.506 0 0 1-.5-.5v-17a.506.506 0 0 1 .5-.5h17a.506.506 0 0 1 .5.5Zm-2.684-9.321a1 1 0 0 1 0 1.643L16.57 20.81A1 1 0 0 1 15 19.99V18h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4v-1.989a1 1 0 0 1 1.57-.821Z"
        })
    });
var $a04a99f4723be141$export$2e2bcd8739ae039 = $a04a99f4723be141$var$SvgGlyphiconsBasic310SquareEmptyRight;




const $87b45723538e8c14$var$SvgGlyphiconsBasic311Spade = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.725 8.275-4-4a1 1 0 0 0-1.414 0l-2.122 2.121a1.001 1.001 0 0 0-.289.798l.183 2.011a.99.99 0 0 0 .16.432l-8.372 8.37-2.3-2.3a1 1 0 0 0-1.414 0l-2.621 2.621.021.022c-2.03 2.466-1.498 6.952-.591 8.616 1.664.907 6.15 1.44 8.616-.591l.022.021 2.62-2.62a1 1 0 0 0 0-1.415l-2.231-2.232 8.37-8.371a.991.991 0 0 0 .432.159l2.01.183c.03.002.061.004.091.004a1 1 0 0 0 .707-.293l2.122-2.122a1 1 0 0 0 0-1.414Zm-3.204 1.79-1.184-.108-1.295-1.293-.107-1.185 1.083-1.083 2.586 2.586Z"
        })
    });
var $87b45723538e8c14$export$2e2bcd8739ae039 = $87b45723538e8c14$var$SvgGlyphiconsBasic311Spade;




const $f241c63a5d15221f$var$SvgGlyphiconsBasic312Saw = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.056 6.964a3.006 3.006 0 0 0-1.865-1.537l-3.6-1.016a3.025 3.025 0 0 0-3.228 1.105L15.44 9.597c-.015.022-.023.047-.036.07L4.405 24.183a1 1 0 0 0 .09 1.311L7 28h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2h2v-2.218l2.411.214c.03.002.06.004.09.004a1 1 0 0 0 .935-.647l.747-1.978a3.005 3.005 0 0 0-.127-2.41Zm-1.744 1.704-.48 1.269-6.746-.6 1.89-2.64a.996.996 0 0 1 1.073-.362l3.6 1.017a1 1 0 0 1 .663 1.316Z"
        })
    });
var $f241c63a5d15221f$export$2e2bcd8739ae039 = $f241c63a5d15221f$var$SvgGlyphiconsBasic312Saw;




const $f8219286fdcf04d8$var$SvgGlyphiconsBasic313ClawHammer = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.257 7.843a1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0l1.743 1.742L17 9.586 15.954 8.54Zm10.657 2.828-3.586-3.585L18.414 11 22 14.586l1.785-1.785C25.14 14.063 27 15.522 27 18h1c0-3.016.02-5.223-2.086-7.329Zm-8.682 1.976-3.792 3.792-.354-.353a1 1 0 0 0-1.414 0l-7.086 7.086a1 1 0 0 0 0 1.414l2.828 2.828a1 1 0 0 0 1.414 0l7.086-7.086a1 1 0 0 0 0-1.414l-.354-.353 3.793-3.793Z"
        })
    });
var $f8219286fdcf04d8$export$2e2bcd8739ae039 = $f8219286fdcf04d8$var$SvgGlyphiconsBasic313ClawHammer;




const $4ac47ef705cfd8f8$var$SvgGlyphiconsBasic314Hammer = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m16.172 11.586 4.242 4.242L8.828 27.414a1 1 0 0 1-1.414 0l-2.828-2.828a1 1 0 0 1 0-1.414Zm3-7.657a1 1 0 0 0-1.415 0L14.55 7.136 25.864 18.45l1.086-1.086v-5.657Z"
        })
    });
var $4ac47ef705cfd8f8$export$2e2bcd8739ae039 = $4ac47ef705cfd8f8$var$SvgGlyphiconsBasic314Hammer;




const $a7a8abb21019a365$var$SvgGlyphiconsBasic315Screwdriver = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m13.672 14.086 4.242 4.242-9.086 9.086a1 1 0 0 1-1.414 0l-2.828-2.828a1 1 0 0 1 0-1.414ZM27.575 5.64 26.373 4.44a1.25 1.25 0 0 0-1.333-.283l-2.758 1.676a1.264 1.264 0 0 0-.502.655l-.706 2.157a.757.757 0 0 1-.182.296l-4.77 4.769 2.183 2.182 4.768-4.768a.753.753 0 0 1 .297-.183l2.156-.706a1.254 1.254 0 0 0 .65-.492l1.661-2.728a1.258 1.258 0 0 0-.262-1.373Z"
        })
    });
var $a7a8abb21019a365$export$2e2bcd8739ae039 = $a7a8abb21019a365$var$SvgGlyphiconsBasic315Screwdriver;




const $1e751b39527b76ee$var$SvgGlyphiconsBasic316Wrench = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.405 12.92a6.386 6.386 0 0 1-7.783 3.7L8.828 27.415a1 1 0 0 1-1.414 0l-2.828-2.828a1 1 0 0 1 0-1.414l10.746-10.747a6.405 6.405 0 0 1 3.7-7.924 6.227 6.227 0 0 1 2.778-.492.499.499 0 0 1 .34.849l-2.417 2.417a.496.496 0 0 0-.131.47l.829 3.38a.496.496 0 0 0 .363.363l3.381.83a.496.496 0 0 0 .469-.131l2.419-2.42a.494.494 0 0 1 .845.302 6.221 6.221 0 0 1-.503 2.85Z"
        })
    });
var $1e751b39527b76ee$export$2e2bcd8739ae039 = $1e751b39527b76ee$var$SvgGlyphiconsBasic316Wrench;




const $cc61ee5308c7f866$var$SvgGlyphiconsBasic317Ax = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29.419 13.986s-2.973 6.164-9.34 4.699c0-1.906-.005-4.246-.005-4.246l-4.706-4.704a1 1 0 0 1-.007-1.407l3.45-3.521a1 1 0 0 1 1.42-.007Zm-14.638-2.01L11 15.772v1.985l-6.414 6.414a1 1 0 0 0 0 1.415l1.828 1.828a1 1 0 0 0 1.414 0l10.248-10.248-.001-1.897Z"
        })
    });
var $cc61ee5308c7f866$export$2e2bcd8739ae039 = $cc61ee5308c7f866$var$SvgGlyphiconsBasic317Ax;




const $d422c232b20e3c0f$var$SvgGlyphiconsBasic318Blacksmith = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 14.5v1.569a.99.99 0 0 1-.868.984A7.001 7.001 0 0 0 20 24v1h2a1 1 0 0 1 1 1v2H9v-2a1 1 0 0 1 1-1h2v-3a1 1 0 0 0-1-1h-1a5.001 5.001 0 0 1-4.967-4.424A.508.508 0 0 1 5.53 16h6.97a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5ZM5.5 14h4a.5.5 0 0 0 .5-.5V11h16a.917.917 0 0 0 1-.8V7.8a.917.917 0 0 0-1-.8H10V3.5a.5.5 0 0 0-.5-.5H8.25a.5.5 0 0 0-.4.2L5 7v6.5a.5.5 0 0 0 .5.5Z"
        })
    });
var $d422c232b20e3c0f$export$2e2bcd8739ae039 = $d422c232b20e3c0f$var$SvgGlyphiconsBasic318Blacksmith;




const $fab42a4fa59d8592$var$SvgGlyphiconsBasic319SawBlade = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.687 16.842a2 2 0 0 0-.698-1.225l-1.295-1.075a1.21 1.21 0 0 1-.155-1.667 5.009 5.009 0 0 1 1.776-.836.247.247 0 0 0 .114-.393l-1.02-1.26a2 2 0 0 0-1.219-.713l-1.658-.282a1.176 1.176 0 0 1-.968-1.367 5.641 5.641 0 0 1 1.126-1.612.247.247 0 0 0-.1-.396l-1.515-.582a2.002 2.002 0 0 0-1.413-.008l-1.576.584a1.205 1.205 0 0 1-1.523-.699 5.01 5.01 0 0 1 .164-1.957.247.247 0 0 0-.284-.295l-1.6.253a2 2 0 0 0-1.226.698l-1.075 1.296a1.181 1.181 0 0 1-.912.428 1.2 1.2 0 0 1-.756-.273 5.552 5.552 0 0 1-.832-1.782.247.247 0 0 0-.393-.111l-1.264 1.024a1.999 1.999 0 0 0-.712 1.217L9.39 7.467a1.184 1.184 0 0 1-1.166.986 4.297 4.297 0 0 1-1.81-1.135.249.249 0 0 0-.4.097l-.58 1.512a2 2 0 0 0-.008 1.411l.584 1.577a1.16 1.16 0 0 1-.698 1.522 5.914 5.914 0 0 1-1.962-.17.247.247 0 0 0-.293.284l.255 1.606a2 2 0 0 0 .699 1.226l1.295 1.075a1.206 1.206 0 0 1 .155 1.667 5.276 5.276 0 0 1-1.78.834.247.247 0 0 0-.112.393l1.023 1.262a1.998 1.998 0 0 0 1.217.713l1.659.282a1.225 1.225 0 0 1 .968 1.367 4.144 4.144 0 0 1-1.105 1.611.247.247 0 0 0 .094.403l1.502.576a1.998 1.998 0 0 0 1.41.009l1.577-.585a1.174 1.174 0 0 1 1.523.699 4.719 4.719 0 0 1-.156 1.952.247.247 0 0 0 .283.3l1.593-.253a2 2 0 0 0 1.226-.699l1.075-1.295a1.172 1.172 0 0 1 1.668-.155 4.827 4.827 0 0 1 .84 1.77.247.247 0 0 0 .394.117l1.255-1.018a1.999 1.999 0 0 0 .712-1.217l.283-1.658a1.216 1.216 0 0 1 1.366-.969 4.087 4.087 0 0 1 1.612 1.102.247.247 0 0 0 .403-.093l.575-1.5a2 2 0 0 0 .008-1.411l-.584-1.577a1.183 1.183 0 0 1 .698-1.522 5.963 5.963 0 0 1 1.964.173.248.248 0 0 0 .291-.285ZM16 19a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
        })
    });
var $fab42a4fa59d8592$export$2e2bcd8739ae039 = $fab42a4fa59d8592$var$SvgGlyphiconsBasic319SawBlade;




const $a1c89f17ae4938f1$var$SvgGlyphiconsBasic32Bus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 8a4.012 4.012 0 0 0-4-4H8a4.012 4.012 0 0 0-4 4v19a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h16v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1ZM12 6.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5Zm-2 16a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm16 0a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm0-6a1.718 1.718 0 0 1-.89 1.455A22.886 22.886 0 0 1 16 19.5a22.886 22.886 0 0 1-9.11-1.545A1.718 1.718 0 0 1 6 16.5V11a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Z"
        })
    });
var $a1c89f17ae4938f1$export$2e2bcd8739ae039 = $a1c89f17ae4938f1$var$SvgGlyphiconsBasic32Bus;




const $e58be2fbbcca1c3b$var$SvgGlyphiconsBasic320Certificate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.936 23.472a3.176 3.176 0 0 0 .753.457l-1.598 4.915a.5.5 0 0 1-.921.072l-1.15-2.26a.5.5 0 0 0-.673-.219l-2.26 1.151a.5.5 0 0 1-.702-.6l1.647-5.065a3.215 3.215 0 0 0 1.977.678l.155-.003 1.599-.113Zm11.558 5.016-2.221-6.83a3.2 3.2 0 0 1-2.263.944l-.237-.01-1.522-.107-1.172.985a3.17 3.17 0 0 1-.429.3l2.138 6.574a.5.5 0 0 0 .92.072l1.152-2.26a.5.5 0 0 1 .672-.219l2.26 1.151a.5.5 0 0 0 .702-.6Zm-4.57-7.906a1.211 1.211 0 0 0 1.25-.91l.566-2.28 1.99-1.242a1.216 1.216 0 0 0 .48-1.472l-.879-2.178.879-2.177a1.214 1.214 0 0 0-.478-1.471l-1.99-1.246-.57-2.274a1.194 1.194 0 0 0-1.251-.913l-2.342.165-1.799-1.512a1.219 1.219 0 0 0-1.548 0l-1.796 1.512-2.347-.166a1.197 1.197 0 0 0-1.25.91l-.567 2.28-1.995 1.245a1.218 1.218 0 0 0-.474 1.47l.88 2.177-.88 2.177a1.214 1.214 0 0 0 .478 1.471l1.991 1.246.569 2.275a1.199 1.199 0 0 0 1.252.912l2.342-.164 1.798 1.511a1.218 1.218 0 0 0 1.548 0l1.797-1.512Z"
        })
    });
var $e58be2fbbcca1c3b$export$2e2bcd8739ae039 = $e58be2fbbcca1c3b$var$SvgGlyphiconsBasic320Certificate;




const $5e3cff78da2cfae3$var$SvgGlyphiconsBasic321Users = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 26.237V27.5a.5.5 0 0 1-.5.5h-16a.5.5 0 0 1-.5-.5v-1.263a1.86 1.86 0 0 1 .83-1.559c.372-.3 1.797-1.473 2.946-2.42A5.014 5.014 0 0 0 11.552 24h1.896a5.015 5.015 0 0 0 3.77-1.734c1.124.933 2.517 2.083 2.952 2.412a1.658 1.658 0 0 1 .83 1.559Zm6.573-3.036-2.213-1.549a4.005 4.005 0 0 1-3.084 2.308 3.392 3.392 0 0 1 .717 2.04H27.5a.5.5 0 0 0 .5-.5v-1.48a1 1 0 0 0-.427-.819ZM6.645 15.126a2.992 2.992 0 0 0 1.31 1.462l.666 3.052A3 3 0 0 0 11.552 22h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a2.991 2.991 0 0 0 1.311-1.462l.28-.752A1.275 1.275 0 0 0 18 12.63V10c0-3-2-5-5.5-5S7 7 7 10v2.63a1.275 1.275 0 0 0-.635 1.744Zm17.074 5.122.165-1.317a1.49 1.49 0 0 0 .932-.88l.368-1.102a.675.675 0 0 0-.184-.763V14a3.952 3.952 0 0 0-5-3.859v1.53a3.354 3.354 0 0 1 .509 3.401l-.279.75a4.726 4.726 0 0 1-1.394 1.941l-.503 2.303c-.013.059-.039.112-.053.17l.001.012A2 2 0 0 0 20.266 22h1.468a2 2 0 0 0 1.985-1.752Z"
        })
    });
var $5e3cff78da2cfae3$export$2e2bcd8739ae039 = $5e3cff78da2cfae3$var$SvgGlyphiconsBasic321Users;




const $c6120c1a4994b0f3$var$SvgGlyphiconsBasic322ShieldCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.546 4.85A23.598 23.598 0 0 0 16 3a23.598 23.598 0 0 0-9.546 1.85A2.507 2.507 0 0 0 5 7.122V14.5c0 7.816 9.88 13.106 10.302 13.327a1.497 1.497 0 0 0 1.396 0C17.12 27.606 27 22.316 27 14.5V7.122a2.507 2.507 0 0 0-1.454-2.272Zm-2.858 6.002-6.713 7.58a1 1 0 0 1-1.476.023l-3.2-3.389a.5.5 0 0 1-.027-.655l.475-.595a.5.5 0 0 1 .614-.135L15 15l6.399-5.45a.5.5 0 0 1 .677.026l.591.591a.5.5 0 0 1 .021.685Z"
        })
    });
var $c6120c1a4994b0f3$export$2e2bcd8739ae039 = $c6120c1a4994b0f3$var$SvgGlyphiconsBasic322ShieldCheck;




const $2f830a60c3e7d800$var$SvgGlyphiconsBasic323ShieldHalf = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.546 4.85A23.598 23.598 0 0 0 16 3a23.598 23.598 0 0 0-9.546 1.85A2.507 2.507 0 0 0 5 7.122V14.5c0 7.816 9.88 13.106 10.302 13.327a1.497 1.497 0 0 0 1.396 0C17.12 27.606 27 22.316 27 14.5V7.122a2.507 2.507 0 0 0-1.454-2.272ZM24 14.5c0 4.982-5.933 9.015-8 10.268V6a21.368 21.368 0 0 1 8 1.448Z"
        })
    });
var $2f830a60c3e7d800$export$2e2bcd8739ae039 = $2f830a60c3e7d800$var$SvgGlyphiconsBasic323ShieldHalf;




const $5b025195ebf2ed8f$var$SvgGlyphiconsBasic324ShieldEmptyStar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.546 4.85A23.598 23.598 0 0 0 16 3a23.598 23.598 0 0 0-9.546 1.85A2.507 2.507 0 0 0 5 7.122V14.5c0 7.816 9.88 13.106 10.302 13.327a1.497 1.497 0 0 0 1.396 0C17.12 27.606 27 22.316 27 14.5V7.122a2.507 2.507 0 0 0-1.454-2.272ZM24 14.5c0 4.477-4.68 8.147-7.47 9.938l-.542.347-.54-.349C13.21 22.991 8 19.13 8 14.5V7.43l.663-.237A21.918 21.918 0 0 1 16 6a22.137 22.137 0 0 1 7.337 1.193L24 7.43Zm-1.703-1.723-1.791 1.3-1.691 1.229.645 1.987.683 2.101a.43.43 0 0 1-.66.48l-1.789-1.298-1.69-1.228-1.69 1.228-1.788 1.298a.43.43 0 0 1-.66-.48l.682-2.1.645-1.988-1.69-1.228-1.792-1.301A.43.43 0 0 1 9.963 12h4.304l.645-1.988.684-2.105a.43.43 0 0 1 .816 0l.684 2.105.646 1.988h4.303a.43.43 0 0 1 .252.777Z"
        })
    });
var $5b025195ebf2ed8f$export$2e2bcd8739ae039 = $5b025195ebf2ed8f$var$SvgGlyphiconsBasic324ShieldEmptyStar;




const $96f3d25a7ed32be4$var$SvgGlyphiconsBasic325ShieldQuarter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.546 4.85A23.598 23.598 0 0 0 16 3a23.598 23.598 0 0 0-9.546 1.85A2.507 2.507 0 0 0 5 7.122V14.5c0 7.816 9.88 13.106 10.302 13.327a1.497 1.497 0 0 0 1.396 0C17.12 27.606 27 22.316 27 14.5V7.122a2.507 2.507 0 0 0-1.454-2.272ZM16 24.768V15H8.035c-.014-.166-.035-.332-.035-.5V7.448A21.368 21.368 0 0 1 16 6v9h7.964c-.378 4.75-5.967 8.557-7.964 9.768Z"
        })
    });
var $96f3d25a7ed32be4$export$2e2bcd8739ae039 = $96f3d25a7ed32be4$var$SvgGlyphiconsBasic325ShieldQuarter;




const $e7402e46d57228d5$var$SvgGlyphiconsBasic326ShieldStar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.546 4.85A23.598 23.598 0 0 0 16 3a23.598 23.598 0 0 0-9.546 1.85A2.507 2.507 0 0 0 5 7.122V14.5c0 7.816 9.88 13.106 10.302 13.327a1.497 1.497 0 0 0 1.396 0C17.12 27.606 27 22.316 27 14.5V7.122a2.507 2.507 0 0 0-1.454-2.272Zm-3.249 7.927-1.791 1.3-1.691 1.229.645 1.987.683 2.101a.43.43 0 0 1-.66.48l-1.789-1.298-1.69-1.228-1.69 1.228-1.788 1.298a.43.43 0 0 1-.66-.48l.682-2.1.645-1.988-1.69-1.228-1.792-1.301A.43.43 0 0 1 9.963 12h4.304l.645-1.988.684-2.105a.43.43 0 0 1 .816 0l.684 2.105.646 1.988h4.303a.43.43 0 0 1 .252.777Z"
        })
    });
var $e7402e46d57228d5$export$2e2bcd8739ae039 = $e7402e46d57228d5$var$SvgGlyphiconsBasic326ShieldStar;




const $8b97bf8cfb0ba6be$var$SvgGlyphiconsBasic327ContactlessLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.398 9.21A15.27 15.27 0 0 1 15 16a15.27 15.27 0 0 1-1.602 6.79 1.5 1.5 0 1 1-2.691-1.324A12.303 12.303 0 0 0 12 16a12.303 12.303 0 0 0-1.293-5.466 1.5 1.5 0 1 1 2.691-1.324Zm-7.55 1.251a1.5 1.5 0 0 0-.684 2.008A7.94 7.94 0 0 1 6 16a7.94 7.94 0 0 1-.836 3.53 1.5 1.5 0 1 0 2.691 1.325A10.906 10.906 0 0 0 9 16a10.906 10.906 0 0 0-1.145-4.855 1.499 1.499 0 0 0-2.007-.684ZM19 11V7.392c-.02-.04-.035-.08-.055-.12a1.5 1.5 0 1 0-2.691 1.325 16.566 16.566 0 0 1 0 14.806 1.5 1.5 0 1 0 2.691 1.324A19.615 19.615 0 0 0 21 16a19.531 19.531 0 0 0-.127-2.224A3.001 3.001 0 0 1 19 11Zm13-6v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3ZM23.896 14c.064.663.104 1.33.104 2a21 21 0 0 1-2.202 9.338 1.5 1.5 0 1 0 2.691 1.324A23.966 23.966 0 0 0 27 16c0-.67-.038-1.337-.093-2Z"
        })
    });
var $8b97bf8cfb0ba6be$export$2e2bcd8739ae039 = $8b97bf8cfb0ba6be$var$SvgGlyphiconsBasic327ContactlessLock;




const $3334bb54d70bbe34$var$SvgGlyphiconsBasic328Contactless = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.398 9.21A15.27 15.27 0 0 1 15 16a15.27 15.27 0 0 1-1.602 6.79 1.5 1.5 0 1 1-2.691-1.324A12.303 12.303 0 0 0 12 16a12.303 12.303 0 0 0-1.293-5.466 1.5 1.5 0 1 1 2.691-1.324ZM24.49 5.338a1.5 1.5 0 0 0-2.691 1.324 20.899 20.899 0 0 1 0 18.676 1.5 1.5 0 1 0 2.691 1.324 23.894 23.894 0 0 0 0-21.324ZM5.848 10.46a1.5 1.5 0 0 0-.684 2.008A7.94 7.94 0 0 1 6 16a7.94 7.94 0 0 1-.836 3.53 1.5 1.5 0 1 0 2.691 1.325A10.906 10.906 0 0 0 9 16a10.906 10.906 0 0 0-1.145-4.855 1.499 1.499 0 0 0-2.007-.684Zm11.09-3.872a1.5 1.5 0 0 0-.684 2.008 16.566 16.566 0 0 1 0 14.806 1.5 1.5 0 1 0 2.691 1.324 19.56 19.56 0 0 0 0-17.454 1.5 1.5 0 0 0-2.008-.684Z"
        })
    });
var $3334bb54d70bbe34$export$2e2bcd8739ae039 = $3334bb54d70bbe34$var$SvgGlyphiconsBasic328Contactless;




const $f9b221c2b7b8b18f$var$SvgGlyphiconsBasic329CreditCard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 23a2.002 2.002 0 0 0 2 2h20a2.002 2.002 0 0 0 2-2v-8H4Zm16-3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5ZM28 9v2H4V9a2.002 2.002 0 0 1 2-2h20a2.002 2.002 0 0 1 2 2Z"
        })
    });
var $f9b221c2b7b8b18f$export$2e2bcd8739ae039 = $f9b221c2b7b8b18f$var$SvgGlyphiconsBasic329CreditCard;




const $7b37aabd40cfc187$var$SvgGlyphiconsBasic33AccessPoint = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.9 13a6.862 6.862 0 0 1-2.062 4.905 1.004 1.004 0 0 1-1.41-.015l-.566-.567a.983.983 0 0 1-.015-1.395 4.048 4.048 0 0 0 0-5.856.983.983 0 0 1 .015-1.395l.567-.567a1.004 1.004 0 0 1 1.41-.015A6.862 6.862 0 0 1 22.9 13Zm-11 0a4.05 4.05 0 0 1 1.253-2.928.983.983 0 0 0-.015-1.395l-.567-.567a1.004 1.004 0 0 0-1.41-.015 6.864 6.864 0 0 0 0 9.81 1.004 1.004 0 0 0 1.41-.015l.567-.567a.983.983 0 0 0 .015-1.395A4.05 4.05 0 0 1 11.9 13Zm12.497-8.417a1.011 1.011 0 0 0-1.43-.011l-.568.567a.995.995 0 0 0 .007 1.413 9.066 9.066 0 0 1 0 12.896.995.995 0 0 0-.007 1.413l.567.567a1.011 1.011 0 0 0 1.431-.01 11.865 11.865 0 0 0 0-16.836ZM6.9 13a9.06 9.06 0 0 1 2.694-6.448.995.995 0 0 0 .007-1.413l-.567-.567a1.011 1.011 0 0 0-1.431.01 11.865 11.865 0 0 0 0 16.836 1.011 1.011 0 0 0 1.43.01l.568-.567a.995.995 0 0 0-.007-1.413A9.06 9.06 0 0 1 6.9 13Zm9.1-2a2 2 0 1 0 2 2 2.002 2.002 0 0 0-2-2Zm.5 6h-1a.673.673 0 0 0-.621.485L14 21v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6l-.879-3.515A.673.673 0 0 0 16.5 17Z"
        })
    });
var $7b37aabd40cfc187$export$2e2bcd8739ae039 = $7b37aabd40cfc187$var$SvgGlyphiconsBasic33AccessPoint;




const $ef88fff78e4d4cf5$var$SvgGlyphiconsBasic330CreditCardOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06 5.06 27.215a1.5 1.5 0 0 1-2.122-2.12l1.253-1.253A1.978 1.978 0 0 1 4 23v-8h9.033l4-4H4V9a2.002 2.002 0 0 1 2-2h15.033l4.06-4.06a1.5 1.5 0 0 1 2.122 2.12Zm.593 3.1L24.968 11H28V9a1.978 1.978 0 0 0-.192-.84ZM20.968 15H28v8a2.002 2.002 0 0 1-2 2H10.967Zm3.532 4h-4a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5Z"
        })
    });
var $ef88fff78e4d4cf5$export$2e2bcd8739ae039 = $ef88fff78e4d4cf5$var$SvgGlyphiconsBasic330CreditCardOff;




const $c12a16c36450b633$var$SvgGlyphiconsBasic331QuadBike = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 4a1 1 0 0 1 1-1h3a1 1 0 0 1 .707.293L13.414 5h5.172l1.707-1.707A1 1 0 0 1 21 3h3a1 1 0 0 1 0 2h-2.586l-1.707 1.707A1 1 0 0 1 19 7h-6a1 1 0 0 1-.707-.293L10.586 5H8a1 1 0 0 1-1-1Zm19 16h-4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm-16 0H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm17-6v4.184A2.965 2.965 0 0 0 26 18h-4a3.003 3.003 0 0 0-3 3v3h-6v-3a3.003 3.003 0 0 0-3-3H6a2.965 2.965 0 0 0-1 .184V14a2 2 0 0 1 2-2h2.13a1.031 1.031 0 0 0 .977-.797A3.001 3.001 0 0 1 13 9h6a3.001 3.001 0 0 1 2.893 2.203 1.031 1.031 0 0 0 .977.797H25a2 2 0 0 1 2 2Zm-14 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm10 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Z"
        })
    });
var $c12a16c36450b633$export$2e2bcd8739ae039 = $c12a16c36450b633$var$SvgGlyphiconsBasic331QuadBike;




const $bedb1a3791a5d579$var$SvgGlyphiconsBasic332Motorbike = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 20v7a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm5-8v9a3.99 3.99 0 0 1-3 3.859V20a3.003 3.003 0 0 0-3-3h-2a3.003 3.003 0 0 0-3 3v4.859A3.99 3.99 0 0 1 9 21v-9a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3Zm-5-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm6.555-6.332-3-2a1 1 0 0 0-1.262.125L18.586 5h-5.172l-1.707-1.707a.999.999 0 0 0-1.262-.125l-3 2a1 1 0 1 0 1.11 1.664l2.318-1.545 1.42 1.42A1 1 0 0 0 13 7h6a1 1 0 0 0 .707-.293l1.42-1.42 2.318 1.545a1 1 0 1 0 1.11-1.664Z"
        })
    });
var $bedb1a3791a5d579$export$2e2bcd8739ae039 = $bedb1a3791a5d579$var$SvgGlyphiconsBasic332Motorbike;




const $3394a6f9f2897970$var$SvgGlyphiconsBasic333Squares = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 6.5v13a3.495 3.495 0 0 1-3 3.45V6.5a.506.506 0 0 0-.5-.5H9.05a3.495 3.495 0 0 1 3.45-3h13A3.504 3.504 0 0 1 29 6.5Zm-5 5v13a3.504 3.504 0 0 1-3.5 3.5h-13A3.504 3.504 0 0 1 4 24.5v-13A3.504 3.504 0 0 1 7.5 8h13a3.504 3.504 0 0 1 3.5 3.5Zm-3 0a.506.506 0 0 0-.5-.5h-13a.506.506 0 0 0-.5.5v13a.506.506 0 0 0 .5.5h13a.506.506 0 0 0 .5-.5Z"
        })
    });
var $3394a6f9f2897970$export$2e2bcd8739ae039 = $3394a6f9f2897970$var$SvgGlyphiconsBasic333Squares;




const $1f1f8fb9e1d1c80c$var$SvgGlyphiconsBasic334BrightnessUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6.308 8.429a1.5 1.5 0 0 1 2.121-2.121l2.219 2.218a8.541 8.541 0 0 0-2.122 2.122Zm16.166 2.219 2.218-2.219a1.5 1.5 0 0 0-2.121-2.121l-2.219 2.218a8.541 8.541 0 0 1 2.122 2.122ZM7 15.5a8.523 8.523 0 0 1 .14-1.5H4a1.5 1.5 0 0 0 0 3h3.14A8.523 8.523 0 0 1 7 15.5Zm10-8.36V4a1.5 1.5 0 0 0-3 0v3.14a8.098 8.098 0 0 1 3 0ZM8.526 20.352l-2.218 2.219a1.5 1.5 0 0 0 2.121 2.121l2.219-2.218a8.541 8.541 0 0 1-2.122-2.122Zm13.948 0a8.541 8.541 0 0 1-2.122 2.122l2.219 2.218a1.5 1.5 0 0 0 2.121-2.121ZM27 14h-3.14a8.098 8.098 0 0 1 0 3H27a1.5 1.5 0 0 0 0-3Zm-13 9.86V27a1.5 1.5 0 0 0 3 0v-3.14a8.098 8.098 0 0 1-3 0Zm7-8.36a5.5 5.5 0 1 1-5.5-5.5 5.507 5.507 0 0 1 5.5 5.5Zm-3 0a2.5 2.5 0 1 0-2.5 2.5 2.503 2.503 0 0 0 2.5-2.5Z"
        })
    });
var $1f1f8fb9e1d1c80c$export$2e2bcd8739ae039 = $1f1f8fb9e1d1c80c$var$SvgGlyphiconsBasic334BrightnessUp;




const $3d8286a3d193943c$var$SvgGlyphiconsBasic335BrightnessDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.5 11a4.5 4.5 0 1 0 4.5 4.5 4.505 4.505 0 0 0-4.5-4.5Zm0 6a1.5 1.5 0 1 1 1.5-1.5 1.502 1.502 0 0 1-1.5 1.5Zm0-9a7.535 7.535 0 0 0-1.5.15V6a1.5 1.5 0 0 1 3 0v2.15A7.535 7.535 0 0 0 15.5 8ZM7.722 9.843a1.5 1.5 0 0 1 2.121-2.121l1.523 1.523a7.534 7.534 0 0 0-2.121 2.121ZM8.15 17H6a1.5 1.5 0 0 1 0-3h2.15a7.547 7.547 0 0 0 0 3Zm11.483-7.755 1.523-1.523a1.5 1.5 0 0 1 2.121 2.121l-1.523 1.523a7.534 7.534 0 0 0-2.121-2.121Zm3.644 11.912a1.5 1.5 0 0 1-2.121 2.121l-1.523-1.523a7.534 7.534 0 0 0 2.121-2.121ZM26.5 15.5A1.5 1.5 0 0 1 25 17h-2.15a7.547 7.547 0 0 0 0-3H25a1.5 1.5 0 0 1 1.5 1.5Zm-11 7.5a7.535 7.535 0 0 0 1.5-.15V25a1.5 1.5 0 0 1-3 0v-2.15a7.535 7.535 0 0 0 1.5.15Zm-4.134-1.245-1.523 1.523a1.5 1.5 0 0 1-2.121-2.121l1.523-1.523a7.534 7.534 0 0 0 2.121 2.121Z"
        })
    });
var $3d8286a3d193943c$export$2e2bcd8739ae039 = $3d8286a3d193943c$var$SvgGlyphiconsBasic335BrightnessDown;




const $150a73bbeea8eb42$var$SvgGlyphiconsBasic336Folder = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 12h24v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Zm22-5H13l-1.414-1.414A2 2 0 0 0 10.172 5H6a2 2 0 0 0-2 2v3h24V9a2 2 0 0 0-2-2Z"
        })
    });
var $150a73bbeea8eb42$export$2e2bcd8739ae039 = $150a73bbeea8eb42$var$SvgGlyphiconsBasic336Folder;




const $dad232f18e84a6ad$var$SvgGlyphiconsBasic337FolderCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.667 10H4V7a2 2 0 0 1 2-2h4.172a2 2 0 0 1 1.414.586L13 7h5.575a7.442 7.442 0 0 0 1.092 3Zm1.852 2H4v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V13.221A7.404 7.404 0 0 1 21.519 12Zm10.187-5.646a.497.497 0 0 1-.379.47l-1.156.29a4.523 4.523 0 0 1-.43 1.04l.617 1.028a.504.504 0 0 1-.046.586 5.858 5.858 0 0 1-.539.542.497.497 0 0 1-.582.043l-1.03-.62a4.417 4.417 0 0 1-1.042.432l-.29 1.156a.498.498 0 0 1-.471.38 15.98 15.98 0 0 1-.716 0 .497.497 0 0 1-.47-.38l-.29-1.156a4.404 4.404 0 0 1-1.04-.43l-1.03.617a.504.504 0 0 1-.586-.047 5.817 5.817 0 0 1-.541-.54.497.497 0 0 1-.043-.58l.619-1.032a4.347 4.347 0 0 1-.429-1.04l-1.157-.289a.498.498 0 0 1-.38-.472 15.976 15.976 0 0 1 .001-.715.497.497 0 0 1 .379-.47l1.157-.29a4.361 4.361 0 0 1 .43-1.041l-.618-1.03a.504.504 0 0 1 .047-.586 5.8 5.8 0 0 1 .54-.54.497.497 0 0 1 .58-.043l1.032.618a4.348 4.348 0 0 1 1.04-.429l.29-1.157a.498.498 0 0 1 .471-.38c.225-.004.494-.004.716.001a.497.497 0 0 1 .47.38l.29 1.156a4.324 4.324 0 0 1 1.04.429l1.028-.617a.504.504 0 0 1 .586.046 5.86 5.86 0 0 1 .542.539.497.497 0 0 1 .043.582l-.619 1.03a4.414 4.414 0 0 1 .43 1.042l1.157.29a.498.498 0 0 1 .38.471c.005.225.004.494-.001.716Zm-3.558-.36A2.147 2.147 0 1 0 26 8.143a2.15 2.15 0 0 0 2.148-2.149Z"
        })
    });
var $dad232f18e84a6ad$export$2e2bcd8739ae039 = $dad232f18e84a6ad$var$SvgGlyphiconsBasic337FolderCogwheel;




const $c4aec530be05fa11$var$SvgGlyphiconsBasic338FolderAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.082 10H4V7a2 2 0 0 1 2-2h4.172a2 2 0 0 1 1.414.586L13 7h5.07a7.931 7.931 0 0 0 1.012 3Zm1.644 2H4v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V13.737A7.895 7.895 0 0 1 20.726 12ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-5 2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm0-6a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v2a3.942 3.942 0 0 0 .149.977l.399 1.284a.362.362 0 0 0 .324.239h.256a.362.362 0 0 0 .324-.239l.4-1.284A3.942 3.942 0 0 0 27 4.5Z"
        })
    });
var $c4aec530be05fa11$export$2e2bcd8739ae039 = $c4aec530be05fa11$var$SvgGlyphiconsBasic338FolderAlert;




const $30e7dc61643b862c$var$SvgGlyphiconsBasic339FolderLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 10H4V7a2 2 0 0 1 2-2h4.172a2 2 0 0 1 1.414.586L13 7h6Zm.184 2H4v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V14h-6a2.995 2.995 0 0 1-2.816-2ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $30e7dc61643b862c$export$2e2bcd8739ae039 = $30e7dc61643b862c$var$SvgGlyphiconsBasic339FolderLock;




const $ff198129aff5d076$var$SvgGlyphiconsBasic34Luggage = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 6h-2V5a2.002 2.002 0 0 1 2-2h4a2.002 2.002 0 0 1 2 2v1h-2V5h-4Zm11 5v12a3.009 3.009 0 0 1-3 3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1h-6v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a3.009 3.009 0 0 1-3-3V11a3.009 3.009 0 0 1 3-3h12a3.009 3.009 0 0 1 3 3Zm-7 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Z"
        })
    });
var $ff198129aff5d076$export$2e2bcd8739ae039 = $ff198129aff5d076$var$SvgGlyphiconsBasic34Luggage;




const $8076a50ebaf4848b$var$SvgGlyphiconsBasic340FolderNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14a7.96 7.96 0 0 0 2-.263V26a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12h16.726A7.958 7.958 0 0 0 26 14Zm-7.93-7H13l-1.414-1.414A2 2 0 0 0 10.172 5H6a2 2 0 0 0-2 2v3h15.082a7.932 7.932 0 0 1-1.013-3ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-9.433 2.019 5.452-5.452A3.954 3.954 0 0 0 26 2a4.005 4.005 0 0 0-4 4 3.955 3.955 0 0 0 .567 2.019ZM30 6a3.955 3.955 0 0 0-.567-2.02l-5.452 5.453A3.956 3.956 0 0 0 26 10a4.005 4.005 0 0 0 4-4Z"
        })
    });
var $8076a50ebaf4848b$export$2e2bcd8739ae039 = $8076a50ebaf4848b$var$SvgGlyphiconsBasic340FolderNo;




const $eb45ee7ed6e08298$var$SvgGlyphiconsBasic341Mic = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11 15v-2h10v2a5 5 0 0 1-10 0Zm10-6a5 5 0 0 0-10 0v2h10Zm3 2a1 1 0 0 0-1 1v3a6.627 6.627 0 0 1-7 7 6.627 6.627 0 0 1-7-7v-3a1 1 0 0 0-2 0v3a8.526 8.526 0 0 0 7 8.81V26h-1a1 1 0 0 0-1 1v1h8v-1a1 1 0 0 0-1-1h-1v-2.19A8.526 8.526 0 0 0 25 15v-3a1 1 0 0 0-1-1Z"
        })
    });
var $eb45ee7ed6e08298$export$2e2bcd8739ae039 = $eb45ee7ed6e08298$var$SvgGlyphiconsBasic341Mic;




const $142ac40fe9f85996$var$SvgGlyphiconsBasic342MicOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06 5.06 27.215a1.5 1.5 0 0 1-2.122-2.12l5.29-5.291A9.474 9.474 0 0 1 7 15v-3a1 1 0 0 1 2 0v3a7.652 7.652 0 0 0 .715 3.318l1.599-1.599A4.88 4.88 0 0 1 11 15v-2h4.033l2-2H11V9a4.988 4.988 0 0 1 9.695-1.662l4.399-4.399a1.5 1.5 0 0 1 2.12 2.122ZM23 12.968V15a6.627 6.627 0 0 1-7 7 8.35 8.35 0 0 1-1.83-.203l-1.611 1.611a9.348 9.348 0 0 0 1.441.401V26h-1a1 1 0 0 0-1 1v1h8v-1a1 1 0 0 0-1-1h-1v-2.19A8.526 8.526 0 0 0 25 15v-3a.992.992 0 0 0-.313-.72ZM21 15v-.033l-5.03 5.03L16 20a5 5 0 0 0 5-5Z"
        })
    });
var $142ac40fe9f85996$export$2e2bcd8739ae039 = $142ac40fe9f85996$var$SvgGlyphiconsBasic342MicOff;




const $c1b9faa2b7cbd8b1$var$SvgGlyphiconsBasic343Repeat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 13.257V21.5a3.504 3.504 0 0 1-3.5 3.5H11v2.046a.5.5 0 0 1-.785.41l-5.121-3.545a.5.5 0 0 1 0-.822l5.121-3.546a.5.5 0 0 1 .785.411V22h14.5a.506.506 0 0 0 .5-.5v-6.597a1 1 0 0 1 .43-.822l1.785-1.235a.5.5 0 0 1 .785.41Zm-23 6.34V12.5a.506.506 0 0 1 .5-.5h15v2.046a.5.5 0 0 0 .785.41l5.121-3.545a.5.5 0 0 0 0-.822l-5.121-3.546a.5.5 0 0 0-.785.411V9h-15A3.504 3.504 0 0 0 3 12.5v8.743a.5.5 0 0 0 .785.411l1.784-1.235A1 1 0 0 0 6 19.597Z"
        })
    });
var $c1b9faa2b7cbd8b1$export$2e2bcd8739ae039 = $c1b9faa2b7cbd8b1$var$SvgGlyphiconsBasic343Repeat;




const $c04e163a70cdabf3$var$SvgGlyphiconsBasic344RepeatOnce = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 13.257V21.5a3.504 3.504 0 0 1-3.5 3.5h-19A3.504 3.504 0 0 1 3 21.5v-9A3.504 3.504 0 0 1 6.5 9h15V6.954a.5.5 0 0 1 .785-.41l5.121 3.545a.5.5 0 0 1 0 .822l-5.121 3.546a.5.5 0 0 1-.785-.411V12h-15a.506.506 0 0 0-.5.5v9a.506.506 0 0 0 .5.5h19a.506.506 0 0 0 .5-.5v-6.597a1 1 0 0 1 .43-.822l1.785-1.235a.5.5 0 0 1 .785.41Z"
        })
    });
var $c04e163a70cdabf3$export$2e2bcd8739ae039 = $c04e163a70cdabf3$var$SvgGlyphiconsBasic344RepeatOnce;




const $17b9b3d66b474818$var$SvgGlyphiconsBasic345ElectricCord = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 17.5V28h-3V17.5a2.5 2.5 0 0 0-5 0v4a5.5 5.5 0 0 1-11 0v-4.213A5.499 5.499 0 0 1 5 12V9a1 1 0 0 1 1-1h1V5a1 1 0 0 1 2 0v3h3V5a1 1 0 0 1 2 0v3h1a1 1 0 0 1 1 1v3a5.499 5.499 0 0 1-4 5.288V21.5a2.5 2.5 0 0 0 5 0v-4a5.5 5.5 0 0 1 11 0Z"
        })
    });
var $17b9b3d66b474818$export$2e2bcd8739ae039 = $17b9b3d66b474818$var$SvgGlyphiconsBasic345ElectricCord;




const $8a04c1cd58cfdbc3$var$SvgGlyphiconsBasic346SelfWindingCord = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 16.02a11.931 11.931 0 0 1-3.657 8.578l-.35.313a5.732 5.732 0 0 1-3.576 1.286 6.03 6.03 0 0 1-5.893-5.674A5.016 5.016 0 0 1 11 16v-1.98a1 1 0 0 1 1-1h1v-2.5a1 1 0 1 1 2 0v2.5h2v-2.5a1 1 0 1 1 2 0v2.5h1a1 1 0 0 1 1 1V16a4.99 4.99 0 0 1-3.455 4.502 3.005 3.005 0 0 0 2.872 2.695 2.753 2.753 0 0 0 1.73-.635 8.983 8.983 0 1 0-8.141 2.228 7.946 7.946 0 0 0 4.075 3.037A11.994 11.994 0 1 1 28 16.02Z"
        })
    });
var $8a04c1cd58cfdbc3$export$2e2bcd8739ae039 = $8a04c1cd58cfdbc3$var$SvgGlyphiconsBasic346SelfWindingCord;




const $e5dbbd47a8b12d21$var$SvgGlyphiconsBasic347IdBadge = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.001 9H15V4h2ZM28 11v13a3.009 3.009 0 0 1-3 3H7a3.009 3.009 0 0 1-3-3V11a3.009 3.009 0 0 1 3-3h6v1a2.002 2.002 0 0 0 2 2h2a2.002 2.002 0 0 0 2-2V8h6a3.009 3.009 0 0 1 3 3Zm-8 11.549a1 1 0 0 0-.463-.844L18 20.728l.145-1.16a1.458 1.458 0 0 0 .76-.798l.107-.321a.73.73 0 0 0-.054-.626v-1.802a2.958 2.958 0 1 0-5.916 0v1.802a.73.73 0 0 0-.054.626l.107.321a1.458 1.458 0 0 0 .76.798l.145 1.16-1.537.977a1 1 0 0 0-.463.844v.951a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5Z"
        })
    });
var $e5dbbd47a8b12d21$export$2e2bcd8739ae039 = $e5dbbd47a8b12d21$var$SvgGlyphiconsBasic347IdBadge;




const $a1805f41d0876d4e$var$SvgGlyphiconsBasic348IdBadgeVertical = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.001 8H15V3h2ZM26 9v16a3.009 3.009 0 0 1-3 3H9a3.009 3.009 0 0 1-3-3V9a3.009 3.009 0 0 1 3-3h4v2a2.002 2.002 0 0 0 2 2h2a2.002 2.002 0 0 0 2-2V6h4a3.009 3.009 0 0 1 3 3Zm-6 13.549a1 1 0 0 0-.463-.844L18 20.728l.145-1.16a1.458 1.458 0 0 0 .76-.798l.107-.321a.73.73 0 0 0-.054-.626v-1.802a2.958 2.958 0 1 0-5.916 0v1.802a.73.73 0 0 0-.054.626l.107.321a1.458 1.458 0 0 0 .76.798l.145 1.16-1.537.977a1 1 0 0 0-.463.844v.951a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5Z"
        })
    });
var $a1805f41d0876d4e$export$2e2bcd8739ae039 = $a1805f41d0876d4e$var$SvgGlyphiconsBasic348IdBadgeVertical;




const $1d9a7e45c3da04a6$var$SvgGlyphiconsBasic349IdBinder = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h2v-1h-.5a.501.501 0 0 1-.5-.5v-2a.501.501 0 0 1 .5-.5h3a.501.501 0 0 1 .5.5v2a.501.501 0 0 1-.5.5H12v1h8v-1h-.5a.501.501 0 0 1-.5-.5v-2a.501.501 0 0 1 .5-.5h3a.501.501 0 0 1 .5.5v2a.501.501 0 0 1-.5.5H22v1h2a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3Zm-4 13.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-.951a1 1 0 0 1 .463-.844L14 15.728l-.145-1.16a1.458 1.458 0 0 1-.76-.798l-.107-.321a.73.73 0 0 1 .054-.626v-1.802a2.958 2.958 0 1 1 5.916 0v1.802a.73.73 0 0 1 .054.626l-.107.321a1.458 1.458 0 0 1-.76.798L18 15.728l1.537.977a1 1 0 0 1 .463.844Z"
        })
    });
var $1d9a7e45c3da04a6$export$2e2bcd8739ae039 = $1d9a7e45c3da04a6$var$SvgGlyphiconsBasic349IdBinder;




const $4fc10ff478a9548c$var$SvgGlyphiconsBasic35UserIncognito = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m15.621 9.991-5.924-.658 1.73-5.381a1.064 1.064 0 0 1 1.273-.695L15.5 4l2.8-.743a1.064 1.064 0 0 1 1.273.695l1.733 5.39ZM6.64 12.412l2.954.838c.012.05.016.098.033.15l1.882 5.7a2.96 2.96 0 0 0 2.627 1.9h2.728a2.96 2.96 0 0 0 2.627-1.9l1.882-5.7c.014-.042.016-.08.027-.121l2.966-.865a.5.5 0 0 0 .351-.573l-.157-.834a.5.5 0 0 0-.54-.405l-.314.03-8.08 1.377-8.311-1.378-.34-.031a.5.5 0 0 0-.538.407l-.153.834a.5.5 0 0 0 .356.571Zm19.429 10.46-4.918-2.59A4.97 4.97 0 0 1 16.863 23h-2.726a4.97 4.97 0 0 1-4.288-2.718l-4.918 2.59A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365Z"
        })
    });
var $4fc10ff478a9548c$export$2e2bcd8739ae039 = $4fc10ff478a9548c$var$SvgGlyphiconsBasic35UserIncognito;




const $6287924da417ce7e$var$SvgGlyphiconsBasic350LockOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 14v12a2.006 2.006 0 0 1-2 2H7.967L24 11.967V12h1a2.006 2.006 0 0 1 2 2Zm.215-8.94L5.06 27.215a1.5 1.5 0 0 1-2.122-2.12L5 23.032V14a2.006 2.006 0 0 1 2-2h1V9a5.006 5.006 0 0 1 5-5h6a4.947 4.947 0 0 1 3.535 1.498l2.559-2.559a1.5 1.5 0 0 1 2.12 2.122Zm-7.498 3.256A.994.994 0 0 0 19 8h-6a1.013 1.013 0 0 0-1 1v3h4.033Z"
        })
    });
var $6287924da417ce7e$export$2e2bcd8739ae039 = $6287924da417ce7e$var$SvgGlyphiconsBasic350LockOff;




const $6d12b2c4b39e351b$var$SvgGlyphiconsBasic351Link = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 13.5v5a4.5 4.5 0 0 1-4.5 4.5h-7a4.5 4.5 0 0 1-4.5-4.5V15a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5h-1.64a.5.5 0 0 1-.474-.342l-.667-2A.5.5 0 0 1 21.194 9H23.5a4.5 4.5 0 0 1 4.5 4.5Zm-17.386 6.842A.5.5 0 0 0 10.14 20H8.5A1.5 1.5 0 0 1 7 18.5v-5A1.5 1.5 0 0 1 8.5 12h7a1.5 1.5 0 0 1 1.5 1.5V17a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3.5A4.5 4.5 0 0 0 15.5 9h-7A4.5 4.5 0 0 0 4 13.5v5A4.5 4.5 0 0 0 8.5 23h2.306a.5.5 0 0 0 .475-.658Z"
        })
    });
var $6d12b2c4b39e351b$export$2e2bcd8739ae039 = $6d12b2c4b39e351b$var$SvgGlyphiconsBasic351Link;




const $094678927b9ccdf4$var$SvgGlyphiconsBasic352LinkRemove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30 13.5v5a4.5 4.5 0 0 1-4.5 4.5H19a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6.5a1.5 1.5 0 0 0 1.5-1.5v-5a1.5 1.5 0 0 0-1.5-1.5H19a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6.5a4.5 4.5 0 0 1 4.5 4.5ZM19.345 6.924a.999.999 0 0 0 1.306-.54l.865-2.089a1 1 0 1 0-1.848-.763l-.864 2.085a1 1 0 0 0 .54 1.307Zm-7.996-.54a1 1 0 0 0 1.847-.767l-.864-2.085a1 1 0 1 0-1.848.763ZM16 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Zm-3 7H6.5A4.5 4.5 0 0 0 2 13.5v5A4.5 4.5 0 0 0 6.5 23H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H6.5A1.5 1.5 0 0 1 5 18.5v-5A1.5 1.5 0 0 1 6.5 12H13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm7.651 16.617a1 1 0 0 0-1.847.766l.864 2.085a1 1 0 1 0 1.848-.763ZM16 26a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1Zm-3.345-.924a1.002 1.002 0 0 0-1.306.54l-.865 2.089a1 1 0 1 0 1.848.763l.864-2.085a1 1 0 0 0-.54-1.307Z"
        })
    });
var $094678927b9ccdf4$export$2e2bcd8739ae039 = $094678927b9ccdf4$var$SvgGlyphiconsBasic352LinkRemove;




const $5c9239055a22c7c6$var$SvgGlyphiconsBasic353Bank = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24.5v3a.5.5 0 0 1-.5.5h-21a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H7v-9h4v9h3v-9h4v9h3v-9h4v9h1.5a.5.5 0 0 1 .5.5Zm.641-14.68-11.382-5.7a.65.65 0 0 0-.583 0L4.358 9.82A.65.65 0 0 0 4 10.4v1.95a.65.65 0 0 0 .65.65h22.7a.65.65 0 0 0 .65-.65v-1.949a.65.65 0 0 0-.359-.58Z"
        })
    });
var $5c9239055a22c7c6$export$2e2bcd8739ae039 = $5c9239055a22c7c6$var$SvgGlyphiconsBasic353Bank;




const $da4631627f97c043$var$SvgGlyphiconsBasic354ScissorsCutting = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m13.54 21.816-3.722-1.647a3.76 3.76 0 0 1-1.528-1.12l-.29.185-2.835 1.782a2.503 2.503 0 0 0-.753 3.454l2.1 3.366a2.503 2.503 0 0 0 3.455.753l2.168-1.352a3.516 3.516 0 0 0 1.632-3.287Zm-2.586 2.846-1.736 1.142a.5.5 0 0 1-.691-.15L7.307 23.8a.52.52 0 0 1 .21-.691l2.537-1.695a.5.5 0 0 1 .768.372l.359 2.406a.499.499 0 0 1-.227.47Zm16.43-16.176a1 1 0 0 1-.301 1.382l-7.143 4.918-4.546-3.13.011-.11 9.767-4.323a1.5 1.5 0 0 1 1.784.596ZM30 19.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm-16.722-6.873.489-4.577a3.516 3.516 0 0 0-1.632-3.287L9.967 3.411a2.503 2.503 0 0 0-3.454.753L4.412 7.53a2.503 2.503 0 0 0 .753 3.455L8 12.765l1.262.81.089 2.999a2.001 2.001 0 0 0 1.277 1.766l1.49.66H16v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V19h2v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1.604a.5.5 0 0 0-.216-.412Zm-2.456-2.414a.5.5 0 0 1-.768.372L7.517 8.89a.52.52 0 0 1-.21-.69l1.22-1.854a.5.5 0 0 1 .69-.15l1.737 1.142a.5.5 0 0 1 .227.469Zm3.43 6.604a1.5 1.5 0 1 1-.452-2.072 1.502 1.502 0 0 1 .451 2.072ZM26 19.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $da4631627f97c043$export$2e2bcd8739ae039 = $da4631627f97c043$var$SvgGlyphiconsBasic354ScissorsCutting;




const $3e03599ff592eec7$var$SvgGlyphiconsBasic355Mouse = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 8.294V7a1 1 0 0 0-1-1h-1V2h-2v4h-1a1 1 0 0 0-1 1v1.294A7 7 0 0 0 8 15v7a7 7 0 0 0 7 7h2a7 7 0 0 0 7-7v-7a7 7 0 0 0-5-6.706ZM18 15.5a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5Z"
        })
    });
var $3e03599ff592eec7$export$2e2bcd8739ae039 = $3e03599ff592eec7$var$SvgGlyphiconsBasic355Mouse;




const $00b40af949c7d62c$var$SvgGlyphiconsBasic356MouseWireless = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11.58 3.397a1 1 0 0 1 0-1.414 6.252 6.252 0 0 1 8.84 0 1 1 0 0 1-1.414 1.415 4.25 4.25 0 0 0-6.012 0 1 1 0 0 1-1.414-.001Zm1.769 1.354a1 1 0 1 0 1.414 1.414 1.794 1.794 0 0 1 2.474 0 1 1 0 1 0 1.414-1.414 3.839 3.839 0 0 0-5.302 0ZM24 15v7a7 7 0 0 1-7 7h-2a7 7 0 0 1-7-7v-7a7 7 0 0 1 7-7h2a7 7 0 0 1 7 7Zm-6-2.5a1.5 1.5 0 0 0-1.5-1.5h-1a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5-1.5Z"
        })
    });
var $00b40af949c7d62c$export$2e2bcd8739ae039 = $00b40af949c7d62c$var$SvgGlyphiconsBasic356MouseWireless;




const $93f47e4c850d44fb$var$SvgGlyphiconsBasic357Keyboard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 10H19V9a1 1 0 0 0-1-1h-1V4h-2v4h-1a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1Zm-8 3.25a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM19.25 17h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25Zm-2.25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25Zm0-4a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25Zm-4 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM11.25 17h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25ZM9 13.25a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25Zm-4 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM8.75 19h-3.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25ZM23 22.75a.25.25 0 0 1-.25.25H9.25a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h13.5a.25.25 0 0 1 .25.25Zm4-4a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25Zm0-4a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25Z"
        })
    });
var $93f47e4c850d44fb$export$2e2bcd8739ae039 = $93f47e4c850d44fb$var$SvgGlyphiconsBasic357Keyboard;




const $edc1dbee358ccce1$var$SvgGlyphiconsBasic358KeyboardWireless = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 10H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1Zm-8 3.25a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM19.25 17h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25ZM17 13.25a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM15.25 17h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25ZM13 13.25a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM11.25 17h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25ZM9 13.25a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25Zm-4 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25ZM8.75 19h-3.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 1-.25.25ZM23 22.75a.25.25 0 0 1-.25.25H9.25a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h13.5a.25.25 0 0 1 .25.25Zm4-4a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25Zm0-4a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25ZM11.58 5.397a1 1 0 0 1 0-1.414 6.252 6.252 0 0 1 8.84 0 1 1 0 0 1-1.414 1.415 4.25 4.25 0 0 0-6.012 0 1 1 0 0 1-1.414-.001Zm7.071 1.354a1 1 0 1 1-1.414 1.414 1.794 1.794 0 0 0-2.474 0 1 1 0 1 1-1.414-1.414 3.839 3.839 0 0 1 5.302 0Z"
        })
    });
var $edc1dbee358ccce1$export$2e2bcd8739ae039 = $edc1dbee358ccce1$var$SvgGlyphiconsBasic358KeyboardWireless;




const $f7dead5bb6a8bbb4$var$SvgGlyphiconsBasic359GraphicTablet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 24H10V14h10.397l4-4H19V9a1 1 0 0 0-1-1h-1V4h-2v4h-1a1 1 0 0 0-1 1v1H6.5A2.503 2.503 0 0 0 4 12.5v13A2.503 2.503 0 0 0 6.5 28h19a2.503 2.503 0 0 0 2.5-2.5v-7.899l-4 4ZM8 19.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm21.64-6.368-6.572 6.573-2.774-2.774 6.573-6.573a1.223 1.223 0 0 1 1.73 0l1.044 1.044a1.223 1.223 0 0 1 0 1.73Zm-11.618 7.993 1.6-3.136 2.388 2.388-3.136 1.6a.619.619 0 0 1-.852-.852Z"
        })
    });
var $f7dead5bb6a8bbb4$export$2e2bcd8739ae039 = $f7dead5bb6a8bbb4$var$SvgGlyphiconsBasic359GraphicTablet;




const $586c2792d19b2311$var$SvgGlyphiconsBasic36UserFemale = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 24.237V27a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2.763a1.677 1.677 0 0 1 .914-1.407l5.134-2.285A4.892 4.892 0 0 0 15.158 23h.685a4.892 4.892 0 0 0 4.108-2.455l5.135 2.285A1.677 1.677 0 0 1 26 24.237ZM7.91 18.024a16.234 16.234 0 0 0 4.711 1.193A2.893 2.893 0 0 0 15.157 21h.686a2.894 2.894 0 0 0 2.534-1.779 16.827 16.827 0 0 0 4.398-1.06.992.992 0 0 0 .481-1.457C20.522 12.755 23.57 5 18 5c-3-3-8-1-9 3-.836 3.342-.136 5.608-1.568 8.705a.993.993 0 0 0 .477 1.32Z"
        })
    });
var $586c2792d19b2311$export$2e2bcd8739ae039 = $586c2792d19b2311$var$SvgGlyphiconsBasic36UserFemale;




const $6c3803ec9092ce35$var$SvgGlyphiconsBasic360GraphicTabletWireless = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18.651 6.751a1 1 0 1 1-1.414 1.414 1.794 1.794 0 0 0-2.474 0 1 1 0 1 1-1.414-1.414 3.839 3.839 0 0 1 5.302 0Zm-5.657-1.353a4.25 4.25 0 0 1 6.012 0 1 1 0 0 0 1.414-1.415 6.252 6.252 0 0 0-8.84 0 1 1 0 0 0 1.414 1.415Zm5.118 16.49a.697.697 0 0 0 .762.089l3.136-1.6-2.388-2.388-1.6 3.136a.697.697 0 0 0 .09.762ZM29.64 11.401l-1.044-1.044a1.223 1.223 0 0 0-1.73 0l-6.573 6.573 2.774 2.774 6.573-6.573a1.223 1.223 0 0 0 0-1.73ZM24 21.601l4-4V25.5a2.503 2.503 0 0 1-2.5 2.5h-19A2.503 2.503 0 0 1 4 25.5v-13A2.503 2.503 0 0 1 6.5 10h17.897l-4 4H10v10h14ZM8 18.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z"
        })
    });
var $6c3803ec9092ce35$export$2e2bcd8739ae039 = $6c3803ec9092ce35$var$SvgGlyphiconsBasic360GraphicTabletWireless;




const $7c8ab648d29a355b$var$SvgGlyphiconsBasic361TShirt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.361 5.7a.51.51 0 0 1 .465-.7l6.35-.001a.51.51 0 0 1 .465.701A3.538 3.538 0 0 1 16 8a3.535 3.535 0 0 1-3.639-2.3Zm17.893 7.325-5.831-5.618a3.001 3.001 0 0 0-.968-.625l-1.837-.735A5.54 5.54 0 0 1 16 10a5.54 5.54 0 0 1-5.619-3.953l-1.836.735a3.001 3.001 0 0 0-.968.625l-5.831 5.618a.5.5 0 0 0-.007.714l3.529 3.529a.5.5 0 0 0 .707 0L9 14.242V27.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V14.242l3.025 3.026a.5.5 0 0 0 .707 0l3.529-3.529a.5.5 0 0 0-.007-.714Z"
        })
    });
var $7c8ab648d29a355b$export$2e2bcd8739ae039 = $7c8ab648d29a355b$var$SvgGlyphiconsBasic361TShirt;




const $ae38a4a641d45547$var$SvgGlyphiconsBasic362TShirtV = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.882 5.825a.5.5 0 0 1 .38-.825h5.478a.5.5 0 0 1 .38.825l-2.738 3.197a.5.5 0 0 1-.76 0Zm17.372 7.2-5.831-5.618a3.001 3.001 0 0 0-.968-.625l-1.879-.752-4.058 4.735a1.998 1.998 0 0 1-3.036 0L10.424 6.03l-1.88.752a3.001 3.001 0 0 0-.967.625l-5.831 5.618a.5.5 0 0 0-.007.714l3.529 3.529a.5.5 0 0 0 .707 0L9 14.242V27.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V14.242l3.025 3.026a.5.5 0 0 0 .707 0l3.529-3.529a.5.5 0 0 0-.007-.714Z"
        })
    });
var $ae38a4a641d45547$export$2e2bcd8739ae039 = $ae38a4a641d45547$var$SvgGlyphiconsBasic362TShirtV;




const $1331025dce149bd9$var$SvgGlyphiconsBasic363TShirtSleeves = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.4 24.777-3.73 1.446a.5.5 0 0 1-.646-.285L23 18.139V27.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9.36l-3.024 7.798a.5.5 0 0 1-.647.285l-3.728-1.446a.5.5 0 0 1-.285-.648L7.684 7.808a2 2 0 0 1 1.12-1.13l1.576-.63A5.54 5.54 0 0 0 16 10a5.54 5.54 0 0 0 5.618-3.953l1.577.63a2 2 0 0 1 1.12 1.13l6.37 16.322a.5.5 0 0 1-.286.648ZM16 8a3.538 3.538 0 0 0 3.64-2.3.51.51 0 0 0-.464-.701h-6.35a.51.51 0 0 0-.465.702A3.535 3.535 0 0 0 16 8Z"
        })
    });
var $1331025dce149bd9$export$2e2bcd8739ae039 = $1331025dce149bd9$var$SvgGlyphiconsBasic363TShirtSleeves;




const $9c9ba73907572dc3$var$SvgGlyphiconsBasic364Shirt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.4 24.777-3.73 1.446a.5.5 0 0 1-.646-.285L23 18.139V26c-.722 1.724-3.976 3-7 3s-6.278-1.276-7-3v-7.86l-3.024 7.798a.5.5 0 0 1-.647.285l-3.728-1.446a.5.5 0 0 1-.285-.648L7.684 7.808a2 2 0 0 1 1.12-1.13l.785-.314.625 3.568a2 2 0 0 0 2.935 1.407l1.886-1.038a2 2 0 0 1 1.929 0l1.886 1.038a2 2 0 0 0 2.934-1.407l.625-3.568.785.314a2 2 0 0 1 1.12 1.13l6.37 16.321a.5.5 0 0 1-.286.648ZM11.827 9.312a.5.5 0 0 0 .762.294l1.994-1.329a.5.5 0 0 0 .139-.693l-1.205-1.807A.5.5 0 0 1 13.934 5h4.132a.5.5 0 0 1 .416.777l-1.205 1.807a.5.5 0 0 0 .139.693l1.994 1.33a.5.5 0 0 0 .762-.295l.738-2.954a2.999 2.999 0 0 0 .09-.727V5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v.63a2.999 2.999 0 0 0 .09.728Z"
        })
    });
var $9c9ba73907572dc3$export$2e2bcd8739ae039 = $9c9ba73907572dc3$var$SvgGlyphiconsBasic364Shirt;




const $6bfe0f71898ff422$var$SvgGlyphiconsBasic365Tie = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.633 25.367-4.279 4.279a.5.5 0 0 1-.708 0l-4.28-4.294a1 1 0 0 1-.277-.879L13.447 11h5.106l2.358 13.488a1 1 0 0 1-.278.88ZM13.8 8.984 13.797 9h4.406l-.003-.016 1.47-3.292a.5.5 0 0 0-.31-.682l-3.214-.981a.5.5 0 0 0-.292 0l-3.213.982a.5.5 0 0 0-.31.682Z"
        })
    });
var $6bfe0f71898ff422$export$2e2bcd8739ae039 = $6bfe0f71898ff422$var$SvgGlyphiconsBasic365Tie;




const $56f93fe239c6864a$var$SvgGlyphiconsBasic366Trousers = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 6H9V4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5Zm.273 2H8.727l-2.65 19.432a.5.5 0 0 0 .496.568h6.01a.5.5 0 0 0 .492-.41L15.727 13h.546l2.652 14.59a.5.5 0 0 0 .492.41h6.01a.5.5 0 0 0 .496-.568Z"
        })
    });
var $56f93fe239c6864a$export$2e2bcd8739ae039 = $56f93fe239c6864a$var$SvgGlyphiconsBasic366Trousers;




const $c033accdae7f0cdc$var$SvgGlyphiconsBasic367Dress = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10.205 9.616A4 4 0 0 1 10 8.35V3.96a.96.96 0 1 1 1.919.01c.02 1.322.579 3.53 4.081 3.53s4.06-2.208 4.081-3.53A.96.96 0 1 1 22 3.96v4.39a4 4 0 0 1-.205 1.266l-.358 1.074c-.034.102-.05.207-.076.31H10.64c-.026-.103-.042-.208-.076-.31Zm11.26 3.684c-.036-.098-.053-.2-.08-.3h-10.77c-.027.1-.044.202-.08.3L6 26h.295c1 1.724 5.513 3 9.705 3s8.704-1.276 9.705-3H26Z"
        })
    });
var $c033accdae7f0cdc$export$2e2bcd8739ae039 = $c033accdae7f0cdc$var$SvgGlyphiconsBasic367Dress;




const $a616dcc57b2fc4b1$var$SvgGlyphiconsBasic368Underwear = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 6H5V4.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5Zm-6 2h-2v3a1 1 0 0 0 2 0Zm-4 3V8H5.095l-.912 7.445A.5.5 0 0 0 4.68 16h5.516a.5.5 0 0 0 .486-.384l.462-1.755A2.994 2.994 0 0 1 9 11Zm4.804 5h5.516a.5.5 0 0 0 .497-.555L18.905 8H15v3a2.994 2.994 0 0 1-2.144 2.86l.462 1.756a.5.5 0 0 0 .486.384ZM27.5 18h-14a.5.5 0 0 0-.5.5v1.58a.994.994 0 0 0 .85.982c2.366.359 4.411 2.293 5.462 6.177a1.011 1.011 0 0 0 .969.761h.445a1.016 1.016 0 0 0 .967-.75c1.104-3.783 3.745-5.72 5.542-6.154A1.025 1.025 0 0 0 28 20.089V18.5a.5.5 0 0 0-.5-.5Z"
        })
    });
var $a616dcc57b2fc4b1$export$2e2bcd8739ae039 = $a616dcc57b2fc4b1$var$SvgGlyphiconsBasic368Underwear;




const $9bea3c7a71b38517$var$SvgGlyphiconsBasic369Fabric = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.646 13.354 26.5 15.5l2.146 2.146a.5.5 0 0 1 0 .708L26.5 20.5l2.146 2.146a.5.5 0 0 1 0 .708l-2.292 2.292a.5.5 0 0 1-.708 0L23.5 23.5l-2.146 2.146a.5.5 0 0 1-.708 0L18.5 23.5l-2.146 2.146a.5.5 0 0 1-.708 0L13.5 23.5l-2.146 2.146a.5.5 0 0 1-.708 0L8.5 23.5l-2.146 2.146a.5.5 0 0 1-.708 0l-2.292-2.292a.5.5 0 0 1 0-.708L5.5 20.5l-2.146-2.146a.5.5 0 0 1 0-.708L5.5 15.5l-2.146-2.146a.5.5 0 0 1 0-.708L5.5 10.5 3.354 8.354a.5.5 0 0 1 0-.708l2.292-2.292a.5.5 0 0 1 .708 0L8.5 7.5l2.146-2.146a.5.5 0 0 1 .708 0L13.5 7.5l2.146-2.146a.5.5 0 0 1 .708 0L18.5 7.5l2.146-2.146a.5.5 0 0 1 .708 0L23.5 7.5l2.146-2.146a.5.5 0 0 1 .708 0l2.292 2.292a.5.5 0 0 1 0 .708L26.5 10.5l2.146 2.146a.5.5 0 0 1 0 .708Z"
        })
    });
var $9bea3c7a71b38517$export$2e2bcd8739ae039 = $9bea3c7a71b38517$var$SvgGlyphiconsBasic369Fabric;




const $fb1411d6c2c57e7c$var$SvgGlyphiconsBasic37File = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 11h5.5a.5.5 0 0 1 .5.5V27a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10.5a.5.5 0 0 1 .5.5V10a1 1 0 0 0 1 1Zm1.5-2H26l-5-5v4.5a.5.5 0 0 0 .5.5Z"
        })
    });
var $fb1411d6c2c57e7c$export$2e2bcd8739ae039 = $fb1411d6c2c57e7c$var$SvgGlyphiconsBasic37File;




const $5cf5dc3ffc161180$var$SvgGlyphiconsBasic370Leather = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.683 22.933-1.55 2.543a.496.496 0 0 1-.648.188 7.549 7.549 0 0 0-4.326-.688 5.961 5.961 0 0 0-3.955 2.689.243.243 0 0 1-.408 0 5.961 5.961 0 0 0-3.955-2.689 7.549 7.549 0 0 0-4.326.688.496.496 0 0 1-.648-.188l-1.55-2.543a.494.494 0 0 1 .116-.651c.993-.775 2.715-4.327 2.715-9.018a5.764 5.764 0 0 0-2.514-4.75.496.496 0 0 1-.102-.658l1.402-2.16a.494.494 0 0 1 .676-.156 5.312 5.312 0 0 0 3.654.732 3.08 3.08 0 0 0 2.645-1.94.497.497 0 0 1 .47-.332h3.242a.497.497 0 0 1 .47.333 3.08 3.08 0 0 0 2.645 1.939 5.312 5.312 0 0 0 3.654-.732.494.494 0 0 1 .676.157l1.402 2.159a.496.496 0 0 1-.102.658 5.764 5.764 0 0 0-2.514 4.75c0 4.69 1.722 8.243 2.715 9.018a.494.494 0 0 1 .116.65Z"
        })
    });
var $5cf5dc3ffc161180$export$2e2bcd8739ae039 = $5cf5dc3ffc161180$var$SvgGlyphiconsBasic370Leather;




const $464b3fd36ff0bd1a$var$SvgGlyphiconsBasic371Plus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 14v4a1 1 0 0 1-1 1h-7v7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-7H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h7V6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7h7a1 1 0 0 1 1 1Z"
        })
    });
var $464b3fd36ff0bd1a$export$2e2bcd8739ae039 = $464b3fd36ff0bd1a$var$SvgGlyphiconsBasic371Plus;




const $158d7a26243dbb39$var$SvgGlyphiconsBasic372Minus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Z"
        })
    });
var $158d7a26243dbb39$export$2e2bcd8739ae039 = $158d7a26243dbb39$var$SvgGlyphiconsBasic372Minus;




const $dceed6addde58781$var$SvgGlyphiconsBasic373Times = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.242 16 5.657 5.657-4.242 4.242L16 20.242 10.343 25.9 6.1 21.657 11.758 16 6.1 10.343l4.242-4.242L16 11.758 21.657 6.1l4.242 4.242Z"
        })
    });
var $dceed6addde58781$export$2e2bcd8739ae039 = $dceed6addde58781$var$SvgGlyphiconsBasic373Times;




const $44ee57a349c8efd2$var$SvgGlyphiconsBasic374Division = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Zm-9 7h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Zm-2-10h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2Z"
        })
    });
var $44ee57a349c8efd2$export$2e2bcd8739ae039 = $44ee57a349c8efd2$var$SvgGlyphiconsBasic374Division;




const $becd13b922513759$var$SvgGlyphiconsBasic375Equals = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 11v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Zm-1 7H7a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Z"
        })
    });
var $becd13b922513759$export$2e2bcd8739ae039 = $becd13b922513759$var$SvgGlyphiconsBasic375Equals;




const $7943d1ebb279b68b$var$SvgGlyphiconsBasic376Hanger = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.31 19.653-10.046-5.861c-.086-.05-.175-.089-.264-.13v-.833a.497.497 0 0 1 .146-.354l.829-.829A3.477 3.477 0 0 0 20 9.171V8.5A3.504 3.504 0 0 0 16.5 5h-1A3.504 3.504 0 0 0 12 8.5V9a1.5 1.5 0 0 0 3 0v-.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.671a.497.497 0 0 1-.146.354l-.829.829A3.477 3.477 0 0 0 15 12.829v.832c-.088.042-.178.081-.264.131L4.69 19.653A3.405 3.405 0 0 0 6.405 26h20.19a3.406 3.406 0 0 0 1.716-6.347ZM26.596 23H6.405a.406.406 0 0 1-.204-.756l10.047-5.86a.498.498 0 0 1 .504 0l10.047 5.86a.406.406 0 0 1-.204.756Z"
        })
    });
var $7943d1ebb279b68b$export$2e2bcd8739ae039 = $7943d1ebb279b68b$var$SvgGlyphiconsBasic376Hanger;




const $b8a9636f1e27eafe$var$SvgGlyphiconsBasic377Flower = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 11a13.537 13.537 0 0 1 1-5.172l2.943 1.943L16 3.715l3.057 4.056L22 5.828A13.537 13.537 0 0 1 23 11c0 3-2 6-7 6s-7-3-7-6Zm15.901 8.96a3.321 3.321 0 0 0-1.576-.691 4.245 4.245 0 0 0-5.066 2.876c-.017.055-.023.121-.038.178L17 23.028V18.96c-.324.024-.655.041-1 .041s-.676-.017-1-.04v4.068l-1.221-.705c-.015-.057-.021-.123-.038-.178a4.245 4.245 0 0 0-5.066-2.876 3.321 3.321 0 0 0-1.576.692 3.322 3.322 0 0 0 .189 1.71 4.245 4.245 0 0 0 5.024 2.95 5.683 5.683 0 0 0 .903-.313L15 25.338V27a1 1 0 0 0 2 0v-1.662l1.785-1.03a5.683 5.683 0 0 0 .903.313 4.245 4.245 0 0 0 5.024-2.95 3.322 3.322 0 0 0 .19-1.71Z"
        })
    });
var $b8a9636f1e27eafe$export$2e2bcd8739ae039 = $b8a9636f1e27eafe$var$SvgGlyphiconsBasic377Flower;




const $ef1e6cf839ccf180$var$SvgGlyphiconsBasic378Plant = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 16v1.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5V16a1 1 0 0 1 1-1h6v-2.162l-2.417-1.395C9.181 12.76 7.241 9.29 7.578 7.68c1.148-1.027 4.709-1.143 5.617 1.806L15 10.528v-2.5c-2.478-2.28-.523-5.507.993-6.005 1.513.497 3.464 3.714 1.007 5.993v2.512l1.805-1.042c.908-2.949 4.47-2.833 5.617-1.806.337 1.61-1.603 5.081-5.005 3.763L17 12.838V15h6a1 1 0 0 1 1 1ZM10.85 27.179a1 1 0 0 0 .985.821h8.33a1 1 0 0 0 .984-.821L22.455 20H9.545Z"
        })
    });
var $ef1e6cf839ccf180$export$2e2bcd8739ae039 = $ef1e6cf839ccf180$var$SvgGlyphiconsBasic378Plant;




const $45e034c428347e43$var$SvgGlyphiconsBasic379TreeConifer = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.527 23H18v3l.638 1.276a.5.5 0 0 1-.447.724h-4.382a.5.5 0 0 1-.447-.724L14 26v-3H7.473a.502.502 0 0 1-.384-.791l4.172-6.161H9.62a.503.503 0 0 1-.373-.806L13.808 9h-.807a.502.502 0 0 1-.388-.785l3.028-4.622a.458.458 0 0 1 .776 0l3.028 4.622a.502.502 0 0 1-.388.785h-.865l4.56 6.242a.503.503 0 0 1-.373.806h-1.64l4.172 6.16a.502.502 0 0 1-.384.792Z"
        })
    });
var $45e034c428347e43$export$2e2bcd8739ae039 = $45e034c428347e43$var$SvgGlyphiconsBasic379TreeConifer;




const $931071e957291e25$var$SvgGlyphiconsBasic38Picture = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.5 5h-23A1.5 1.5 0 0 0 3 6.5v19A1.5 1.5 0 0 0 4.5 27h23a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 27.5 5ZM26 18.5l-4.794-5.23a.994.994 0 0 0-1.445-.031l-5.347 5.347L19.828 24H17l-4.793-4.793a1 1 0 0 0-1.414 0L6 24V8h20Zm-17.9-6a2.4 2.4 0 1 1 2.4 2.4 2.4 2.4 0 0 1-2.4-2.4Z"
        })
    });
var $931071e957291e25$export$2e2bcd8739ae039 = $931071e957291e25$var$SvgGlyphiconsBasic38Picture;




const $af77e7a66dae513d$var$SvgGlyphiconsBasic380TreeDeciduous = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 16a5.987 5.987 0 0 1-8 5.651V26l.638 1.276a.5.5 0 0 1-.447.724h-4.382a.5.5 0 0 1-.447-.724L14 26v-4.349a5.995 5.995 0 0 1-6.656-9.432A4.495 4.495 0 0 1 11.5 6a4.455 4.455 0 0 1 .622.063 3.985 3.985 0 0 1 7.748-.026 4.466 4.466 0 0 1 4.027 5.406A5.982 5.982 0 0 1 26 16Z"
        })
    });
var $af77e7a66dae513d$export$2e2bcd8739ae039 = $af77e7a66dae513d$var$SvgGlyphiconsBasic380TreeDeciduous;




const $f4d5dad42a686c54$var$SvgGlyphiconsBasic381Bowling = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 5a11 11 0 1 0 11 11A11.012 11.012 0 0 0 16 5Zm-4.5 7a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm4 3a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-5A1.5 1.5 0 1 1 17 8.5a1.5 1.5 0 0 1-1.5 1.5Z"
        })
    });
var $f4d5dad42a686c54$export$2e2bcd8739ae039 = $f4d5dad42a686c54$var$SvgGlyphiconsBasic381Bowling;




const $8a91e9592ed4a2f2$var$SvgGlyphiconsBasic382Rugby = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m5.315 20.164 7.501 7.502c-3.328.334-5.997-.34-6.579-.923-.582-.582-1.256-3.25-.922-6.579ZM26.743 6.237c-.582-.582-3.25-1.257-6.579-.922l7.502 7.501c.334-3.328-.34-5.997-.923-6.579Zm-8.995-.51 9.506 9.506a16.209 16.209 0 0 1-12.02 12.02l-9.507-9.505a16.209 16.209 0 0 1 12.02-12.021Zm-.197 5.46-.707.707a.5.5 0 0 0 0 .707l1.06 1.061-1.414 1.414-1.06-1.06a.5.5 0 0 0-.707 0l-.707.707a.5.5 0 0 0 0 .707l1.06 1.06-1.414 1.415-1.06-1.061a.5.5 0 0 0-.708 0l-.707.707a.5.5 0 0 0 0 .707l1.06 1.06-.353.354a.5.5 0 0 0 0 .707l.707.707a.5.5 0 0 0 .707 0l.354-.353 1.06 1.06a.5.5 0 0 0 .708 0l.707-.706a.5.5 0 0 0 0-.707l-1.061-1.061 1.414-1.415 1.061 1.06a.5.5 0 0 0 .707 0l.707-.706a.5.5 0 0 0 0-.707l-1.06-1.06 1.414-1.415 1.06 1.06a.5.5 0 0 0 .707 0l.707-.706a.5.5 0 0 0 0-.708l-1.06-1.06.353-.354a.5.5 0 0 0 0-.707l-.707-.707a.5.5 0 0 0-.707 0l-.353.354-1.061-1.061a.5.5 0 0 0-.707 0Z"
        })
    });
var $8a91e9592ed4a2f2$export$2e2bcd8739ae039 = $8a91e9592ed4a2f2$var$SvgGlyphiconsBasic382Rugby;




const $e13de8a51f42da5e$var$SvgGlyphiconsBasic383TableTennis = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m11.04 21.526 1.132 1.13-5.015 5.016a1 1 0 0 1-1.414 0l-1.415-1.415a1 1 0 0 1 0-1.414l5.015-5.014ZM24.192 7.808c-4.95-4.95-9.9-2.829-13.364.636a8.021 8.021 0 0 0-2.55 7.492l7.663 7.662a8.055 8.055 0 0 0 7.615-2.426c2.758-2.758 5.586-8.415.636-13.364ZM25 23a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
        })
    });
var $e13de8a51f42da5e$export$2e2bcd8739ae039 = $e13de8a51f42da5e$var$SvgGlyphiconsBasic383TableTennis;




const $7a8ad13f291e8ae8$var$SvgGlyphiconsBasic384Basketball = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.575 13.161a7.854 7.854 0 0 0 1.938-4.486l.078-.858a5.812 5.812 0 0 1 .96-2.69 10.922 10.922 0 0 1 5.484 2.424L16 14.586Zm-.054-4.667.079-.86a7.788 7.788 0 0 1 .72-2.596A10.944 10.944 0 0 0 8.965 7.55l4.193 4.193a5.841 5.841 0 0 0 1.363-3.25Zm4.318 8.93a7.853 7.853 0 0 1 4.486-1.937l.858-.078a5.816 5.816 0 0 0 2.69-.96 10.923 10.923 0 0 0-2.424-5.484L17.414 16ZM8.494 14.522a5.841 5.841 0 0 0 3.25-1.363L7.55 8.965a10.944 10.944 0 0 0-2.513 6.355 7.797 7.797 0 0 1 2.597-.72Zm4.667.054a7.854 7.854 0 0 1-4.486 1.938l-.858.078a5.816 5.816 0 0 0-2.69.96 10.923 10.923 0 0 0 2.424 5.484L14.586 16Zm4.318 8.931-.079.86a7.788 7.788 0 0 1-.72 2.596 10.944 10.944 0 0 0 6.355-2.513l-4.193-4.193a5.842 5.842 0 0 0-1.363 3.25ZM16 17.414 8.965 24.45a10.922 10.922 0 0 0 5.483 2.424 5.811 5.811 0 0 0 .96-2.69l.079-.859a7.854 7.854 0 0 1 1.938-4.485Zm8.365-.013-.859.078a5.841 5.841 0 0 0-3.25 1.363l4.193 4.193a10.944 10.944 0 0 0 2.513-6.355 7.797 7.797 0 0 1-2.597.72Z"
        })
    });
var $7a8ad13f291e8ae8$export$2e2bcd8739ae039 = $7a8ad13f291e8ae8$var$SvgGlyphiconsBasic384Basketball;




const $c202d66c8b798bcb$var$SvgGlyphiconsBasic385Volleyball = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.075 5.627a11.905 11.905 0 0 0-5.978-1.594.974.974 0 0 0-.12.003 11.97 11.97 0 0 0-10.302 17.94.976.976 0 0 0 .06.112 11.974 11.974 0 0 0 10.32 5.937 12.077 12.077 0 0 0 3.127-.414 12 12 0 0 0 2.893-21.984Zm-5.503.414a9.949 9.949 0 0 1 8.89 6.551 9.853 9.853 0 0 0-1.123-.91 11.678 11.678 0 0 0-9.244-1.602 7.5 7.5 0 0 1 1.477-4.039Zm-6.391 5.138a13.103 13.103 0 0 1 1.138-3.94 10.059 10.059 0 0 1 2.794-1.01 9.424 9.424 0 0 0 .798 9.888 7.473 7.473 0 0 1-1.832 2.573 9.74 9.74 0 0 1-2.898-7.51Zm-2.994 9.4A9.89 9.89 0 0 1 8.404 9.62a9.855 9.855 0 0 0-.217 1.413 11.674 11.674 0 0 0 3.234 8.806 7.481 7.481 0 0 1-4.234.74Zm1.374 2.026a9.382 9.382 0 0 0 8.19-5.65 7.482 7.482 0 0 1 3.137.313 9.742 9.742 0 0 1-5.058 6.277 13.183 13.183 0 0 1-3.984.987 9.936 9.936 0 0 1-2.285-1.927Zm10.103 3.074a9.953 9.953 0 0 1-4.303.187 9.868 9.868 0 0 0 1.34-.52 11.679 11.679 0 0 0 6.003-7.185 7.47 7.47 0 0 1 2.75 3.296 9.916 9.916 0 0 1-5.79 4.222Zm6.88-6.45a9.42 9.42 0 0 0-8.996-4.262 7.502 7.502 0 0 1-1.298-2.873 9.746 9.746 0 0 1 7.966 1.242 13.128 13.128 0 0 1 2.853 2.97 9.928 9.928 0 0 1-.525 2.923Z"
        })
    });
var $c202d66c8b798bcb$export$2e2bcd8739ae039 = $c202d66c8b798bcb$var$SvgGlyphiconsBasic385Volleyball;




const $e45f7c17967c1aaa$var$SvgGlyphiconsBasic386Football = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm1 3.6 2.442-.977a10 10 0 0 1 2.957 1.701l.37 2.573-3.47 1.542L17 10.77Zm-7.399.724a9.998 9.998 0 0 1 2.957-1.7L15 7.6v3.178l-2.292 1.665-3.477-1.546Zm-3.18 10.534a9.698 9.698 0 0 1-.264-4.564l2.09-1.645 3.323 1.476 1.044 3.212L10.2 20.08Zm12.33 6.748a9.806 9.806 0 0 1-5.502 0l-1.47-4.292 2.112-2.401h4.218l2.112 2.401Zm3.048-5.526-2.403-2.732 1.05-3.23 3.306-1.47 2.091 1.646a9.698 9.698 0 0 1-.264 4.564Z"
        })
    });
var $e45f7c17967c1aaa$export$2e2bcd8739ae039 = $e45f7c17967c1aaa$var$SvgGlyphiconsBasic386Football;




const $ad19f9adff4094a2$var$SvgGlyphiconsBasic387Baseball = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24a3 3 0 1 1-3-3 3 3 0 0 1 3 3Zm.853-19.147-.706-.706a2 2 0 0 0-2.829 0l-8.586 8.585-5.293 6.707-4.792 4.793-.354-.353a.5.5 0 0 0-.707 0l-.707.707a.5.5 0 0 0 0 .707l2.828 2.828a.5.5 0 0 0 .707 0l.707-.707a.5.5 0 0 0 0-.707l-.353-.354 4.793-4.792 6.707-5.293 8.585-8.586a2 2 0 0 0 0-2.829Z"
        })
    });
var $ad19f9adff4094a2$export$2e2bcd8739ae039 = $ad19f9adff4094a2$var$SvgGlyphiconsBasic387Baseball;




const $5ba9510e15de43f0$var$SvgGlyphiconsBasic388Hockey = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.945 10.373 14.009 27.2a2 2 0 0 1-1.471.9l-6.317.652A2 2 0 0 1 4 26.766V24.19a2 2 0 0 1 2.181-1.992l4.668.424a3 3 0 0 0 2.786-1.352l8.673-12.592ZM26 24h-4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm1.857-18.843-1.342-.872a1 1 0 0 0-1.383.293L23.444 7.03l2.59 1.665 1.94-2.985a.4.4 0 0 0-.117-.553Z"
        })
    });
var $5ba9510e15de43f0$export$2e2bcd8739ae039 = $5ba9510e15de43f0$var$SvgGlyphiconsBasic388Hockey;




const $13c0eb931be01f25$var$SvgGlyphiconsBasic389Golf = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 25a2 2 0 1 1-2-2 2 2 0 0 1 2 2Zm.044-19.726L25.362 4.19a1 1 0 0 0-1.382.299l-5.69 8.789a.988.988 0 0 0 .087 1.177l-5.69 8.357a1 1 0 0 1-1.213.386l-3.5-1.404a2 2 0 0 0-2.642 1.224l-.45 2.35A2 2 0 0 0 6.782 28l4.508-.006a2 2 0 0 0 1.677-.915l7.316-11.33a.998.998 0 0 0 1.37-.304l5.69-8.79a1 1 0 0 0-.299-1.381Z"
        })
    });
var $13c0eb931be01f25$export$2e2bcd8739ae039 = $13c0eb931be01f25$var$SvgGlyphiconsBasic389Golf;




const $cf507154190949d7$var$SvgGlyphiconsBasic39Airplane = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 20.48v1.042a1 1 0 0 1-1.372.928l-7.99-3.2-.597 5.383 2.771 2.217a.5.5 0 0 1 .188.39v1.021a.5.5 0 0 1-.686.465L16 27l-4.314 1.726A.5.5 0 0 1 11 28.26v-1.02a.5.5 0 0 1 .188-.391l2.771-2.217-.598-5.383-7.99 3.2A1 1 0 0 1 4 21.522v-1.041a1 1 0 0 1 .375-.781L13 12.802V7a3 3 0 0 1 6 0v5.802l8.625 6.898a1 1 0 0 1 .375.78Z"
        })
    });
var $cf507154190949d7$export$2e2bcd8739ae039 = $cf507154190949d7$var$SvgGlyphiconsBasic39Airplane;




const $cf3f527afb9073f1$var$SvgGlyphiconsBasic390GolfGreen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.5 17.792a28.391 28.391 0 0 0-4.5.353V13.25l7.503-2.814a1 1 0 0 0 0-1.872L11 5.75V5a1 1 0 0 0-2 0v13.557c-3.593.915-6 2.56-6 4.443 0 2.876 5.596 5.208 12.5 5.208S28 25.876 28 23s-5.596-5.208-12.5-5.208ZM9 24.408c-1.163-.206-2-.756-2-1.408s.837-1.202 2-1.408Zm2 0v-2.816c1.163.206 2 .756 2 1.408s-.837 1.202-2 1.408ZM22.5 25a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Z"
        })
    });
var $cf3f527afb9073f1$export$2e2bcd8739ae039 = $cf3f527afb9073f1$var$SvgGlyphiconsBasic390GolfGreen;




const $4621d8e52eb24c48$var$SvgGlyphiconsBasic391Winners = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.584 7.645A2.403 2.403 0 0 1 13 6.214V4.545A.524.524 0 0 1 13.5 4h5a.524.524 0 0 1 .5.545v1.669a2.403 2.403 0 0 1-.584 1.43L17 10v1h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h.5v-1ZM27 19h-5v4a1 1 0 0 1-2 0v-8a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v8a1 1 0 0 1-2 0v-6H5a1 1 0 0 0-1 1v10h24v-8a1 1 0 0 0-1-1Z"
        })
    });
var $4621d8e52eb24c48$export$2e2bcd8739ae039 = $4621d8e52eb24c48$var$SvgGlyphiconsBasic391Winners;




const $a1d7834fba54113a$var$SvgGlyphiconsBasic392WinnersStars = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 20v8H4V18a1 1 0 0 1 1-1h5v6a1 1 0 0 0 2 0v-8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8a1 1 0 0 0 2 0v-4h5a1 1 0 0 1 1 1ZM14.287 8.061l-.584 1.8a.5.5 0 0 0 .769.56l1.532-1.113 1.532 1.113a.5.5 0 0 0 .77-.56l-.585-1.8 1.534-1.114a.5.5 0 0 0-.294-.905h-1.896L16.48 4.24a.5.5 0 0 0-.951 0l-.586 1.803h-1.896a.5.5 0 0 0-.294.905Zm-8.77 3.844-.507 1.56a.433.433 0 0 0 .667.484l1.327-.964 1.327.964a.433.433 0 0 0 .667-.484l-.507-1.56 1.33-.966a.433.433 0 0 0-.255-.784H7.923l-.507-1.562a.433.433 0 0 0-.824 0l-.507 1.562H4.442a.433.433 0 0 0-.254.784Zm18 2-.507 1.56a.433.433 0 0 0 .667.484l1.327-.964 1.327.964a.433.433 0 0 0 .667-.484l-.507-1.56 1.33-.966a.433.433 0 0 0-.255-.784h-1.643l-.507-1.562a.433.433 0 0 0-.824 0l-.507 1.562h-1.643a.433.433 0 0 0-.254.784Z"
        })
    });
var $a1d7834fba54113a$export$2e2bcd8739ae039 = $a1d7834fba54113a$var$SvgGlyphiconsBasic392WinnersStars;




const $fb8295234e4f912a$var$SvgGlyphiconsBasic393Medal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.277 12.243 16.86 6.55l1.7-2.55h7.211ZM15.5 11a9.498 9.498 0 0 1 1.805.177L12.998 4H6.001l4.912 8.186A9.437 9.437 0 0 1 15.5 11Zm0 2a7.5 7.5 0 1 0 7.5 7.5 7.5 7.5 0 0 0-7.5-7.5Z"
        })
    });
var $fb8295234e4f912a$export$2e2bcd8739ae039 = $fb8295234e4f912a$var$SvgGlyphiconsBasic393Medal;




const $f18e74f8587d107e$var$SvgGlyphiconsBasic394Dumbbell = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30 14.5v3a.5.5 0 0 1-.5.5H28v3a1 1 0 0 1-1 1h-3v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-5h-8v5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1H5a1 1 0 0 1-1-1v-3H2.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H4v-3a1 1 0 0 1 1-1h3V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h8V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v3h1.5a.5.5 0 0 1 .5.5Z"
        })
    });
var $f18e74f8587d107e$export$2e2bcd8739ae039 = $f18e74f8587d107e$var$SvgGlyphiconsBasic394Dumbbell;




const $cdfc8602ec22de0e$var$SvgGlyphiconsBasic395Filter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 5v1.62a1 1 0 0 1-.253.664L19 16v6.518a1 1 0 0 1-.36.768l-4.82 4.017a.5.5 0 0 1-.82-.384V16L5.253 7.284A1 1 0 0 1 5 6.62V5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1Z"
        })
    });
var $cdfc8602ec22de0e$export$2e2bcd8739ae039 = $cdfc8602ec22de0e$var$SvgGlyphiconsBasic395Filter;




const $5b2452b9f76464e2$var$SvgGlyphiconsBasic396FilterPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.84 12.806 19 16v6.518a1 1 0 0 1-.36.768l-4.82 4.017a.5.5 0 0 1-.82-.384V16L5.253 7.284A1 1 0 0 1 5 6.62V5a1 1 0 0 1 1-1h12.26a7.93 7.93 0 0 0 3.58 8.806ZM32 5.986a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1.5h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $5b2452b9f76464e2$export$2e2bcd8739ae039 = $5b2452b9f76464e2$var$SvgGlyphiconsBasic396FilterPlus;




const $7d9c70de537281c4$var$SvgGlyphiconsBasic397FilterMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.84 12.806 19 16v6.518a1 1 0 0 1-.36.768l-4.82 4.017a.5.5 0 0 1-.82-.384V16L5.253 7.284A1 1 0 0 1 5 6.62V5a1 1 0 0 1 1-1h12.26a7.93 7.93 0 0 0 3.58 8.806ZM32 5.986a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $7d9c70de537281c4$export$2e2bcd8739ae039 = $7d9c70de537281c4$var$SvgGlyphiconsBasic397FilterMinus;




const $c68a4fd02d923599$var$SvgGlyphiconsBasic398FilterCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.168 12.436 19 16v6.518a1 1 0 0 1-.36.768l-4.82 4.017a.5.5 0 0 1-.82-.384V16L5.253 7.284A1 1 0 0 1 5 6.62V5a1 1 0 0 1 1-1h12.779a7.446 7.446 0 0 0 3.39 8.436Zm9.538-6.082a.497.497 0 0 1-.379.47l-1.156.29a4.523 4.523 0 0 1-.43 1.04l.617 1.028a.504.504 0 0 1-.046.586 5.865 5.865 0 0 1-.539.542.497.497 0 0 1-.582.043l-1.03-.62a4.417 4.417 0 0 1-1.042.432l-.29 1.156a.498.498 0 0 1-.471.38 15.89 15.89 0 0 1-.716 0 .497.497 0 0 1-.47-.38l-.29-1.156a4.404 4.404 0 0 1-1.04-.43l-1.03.617a.504.504 0 0 1-.586-.047 5.817 5.817 0 0 1-.541-.54.497.497 0 0 1-.043-.58l.619-1.032a4.347 4.347 0 0 1-.429-1.04l-1.157-.29a.498.498 0 0 1-.38-.471 15.979 15.979 0 0 1 .001-.716.497.497 0 0 1 .379-.47l1.157-.289a4.361 4.361 0 0 1 .43-1.041l-.618-1.03a.504.504 0 0 1 .047-.587 5.806 5.806 0 0 1 .54-.54.497.497 0 0 1 .58-.042l1.032.618a4.348 4.348 0 0 1 1.04-.429l.29-1.157a.498.498 0 0 1 .471-.38c.225-.005.494-.004.716.001a.497.497 0 0 1 .47.379l.29 1.157a4.324 4.324 0 0 1 1.04.429l1.028-.617a.504.504 0 0 1 .586.046 5.852 5.852 0 0 1 .542.539.497.497 0 0 1 .043.582l-.619 1.03a4.414 4.414 0 0 1 .43 1.042l1.157.29a.498.498 0 0 1 .38.471c.005.225.004.494-.001.716Zm-3.558-.36A2.147 2.147 0 1 0 26 8.143a2.15 2.15 0 0 0 2.148-2.149Z"
        })
    });
var $c68a4fd02d923599$export$2e2bcd8739ae039 = $c68a4fd02d923599$var$SvgGlyphiconsBasic398FilterCogwheel;




const $9a230dbde7da0c56$var$SvgGlyphiconsBasic399Import = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 23v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-15.635-9.436-1.83 1.83a1 1 0 0 0 .543 1.693l9.43 1.572a1 1 0 0 0 1.15-1.15l-1.57-9.431a1 1 0 0 0-1.694-.543L16.549 9.38c-3.883-3.106-9.943-2.768-13.296-.75a.87.87 0 0 0-.4.837.879.879 0 0 0 .95.79 9.744 9.744 0 0 1 8.562 3.307Z"
        })
    });
var $9a230dbde7da0c56$export$2e2bcd8739ae039 = $9a230dbde7da0c56$var$SvgGlyphiconsBasic399Import;




const $8ed7ed5dd5cd5ae4$var$SvgGlyphiconsBasic4User = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24.237V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.763a1.578 1.578 0 0 1 .931-1.365l5.136-2.705A5.024 5.024 0 0 0 14.553 23h1.894a5.023 5.023 0 0 0 4.486-2.833l5.136 2.705A1.578 1.578 0 0 1 27 24.237ZM9.645 14.126a2.991 2.991 0 0 0 1.31 1.462l.666 3.051A3 3 0 0 0 14.552 21h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a2.991 2.991 0 0 0 1.311-1.462l.28-.752A1.275 1.275 0 0 0 21 11.63V9c0-3-2-5-5.5-5S10 6 10 9v2.63a1.275 1.275 0 0 0-.635 1.744Z"
        })
    });
var $8ed7ed5dd5cd5ae4$export$2e2bcd8739ae039 = $8ed7ed5dd5cd5ae4$var$SvgGlyphiconsBasic4User;




const $969a7287fb200f84$var$SvgGlyphiconsBasic40Notes = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 22.5v1a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5Zm-.5-4.5h-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-11a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM26 7v19a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h.5a2 2 0 0 1 2 2Zm-1.999 19L24 11H8v15Z"
        })
    });
var $969a7287fb200f84$export$2e2bcd8739ae039 = $969a7287fb200f84$var$SvgGlyphiconsBasic40Notes;




const $2666f5463fe2e2dd$var$SvgGlyphiconsBasic400Export = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 23v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm.36-11.814L20.582 5.63A1 1 0 0 0 19 6.443v2.613c-4.94.55-8.985 5.074-9.93 8.871a.87.87 0 0 0 .31.875.879.879 0 0 0 1.232-.113A9.743 9.743 0 0 1 19 14.973v2.584a1 1 0 0 0 1.581.814l7.78-5.557a1 1 0 0 0 0-1.628Z"
        })
    });
var $2666f5463fe2e2dd$export$2e2bcd8739ae039 = $2666f5463fe2e2dd$var$SvgGlyphiconsBasic400Export;




const $04a31dc5bb002e94$var$SvgGlyphiconsBasic401HardDrive = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 22H8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM26 7v13.556A3.954 3.954 0 0 0 24 20H8a3.954 3.954 0 0 0-2 .556V7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3Z"
        })
    });
var $04a31dc5bb002e94$export$2e2bcd8739ae039 = $04a31dc5bb002e94$var$SvgGlyphiconsBasic401HardDrive;




const $00c015478d6f0127$var$SvgGlyphiconsBasic402HardDriveCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31.706 6.354c.005-.222.006-.491 0-.716a.498.498 0 0 0-.379-.472l-1.156-.289a4.414 4.414 0 0 0-.43-1.041l.618-1.031a.497.497 0 0 0-.043-.582 5.854 5.854 0 0 0-.542-.539.504.504 0 0 0-.586-.046l-1.029.617a4.324 4.324 0 0 0-1.04-.429L26.83.67a.497.497 0 0 0-.47-.379 15.93 15.93 0 0 0-.715 0 .498.498 0 0 0-.472.379l-.29 1.157a4.348 4.348 0 0 0-1.04.429l-1.03-.619a.497.497 0 0 0-.581.043 5.804 5.804 0 0 0-.54.54.503.503 0 0 0-.047.587l.618 1.03a4.361 4.361 0 0 0-.43 1.041l-1.157.29a.497.497 0 0 0-.379.47c-.005.221-.006.49 0 .715a.498.498 0 0 0 .379.472l1.157.29a4.347 4.347 0 0 0 .429 1.04l-.619 1.03a.497.497 0 0 0 .043.581 5.815 5.815 0 0 0 .54.54.504.504 0 0 0 .588.047l1.029-.618a4.404 4.404 0 0 0 1.04.431l.29 1.156a.497.497 0 0 0 .47.38c.222.004.491.005.716 0a.498.498 0 0 0 .472-.38l.29-1.156a4.417 4.417 0 0 0 1.041-.432l1.03.62a.497.497 0 0 0 .582-.043 5.854 5.854 0 0 0 .539-.542.504.504 0 0 0 .046-.586l-.617-1.029a4.523 4.523 0 0 0 .43-1.04l1.156-.289a.497.497 0 0 0 .379-.47ZM26 8.143a2.147 2.147 0 1 1 2.148-2.149A2.15 2.15 0 0 1 26 8.143ZM24 22H8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm2-12.043v7.1A3.954 3.954 0 0 0 24 20H8a3.954 3.954 0 0 0-2 .556V7a3 3 0 0 1 3-3h9.823A7.438 7.438 0 0 0 26 13.457Z"
        })
    });
var $00c015478d6f0127$export$2e2bcd8739ae039 = $00c015478d6f0127$var$SvgGlyphiconsBasic402HardDriveCogwheel;




const $4c41442ba7579b92$var$SvgGlyphiconsBasic403HardDriveLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 4h-1V2a2.003 2.003 0 0 0-2-2h-3a2.003 2.003 0 0 0-2 2v2h-1a1.003 1.003 0 0 0-1 1v6a1.003 1.003 0 0 0 1 1h9a1.003 1.003 0 0 0 1-1V5a1.003 1.003 0 0 0-1-1Zm-6-1.75a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25V4h-3ZM24 22H8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM26 14v6.556A3.954 3.954 0 0 0 24 20H8a3.954 3.954 0 0 0-2 .556V7a3 3 0 0 1 3-3h10.176A2.976 2.976 0 0 0 19 5v6a3.003 3.003 0 0 0 3 3Z"
        })
    });
var $4c41442ba7579b92$export$2e2bcd8739ae039 = $4c41442ba7579b92$var$SvgGlyphiconsBasic403HardDriveLock;




const $0d351985491c0129$var$SvgGlyphiconsBasic404HardDriveEject = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 22H8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM26 12v8.556A3.954 3.954 0 0 0 24 20H8a3.954 3.954 0 0 0-2 .556V7a3 3 0 0 1 3-3h13.55A1.778 1.778 0 0 0 22 5.282V9.5a2.503 2.503 0 0 0 2.5 2.5Zm5.832-6.817L28.387.973a.5.5 0 0 0-.774 0l-3.445 4.21a.5.5 0 0 0 .387.817h6.89a.5.5 0 0 0 .387-.817ZM31.5 10h-7a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5Z"
        })
    });
var $0d351985491c0129$export$2e2bcd8739ae039 = $0d351985491c0129$var$SvgGlyphiconsBasic404HardDriveEject;




const $550ccdfa9ee6b936$var$SvgGlyphiconsBasic405Turtle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 16.46V18a1 1 0 0 1-1 1h-3.94A3.06 3.06 0 0 0 23 22.06V23a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4H3a1 1 0 0 1-1-1v-.22a1 1 0 0 1 .757-.97l2.281-.57A7.999 7.999 0 0 1 13 9h2a7.996 7.996 0 0 1 7.93 7h.628a2 2 0 0 0 1.898-1.367l.265-.796a1 1 0 0 1 1.144-.664l1.723.345A3 3 0 0 1 31 16.459Z"
        })
    });
var $550ccdfa9ee6b936$export$2e2bcd8739ae039 = $550ccdfa9ee6b936$var$SvgGlyphiconsBasic405Turtle;




const $b1e2eb9527972814$var$SvgGlyphiconsBasic406Rabbit = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.615 17.476-.56 2.528 4.157 2.518a1 1 0 0 1 .376 1.303l-.2.4a1 1 0 0 1-1.21.5L21 22l-3-2H5.621L3.44 22.182a1 1 0 0 1-1.414 0l-.706-.706a1 1 0 0 1 .001-1.416l3.652-3.64a1 1 0 0 1 .977-.254l1.279.36 2.464-2.15-1.33-.89a1.522 1.522 0 1 1 2.112-2.111l.997 1.45 8.093 1.783a3 3 0 0 0 3.024-1.101l.415-.539-5.522-1.363a2.334 2.334 0 1 1 1.824-4.229l6.299 4.058a1.984 1.984 0 0 1 1.465.34l2.922 2.117a2 2 0 0 1 .758 2.137l-.082.307a.5.5 0 0 1-.378.36Z"
        })
    });
var $b1e2eb9527972814$export$2e2bcd8739ae039 = $b1e2eb9527972814$var$SvgGlyphiconsBasic406Rabbit;




const $8eb537c331d4e170$var$SvgGlyphiconsBasic407Cat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.035 13.79-.389.34-.114.435a.65.65 0 0 1-.614.435h-1.794a2.327 2.327 0 0 0-1.775.822l-2.543 3C21.639 20.229 21 23.83 21 23.83v3.42a.75.75 0 0 1-.75.75h-.664a.75.75 0 0 1-.728-.568L17 20l-5.67-1.215a2 2 0 0 0-2.084.846L7 23l-.88 4.397a.75.75 0 0 1-.735.603H4.75a.75.75 0 0 1-.75-.75v-5.601a3.998 3.998 0 0 1 .205-1.265l2.25-6.75A5.635 5.635 0 0 1 5.5 10 3.342 3.342 0 0 0 2 6.5a1.5 1.5 0 0 1 0-3A6.317 6.317 0 0 1 8.5 10a6.751 6.751 0 0 0 .072 1.057l.602-.362a6.001 6.001 0 0 1 5.772-.222l2.678 1.839a4 4 0 0 0 4.393-.541s1.485-1.273 1.513-1.24a6.703 6.703 0 0 1 2.047-1.173l1.996-1.996A.25.25 0 0 1 28 7.54v2.167l.284.2a2.327 2.327 0 0 1 .805 1.005l1.092 2.105a.67.67 0 0 1-.146.774Z"
        })
    });
var $8eb537c331d4e170$export$2e2bcd8739ae039 = $8eb537c331d4e170$var$SvgGlyphiconsBasic407Cat;




const $df0244c66c0cd3d3$var$SvgGlyphiconsBasic408Sailboat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.856 21.622C27.658 26.167 23.787 28 19 28H6.66a1 1 0 0 1-.92-.606L3.3 21.697a.5.5 0 0 1 .46-.697h24.606a.505.505 0 0 1 .491.622ZM5.92 19H15.5a.5.5 0 0 0 .5-.5V3.693a.5.5 0 0 0-.92-.272L5.5 18.228a.5.5 0 0 0 .42.772ZM18.5 19h6.638a.5.5 0 0 0 .435-.748L18.934 6.635a.5.5 0 0 0-.934.248V18.5a.5.5 0 0 0 .5.5Z"
        })
    });
var $df0244c66c0cd3d3$export$2e2bcd8739ae039 = $df0244c66c0cd3d3$var$SvgGlyphiconsBasic408Sailboat;




const $0f9bb13b55f224ae$var$SvgGlyphiconsBasic409Webcam = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 5a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm0 14a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm2-4a2 2 0 0 1-4 0 1.974 1.974 0 0 1 .073-.507 1.493 1.493 0 0 0 1.42-1.42A1.975 1.975 0 0 1 16 13a2.002 2.002 0 0 1 2 2Zm2 11v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
        })
    });
var $0f9bb13b55f224ae$export$2e2bcd8739ae039 = $0f9bb13b55f224ae$var$SvgGlyphiconsBasic409Webcam;




const $387bbcadd72d78bd$var$SvgGlyphiconsBasic41Stats = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.386 22.79a1 1 0 0 1-.175-1.404l2.1-2.7A2.472 2.472 0 0 1 11 17.5a2.497 2.497 0 0 1 4.291-1.74l3.723-1.395A2.493 2.493 0 0 1 21.5 12c.043 0 .083.01.126.013l1.96-3.922A2.49 2.49 0 1 1 25.5 9c-.043 0-.083-.01-.126-.013l-1.96 3.922a2.492 2.492 0 0 1-3.705 3.33l-3.723 1.397a2.46 2.46 0 0 1-3.098 2.28l-2.099 2.698a1 1 0 0 1-1.403.176ZM27.5 24h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-2.5a.5.5 0 0 0-.5-.5Z"
        })
    });
var $387bbcadd72d78bd$export$2e2bcd8739ae039 = $387bbcadd72d78bd$var$SvgGlyphiconsBasic41Stats;




const $e07cd6f2fdcd6369$var$SvgGlyphiconsBasic410Projector = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 8h-2.106a6.989 6.989 0 0 0-9.788 0H5a2.006 2.006 0 0 0-2 2v11a2.006 2.006 0 0 0 2 2v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h13v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h1a2.006 2.006 0 0 0 2-2V10a2.006 2.006 0 0 0-2-2ZM8 20.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM20 17a4 4 0 1 1 4-4 4 4 0 0 1-4 4Zm2-4a2 2 0 0 1-4 0 1.974 1.974 0 0 1 .073-.507 1.493 1.493 0 0 0 1.42-1.42A1.975 1.975 0 0 1 20 11a2.002 2.002 0 0 1 2 2Z"
        })
    });
var $e07cd6f2fdcd6369$export$2e2bcd8739ae039 = $e07cd6f2fdcd6369$var$SvgGlyphiconsBasic410Projector;




const $211a209e9c5bceed$var$SvgGlyphiconsBasic411ShoppingBag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.031 12.467a.5.5 0 0 0-.499-.467H7.468a.5.5 0 0 0-.5.467L6.214 23.8A3 3 0 0 0 9.207 27h13.586a3 3 0 0 0 2.994-3.2ZM12 15.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm11 0a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM12.557 10H9.543l.104-1.047A5.484 5.484 0 0 1 15.12 4h1.76a5.484 5.484 0 0 1 5.473 4.952L22.457 10h-3.014l-.075-.749A2.493 2.493 0 0 0 16.88 7h-1.76a2.493 2.493 0 0 0-2.488 2.252Z"
        })
    });
var $211a209e9c5bceed$export$2e2bcd8739ae039 = $211a209e9c5bceed$var$SvgGlyphiconsBasic411ShoppingBag;




const $caf212cb72fd1aa2$var$SvgGlyphiconsBasic412Dice = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.692 12.086-7.778-7.778a2 2 0 0 0-2.828 0L13.393 11H17a4.004 4.004 0 0 1 4 4v2.754a1.493 1.493 0 1 1 0 2.806v2.647a1.991 1.991 0 0 0 1.914-.515l7.778-7.778a2 2 0 0 0 0-2.828Zm-8.131-3.182a1.5 1.5 0 1 1 0-2.122 1.5 1.5 0 0 1 0 2.122Zm5.657 5.657a1.5 1.5 0 1 1 0-2.122 1.5 1.5 0 0 1 0 2.122ZM17 13H6a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2ZM7.5 26A1.5 1.5 0 1 1 9 24.5 1.5 1.5 0 0 1 7.5 26Zm0-8A1.5 1.5 0 1 1 9 16.5 1.5 1.5 0 0 1 7.5 18Zm4 4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm4 4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm0-8a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Z"
        })
    });
var $caf212cb72fd1aa2$export$2e2bcd8739ae039 = $caf212cb72fd1aa2$var$SvgGlyphiconsBasic412Dice;




const $a39c138e1f3b6f98$var$SvgGlyphiconsBasic413GameController = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.787 27a2.705 2.705 0 0 1-2.488-1.644L20.016 21h-8.032L9.7 25.356a2.705 2.705 0 0 1-5.154-1.521L6 15c.43-2.196 1.79-4 4-4h3v-1a1 1 0 0 1 1-1h1V5h2v4h1a1 1 0 0 1 1 1v1h3c2.21 0 3.628 1.828 4 4l1.453 8.834A2.705 2.705 0 0 1 24.787 27Z"
        })
    });
var $a39c138e1f3b6f98$export$2e2bcd8739ae039 = $a39c138e1f3b6f98$var$SvgGlyphiconsBasic413GameController;




const $f29f94d2f7272ee3$var$SvgGlyphiconsBasic414GameControllerWireless = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.787 27a2.705 2.705 0 0 1-2.488-1.644L20.016 21h-8.032L9.7 25.356a2.705 2.705 0 0 1-5.154-1.521L6 15c.43-2.196 1.79-4 4-4h12c2.21 0 3.628 1.828 4 4l1.453 8.834A2.705 2.705 0 0 1 24.787 27ZM12.994 6.398a4.25 4.25 0 0 1 6.012 0 1 1 0 0 0 1.414-1.415 6.252 6.252 0 0 0-8.84 0 1 1 0 0 0 1.414 1.415Zm.355 1.354a1 1 0 1 0 1.414 1.413 1.794 1.794 0 0 1 2.474 0 1 1 0 1 0 1.414-1.414 3.839 3.839 0 0 0-5.302 0Z"
        })
    });
var $f29f94d2f7272ee3$export$2e2bcd8739ae039 = $f29f94d2f7272ee3$var$SvgGlyphiconsBasic414GameControllerWireless;




const $eb27a69e41fdd6e2$var$SvgGlyphiconsBasic415PushPin = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m10.672 19.328 2 2-4.454 4.454a2 2 0 0 1-.455.34L5.098 27.58a.5.5 0 0 1-.678-.678l1.457-2.665a2 2 0 0 1 .34-.455Zm17.056-9.4L22.07 4.273A2 2 0 1 0 19.243 7.1l.5.5L16 11.343a4 4 0 0 0-5.657 0L8.636 13.05a1 1 0 0 0 0 1.414l8.9 8.9a1 1 0 0 0 1.414 0l1.707-1.707a4 4 0 0 0 0-5.657l3.742-3.743.5.5a2 2 0 1 0 2.829-2.828Z"
        })
    });
var $eb27a69e41fdd6e2$export$2e2bcd8739ae039 = $eb27a69e41fdd6e2$var$SvgGlyphiconsBasic415PushPin;




const $b4818d172784a2cb$var$SvgGlyphiconsBasic416IdBadgeLanyard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 18v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h3v.5a2.503 2.503 0 0 0 2.5 2.5h2a2.503 2.503 0 0 0 2.5-2.5V17h3a1 1 0 0 1 1 1Zm6.457-3.043a4.181 4.181 0 0 1-5.914 0l-4.629-4.629a1.121 1.121 0 0 0-1.914.793v1.93a2.5 2.5 0 0 0-.5-.051h-2a2.5 2.5 0 0 0-.5.05V9a5.006 5.006 0 0 1 5-5h3.343a4.968 4.968 0 0 1 3.536 1.464l3.578 3.579a4.188 4.188 0 0 1 0 5.914Zm-1.414-4.5-3.578-3.579A2.982 2.982 0 0 0 19.343 6H16a3.004 3.004 0 0 0-2.995 2.83A3.109 3.109 0 0 1 15.12 8a3.141 3.141 0 0 1 2.207.914l4.629 4.629a2.235 2.235 0 0 0 3.086 0 2.185 2.185 0 0 0 0-3.086ZM11.5 18h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5Z"
        })
    });
var $b4818d172784a2cb$export$2e2bcd8739ae039 = $b4818d172784a2cb$var$SvgGlyphiconsBasic416IdBadgeLanyard;




const $c80c26e6db335c2e$var$SvgGlyphiconsBasic417Globe = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.142 6.776A9.932 9.932 0 0 0 10.015 10H8.019a10.045 10.045 0 0 1 4.123-3.224ZM6.841 12h2.558a17.331 17.331 0 0 0-.372 3H6.05a9.91 9.91 0 0 1 .79-3Zm0 8a9.91 9.91 0 0 1-.79-3h2.976a17.331 17.331 0 0 0 .372 3Zm1.178 2h1.996a9.932 9.932 0 0 0 2.127 3.224A10.045 10.045 0 0 1 8.019 22ZM15 25.06A9.088 9.088 0 0 1 12.195 22H15ZM15 20h-3.565a14.638 14.638 0 0 1-.412-3H15Zm0-5h-3.977a14.638 14.638 0 0 1 .412-3H15Zm0-5h-2.805A9.088 9.088 0 0 1 15 6.94Zm8.98 0h-1.995a9.934 9.934 0 0 0-2.128-3.224A10.045 10.045 0 0 1 23.981 10ZM17 6.94A9.09 9.09 0 0 1 19.805 10H17ZM17 12h3.565a14.638 14.638 0 0 1 .412 3H17Zm0 5h3.977a14.638 14.638 0 0 1-.412 3H17Zm0 8.06V22h2.805A9.09 9.09 0 0 1 17 25.06Zm2.857.164A9.934 9.934 0 0 0 21.985 22h1.996a10.045 10.045 0 0 1-4.124 3.224ZM25.16 20h-2.558a17.325 17.325 0 0 0 .372-3h2.976a9.91 9.91 0 0 1-.79 3Zm-2.186-5a17.325 17.325 0 0 0-.372-3h2.558a9.91 9.91 0 0 1 .79 3ZM28 16a12 12 0 1 0-12 12 12 12 0 0 0 12-12Z"
        })
    });
var $c80c26e6db335c2e$export$2e2bcd8739ae039 = $c80c26e6db335c2e$var$SvgGlyphiconsBasic417Globe;




const $a4860b0285ad96c8$var$SvgGlyphiconsBasic418WorldWest = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm1.8 21.83a7.005 7.005 0 0 0-1.39-2.057c-1.046-1.318-.455-3.182-3.67-4.693-2.269-1.066-2.958-2.285-3.425-4.602-.298-1.478-.451-2.523.034-3.511a6.328 6.328 0 0 0 .703-2.987 9.932 9.932 0 0 1 9.927-1.15 1.367 1.367 0 0 1-1.576.817c-.8-.316-3.484-.524-3.585 1.217S16 11 18.494 9.184a1.629 1.629 0 0 1 1.739.038c.645.299 1.109.517 1.109 1.257-.07 1.294-3.206 2.385-3.797 4.476-.357 1.265 1.091 2.227-.618 2.351-.97.07-1.836-2.597-3.395-1.271-1.729 1.47.959 1.716 1.439 1.994 1.679.974.646 2.603 2.81 1.836a5.224 5.224 0 0 1 3.618-.323 23.992 23.992 0 0 1 2.999 1.867 10.01 10.01 0 0 1-6.598 4.42Z"
        })
    });
var $a4860b0285ad96c8$export$2e2bcd8739ae039 = $a4860b0285ad96c8$var$SvgGlyphiconsBasic418WorldWest;




const $6adc03054bc75913$var$SvgGlyphiconsBasic419WorldEast = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm8.458 12.765c-1.284-.183-2.864-3.395-3.93-2.018s1.437 1.938.118 3.024c-1.664 1.369-1.146 3.5-1.583 4.958s-2.955 2.998-3.607 2.45.023-1.679-.331-2.783-.41-2.014-1.313-2.833c-.649-.59-3.614.95-4.023-1.48-.137-.811.357-3.104 1.398-3.416 2.25-.57 2.48.389 4.063.541s3.59-1.095 2.9-2.063c-.49-.688-1.21-.465-2.308-.714-1.143-.26-.156-1.532-1.247-1.428-1.413.134-1.419 3.15-3.413 2.562-1.173-.346.23-1.396.365-2.122s-.33-1.105-.39-1.8c-.035-.394.558-.713 1.329-.536s2.556-1.365 3.217-1.332c1.79.092.54.787 1.365 1.393.762.56 2.824-.71 3.453-1.066.372-.21.634-.379.844-.495a9.993 9.993 0 0 1 4.593 8.4c0 .235-.019.466-.035.697a3.95 3.95 0 0 1-1.465.061Z"
        })
    });
var $6adc03054bc75913$export$2e2bcd8739ae039 = $6adc03054bc75913$var$SvgGlyphiconsBasic419WorldEast;




const $3d708429dc79a2bf$var$SvgGlyphiconsBasic42StatsBars = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 26v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h2v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9h2V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v20h2V12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v13h1a1 1 0 0 1 1 1Z"
        })
    });
var $3d708429dc79a2bf$export$2e2bcd8739ae039 = $3d708429dc79a2bf$var$SvgGlyphiconsBasic42StatsBars;




const $65a4cfc92089a54f$var$SvgGlyphiconsBasic420Vases = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 24v1.75l1.351.507a1 1 0 0 1 .649.936V28H5v-.807a1 1 0 0 1 .649-.936L7 25.75V24c0-4-3-6-3-10s3-5 3-7V6h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H12v1c0 2 3 3 3 7s-3 6-3 10Zm14.351 2.257-1.034-.388A4.312 4.312 0 0 0 28 22c0-2-3-4-3-6v-1h.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v1c0 2-3 4-3 6a4.312 4.312 0 0 0 2.683 3.869l-1.034.388a1 1 0 0 0-.649.936V28h10v-.807a1 1 0 0 0-.649-.936Z"
        })
    });
var $65a4cfc92089a54f$export$2e2bcd8739ae039 = $65a4cfc92089a54f$var$SvgGlyphiconsBasic420Vases;




const $4d79622a8765eeda$var$SvgGlyphiconsBasic421BookPlay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 23h16V5a1 1 0 0 0-1-1H10a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h15a1 1 0 0 0 1-1v-2H10a1 1 0 0 1 0-2Zm3-12.616a.403.403 0 0 1 .584-.36l7.231 3.615a.403.403 0 0 1 0 .722l-7.231 3.615a.403.403 0 0 1-.584-.36Z"
        })
    });
var $4d79622a8765eeda$export$2e2bcd8739ae039 = $4d79622a8765eeda$var$SvgGlyphiconsBasic421BookPlay;




const $3017b5611a7c55ba$var$SvgGlyphiconsBasic422BookLibrary = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 4h-5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1 21.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-18a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm10.037-2.94a1 1 0 0 0-1.159-.812l-4.924.868a1 1 0 0 0-.81 1.159l3.82 21.666a1 1 0 0 0 1.158.81l4.924-.867a1 1 0 0 0 .81-1.159Zm1.184 21.114-1.97.348a.5.5 0 0 1-.579-.406l-.173-.985a.5.5 0 0 1 .405-.579l1.97-.347a.5.5 0 0 1 .58.405l.173.985a.5.5 0 0 1-.406.58ZM9 4H4a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM8 25.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-18a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Z"
        })
    });
var $3017b5611a7c55ba$export$2e2bcd8739ae039 = $3017b5611a7c55ba$var$SvgGlyphiconsBasic422BookLibrary;




const $afbc16040d255466$var$SvgGlyphiconsBasic423BriefcaseAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 10v4a2.002 2.002 0 0 1-2 2h-8v-1.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V16H6a2.002 2.002 0 0 1-2-2v-4a2.002 2.002 0 0 1 2-2h20a2.002 2.002 0 0 1 2 2ZM5 24a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-6H5Zm9-19h4a1.001 1.001 0 0 1 1 1h2a3.003 3.003 0 0 0-3-3h-4a3.003 3.003 0 0 0-3 3h2a1.001 1.001 0 0 1 1-1Z"
        })
    });
var $afbc16040d255466$export$2e2bcd8739ae039 = $afbc16040d255466$var$SvgGlyphiconsBasic423BriefcaseAlt;




const $3865b333d2cdaef1$var$SvgGlyphiconsBasic424Blackboard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.5 18h-21a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h6.678l-4.967 6.386a1 1 0 1 0 1.578 1.228L11.6 24H20.4l2.81 3.614a1 1 0 1 0 1.58-1.228L19.821 20H26.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-13.345 4 1.556-2h2.578l1.556 2ZM26 16H6V5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Z"
        })
    });
var $3865b333d2cdaef1$export$2e2bcd8739ae039 = $3865b333d2cdaef1$var$SvgGlyphiconsBasic424Blackboard;




const $820f7514b2012eab$var$SvgGlyphiconsBasic425Crown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8 25h16v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1ZM28 9h-2a1 1 0 0 0-1 1v1.655a1 1 0 0 1-.414.81l-3.85 2.782-3.175-7.539a1.071 1.071 0 0 1 .222-1.099A.954.954 0 0 0 18 6V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a.954.954 0 0 0 .217.61 1.071 1.071 0 0 1 .222 1.098l-3.174 7.539-3.85-2.781a1 1 0 0 1-.415-.81V10a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.185a1 1 0 0 1 .955.706L8 23h16l2.86-9.294a1 1 0 0 1 .955-.706H28a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
    });
var $820f7514b2012eab$export$2e2bcd8739ae039 = $820f7514b2012eab$var$SvgGlyphiconsBasic425Crown;




const $8e7ebcf3501e4178$var$SvgGlyphiconsBasic426HomeFlag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.105 17H24v10.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V17H4.895a.785.785 0 0 1-.555-1.34L15.47 4.53a.75.75 0 0 1 1.06 0l11.13 11.13a.785.785 0 0 1-.555 1.34ZM24 9.172v-2.6l4.928-2.112a.5.5 0 0 0 0-.92L24 1.43V1a1 1 0 0 0-2 0v6.172Z"
        })
    });
var $8e7ebcf3501e4178$export$2e2bcd8739ae039 = $8e7ebcf3501e4178$var$SvgGlyphiconsBasic426HomeFlag;




const $44a7984d288bad51$var$SvgGlyphiconsBasic427SquareTriangleDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.81 14.57-3.989 5.746a1 1 0 0 1-1.643 0L11.19 14.57A1 1 0 0 1 12.01 13h7.978a1 1 0 0 1 .821 1.57ZM27 8.5v15a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h15A3.504 3.504 0 0 1 27 8.5Zm-3 0a.506.506 0 0 0-.5-.5h-15a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Z"
        })
    });
var $44a7984d288bad51$export$2e2bcd8739ae039 = $44a7984d288bad51$var$SvgGlyphiconsBasic427SquareTriangleDown;




const $3aa70e95f8d54777$var$SvgGlyphiconsBasic428SquareTriangleUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.81 17.43A1 1 0 0 1 19.99 19H12.01a1 1 0 0 1-.821-1.57l3.989-5.747a1 1 0 0 1 1.643 0ZM27 8.5v15a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h15A3.504 3.504 0 0 1 27 8.5Zm-3 0a.506.506 0 0 0-.5-.5h-15a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Z"
        })
    });
var $3aa70e95f8d54777$export$2e2bcd8739ae039 = $3aa70e95f8d54777$var$SvgGlyphiconsBasic428SquareTriangleUp;




const $303d0eeaa58c1637$var$SvgGlyphiconsBasic429SquareTriangleLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 12.011v7.978a1 1 0 0 1-1.57.821l-5.746-3.989a1 1 0 0 1 0-1.643l5.746-3.988a1 1 0 0 1 1.57.821ZM27 8.5v15a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h15A3.504 3.504 0 0 1 27 8.5Zm-3 0a.506.506 0 0 0-.5-.5h-15a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Z"
        })
    });
var $303d0eeaa58c1637$export$2e2bcd8739ae039 = $303d0eeaa58c1637$var$SvgGlyphiconsBasic429SquareTriangleLeft;




const $c21f18a00b70d0a4$var$SvgGlyphiconsBasic43StatsCircle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m17.414 16 7.447-7.447a12.986 12.986 0 0 1 1.674 2.498L21.585 16ZM20.95 5.465 16 10.415v4.17l7.447-7.446a12.972 12.972 0 0 0-2.498-1.674Zm7 10.535a12.92 12.92 0 0 0-.586-2.949L24.414 16ZM16 4.05v3.536l2.949-2.949A12.944 12.944 0 0 0 16 4.051Zm8.866 21.402A12.928 12.928 0 0 0 27.949 18H17.414ZM14 17V6.05a10.998 10.998 0 1 0 8.037 19.402l-7.744-7.745A.996.996 0 0 1 14 17Z"
        })
    });
var $c21f18a00b70d0a4$export$2e2bcd8739ae039 = $c21f18a00b70d0a4$var$SvgGlyphiconsBasic43StatsCircle;




const $14ea0e8d1079f7ab$var$SvgGlyphiconsBasic430SquareTriangleRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.316 15.178a1 1 0 0 1 0 1.643l-5.746 3.99a1 1 0 0 1-1.57-.822V12.01a1 1 0 0 1 1.57-.821ZM27 8.5v15a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h15A3.504 3.504 0 0 1 27 8.5Zm-3 0a.506.506 0 0 0-.5-.5h-15a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Z"
        })
    });
var $14ea0e8d1079f7ab$export$2e2bcd8739ae039 = $14ea0e8d1079f7ab$var$SvgGlyphiconsBasic430SquareTriangleRight;




const $3ad1cbb3d8986786$var$SvgGlyphiconsBasic431LogIn = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 7.5v17a3.504 3.504 0 0 1-3.5 3.5h-12A3.504 3.504 0 0 1 9 24.5V20h3v4.5a.506.506 0 0 0 .5.5h12a.506.506 0 0 0 .5-.5v-17a.506.506 0 0 0-.5-.5h-12a.506.506 0 0 0-.5.5V12H9V7.5A3.504 3.504 0 0 1 12.5 4h12A3.504 3.504 0 0 1 28 7.5ZM14 19.989a1 1 0 0 0 1.57.821l5.746-3.989a1 1 0 0 0 0-1.642l-5.746-3.99a1 1 0 0 0-1.57.822V14H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h7Z"
        })
    });
var $3ad1cbb3d8986786$export$2e2bcd8739ae039 = $3ad1cbb3d8986786$var$SvgGlyphiconsBasic431LogIn;




const $209242c9d93df68b$var$SvgGlyphiconsBasic432LogOut = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.71 22.453 23 20.864V24.5a3.504 3.504 0 0 1-3.5 3.5h-12A3.504 3.504 0 0 1 4 24.5v-17A3.504 3.504 0 0 1 7.5 4h12A3.504 3.504 0 0 1 23 7.5v3.636l-2.29-1.589a3 3 0 0 0-.71-.359V7.5a.506.506 0 0 0-.5-.5h-12a.506.506 0 0 0-.5.5v17a.506.506 0 0 0 .5.5h12a.506.506 0 0 0 .5-.5v-1.688a3.003 3.003 0 0 0 .71-.359Zm4.606-7.274-5.746-3.99a1 1 0 0 0-1.57.822V14h-7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h7v1.989a1 1 0 0 0 1.57.821l5.746-3.989a1 1 0 0 0 0-1.642Z"
        })
    });
var $209242c9d93df68b$export$2e2bcd8739ae039 = $209242c9d93df68b$var$SvgGlyphiconsBasic432LogOut;




const $5843469d2629b933$var$SvgGlyphiconsBasic433Reply = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.407 22.606-.471.236a1.011 1.011 0 0 1-1.204-.24 13.802 13.802 0 0 0-9.743-4.6v3.455a1 1 0 0 1-1.581.814L4.33 15.786a1 1 0 0 1 0-1.627l9.078-6.485a1 1 0 0 1 1.581.814v3.15a15.76 15.76 0 0 1 11.909 9.723 1.013 1.013 0 0 1-.491 1.245Z"
        })
    });
var $5843469d2629b933$export$2e2bcd8739ae039 = $5843469d2629b933$var$SvgGlyphiconsBasic433Reply;




const $e094529ba8a438da$var$SvgGlyphiconsBasic434ReplyAll = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m6.117 15.949 5.872 4.195v1.314a1 1 0 0 1-1.581.813L1.33 15.786a1 1 0 0 1 0-1.627l9.078-6.485a1 1 0 0 1 1.581.814v1.313l-5.872 4.195a1.2 1.2 0 0 0 0 1.953Zm25.781 5.412A15.76 15.76 0 0 0 19.99 11.64v-2.91a1.124 1.124 0 0 0-1.777-.915l-8.741 6.244a1.124 1.124 0 0 0 0 1.829l8.741 6.244a1.124 1.124 0 0 0 1.777-.914v-3.215a13.801 13.801 0 0 1 9.743 4.6 1.011 1.011 0 0 0 1.204.24l.47-.236a1.012 1.012 0 0 0 .492-1.245Z"
        })
    });
var $e094529ba8a438da$export$2e2bcd8739ae039 = $e094529ba8a438da$var$SvgGlyphiconsBasic434ReplyAll;




const $40ebaa87df1082a8$var$SvgGlyphiconsBasic435ForwardEmail = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.83 16.82-9.257 6.479a1 1 0 0 1-1.573-.82V19L4.885 17.602A1 1 0 0 1 4 16.61V15.39a1 1 0 0 1 .885-.993L17 13V9.52a1 1 0 0 1 1.573-.819l9.257 6.48a1 1 0 0 1 0 1.638Z"
        })
    });
var $40ebaa87df1082a8$export$2e2bcd8739ae039 = $40ebaa87df1082a8$var$SvgGlyphiconsBasic435ForwardEmail;




const $8cb763f055e78508$var$SvgGlyphiconsBasic436Archive = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 27a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V13H6Zm6-10a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1ZM28 7v4H4V7a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Z"
        })
    });
var $8cb763f055e78508$export$2e2bcd8739ae039 = $8cb763f055e78508$var$SvgGlyphiconsBasic436Archive;




const $d65e5d90c01272f9$var$SvgGlyphiconsBasic437PlaylistMusic = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M3 8.5v15a5.46 5.46 0 0 0 .607 2.5H3.5A3.504 3.504 0 0 1 0 22.5v-13A3.504 3.504 0 0 1 3.5 6h.107A5.46 5.46 0 0 0 3 8.5ZM28.5 6h-.107A5.46 5.46 0 0 1 29 8.5v15a5.46 5.46 0 0 1-.607 2.5h.107a3.504 3.504 0 0 0 3.5-3.5v-13A3.504 3.504 0 0 0 28.5 6ZM27 8.5v15a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 23.5v-15A3.504 3.504 0 0 1 8.5 5h15A3.504 3.504 0 0 1 27 8.5Zm-3 0a.506.506 0 0 0-.5-.5h-15a.506.506 0 0 0-.5.5v15a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Zm-3.553 2.724-1.553-.777A4.236 4.236 0 0 0 17 10a1 1 0 0 0-1 1v6.478a.5.5 0 0 1-.356.479l-1.207.362A2.145 2.145 0 0 0 13 20.25v.25a1.256 1.256 0 0 0 1.483 1.277l.962-.144A3.103 3.103 0 0 0 18 18.666V14l1.684.561A1 1 0 0 0 21 13.613v-1.495a1 1 0 0 0-.553-.894Z"
        })
    });
var $d65e5d90c01272f9$export$2e2bcd8739ae039 = $d65e5d90c01272f9$var$SvgGlyphiconsBasic437PlaylistMusic;




const $5904a1d016a49f1f$var$SvgGlyphiconsBasic438PlaylistVideo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M3 9.5v13a5.46 5.46 0 0 0 .607 2.5H3.5A3.504 3.504 0 0 1 0 21.5v-11A3.504 3.504 0 0 1 3.5 7h.107A5.46 5.46 0 0 0 3 9.5ZM28.5 7h-.107A5.46 5.46 0 0 1 29 9.5v13a5.46 5.46 0 0 1-.607 2.5h.107a3.504 3.504 0 0 0 3.5-3.5v-11A3.504 3.504 0 0 0 28.5 7ZM27 9.5v13a3.504 3.504 0 0 1-3.5 3.5h-15A3.504 3.504 0 0 1 5 22.5v-13A3.504 3.504 0 0 1 8.5 6h15A3.504 3.504 0 0 1 27 9.5Zm-3 0a.506.506 0 0 0-.5-.5h-15a.506.506 0 0 0-.5.5v13a.506.506 0 0 0 .5.5h15a.506.506 0 0 0 .5-.5Zm-3.84 5.584-5.665-3.226a1 1 0 0 0-1.495.869v6.452a1 1 0 0 0 1.495.869l5.665-3.226a1 1 0 0 0 0-1.738Z"
        })
    });
var $5904a1d016a49f1f$export$2e2bcd8739ae039 = $5904a1d016a49f1f$var$SvgGlyphiconsBasic438PlaylistVideo;




const $7c119e86eb9fe253$var$SvgGlyphiconsBasic439VideoPlayEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.16 16.822-5.665 3.226a1 1 0 0 1-1.495-.87v-6.451a1 1 0 0 1 1.495-.87l5.665 3.227a1 1 0 0 1 0 1.738ZM28 9.5v13a3.504 3.504 0 0 1-3.5 3.5h-17A3.504 3.504 0 0 1 4 22.5v-13A3.504 3.504 0 0 1 7.5 6h17A3.504 3.504 0 0 1 28 9.5Zm-3 0a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5Z"
        })
    });
var $7c119e86eb9fe253$export$2e2bcd8739ae039 = $7c119e86eb9fe253$var$SvgGlyphiconsBasic439VideoPlayEmpty;




const $1b78aa284a65bd41$var$SvgGlyphiconsBasic44UserGroup = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.734 21h-1.468a1.988 1.988 0 0 1-.259-.024c-.427-.35-.935-.77-1.51-1.248l-.133-.11a2.004 2.004 0 0 1-.081-.362c.016-.064.036-.126.05-.19l.503-2.303a4.726 4.726 0 0 0 1.394-1.94l.279-.75A3.354 3.354 0 0 0 24 10.67V9.14A3.952 3.952 0 0 1 29 13v2.186a.675.675 0 0 1 .184.763l-.368 1.102a1.49 1.49 0 0 1-.932.88l-.165 1.317A2 2 0 0 1 25.734 21ZM8.97 20.978l1.534-1.263.138-.113a2.007 2.007 0 0 0 .076-.347c-.016-.063-.036-.125-.05-.189l-.503-2.303a4.726 4.726 0 0 1-1.393-1.94l-.28-.753A3.353 3.353 0 0 1 9 10.67V9.142A3.952 3.952 0 0 0 4 13v2.186a.675.675 0 0 0-.184.763l.368 1.102a1.49 1.49 0 0 0 .932.88l.165 1.317A2 2 0 0 0 7.266 21h1.468a1.961 1.961 0 0 0 .235-.022Zm22.604 1.223-2.213-1.549a4.005 4.005 0 0 1-3.084 2.308 3.391 3.391 0 0 1 .717 2.04H31.5a.5.5 0 0 0 .5-.5v-1.48a1 1 0 0 0-.427-.819ZM3.64 20.652l-2.213 1.55A1 1 0 0 0 1 23.02V24.5a.5.5 0 0 0 .5.5h4.526a3.63 3.63 0 0 1 .743-2.037 4.002 4.002 0 0 1-3.13-2.31Zm20.53 3.026c-.435-.33-1.828-1.48-2.951-2.412A5.015 5.015 0 0 1 17.448 23h-1.896a5.014 5.014 0 0 1-3.776-1.742c-1.15.947-2.574 2.12-2.946 2.42A1.86 1.86 0 0 0 8 25.237V26.5a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-1.263a1.658 1.658 0 0 0-.83-1.559Zm-13.525-9.552a2.991 2.991 0 0 0 1.31 1.462l.666 3.051A3 3 0 0 0 15.552 21h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a2.991 2.991 0 0 0 1.311-1.462l.28-.752A1.275 1.275 0 0 0 22 11.63V9c0-3-2-5-5.5-5S11 6 11 9v2.63a1.275 1.275 0 0 0-.635 1.744Z"
        })
    });
var $1b78aa284a65bd41$export$2e2bcd8739ae039 = $1b78aa284a65bd41$var$SvgGlyphiconsBasic44UserGroup;




const $eab895a7e9caaaf7$var$SvgGlyphiconsBasic440VideoPlay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 6h-17A3.504 3.504 0 0 0 4 9.5v13A3.504 3.504 0 0 0 7.5 26h17a3.504 3.504 0 0 0 3.5-3.5v-13A3.504 3.504 0 0 0 24.5 6Zm-4.34 10.822-5.665 3.226a1 1 0 0 1-1.495-.87v-6.451a1 1 0 0 1 1.495-.87l5.665 3.227a1 1 0 0 1 0 1.738Z"
        })
    });
var $eab895a7e9caaaf7$export$2e2bcd8739ae039 = $eab895a7e9caaaf7$var$SvgGlyphiconsBasic440VideoPlay;




const $e3963bae5bbb5f83$var$SvgGlyphiconsBasic441Bell = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 22.07V23a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-.93a2 2 0 0 1 .89-1.664l.329-.219A4 4 0 0 0 9 16.86V13a7 7 0 0 1 5-6.706V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.31a7.314 7.314 0 0 1 5 6.983v3.566a4 4 0 0 0 1.781 3.328l.328.22A2 2 0 0 1 26 22.07ZM14 27a2 2 0 0 0 4 0v-1h-4Z"
        })
    });
var $e3963bae5bbb5f83$export$2e2bcd8739ae039 = $e3963bae5bbb5f83$var$SvgGlyphiconsBasic441Bell;




const $cb365c74d617e9a0$var$SvgGlyphiconsBasic442BellOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 22.07V23a1 1 0 0 1-1 1H11.967l11.009-11.009c.004.102.024.2.024.302v3.566a4 4 0 0 0 1.781 3.328l.328.22A2 2 0 0 1 26 22.07ZM14 27a2 2 0 0 0 4 0v-1h-4ZM27.215 2.94a1.5 1.5 0 0 0-2.121 0l-4.706 4.705A6.784 6.784 0 0 0 18 6.31V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.294A7 7 0 0 0 9 13v3.86a4 4 0 0 1-1.781 3.327l-.328.22a1.997 1.997 0 0 0-.886 1.62L2.94 25.093a1.5 1.5 0 1 0 2.122 2.121L27.215 5.061a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $cb365c74d617e9a0$export$2e2bcd8739ae039 = $cb365c74d617e9a0$var$SvgGlyphiconsBasic442BellOff;




const $adec886c8f2da51f$var$SvgGlyphiconsBasic443BellRinging = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 17a1 1 0 0 1-1-1v-3a10.934 10.934 0 0 1 1.5-5.504 1 1 0 1 1 1.727 1.008A8.935 8.935 0 0 0 7 13v3a1 1 0 0 1-1 1ZM3.317 7.067a1 1 0 0 0-1.294.572A14.815 14.815 0 0 0 1 13v3a1 1 0 0 0 2 0v-3a12.804 12.804 0 0 1 .889-4.639 1 1 0 0 0-.572-1.294ZM14 27a2 2 0 0 0 4 0v-1h-4Zm11.11-6.594-.329-.219A4 4 0 0 1 23 16.86v-3.566a7.314 7.314 0 0 0-5-6.982V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.294A7 7 0 0 0 9 13v3.86a4 4 0 0 1-1.781 3.327l-.328.22A2 2 0 0 0 6 22.07V23a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-.93a2 2 0 0 0-.89-1.664Zm4.768-12.779a1 1 0 1 0-1.856.746 13.171 13.171 0 0 1 .978 4.92V16a1 1 0 0 0 2 0v-2.707a15.159 15.159 0 0 0-1.122-5.666Zm-5.852-.487a1 1 0 0 0-.35 1.37A9.395 9.395 0 0 1 25 13.293V16a1 1 0 0 0 2 0v-2.707a11.396 11.396 0 0 0-1.604-5.803 1 1 0 0 0-1.37-.35Z"
        })
    });
var $adec886c8f2da51f$export$2e2bcd8739ae039 = $adec886c8f2da51f$var$SvgGlyphiconsBasic443BellRinging;




const $fc63872215f6633a$var$SvgGlyphiconsBasic444Sampler = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 25.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3.308L10.808 19H6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h13.808L16 24.192Zm-8 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM27 3h-5a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm-2.5 22a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm2.5-6.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5Zm-9 16.864v-5.385l-.925.925a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707L18 15.15v-4.514l-3.607-3.607a2 2 0 0 0-2.828 0l-3.536 3.536a2 2 0 0 0 0 2.828Zm-2.339-11.531a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707l-2.828 2.828a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707Zm-5.657 0 2.829-2.829a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .708l-2.828 2.828a.5.5 0 0 1-.708 0l-.707-.707a.5.5 0 0 1 0-.707Z"
        })
    });
var $fc63872215f6633a$export$2e2bcd8739ae039 = $fc63872215f6633a$var$SvgGlyphiconsBasic444Sampler;




const $c49944cb3b63f2bb$var$SvgGlyphiconsBasic445Wallet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 11H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H27V8a2 2 0 0 0-2-2H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3V13a2 2 0 0 0-2-2Zm-2.5 9a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Z"
        })
    });
var $c49944cb3b63f2bb$export$2e2bcd8739ae039 = $c49944cb3b63f2bb$var$SvgGlyphiconsBasic445Wallet;




const $8e0bb21206686f24$var$SvgGlyphiconsBasic446WalletPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm3 6.5a.5.5 0 0 1-.5.5H27v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V7h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H25V3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V5h1.5a.5.5 0 0 1 .5.5ZM26 14a7.985 7.985 0 0 1-6.235-3H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h10.089A7.95 7.95 0 0 1 18 6H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3v-9.263A7.96 7.96 0 0 1 26 14Zm-2.5 6a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Z"
        })
    });
var $8e0bb21206686f24$export$2e2bcd8739ae039 = $8e0bb21206686f24$var$SvgGlyphiconsBasic446WalletPlus;




const $8858c414b8db2216$var$SvgGlyphiconsBasic447WalletMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.765 11H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h10.089A7.95 7.95 0 0 1 18 6H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3v-9.263A7.925 7.925 0 0 1 19.765 11Zm3.735 9a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5ZM26 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm3 6.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Z"
        })
    });
var $8858c414b8db2216$export$2e2bcd8739ae039 = $8858c414b8db2216$var$SvgGlyphiconsBasic447WalletMinus;




const $61b1983b7a6b3d43$var$SvgGlyphiconsBasic448WalletLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 11H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H19V6H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3v-9h-6a3.003 3.003 0 0 1-3-3Zm4.5 6a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5ZM31 4h-1V2a2.003 2.003 0 0 0-2-2h-3a2.003 2.003 0 0 0-2 2v2h-1a1.003 1.003 0 0 0-1 1v6a1.003 1.003 0 0 0 1 1h9a1.003 1.003 0 0 0 1-1V5a1.003 1.003 0 0 0-1-1Zm-3 0h-3V2.25a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25Z"
        })
    });
var $61b1983b7a6b3d43$export$2e2bcd8739ae039 = $61b1983b7a6b3d43$var$SvgGlyphiconsBasic448WalletLock;




const $95538eae72fd4ef3$var$SvgGlyphiconsBasic449WalletCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.426 11H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h10.63a7.451 7.451 0 0 1-.63-3H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3v-9.779A7.428 7.428 0 0 1 20.426 11Zm3.074 9a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm8.206-14.362a.498.498 0 0 0-.379-.472l-1.156-.289a4.414 4.414 0 0 0-.43-1.041l.618-1.031a.497.497 0 0 0-.043-.582 5.852 5.852 0 0 0-.542-.539.504.504 0 0 0-.586-.046l-1.029.617a4.324 4.324 0 0 0-1.04-.429L26.83.67a.497.497 0 0 0-.47-.379c-.221-.005-.49-.006-.715 0a.498.498 0 0 0-.472.379l-.29 1.157a4.348 4.348 0 0 0-1.04.429l-1.03-.619a.497.497 0 0 0-.581.043 5.806 5.806 0 0 0-.54.54.504.504 0 0 0-.047.587l.618 1.03a4.361 4.361 0 0 0-.43 1.041l-1.157.29a.497.497 0 0 0-.379.47c-.005.221-.006.49 0 .715a.498.498 0 0 0 .379.472l1.157.29a4.347 4.347 0 0 0 .429 1.04l-.619 1.03a.497.497 0 0 0 .043.581 5.817 5.817 0 0 0 .54.54.504.504 0 0 0 .588.047l1.029-.618a4.404 4.404 0 0 0 1.04.431l.29 1.156a.497.497 0 0 0 .47.38c.222.004.491.005.716 0a.498.498 0 0 0 .472-.38l.29-1.156a4.417 4.417 0 0 0 1.041-.432l1.03.62a.497.497 0 0 0 .582-.043 5.865 5.865 0 0 0 .539-.542.504.504 0 0 0 .046-.586l-.617-1.029a4.523 4.523 0 0 0 .43-1.04l1.156-.289a.497.497 0 0 0 .379-.47c.005-.222.006-.491 0-.716ZM26 8.143a2.147 2.147 0 1 1 2.148-2.149A2.15 2.15 0 0 1 26 8.143Z"
        })
    });
var $95538eae72fd4ef3$export$2e2bcd8739ae039 = $95538eae72fd4ef3$var$SvgGlyphiconsBasic449WalletCogwheel;




const $4cbadf05c9ef2abd$var$SvgGlyphiconsBasic45Key = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 12H16l-1.8-2.4A4 4 0 0 0 11 8H7a4 4 0 0 0-4 4v7a4 4 0 0 0 4 4h4a4 4 0 0 0 3.2-1.6L16 19h1.464l2.036-2.036 2 2 2-2 2 2 2-2 1.364 1.364L31 16.667v-2.334ZM9 17a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z"
        })
    });
var $4cbadf05c9ef2abd$export$2e2bcd8739ae039 = $4cbadf05c9ef2abd$var$SvgGlyphiconsBasic45Key;




const $66318f3ef9532d61$var$SvgGlyphiconsBasic450WalletCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.765 11H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h10.089A7.95 7.95 0 0 1 18 6H8a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h17a3 3 0 0 0 3-3v-9.263A7.925 7.925 0 0 1 19.765 11Zm3.735 9a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5ZM26 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm3.2 4.118-3.11 4.575a.83.83 0 0 1-1.297.1L22.56 6.557a.297.297 0 0 1-.027-.377l.433-.554a.323.323 0 0 1 .377-.096l1.766.845 3.15-2.96a.297.297 0 0 1 .377-.027l.512.378a.254.254 0 0 1 .052.352Z"
        })
    });
var $66318f3ef9532d61$export$2e2bcd8739ae039 = $66318f3ef9532d61$var$SvgGlyphiconsBasic450WalletCheck;




const $ee7acc441864b772$var$SvgGlyphiconsBasic451HandLike = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 14v9a1 1 0 0 1-1 1H5V13h4a1 1 0 0 1 1 1Zm15.862 1.154-.61-1.525a1 1 0 0 0-.93-.629h-6.1a.5.5 0 0 1-.469-.676L18.81 9.51A3 3 0 0 0 19 8.456V6.5a1.5 1.5 0 0 0-1.112-1.45.494.494 0 0 0-.128-.016.51.51 0 0 0-.43.24L15.112 8.82q-.113.18-.24.35L12 13v9.5l.914.914a2 2 0 0 0 1.414.586h7.318a2 2 0 0 0 1.857-1.257l2.376-6.891a1 1 0 0 0-.017-.698Z"
        })
    });
var $ee7acc441864b772$export$2e2bcd8739ae039 = $ee7acc441864b772$var$SvgGlyphiconsBasic451HandLike;




const $daad5414920f411e$var$SvgGlyphiconsBasic452HandDislike = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 8v11h-4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Zm-9.328 0h-7.318a2 2 0 0 0-1.857 1.257l-2.376 6.891a1 1 0 0 0 .017.698l.61 1.525a1 1 0 0 0 .93.629h6.1a.5.5 0 0 1 .469.676L13.19 22.49A3 3 0 0 0 13 23.544V25.5a1.5 1.5 0 0 0 1.112 1.45.496.496 0 0 0 .128.016.51.51 0 0 0 .43-.24l2.217-3.546q.113-.18.24-.35L20 19V9.5l-.914-.914A2 2 0 0 0 17.672 8Z"
        })
    });
var $daad5414920f411e$export$2e2bcd8739ae039 = $daad5414920f411e$var$SvgGlyphiconsBasic452HandDislike;




const $b266c11ec9e24760$var$SvgGlyphiconsBasic453HandPointingRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30 13.5a1.5 1.5 0 0 1-1.5 1.5H23l-2.513 6.702A2 2 0 0 1 18.614 23h-5.56a2 2 0 0 1-1.029-.285L10 21.5V11l2.414-2.414A2 2 0 0 1 13.828 8h4.344a2 2 0 0 1 1.414.586l.56.56a.5.5 0 0 1-.353.854H17a1 1 0 0 0 0 2h11.5a1.5 1.5 0 0 1 1.5 1.5ZM7 11H3v11h4a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1Z"
        })
    });
var $b266c11ec9e24760$export$2e2bcd8739ae039 = $b266c11ec9e24760$var$SvgGlyphiconsBasic453HandPointingRight;




const $8886cd466a5271ec$var$SvgGlyphiconsBasic454HandPointingLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 11v11h-4a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1ZM18.172 8h-4.344a2 2 0 0 0-1.414.586l-.56.56a.5.5 0 0 0 .353.854H15a1 1 0 0 1 0 2H3.5a1.5 1.5 0 0 0 0 3H9l2.513 6.702A2 2 0 0 0 13.386 23h5.56a2 2 0 0 0 1.029-.285L22 21.5V11l-2.414-2.414A2 2 0 0 0 18.172 8Z"
        })
    });
var $8886cd466a5271ec$export$2e2bcd8739ae039 = $8886cd466a5271ec$var$SvgGlyphiconsBasic454HandPointingLeft;




const $2b7f16c32ee2c884$var$SvgGlyphiconsBasic455HandPointingUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 25v4H11v-4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1Zm-.298-13.487L15 9V3.5a1.5 1.5 0 0 0-3 0V15a1 1 0 0 1-2 0v-2.793a.5.5 0 0 0-.854-.353l-.56.56A2 2 0 0 0 8 13.828v4.343a2 2 0 0 0 .586 1.415L11 22h10.5l1.215-2.025a2 2 0 0 0 .285-1.03v-5.559a2 2 0 0 0-1.298-1.873Z"
        })
    });
var $2b7f16c32ee2c884$export$2e2bcd8739ae039 = $2b7f16c32ee2c884$var$SvgGlyphiconsBasic455HandPointingUp;




const $04b5c1ff0ba3d8f8$var$SvgGlyphiconsBasic456HandPointingDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 7V3h11v4a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1Zm13.414 5.414L21 10H10.5l-1.215 2.025A2 2 0 0 0 9 13.054v5.56a2 2 0 0 0 1.298 1.873L17 23v5.5a1.5 1.5 0 0 0 3 0V17a1 1 0 0 1 2 0v2.793a.5.5 0 0 0 .854.353l.56-.56A2 2 0 0 0 24 18.17v-4.343a2 2 0 0 0-.586-1.414Z"
        })
    });
var $04b5c1ff0ba3d8f8$export$2e2bcd8739ae039 = $04b5c1ff0ba3d8f8$var$SvgGlyphiconsBasic456HandPointingDown;




const $b10a74996331ce6f$var$SvgGlyphiconsBasic457HandOpen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.915 10.998-1.924 5.467.009.035-.656 1.805-.336.954c-.008.024-.025.04-.034.063L23 22H10l-7-6 .195-.39a2 2 0 0 1 2.491-.978l2.049 1.081a1.595 1.595 0 0 0 1.445-.166 1.578 1.578 0 0 0 .27-.241L8.508 5.139a1.5 1.5 0 1 1 2.986-.278l.507 5.46v.179a1 1 0 0 0 2 0v-8a1.5 1.5 0 0 1 3 0v8a1 1 0 0 0 2 0v-.837l.451-5.692a1.5 1.5 0 0 1 2.99.237l-.429 5.413-.38 2.236a1 1 0 1 0 1.97.336l.271-1.589.212-.602a1.5 1.5 0 1 1 2.83.996ZM22 24H11a1 1 0 0 0-1 1v4h13v-4a1 1 0 0 0-1-1Z"
        })
    });
var $b10a74996331ce6f$export$2e2bcd8739ae039 = $b10a74996331ce6f$var$SvgGlyphiconsBasic457HandOpen;




const $5871ee705aa1d433$var$SvgGlyphiconsBasic458HandOpenAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m29 16-7 6H9l-.974-2.678c-.009-.022-.026-.04-.034-.063l-.336-.954L7 16.5l.009-.035-1.924-5.467a1.5 1.5 0 1 1 2.83-.996l.212.602.27 1.589a1 1 0 1 0 1.971-.336l-.38-2.236-.43-5.413a1.5 1.5 0 0 1 2.99-.237L13 9.663v.837a1 1 0 0 0 2 0v-8a1.5 1.5 0 0 1 3 0v8a1 1 0 0 0 2 0v-.18l.507-5.459a1.5 1.5 0 1 1 2.986.278l-.944 10.167a1.578 1.578 0 0 0 .271.24 1.595 1.595 0 0 0 1.445.167l2.049-1.08a2 2 0 0 1 2.491.977Zm-8 8H10a1 1 0 0 0-1 1v4h13v-4a1 1 0 0 0-1-1Z"
        })
    });
var $5871ee705aa1d433$export$2e2bcd8739ae039 = $5871ee705aa1d433$var$SvgGlyphiconsBasic458HandOpenAlt;




const $fe3c08f8a3179b65$var$SvgGlyphiconsBasic459HandOk = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.893 9.057-2.18 5.325-3.709 5.1.002 1.517a1 1 0 0 1-1 1.001h-8.507a1.494 1.494 0 0 1-.976-.361l-3.5-3a1.499 1.499 0 0 1-.446-.665l-.5-1.5a1.5 1.5 0 1 1 2.846-.948l.369 1.105.466.4 1.467.715 1.24-.409a2 2 0 0 0 1.019-3.037l-1.73-2.5-1.975.542-1.218 1.219a1.5 1.5 0 0 1-2.122-2.122l1.5-1.5a1.499 1.499 0 0 1 .665-.386l3.282-.9a1.5 1.5 0 0 1 1.38.315l2.31 2.006-.573-8.877a1.5 1.5 0 0 1 2.994-.194l.68 10.532A.972.972 0 0 0 19 12.5a1 1 0 0 0 1-1V6.945l1.042-4.299a1.5 1.5 0 1 1 2.916.707l-2.47 10.192a1.888 1.888 0 0 0 .348.064 1.03 1.03 0 0 0 .938-.655L24.92 7.12a1.499 1.499 0 0 1 1.974 1.938ZM20 24h-9a1 1 0 0 0-1 1v3h11v-3a1 1 0 0 0-1-1Z"
        })
    });
var $fe3c08f8a3179b65$export$2e2bcd8739ae039 = $fe3c08f8a3179b65$var$SvgGlyphiconsBasic459HandOk;




const $2e665cf8df210589$var$SvgGlyphiconsBasic46Calendar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 18.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm-.5 3.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-8h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm4 8h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-8-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm12-8h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-4 0h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0-4h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM27 7v19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2.002 2.002 0 0 1 2-2v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V5a2.002 2.002 0 0 1 2 2Zm-1.999 19V12H7v14Z"
        })
    });
var $2e665cf8df210589$export$2e2bcd8739ae039 = $2e665cf8df210589$var$SvgGlyphiconsBasic46Calendar;




const $7951879cff219a47$var$SvgGlyphiconsBasic460Briefcase = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 7h-2a3.003 3.003 0 0 1 3-3h4a3.003 3.003 0 0 1 3 3h-2a1.001 1.001 0 0 0-1-1h-4a1.001 1.001 0 0 0-1 1Zm15 5v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V12a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3Zm-10 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Z"
        })
    });
var $7951879cff219a47$export$2e2bcd8739ae039 = $7951879cff219a47$var$SvgGlyphiconsBasic460Briefcase;




const $1886aa0a073b67de$var$SvgGlyphiconsBasic461Send = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.863 6.914-2.767 18.445a.5.5 0 0 1-.691.386L16.6 22.4l-3.746 3.746a.5.5 0 0 1-.854-.353v-4.955l8.633-7.064a1 1 0 1 0-1.266-1.548l-9.112 7.455-5.218-2.237a.5.5 0 0 1-.012-.914L27.16 6.385a.5.5 0 0 1 .703.529Z"
        })
    });
var $1886aa0a073b67de$export$2e2bcd8739ae039 = $1886aa0a073b67de$var$SvgGlyphiconsBasic461Send;




const $803a623c1e0cd926$var$SvgGlyphiconsBasic462Footprints = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.516 14.47 7.57 15.52l-.52-2.955C6.527 9.61 4.501 3.874 9.917 2.92c2.79-.492 3.476 2.433 3.823 4.403.474 2.69-.56 3.969-.225 7.148Zm8.566-4.55c-2.79-.492-3.476 2.433-3.823 4.403-.474 2.69.56 3.969.225 7.148l5.946 1.048.52-2.955c.522-2.954 2.548-8.69-2.868-9.644Zm-8.256 6.526-5.909 1.042.174.985a3 3 0 1 0 5.91-1.042ZM18 24.431a3 3 0 1 0 5.909 1.042l.174-.985-5.91-1.042Z"
        })
    });
var $803a623c1e0cd926$export$2e2bcd8739ae039 = $803a623c1e0cd926$var$SvgGlyphiconsBasic462Footprints;




const $95fa4f4130fa8bf9$var$SvgGlyphiconsBasic463ConstructionCone = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.045 12h-8.772l2.005-6.303A1 1 0 0 1 14.231 5H16.8a1 1 0 0 1 .94.658Zm.728 2H10.636l-1.59 5H22.59ZM26 25h-1.227l-1.455-4H8.41l-1.273 4H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $95fa4f4130fa8bf9$export$2e2bcd8739ae039 = $95fa4f4130fa8bf9$var$SvgGlyphiconsBasic463ConstructionCone;




const $c621c088191d8a83$var$SvgGlyphiconsBasic464PhoneOld = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 10.7V14a.821.821 0 0 1-.987.836l-4.027-.672A1.225 1.225 0 0 1 22 13v-1.184a1.988 1.988 0 0 0-1.74-1.984 38.144 38.144 0 0 0-8.52 0A1.988 1.988 0 0 0 10 11.816V13a1.225 1.225 0 0 1-.986 1.164l-4.027.672A.821.821 0 0 1 4 14v-3.3a3.003 3.003 0 0 1 1.79-2.747C7.553 7.17 10.756 6.234 16 6.234s8.447.936 10.21 1.719A3.003 3.003 0 0 1 28 10.7Zm-8 3.668V13a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v1.368L6.6 21.2A3 3 0 0 0 6 23v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3a3 3 0 0 0-.6-1.8Z"
        })
    });
var $c621c088191d8a83$export$2e2bcd8739ae039 = $c621c088191d8a83$var$SvgGlyphiconsBasic464PhoneOld;




const $009debcef2ac665a$var$SvgGlyphiconsBasic465Call = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.014 23.489-1.753 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.743 40.743 0 0 0 4.076 4.583 40.741 40.741 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0l2.828 2.828a1 1 0 0 1 0 1.415Z"
        })
    });
var $009debcef2ac665a$export$2e2bcd8739ae039 = $009debcef2ac665a$var$SvgGlyphiconsBasic465Call;




const $5e7ae1d2faacf186$var$SvgGlyphiconsBasic466Fax = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 23a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1ZM25 6a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v2h10Zm3 6v10a2.006 2.006 0 0 1-2 2H15v1a3.003 3.003 0 0 1-3 3H9a3.003 3.003 0 0 1-3-3h2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1h-1.44c-.08 0-.13.006-.176-.067s.016-.15.063-.217A3.003 3.003 0 0 0 12 22V10h14a2.006 2.006 0 0 1 2 2Zm-11 8.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm8-6.5a1 1 0 0 0-1-1h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1Z"
        })
    });
var $5e7ae1d2faacf186$export$2e2bcd8739ae039 = $5e7ae1d2faacf186$var$SvgGlyphiconsBasic466Fax;




const $aec5556705a5d8a3$var$SvgGlyphiconsBasic467Shredder = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 12H6a2.006 2.006 0 0 0-2 2v10a2.006 2.006 0 0 0 2 2h1v-4a1.003 1.003 0 0 1 1-1h16a1.003 1.003 0 0 1 1 1v4h1a2.006 2.006 0 0 0 2-2V14a2.006 2.006 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM24 10H8V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1ZM11 23.5v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm8 0v6a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm-4 0v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm8 0v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $aec5556705a5d8a3$export$2e2bcd8739ae039 = $aec5556705a5d8a3$var$SvgGlyphiconsBasic467Shredder;




const $451c3de8554c3061$var$SvgGlyphiconsBasic468MultifunctionPrinter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 13H6a2.006 2.006 0 0 0-2 2v9a2.006 2.006 0 0 0 2 2h2v-4a1.003 1.003 0 0 1 1-1h14a1.003 1.003 0 0 1 1 1v4h2a2.006 2.006 0 0 0 2-2v-9a2.006 2.006 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM10 23h12v5a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1ZM5.816 2.965l.368-.93a1 1 0 0 1 1.298-.562l19.64 7.764a1 1 0 0 1 .562 1.298l-.368.93a1 1 0 0 1-1.298.562L6.378 4.263a1 1 0 0 1-.562-1.298Z"
        })
    });
var $451c3de8554c3061$export$2e2bcd8739ae039 = $451c3de8554c3061$var$SvgGlyphiconsBasic468MultifunctionPrinter;




const $7c776f83a9812ad9$var$SvgGlyphiconsBasic469Scanner = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 17H6a2.006 2.006 0 0 0-2 2v4a2.006 2.006 0 0 0 2 2v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a2.006 2.006 0 0 0 2-2v-4a2.006 2.006 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM5.816 6.965l.368-.93a1 1 0 0 1 1.298-.562l19.64 7.764a1 1 0 0 1 .562 1.298l-.368.93a1 1 0 0 1-1.298.562L6.378 8.263a1 1 0 0 1-.562-1.298Z"
        })
    });
var $7c776f83a9812ad9$export$2e2bcd8739ae039 = $7c776f83a9812ad9$var$SvgGlyphiconsBasic469Scanner;




const $368aa59675801648$var$SvgGlyphiconsBasic47Router = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.927 12.005a5.874 5.874 0 0 1 0-6.01.998.998 0 0 1 1.354-.335l.697.402a1.011 1.011 0 0 1 .339 1.404 3.034 3.034 0 0 0 0 3.068 1.011 1.011 0 0 1-.34 1.404l-.696.402a.998.998 0 0 1-1.354-.335Zm8.095-.067.697.402a.998.998 0 0 0 1.354-.335 5.874 5.874 0 0 0 0-6.01.998.998 0 0 0-1.354-.335l-.697.402a1.011 1.011 0 0 0-.339 1.404 3.034 3.034 0 0 1 0 3.068 1.011 1.011 0 0 0 .34 1.404ZM4.005 13.064a8.031 8.031 0 0 1 0-8.128.996.996 0 0 0-.355-1.373l-.692-.4a1.008 1.008 0 0 0-1.373.366 10.817 10.817 0 0 0 0 10.942 1.008 1.008 0 0 0 1.373.366l.692-.4a.996.996 0 0 0 .355-1.373Zm14.345 1.373.692.4a1.008 1.008 0 0 0 1.373-.366 10.817 10.817 0 0 0 0-10.942 1.008 1.008 0 0 0-1.373-.366l-.692.4a.996.996 0 0 0-.355 1.373 8.031 8.031 0 0 1 0 8.128.996.996 0 0 0 .355 1.373ZM28 22v4a2.006 2.006 0 0 1-2 2H6a2.006 2.006 0 0 1-2-2v-4a2.006 2.006 0 0 1 2-2h20a2.006 2.006 0 0 1 2 2Zm-2 2.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5ZM12 11V9a1 1 0 0 0-2 0v2l-.778 7h3.556Z"
        })
    });
var $368aa59675801648$export$2e2bcd8739ae039 = $368aa59675801648$var$SvgGlyphiconsBasic47Router;




const $f6eb2a2b685c1035$var$SvgGlyphiconsBasic470SecurityCamera = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 18v9h-2a1 1 0 0 1-1-1v-2h-4a1.5 1.5 0 0 1-1.404-.974l-2.346-6.254-5.246 1.406a.5.5 0 0 1-.503-.151l-6.676-7.529a.5.5 0 0 1 .245-.814l18.537-4.967a1 1 0 0 1 1.224.707l2.07 7.727a1 1 0 0 1-.706 1.225l-6.034 1.616L22.04 21H25v-2a1 1 0 0 1 1-1ZM2.616 13.179a.5.5 0 0 0-.354.612l1.035 3.864a.5.5 0 0 0 .613.354l4.189-1.123-3.71-4.182Z"
        })
    });
var $f6eb2a2b685c1035$export$2e2bcd8739ae039 = $f6eb2a2b685c1035$var$SvgGlyphiconsBasic470SecurityCamera;




const $510732b7432045fd$var$SvgGlyphiconsBasic471Sort = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.08 12H23v5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-5h-2.08a1 1 0 0 1-.819-1.573l4.58-6.542a1 1 0 0 1 1.638 0l4.58 6.542a1 1 0 0 1-.82 1.573Zm-9 8H14v-5a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v5H6.92a1 1 0 0 0-.819 1.573l4.58 6.542a1 1 0 0 0 1.638 0l4.58-6.542a1 1 0 0 0-.82-1.573Z"
        })
    });
var $510732b7432045fd$export$2e2bcd8739ae039 = $510732b7432045fd$var$SvgGlyphiconsBasic471Sort;




const $1f97f72776a586fb$var$SvgGlyphiconsBasic472SortAlphabetically = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.899 20.573-4.58 6.542a1 1 0 0 1-1.638 0l-4.58-6.542a1 1 0 0 1 .82-1.573H19V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v13h2.08a1 1 0 0 1 .819 1.573ZM13 25H9a1 1 0 0 1-.832-1.555L11.132 19H9.5a1 1 0 0 1 0-2H13a1 1 0 0 1 .832 1.555L10.868 23H13a1 1 0 0 1 0 2Zm.849-12.077a1.001 1.001 0 0 1-1.309-.537L11.962 11h-1.925l-.579 1.386a1 1 0 0 1-1.846-.772l2.464-5.9a1 1 0 0 1 1.846 0l2.464 5.9a1.001 1.001 0 0 1-.537 1.309ZM11.329 9.5 11 8.573l-.331.927Z"
        })
    });
var $1f97f72776a586fb$export$2e2bcd8739ae039 = $1f97f72776a586fb$var$SvgGlyphiconsBasic472SortAlphabetically;




const $b24c2634f32f06a2$var$SvgGlyphiconsBasic473SortAlphabeticallyAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.899 20.573-4.58 6.542a1 1 0 0 1-1.638 0l-4.58-6.542a1 1 0 0 1 .82-1.573H19V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v13h2.08a1 1 0 0 1 .819 1.573ZM13 13H9a1 1 0 0 1-.832-1.555L11.132 7H9.5a1 1 0 0 1 0-2H13a1 1 0 0 1 .832 1.555L10.868 11H13a1 1 0 0 1 0 2Zm.849 11.923a1.001 1.001 0 0 1-1.309-.537L11.962 23h-1.925l-.579 1.386a1 1 0 0 1-1.846-.772l2.464-5.9a1 1 0 0 1 1.846 0l2.464 5.9a1.001 1.001 0 0 1-.537 1.309Zm-2.52-3.423-.33-.927-.331.927Z"
        })
    });
var $b24c2634f32f06a2$export$2e2bcd8739ae039 = $b24c2634f32f06a2$var$SvgGlyphiconsBasic473SortAlphabeticallyAlt;




const $6acc71549beefc60$var$SvgGlyphiconsBasic474SortNumerically = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.899 20.573-4.58 6.542a1 1 0 0 1-1.638 0l-4.58-6.542a1 1 0 0 1 .82-1.573H19V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v13h2.08a1 1 0 0 1 .819 1.573ZM13 25H9.321a1 1 0 0 1-.999-.947 3.615 3.615 0 0 1 2.306-3.567c1.05-.373 1.05-.653 1.05-.772a.715.715 0 0 0-.714-.714 1.202 1.202 0 0 0-.95.502 1 1 0 1 1-1.529-1.29A3.169 3.169 0 0 1 10.964 17a2.718 2.718 0 0 1 2.715 2.714c0 1.81-1.791 2.447-2.38 2.657a1.359 1.359 0 0 0-.748.629H13a1 1 0 0 1 0 2Zm-1-13V6a1 1 0 0 0-1.707-.707l-2 2a1 1 0 0 0 1.414 1.414L10 8.414V12a1 1 0 0 0 2 0Z"
        })
    });
var $6acc71549beefc60$export$2e2bcd8739ae039 = $6acc71549beefc60$var$SvgGlyphiconsBasic474SortNumerically;




const $33d99f4de66791df$var$SvgGlyphiconsBasic475SortNumericallyAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.899 20.573-4.58 6.542a1 1 0 0 1-1.638 0l-4.58-6.542a1 1 0 0 1 .82-1.573H19V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v13h2.08a1 1 0 0 1 .819 1.573ZM11 25a1 1 0 0 1-1-1v-3.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2A1 1 0 0 1 12 18v6a1 1 0 0 1-1 1Zm3-13a1 1 0 0 0-1-1h-2.45a1.359 1.359 0 0 1 .749-.629c.589-.21 2.38-.847 2.38-2.657A2.718 2.718 0 0 0 10.964 5a3.169 3.169 0 0 0-2.479 1.213 1 1 0 1 0 1.53 1.289A1.202 1.202 0 0 1 10.964 7a.715.715 0 0 1 .715.714c0 .119 0 .4-1.051.772a3.615 3.615 0 0 0-2.306 3.567 1 1 0 0 0 1 .947H13a1 1 0 0 0 1-1Z"
        })
    });
var $33d99f4de66791df$export$2e2bcd8739ae039 = $33d99f4de66791df$var$SvgGlyphiconsBasic475SortNumericallyAlt;




const $08243d895cfc90ca$var$SvgGlyphiconsBasic476SortAttributes = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.899 20.573-4.58 6.542a1 1 0 0 1-1.638 0l-4.58-6.542a1 1 0 0 1 .82-1.573H19V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v13h2.08a1 1 0 0 1 .819 1.573ZM5 9h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1Zm0 6h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1Zm0 6h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1Zm8 2H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
    });
var $08243d895cfc90ca$export$2e2bcd8739ae039 = $08243d895cfc90ca$var$SvgGlyphiconsBasic476SortAttributes;




const $c6ce726741612000$var$SvgGlyphiconsBasic477SortAttributesAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.899 20.573-4.58 6.542a1 1 0 0 1-1.638 0l-4.58-6.542a1 1 0 0 1 .82-1.573H19V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v13h2.08a1 1 0 0 1 .819 1.573ZM7 23H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm2-6H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm2-6H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm2-6H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $c6ce726741612000$export$2e2bcd8739ae039 = $c6ce726741612000$var$SvgGlyphiconsBasic477SortAttributesAlt;




const $a5aeaa12c8513006$var$SvgGlyphiconsBasic478Switch = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 19v3a1 1 0 0 1-1 1h-5v2.08a1 1 0 0 1-1.573.819l-6.542-4.58a1 1 0 0 1 0-1.638l6.542-4.58a1 1 0 0 1 1.573.82V18h5a1 1 0 0 1 1 1Zm10.115-8.32-6.542-4.579a1 1 0 0 0-1.573.82V9h-5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5v2.08a1 1 0 0 0 1.573.819l6.542-4.58a1 1 0 0 0 0-1.638Z"
        })
    });
var $a5aeaa12c8513006$export$2e2bcd8739ae039 = $a5aeaa12c8513006$var$SvgGlyphiconsBasic478Switch;




const $d9ebf8ed88ca76e0$var$SvgGlyphiconsBasic479UserScam = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24.237V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.763a1.578 1.578 0 0 1 .931-1.365l3.26-1.717A3.992 3.992 0 0 0 12 24h7a3.992 3.992 0 0 0 3.81-2.845l3.259 1.717A1.578 1.578 0 0 1 27 24.237Zm-16.66-5.35A21.767 21.767 0 0 1 9 13v-2.571C9 6.57 11.364 4 15.5 4S22 6.571 22 10.429V13a21.767 21.767 0 0 1-1.339 5.886A2 2 0 0 1 19 22h-7a2 2 0 0 1-1.661-3.114ZM17 12a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2h-1a1 1 0 0 0-1 1Zm-3 5a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2h-1a1 1 0 0 0-1 1Zm-3-5a1 1 0 0 0 1 1h1a1 1 0 0 0 0-2h-1a1 1 0 0 0-1 1Z"
        })
    });
var $d9ebf8ed88ca76e0$export$2e2bcd8739ae039 = $d9ebf8ed88ca76e0$var$SvgGlyphiconsBasic479UserScam;




const $db1c9f587632474c$var$SvgGlyphiconsBasic48VideoCamera = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 9h-7l-2-2H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2v12a2.006 2.006 0 0 0 2 2h16a2.006 2.006 0 0 0 2-2V11a2.006 2.006 0 0 0-2-2Zm0 4.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm10-1v9a.5.5 0 0 1-.5.5H30l-4-2.5v-5l4-2.5h1.5a.5.5 0 0 1 .5.5Z"
        })
    });
var $db1c9f587632474c$export$2e2bcd8739ae039 = $db1c9f587632474c$var$SvgGlyphiconsBasic48VideoCamera;




const $ad9f01f62a3cc1a8$var$SvgGlyphiconsBasic480UserScamAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24.237V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.763a1.578 1.578 0 0 1 .931-1.365l3.26-1.717A3.992 3.992 0 0 0 12 24h7a3.992 3.992 0 0 0 3.81-2.845l3.259 1.717A1.578 1.578 0 0 1 27 24.237Zm-16.66-5.35A21.767 21.767 0 0 1 9 13v-2.571C9 6.57 11.364 4 15.5 4S22 6.571 22 10.429V13a21.767 21.767 0 0 1-1.339 5.886A2 2 0 0 1 19 22h-7a2 2 0 0 1-1.661-3.114Zm.354-6.723.129.774a2 2 0 0 0 1.16 1.5l2.705 1.201a2 2 0 0 0 1.624 0l2.704-1.202a2 2 0 0 0 1.16-1.499l.13-.774A1 1 0 0 0 19.32 11h-7.64a1 1 0 0 0-.986 1.164Z"
        })
    });
var $ad9f01f62a3cc1a8$export$2e2bcd8739ae039 = $ad9f01f62a3cc1a8$var$SvgGlyphiconsBasic480UserScamAlt;




const $57474ed773b1b221$var$SvgGlyphiconsBasic481ShopWindow = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 26v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-8.031c.015.001.028.007.043.009A4.52 4.52 0 0 0 7 16.74V22h18v-5.28a4.21 4.21 0 0 0 1.043.258 4.513 4.513 0 0 0 .456.022s.335-.03.501-.049V25h1a1 1 0 0 1 1 1ZM27 4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1h22Zm1.894 6.789L27 7H5l-1.894 3.789a1 1 0 0 0-.106.447v1.121a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 8 12.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.857a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 15 12.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.857a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 22 12.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.857a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 29 12.5v-1.264a1 1 0 0 0-.106-.447Z"
        })
    });
var $57474ed773b1b221$export$2e2bcd8739ae039 = $57474ed773b1b221$var$SvgGlyphiconsBasic481ShopWindow;




const $9e54fc707433c993$var$SvgGlyphiconsBasic482ShopDoor = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 26v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-8.031c.015.001.028.007.043.009A4.52 4.52 0 0 0 7 16.74V25h7v-8.259a4.514 4.514 0 0 0 2.025-1.448l.014.014A.955.955 0 0 0 16 15.5V19a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-2.28a4.21 4.21 0 0 0 1.043.258 4.513 4.513 0 0 0 .456.022s.335-.03.501-.049V25h1a1 1 0 0 1 1 1ZM27 4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1h22Zm1.894 6.789L27 7H5l-1.894 3.789a1 1 0 0 0-.106.447v1.121a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 8 12.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.857a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 15 12.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.857a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 22 12.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v.857a2.598 2.598 0 0 0 2.242 2.63A2.5 2.5 0 0 0 29 12.5v-1.264a1 1 0 0 0-.106-.447Z"
        })
    });
var $9e54fc707433c993$export$2e2bcd8739ae039 = $9e54fc707433c993$var$SvgGlyphiconsBasic482ShopDoor;




const $2c9e3a19e86affec$var$SvgGlyphiconsBasic483Kiosk = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 5H5V4a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2Zm-.5 14H26v-4h-2v4H8v-4H6v4h-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5H6v3a1 1 0 0 0 2 0v-3h16v3a1 1 0 0 0 2 0v-3h.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Zm2.394-8.21L27 7H5l-1.894 3.79a1 1 0 0 0-.106.446V12a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-.764a1 1 0 0 0-.106-.447Z"
        })
    });
var $2c9e3a19e86affec$export$2e2bcd8739ae039 = $2c9e3a19e86affec$var$SvgGlyphiconsBasic483Kiosk;




const $e1ca56bf649b3fdb$var$SvgGlyphiconsBasic484KioskWheels = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 5H5V4a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2Zm0 17.056a3.493 3.493 0 1 1-5.958 2.86L10.667 23.03a3.496 3.496 0 1 1-5.621-1.022L5 22v-2.5a.5.5 0 0 1 .5-.5H6v-4h2v4h16v-4h2v4h.5a.5.5 0 0 1 .5.5ZM9 24.5A1.5 1.5 0 1 0 7.5 26 1.502 1.502 0 0 0 9 24.5Zm17 0a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5Zm2.894-13.71L27 7H5l-1.894 3.79a1 1 0 0 0-.106.446V12a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-.764a1 1 0 0 0-.106-.447Z"
        })
    });
var $e1ca56bf649b3fdb$export$2e2bcd8739ae039 = $e1ca56bf649b3fdb$var$SvgGlyphiconsBasic484KioskWheels;




const $3936ee44c6011a13$var$SvgGlyphiconsBasic485KioskImmobile = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 11.236V12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-.764a1 1 0 0 1 .106-.447L5 7h22l1.894 3.79a1 1 0 0 1 .106.446ZM27 4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v1h22Zm-.5 15H26v-4h-2v4H8v-4H6v4h-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h5.75l1.857.684-6.453 2.378a1 1 0 0 0 .692 1.877L16 24.75l8.654 3.188a1 1 0 1 0 .692-1.877l-6.453-2.377L20.75 23h5.75a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5Z"
        })
    });
var $3936ee44c6011a13$export$2e2bcd8739ae039 = $3936ee44c6011a13$var$SvgGlyphiconsBasic485KioskImmobile;




const $05c0fe4b69e825a1$var$SvgGlyphiconsBasic486KioskFood = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 8.343V9.5a.5.5 0 0 1-.5.5h-25a.5.5 0 0 1-.5-.5V8.343a.5.5 0 0 1 .32-.466l12.321-4.739a1 1 0 0 1 .718 0l12.32 4.739a.5.5 0 0 1 .321.466ZM20.5 25a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm-9 0a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5Zm14-9H17v-4h-2v4H6.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H8v5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
        })
    });
var $05c0fe4b69e825a1$export$2e2bcd8739ae039 = $05c0fe4b69e825a1$var$SvgGlyphiconsBasic486KioskFood;




const $e124a18a37717e17$var$SvgGlyphiconsBasic487Exchange = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 12V9a1 1 0 0 1 1-1h1v5H8a1 1 0 0 1-1-1Zm5 3.92a1 1 0 0 0-1.573-.819l-6.542 4.58a1 1 0 0 0 0 1.638l6.542 4.58a1 1 0 0 0 1.573-.82V23h5v-5h-5ZM13 8h-2v5h2Zm11 10h-1v5h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Zm4.115-8.32-6.542-4.579a1 1 0 0 0-1.573.82V8h-5v5h5v2.08a1 1 0 0 0 1.573.819l6.542-4.58a1 1 0 0 0 0-1.638ZM19 23h2v-5h-2Z"
        })
    });
var $e124a18a37717e17$export$2e2bcd8739ae039 = $e124a18a37717e17$var$SvgGlyphiconsBasic487Exchange;




const $4d531a3ab39b6fe1$var$SvgGlyphiconsBasic488Bullets = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5 25h6v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Zm8 2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h-6Zm8 0a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h-6ZM10.5 12h-5a.5.5 0 0 0-.5.5V23h6V12.5a.5.5 0 0 0-.5-.5Zm8 0h-5a.5.5 0 0 0-.5.5V23h6V12.5a.5.5 0 0 0-.5-.5Zm8 0h-5a.5.5 0 0 0-.5.5V23h6V12.5a.5.5 0 0 0-.5-.5ZM10 7 8.447 3.894a.5.5 0 0 0-.894 0L6 7v3h4Zm8 0-1.553-3.106a.5.5 0 0 0-.894 0L14 7v3h4Zm8 0-1.553-3.106a.5.5 0 0 0-.894 0L22 7v3h4Z"
        })
    });
var $4d531a3ab39b6fe1$export$2e2bcd8739ae039 = $4d531a3ab39b6fe1$var$SvgGlyphiconsBasic488Bullets;




const $c59ded435fb8d40d$var$SvgGlyphiconsBasic489Gun = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.58 24.694-2.42-9.125a1 1 0 0 1 .249-.99l1.3-1.309a1 1 0 0 0 .291-.705V10a1 1 0 0 0-1-1H9V7.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5V9H5a1 1 0 0 0-1 1v2.543a1 1 0 0 0 .346.756l1.688 1.458a1 1 0 0 0 .654.243h5.415l.935 3.274A1 1 0 0 0 14 19h5.288l1.505 6.275a1 1 0 0 0 .961.725h5.874a1 1 0 0 0 .952-1.306ZM14.754 17l-.571-2h4.145l.48 2Z"
        })
    });
var $c59ded435fb8d40d$export$2e2bcd8739ae039 = $c59ded435fb8d40d$var$SvgGlyphiconsBasic489Gun;




const $7f1571bbaa4422f5$var$SvgGlyphiconsBasic49Star = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.348 14.18-6.392 4.643 2.437 7.506a.654.654 0 0 1-.622.856.643.643 0 0 1-.381-.128l-6.386-4.638-6.386 4.638a.643.643 0 0 1-.38.128.654.654 0 0 1-.623-.856l2.438-7.506-6.393-4.644A.652.652 0 0 1 5.044 13h7.9l2.44-7.516a.652.652 0 0 1 1.24 0L19.064 13h7.9a.652.652 0 0 1 .384 1.18Z"
        })
    });
var $7f1571bbaa4422f5$export$2e2bcd8739ae039 = $7f1571bbaa4422f5$var$SvgGlyphiconsBasic49Star;




const $1643f4605dbc4152$var$SvgGlyphiconsBasic490GunOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.628 26h-5.874a1 1 0 0 1-.961-.725L19.288 19h-2.321l10-10H27a1 1 0 0 1 1 1v2.565a1 1 0 0 1-.29.705l-1.301 1.309a1 1 0 0 0-.25.99l2.421 9.125A1 1 0 0 1 27.628 26Zm-.413-23.06a1.5 1.5 0 0 0-2.121 0L19.034 9H9V7.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5V9H5a1 1 0 0 0-1 1v2.543a1 1 0 0 0 .346.756l1.688 1.458a1 1 0 0 0 .654.243h5.415l.206.724-9.37 9.37a1.5 1.5 0 1 0 2.122 2.12L27.215 5.062a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $1643f4605dbc4152$export$2e2bcd8739ae039 = $1643f4605dbc4152$var$SvgGlyphiconsBasic490GunOff;




const $2aeb5f110ee0e479$var$SvgGlyphiconsBasic491ChargingStation = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30 9V7a1 1 0 0 0-2 0v2h-2V7a1 1 0 0 0-2 0v2a1 1 0 0 0-1 1v1.5a.994.994 0 0 0 .143.515l1.5 2.5A1 1 0 0 0 25.5 15h.5v7h-2v-5a2.003 2.003 0 0 0-2-2h-2V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v19H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1v-8h2v5a2.003 2.003 0 0 0 2 2h2a2.003 2.003 0 0 0 2-2v-7h.5a1 1 0 0 0 .857-.485l1.5-2.5A.994.994 0 0 0 31 11.5V10a1 1 0 0 0-1-1Zm-13 3.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5Z"
        })
    });
var $2aeb5f110ee0e479$export$2e2bcd8739ae039 = $2aeb5f110ee0e479$var$SvgGlyphiconsBasic491ChargingStation;




const $bc14aa41a1f9e97c$var$SvgGlyphiconsBasic492GasStation = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.976 10.65 22 5.42V8.08l1 .875V12a1 1 0 0 0 1 1h3v9h-3v-5a2.003 2.003 0 0 0-2-2h-2V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v19H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1v-8h2v5a2.003 2.003 0 0 0 2 2h3a2.003 2.003 0 0 0 2-2v-9.093a3.001 3.001 0 0 0-1.024-2.258ZM17 12.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5Z"
        })
    });
var $bc14aa41a1f9e97c$export$2e2bcd8739ae039 = $bc14aa41a1f9e97c$var$SvgGlyphiconsBasic492GasStation;




const $dc37afa04d91d849$var$SvgGlyphiconsBasic493Rotate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm-3.226 6.405a8.95 8.95 0 0 1-1.657-.843.498.498 0 0 0-.68.117l-1.174 1.618a.508.508 0 0 0 .123.717 11.946 11.946 0 0 0 2.426 1.235.507.507 0 0 0 .652-.324l.615-1.902a.498.498 0 0 0-.305-.618Zm-5.17-5.155a.498.498 0 0 0-.618-.304l-1.9.621a.507.507 0 0 0-.323.653 11.95 11.95 0 0 0 1.242 2.422.508.508 0 0 0 .718.12l1.614-1.178a.498.498 0 0 0 .115-.68 8.969 8.969 0 0 1-.848-1.654Zm16.07 2.32a.498.498 0 0 0-.683.098 9.042 9.042 0 0 1-1.316 1.318.498.498 0 0 0-.098.682l1.177 1.616a.507.507 0 0 0 .72.105 12.034 12.034 0 0 0 1.921-1.923.508.508 0 0 0-.105-.72Zm-4.737 3.447a.498.498 0 0 0-.61-.32 8.977 8.977 0 0 1-1.837.29.498.498 0 0 0-.48.494l.001 2a.508.508 0 0 0 .521.507 11.969 11.969 0 0 0 2.687-.425.507.507 0 0 0 .337-.645ZM16 4a11.982 11.982 0 0 0-9.37 4.508L5.053 6.932a.5.5 0 0 0-.845.264l-1.114 6.129a.5.5 0 0 0 .581.581l6.129-1.114a.5.5 0 0 0 .264-.845L8.78 10.659A8.983 8.983 0 0 1 25 16a11.26 11.26 0 0 1-.301 2.32.499.499 0 0 0 .32.609l1.902.617a.507.507 0 0 0 .645-.338 9.95 9.95 0 0 0 .432-3.25A11.986 11.986 0 0 0 16 4Z"
        })
    });
var $dc37afa04d91d849$export$2e2bcd8739ae039 = $dc37afa04d91d849$var$SvgGlyphiconsBasic493Rotate;




const $8e4fed0734180cfd$var$SvgGlyphiconsBasic494RotateHorizontal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m17.336 22.456.132 1.986a.498.498 0 0 1-.475.532c-.345.012-.693.016-1.004.026q-.547 0-1.085-.026a.5.5 0 0 1-.47-.539l.143-1.993a.498.498 0 0 1 .526-.46c.294.014.592.022.896.018q.405 0 .804-.016a.51.51 0 0 1 .533.472Zm-5.846-1.003a15.17 15.17 0 0 1-1.59-.497.492.492 0 0 0-.634.27l-.77 1.846a.504.504 0 0 0 .278.666 18.175 18.175 0 0 0 2.035.638.509.509 0 0 0 .615-.383l.436-1.951a.497.497 0 0 0-.37-.589Zm11.164-.194a.492.492 0 0 0-.632-.274 15.293 15.293 0 0 1-1.594.489.497.497 0 0 0-.372.586l.425 1.954a.509.509 0 0 0 .613.386 18.246 18.246 0 0 0 2.036-.626.504.504 0 0 0 .282-.664Zm4.107-3.05a.504.504 0 0 0-.675.118 6.568 6.568 0 0 1-.992.978.503.503 0 0 0-.106.684l1.164 1.63a.504.504 0 0 0 .715.108 9.515 9.515 0 0 0 1.695-1.696.499.499 0 0 0-.131-.712ZM16 14c-1.105 0-2 .672-2 1.5s.895 1.5 2 1.5 2-.672 2-1.5-.895-1.5-2-1.5Zm13.913 1C29.16 10.451 23.323 7 16 7S2.838 10.441 2.086 15H-.046a.5.5 0 0 0-.41.785l3.545 5.121a.5.5 0 0 0 .822 0l3.546-5.121A.5.5 0 0 0 7.046 15H5.173c.903-2.796 5.488-5 10.827-5 5.297 0 9.86 2.169 10.813 4.934a1.097 1.097 0 0 0 .494.614s1.155.614 1.663.878a.715.715 0 0 0 1.024-.696 10.61 10.61 0 0 0-.081-.73Z"
        })
    });
var $8e4fed0734180cfd$export$2e2bcd8739ae039 = $8e4fed0734180cfd$var$SvgGlyphiconsBasic494RotateHorizontal;




const $b7c1100c0009556e$var$SvgGlyphiconsBasic495RotateVertical = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.78 29.183a.5.5 0 0 1-.34.645 6.099 6.099 0 0 1-2.88 0 .5.5 0 0 1-.34-.645l.62-1.873a.565.565 0 0 1 .641-.354 3.07 3.07 0 0 0 1.038 0 .565.565 0 0 1 .641.354Zm-5.793-5.109a.502.502 0 0 0-.668-.193l-1.759.95a.508.508 0 0 0-.198.698 11.686 11.686 0 0 0 1.337 1.848.502.502 0 0 0 .724.01l1.42-1.407a.5.5 0 0 0 .017-.688 8.743 8.743 0 0 1-.873-1.218Zm12.963-9.231.02-.001c-.025-.496-.07-.981-.126-1.46l-.003-.045c0-.006-.005-.011-.006-.017C24.04 6.77 20.402 2 16 2c-4.608 0-8.294 5.133-8.902 12H4.954a.5.5 0 0 0-.41.785l3.545 5.121a.5.5 0 0 0 .822 0l3.546-5.121a.5.5 0 0 0-.411-.785h-1.937c.53-5.046 3.01-9 5.891-9 2.795 0 5.302 3.867 5.874 8.83.06.531.102 1.07.117 1.616a.497.497 0 0 0 .496.488l2-.006a.506.506 0 0 0 .505-.514c-.005-.193-.032-.38-.042-.571Zm-2.484 9.938-1.762-.943a.502.502 0 0 0-.667.196 8.823 8.823 0 0 1-.87 1.224.5.5 0 0 0 .02.689l1.43 1.399a.502.502 0 0 0 .724-.016 11.79 11.79 0 0 0 1.326-1.853.507.507 0 0 0-.201-.696Zm1.82-5.83-1.98-.273a.497.497 0 0 0-.557.417 16.887 16.887 0 0 1-.357 1.645.493.493 0 0 0 .332.607l1.914.582a.504.504 0 0 0 .634-.342 19.876 19.876 0 0 0 .446-2.057.507.507 0 0 0-.431-.579ZM16.5 14c-.828 0-1.5.895-1.5 2s.672 2 1.5 2 1.5-.895 1.5-2-.672-2-1.5-2Z"
        })
    });
var $b7c1100c0009556e$export$2e2bcd8739ae039 = $b7c1100c0009556e$var$SvgGlyphiconsBasic495RotateVertical;




const $ce954a6c21627c32$var$SvgGlyphiconsBasic496Podcast = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.9 15a6.914 6.914 0 0 1-.28 1.94 1.4 1.4 0 0 1-2.688-.783A4.157 4.157 0 0 0 20.1 15a4.1 4.1 0 1 0-8.2 0 4.157 4.157 0 0 0 .168 1.157 1.4 1.4 0 0 1-2.687.783A6.9 6.9 0 1 1 22.9 15ZM16 3.1A11.9 11.9 0 0 0 5.52 20.64a1.4 1.4 0 0 0 2.465-1.33 9.1 9.1 0 1 1 16.03 0 1.4 1.4 0 0 0 2.464 1.33A11.9 11.9 0 0 0 16 3.1ZM18 15a2 2 0 1 0-2 2 2.002 2.002 0 0 0 2-2Zm-1.36 4h-1.28a2 2 0 0 0-1.972 2.329l.973 5.835a1 1 0 0 0 .986.836h1.306a1 1 0 0 0 .986-.836l.973-5.835A2 2 0 0 0 16.639 19Z"
        })
    });
var $ce954a6c21627c32$export$2e2bcd8739ae039 = $ce954a6c21627c32$var$SvgGlyphiconsBasic496Podcast;




const $08140fe4a3d38549$var$SvgGlyphiconsBasic497More = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 16a3 3 0 1 1-3-3 3 3 0 0 1 3 3Zm-11-3a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm-8 0a3 3 0 1 0 3 3 3 3 0 0 0-3-3Z"
        })
    });
var $08140fe4a3d38549$export$2e2bcd8739ae039 = $08140fe4a3d38549$var$SvgGlyphiconsBasic497More;




const $a1c740ef78072cb3$var$SvgGlyphiconsBasic498MoreVertical = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 24a3 3 0 1 1-3-3 3 3 0 0 1 3 3Zm-3-11a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm0-2a3 3 0 1 0-3-3 3 3 0 0 0 3 3Z"
        })
    });
var $a1c740ef78072cb3$export$2e2bcd8739ae039 = $a1c740ef78072cb3$var$SvgGlyphiconsBasic498MoreVertical;




const $869f970e18f0a762$var$SvgGlyphiconsBasic499SkullCrossbones = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.5 20h-1.983l-2.156-1.165.08-.477A4.194 4.194 0 0 0 25 16.35a22.481 22.481 0 0 0-.231-3.377L26.556 12H28.5a1.5 1.5 0 0 0 0-3H28v-.5a1.5 1.5 0 0 0-3 0v.932l-1.04.566C22.747 7.135 20.333 5.35 16 5.35c-4.387 0-6.81 1.71-8.007 4.623L7 9.433V8.5a1.5 1.5 0 0 0-3 0V9h-.5a1.5 1.5 0 0 0 0 3h1.944q.788.43 1.775.966A23.881 23.881 0 0 0 7 16.35a4.194 4.194 0 0 0 .56 2.008l.08.477L5.482 20H3.5a1.5 1.5 0 0 0 0 3H4v.5a1.5 1.5 0 0 0 3 0v-.91c.639-.344 1.376-.743 2.202-1.19l.85.284a2.035 2.035 0 0 1 1.19 1.286l.515 2.06A1.35 1.35 0 0 0 13 26h6a1.35 1.35 0 0 0 1.243-.97l.514-2.06a2.035 2.035 0 0 1 1.192-1.286l.849-.283L25 22.59v.909a1.5 1.5 0 0 0 3 0V23h.5a1.5 1.5 0 0 0 0-3Zm-15.651.151a1.343 1.343 0 0 1-1.77.08l-1.157-.963a1.765 1.765 0 0 1-.476-1.882l.108-.272A1.918 1.918 0 0 1 11.2 16h1.6a2.062 2.062 0 0 1 1.7 1 1.724 1.724 0 0 1-.349 1.849Zm4.257 3.402-.212-.106a2.26 2.26 0 0 0-1.788 0l-.212.106c-.492.246-.693.044-.447-.447l1.106-2.212c.246-.492.648-.492.894 0l1.106 2.212c.246.491.045.693-.447.447Zm4.972-4.285-1.156.964a1.343 1.343 0 0 1-1.77-.08l-1.304-1.303A1.724 1.724 0 0 1 17.5 17a2.062 2.062 0 0 1 1.7-1h1.6a1.918 1.918 0 0 1 1.646 1.114l.108.272a1.765 1.765 0 0 1-.476 1.882Z"
        })
    });
var $869f970e18f0a762$export$2e2bcd8739ae039 = $869f970e18f0a762$var$SvgGlyphiconsBasic499SkullCrossbones;




const $801c92e14ff50229$var$SvgGlyphiconsBasic5Settings = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.824 9.742 4.163 7.014a1.258 1.258 0 0 1 .262-1.373L5.627 4.44a1.25 1.25 0 0 1 1.333-.283l2.758 1.676a1.264 1.264 0 0 1 .502.655l.706 2.157a.757.757 0 0 0 .182.296l1.947 1.947a8.37 8.37 0 0 0 .074.913l-1.763 1.762-2.44-2.44a.753.753 0 0 0-.296-.182l-2.156-.706a1.254 1.254 0 0 1-.65-.492Zm17.171 9.01c-.072.014-.14.037-.213.048a8.607 8.607 0 0 1-1.285.097 8.469 8.469 0 0 1-1.232-.09l-2.85 2.85 5.757 5.757a1 1 0 0 0 1.414 0l2.828-2.828a1 1 0 0 0 0-1.414Zm-.513-1.93a6.5 6.5 0 0 0 4.923-3.903 6.22 6.22 0 0 0 .503-2.85.495.495 0 0 0-.845-.301l-2.419 2.419a.496.496 0 0 1-.469.13l-3.38-.829a.496.496 0 0 1-.364-.363l-.83-3.38a.496.496 0 0 1 .132-.47l2.417-2.417a.499.499 0 0 0-.34-.849 6.228 6.228 0 0 0-2.778.491 6.405 6.405 0 0 0-3.7 7.925L4.586 23.171a1 1 0 0 0 0 1.415l2.828 2.828a1 1 0 0 0 1.414 0l10.794-10.793a6.507 6.507 0 0 0 2.86.201Z"
        })
    });
var $801c92e14ff50229$export$2e2bcd8739ae039 = $801c92e14ff50229$var$SvgGlyphiconsBasic5Settings;




const $30efc1c145e55dea$var$SvgGlyphiconsBasic50StarEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.965 13h-7.9l-2.44-7.516a.652.652 0 0 0-1.241 0L12.944 13h-7.9a.652.652 0 0 0-.384 1.18l6.393 4.643-2.438 7.506a.654.654 0 0 0 .622.856.643.643 0 0 0 .381-.128l6.386-4.638 6.386 4.638a.643.643 0 0 0 .38.128.654.654 0 0 0 .623-.856l-2.437-7.506 6.392-4.644A.652.652 0 0 0 26.965 13Zm-7.361 3.961-1.352.982.516 1.59.872 2.684-2.284-1.659-1.352-.982-1.352.982-2.284 1.659.872-2.684.516-1.59-1.352-.982-2.287-1.661h4.498l.516-1.59.873-2.689.873 2.69.516 1.589h4.498Z"
        })
    });
var $30efc1c145e55dea$export$2e2bcd8739ae039 = $30efc1c145e55dea$var$SvgGlyphiconsBasic50StarEmpty;




const $cddee6523cd1f4ae$var$SvgGlyphiconsBasic500Skull = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 3.35c-7 0-10 4.35-10 11a4.313 4.313 0 0 0 1.686 3.453l.173 1.207A1.191 1.191 0 0 0 9 20h1a1.777 1.777 0 0 1 1.447.894l1.106 2.212A1.777 1.777 0 0 0 14 24h4a1.777 1.777 0 0 0 1.447-.894l1.106-2.212A1.777 1.777 0 0 1 22 20h1a1.191 1.191 0 0 0 1.141-.99l.173-1.207A4.313 4.313 0 0 0 26 14.35c0-6.35-3-11-10-11Zm-3.151 14.801a1.343 1.343 0 0 1-1.77.08l-1.157-.963a1.765 1.765 0 0 1-.476-1.882l.108-.272A1.918 1.918 0 0 1 11.2 14h1.6a2.062 2.062 0 0 1 1.7 1 1.724 1.724 0 0 1-.349 1.849Zm4.257 3.402-.212-.106a2.26 2.26 0 0 0-1.788 0l-.212.106c-.492.246-.693.044-.447-.447l1.106-2.212c.246-.492.648-.492.894 0l1.106 2.212c.246.491.045.693-.447.447Zm4.972-4.285-1.156.964a1.343 1.343 0 0 1-1.77-.08l-1.304-1.303A1.724 1.724 0 0 1 17.5 15a2.062 2.062 0 0 1 1.7-1h1.6a1.918 1.918 0 0 1 1.646 1.114l.108.272a1.765 1.765 0 0 1-.476 1.882Zm1.06 6.456-1.032 3.065A4 4 0 0 1 18.528 29h-5.056a4 4 0 0 1-3.578-2.211l-1.032-3.065A.5.5 0 0 1 9.309 23h.423a.5.5 0 0 1 .416.223l1.555 2.332a1 1 0 0 0 .832.445h6.93a1 1 0 0 0 .832-.445l1.554-2.332a.5.5 0 0 1 .417-.223h.423a.5.5 0 0 1 .447.724Z"
        })
    });
var $cddee6523cd1f4ae$export$2e2bcd8739ae039 = $cddee6523cd1f4ae$var$SvgGlyphiconsBasic500Skull;




const $dc553b37db60f487$var$SvgGlyphiconsBasic501Server = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.5 22H26v-.5a.5.5 0 0 0-.5-.5h-19a.5.5 0 0 0-.5.5v.5H4.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H6v.5a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5V26h1.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5ZM24 24.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM27.5 6H26v-.5a.5.5 0 0 0-.5-.5h-19a.5.5 0 0 0-.5.5V6H4.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H6v.5a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5V10h1.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5ZM24 8.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm3.5 5.5H26v-.5a.5.5 0 0 0-.5-.5h-19a.5.5 0 0 0-.5.5v.5H4.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H6v.5a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5V18h1.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5ZM24 16.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Z"
        })
    });
var $dc553b37db60f487$export$2e2bcd8739ae039 = $dc553b37db60f487$var$SvgGlyphiconsBasic501Server;




const $0b3f043acb65ffbc$var$SvgGlyphiconsBasic502ServerPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h11.57a7.845 7.845 0 0 0 1.695 6H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 5v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h15.636A7.946 7.946 0 0 0 26 14h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4 7v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $0b3f043acb65ffbc$export$2e2bcd8739ae039 = $0b3f043acb65ffbc$var$SvgGlyphiconsBasic502ServerPlus;




const $1bfd77fc7716011d$var$SvgGlyphiconsBasic503ServerMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h11.57a7.845 7.845 0 0 0 1.695 6H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 5v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h15.636A7.946 7.946 0 0 0 26 14h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4 7v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $1bfd77fc7716011d$export$2e2bcd8739ae039 = $1bfd77fc7716011d$var$SvgGlyphiconsBasic503ServerMinus;




const $b9ae5e95575485d4$var$SvgGlyphiconsBasic504ServerNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h11.57a7.845 7.845 0 0 0 1.695 6H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 13v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4-9v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h15.636A7.946 7.946 0 0 0 26 14h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5ZM26 0a6 6 0 1 1-6 6 6 6 0 0 1 6-6Zm0 10a4.005 4.005 0 0 0 4-4 3.955 3.955 0 0 0-.567-2.02l-5.452 5.453A3.955 3.955 0 0 0 26 10Zm-3.433-1.98 5.452-5.453A3.955 3.955 0 0 0 26 2a4.005 4.005 0 0 0-4 4 3.955 3.955 0 0 0 .567 2.02Z"
        })
    });
var $b9ae5e95575485d4$export$2e2bcd8739ae039 = $b9ae5e95575485d4$var$SvgGlyphiconsBasic504ServerNo;




const $139c26b6857fa8b3$var$SvgGlyphiconsBasic505ServerCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h11.57a7.845 7.845 0 0 0 1.695 6H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 5v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h15.636A7.947 7.947 0 0 0 26 14h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4 7v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-2.852-2.234-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.096l-.433.554a.297.297 0 0 0 .027.377l2.233 2.236a.83.83 0 0 0 1.298-.1L29.2 4.118a.254.254 0 0 0-.052-.352Z"
        })
    });
var $139c26b6857fa8b3$export$2e2bcd8739ae039 = $139c26b6857fa8b3$var$SvgGlyphiconsBasic505ServerCheck;




const $da07b94025bf62f5$var$SvgGlyphiconsBasic506ServerLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5H19v6H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 5v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h13.28A2.982 2.982 0 0 0 22 14h5.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4 7v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $da07b94025bf62f5$export$2e2bcd8739ae039 = $da07b94025bf62f5$var$SvgGlyphiconsBasic506ServerLock;




const $70eca28c1953da7e$var$SvgGlyphiconsBasic507ServerRefresh = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h10.511l-.276 1.146a5.273 5.273 0 0 0-.065 1.4L17.36 11H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 13v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4-9v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h14.665a7.956 7.956 0 0 0 3.827.999L26 14h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm6.663-14.186a.445.445 0 0 0-.75-.227l-.687.686c-.084-.085-.155-.18-.245-.26a6.002 6.002 0 0 0-9.815 3.08l1.982.397a3.945 3.945 0 0 1 3.614-2.981c.081-.005.163-.007.243-.007a3.966 3.966 0 0 1 2.649 1.008c.06.053.102.12.158.178l-.725.725a.445.445 0 0 0 .227.75l3.532.706a.444.444 0 0 0 .523-.523Zm-2.673 7.34a3.998 3.998 0 0 1-5.644.337s-.111-.131-.158-.179l.725-.725a.445.445 0 0 0-.227-.75l-3.532-.706a.444.444 0 0 0-.523.523l.706 3.532a.445.445 0 0 0 .75.227l.687-.686c.084.085.155.18.245.26a5.951 5.951 0 0 0 3.973 1.512c.121 0 .243-.004.365-.012a6.006 6.006 0 0 0 5.477-4.58l-1.982-.397a3.965 3.965 0 0 1-.862 1.644Z"
        })
    });
var $70eca28c1953da7e$export$2e2bcd8739ae039 = $70eca28c1953da7e$var$SvgGlyphiconsBasic507ServerRefresh;




const $729c8b7f6144c0b3$var$SvgGlyphiconsBasic508ServerFlag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5H22v2h-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h.5v2H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 13v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4-9v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h16.012a2.489 2.489 0 0 0 1.988 1h3a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5ZM30 0h-5a1 1 0 0 0-1 1v10.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7.417l4.526-1.259A.74.74 0 0 0 31 5.5V1a1 1 0 0 0-1-1Z"
        })
    });
var $729c8b7f6144c0b3$export$2e2bcd8739ae039 = $729c8b7f6144c0b3$var$SvgGlyphiconsBasic508ServerFlag;




const $71c5e4890641645f$var$SvgGlyphiconsBasic509ServerCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 9.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h12.075a7.338 7.338 0 0 0 1.85 6H6.5a.5.5 0 0 1-.5-.5V10H4.5a.5.5 0 0 1-.5-.5Zm24 5v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V18H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h16.83a7.448 7.448 0 0 0 2.67.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm4 7v3a.5.5 0 0 1-.5.5H26v.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5V26H4.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H6v-.5a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v.5h1.5a.5.5 0 0 1 .5.5Zm-4 1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm7.706-17.146a.497.497 0 0 1-.379.47l-1.156.29a4.523 4.523 0 0 1-.43 1.04l.617 1.028a.504.504 0 0 1-.046.586 5.865 5.865 0 0 1-.539.542.497.497 0 0 1-.582.043l-1.03-.62a4.417 4.417 0 0 1-1.042.432l-.29 1.156a.498.498 0 0 1-.471.38 15.89 15.89 0 0 1-.716 0 .497.497 0 0 1-.47-.38l-.29-1.156a4.404 4.404 0 0 1-1.04-.43l-1.03.617a.504.504 0 0 1-.586-.047 5.817 5.817 0 0 1-.541-.54.497.497 0 0 1-.043-.58l.619-1.032a4.347 4.347 0 0 1-.429-1.04l-1.157-.29a.498.498 0 0 1-.38-.471 15.979 15.979 0 0 1 .001-.716.497.497 0 0 1 .379-.47l1.157-.289a4.361 4.361 0 0 1 .43-1.041l-.618-1.03a.504.504 0 0 1 .047-.587 5.806 5.806 0 0 1 .54-.54.497.497 0 0 1 .58-.042l1.032.618a4.348 4.348 0 0 1 1.04-.429l.29-1.157a.498.498 0 0 1 .471-.38c.225-.005.494-.004.716.001a.497.497 0 0 1 .47.379l.29 1.157a4.324 4.324 0 0 1 1.04.429l1.028-.617a.504.504 0 0 1 .586.046 5.852 5.852 0 0 1 .542.539.497.497 0 0 1 .043.582l-.619 1.03a4.414 4.414 0 0 1 .43 1.042l1.157.29a.498.498 0 0 1 .38.471c.005.225.004.494-.001.716Zm-3.558-.36A2.147 2.147 0 1 0 26 8.143a2.15 2.15 0 0 0 2.148-2.149Z"
        })
    });
var $71c5e4890641645f$export$2e2bcd8739ae039 = $71c5e4890641645f$var$SvgGlyphiconsBasic509ServerCogwheel;




const $f52b1b234b3d212d$var$SvgGlyphiconsBasic51Pulse = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 19v1a1 1 0 0 1-1 1h-4.5a1.5 1.5 0 0 1-1.477-1.236l-1.07-5.997-2.48 13.014a1.5 1.5 0 0 1-1.406 1.218A1.527 1.527 0 0 1 16 28a1.5 1.5 0 0 1-1.441-1.088L12 17.96l-.558 1.952A1.5 1.5 0 0 1 10 21H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h3.868l1.69-5.912a1.5 1.5 0 0 1 2.884 0l2.266 7.93 2.818-14.799a1.5 1.5 0 0 1 2.95.017L23.757 18H27a1 1 0 0 1 1 1Z"
        })
    });
var $f52b1b234b3d212d$export$2e2bcd8739ae039 = $f52b1b234b3d212d$var$SvgGlyphiconsBasic51Pulse;




const $55b8cd4cab4427fb$var$SvgGlyphiconsBasic510LightBeacon = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 25v3H7v-3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1ZM16 8.5a1 1 0 0 0 1-1V5a1 1 0 0 0-2 0v2.5a1 1 0 0 0 1 1Zm6.108 1.392a.997.997 0 0 0 .707-.293l1.774-1.774a1 1 0 1 0-1.414-1.414L21.4 8.185a1 1 0 0 0 .707 1.707ZM9.185 9.599a1 1 0 0 0 1.414-1.414L8.825 6.41a1 1 0 0 0-1.414 1.414ZM26.902 14h-2.534a1 1 0 0 0 0 2h2.534a1 1 0 0 0 0-2Zm-18.27 1a1 1 0 0 0-1-1H5.098a1 1 0 0 0 0 2h2.534a1 1 0 0 0 1-1Zm1.95-2.493A3 3 0 0 1 13.542 10h4.917a3 3 0 0 1 2.959 2.507L23 22H9Zm1.33 4.186a1 1 0 0 0 .821 1.152.968.968 0 0 0 .166.013 1 1 0 0 0 .986-.835l.433-2.597a1 1 0 0 0-1.972-.33Z"
        })
    });
var $55b8cd4cab4427fb$export$2e2bcd8739ae039 = $55b8cd4cab4427fb$var$SvgGlyphiconsBasic510LightBeacon;




const $4a228e50a67924fd$var$SvgGlyphiconsBasic511Bed = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 17v10.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V25H7v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V17a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2ZM8 11a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2h2v-2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2h2V9a4 4 0 0 0-4-4H10a4 4 0 0 0-4 4v4h2Z"
        })
    });
var $4a228e50a67924fd$export$2e2bcd8739ae039 = $4a228e50a67924fd$var$SvgGlyphiconsBasic511Bed;




const $88c56a31b97568e0$var$SvgGlyphiconsBasic512BedSingle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 17v10.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V25H9v2.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V17a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2Zm-15-6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h3V9a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v4h3Z"
        })
    });
var $88c56a31b97568e0$export$2e2bcd8739ae039 = $88c56a31b97568e0$var$SvgGlyphiconsBasic512BedSingle;




const $e24f670bb7feb9f6$var$SvgGlyphiconsBasic513Cot = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 7h-2a.5.5 0 0 0-.5.5V10H9V7.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v19a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V23h14v3.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-19a.5.5 0 0 0-.5-.5ZM11 17H9v-5h2Zm4 0h-2v-5h2Zm4 0h-2v-5h2Zm4 0h-2v-5h2Z"
        })
    });
var $e24f670bb7feb9f6$export$2e2bcd8739ae039 = $e24f670bb7feb9f6$var$SvgGlyphiconsBasic513Cot;




const $01a2c54721c2f732$var$SvgGlyphiconsBasic514PersonalHygiene = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 6v4.885a6.504 6.504 0 0 1-.194 1.576l-2.71 9.84a3.452 3.452 0 0 0-.096.814V27a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3.885a6.504 6.504 0 0 1 .194-1.576l2.71-9.84a3.425 3.425 0 0 0 .09-.699H21a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3a2 2 0 0 1 2 2ZM9.905 27.621a.5.5 0 0 0 .485.379h2.22a.5.5 0 0 0 .485-.379L13.75 25h-4.5ZM16 4H7a1 1 0 0 0-1 1v2l.958 13.405a3 3 0 0 0 .309 1.128L8 23h7l.733-1.467a3 3 0 0 0 .31-1.128L17 7V5a1 1 0 0 0-1-1Z"
        })
    });
var $01a2c54721c2f732$export$2e2bcd8739ae039 = $01a2c54721c2f732$var$SvgGlyphiconsBasic514PersonalHygiene;




const $5674f464f941388b$var$SvgGlyphiconsBasic515Hairdresser = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 6v20a2 2 0 0 1-4 0v-6.291l-4.07-.593A1.062 1.062 0 0 1 20.062 17H24v-2h-4a1 1 0 0 1 0-2h4v-2h-4a1 1 0 0 1 0-2h4V7h-3.938a1.062 1.062 0 0 1-.132-2.116L26 4a2 2 0 0 1 2 2Zm-8.95 15.605.572 4.262a1 1 0 0 1-.795 1.114l-4.202.838a2 2 0 0 1-2.376-1.716l-.369-2.983-.158-1.28-.68-.367-.689.372-.158 1.28-.369 2.984a2 2 0 0 1-2.376 1.716l-4.202-.84a1 1 0 0 1-.795-1.113l.572-4.262a1 1 0 0 1 .62-.795l4.438-1.774L9.89 4.874A1 1 0 0 1 10.88 4h.243a1 1 0 0 1 .991.869l1.877 14.166 4.438 1.775a1 1 0 0 1 .62.795ZM7.627 22.727a.5.5 0 0 0-.667-.532l-1.685.613a.5.5 0 0 0-.325.408l-.166 1.343a.5.5 0 0 0 .436.558l1.585.193a.5.5 0 0 0 .557-.435Zm4.194-5.996a1.5 1.5 0 1 0 .452 2.073 1.502 1.502 0 0 0-.452-2.073Zm5.47 7.823-.166-1.342a.5.5 0 0 0-.325-.409l-1.685-.613a.5.5 0 0 0-.667.531l.265 2.15a.5.5 0 0 0 .557.434l1.586-.193a.5.5 0 0 0 .435-.558Z"
        })
    });
var $5674f464f941388b$export$2e2bcd8739ae039 = $5674f464f941388b$var$SvgGlyphiconsBasic515Hairdresser;




const $1ce6460eaebb58df$var$SvgGlyphiconsBasic516BedSleeping = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 13a2 2 0 1 1 2 2 2 2 0 0 1-2-2Zm21 .67a2 2 0 0 0-1.644-1.967l-8.773-1.586A5.998 5.998 0 0 0 16.406 10H15a3 3 0 0 0-3 3v2h16ZM29.5 17H6V7.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v19a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V23h21v3.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Z"
        })
    });
var $1ce6460eaebb58df$export$2e2bcd8739ae039 = $1ce6460eaebb58df$var$SvgGlyphiconsBasic516BedSleeping;




const $d86c977388f85623$var$SvgGlyphiconsBasic517FoodService = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.512 17H5.088C5.663 13.32 9.317 9.873 14 9.15V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2.208c4.492.852 7.954 4.215 8.512 7.792ZM3 19v1a1 1 0 0 0 1 1h1l2.4 3.2A2 2 0 0 0 9 25h14a2 2 0 0 0 1.6-.8L27 21h1a1 1 0 0 0 1-1v-1Z"
        })
    });
var $d86c977388f85623$export$2e2bcd8739ae039 = $d86c977388f85623$var$SvgGlyphiconsBasic517FoodService;




const $f91ea2c8681b09d4$var$SvgGlyphiconsBasic518LampTable = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 26v2H12v-2a1 1 0 0 1 1-1h2.024l-8.136-8.993a1.5 1.5 0 0 1 .051-2.068l4.818-4.817 1.815 1.814.138.475-3.64 3.64 8.542 9.442a1.498 1.498 0 0 1 .302.507H22a1 1 0 0 1 1 1Zm1.052-18.15-5.167-1.5-2.506-2.507a1 1 0 0 0-1.415 0l-2.12 2.121a1 1 0 0 0 0 1.415l2.506 2.506 1.5 5.167a.5.5 0 0 0 .834.214l6.582-6.582a.5.5 0 0 0-.214-.834Z"
        })
    });
var $f91ea2c8681b09d4$export$2e2bcd8739ae039 = $f91ea2c8681b09d4$var$SvgGlyphiconsBasic518LampTable;




const $7ff8c41522d40133$var$SvgGlyphiconsBasic519Lamp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 26v2h-9v-2a1 1 0 0 1 1-1h2V15h3v10h2a1 1 0 0 1 1 1Zm2.208-14.406-3.11-7A1 1 0 0 0 19.182 4h-5.366a1 1 0 0 0-.914.594l-3.111 7A1 1 0 0 0 10.705 13h11.59a1 1 0 0 0 .913-1.406Z"
        })
    });
var $7ff8c41522d40133$export$2e2bcd8739ae039 = $7ff8c41522d40133$var$SvgGlyphiconsBasic519Lamp;




const $cbca32a1dc9c558c$var$SvgGlyphiconsBasic52Eye = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.308 14.368C28.255 12.002 22.75 6.5 16 6.5S3.745 12.002 1.693 14.366a2.5 2.5 0 0 0 0 3.266C3.744 19.998 9.248 25.5 16 25.5s12.255-5.502 14.308-7.868a2.499 2.499 0 0 0 0-3.264ZM9.24 20.26A25.34 25.34 0 0 1 4.254 16a25.336 25.336 0 0 1 4.986-4.26 7.934 7.934 0 0 0 0 8.52ZM16 22a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6Zm6.76-1.74a7.934 7.934 0 0 0 0-8.52A25.34 25.34 0 0 1 27.746 16a25.336 25.336 0 0 1-4.986 4.26ZM19 16a3 3 0 1 1-5.806-1.032 1.5 1.5 0 0 0 1.774-1.774A2.976 2.976 0 0 1 19 16Z"
        })
    });
var $cbca32a1dc9c558c$export$2e2bcd8739ae039 = $cbca32a1dc9c558c$var$SvgGlyphiconsBasic52Eye;




const $6e1bcc86dd2377e1$var$SvgGlyphiconsBasic520Hourglass = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 10.559V8c.552 0 1-.597 1-1.333V5.333C24 4.597 23.552 4 23 4H9c-.552 0-1 .597-1 1.333v1.334C8 7.403 8.448 8 9 8v2.559a3.98 3.98 0 0 0 1.501 3.123L13.398 16l-2.897 2.318A3.98 3.98 0 0 0 9 21.441V24c-.552 0-1 .597-1 1.333v1.334C8 27.403 8.448 28 9 28h14c.552 0 1-.597 1-1.333v-1.334c0-.736-.448-1.333-1-1.333v-2.559a3.98 3.98 0 0 0-1.501-3.123L18.602 16l2.897-2.318A3.98 3.98 0 0 0 23 10.559Zm-2 0a1.986 1.986 0 0 1-.751 1.56l-2.896 2.319a2 2 0 0 0-.001 3.124l2.897 2.319A1.986 1.986 0 0 1 21 21.44V24h-1.788l-2.806-3.901a.5.5 0 0 0-.812 0L12.788 24H11v-2.559a1.986 1.986 0 0 1 .751-1.56l2.896-2.318a2 2 0 0 0 .001-3.125l-2.897-2.319A1.986 1.986 0 0 1 11 10.56V8h10Zm-7.567-.131A.25.25 0 0 1 13.61 10h4.782a.25.25 0 0 1 .175.428l-2.216 2.186a.5.5 0 0 1-.702 0Z"
        })
    });
var $6e1bcc86dd2377e1$export$2e2bcd8739ae039 = $6e1bcc86dd2377e1$var$SvgGlyphiconsBasic520Hourglass;




const $6340a5ca2e18f641$var$SvgGlyphiconsBasic521Monitor = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 7h-19A1.5 1.5 0 0 0 5 8.5v13A1.5 1.5 0 0 0 6.5 23h19a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 25.5 7ZM24 20H8V10h16Zm-4 6v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
        })
    });
var $6340a5ca2e18f641$export$2e2bcd8739ae039 = $6340a5ca2e18f641$var$SvgGlyphiconsBasic521Monitor;




const $ecedfd37b0822888$var$SvgGlyphiconsBasic522Monitors = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.5 11h-17A1.5 1.5 0 0 0 3 12.5v12A1.5 1.5 0 0 0 4.5 26H10v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h5.5a1.5 1.5 0 0 0 1.5-1.5v-12a1.5 1.5 0 0 0-1.5-1.5ZM20 23H6v-9h14Zm9-17.5v12a1.5 1.5 0 0 1-1.5 1.5H25v-3h1V7H12v2H9V5.5A1.5 1.5 0 0 1 10.5 4h17A1.5 1.5 0 0 1 29 5.5Z"
        })
    });
var $ecedfd37b0822888$export$2e2bcd8739ae039 = $ecedfd37b0822888$var$SvgGlyphiconsBasic522Monitors;




const $81fea2bc047aff72$var$SvgGlyphiconsBasic523MonitorRotate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 8h-15A1.5 1.5 0 0 0 7 9.5v11A1.5 1.5 0 0 0 8.5 22H13v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1h4.5a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 23.5 8ZM22 19H10v-8h12Zm9.628-10.196-2.23 2.919a.475.475 0 0 1-.795 0l-2.231-2.92c-.338-.441-.16-.803.397-.803H28V7a1 1 0 0 0-1-1h-2V4h2a3.003 3.003 0 0 1 3 3v1h1.231c.556 0 .735.362.397.804ZM5 24h2v2H5a3.003 3.003 0 0 1-3-3v-1H.769c-.556 0-.735-.362-.397-.804l2.23-2.919a.475.475 0 0 1 .795 0l2.231 2.92c.338.441.16.803-.397.803H4v1a1 1 0 0 0 1 1Z"
        })
    });
var $81fea2bc047aff72$export$2e2bcd8739ae039 = $81fea2bc047aff72$var$SvgGlyphiconsBasic523MonitorRotate;




const $80769cb2b0a22e67$var$SvgGlyphiconsBasic524MonitorVertical = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.5 3h-13A1.5 1.5 0 0 0 8 4.5v17A1.5 1.5 0 0 0 9.5 23h13a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 22.5 3ZM21 20H11V6h10Zm-1 6v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
        })
    });
var $80769cb2b0a22e67$export$2e2bcd8739ae039 = $80769cb2b0a22e67$var$SvgGlyphiconsBasic524MonitorVertical;




const $f36ccfb2e28d7dce$var$SvgGlyphiconsBasic525PhoneToHorizontal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16.5 4h-11A2.502 2.502 0 0 0 3 6.5v19A2.502 2.502 0 0 0 5.5 28h11a2.502 2.502 0 0 0 2.5-2.5v-19A2.502 2.502 0 0 0 16.5 4ZM12 25.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm4-3.5H6V7h10Zm15-6.5v10a2.502 2.502 0 0 1-2.5 2.5H21v-3h7v-9h-7v-3h7.5a2.502 2.502 0 0 1 2.5 2.5ZM24 5h-2V3h2a3.003 3.003 0 0 1 3 3v1h1.231c.556 0 .735.362.397.804l-2.23 2.919a.475.475 0 0 1-.795 0l-2.231-2.92c-.338-.441-.16-.803.397-.803H25V6a1 1 0 0 0-1-1Z"
        })
    });
var $f36ccfb2e28d7dce$export$2e2bcd8739ae039 = $f36ccfb2e28d7dce$var$SvgGlyphiconsBasic525PhoneToHorizontal;




const $80e8f0c9c3849dc0$var$SvgGlyphiconsBasic526PhoneRotate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.628 8.804-2.23 2.919a.475.475 0 0 1-.795 0l-2.231-2.92c-.338-.441-.16-.803.397-.803H27V7a1 1 0 0 0-1-1h-2V4h2a3.003 3.003 0 0 1 3 3v1h1.231c.556 0 .735.362.397.804ZM5 25v-1h1.231c.556 0 .735-.362.397-.804l-2.23-2.919a.475.475 0 0 0-.795 0l-2.231 2.92c-.338.441-.16.803.397.803H3v1a3.003 3.003 0 0 0 3 3h2v-2H6a1 1 0 0 1-1-1ZM23 8.5v15a2.502 2.502 0 0 1-2.5 2.5h-9A2.502 2.502 0 0 1 9 23.5v-15A2.502 2.502 0 0 1 11.5 6h9A2.502 2.502 0 0 1 23 8.5Zm-6 14a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5ZM20 9h-8v11h8Z"
        })
    });
var $80e8f0c9c3849dc0$export$2e2bcd8739ae039 = $80e8f0c9c3849dc0$var$SvgGlyphiconsBasic526PhoneRotate;




const $0222ba720c2d1531$var$SvgGlyphiconsBasic527PhoneHorizontal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 8h-19A2.502 2.502 0 0 0 4 10.5v11A2.502 2.502 0 0 0 6.5 24h19a2.502 2.502 0 0 0 2.5-2.5v-11A2.502 2.502 0 0 0 25.5 8ZM22 21H7V11h15Zm4-4.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $0222ba720c2d1531$export$2e2bcd8739ae039 = $0222ba720c2d1531$var$SvgGlyphiconsBasic527PhoneHorizontal;




const $5198fc3375e100d7$var$SvgGlyphiconsBasic528Shower = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.5 7h-5A1.502 1.502 0 0 0 7 8.5V28H4V8.5A4.505 4.505 0 0 1 8.5 4h5A4.505 4.505 0 0 1 18 8.5V9l3.707 3.707a1 1 0 0 1 .293.707V14a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-.586a1 1 0 0 1 .293-.707L15 9v-.5A1.502 1.502 0 0 0 13.5 7Zm.5 15a1 1 0 0 0-2 0v1a1 1 0 0 0 2 0Zm4 0a1 1 0 0 0-2 0v1a1 1 0 0 0 2 0Zm4 0a1 1 0 0 0-2 0v1a1 1 0 0 0 2 0Zm-8-4v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-2 0Zm4 0v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-2 0Zm-7 7a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1Zm4 0a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1Zm4 0a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1Zm4 0a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0-1-1Z"
        })
    });
var $5198fc3375e100d7$export$2e2bcd8739ae039 = $5198fc3375e100d7$var$SvgGlyphiconsBasic528Shower;




const $5d817314f41d52d4$var$SvgGlyphiconsBasic529ShowerAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m18.536 8.172-6.364 6.364a1 1 0 0 1-1.415 0l-.414-.415a1 1 0 0 1-.293-.707V8.172L9.025 7.146A.506.506 0 0 0 8.672 7H7.5a.501.501 0 0 0-.5.5V28H4V7.5A3.504 3.504 0 0 1 7.5 4h1.172a3.477 3.477 0 0 1 2.474 1.025l1.026 1.025h5.242a1 1 0 0 1 .707.293l.415.414a1 1 0 0 1 0 1.415Zm-.829 8.535a1 1 0 0 0 0-1.414l-1-1a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0Zm.586-4 1 1a1 1 0 0 0 1.414-1.414l-1-1a1 1 0 0 0-1.414 1.414Zm2 3.586a1 1 0 0 0 0 1.414l1 1a1 1 0 0 0 1.414-1.414l-1-1a1 1 0 0 0-1.414 0Zm4-.586a1 1 0 0 0 1.414-1.414l-1-1a1 1 0 0 0-1.414 1.414Zm-.586 5.586a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414-1.414Zm3-3a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414-1.414Zm4-2-1-1a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414-1.414Zm-10 8a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414-1.414Zm-1-2.586a1 1 0 0 0 0-1.414l-1-1a1 1 0 0 0-1.414 1.414l1 1a1 1 0 0 0 1.414 0Z"
        })
    });
var $5d817314f41d52d4$export$2e2bcd8739ae039 = $5d817314f41d52d4$var$SvgGlyphiconsBasic529ShowerAlt;




const $c789d1a16e70a25c$var$SvgGlyphiconsBasic53EyeOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.308 17.632C28.255 19.998 22.75 25.5 16 25.5a13.762 13.762 0 0 1-4.675-.858l2.908-2.908a6 6 0 0 0 7.5-7.5l1.542-1.542a7.924 7.924 0 0 1-.515 7.568A25.336 25.336 0 0 0 27.746 16a26.048 26.048 0 0 0-4.11-3.669l2.16-2.16a29.016 29.016 0 0 1 4.512 4.197 2.499 2.499 0 0 1 0 3.264ZM27.215 5.061 5.06 27.214a1.5 1.5 0 0 1-2.122-2.12l3.27-3.27a28.951 28.951 0 0 1-4.517-4.192 2.5 2.5 0 0 1 .001-3.266C3.745 12.002 9.25 6.5 16 6.5a13.716 13.716 0 0 1 4.675.858l4.419-4.419a1.5 1.5 0 0 1 2.12 2.122ZM8 16a7.942 7.942 0 0 1 1.24-4.26A25.336 25.336 0 0 0 4.254 16a26.048 26.048 0 0 0 4.11 3.669l.36-.361A7.905 7.905 0 0 1 8 16Zm9.764-5.731A5.936 5.936 0 0 0 16 10a6.007 6.007 0 0 0-6 6 5.936 5.936 0 0 0 .269 1.764Z"
        })
    });
var $c789d1a16e70a25c$export$2e2bcd8739ae039 = $c789d1a16e70a25c$var$SvgGlyphiconsBasic53EyeOff;




const $b680ab6f45562492$var$SvgGlyphiconsBasic530Bath = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 17v1a1 1 0 0 1-1 1 7.985 7.985 0 0 1-2.975 6.217l.912 2.431a1 1 0 0 1-1.873.704l-.776-2.067A7.941 7.941 0 0 1 20 27h-8a7.941 7.941 0 0 1-3.288-.715l-.775 2.067a1 1 0 0 1-1.873-.704l.911-2.431A7.985 7.985 0 0 1 4 19a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h24a1 1 0 0 1 1 1ZM6 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1L8.293 7.707A1 1 0 0 0 8 8.414V9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-.586a1 1 0 0 0-.293-.707L12 6a3.003 3.003 0 0 0-3-3H7a3.003 3.003 0 0 0-3 3v8h2Z"
        })
    });
var $b680ab6f45562492$export$2e2bcd8739ae039 = $b680ab6f45562492$var$SvgGlyphiconsBasic530Bath;




const $040ebdcb42efabf5$var$SvgGlyphiconsBasic531UserParentsAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.935 20.85c.2.09.42.173.636.256a2.988 2.988 0 0 1-2.123.894H9.552a3 3 0 0 1-2.93-2.36l-.666-3.052a2.992 2.992 0 0 1-1.311-1.462l-.28-.752A1.275 1.275 0 0 1 5 12.63V10c0-3 2-5 5.5-5a6.113 6.113 0 0 1 3.546.99 7.83 7.83 0 0 0-1.144 2.525 22.268 22.268 0 0 0-.562 4.07 11.044 11.044 0 0 1-.88 4.278 2.984 2.984 0 0 0-.088 2.31 2.952 2.952 0 0 0 1.563 1.677Zm-.227 2.978a4.89 4.89 0 0 1-1.26.172H9.552a5.014 5.014 0 0 1-3.776-1.742c-1.15.947-2.574 2.12-2.946 2.42A1.86 1.86 0 0 0 2 26.237V27.5a.5.5 0 0 0 .5.5h9.393a2.504 2.504 0 0 1-.05-.5v-1.264a4.075 4.075 0 0 1 .865-2.408Zm12.785-1.806A4.883 4.883 0 0 1 21.686 24H21a4.885 4.885 0 0 1-3.811-1.983l-2.517 2.661a2.107 2.107 0 0 0-.83 1.559V27.5a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-1.263a2.157 2.157 0 0 0-.829-1.559 216.077 216.077 0 0 1-2.52-2.656Zm3.606-4.318C26.365 13.755 29.413 6 23.843 6c-3-3-8-1-9 3-.836 3.342-.136 5.608-1.569 8.705a.993.993 0 0 0 .478 1.32 16.228 16.228 0 0 0 4.712 1.192A2.893 2.893 0 0 0 21 22h.686a2.894 2.894 0 0 0 2.534-1.779 16.824 16.824 0 0 0 4.398-1.06.992.992 0 0 0 .481-1.457Z"
        })
    });
var $040ebdcb42efabf5$export$2e2bcd8739ae039 = $040ebdcb42efabf5$var$SvgGlyphiconsBasic531UserParentsAlt;




const $ea4ae1e9c149d918$var$SvgGlyphiconsBasic532UserFamily = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.503 20.715A646.778 646.778 0 0 1 6.723 23H6.48a3.03 3.03 0 0 1-2.663-1.887l-.475-1.352a3.225 3.225 0 0 1-1.7-1.511 1.154 1.154 0 0 1 .202-1.428V14a4.591 4.591 0 0 1 3.245-4.66.958.958 0 0 1 .098-.085 2.062 2.062 0 0 0 .64-1.362 1 1 0 0 1 1.361-.789 4.592 4.592 0 0 1 1.132.664A7.688 7.688 0 0 0 8 10v1.67a3.353 3.353 0 0 0-.51 3.4l.28.754a4.716 4.716 0 0 0 1.395 1.94l.502 2.302c.031.143.068.284.111.421Zm-4.218 4.108a5.334 5.334 0 0 1-2.35-1.413c-.491.567-.99 1.137-1.203 1.369a2.376 2.376 0 0 0-.89 1.835V27a1 1 0 0 0 1 1h3.209A2.504 2.504 0 0 1 5 27.5v-1.264a3.75 3.75 0 0 1 .285-1.413Zm4.36-9.697a2.992 2.992 0 0 0 1.31 1.462l.666 3.051A3 3 0 0 0 14.552 22h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a2.991 2.991 0 0 0 1.311-1.462l.28-.752A1.275 1.275 0 0 0 21 12.63V10c0-3-2-5-5.5-5S10 7 10 10v2.63a1.275 1.275 0 0 0-.635 1.744Zm21.454 2.578C28.365 13.755 31.413 6 25.843 6a4.88 4.88 0 0 0-5.046-1.184A6.717 6.717 0 0 1 23 10v1.67a3.354 3.354 0 0 1 .509 3.402l-.279.75a4.72 4.72 0 0 1-1.395 1.942l-.502 2.302a5.24 5.24 0 0 1-.114.43l.278.232c.584.485 1.102.913 1.539 1.272h.65a2.893 2.893 0 0 0 2.536-1.784 16.843 16.843 0 0 0 4.396-1.055.992.992 0 0 0 .481-1.457Zm-3.606 4.318a5.03 5.03 0 0 1-2.393 1.731 3.495 3.495 0 0 1 .9 2.483V27.5a2.504 2.504 0 0 1-.05.5h4.393a.5.5 0 0 0 .5-.5v-1.263a2.157 2.157 0 0 0-.83-1.559 216.077 216.077 0 0 1-2.52-2.656Zm-4.323 2.656c-.435-.33-1.828-1.48-2.951-2.412A5.015 5.015 0 0 1 16.448 24h-1.896a5.014 5.014 0 0 1-3.776-1.742c-1.15.947-2.574 2.12-2.946 2.42A1.86 1.86 0 0 0 7 26.237V27.5a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-1.263a1.658 1.658 0 0 0-.83-1.559Z"
        })
    });
var $ea4ae1e9c149d918$export$2e2bcd8739ae039 = $ea4ae1e9c149d918$var$SvgGlyphiconsBasic532UserFamily;




const $950a2ef653e0d438$var$SvgGlyphiconsBasic533UserChild = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 25.358V27a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1.642a2 2 0 0 1 .956-1.706l2.76-1.69A4.952 4.952 0 0 0 13.636 23h3.728a4.952 4.952 0 0 0 2.92-1.037l2.76 1.689A2 2 0 0 1 24 25.358Zm-14.917-8.21a3.258 3.258 0 0 0 2.168 1.77l.097.235A3.25 3.25 0 0 0 14.116 21h2.768a3.25 3.25 0 0 0 2.768-1.847l.097-.235a3.258 3.258 0 0 0 2.168-1.77l.326-.797A1.282 1.282 0 0 0 22 14.832V12.5a7.12 7.12 0 0 0-3.966-5.883c-.01-.025-.005-.052-.016-.076a5.479 5.479 0 0 0-2.659-2.507 1 1 0 0 0-1.37.881 3.32 3.32 0 0 1-1.088 1.737A7.113 7.113 0 0 0 9 12.5v2.332a1.282 1.282 0 0 0-.243 1.52Z"
        })
    });
var $950a2ef653e0d438$export$2e2bcd8739ae039 = $950a2ef653e0d438$var$SvgGlyphiconsBasic533UserChild;




const $751104a66e091028$var$SvgGlyphiconsBasic534UserBoy = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 25.237V27a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1.763a1.805 1.805 0 0 1 .889-1.458l4.332-2.232A5.062 5.062 0 0 0 14.636 23h1.728a5.062 5.062 0 0 0 3.415-1.453l4.332 2.232A1.805 1.805 0 0 1 25 25.237ZM9.927 16.115a3.005 3.005 0 0 0 1.56 1.615l.486 1.383A3.03 3.03 0 0 0 14.636 21h1.728a3.03 3.03 0 0 0 2.663-1.887l.486-1.383a3.005 3.005 0 0 0 1.56-1.615l.259-.73A1.352 1.352 0 0 0 21 13.822V11a5.522 5.522 0 0 0-.364-2.036l.259-.517a1 1 0 0 0-.699-1.427l-.452-.09.204-.614a1 1 0 0 0-1.19-1.286s-4.042 1.022-4.065 1.03C11.705 6.352 10 8.244 10 11v2.822a1.352 1.352 0 0 0-.332 1.563Z"
        })
    });
var $751104a66e091028$export$2e2bcd8739ae039 = $751104a66e091028$var$SvgGlyphiconsBasic534UserBoy;




const $7f51458572017e23$var$SvgGlyphiconsBasic535UserGirl = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 25.237V27a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1.763a1.805 1.805 0 0 1 .889-1.458l4.332-2.232A5.062 5.062 0 0 0 14.636 23h1.728a5.062 5.062 0 0 0 3.415-1.453l4.332 2.232A1.805 1.805 0 0 1 25 25.237Zm.38-7.444-2.084-.694a1 1 0 0 1-.483-.349L21.8 15.4A4 4 0 0 1 21 13v-2c0-3-2-5-5.5-5S10 8 10 11v2a4 4 0 0 1-.8 2.4l-1.012 1.35a1.001 1.001 0 0 1-.484.349l-2.083.694a.475.475 0 0 0-.258.751l1.221 1.832a.465.465 0 0 0 .832 0l1.287-1.93A1 1 0 0 1 9.535 18h1.971l.425 1.128A3.116 3.116 0 0 0 14.636 21h1.728a3.116 3.116 0 0 0 2.705-1.872L19.494 18h1.97a1 1 0 0 1 .833.445l1.287 1.931a.465.465 0 0 0 .832 0l1.22-1.832a.475.475 0 0 0-.257-.751Z"
        })
    });
var $7f51458572017e23$export$2e2bcd8739ae039 = $7f51458572017e23$var$SvgGlyphiconsBasic535UserGirl;




const $8f1959bc963b234f$var$SvgGlyphiconsBasic536Speakers = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 20a2 2 0 1 1-2-2 2 2 0 0 1 2 2Zm-2-9a1 1 0 1 0-1-1 1 1 0 0 0 1 1Zm7-5v20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1ZM8 10a3 3 0 1 0 3-3 3 3 0 0 0-3 3Zm8 10a5 5 0 1 0-5 5 5 5 0 0 0 5-5ZM27 5h-7.184A2.965 2.965 0 0 1 20 6v1.184a3 3 0 1 1 0 5.632v2.285a5 5 0 1 1 0 9.798V26a2.965 2.965 0 0 1-.184 1H27a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-5 5a1 1 0 1 0-1 1 1 1 0 0 0 1-1Zm1 10a2 2 0 0 0-2-2 1.98 1.98 0 0 0-1 .277v3.446A1.98 1.98 0 0 0 21 22a2 2 0 0 0 2-2Z"
        })
    });
var $8f1959bc963b234f$export$2e2bcd8739ae039 = $8f1959bc963b234f$var$SvgGlyphiconsBasic536Speakers;




const $597ea9ef733b2d6d$var$SvgGlyphiconsBasic537Progress = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 5H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-1 4h-7V7h7Zm1 4H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4H15v-2h11Zm1 4H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4h-3v-2h3Z"
        })
    });
var $597ea9ef733b2d6d$export$2e2bcd8739ae039 = $597ea9ef733b2d6d$var$SvgGlyphiconsBasic537Progress;




const $068caeaba262e045$var$SvgGlyphiconsBasic538Tasks = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 5H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-1 4h-7V7h7Zm1 4H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4h-9v-2h9Zm1 4H13a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4h-4v-2h4ZM9 5H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM8 9H6V7h2Zm1 4H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4H6v-2h2Zm1 4H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4H6v-2h2Z"
        })
    });
var $068caeaba262e045$export$2e2bcd8739ae039 = $068caeaba262e045$var$SvgGlyphiconsBasic538Tasks;




const $a44983cd1155f044$var$SvgGlyphiconsBasic539Barcode = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 26h6v2H6ZM6 4H4v20h2Zm4 0H8v20h2Zm8 0h-4v20h4Zm-4 24h2v-2h-2Zm4 0h2v-2h-2Zm4 0h4v-2h-4Zm2-24v20h4V4Zm-2 0h-2v20h2Z"
        })
    });
var $a44983cd1155f044$export$2e2bcd8739ae039 = $a44983cd1155f044$var$SvgGlyphiconsBasic539Barcode;




const $f33346d0485a20cc$var$SvgGlyphiconsBasic54Alarm = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.743 9.914-1.178 1.178a13.07 13.07 0 0 0-5.657-5.657l1.178-1.178a2.006 2.006 0 0 1 2.828 0l2.829 2.829a2.006 2.006 0 0 1 0 2.828Zm-18.651-4.48L8.914 4.258a2.006 2.006 0 0 0-2.828 0L3.257 7.086a2.006 2.006 0 0 0 0 2.828l1.178 1.178a13.07 13.07 0 0 1 5.657-5.657ZM5.293 27.587a.5.5 0 0 0 0 .707l1.414 1.414a.5.5 0 0 0 .707 0l1.7-1.7a13.075 13.075 0 0 1-2.36-1.882Zm19.953-1.461a13.075 13.075 0 0 1-2.36 1.882l1.7 1.7a.5.5 0 0 0 .707 0l1.414-1.414a.5.5 0 0 0 0-.707ZM27 17A11 11 0 1 1 16 6a11.012 11.012 0 0 1 11 11Zm-3 0a8 8 0 1 0-8 8 8.01 8.01 0 0 0 8-8Zm-7-1.723V12a1 1 0 0 0-2 0v3.277a1.996 1.996 0 0 0-.723.723H12a1 1 0 0 0 0 2h2.277A1.994 1.994 0 1 0 17 15.277Z"
        })
    });
var $f33346d0485a20cc$export$2e2bcd8739ae039 = $f33346d0485a20cc$var$SvgGlyphiconsBasic54Alarm;




const $7e80f633419886c7$var$SvgGlyphiconsBasic540QrCode = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 4H4v9h9Zm-3 6H7V7h3Zm9-6v9h9V4Zm6 6h-3V7h3ZM4 28h9v-9H4Zm3-6h3v3H7Zm10-7v2h-5v-2Zm-2 4h2v3h-2Zm0 5h4v4h-4Zm6 2h7v2h-7Zm5-11h2v9h-2v-2h-2v-2h2ZM6 17H4v-2h2Zm2 0v-2h2v2Zm9-10h-2V4h2Zm0 6h-2V9h2Zm4 9h3v2h-5v-5h-2v-2h2v-2h5v2h-3Z"
        })
    });
var $7e80f633419886c7$export$2e2bcd8739ae039 = $7e80f633419886c7$var$SvgGlyphiconsBasic540QrCode;




const $823492300bff5596$var$SvgGlyphiconsBasic541CreditEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.234 14.571a10.42 10.42 0 0 0-1.025 2.845 6.998 6.998 0 1 1 9.506-8.376 10.412 10.412 0 0 0-2.95.659 3.99 3.99 0 1 0-5.53 4.872ZM27.083 19.5a8.583 8.583 0 1 1-8.583-8.583 8.593 8.593 0 0 1 8.583 8.583Zm-3 0a5.583 5.583 0 1 0-5.583 5.583 5.59 5.59 0 0 0 5.583-5.583Z"
        })
    });
var $823492300bff5596$export$2e2bcd8739ae039 = $823492300bff5596$var$SvgGlyphiconsBasic541CreditEmpty;




const $897c6ad247279757$var$SvgGlyphiconsBasic542Credit = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8.21 17.416a6.998 6.998 0 1 1 9.505-8.376 10.514 10.514 0 0 0-9.506 8.376Zm10.29-6.499a8.583 8.583 0 1 0 8.583 8.583 8.593 8.593 0 0 0-8.583-8.583Z"
        })
    });
var $897c6ad247279757$export$2e2bcd8739ae039 = $897c6ad247279757$var$SvgGlyphiconsBasic542Credit;




const $7e696b185d121242$var$SvgGlyphiconsBasic543StarHalf = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.965 13h-7.9l-2.44-7.516a.652.652 0 0 0-1.241 0L12.944 13h-7.9a.652.652 0 0 0-.384 1.18l6.393 4.642-2.438 7.506a.654.654 0 0 0 .622.857.643.643 0 0 0 .381-.128l6.386-4.638 6.386 4.638a.643.643 0 0 0 .38.128.654.654 0 0 0 .623-.857l-2.437-7.506 6.392-4.643A.652.652 0 0 0 26.965 13Zm-7.361 3.961-1.352.982.516 1.59.872 2.684-2.284-1.659-1.352-.982v-8.555l.873 2.69.516 1.589h4.498Z"
        })
    });
var $7e696b185d121242$export$2e2bcd8739ae039 = $7e696b185d121242$var$SvgGlyphiconsBasic543StarHalf;




const $fb05c820afdce076$var$SvgGlyphiconsBasic544Cloud = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.557 10A8.997 8.997 0 0 0 5.5 14c0 .265.013.532.038.8A5.938 5.938 0 0 0 2.5 20a5.034 5.034 0 0 0 .968 2.965A5.353 5.353 0 0 0 7.703 25h16.25a6.5 6.5 0 0 0 4.62-2 7.452 7.452 0 0 0 1.927-5 8.01 8.01 0 0 0-7.943-8Zm3.789 10.99A3.502 3.502 0 0 1 23.953 22H7.703a2.423 2.423 0 0 1-1.789-.771A2.014 2.014 0 0 1 5.5 20a2.972 2.972 0 0 1 2.138-2.852l.898-.271a.5.5 0 0 0 .343-.593l-.214-.913a5.979 5.979 0 0 1 6.444-7.34 6.17 6.17 0 0 1 5.126 4.213l.204.594a.497.497 0 0 0 .534.334c.515-.066 1.362-.172 1.527-.172a5.006 5.006 0 0 1 5 5 4.455 4.455 0 0 1-1.154 2.99Z"
        })
    });
var $fb05c820afdce076$export$2e2bcd8739ae039 = $fb05c820afdce076$var$SvgGlyphiconsBasic544Cloud;




const $d0b85fc8d05edfb7$var$SvgGlyphiconsBasic545CloudUpload = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.5 18a7.452 7.452 0 0 1-1.928 5 6.5 6.5 0 0 1-4.619 2H23v-3h.953a3.502 3.502 0 0 0 2.393-1.01A4.455 4.455 0 0 0 27.5 18a5.006 5.006 0 0 0-5-5c-.165 0-1.012.106-1.527.172a.497.497 0 0 1-.534-.334l-.204-.594A6.17 6.17 0 0 0 15.11 8.03a5.979 5.979 0 0 0-6.444 7.341l.214.913a.5.5 0 0 1-.343.593l-.898.271A2.972 2.972 0 0 0 5.5 20a2.014 2.014 0 0 0 .414 1.229 2.423 2.423 0 0 0 1.79.771H10v3H7.703a5.353 5.353 0 0 1-4.235-2.035A5.034 5.034 0 0 1 2.5 20a5.938 5.938 0 0 1 3.038-5.2A8.514 8.514 0 0 1 5.5 14a8.997 8.997 0 0 1 17.057-4 8.01 8.01 0 0 1 7.943 8Zm-13.596-.946a.5.5 0 0 0-.808 0l-3.759 5.151a.5.5 0 0 0 .404.795H15v5.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V23h2.259a.5.5 0 0 0 .404-.795Z"
        })
    });
var $d0b85fc8d05edfb7$export$2e2bcd8739ae039 = $d0b85fc8d05edfb7$var$SvgGlyphiconsBasic545CloudUpload;




const $fb2854415518a95c$var$SvgGlyphiconsBasic546CloudDownload = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.5 18a7.452 7.452 0 0 1-1.928 5 6.5 6.5 0 0 1-4.619 2H23v-3h.953a3.502 3.502 0 0 0 2.393-1.01A4.455 4.455 0 0 0 27.5 18a5.006 5.006 0 0 0-5-5c-.165 0-1.012.106-1.527.172a.497.497 0 0 1-.534-.334l-.204-.594A6.17 6.17 0 0 0 15.11 8.03a5.979 5.979 0 0 0-6.444 7.341l.214.913a.5.5 0 0 1-.343.593l-.898.271A2.972 2.972 0 0 0 5.5 20a2.014 2.014 0 0 0 .414 1.229 2.423 2.423 0 0 0 1.79.771H10v3H7.703a5.353 5.353 0 0 1-4.235-2.035A5.034 5.034 0 0 1 2.5 20a5.938 5.938 0 0 1 3.038-5.2A8.514 8.514 0 0 1 5.5 14a8.997 8.997 0 0 1 17.057-4 8.01 8.01 0 0 1 7.943 8Zm-10.241 5H18v-5.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5V23h-2.259a.5.5 0 0 0-.404.795l3.76 5.151a.5.5 0 0 0 .807 0l3.759-5.151a.5.5 0 0 0-.404-.795Z"
        })
    });
var $fb2854415518a95c$export$2e2bcd8739ae039 = $fb2854415518a95c$var$SvgGlyphiconsBasic546CloudDownload;




const $583b479813a95cd8$var$SvgGlyphiconsBasic547CloudRefresh = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.5 18a7.452 7.452 0 0 1-1.928 5 6.388 6.388 0 0 1-3.812 1.934c.005-.02.014-.039.018-.059l.487-2.021a6.432 6.432 0 0 0 .09-1.189 2.936 2.936 0 0 0 .99-.676A4.455 4.455 0 0 0 27.5 18a5.006 5.006 0 0 0-5-5c-.165 0-1.012.106-1.527.172a.497.497 0 0 1-.534-.334l-.204-.594A6.17 6.17 0 0 0 15.11 8.03a5.979 5.979 0 0 0-6.444 7.341l.214.913a.5.5 0 0 1-.343.593l-.898.271A2.972 2.972 0 0 0 5.5 20a2.014 2.014 0 0 0 .414 1.229 2.423 2.423 0 0 0 1.79.771H9.01l-.276 1.146a5.273 5.273 0 0 0-.065 1.4l.09.454H7.704a5.353 5.353 0 0 1-4.235-2.035A5.034 5.034 0 0 1 2.5 20a5.938 5.938 0 0 1 3.038-5.2A8.514 8.514 0 0 1 5.5 14a8.997 8.997 0 0 1 17.057-4 8.01 8.01 0 0 1 7.943 8Zm-8.587.087-.687.686c-.084-.085-.155-.18-.245-.26a6.002 6.002 0 0 0-9.815 3.08l1.982.397a3.945 3.945 0 0 1 3.614-2.981c.081-.005.163-.007.243-.007a3.966 3.966 0 0 1 2.649 1.008c.06.053.102.12.158.178l-.725.725a.445.445 0 0 0 .227.75l3.532.706a.444.444 0 0 0 .523-.523l-.706-3.532a.445.445 0 0 0-.75-.227Zm-1.923 7.567a3.998 3.998 0 0 1-5.644.337s-.102-.122-.158-.179l.725-.725a.445.445 0 0 0-.227-.75l-3.532-.706a.444.444 0 0 0-.523.523l.706 3.532a.445.445 0 0 0 .75.227l.687-.686c.084.085.155.18.245.26a5.951 5.951 0 0 0 3.973 1.512c.121 0 .243-.004.365-.012a6.006 6.006 0 0 0 5.477-4.58l-1.982-.397a3.965 3.965 0 0 1-.862 1.644Z"
        })
    });
var $583b479813a95cd8$export$2e2bcd8739ae039 = $583b479813a95cd8$var$SvgGlyphiconsBasic547CloudRefresh;




const $935279f973530aa3$var$SvgGlyphiconsBasic548CloudAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.5 18a7.452 7.452 0 0 1-1.928 5 6.389 6.389 0 0 1-3.818 1.935 7.521 7.521 0 0 0 .15-3.104 3.19 3.19 0 0 0 1.442-.842A4.455 4.455 0 0 0 27.5 18a5.006 5.006 0 0 0-5-5c-.165 0-1.012.106-1.527.172a.497.497 0 0 1-.534-.334l-.204-.594A6.17 6.17 0 0 0 15.11 8.03a5.979 5.979 0 0 0-6.444 7.341l.214.913a.5.5 0 0 1-.343.593l-.898.271A2.972 2.972 0 0 0 5.5 20a2.014 2.014 0 0 0 .414 1.229 2.423 2.423 0 0 0 1.79.771h1.365a7.557 7.557 0 0 0 .194 3h-1.56a5.353 5.353 0 0 1-4.235-2.035A5.034 5.034 0 0 1 2.5 20a5.938 5.938 0 0 1 3.038-5.2A8.514 8.514 0 0 1 5.5 14a8.997 8.997 0 0 1 17.057-4 8.01 8.01 0 0 1 7.943 8ZM23 23a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-5 2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm0-6a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v2a3.942 3.942 0 0 0 .149.977l.399 1.284a.362.362 0 0 0 .324.239h.256a.362.362 0 0 0 .324-.239l.4-1.284A3.942 3.942 0 0 0 18 21.5Z"
        })
    });
var $935279f973530aa3$export$2e2bcd8739ae039 = $935279f973530aa3$var$SvgGlyphiconsBasic548CloudAlert;




const $9f2bbd6ac3905422$var$SvgGlyphiconsBasic549CloudPause = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.5 18a7.452 7.452 0 0 1-1.928 5 6.5 6.5 0 0 1-4.619 2H23v-3h.953a3.502 3.502 0 0 0 2.393-1.01A4.455 4.455 0 0 0 27.5 18a5.006 5.006 0 0 0-5-5c-.165 0-1.012.106-1.527.172a.497.497 0 0 1-.534-.334l-.204-.594A6.17 6.17 0 0 0 15.11 8.03a5.979 5.979 0 0 0-6.444 7.341l.214.913a.5.5 0 0 1-.343.593l-.898.271A2.972 2.972 0 0 0 5.5 20a2.014 2.014 0 0 0 .414 1.229 2.423 2.423 0 0 0 1.79.771H11v3H7.703a5.353 5.353 0 0 1-4.235-2.035A5.034 5.034 0 0 1 2.5 20a5.938 5.938 0 0 1 3.038-5.2A8.514 8.514 0 0 1 5.5 14a8.997 8.997 0 0 1 17.057-4 8.01 8.01 0 0 1 7.943 8Zm-15 0h-2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Zm5 0h-2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5Z"
        })
    });
var $9f2bbd6ac3905422$export$2e2bcd8739ae039 = $9f2bbd6ac3905422$var$SvgGlyphiconsBasic549CloudPause;




const $bf6abbcdffcfe777$var$SvgGlyphiconsBasic55Clock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm2-9a1.994 1.994 0 0 1-3.723 1H12a1 1 0 0 1 0-2h2.277a1.996 1.996 0 0 1 .723-.723V10a1 1 0 0 1 2 0v4.277A1.992 1.992 0 0 1 18 16Z"
        })
    });
var $bf6abbcdffcfe777$export$2e2bcd8739ae039 = $bf6abbcdffcfe777$var$SvgGlyphiconsBasic55Clock;




const $81549cc927a29248$var$SvgGlyphiconsBasic550CloudCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.5 18a7.452 7.452 0 0 1-1.928 5 6.389 6.389 0 0 1-3.818 1.935 7.521 7.521 0 0 0 .15-3.104 3.19 3.19 0 0 0 1.442-.842A4.455 4.455 0 0 0 27.5 18a5.006 5.006 0 0 0-5-5c-.165 0-1.012.106-1.527.172a.497.497 0 0 1-.534-.334l-.204-.594A6.17 6.17 0 0 0 15.11 8.03a5.979 5.979 0 0 0-6.444 7.341l.214.913a.5.5 0 0 1-.343.593l-.898.271A2.972 2.972 0 0 0 5.5 20a2.014 2.014 0 0 0 .414 1.229 2.423 2.423 0 0 0 1.79.771h1.365a7.557 7.557 0 0 0 .194 3h-1.56a5.353 5.353 0 0 1-4.235-2.035A5.034 5.034 0 0 1 2.5 20a5.938 5.938 0 0 1 3.038-5.2A8.514 8.514 0 0 1 5.5 14a8.997 8.997 0 0 1 17.057-4 8.01 8.01 0 0 1 7.943 8ZM23 23a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-2.852-2.234-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.096l-.433.554a.297.297 0 0 0 .027.377l2.233 2.236a.83.83 0 0 0 1.298-.1l3.109-4.575a.254.254 0 0 0-.052-.352Z"
        })
    });
var $81549cc927a29248$export$2e2bcd8739ae039 = $81549cc927a29248$var$SvgGlyphiconsBasic550CloudCheck;




const $8e46e35d8ed18e6d$var$SvgGlyphiconsBasic551Bag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11.105 3.447A1 1 0 0 1 12.6 2.2 6.923 6.923 0 0 0 16 3.5a6.92 6.92 0 0 0 3.401-1.3 1 1 0 0 1 1.494 1.247L19.118 7h-6.236Zm15.26 16.322c-.172-1.835-.32-3.42-.366-4.288-.16-3.02-2.03-4.338-4.009-5.735-.331-.233-.68-.487-1.027-.746h-9.926c-.348.26-.696.513-1.027.746C8.03 11.143 6.16 12.461 6 15.481c-.046.868-.194 2.453-.366 4.288-.117 1.252-.244 2.606-.354 3.896A3.998 3.998 0 0 0 9.268 28h13.464a3.998 3.998 0 0 0 3.987-4.336c-.11-1.289-.237-2.643-.354-3.895Z"
        })
    });
var $8e46e35d8ed18e6d$export$2e2bcd8739ae039 = $8e46e35d8ed18e6d$var$SvgGlyphiconsBasic551Bag;




const $0bad8767464e28f9$var$SvgGlyphiconsBasic552HandDonate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 5a2.994 2.994 0 0 1 5.891-.759 5.524 5.524 0 0 0-3.65 3.65A2.993 2.993 0 0 1 15 5Zm4 4.5A3.5 3.5 0 1 0 22.5 6 3.5 3.5 0 0 0 19 9.5Zm10.893 8.443a1.499 1.499 0 0 0-1.95-.836l-3.1 1.24-3.865 1.579A1.002 1.002 0 0 1 20.6 20H16a1 1 0 0 1 0-2h4.403l1.199-.49A1.495 1.495 0 0 0 20.5 15H17l-3.327-.865a2 2 0 0 0-1.287.172L9.29 15.855a1.998 1.998 0 0 0-.52.374L7 18l6 6h5.5a1.492 1.492 0 0 0 .557-.107l10-4a1.5 1.5 0 0 0 .836-1.95ZM5.707 19.707a1 1 0 0 0-1.414 0L2 22l7 7 2.293-2.293a1 1 0 0 0 0-1.414Z"
        })
    });
var $0bad8767464e28f9$export$2e2bcd8739ae039 = $0bad8767464e28f9$var$SvgGlyphiconsBasic552HandDonate;




const $5b3b3869035554c9$var$SvgGlyphiconsBasic553HandHeart = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.128 6.836c0-2.286 3.117-3.923 4.787-1.582a.107.107 0 0 0 .174.003 2.636 2.636 0 0 1 4.783 1.58c0 1.995-2.537 3.59-4.564 5.817a.413.413 0 0 1-.616 0c-2.027-2.228-4.564-3.822-4.564-5.818Zm-9.42 12.871a1 1 0 0 0-1.415 0L2 22l7 7 2.293-2.293a1 1 0 0 0 0-1.414Zm24.185-1.764a1.499 1.499 0 0 0-1.95-.836l-3.1 1.24-3.865 1.579A1.002 1.002 0 0 1 20.6 20H16a1 1 0 0 1 0-2h4.403l1.199-.49A1.495 1.495 0 0 0 20.5 15H17l-3.327-.865a2 2 0 0 0-1.287.172L9.29 15.855a1.998 1.998 0 0 0-.52.374L7 18l6 6h5.5a1.492 1.492 0 0 0 .557-.107l10-4a1.5 1.5 0 0 0 .836-1.95Z"
        })
    });
var $5b3b3869035554c9$export$2e2bcd8739ae039 = $5b3b3869035554c9$var$SvgGlyphiconsBasic553HandHeart;




const $9a8cb1bda0e296c8$var$SvgGlyphiconsBasic554Handshake = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m8.804 9.536-4.5 7.794a1 1 0 0 1-1.366.366l-3.464-2 5.5-9.526 3.464 2a1 1 0 0 1 .366 1.366Zm1.3 11.15a.998.998 0 0 0-1.194.005l-1.069.802 5.672 4.15a1.997 1.997 0 0 0-.343-2.699ZM27.026 6.17l-3.464 2a1 1 0 0 0-.366 1.366l4.5 7.794a1 1 0 0 0 1.366.366l3.464-2Zm-9.078 9.328-1.317.526a4.02 4.02 0 0 1-4.814-1.495l-.113-.17a1.991 1.991 0 0 1 .503-2.736l2.277-1.402-3.448-.551-5.25 9.093.695 1.252 1.23-.923a2.982 2.982 0 0 1 3.579-.016l3.113 2.295a4.044 4.044 0 0 1 1.47 3.207l.403.27a3 3 0 0 0 3.411-.053l4.011-2.865-4.578-6.104a1.006 1.006 0 0 0-1.172-.328Zm1.139-5.762-5.713 3.514.108.17a2.002 2.002 0 0 0 2.406.747l1.318-.526a3.003 3.003 0 0 1 3.514.985l3.942 5.257 1.552-1.12-5.25-9.093Z"
        })
    });
var $9a8cb1bda0e296c8$export$2e2bcd8739ae039 = $9a8cb1bda0e296c8$var$SvgGlyphiconsBasic554Handshake;




const $4e28e976c46c59de$var$SvgGlyphiconsBasic555HandPraying = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 25v-2a1 1 0 0 0-2 0v2l-5.707-5.707A1 1 0 0 1 8 18.586l.006-5.09a1.485 1.485 0 0 1 .152-.667l3.958-8.916A1.565 1.565 0 0 1 14 3.085a1.5 1.5 0 0 1 .952 1.788S12.375 11.25 12 12.146A9.503 9.503 0 0 0 11 15a.999.999 0 0 0 1 1c.462 0 .759-.397 1-.877V14a2 2 0 0 1 4 0v1.123c.241.48.538.877 1 .877a.999.999 0 0 0 1-1 9.503 9.503 0 0 0-1-2.854c-.375-.896-2.952-7.273-2.952-7.273A1.5 1.5 0 0 1 16 3.085a1.565 1.565 0 0 1 1.884.828l3.958 8.916a1.485 1.485 0 0 1 .152.666l.006 5.09a1 1 0 0 1-.293.708Zm-9.293-4.293a1 1 0 0 0-1.414 0L3 23l7 7 2.293-2.293a1 1 0 0 0 0-1.414Zm18 0a1 1 0 0 0-1.414 0l-5.586 5.586a1 1 0 0 0 0 1.414L20 30l7-7Z"
        })
    });
var $4e28e976c46c59de$export$2e2bcd8739ae039 = $4e28e976c46c59de$var$SvgGlyphiconsBasic555HandPraying;




const $287d6160fef5f185$var$SvgGlyphiconsBasic556Flash = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m23.484 14.608-9.943 13a1 1 0 0 1-.795.392h-.221a1 1 0 0 1-.97-1.245L13.767 18H7.764a1 1 0 0 1-.8-1.6l8.976-12a1 1 0 0 1 .801-.4h.25a1 1 0 0 1 .975 1.22L16.214 13h6.476a1 1 0 0 1 .794 1.608Z"
        })
    });
var $287d6160fef5f185$export$2e2bcd8739ae039 = $287d6160fef5f185$var$SvgGlyphiconsBasic556Flash;




const $6adb6a2e2a9b0564$var$SvgGlyphiconsBasic557FlashAutomatic = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m23.484 14.608-9.943 13a1 1 0 0 1-.795.392h-.221a1 1 0 0 1-.97-1.245L13.767 18H7.764a1 1 0 0 1-.8-1.6l8.976-12a1 1 0 0 1 .801-.4h.25a1 1 0 0 1 .975 1.22L16.214 13h6.476a1 1 0 0 1 .794 1.608Zm7.377-4.616a1 1 0 0 1-1.315-.518L28.906 8h-3.814l-.64 1.474a1 1 0 1 1-1.834-.797L26.082.7a1 1 0 0 1 1.834 0l3.464 7.976a.999.999 0 0 1-.519 1.315ZM28.037 6 27 3.61 25.961 6Z"
        })
    });
var $6adb6a2e2a9b0564$export$2e2bcd8739ae039 = $6adb6a2e2a9b0564$var$SvgGlyphiconsBasic557FlashAutomatic;




const $f7f74a37a009fea3$var$SvgGlyphiconsBasic558FlashNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m23.484 14.608-9.943 13a1 1 0 0 1-.795.392h-.221a1 1 0 0 1-.97-1.245L13.767 18H7.764a1 1 0 0 1-.8-1.6l8.976-12a1 1 0 0 1 .801-.4h.25a1 1 0 0 1 .975 1.22L16.214 13h6.476a1 1 0 0 1 .794 1.608ZM32 5.5A5.5 5.5 0 1 1 26.5 0 5.5 5.5 0 0 1 32 5.5Zm-8.566 1.652 4.718-4.718A3.456 3.456 0 0 0 26.5 2 3.504 3.504 0 0 0 23 5.5a3.456 3.456 0 0 0 .434 1.652ZM30 5.5a3.456 3.456 0 0 0-.434-1.652l-4.718 4.718A3.456 3.456 0 0 0 26.5 9 3.504 3.504 0 0 0 30 5.5Z"
        })
    });
var $f7f74a37a009fea3$export$2e2bcd8739ae039 = $f7f74a37a009fea3$var$SvgGlyphiconsBasic558FlashNo;




const $0c14f8d8cc5886c3$var$SvgGlyphiconsBasic559Target = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.121 8a1 1 0 0 0 .707-.293l1.854-1.853A.5.5 0 0 0 29.328 5H27V2.671a.5.5 0 0 0-.854-.353L24.293 4.17A1 1 0 0 0 24 4.88v1.707l-.271.271a11.97 11.97 0 1 0 2.578 3.028l-1.463 1.462a10.055 10.055 0 1 1-2.525-3.08l-1.426 1.426A7.93 7.93 0 0 0 16 8a8.008 8.008 0 1 0 7.348 4.843l-1.568 1.569a6.033 6.033 0 1 1-2.312-3.294l-1.449 1.449A3.956 3.956 0 0 0 16 12a4 4 0 1 0 4 4 3.956 3.956 0 0 0-.567-2.02L25.414 8ZM16 18a2 2 0 0 1 0-4 1.975 1.975 0 0 1 .511.075l-.67.67a1 1 0 1 0 1.414 1.414l.67-.67A1.975 1.975 0 0 1 18 16a2.003 2.003 0 0 1-2 2Z"
        })
    });
var $0c14f8d8cc5886c3$export$2e2bcd8739ae039 = $0c14f8d8cc5886c3$var$SvgGlyphiconsBasic559Target;




const $d1298660d5035ded$var$SvgGlyphiconsBasic56Stopwatch = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m29.146 6.854-1.458 1.458A14.086 14.086 0 0 0 25.37 5.63l1.275-1.275a.5.5 0 0 1 .708 0l1.792 1.793a.5.5 0 0 1 0 .707ZM18 2.16V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.16A13.997 13.997 0 0 1 16 2a13.997 13.997 0 0 1 2 .16ZM28 16A12 12 0 1 1 16 4a12.013 12.013 0 0 1 12 12Zm-3 0a9 9 0 1 0-9 9 9.01 9.01 0 0 0 9-9Zm-8-1.723V10a1 1 0 0 0-2 0v4.277a1.984 1.984 0 0 0 0 3.446V18a1 1 0 0 0 2 0v-.277a1.984 1.984 0 0 0 0-3.446Z"
        })
    });
var $d1298660d5035ded$export$2e2bcd8739ae039 = $d1298660d5035ded$var$SvgGlyphiconsBasic56Stopwatch;




const $a6760b40fb540636$var$SvgGlyphiconsBasic560Marriage = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 20.5a7.5 7.5 0 1 1-14.442-2.83 3.484 3.484 0 0 1 1.468 2.326A5.522 5.522 0 0 0 15 20.5a5.515 5.515 0 1 0 4.315-5.368 9.556 9.556 0 0 0-1.437-1.65A7.48 7.48 0 0 1 28 20.5Zm-12.308-8.846a.413.413 0 0 0 .616 0c2.027-2.228 4.564-3.822 4.564-5.818a2.636 2.636 0 0 0-4.783-1.58.107.107 0 0 1-.174-.002c-1.67-2.34-4.787-.704-4.787 1.582 0 1.996 2.537 3.59 4.564 5.818ZM11.5 26a5.5 5.5 0 1 1 5.5-5.5c0 .179-.01.355-.027.53a3.483 3.483 0 0 0 1.468 2.301 7.54 7.54 0 1 0-4.32 4.187 9.556 9.556 0 0 1-1.436-1.65A5.487 5.487 0 0 1 11.5 26Z"
        })
    });
var $a6760b40fb540636$export$2e2bcd8739ae039 = $a6760b40fb540636$var$SvgGlyphiconsBasic560Marriage;




const $a2a085c6b37b56dc$var$SvgGlyphiconsBasic561Shoes = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 13.781V15a1 1 0 0 1-.9.995l-5.534.554-5.286-1.321-5.408-3.865a3.996 3.996 0 0 0-3.143-.655 4.035 4.035 0 0 0-2.178 1.271A24.574 24.574 0 0 1 6 11.59V7a1 1 0 0 1 1.242-.97A34.789 34.789 0 0 0 13 7a.825.825 0 0 0 .82-.382 2.03 2.03 0 0 1 1.325-.953 1.978 1.978 0 0 1 1.565.328l5.717 4.083 7.057 1.765A1.997 1.997 0 0 1 31 13.78Zm-5.516 5.06-7.057-1.765-5.717-4.083a1.979 1.979 0 0 0-1.565-.328 2.03 2.03 0 0 0-1.325.953A.825.825 0 0 1 9 14a34.789 34.789 0 0 1-5.758-.97A1 1 0 0 0 2 14v9a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-.72l4.935 1.234a11.721 11.721 0 0 0 4.034.295l8.13-.814A1 1 0 0 0 27 22v-1.219a1.997 1.997 0 0 0-1.516-1.94Z"
        })
    });
var $a2a085c6b37b56dc$export$2e2bcd8739ae039 = $a2a085c6b37b56dc$var$SvgGlyphiconsBasic561Shoes;




const $67386ff679a65fbf$var$SvgGlyphiconsBasic562ShoesOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 13.781V15a1 1 0 0 1-.9.995l-5.534.554-4.119-1.03 4.75-4.75 4.287 1.072A1.997 1.997 0 0 1 31 13.78Zm-5.516 5.06-6.686-1.672-6.049 6.048 1.186.297a11.721 11.721 0 0 0 4.034.295l8.13-.814A1 1 0 0 0 27 22v-1.219a1.997 1.997 0 0 0-1.516-1.94Zm1.73-15.902a1.5 1.5 0 0 0-2.12 0l-5.275 5.275-3.109-2.22a1.978 1.978 0 0 0-1.565-.329 2.03 2.03 0 0 0-1.325.953A.825.825 0 0 1 13 7a34.789 34.789 0 0 1-5.758-.97A1 1 0 0 0 6 7v4.59a24.574 24.574 0 0 0 2.55.39 4.035 4.035 0 0 1 2.18-1.272 3.996 3.996 0 0 1 3.142.655l1.632 1.166-1.435 1.435-1.359-.97a1.979 1.979 0 0 0-1.565-.329 2.03 2.03 0 0 0-1.325.953A.825.825 0 0 1 9 14a34.789 34.789 0 0 1-5.758-.97A1 1 0 0 0 2 14v9a1 1 0 0 0 1 1h1.033L2.94 25.094a1.5 1.5 0 1 0 2.122 2.12L27.215 5.062a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $67386ff679a65fbf$export$2e2bcd8739ae039 = $67386ff679a65fbf$var$SvgGlyphiconsBasic562ShoesOff;




const $a646ed4171c0b7b6$var$SvgGlyphiconsBasic563CardHearts = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 10.5c0 6.5-5.66 12.126-9.65 16.149a.488.488 0 0 1-.7 0C11.66 22.626 6 17 6 10.5A5.533 5.533 0 0 1 11.5 5a5.666 5.666 0 0 1 4.122 2.346.488.488 0 0 0 .756 0A5.666 5.666 0 0 1 20.5 5a5.533 5.533 0 0 1 5.5 5.5Z"
        })
    });
var $a646ed4171c0b7b6$export$2e2bcd8739ae039 = $a646ed4171c0b7b6$var$SvgGlyphiconsBasic563CardHearts;




const $f97c7177e2b5bc70$var$SvgGlyphiconsBasic564CardSpades = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 15.5a5.226 5.226 0 0 1-5.5 5.5 5.464 5.464 0 0 1-3.323-1.12 1.948 1.948 0 0 0-2.354 0A5.464 5.464 0 0 1 11.5 21 5.226 5.226 0 0 1 6 15.5C6 11 13 6 16 4c3 2 10 7 10 11.5ZM23 26h-1a5.665 5.665 0 0 1-4.439-2.534 1.97 1.97 0 0 0-3.122 0A5.665 5.665 0 0 1 10 26H9a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2Z"
        })
    });
var $f97c7177e2b5bc70$export$2e2bcd8739ae039 = $f97c7177e2b5bc70$var$SvgGlyphiconsBasic564CardSpades;




const $a4e92c9c68365d02$var$SvgGlyphiconsBasic565CardDiamonds = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m25.6 16.48-9.216 11.06a.5.5 0 0 1-.768 0L6.4 16.48a.75.75 0 0 1 0-.96l9.216-11.06a.5.5 0 0 1 .768 0L25.6 15.52a.75.75 0 0 1 0 .96Z"
        })
    });
var $a4e92c9c68365d02$export$2e2bcd8739ae039 = $a4e92c9c68365d02$var$SvgGlyphiconsBasic565CardDiamonds;




const $9a2ac6c77bb6cd9d$var$SvgGlyphiconsBasic566CardClubs = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.992 15.798a5.567 5.567 0 0 1-5.304 5.199 5.467 5.467 0 0 1-3.54-1.14 1.901 1.901 0 0 0-2.297 0 5.467 5.467 0 0 1-3.54 1.14 5.567 5.567 0 0 1-5.303-5.199 5.497 5.497 0 0 1 4.525-5.708 5.564 5.564 0 0 1-.033-.59 5.5 5.5 0 0 1 5.247-5.494 5.627 5.627 0 0 1 5.441 3.808 4.773 4.773 0 0 1 .28 2.276 5.497 5.497 0 0 1 4.524 5.708ZM23 26h-1a5.665 5.665 0 0 1-4.439-2.534 1.97 1.97 0 0 0-3.122 0A5.665 5.665 0 0 1 10 26H9a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2Z"
        })
    });
var $9a2ac6c77bb6cd9d$export$2e2bcd8739ae039 = $9a2ac6c77bb6cd9d$var$SvgGlyphiconsBasic566CardClubs;




const $e46675d71cde845e$var$SvgGlyphiconsBasic567BringForward = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 7H8a1 1 0 0 0-1 1v7H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1Zm8 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 9 21.5v-11A1.5 1.5 0 0 1 10.5 9h11a1.5 1.5 0 0 1 1.5 1.5ZM20 12h-8v8h8Z"
        })
    });
var $e46675d71cde845e$export$2e2bcd8739ae039 = $e46675d71cde845e$var$SvgGlyphiconsBasic567BringForward;




const $002048bce79fbd5a$var$SvgGlyphiconsBasic568BringToFront = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8 7a1 1 0 0 0-1 1v7H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v2Zm19 10h-2v7a1 1 0 0 1-1 1h-7v2a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1Zm-5.5 6h-11A1.5 1.5 0 0 1 9 21.5v-11A1.5 1.5 0 0 1 10.5 9h11a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5ZM20 12h-8v8h8Z"
        })
    });
var $002048bce79fbd5a$export$2e2bcd8739ae039 = $002048bce79fbd5a$var$SvgGlyphiconsBasic568BringToFront;




const $643dd38d95ab045d$var$SvgGlyphiconsBasic569SendBackward = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 15H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1Zm7.5-6H17v3h3v8h-8v-3H9v4.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 21.5 9Z"
        })
    });
var $643dd38d95ab045d$export$2e2bcd8739ae039 = $643dd38d95ab045d$var$SvgGlyphiconsBasic569SendBackward;




const $c2a3adba82356610$var$SvgGlyphiconsBasic57ScissorsHorizontal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.242 9h-7.16l7.508-4.955a1.5 1.5 0 0 1 1.87.202l.56.56a1 1 0 0 1 0 1.415Zm-6.826 12.617a3.483 3.483 0 0 1-.856 3.55l-1.914 1.915a2.503 2.503 0 0 1-3.535 0l-2.828-2.83a2.5 2.5 0 0 1 0-3.535l2.688-2.688a4.008 4.008 0 0 0 2.901 1.25 7.481 7.481 0 0 0 .803-.08l1.838-.377Zm-2.855.923-.69-2.139a.5.5 0 0 0-.83-.2l-1.93 1.93a.5.5 0 0 0 0 .708l1.414 1.414a.5.5 0 0 0 .707 0l1.207-1.207a.5.5 0 0 0 .122-.506ZM30 12v.792a1.5 1.5 0 0 1-1.18 1.466l-14.547 2.981a2.001 2.001 0 0 1-2.029-.797L10.5 14h-5A2.503 2.503 0 0 1 3 11.5v-4A2.503 2.503 0 0 1 5.5 5h2.707a3.485 3.485 0 0 1 3.115 1.906L13.418 11H29a1 1 0 0 1 1 1ZM9.675 10.272l-1.024-2A.5.5 0 0 0 8.207 8H6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.73a.5.5 0 0 0 .445-.728ZM16.5 14a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5Z"
        })
    });
var $c2a3adba82356610$export$2e2bcd8739ae039 = $c2a3adba82356610$var$SvgGlyphiconsBasic57ScissorsHorizontal;




const $c4acacf6483115fa$var$SvgGlyphiconsBasic570SendToBack = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 5v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1Zm12 12h-9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1Zm-7-2h3v-4.5A1.5 1.5 0 0 0 21.5 9H17v3h3Zm-8 2H9v4.5a1.5 1.5 0 0 0 1.5 1.5H15v-3h-3Z"
        })
    });
var $c4acacf6483115fa$export$2e2bcd8739ae039 = $c4acacf6483115fa$var$SvgGlyphiconsBasic570SendToBack;




const $8ea0fa06d08daf7a$var$SvgGlyphiconsBasic571WashingMachine = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 10a7 7 0 1 0 7 7 7.008 7.008 0 0 0-7-7Zm2.408 5.92a4.188 4.188 0 0 0-3.07 1.337 2.285 2.285 0 0 1-1.73.823 4.848 4.848 0 0 1-2.594-1.217 4.98 4.98 0 0 1 9.94-.31 5.587 5.587 0 0 0-2.546-.633ZM27 4H5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM16 26a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9ZM26 7.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Z"
        })
    });
var $8ea0fa06d08daf7a$export$2e2bcd8739ae039 = $8ea0fa06d08daf7a$var$SvgGlyphiconsBasic571WashingMachine;




const $d5a5cd7128ab8f02$var$SvgGlyphiconsBasic572Dryer = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.72 18.332a2.382 2.382 0 0 1-.282 1.132 1 1 0 0 1-.886.536.99.99 0 0 1-.463-.114 1 1 0 0 1-.422-1.35.384.384 0 0 0 .053-.204c0-.202-.05-.275-.4-.6a2.654 2.654 0 0 1-1.04-2.068 2.379 2.379 0 0 1 .279-1.126 1 1 0 1 1 1.773.924.386.386 0 0 0-.052.202c0 .202.05.275.4.6a2.654 2.654 0 0 1 1.04 2.068ZM23 17a7 7 0 1 1-7-7 7.008 7.008 0 0 1 7 7Zm-2.534-2.248a5 5 0 1 0-6.033 6.996 4.962 4.962 0 0 0 3.815-.282 4.999 4.999 0 0 0 2.218-6.714Zm-1.786 1.513c-.35-.326-.4-.399-.4-.6a.386.386 0 0 1 .052-.203 1 1 0 1 0-1.773-.924 2.379 2.379 0 0 0-.279 1.126 2.654 2.654 0 0 0 1.04 2.068c.35.325.4.398.4.6a.384.384 0 0 1-.053.204 1 1 0 0 0 .422 1.35.99.99 0 0 0 .463.114 1 1 0 0 0 .886-.536 2.382 2.382 0 0 0 .282-1.132 2.654 2.654 0 0 0-1.04-2.067ZM28 5v22a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-3 12a9 9 0 1 0-9 9 9.01 9.01 0 0 0 9-9Zm1-10.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Z"
        })
    });
var $d5a5cd7128ab8f02$export$2e2bcd8739ae039 = $d5a5cd7128ab8f02$var$SvgGlyphiconsBasic572Dryer;




const $ca046d5e4908560f$var$SvgGlyphiconsBasic573Dishwasher = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 4H5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-2 20a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm1-16.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm-17 7h6v2a2.991 2.991 0 0 1-2 2.816V21l1.553.776A.885.885 0 0 1 15 22.5v.5H9v-.5a.885.885 0 0 1 .447-.724L11 21v-1.684A2.991 2.991 0 0 1 9 16.5Zm13.707-1.793a1 1 0 0 1 .293.707v8.172a1 1 0 0 1-.293.707l-.353.353A1.386 1.386 0 0 1 21.5 23H21V12h.5a1.386 1.386 0 0 1 .854.354Zm-4 0a1 1 0 0 1 .293.707v8.172a1 1 0 0 1-.293.707l-.353.353A1.386 1.386 0 0 1 17.5 23H17V12h.5a1.386 1.386 0 0 1 .854.354Z"
        })
    });
var $ca046d5e4908560f$export$2e2bcd8739ae039 = $ca046d5e4908560f$var$SvgGlyphiconsBasic573Dishwasher;




const $8eefe6a32a5c7c41$var$SvgGlyphiconsBasic574Oven = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.72 21.332a2.382 2.382 0 0 1-.282 1.132 1 1 0 0 1-.886.536.99.99 0 0 1-.463-.114 1 1 0 0 1-.422-1.35.384.384 0 0 0 .053-.204c0-.202-.05-.275-.4-.6a2.654 2.654 0 0 1-1.04-2.068 2.379 2.379 0 0 1 .279-1.126 1 1 0 1 1 1.773.924.386.386 0 0 0-.052.202c0 .202.05.275.4.6a2.654 2.654 0 0 1 1.04 2.068Zm2.96-2.067c-.35-.326-.4-.399-.4-.601a.386.386 0 0 1 .052-.202 1 1 0 1 0-1.773-.924 2.379 2.379 0 0 0-.279 1.126 2.654 2.654 0 0 0 1.04 2.067c.35.326.4.399.4.601a.384.384 0 0 1-.053.204 1 1 0 0 0 .422 1.35.99.99 0 0 0 .463.114 1 1 0 0 0 .886-.536 2.382 2.382 0 0 0 .282-1.132 2.654 2.654 0 0 0-1.04-2.067Zm-8 0c-.35-.326-.4-.399-.4-.601a.386.386 0 0 1 .052-.202 1 1 0 1 0-1.773-.924 2.379 2.379 0 0 0-.279 1.126 2.654 2.654 0 0 0 1.04 2.067c.35.326.4.399.4.601a.384.384 0 0 1-.053.204 1 1 0 0 0 .422 1.35.99.99 0 0 0 .463.114 1 1 0 0 0 .886-.536 2.382 2.382 0 0 0 .282-1.132 2.654 2.654 0 0 0-1.04-2.067ZM28 5v22a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-3 10a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1Zm0-4.5a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5Zm1-4a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Z"
        })
    });
var $8eefe6a32a5c7c41$export$2e2bcd8739ae039 = $8eefe6a32a5c7c41$var$SvgGlyphiconsBasic574Oven;




const $24a0eb6802a73add$var$SvgGlyphiconsBasic575Hob = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 10a2 2 0 1 1 2 2 2.003 2.003 0 0 1-2-2Zm12 1a1 1 0 1 0-1-1 1 1 0 0 0 1 1Zm-10 7a1 1 0 1 0 1 1 1 1 0 0 0-1-1Zm10-1a2 2 0 1 0 2 2 2.003 2.003 0 0 0-2-2Zm7-12v22a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-10 5a3 3 0 1 0 3-3 3.003 3.003 0 0 0-3 3ZM7 10a4 4 0 1 0 4-4 4.004 4.004 0 0 0-4 4Zm7 9a3 3 0 1 0-3 3 3.003 3.003 0 0 0 3-3Zm4 5.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm7-5.5a4 4 0 1 0-4 4 4.004 4.004 0 0 0 4-4Z"
        })
    });
var $24a0eb6802a73add$export$2e2bcd8739ae039 = $24a0eb6802a73add$var$SvgGlyphiconsBasic575Hob;




const $8cb9e2242ebe2d61$var$SvgGlyphiconsBasic576Microwave = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 7H5a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm-6 14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Zm5-9.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm-7.4 5.698a1 1 0 0 1-1.2 1.6 2.057 2.057 0 0 0-2.797.002 4.035 4.035 0 0 1-5.204-.001 1 1 0 0 1 1.202-1.6 2.06 2.06 0 0 0 2.802.001 4.03 4.03 0 0 1 5.197-.002Zm0-4a1 1 0 0 1-1.2 1.6 2.057 2.057 0 0 0-2.797.002 4.035 4.035 0 0 1-5.204-.001 1 1 0 0 1 1.202-1.6 2.06 2.06 0 0 0 2.802.001 4.03 4.03 0 0 1 5.197-.002Z"
        })
    });
var $8cb9e2242ebe2d61$export$2e2bcd8739ae039 = $8cb9e2242ebe2d61$var$SvgGlyphiconsBasic576Microwave;




const $9b7222dbec3f30d3$var$SvgGlyphiconsBasic577Cluster = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 25a3 3 0 1 1-5.7-1.286L18.286 19.7a2.9 2.9 0 0 1-2.727-.084l-4.785 4.248a3.064 3.064 0 1 1-1.341-1.484l4.79-4.253A2.985 2.985 0 0 1 14 17c0-.04.01-.078.012-.118l-4.77-1.908A2.987 2.987 0 1 1 10 13c0 .04-.01.078-.012.118l4.77 1.908a3 3 0 0 1 .474-.439l-1.38-4.602a3 3 0 1 1 1.916-.572l1.38 4.602a2.971 2.971 0 0 1 1.138.285l4.014-4.014a3.028 3.028 0 1 1 1.414 1.414L19.7 15.714a2.907 2.907 0 0 1 0 2.572l4.014 4.014A2.982 2.982 0 0 1 28 25Z"
        })
    });
var $9b7222dbec3f30d3$export$2e2bcd8739ae039 = $9b7222dbec3f30d3$var$SvgGlyphiconsBasic577Cluster;




const $379e63cad9a4df74$var$SvgGlyphiconsBasic578Share = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 24a4 4 0 0 1-8 0c0-.105.023-.204.03-.307l-9.4-4.7a4 4 0 1 1 0-5.985l9.4-4.7C20.024 8.203 20 8.104 20 8a4.04 4.04 0 1 1 1.37 2.992l-9.4 4.7c.007.104.03.203.03.308s-.023.204-.03.307l9.4 4.7A3.982 3.982 0 0 1 28 24Z"
        })
    });
var $379e63cad9a4df74$export$2e2bcd8739ae039 = $379e63cad9a4df74$var$SvgGlyphiconsBasic578Share;




const $a0220f226bc935ed$var$SvgGlyphiconsBasic579TranslateAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.736 13.587A3.952 3.952 0 0 1 26 14h-.21a9.752 9.752 0 0 1 .16 1h-2.56l-.752.815A3.252 3.252 0 0 1 17.31 15H17v-1.537A4.002 4.002 0 0 1 15 10h-2.805A9.094 9.094 0 0 1 15 6.94V6a3.954 3.954 0 0 1 .556-2H15v.05A12.007 12.007 0 0 0 4.05 15H4v2h.05A12.007 12.007 0 0 0 15 27.95V28h2v-.05A12.007 12.007 0 0 0 27.95 17H28v-2h-.05a11.91 11.91 0 0 0-.214-1.413ZM12.143 6.776A9.934 9.934 0 0 0 10.015 10H8.02a10.045 10.045 0 0 1 4.124-3.224ZM6.841 12h2.558a17.325 17.325 0 0 0-.372 3H6.05a9.911 9.911 0 0 1 .79-3Zm0 8a9.911 9.911 0 0 1-.79-3h2.976a17.325 17.325 0 0 0 .372 3Zm1.178 2h1.996a9.936 9.936 0 0 0 2.128 3.224A10.046 10.046 0 0 1 8.019 22ZM15 25.06A9.094 9.094 0 0 1 12.195 22H15ZM15 20h-3.565a14.638 14.638 0 0 1-.412-3H15Zm0-5h-3.977a14.638 14.638 0 0 1 .412-3H15Zm2 2h3.977a14.638 14.638 0 0 1-.412 3H17Zm0 8.06V22h2.805A9.094 9.094 0 0 1 17 25.06Zm2.857.164A9.935 9.935 0 0 0 21.985 22h1.996a10.045 10.045 0 0 1-4.124 3.224ZM25.16 20h-2.558a17.325 17.325 0 0 0 .372-3h2.976a9.91 9.91 0 0 1-.79 3ZM26 4h-7a2.003 2.003 0 0 0-2 2v4a2.003 2.003 0 0 0 2 2v1.61a1.25 1.25 0 0 0 2.168.849L23.438 12H26a2.003 2.003 0 0 0 2-2V6a2.003 2.003 0 0 0-2-2Zm0 6h-3.438L21 11.692V10h-2V6h7Z"
        })
    });
var $a0220f226bc935ed$export$2e2bcd8739ae039 = $a0220f226bc935ed$var$SvgGlyphiconsBasic579TranslateAlt;




const $977aec84731c4216$var$SvgGlyphiconsBasic58History = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.013 9.984v4.3a1.947 1.947 0 0 1 .913 2.227l1.61 1.61a1 1 0 0 1-1.415 1.415l-1.61-1.61a1.99 1.99 0 0 1-1.498-3.655V9.984a1 1 0 1 1 2 0ZM15.895 4A12.01 12.01 0 0 0 4.05 15H1.954a.5.5 0 0 0-.41.785l3.545 5.121a.5.5 0 0 0 .822 0l3.546-5.121A.5.5 0 0 0 9.046 15H7.059a9.011 9.011 0 0 1 8.765-7.998 9.102 9.102 0 0 1 9.172 8.724A8.993 8.993 0 0 1 9.827 22.54a.993.993 0 0 0-1.503.15l-.573.828a1.013 1.013 0 0 0 .163 1.325 11.983 11.983 0 0 0 20.076-9.33A12.118 12.118 0 0 0 15.895 4Z"
        })
    });
var $977aec84731c4216$export$2e2bcd8739ae039 = $977aec84731c4216$var$SvgGlyphiconsBasic58History;




const $af9ec7b132a7f5c5$var$SvgGlyphiconsBasic580Translate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.646 15.525a3.504 3.504 0 0 1 0 4.95l-2.707 2.707 1.197 1.196a.448.448 0 0 1-.237.758l-5.492.998a.448.448 0 0 1-.52-.52l.998-5.492a.448.448 0 0 1 .758-.237l1.175 1.176 2.707-2.707a.502.502 0 0 0 0-.707l-1.037-1.038a3.255 3.255 0 0 0 1.15-.794l1.103-1.195ZM15 22v4a2.003 2.003 0 0 1-2 2H6a2.003 2.003 0 0 1-2-2v-4a2.003 2.003 0 0 1 2-2h2.562l2.27-2.459A1.25 1.25 0 0 1 13 18.39V20a2.003 2.003 0 0 1 2 2Zm-2 0h-2v-1.692L9.437 22H6v4h7ZM28 6v4a2.003 2.003 0 0 1-2 2h-2.563l-2.269 2.459A1.25 1.25 0 0 1 19 13.61V12a2.003 2.003 0 0 1-2-2V6a2.003 2.003 0 0 1 2-2h7a2.003 2.003 0 0 1 2 2Zm-2 0h-7v4h2v1.692L22.562 10H26Zm-11.407-.134L9.1 6.864a.448.448 0 0 0-.237.758l1.197 1.196-2.707 2.707a3.504 3.504 0 0 0 0 4.95l.905.905 1.103-1.195a3.256 3.256 0 0 1 1.15-.794l-1.037-1.037a.502.502 0 0 1 0-.707l2.707-2.708 1.175 1.176a.448.448 0 0 0 .758-.237l.999-5.491a.448.448 0 0 0-.521-.521Z"
        })
    });
var $af9ec7b132a7f5c5$export$2e2bcd8739ae039 = $af9ec7b132a7f5c5$var$SvgGlyphiconsBasic580Translate;




const $f0dfd04a6cbf0f1c$var$SvgGlyphiconsBasic581Directions = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.06 14.94-11-11a1.5 1.5 0 0 0-2.12 0l-11 11a1.5 1.5 0 0 0 0 2.12l11 11a1.5 1.5 0 0 0 2.12 0l11-11a1.5 1.5 0 0 0 0-2.12Zm-5.593.96L17.8 19.4a.5.5 0 0 1-.8-.4v-2h-2v3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-4a2.5 2.5 0 0 1 2.5-2.5H17v-2a.5.5 0 0 1 .8-.4l4.667 3.5a.5.5 0 0 1 0 .8Z"
        })
    });
var $f0dfd04a6cbf0f1c$export$2e2bcd8739ae039 = $f0dfd04a6cbf0f1c$var$SvgGlyphiconsBasic581Directions;




const $6e590f2303229227$var$SvgGlyphiconsBasic582DirectionsArrow = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m14.586 11.757-1.415 1.415a3.967 3.967 0 0 0-1.022 1.805l-6.27-6.27a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0Zm11.362-6.836-5.919.845a1 1 0 0 0-.566 1.697l1.123 1.123-6 6A2 2 0 0 0 14 16v11a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V16.828l5.414-5.414 1.123 1.123a1 1 0 0 0 1.697-.566l.845-5.919a1 1 0 0 0-1.131-1.131Z"
        })
    });
var $6e590f2303229227$export$2e2bcd8739ae039 = $6e590f2303229227$var$SvgGlyphiconsBasic582DirectionsArrow;




const $340a25fb7c93e1a2$var$SvgGlyphiconsBasic583FinishLine = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 11v3h-3v-3Zm-9 0v3h3v-3ZM4 27.5V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h19V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v22.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V19H7v8.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5ZM27 8h-3v3h-3V8h-3v3h-3V8h-3v3H9V8H6v3h3v3H6v3h3v-3h3v3h3v-3h3v3h3v-3h3v3h3v-3h-3v-3h3Z"
        })
    });
var $340a25fb7c93e1a2$export$2e2bcd8739ae039 = $340a25fb7c93e1a2$var$SvgGlyphiconsBasic583FinishLine;




const $392e4ed0334e91e9$var$SvgGlyphiconsBasic584Radio = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.08 7h-5.16l9.92-4.172a1 1 0 0 1 .775 1.844ZM28 10v15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1v-2a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1Zm-3 12.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm0-10a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Z"
        })
    });
var $392e4ed0334e91e9$export$2e2bcd8739ae039 = $392e4ed0334e91e9$var$SvgGlyphiconsBasic584Radio;




const $75b794eee67aeae3$var$SvgGlyphiconsBasic585Start = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 11v3h-3v-3Zm8-4v11a1 1 0 0 1-1 1H10v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h15a1 1 0 0 1 1 1Zm-2 1h-3v3h-3V8h-3v3h-3V8H9v3h3v3H9v3h3v-3h3v3h3v-3h3v3h3v-3h-3v-3h3Z"
        })
    });
var $75b794eee67aeae3$export$2e2bcd8739ae039 = $75b794eee67aeae3$var$SvgGlyphiconsBasic585Start;




const $6ce2c5165dc4672a$var$SvgGlyphiconsBasic586Bomb = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 13.999v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0Zm-1-9a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm5 5h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Zm-14-4a1.834 1.834 0 0 1 2 2 4.004 4.004 0 0 0 4 4h2a1 1 0 0 0 0-2h-2a2.003 2.003 0 0 1-2-2 3.787 3.787 0 0 0-4-4 3.787 3.787 0 0 0-4 4h-1a1 1 0 0 0-1 1v1.525a9 9 0 1 0 6 0V8.999a1 1 0 0 0-1-1h-1a1.834 1.834 0 0 1 2-2Zm12.328 3.086 1.414-1.414a1 1 0 0 0-1.414-1.414L27.914 7.67a1 1 0 0 0 1.414 1.414Zm.001 3.829a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 1 0 1.414-1.414Z"
        })
    });
var $6ce2c5165dc4672a$export$2e2bcd8739ae039 = $6ce2c5165dc4672a$var$SvgGlyphiconsBasic586Bomb;




const $2d2bcde06949c22b$var$SvgGlyphiconsBasic587Bug = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 9h-8V8a4.141 4.141 0 0 1 4-4 4.141 4.141 0 0 1 4 4Zm7 7h-4v-1a3.964 3.964 0 0 0-.247-1.34l2.954-2.953A1 1 0 0 0 26 10V8a1 1 0 0 0-2 0v1.586l-2.398 2.398A3.966 3.966 0 0 0 19 11h-6a3.966 3.966 0 0 0-2.602.984L8 9.586V8a1 1 0 0 0-2 0v2a1 1 0 0 0 .293.707l2.954 2.954A3.964 3.964 0 0 0 9 15v1H5a1 1 0 0 0 0 2h4v2.155a.963.963 0 0 0-.207.138l-2.5 2.5A1 1 0 0 0 6 23.5v3a1 1 0 0 0 2 0v-2.586l1.216-1.216a6.991 6.991 0 0 0 13.568 0L24 23.914V26.5a1 1 0 0 0 2 0v-3a1 1 0 0 0-.293-.707l-2.5-2.5a.963.963 0 0 0-.207-.138V18h4a1 1 0 0 0 0-2Z"
        })
    });
var $2d2bcde06949c22b$export$2e2bcd8739ae039 = $2d2bcde06949c22b$var$SvgGlyphiconsBasic587Bug;




const $3c9493eea39100db$var$SvgGlyphiconsBasic588BookOpenText = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 5h-6a4.995 4.995 0 0 0-4 2.003A4.995 4.995 0 0 0 12 5H6a3.003 3.003 0 0 0-3 3v15a3 3 0 0 0 3 3h6a1.252 1.252 0 0 1 1.154.772A2 2 0 0 0 14.996 28h2.007a2 2 0 0 0 1.843-1.229A1.25 1.25 0 0 1 19.999 26h6a3 3 0 0 0 3-3V8a3.003 3.003 0 0 0-3-3ZM15 24h-.184A2.991 2.991 0 0 0 12 22H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6a3 3 0 0 1 3 3Zm12-3a1 1 0 0 1-1 1h-6a2.991 2.991 0 0 0-2.816 2H17V10a3 3 0 0 1 3-3h6a1 1 0 0 1 1 1Zm-14-3.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm0-4v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm0-4v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm12 0v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm-2 8v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm2-4v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Z"
        })
    });
var $3c9493eea39100db$export$2e2bcd8739ae039 = $3c9493eea39100db$var$SvgGlyphiconsBasic588BookOpenText;




const $2ec1cd982bec3b95$var$SvgGlyphiconsBasic589BookOpen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 5h-6a4.995 4.995 0 0 0-4 2.003A4.995 4.995 0 0 0 12 5H6a3.003 3.003 0 0 0-3 3v15a3 3 0 0 0 3 3h6a1.252 1.252 0 0 1 1.154.772A2 2 0 0 0 14.996 28h2.007a2 2 0 0 0 1.843-1.229A1.25 1.25 0 0 1 19.999 26h6a3 3 0 0 0 3-3V8a3.003 3.003 0 0 0-3-3ZM15 24h-.184A2.991 2.991 0 0 0 12 22H6a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6a3 3 0 0 1 3 3Zm12-3a1 1 0 0 1-1 1h-6a2.991 2.991 0 0 0-2.816 2H17V10a3 3 0 0 1 3-3h6a1 1 0 0 1 1 1Z"
        })
    });
var $2ec1cd982bec3b95$export$2e2bcd8739ae039 = $2ec1cd982bec3b95$var$SvgGlyphiconsBasic589BookOpen;




const $a50ab3a6773fc2e4$var$SvgGlyphiconsBasic59Truck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 2H5a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2h14v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-7a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1ZM11 22.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm14 0a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm0-7.5a1.003 1.003 0 0 1-1 1H8a1.003 1.003 0 0 1-1-1v-5a1.003 1.003 0 0 1 1-1h16a1.003 1.003 0 0 1 1 1Z"
        })
    });
var $a50ab3a6773fc2e4$export$2e2bcd8739ae039 = $a50ab3a6773fc2e4$var$SvgGlyphiconsBasic59Truck;




const $358439cf0cb7fbbb$var$SvgGlyphiconsBasic590Newspaper = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.5 14h11a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5Zm11 2h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm0 4h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-11 2h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5ZM27 5H9a1 1 0 0 0-1 1v17a1 1 0 0 1-2 0V6a2.003 2.003 0 0 0-2 2v15a3.003 3.003 0 0 0 2.998 3H25a3.003 3.003 0 0 0 3-3V6a1 1 0 0 0-1-1Zm-1 18a1 1 0 0 1-1 1H9.83a3 3 0 0 0 .17-1V7h16Zm-13.5-5h4a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Z"
        })
    });
var $358439cf0cb7fbbb$export$2e2bcd8739ae039 = $358439cf0cb7fbbb$var$SvgGlyphiconsBasic590Newspaper;




const $c035ffa49fb0d773$var$SvgGlyphiconsBasic591MapMarker = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a9 9 0 0 0-9 9c0 6 6.758 13.078 8.162 14.631a1.138 1.138 0 0 0 1.676 0C18.242 26.078 25 19 25 13a9 9 0 0 0-9-9Zm0 14a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z"
        })
    });
var $c035ffa49fb0d773$export$2e2bcd8739ae039 = $c035ffa49fb0d773$var$SvgGlyphiconsBasic591MapMarker;




const $bef90a56ad254518$var$SvgGlyphiconsBasic592Map = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 8v16a1 1 0 0 1-.648.937l-8 3c-.01.003-.018.001-.027.004a.93.93 0 0 1-.65 0c-.009-.003-.018-.001-.027-.004L12 25.068l-7.648 2.869A1 1 0 0 1 3 27V11a1 1 0 0 1 .648-.937l5.366-2.012c-.003.095-.014.187-.014.282a7.358 7.358 0 0 0 .237 1.771L5 11.694v13.863l6-2.25v-9.338a24.735 24.735 0 0 0 2 2.656v6.682l6 2.25v-8.932a24.735 24.735 0 0 0 2-2.656v11.588l6-2.25V9.443l-4.559 1.71a8.56 8.56 0 0 0 .532-2.336l4.675-1.754A1 1 0 0 1 29 8Zm-13.466 8.462C14.754 15.599 11 11.667 11 8.333a5 5 0 0 1 10 0c0 3.334-3.755 7.266-4.534 8.129a.632.632 0 0 1-.932 0Zm.466-5.35a2.778 2.778 0 1 0-2.778-2.779A2.778 2.778 0 0 0 16 11.111Z"
        })
    });
var $bef90a56ad254518$export$2e2bcd8739ae039 = $bef90a56ad254518$var$SvgGlyphiconsBasic592Map;




const $c24b523acf3bc69c$var$SvgGlyphiconsBasic593Route = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.434 25.752a2.792 2.792 0 0 0 .275.248H9.997a2.5 2.5 0 0 1-1.169-4.71l4.438-2.348a.469.469 0 0 0 .252-.563.474.474 0 0 0-.486-.379H8.545c.384-.42 1.018-1.12 1.691-2h2.796a2.5 2.5 0 0 1 1.17 4.71l-4.438 2.348a.469.469 0 0 0-.252.563.474.474 0 0 0 .485.379h9.89c.553.66 1.044 1.2 1.378 1.565ZM11 9.5c0 3-3.38 6.539-4.08 7.316a.569.569 0 0 1-.84 0C5.38 16.039 2 12.5 2 9.5a4.5 4.5 0 0 1 9 0Zm-2 0A2.5 2.5 0 1 0 6.5 12 2.5 2.5 0 0 0 9 9.5Zm20.75 4.75c0 4.167-4.693 9.082-5.668 10.16a.79.79 0 0 1-1.164 0c-.975-1.078-5.668-5.993-5.668-10.16a6.25 6.25 0 0 1 12.5 0Zm-2.778 0a3.472 3.472 0 1 0-3.472 3.472 3.472 3.472 0 0 0 3.472-3.472Z"
        })
    });
var $c24b523acf3bc69c$export$2e2bcd8739ae039 = $c24b523acf3bc69c$var$SvgGlyphiconsBasic593Route;




const $f100067fd616b8ba$var$SvgGlyphiconsBasic594Nearby = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 21.5c0 3.645-5.49 6.5-12.5 6.5S3 25.145 3 21.5c0-2.399 2.386-4.45 6.01-5.575.346.612.716 1.2 1.097 1.752C6.953 18.533 5 20.07 5 21.5 5 23.629 9.312 26 15.5 26S26 23.629 26 21.5c0-1.43-1.953-2.967-5.107-3.823.38-.553.751-1.14 1.096-1.752C25.614 17.05 28 19.1 28 21.5Zm-13.082-1.09c-.975-1.078-5.668-5.993-5.668-10.16a6.25 6.25 0 0 1 12.5 0c0 4.167-4.693 9.082-5.668 10.16a.79.79 0 0 1-1.164 0Zm.582-6.688a3.472 3.472 0 1 0-3.472-3.472 3.472 3.472 0 0 0 3.472 3.472Z"
        })
    });
var $f100067fd616b8ba$export$2e2bcd8739ae039 = $f100067fd616b8ba$var$SvgGlyphiconsBasic594Nearby;




const $a284c76da451cf7b$var$SvgGlyphiconsBasic595NearbyAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.26 26.194a1.983 1.983 0 0 1-1.604.806H5.344a2 2 0 0 1-1.916-2.574l2.4-8A2.013 2.013 0 0 1 7.744 15h.779a20.215 20.215 0 0 0 1.132 2h-1.91l-2.401 8h20.312l-2.4-8h-1.911a20.215 20.215 0 0 0 1.132-2h.779a2.013 2.013 0 0 1 1.916 1.426l2.4 8a1.983 1.983 0 0 1-.311 1.768Zm-12.342-5.783c-.975-1.08-5.668-5.994-5.668-10.161a6.25 6.25 0 0 1 12.5 0c0 4.167-4.693 9.082-5.668 10.16a.79.79 0 0 1-1.164 0Zm.582-6.689a3.472 3.472 0 1 0-3.472-3.472 3.472 3.472 0 0 0 3.472 3.472Z"
        })
    });
var $a284c76da451cf7b$export$2e2bcd8739ae039 = $a284c76da451cf7b$var$SvgGlyphiconsBasic595NearbyAlt;




const $2dd73eb1ef62d575$var$SvgGlyphiconsBasic596PiggyBank = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.497 9.145a1 1 0 0 0-.568 1.918 1.5 1.5 0 1 1-1.015 2.818A8.212 8.212 0 0 0 17.726 7H13a7.946 7.946 0 0 0-3.867 1H5.434a.5.5 0 0 0-.416.777l1.263 1.895a7.96 7.96 0 0 0-1.08 2.572.984.984 0 0 1-.966.756H3a1 1 0 0 0-1 1v1.34a1 1 0 0 0 .606.92l3.29 1.41a8.04 8.04 0 0 0 2.65 2.956l-.405 3.25A1 1 0 0 0 9.133 26h1.984a1 1 0 0 0 .992-.876l.271-2.168c.207.016.41.044.62.044h5a8.014 8.014 0 0 0 1.391-.13l-.25 2.006A1 1 0 0 0 20.133 26h1.984a1 1 0 0 0 .992-.876l.562-4.492a7.963 7.963 0 0 0 2.265-4.689A3.438 3.438 0 0 0 30 12.5a3.52 3.52 0 0 0-2.503-3.355ZM19 10.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5Z"
        })
    });
var $2dd73eb1ef62d575$export$2e2bcd8739ae039 = $2dd73eb1ef62d575$var$SvgGlyphiconsBasic596PiggyBank;




const $c59b1d3b6493f208$var$SvgGlyphiconsBasic597PiggyBankCoins = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 2.5a2.494 2.494 0 0 1 4.978-.217 4.495 4.495 0 0 0-2.695 2.695A2.492 2.492 0 0 1 9 2.5Zm21 10a3.438 3.438 0 0 1-4.064 3.443 7.963 7.963 0 0 1-2.265 4.689l-.561 4.492a1 1 0 0 1-.993.876h-1.984a1 1 0 0 1-.992-1.124l.25-2.007A8.014 8.014 0 0 1 18 23h-5c-.21 0-.413-.028-.62-.044l-.27 2.168a1 1 0 0 1-.993.876H9.133a1 1 0 0 1-.992-1.124l.406-3.25a8.04 8.04 0 0 1-2.65-2.956l-3.291-1.41A1 1 0 0 1 2 16.34V15a1 1 0 0 1 1-1h1.235a.984.984 0 0 0 .966-.756 7.96 7.96 0 0 1 1.08-2.572L5.018 8.777A.5.5 0 0 1 5.434 8h3.699A7.946 7.946 0 0 1 13 7h.05a2.5 2.5 0 1 1 4.897.01 8.199 8.199 0 0 1 7.967 6.87 1.5 1.5 0 1 0 1.015-2.817 1 1 0 0 1 .568-1.918A3.52 3.52 0 0 1 30 12.5Zm-11-3a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5Z"
        })
    });
var $c59b1d3b6493f208$export$2e2bcd8739ae039 = $c59b1d3b6493f208$var$SvgGlyphiconsBasic597PiggyBankCoins;




const $6c1e971f0cbaebcb$var$SvgGlyphiconsBasic598SoundSurround = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 16a3 3 0 1 1-3-3 3.003 3.003 0 0 1 3 3ZM6.39 8.263a1.4 1.4 0 0 0-1.95.34 12.856 12.856 0 0 0 0 14.794 1.4 1.4 0 0 0 2.291-1.61 10.06 10.06 0 0 1 0-11.574 1.4 1.4 0 0 0-.34-1.95Zm21.17.34a1.4 1.4 0 0 0-2.291 1.61 10.06 10.06 0 0 1 0 11.574 1.4 1.4 0 1 0 2.29 1.61 12.856 12.856 0 0 0 0-14.794Zm-17.078 2.524a1.399 1.399 0 0 0-1.95.343 7.88 7.88 0 0 0 0 9.06 1.4 1.4 0 1 0 2.293-1.607 5.081 5.081 0 0 1 0-5.846 1.4 1.4 0 0 0-.343-1.95Zm11.036 0a1.4 1.4 0 0 0-.343 1.95 5.081 5.081 0 0 1 0 5.846 1.4 1.4 0 1 0 2.293 1.607 7.88 7.88 0 0 0 0-9.06 1.401 1.401 0 0 0-1.95-.343Z"
        })
    });
var $6c1e971f0cbaebcb$export$2e2bcd8739ae039 = $6c1e971f0cbaebcb$var$SvgGlyphiconsBasic598SoundSurround;




const $c7a8408ad80b1330$var$SvgGlyphiconsBasic599MenuClose = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.839 23.01a.5.5 0 0 1 0 .708l-2.121 2.12a.5.5 0 0 1-.708 0L16 18.829l-7.01 7.01a.5.5 0 0 1-.708 0l-2.12-2.12a.5.5 0 0 1 0-.708l7.01-7.01-7.01-7.01a.5.5 0 0 1 0-.708l2.12-2.12a.5.5 0 0 1 .708 0l7.01 7.01 7.01-7.01a.5.5 0 0 1 .708 0l2.12 2.12a.5.5 0 0 1 0 .707L18.829 16Z"
        })
    });
var $c7a8408ad80b1330$export$2e2bcd8739ae039 = $c7a8408ad80b1330$var$SvgGlyphiconsBasic599MenuClose;




const $b778d4f1137058a1$var$SvgGlyphiconsBasic6Car = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.165 14.383-1.49-6.46A3.962 3.962 0 0 0 22 5H10a3.962 3.962 0 0 0-3.675 2.923l-1.49 6.46A1.996 1.996 0 0 0 4 16v11a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h16v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V16a1.996 1.996 0 0 0-.835-1.617ZM8.274 8.373A1.967 1.967 0 0 1 10 7h12a1.967 1.967 0 0 1 1.726 1.373L24.794 13H7.206ZM10 17.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm16 0a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Z"
        })
    });
var $b778d4f1137058a1$export$2e2bcd8739ae039 = $b778d4f1137058a1$var$SvgGlyphiconsBasic6Car;




const $d1e645c08651e69d$var$SvgGlyphiconsBasic60Timer = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.736 27.935A11.984 11.984 0 0 1 6.525 8.652a.99.99 0 0 1 1.491-.13l.733.686a1.013 1.013 0 0 1 .123 1.314 8.997 8.997 0 1 0 16.106 4.835A9.144 9.144 0 0 0 17 7.101V9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1a.913.913 0 0 1 .101.02A12.2 12.2 0 0 1 27.96 15a12.013 12.013 0 0 1-13.223 12.935Zm-.725-11.828a1.996 1.996 0 1 0 2.096-2.096L11.8 10.86a.603.603 0 0 0-.758.059l-.121.121a.602.602 0 0 0-.059.757Z"
        })
    });
var $d1e645c08651e69d$export$2e2bcd8739ae039 = $d1e645c08651e69d$var$SvgGlyphiconsBasic60Timer;




const $ec7d266974f3e11f$var$SvgGlyphiconsBasic600Menu = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 23v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1ZM26 6H6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm0 8H6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
    });
var $ec7d266974f3e11f$export$2e2bcd8739ae039 = $ec7d266974f3e11f$var$SvgGlyphiconsBasic600Menu;




const $7e512016439c0b74$var$SvgGlyphiconsBasic601UserNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.365 13.374A1.275 1.275 0 0 1 10 11.63V9c0-3 2-5 5.5-5a6.791 6.791 0 0 1 2.646.501 7.948 7.948 0 0 0 3.599 8.261 1.712 1.712 0 0 1-.11.612l-.28.752a2.991 2.991 0 0 1-1.31 1.462l-.666 3.051A3 3 0 0 1 16.448 21h-1.896a3 3 0 0 1-2.93-2.36l-.666-3.052a2.991 2.991 0 0 1-1.311-1.462Zm16.704 9.498-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-9.433 2.019 5.452-5.452A3.955 3.955 0 0 0 26 2a4.005 4.005 0 0 0-4 4 3.954 3.954 0 0 0 .567 2.019ZM30 6a3.954 3.954 0 0 0-.567-2.019l-5.452 5.452A3.955 3.955 0 0 0 26 10a4.005 4.005 0 0 0 4-4Z"
        })
    });
var $7e512016439c0b74$export$2e2bcd8739ae039 = $7e512016439c0b74$var$SvgGlyphiconsBasic601UserNo;




const $cf3b3c38afc89caf$var$SvgGlyphiconsBasic602UserLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.365 13.374A1.275 1.275 0 0 1 10 11.63V9c0-3 2-5 5.5-5a6.151 6.151 0 0 1 3.503.959c0 .014-.003.027-.003.041v6a3.003 3.003 0 0 0 2.424 2.942l-.069.184a2.991 2.991 0 0 1-1.31 1.462l-.666 3.051A3 3 0 0 1 16.448 21h-1.896a3 3 0 0 1-2.93-2.36l-.666-3.052a2.991 2.991 0 0 1-1.311-1.462Zm16.704 9.498-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $cf3b3c38afc89caf$export$2e2bcd8739ae039 = $cf3b3c38afc89caf$var$SvgGlyphiconsBasic602UserLock;




const $a1aa5bb50a75af7c$var$SvgGlyphiconsBasic603UserFlag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.365 13.374A1.275 1.275 0 0 1 10 11.63V9c0-3 2-5 5.5-5S21 6 21 9v2.63a1.275 1.275 0 0 1 .635 1.744l-.28.752a2.991 2.991 0 0 1-1.31 1.462l-.666 3.051A3 3 0 0 1 16.448 21h-1.896a3 3 0 0 1-2.93-2.36l-.666-3.052a2.991 2.991 0 0 1-1.311-1.462Zm16.704 9.498-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365ZM30 0h-5a1 1 0 0 0-1 1v10.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7.417l4.526-1.259A.74.74 0 0 0 31 5.5V1a1 1 0 0 0-1-1Z"
        })
    });
var $a1aa5bb50a75af7c$export$2e2bcd8739ae039 = $a1aa5bb50a75af7c$var$SvgGlyphiconsBasic603UserFlag;




const $2ce355753c56e0eb$var$SvgGlyphiconsBasic604UserStar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24.237V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.763a1.578 1.578 0 0 1 .931-1.365l5.136-2.705A5.024 5.024 0 0 0 14.553 23h1.894a5.023 5.023 0 0 0 4.486-2.833l5.136 2.705A1.578 1.578 0 0 1 27 24.237ZM9.645 14.126a2.991 2.991 0 0 0 1.31 1.462l.666 3.051A3 3 0 0 0 14.552 21h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a3.358 3.358 0 0 0 .826-.679 2.41 2.41 0 0 1-1.908-3.13l.88-2.709-2.307-1.675a2.398 2.398 0 0 1-.619-3.26A7.782 7.782 0 0 0 15.5 4C12 4 10 6 10 9v2.63a1.275 1.275 0 0 0-.635 1.744ZM31.045 5h-4.303l-.646-1.988-.684-2.105a.43.43 0 0 0-.816 0l-.684 2.105L23.267 5h-4.304a.43.43 0 0 0-.252.777l1.791 1.3 1.691 1.229-.645 1.987-.683 2.101a.43.43 0 0 0 .661.48l1.788-1.298 1.69-1.228 1.69 1.228 1.788 1.298a.43.43 0 0 0 .66-.48l-.682-2.1-.645-1.988 1.69-1.228 1.792-1.301A.43.43 0 0 0 31.045 5Z"
        })
    });
var $2ce355753c56e0eb$export$2e2bcd8739ae039 = $2ce355753c56e0eb$var$SvgGlyphiconsBasic604UserStar;




const $38e82c133177a81e$var$SvgGlyphiconsBasic605UserAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.365 13.374A1.275 1.275 0 0 1 10 11.63V9c0-3 2-5 5.5-5a6.791 6.791 0 0 1 2.646.501 7.948 7.948 0 0 0 3.599 8.261 1.712 1.712 0 0 1-.11.612l-.28.752a2.991 2.991 0 0 1-1.31 1.462l-.666 3.051A3 3 0 0 1 16.448 21h-1.896a3 3 0 0 1-2.93-2.36l-.666-3.052a2.991 2.991 0 0 1-1.311-1.462Zm16.704 9.498-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-5 2.5a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v1a.502.502 0 0 0 .5.5h1a.502.502 0 0 0 .5-.5Zm0-6a.501.501 0 0 0-.5-.5h-1a.501.501 0 0 0-.5.5v2a3.942 3.942 0 0 0 .149.977l.399 1.284a.362.362 0 0 0 .324.239h.256a.362.362 0 0 0 .324-.239l.4-1.284A3.942 3.942 0 0 0 27 4.5Z"
        })
    });
var $38e82c133177a81e$export$2e2bcd8739ae039 = $38e82c133177a81e$var$SvgGlyphiconsBasic605UserAlert;




const $c3dbba9019a0a45f$var$SvgGlyphiconsBasic606UserChat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.365 13.374A1.275 1.275 0 0 1 10 11.63V9c0-3 2-5 5.5-5a6.94 6.94 0 0 1 2.5.435V7a4.002 4.002 0 0 0 2 3.463v.037a3.225 3.225 0 0 0 1.647 2.819c-.007.019-.005.036-.012.055l-.28.752a2.991 2.991 0 0 1-1.31 1.462l-.666 3.051A3 3 0 0 1 16.448 21h-1.896a3 3 0 0 1-2.93-2.36l-.666-3.052a2.991 2.991 0 0 1-1.311-1.462Zm16.704 9.498-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365ZM32 2v5a2.003 2.003 0 0 1-2 2h-2.667L24 11.5a1.25 1.25 0 0 1-2-1V9a2.003 2.003 0 0 1-2-2V2a2.003 2.003 0 0 1 2-2h8a2.003 2.003 0 0 1 2 2Zm-2 0h-7.997L22 7h2v2l2.667-2H30Z"
        })
    });
var $c3dbba9019a0a45f$export$2e2bcd8739ae039 = $c3dbba9019a0a45f$var$SvgGlyphiconsBasic606UserChat;




const $f6581f4ab9d25c93$var$SvgGlyphiconsBasic607UserCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24.237V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.763a1.578 1.578 0 0 1 .931-1.365l5.136-2.705A5.024 5.024 0 0 0 14.553 23h1.894a5.023 5.023 0 0 0 4.486-2.833l5.136 2.705A1.578 1.578 0 0 1 27 24.237ZM9.645 14.126a2.991 2.991 0 0 0 1.31 1.462l.666 3.051A3 3 0 0 0 14.552 21h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a2.991 2.991 0 0 0 1.311-1.462l.28-.752a1.712 1.712 0 0 0 .11-.612 7.948 7.948 0 0 1-3.6-8.26A6.791 6.791 0 0 0 15.5 4C12 4 10 6 10 9v2.63a1.275 1.275 0 0 0-.635 1.744ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-2.852-2.234-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.096l-.433.554a.297.297 0 0 0 .027.377l2.233 2.236a.83.83 0 0 0 1.298-.1L29.2 4.118a.254.254 0 0 0-.052-.352Z"
        })
    });
var $f6581f4ab9d25c93$export$2e2bcd8739ae039 = $f6581f4ab9d25c93$var$SvgGlyphiconsBasic607UserCheck;




const $6d16f187a092eb6a$var$SvgGlyphiconsBasic608SquareHospital = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 5H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm-2 17.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V18h-6v4.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V14h6V9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Z"
        })
    });
var $6d16f187a092eb6a$export$2e2bcd8739ae039 = $6d16f187a092eb6a$var$SvgGlyphiconsBasic608SquareHospital;




const $803cad4457b43828$var$SvgGlyphiconsBasic609CircleRedCross = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm8 13.5a.5.5 0 0 1-.5.5H18v5.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V18H8.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H14V8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V14h5.5a.5.5 0 0 1 .5.5Z"
        })
    });
var $803cad4457b43828$export$2e2bcd8739ae039 = $803cad4457b43828$var$SvgGlyphiconsBasic609CircleRedCross;




const $9d3c9e41b820d996$var$SvgGlyphiconsBasic61Compass = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm3.76-14.024-6.114 2.037a1 1 0 0 0-.633.633l-2.037 6.114c-.348 1.043.221 1.612 1.265 1.264l6.113-2.037a1 1 0 0 0 .633-.633l2.037-6.114c.348-1.043-.221-1.612-1.265-1.264Zm-2.7 6.085a1.5 1.5 0 1 1 0-2.122 1.5 1.5 0 0 1 0 2.122Z"
        })
    });
var $9d3c9e41b820d996$export$2e2bcd8739ae039 = $9d3c9e41b820d996$var$SvgGlyphiconsBasic61Compass;




const $5d9d85dfdf99546e$var$SvgGlyphiconsBasic610StarOfLife = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.393 20.268-2 3.464a1 1 0 0 1-1.366.366L19 21.196V27a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5.804l-5.027 2.902a1 1 0 0 1-1.366-.366l-2-3.464a1 1 0 0 1 .366-1.366L10 16l-5.027-2.901a1 1 0 0 1-.366-1.366l2-3.465A1 1 0 0 1 7.974 7.9L13 10.804V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5.804L24.026 7.9a1 1 0 0 1 1.367.367l2 3.465a1 1 0 0 1-.366 1.366L22 16l5.027 2.902a1 1 0 0 1 .366 1.366Z"
        })
    });
var $5d9d85dfdf99546e$export$2e2bcd8739ae039 = $5d9d85dfdf99546e$var$SvgGlyphiconsBasic610StarOfLife;




const $68c7a1f9c8cd8616$var$SvgGlyphiconsBasic611CopyDuplicate = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 15.5V11l5 5h-4.5a.5.5 0 0 1-.5-.5ZM11 10V4.5a.5.5 0 0 0-.5-.5H6a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h7v-9a2.972 2.972 0 0 1 .184-1H12a1 1 0 0 1-1-1Zm10 7v-5.5a.5.5 0 0 0-.5-.5H16a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8.5a.5.5 0 0 0-.5-.5H22a1 1 0 0 1-1-1ZM13 4v4.5a.5.5 0 0 0 .5.5H18Z"
        })
    });
var $68c7a1f9c8cd8616$export$2e2bcd8739ae039 = $68c7a1f9c8cd8616$var$SvgGlyphiconsBasic611CopyDuplicate;




const $6ff588ae609d5835$var$SvgGlyphiconsBasic612Scissors = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7.223 6.828a1.5 1.5 0 0 1 .596-1.784l.667-.428a1 1 0 0 1 1.382.301l4.918 7.143-3.13 4.546-.11-.011Zm20.613 18.66-3.366 2.1a2.503 2.503 0 0 1-3.455-.753L19.235 24l-.187-.29a3.767 3.767 0 0 0 1.121-1.528l1.647-3.721 2.134-.228a3.516 3.516 0 0 1 3.287 1.632l1.352 2.168a2.503 2.503 0 0 1-.753 3.454Zm-2.032-2.706-1.142-1.736a.499.499 0 0 0-.469-.227l-2.406.36a.5.5 0 0 0-.372.767l1.695 2.537a.52.52 0 0 0 .69.21l1.854-1.22a.5.5 0 0 0 .15-.69ZM24.777 6.828 18.34 21.372a2.001 2.001 0 0 1-1.766 1.277l-2.998.089-.81 1.262-1.781 2.835a2.503 2.503 0 0 1-3.455.753l-3.366-2.1a2.503 2.503 0 0 1-.753-3.455l1.352-2.167a3.516 3.516 0 0 1 3.287-1.633l4.577.489 9.505-13.805a1 1 0 0 1 1.382-.301l.667.428a1.5 1.5 0 0 1 .596 1.784Zm-14.564 14.35-2.406-.359a.499.499 0 0 0-.47.227l-1.141 1.736a.5.5 0 0 0 .15.691l1.853 1.22a.52.52 0 0 0 .691-.21l1.695-2.537a.5.5 0 0 0-.372-.768Zm6.604-3.43a1.5 1.5 0 1 0 .452 2.073 1.502 1.502 0 0 0-.452-2.072Z"
        })
    });
var $6ff588ae609d5835$export$2e2bcd8739ae039 = $6ff588ae609d5835$var$SvgGlyphiconsBasic612Scissors;




const $0ae553c05b5f6058$var$SvgGlyphiconsBasic613Paste = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 16H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h7.279A2.978 2.978 0 0 0 15 16Zm0 2H8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H15Zm-7 4.5v1a.5.5 0 0 0 .5.5H15v-2H8.5a.5.5 0 0 0-.5.5ZM17 10h2v3h2v-3a2.003 2.003 0 0 0-2-2h-2V7a1 1 0 0 0-1-1h-1a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2H9a1 1 0 0 0-1 1v1H6a2.003 2.003 0 0 0-2 2v16a2.003 2.003 0 0 0 2 2h9.184A2.972 2.972 0 0 1 15 27v-1H6V10h2v1a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1Zm7.5 9H28l-4-4v3.5a.5.5 0 0 0 .5.5ZM22 20v-5h-4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-6h-5a1 1 0 0 1-1-1Z"
        })
    });
var $0ae553c05b5f6058$export$2e2bcd8739ae039 = $0ae553c05b5f6058$var$SvgGlyphiconsBasic613Paste;




const $3c7fb392aee6ec7c$var$SvgGlyphiconsBasic614Copy = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17 19a1.993 1.993 0 0 0-.277-1H23.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H17Zm6.5 3H17v2h6.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm.5-6.5v-1a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5ZM26 8h-2V7a1 1 0 0 0-1-1h-1a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2h-1a1 1 0 0 0-1 1v1h-2a2.003 2.003 0 0 0-2 2v3a2 2 0 0 1 1.414.586l.586.586V10h2v1a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-1h2l.002 16H17v1a2.972 2.972 0 0 1-.184 1H26a2.003 2.003 0 0 0 2-2V10a2.003 2.003 0 0 0-2-2ZM11 18.5a.5.5 0 0 0 .5.5H15l-4-4ZM9 20v-5H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-6h-5a1 1 0 0 1-1-1Z"
        })
    });
var $3c7fb392aee6ec7c$export$2e2bcd8739ae039 = $3c7fb392aee6ec7c$var$SvgGlyphiconsBasic614Copy;




const $b4980006b7bcc8fa$var$SvgGlyphiconsBasic615BalanceScales = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 26v1a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-1a1 1 0 0 1 1-1h3V8.723a1.996 1.996 0 0 1-.493-.405L7.935 9.633 11.118 16H8.882L7 12.236 5.118 16H2.882l3.01-6.019a.992.992 0 0 1-.088-1.961l8.311-1.663a1.983 1.983 0 0 1 3.378-.675l8.31-1.662a1 1 0 1 1 .393 1.96l-.08.016L29.118 12h-2.236L25 8.236 23.118 12h-2.236l2.753-5.507-5.75 1.15A1.993 1.993 0 0 1 17 8.723V23h3a1 1 0 0 1 1 1v1h1a1 1 0 0 1 1 1Zm6.47-12h-8.94a.508.508 0 0 0-.497.576 5 5 0 0 0 9.934 0A.508.508 0 0 0 29.47 14Zm-17.503 4.576A.508.508 0 0 0 11.47 18H2.53a.508.508 0 0 0-.497.576 5 5 0 0 0 9.934 0Z"
        })
    });
var $b4980006b7bcc8fa$export$2e2bcd8739ae039 = $b4980006b7bcc8fa$var$SvgGlyphiconsBasic615BalanceScales;




const $8c05bb0eff3b4555$var$SvgGlyphiconsBasic616CourtGavel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.814 26.185-.107.108-.87.87-.651.651a.848.848 0 0 1-1.2 0L21.14 23.97l-5.78-7.196-.592-.591-1.56 1.56a.5.5 0 0 1-.708 0L6.257 11.5a.5.5 0 0 1 0-.707l4.536-4.536a.5.5 0 0 1 .707 0l6.243 6.243a.5.5 0 0 1 0 .707l-1.561 1.56.591.592 7.195 5.781 3.846 3.846a.848.848 0 0 1 0 1.2ZM19.541 11.47a.25.25 0 0 0 .353 0l.53-.53a1 1 0 0 0 0-1.415l-5.95-5.95a1 1 0 0 0-1.413 0l-.53.53a.25.25 0 0 0 0 .354ZM4.459 12.53a.25.25 0 0 0-.353 0l-.53.53a1 1 0 0 0 0 1.415l5.95 5.95a1 1 0 0 0 1.413 0l.53-.53a.25.25 0 0 0 0-.354Z"
        })
    });
var $8c05bb0eff3b4555$export$2e2bcd8739ae039 = $8c05bb0eff3b4555$var$SvgGlyphiconsBasic616CourtGavel;




const $b62b5ee839c09c34$var$SvgGlyphiconsBasic617CourtGavelAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.814 24.185-1.628 1.63a.848.848 0 0 1-1.2 0l-4.846-4.846-5.946-7.213-.987.987a.5.5 0 0 1-.707 0L8.257 10.5a.5.5 0 0 1 0-.707l3.536-3.536a.5.5 0 0 1 .707 0l4.243 4.243a.5.5 0 0 1 0 .707l-.987.987 7.212 5.946 4.846 4.846a.848.848 0 0 1 0 1.2Zm-18.289-6.76a1 1 0 0 0 1.414 0l.53-.53a.25.25 0 0 0 0-.354l-5.01-5.01a.25.25 0 0 0-.353 0l-.53.53a1 1 0 0 0 0 1.414Zm9.016-7.955a.25.25 0 0 0 .353 0l.53-.53a1 1 0 0 0 0-1.415l-3.95-3.95a1 1 0 0 0-1.413 0l-.53.53a.25.25 0 0 0 0 .354ZM17 25h-1v-1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $b62b5ee839c09c34$export$2e2bcd8739ae039 = $b62b5ee839c09c34$var$SvgGlyphiconsBasic617CourtGavelAlt;




const $8f5e53e3785e0050$var$SvgGlyphiconsBasic618CircleHospital = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm7 18.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V18h-6v4.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V14h6V9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Z"
        })
    });
var $8f5e53e3785e0050$export$2e2bcd8739ae039 = $8f5e53e3785e0050$var$SvgGlyphiconsBasic618CircleHospital;




const $70f49f5f992d1fb4$var$SvgGlyphiconsBasic619SquareRedCross = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 5H7a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm-1 12.5a.5.5 0 0 1-.5.5H18v5.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V18H8.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H14V8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V14h5.5a.5.5 0 0 1 .5.5Z"
        })
    });
var $70f49f5f992d1fb4$export$2e2bcd8739ae039 = $70f49f5f992d1fb4$var$SvgGlyphiconsBasic619SquareRedCross;




const $dc24c2ed89b035df$var$SvgGlyphiconsBasic62Presentation = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 26.5c0 1.38-2.015 2.5-4.5 2.5S12 27.88 12 26.5c0-1.087 1.256-2.002 3-2.347V19h3v5.153c1.744.345 3 1.26 3 2.347Zm4.174-19.717A1 1 0 0 0 24.198 6H12V4a1.001 1.001 0 0 1 1-1h.277A1.992 1.992 0 0 0 15 4h1a2 2 0 0 0 0-4h-1a1.992 1.992 0 0 0-1.723 1H13a3.003 3.003 0 0 0-3 3v2H8.802a1 1 0 0 0-.976.783L6 15v1a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-1Z"
        })
    });
var $dc24c2ed89b035df$export$2e2bcd8739ae039 = $dc24c2ed89b035df$var$SvgGlyphiconsBasic62Presentation;




const $c55feed84fad455f$var$SvgGlyphiconsBasic620StarOfLifeEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.527 18.036 24 16l3.526-2.036a1 1 0 0 0 .366-1.366l-2.999-5.196a1 1 0 0 0-1.366-.366L20 9.072V5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v4.072L8.473 7.036a1 1 0 0 0-1.366.366l-2.999 5.196a1 1 0 0 0 .366 1.366L8 16l-3.527 2.036a1 1 0 0 0-.366 1.366l3 5.196a1 1 0 0 0 1.366.366L12 22.928V27a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4.072l3.527 2.036a1 1 0 0 0 1.366-.366l3-5.196a1 1 0 0 0-.366-1.366Zm-1.992 1.449-1.75 3.03a.25.25 0 0 1-.341.092l-4.694-2.71a.5.5 0 0 0-.75.433v5.42a.25.25 0 0 1-.25.25h-3.5a.25.25 0 0 1-.25-.25v-5.42a.5.5 0 0 0-.75-.433l-4.694 2.71a.25.25 0 0 1-.341-.092l-1.75-3.03a.25.25 0 0 1 .091-.342l4.694-2.71a.5.5 0 0 0 0-.866l-4.694-2.71a.25.25 0 0 1-.091-.342l1.749-3.03a.25.25 0 0 1 .342-.092l4.694 2.71a.5.5 0 0 0 .75-.433V6.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v5.42a.5.5 0 0 0 .75.434l4.695-2.71a.25.25 0 0 1 .341.09l1.75 3.031a.25.25 0 0 1-.092.342l-4.694 2.71a.5.5 0 0 0 0 .866l4.694 2.71a.25.25 0 0 1 .091.342Z"
        })
    });
var $c55feed84fad455f$export$2e2bcd8739ae039 = $c55feed84fad455f$var$SvgGlyphiconsBasic620StarOfLifeEmpty;




const $28b50e25740028de$var$SvgGlyphiconsBasic621ScalePersonal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 5H9a4 4 0 0 0-4 4v9.769a10 10 0 0 0 .299 2.425l.944 3.776a4 4 0 0 0 3.88 3.03h11.754a4 4 0 0 0 3.88-3.03l.944-3.776A10 10 0 0 0 27 18.77V9a4 4 0 0 0-4-4Zm.262 5.468-2.303 5.56a.99.99 0 0 1-1.217.573 11.955 11.955 0 0 0-7.484 0 .99.99 0 0 1-1.217-.572l-2.303-5.561a.987.987 0 0 1 .568-1.31 19.923 19.923 0 0 1 13.388 0 .987.987 0 0 1 .568 1.31Zm-10.383.637 1.388 3.036a11.909 11.909 0 0 0-1.716.37l-.712-3.05a.553.553 0 0 1 1.04-.356Z"
        })
    });
var $28b50e25740028de$export$2e2bcd8739ae039 = $28b50e25740028de$var$SvgGlyphiconsBasic621ScalePersonal;




const $3c581373a1c6e83b$var$SvgGlyphiconsBasic622ScaleKitchen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.556 25.631-2.25-12A2 2 0 0 0 22.34 12H18v-2h-4v2H9.66a2 2 0 0 0-1.966 1.631l-2.25 12A2 2 0 0 0 7.41 28h17.18a2 2 0 0 0 1.966-2.369ZM16 26a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6ZM7 6V5h19v1a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2Zm9.55 10.498.35 3.507a.905.905 0 1 1-1.8 0l.35-3.507a.552.552 0 0 1 1.1 0Z"
        })
    });
var $3c581373a1c6e83b$export$2e2bcd8739ae039 = $3c581373a1c6e83b$var$SvgGlyphiconsBasic622ScaleKitchen;




const $b2530ccfbf0c00a2$var$SvgGlyphiconsBasic623Fireworks = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.05 11.684a1.002 1.002 0 0 1 1.266-.633l1.633.544A2.998 2.998 0 0 1 25 14.44v1.65a5.58 5.58 0 0 0-2 0v-1.65a1 1 0 0 0-.684-.949l-1.632-.543a1.002 1.002 0 0 1-.633-1.265ZM24 18a3.982 3.982 0 0 0-3 6.62V27a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2.38A3.982 3.982 0 0 0 24 18Zm-7-4h-4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1Zm.684-6.95-1.633.546A2.996 2.996 0 0 0 14 10.44V12h2v-1.559a.998.998 0 0 1 .684-.948l1.632-.544a1 1 0 0 0-.632-1.898ZM4 12.415v3.172L8.586 11H5.414Zm0 9.172 6-6v-3.172l-6 6ZM8.586 23 10 21.586v-3.172L5.414 23ZM7.384 3.46a.5.5 0 0 0-.768 0L2.683 8.18a.5.5 0 0 0 .385.82h7.864a.5.5 0 0 0 .385-.82ZM6 28h2v-3H6Z"
        })
    });
var $b2530ccfbf0c00a2$export$2e2bcd8739ae039 = $b2530ccfbf0c00a2$var$SvgGlyphiconsBasic623Fireworks;




const $0caf94ae7a7410f9$var$SvgGlyphiconsBasic624FireworksAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m11.554 25.4.518 1.932-1.932.518-.518-1.932Zm6.032-2.4L19 21.586v-3.172L14.414 23ZM11 22v-6.395l-.879-3.28a1 1 0 0 0-1.224-.706l-3.864 1.035a1 1 0 0 0-.707 1.225l2.847 10.625 4.18-1.12A2.962 2.962 0 0 1 11 22ZM9.937 8.424 5.52 5.249a.5.5 0 0 0-.748.2l-2.238 4.958a.5.5 0 0 0 .586.689l6.655-1.783a.5.5 0 0 0 .162-.89ZM13 21.586l6-6v-3.172l-6 6ZM15 28h2v-3h-2Zm14.466-17.593L27.228 5.45a.5.5 0 0 0-.748-.2l-4.417 3.175a.5.5 0 0 0 .162.889l6.655 1.783a.5.5 0 0 0 .586-.689ZM13 12.414v3.172L17.586 11h-3.172Zm8 3.191V22a2.962 2.962 0 0 1-.354 1.384l3.215.861a1 1 0 0 0 1.225-.707l2.847-10.625-5.795-1.553Zm-1.072 11.727 1.932.518.518-1.932-1.932-.518ZM19.9 8.2l-3.5-4.667a.5.5 0 0 0-.8 0L12.1 8.2a.5.5 0 0 0 .4.8h7a.5.5 0 0 0 .4-.8Z"
        })
    });
var $0caf94ae7a7410f9$export$2e2bcd8739ae039 = $0caf94ae7a7410f9$var$SvgGlyphiconsBasic624FireworksAlt;




const $5c35ac059b3ab2b6$var$SvgGlyphiconsBasic625Chemistry = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 13.864V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1l-.005 8.87a7.467 7.467 0 0 0-3.994 6.777A7.559 7.559 0 0 0 10.389 28L10.5 28A7.502 7.502 0 0 0 14 13.864ZM5.031 20a5.465 5.465 0 0 1 2.9-4.362A1.97 1.97 0 0 0 9 13.906V6h3v7.906a1.97 1.97 0 0 0 1.07 1.732A5.481 5.481 0 0 1 15.965 20ZM27 4h-6a1 1 0 0 0-1 1v19a3.003 3.003 0 0 0 3 3h2a3.003 3.003 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 6h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H26v2h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H26v2h-4V6h4Z"
        })
    });
var $5c35ac059b3ab2b6$export$2e2bcd8739ae039 = $5c35ac059b3ab2b6$var$SvgGlyphiconsBasic625Chemistry;




const $5e5e5fd60d583afd$var$SvgGlyphiconsBasic626ChemistryAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m25.447 23.658-5.342-10.683a.997.997 0 0 1-.105-.447V5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7.528a.997.997 0 0 1-.105.447L6.553 23.658A3 3 0 0 0 9.236 28h13.528a3 3 0 0 0 2.683-4.342ZM18 21a1 1 0 0 0-2 0h-5.882l3.566-7.13A3.014 3.014 0 0 0 14 12.527V6h4v6.528a3.014 3.014 0 0 0 .316 1.341L21.882 21Zm-1-7a1 1 0 1 1-1-1 1 1 0 0 1 1 1Zm-1 4.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5Z"
        })
    });
var $5e5e5fd60d583afd$export$2e2bcd8739ae039 = $5e5e5fd60d583afd$var$SvgGlyphiconsBasic626ChemistryAlt;




const $7d8560094d6bd92e$var$SvgGlyphiconsBasic627SyringeEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.728 12.736a1 1 0 0 1-1.415 0L24.9 11.322l-1.708 1.707-1.414-1.414 1.707-1.707-1.414-1.414-1.707 1.707-1.414-1.414 1.708-1.707-1.415-1.415a1 1 0 0 1 1.414-1.414l7.07 7.071a1 1 0 0 1 0 1.414Zm-3.122 4.536a1 1 0 1 1-1.414 1.415l-1.414-1.415-7.192 7.193a1 1 0 0 1-1.414 0l-.708-.708-2.121 2.122a1 1 0 0 1-1.414 0l-.707-.707L5.393 28H2.565l4.243-4.243-.707-.707a1 1 0 0 1 0-1.414l2.12-2.121-.706-.707a1 1 0 0 1 0-1.414l7.192-7.193-1.414-1.414a1 1 0 0 1 1.414-1.414ZM11.05 22.343 9.636 20.93l-1.414 1.414 1.414 1.415Zm9.314-6.485-4.243-4.243-6.485 6.486 4.243 4.243 1.025-1.026-1.257-1.257a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0l1.257 1.257 1.586-1.586-1.257-1.257a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0l1.257 1.257Z"
        })
    });
var $7d8560094d6bd92e$export$2e2bcd8739ae039 = $7d8560094d6bd92e$var$SvgGlyphiconsBasic627SyringeEmpty;




const $453fe637b8df9e8c$var$SvgGlyphiconsBasic628Syringe = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.606 17.272a1 1 0 1 1-1.414 1.415l-1.414-1.415-7.192 7.193a1 1 0 0 1-1.414 0l-.708-.708-2.121 2.122a1 1 0 0 1-1.414 0l-.707-.707L5.393 28H2.565l4.243-4.243-.707-.707a1 1 0 0 1 0-1.414l2.12-2.121-.706-.707a1 1 0 0 1 0-1.414l7.192-7.193-1.414-1.414a1 1 0 0 1 1.414-1.414Zm3.122-5.95-7.07-7.071a1 1 0 0 0-1.415 1.414l1.415 1.415-1.708 1.707 1.414 1.414 1.707-1.707 1.414 1.414-1.707 1.707 1.414 1.414 1.708-1.707 1.414 1.414a1 1 0 1 0 1.414-1.414Z"
        })
    });
var $453fe637b8df9e8c$export$2e2bcd8739ae039 = $453fe637b8df9e8c$var$SvgGlyphiconsBasic628Syringe;




const $64439050a9999205$var$SvgGlyphiconsBasic629Heartbeat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.781 11.926c0 4.715-5.856 8.503-10.696 13.698a1.486 1.486 0 0 1-2.17 0c-1.56-1.674-3.214-3.197-4.753-4.657A.947.947 0 0 1 10 21H7a1 1 0 0 1 0-2h3a1 1 0 0 0 .949-.684l.136-.41.986 2.465A1 1 0 0 0 13 21h.039a1 1 0 0 0 .916-.702l1.576-5.044 1.02 3.062A1 1 0 0 0 17.5 19h2.038a1 1 0 0 0 0-2h-1.317l-1.772-5.316a1 1 0 0 0-1.904.018l-1.66 5.316-.956-2.39a1 1 0 0 0-1.878.056L9.28 17H6.36a8.28 8.28 0 0 1-2.14-5.074c0-5.531 7.54-9.489 11.577-3.822a.255.255 0 0 0 .415.005c4.266-5.674 11.57-1.716 11.57 3.817Z"
        })
    });
var $64439050a9999205$export$2e2bcd8739ae039 = $64439050a9999205$var$SvgGlyphiconsBasic629Heartbeat;




const $b51074dfebfe5b6e$var$SvgGlyphiconsBasic63Paperclip = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m25.9 19.828-6.425 6.425a8.51 8.51 0 0 1-12.02 0l-.708-.707a8.501 8.501 0 0 1 0-12.022l7.74-7.739a6.652 6.652 0 0 1 8.708-.726 6.508 6.508 0 0 1 .644 9.759l-7.9 7.9a3.5 3.5 0 0 1-4.95 0l-.618-.62a3.656 3.656 0 0 1-1.053-1.91 3.502 3.502 0 0 1 .965-3.127L16 11.343a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414l-5.717 5.718a.506.506 0 0 0 0 .707l.707.707a.507.507 0 0 0 .707 0l7.831-7.83a3.561 3.561 0 0 0 .535-4.447 3.507 3.507 0 0 0-5.416-.572l-7.9 7.9a5.5 5.5 0 0 0 0 7.778l.707.707a5.5 5.5 0 0 0 7.778 0l6.425-6.425a1 1 0 0 1 1.414 0l.707.707a1 1 0 0 1 0 1.414Z"
        })
    });
var $b51074dfebfe5b6e$export$2e2bcd8739ae039 = $b51074dfebfe5b6e$var$SvgGlyphiconsBasic63Paperclip;




const $4dec784e1e762b6a$var$SvgGlyphiconsBasic630HeartBroken = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m15.084 20.21-1.928 3.617c-4.392-4.311-8.937-7.747-8.937-11.901 0-4.999 6.156-8.706 10.322-5.192l-1.956 2.57a1.15 1.15 0 0 0 .102 1.51L15.874 14l-2.688 2.687a1.15 1.15 0 0 0 0 1.627Zm2.189-13.267-2.25 2.954 3.29 3.29a1.15 1.15 0 0 1 0 1.627L15.626 17.5l1.688 1.687a1.15 1.15 0 0 1 .2 1.354l-2.67 5.008.07.075a1.487 1.487 0 0 0 2.171 0c4.84-5.196 10.696-8.983 10.696-13.698 0-5.096-6.197-8.857-10.508-4.983Z"
        })
    });
var $4dec784e1e762b6a$export$2e2bcd8739ae039 = $4dec784e1e762b6a$var$SvgGlyphiconsBasic630HeartBroken;




const $63a93657d7806e43$var$SvgGlyphiconsBasic631CirclePlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm6 13a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1Z"
        })
    });
var $63a93657d7806e43$export$2e2bcd8739ae039 = $63a93657d7806e43$var$SvgGlyphiconsBasic631CirclePlus;




const $3722f276aca67af4$var$SvgGlyphiconsBasic632CircleMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm6 13a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z"
        })
    });
var $3722f276aca67af4$export$2e2bcd8739ae039 = $3722f276aca67af4$var$SvgGlyphiconsBasic632CircleMinus;




const $a91a47abd167f77c$var$SvgGlyphiconsBasic633CircleRemove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm5.303 14.475a.5.5 0 0 1 0 .707l-2.121 2.121a.5.5 0 0 1-.707 0L16 18.828l-2.475 2.475a.5.5 0 0 1-.707 0l-2.121-2.121a.5.5 0 0 1 0-.707L13.172 16l-2.475-2.475a.5.5 0 0 1 0-.707l2.121-2.121a.5.5 0 0 1 .707 0L16 13.172l2.475-2.475a.5.5 0 0 1 .707 0l2.121 2.121a.5.5 0 0 1 0 .707L18.828 16Z"
        })
    });
var $a91a47abd167f77c$export$2e2bcd8739ae039 = $a91a47abd167f77c$var$SvgGlyphiconsBasic633CircleRemove;




const $024b4e8eb0e70117$var$SvgGlyphiconsBasic634CircleCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm6.57 8.4-7.292 8.628a1 1 0 0 1-1.507.025l-3.89-4.312a.5.5 0 0 1 .007-.677l1.137-1.215a.5.5 0 0 1 .633-.08l2.611 1.662 6.573-5.695a.5.5 0 0 1 .671.015l1.019.964a.5.5 0 0 1 .038.686Z"
        })
    });
var $024b4e8eb0e70117$export$2e2bcd8739ae039 = $024b4e8eb0e70117$var$SvgGlyphiconsBasic634CircleCheck;




const $c03908b1723299ee$var$SvgGlyphiconsBasic635CircleQuestion = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm2 18a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm2.75-8.886c0 1.38-.867 2.082-1.956 2.825a3.518 3.518 0 0 0-1.473 1.721.491.491 0 0 1-.472.34h-2.062a.502.502 0 0 1-.494-.58 3.269 3.269 0 0 1 .66-1.601 10.469 10.469 0 0 1 2.327-1.857 1.016 1.016 0 0 0 .47-.848V13a1.001 1.001 0 0 0-1-1h-1.5a1 1 0 0 0-1 1 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1 4 4 0 0 1 4-4h1.5c2.283 0 4 1.164 4 4Z"
        })
    });
var $c03908b1723299ee$export$2e2bcd8739ae039 = $c03908b1723299ee$var$SvgGlyphiconsBasic635CircleQuestion;




const $a5ddbfde1160a7cd$var$SvgGlyphiconsBasic636CircleInfo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm2.425 10.916L16.6 21h1.26a.5.5 0 0 1 .485.621l-.25 1a.5.5 0 0 1-.485.379H14a1.408 1.408 0 0 1-1.425-1.916L14.4 15h-.76a.5.5 0 0 1-.485-.621l.25-1A.5.5 0 0 1 13.89 13H17a1.408 1.408 0 0 1 1.425 1.916Zm.145-3.334a.5.5 0 0 1-.494.418H15.59a.5.5 0 0 1-.493-.582l.333-2A.5.5 0 0 1 15.924 9h2.486a.5.5 0 0 1 .493.582Z"
        })
    });
var $a5ddbfde1160a7cd$export$2e2bcd8739ae039 = $a5ddbfde1160a7cd$var$SvgGlyphiconsBasic636CircleInfo;




const $36e1e23e2ac210cd$var$SvgGlyphiconsBasic637CircleAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm2 18a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm0-9-.92 4.598a.5.5 0 0 1-.49.402h-1.18a.5.5 0 0 1-.491-.402L14 13v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Z"
        })
    });
var $36e1e23e2ac210cd$export$2e2bcd8739ae039 = $36e1e23e2ac210cd$var$SvgGlyphiconsBasic637CircleAlert;




const $53545763b8d91b7c$var$SvgGlyphiconsBasic638TriangleAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m29.304 25.759-12-21.12a1.5 1.5 0 0 0-2.608 0l-12 21.12A1.5 1.5 0 0 0 4 28h24a1.5 1.5 0 0 0 1.304-2.241ZM18 24a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm0-9-.628 3.586a.5.5 0 0 1-.492.414h-1.76a.5.5 0 0 1-.492-.414L14 15v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Z"
        })
    });
var $53545763b8d91b7c$export$2e2bcd8739ae039 = $53545763b8d91b7c$var$SvgGlyphiconsBasic638TriangleAlert;




const $9d66e0b8b5e8afea$var$SvgGlyphiconsBasic639OctagonRemoveEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.414 10.443-5.858-5.857A2 2 0 0 0 20.142 4h-8.284a2 2 0 0 0-1.414.586l-5.858 5.857A2 2 0 0 0 4 11.858v8.284a2 2 0 0 0 .586 1.414l5.858 5.858a2 2 0 0 0 1.414.586h8.284a2 2 0 0 0 1.414-.586l5.858-5.858A2 2 0 0 0 28 20.142v-8.284a2 2 0 0 0-.586-1.415ZM25 19.728 19.728 25h-7.456L7 19.728v-7.456L12.272 7h7.456L25 12.272Zm-5.818-9.031 2.121 2.121a.5.5 0 0 1 0 .707L18.828 16l2.475 2.475a.5.5 0 0 1 0 .707l-2.121 2.121a.5.5 0 0 1-.707 0L16 18.828l-2.475 2.475a.5.5 0 0 1-.707 0l-2.121-2.121a.5.5 0 0 1 0-.707L13.172 16l-2.475-2.475a.5.5 0 0 1 0-.707l2.121-2.121a.5.5 0 0 1 .707 0L16 13.172l2.475-2.475a.5.5 0 0 1 .707 0Z"
        })
    });
var $9d66e0b8b5e8afea$export$2e2bcd8739ae039 = $9d66e0b8b5e8afea$var$SvgGlyphiconsBasic639OctagonRemoveEmpty;




const $12b95a45734418b3$var$SvgGlyphiconsBasic64Power = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 16V4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1Zm7.64-9.215a1.009 1.009 0 0 0-1.438.394l-.453.897a.989.989 0 0 0 .342 1.28 8.503 8.503 0 1 1-9.186.002.991.991 0 0 0 .346-1.282l-.453-.897a1.012 1.012 0 0 0-1.446-.389 11.44 11.44 0 0 0-5.346 10.1A11.5 11.5 0 0 0 28 16.5a11.435 11.435 0 0 0-5.36-9.715Z"
        })
    });
var $12b95a45734418b3$export$2e2bcd8739ae039 = $12b95a45734418b3$var$SvgGlyphiconsBasic64Power;




const $3fa19e098711c8aa$var$SvgGlyphiconsBasic640OctagonRemove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.414 10.443-5.858-5.857A2 2 0 0 0 20.142 4h-8.284a2 2 0 0 0-1.414.586l-5.858 5.857A2 2 0 0 0 4 11.858v8.284a2 2 0 0 0 .586 1.414l5.858 5.858a2 2 0 0 0 1.414.586h8.284a2 2 0 0 0 1.414-.586l5.858-5.858A2 2 0 0 0 28 20.142v-8.284a2 2 0 0 0-.586-1.415Zm-6.11 8.032a.5.5 0 0 1 0 .707l-2.122 2.121a.5.5 0 0 1-.707 0L16 18.83l-2.475 2.474a.5.5 0 0 1-.707 0l-2.121-2.12a.5.5 0 0 1 0-.708L13.172 16l-2.475-2.475a.5.5 0 0 1 0-.707l2.121-2.121a.5.5 0 0 1 .707 0L16 13.17l2.475-2.474a.5.5 0 0 1 .707 0l2.121 2.12a.5.5 0 0 1 0 .708L18.828 16Z"
        })
    });
var $3fa19e098711c8aa$export$2e2bcd8739ae039 = $3fa19e098711c8aa$var$SvgGlyphiconsBasic640OctagonRemove;




const $2488876c7785efc7$var$SvgGlyphiconsBasic641TriangleRadioactive = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m29.304 25.759-12-21.12a1.5 1.5 0 0 0-2.608 0l-12 21.12A1.5 1.5 0 0 0 4 28h24a1.5 1.5 0 0 0 1.304-2.241ZM16 18a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm-6 1a6.012 6.012 0 0 1 3.002-5.192l1.505 2.606A2.99 2.99 0 0 0 13 19Zm6 6a5.965 5.965 0 0 1-2.998-.808l1.505-2.606a2.903 2.903 0 0 0 2.986 0l1.505 2.606A5.965 5.965 0 0 1 16 25Zm3-6a2.99 2.99 0 0 0-1.507-2.586l1.505-2.606A6.012 6.012 0 0 1 22 19Z"
        })
    });
var $2488876c7785efc7$export$2e2bcd8739ae039 = $2488876c7785efc7$var$SvgGlyphiconsBasic641TriangleRadioactive;




const $4cc324a84660cf0a$var$SvgGlyphiconsBasic642Radioactive = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 15H4.517a.505.505 0 0 1-.506-.519 12.03 12.03 0 0 1 5.55-9.595.504.504 0 0 1 .702.177l3.746 6.488A3.986 3.986 0 0 0 12 15Zm14.384-5.996a12.043 12.043 0 0 0-3.944-4.118.504.504 0 0 0-.703.177l-3.746 6.488A3.986 3.986 0 0 1 20 15h7.483a.505.505 0 0 0 .506-.519 11.936 11.936 0 0 0-1.605-5.477Zm-8.393 9.445a3.87 3.87 0 0 1-3.982 0L10.26 24.94a.5.5 0 0 0 .195.692 11.925 11.925 0 0 0 11.088 0 .5.5 0 0 0 .195-.692l-3.748-6.492ZM16 17a2 2 0 1 0-2-2 2 2 0 0 0 2 2Z"
        })
    });
var $4cc324a84660cf0a$export$2e2bcd8739ae039 = $4cc324a84660cf0a$var$SvgGlyphiconsBasic642Radioactive;




const $f3a25751c5764c60$var$SvgGlyphiconsBasic643Compound = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.667 19.89-1.574-1.575 1.195-4.462a.999.999 0 0 0-.259-.965L23.764 9.62l.592-2.214a1 1 0 0 0-1.931-.517l-.593 2.214-3.904 1.045-2.858-2.857.449-1.673a1 1 0 0 0-1.932-.517l-.448 1.672L8.677 7.97a1.002 1.002 0 0 0-.707.707l-1.196 4.462-1.672.448a1 1 0 0 0 .517 1.932l1.673-.449 2.857 2.858-1.046 3.904-1.672.448a1 1 0 1 0 .517 1.932l1.673-.448 3.267 3.265a1.003 1.003 0 0 0 .707.293.982.982 0 0 0 .258-.034l4.462-1.195 1.575 1.574a1 1 0 0 0 1.414-1.414l-1.576-1.574 1.046-3.905 3.905-1.045 1.574 1.575a1 1 0 0 0 1.414-1.414ZM8.706 13.656l1.046-3.904 3.904-1.046 2.858 2.858-1.046 3.904-1.952.523-1.952.522Zm9.614 8.553-.523 1.952-3.903 1.046-2.859-2.857 1.046-3.905 3.904-1.046 2.858 2.858Zm5.841-4.412-3.904 1.046-2.858-2.858.523-1.952.523-1.952 3.905-1.046 2.857 2.859Z"
        })
    });
var $f3a25751c5764c60$export$2e2bcd8739ae039 = $f3a25751c5764c60$var$SvgGlyphiconsBasic643Compound;




const $a4b7568cd06f3fd7$var$SvgGlyphiconsBasic644Dna = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5v.862a10.98 10.98 0 0 1-3.896 8.398l-.508.43-1.548-1.31.766-.648A8.981 8.981 0 0 0 22 5.862V5a1 1 0 0 1 2 0Zm-9.813 14.268.765-.648-1.548-1.31-.508.43A10.98 10.98 0 0 0 9 26.138V27a1 1 0 0 0 2 0v-.862a8.981 8.981 0 0 1 3.187-6.87Zm5.918-1.528-5.918-5.008a9.035 9.035 0 0 1-.765-.732h3.16l.94-.794A7.007 7.007 0 0 0 18.64 10h-6.62a8.959 8.959 0 0 1-.755-2h8.396a7 7 0 0 0 .331-2h-8.985c0-.046-.007-.091-.007-.138V5a1 1 0 0 0-2 0v.862a10.98 10.98 0 0 0 3.896 8.398l5.918 5.008a9.035 9.035 0 0 1 .764.732h-3.16l-.94.794A7.007 7.007 0 0 0 14.36 22h6.62a8.959 8.959 0 0 1 .755 2h-8.396a7 7 0 0 0-.331 2h8.985c0 .046.007.091.007.138V27a1 1 0 0 0 2 0v-.862a10.98 10.98 0 0 0-3.896-8.398Z"
        })
    });
var $a4b7568cd06f3fd7$export$2e2bcd8739ae039 = $a4b7568cd06f3fd7$var$SvgGlyphiconsBasic644Dna;




const $944e141f6dbfd80f$var$SvgGlyphiconsBasic645Biohazard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.337 14.597a7.278 7.278 0 0 0-4.629-.892A7.17 7.17 0 0 0 23.25 9.25a7.285 7.285 0 0 0-4.181-6.562.75.75 0 0 0-1.069.68v.103a.75.75 0 0 0 .391.658 5 5 0 1 1-4.782 0A.75.75 0 0 0 14 3.471v-.103a.75.75 0 0 0-1.069-.68A7.285 7.285 0 0 0 8.75 9.25a7.17 7.17 0 0 0 1.542 4.455 7.227 7.227 0 0 0-8.22 7.793.75.75 0 0 0 1.123.585l.09-.051a.75.75 0 0 0 .373-.668 4.998 4.998 0 1 1 7.494 4.208 4.873 4.873 0 0 1-2.49.669 5.049 5.049 0 0 1-2.614-.736.75.75 0 0 0-.764-.009l-.09.051a.75.75 0 0 0-.051 1.266 7.409 7.409 0 0 0 7.77.341A7.171 7.171 0 0 0 16 23.592a7.214 7.214 0 0 0 6.692 4.53 7.38 7.38 0 0 0 4.165-1.309.75.75 0 0 0-.052-1.266l-.089-.05a.751.751 0 0 0-.764.008 4.99 4.99 0 0 1-5.104.067 5 5 0 0 1-1.83-6.83 4.997 4.997 0 0 1 9.324 2.622.75.75 0 0 0 .374.668l.09.052a.75.75 0 0 0 1.123-.586 7.284 7.284 0 0 0-3.592-6.901ZM16 18a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm-3.383-7.124a6.97 6.97 0 0 1 6.766 0 4.153 4.153 0 0 1-1.736 1.425 4.654 4.654 0 0 0-3.294 0 4.153 4.153 0 0 1-1.736-1.425Zm6.63 9.895a4.974 4.974 0 0 0 1.66-2.856 4.15 4.15 0 0 1 2.086-.782 6.994 6.994 0 0 1-3.383 5.853 4.152 4.152 0 0 1-.364-2.215Zm-6.857 2.215a6.994 6.994 0 0 1-3.383-5.853 4.15 4.15 0 0 1 2.086.782 4.974 4.974 0 0 0 1.66 2.856 4.152 4.152 0 0 1-.363 2.215Z"
        })
    });
var $944e141f6dbfd80f$export$2e2bcd8739ae039 = $944e141f6dbfd80f$var$SvgGlyphiconsBasic645Biohazard;




const $f9af44ac3cc8fded$var$SvgGlyphiconsBasic646CirclePlay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm4.16 12.822-5.665 3.226a1 1 0 0 1-1.495-.87v-6.451a1 1 0 0 1 1.495-.87l5.665 3.227a1 1 0 0 1 0 1.738Z"
        })
    });
var $f9af44ac3cc8fded$export$2e2bcd8739ae039 = $f9af44ac3cc8fded$var$SvgGlyphiconsBasic646CirclePlay;




const $4cd7a6b411feb638$var$SvgGlyphiconsBasic647CircleDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm4.81 12.57-3.989 5.746a1 1 0 0 1-1.643 0L11.19 16.57A1 1 0 0 1 12.01 15H14v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4h1.989a1 1 0 0 1 .821 1.57Z"
        })
    });
var $4cd7a6b411feb638$export$2e2bcd8739ae039 = $4cd7a6b411feb638$var$SvgGlyphiconsBasic647CircleDown;




const $f490ec4b6336f441$var$SvgGlyphiconsBasic648CircleUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm3.989 13H18v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4h-1.989a1 1 0 0 1-.821-1.57l3.989-5.747a1 1 0 0 1 1.643 0l3.988 5.747A1 1 0 0 1 19.99 17Z"
        })
    });
var $f490ec4b6336f441$export$2e2bcd8739ae039 = $f490ec4b6336f441$var$SvgGlyphiconsBasic648CircleUp;




const $5d2fb940c0c73727$var$SvgGlyphiconsBasic649CircleLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm6 13a1 1 0 0 1-1 1h-4v1.989a1 1 0 0 1-1.57.821l-5.746-3.988a1 1 0 0 1 0-1.644l5.746-3.988a1 1 0 0 1 1.57.821V14h4a1 1 0 0 1 1 1Z"
        })
    });
var $5d2fb940c0c73727$export$2e2bcd8739ae039 = $5d2fb940c0c73727$var$SvgGlyphiconsBasic649CircleLeft;




const $64d3fd73e1eff99d$var$SvgGlyphiconsBasic65Lightbulb = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 3.5C10.299 3.5 6 7.584 6 13a9.915 9.915 0 0 0 2.578 6.575C9.486 20.751 10 21.467 10 22.5v2a2.497 2.497 0 0 0 1.635 2.336l.614 1.535a1 1 0 0 0 .928.629h5.646a1 1 0 0 0 .928-.629l.614-1.535A2.497 2.497 0 0 0 22 24.5v-2c0-1.033.514-1.749 1.422-2.925A9.915 9.915 0 0 0 26 13c0-5.416-4.299-9.5-10-9.5Zm5.047 14.242A7.95 7.95 0 0 0 19.032 22h-6.064a7.95 7.95 0 0 0-2.015-4.258A7.09 7.09 0 0 1 9 13c0-3.706 3.01-6.5 7-6.5s7 2.794 7 6.5a7.09 7.09 0 0 1-1.953 4.742Z"
        })
    });
var $64d3fd73e1eff99d$export$2e2bcd8739ae039 = $64d3fd73e1eff99d$var$SvgGlyphiconsBasic65Lightbulb;




const $997977e4a5966eac$var$SvgGlyphiconsBasic650CircleRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm6.316 12.822L16.57 20.81A1 1 0 0 1 15 19.99V18h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4v-1.989a1 1 0 0 1 1.57-.821l5.746 3.988a1 1 0 0 1 0 1.644Z"
        })
    });
var $997977e4a5966eac$export$2e2bcd8739ae039 = $997977e4a5966eac$var$SvgGlyphiconsBasic650CircleRight;




const $045833b76db3d8d4$var$SvgGlyphiconsBasic651King = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 26v2H5v-2a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2ZM10.707 15.707a1 1 0 0 1 .293.707V18.5a1 1 0 0 1-.4.8l-2.4 1.8a.5.5 0 0 0 .3.9h14a.5.5 0 0 0 .3-.9l-2.4-1.8a1 1 0 0 1-.4-.8v-2.086a1 1 0 0 1 .293-.707l3-3A1 1 0 0 0 22.586 11H8.414a1 1 0 0 0-.707 1.707ZM13 7h1v2h3V7h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Z"
        })
    });
var $045833b76db3d8d4$export$2e2bcd8739ae039 = $045833b76db3d8d4$var$SvgGlyphiconsBasic651King;




const $5faa6b3006db6e5a$var$SvgGlyphiconsBasic652Queen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8.734 8.28A2 2 0 0 1 10.27 5h3.507a1.98 1.98 0 0 1-.277-1 2 2 0 0 1 4 0 1.98 1.98 0 0 1-.277 1h3.507a2 2 0 0 1 1.536 3.28l-.6.72H9.334Zm1.973 7.427a1 1 0 0 1 .293.707V18.5a1 1 0 0 1-.4.8l-2.4 1.8a.5.5 0 0 0 .3.9h14a.5.5 0 0 0 .3-.9l-2.4-1.8a1 1 0 0 1-.4-.8v-2.086a1 1 0 0 1 .293-.707l3-3A1 1 0 0 0 22.586 11H8.414a1 1 0 0 0-.707 1.707ZM24 24H7a2 2 0 0 0-2 2v2h21v-2a2 2 0 0 0-2-2Z"
        })
    });
var $5faa6b3006db6e5a$export$2e2bcd8739ae039 = $5faa6b3006db6e5a$var$SvgGlyphiconsBasic652Queen;




const $d203daf1caa1167e$var$SvgGlyphiconsBasic653Rook = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8 9V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v2h2V5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2h2V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Zm16 15H7a2 2 0 0 0-2 2v2h21v-2a2 2 0 0 0-2-2ZM8.5 22h14a.5.5 0 0 0 .3-.9l-2.4-1.8a1 1 0 0 1-.4-.8v-3.138a1 1 0 0 1 .232-.64l1.585-1.902a.5.5 0 0 0-.385-.82H9.568a.5.5 0 0 0-.385.82l1.585 1.902a1 1 0 0 1 .232.64V18.5a1 1 0 0 1-.4.8l-2.4 1.8a.5.5 0 0 0 .3.9Z"
        })
    });
var $d203daf1caa1167e$export$2e2bcd8739ae039 = $d203daf1caa1167e$var$SvgGlyphiconsBasic653Rook;




const $972165ba5755125c$var$SvgGlyphiconsBasic654Bishop = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11.092 14a1.486 1.486 0 0 1-.092-.5v-1a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.5 1.5v1a1.486 1.486 0 0 1-.092.5Zm7.87-5A4.806 4.806 0 0 0 19 8.5C19 6.015 17 3 15.5 3S12 6.015 12 8.5a4.806 4.806 0 0 0 .038.5ZM24 24H7a2 2 0 0 0-2 2v2h21v-2a2 2 0 0 0-2-2ZM8.207 22h14.586a.5.5 0 0 0 .353-.854l-4.853-4.853a.994.994 0 0 1-.196-.293h-5.194a.994.994 0 0 1-.196.293l-4.853 4.853a.5.5 0 0 0 .353.854Z"
        })
    });
var $972165ba5755125c$export$2e2bcd8739ae039 = $972165ba5755125c$var$SvgGlyphiconsBasic654Bishop;




const $eec0c95271ef36a4$var$SvgGlyphiconsBasic655Knight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 26v2H5v-2a2 2 0 0 1 2-2h17a2 2 0 0 1 2 2ZM9.939 22H22c0-4-5.578-5.678-5.962-10.384l6.103-.872a1 1 0 0 0 .859-.99v-1.44a1 1 0 0 0-.65-.936L16 5V3.038a8.799 8.799 0 0 0-7.947 8.575C8.053 17 10 18 10 21c0 .355-.032.676-.061 1Z"
        })
    });
var $eec0c95271ef36a4$export$2e2bcd8739ae039 = $eec0c95271ef36a4$var$SvgGlyphiconsBasic655Knight;




const $7a2d3a5a823c11d6$var$SvgGlyphiconsBasic656Pawn = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m7.854 21.146 4.853-4.853a1 1 0 0 0 .293-.707V13a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2.586a1 1 0 0 0 .293.707l4.853 4.853a.5.5 0 0 1-.353.854H8.207a.5.5 0 0 1-.353-.854ZM24 24H7a2 2 0 0 0-2 2v2h21v-2a2 2 0 0 0-2-2Zm-6.056-14a3.5 3.5 0 1 0-4.888 0Z"
        })
    });
var $7a2d3a5a823c11d6$export$2e2bcd8739ae039 = $7a2d3a5a823c11d6$var$SvgGlyphiconsBasic656Pawn;




const $03eee656541254fd$var$SvgGlyphiconsBasic657Door = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m25.083 4.924-10-.834a.99.99 0 0 0-1.065.91H14v21h.018a.99.99 0 0 0 1.065.91l10-.834A1 1 0 0 0 26 25.08V5.92a1 1 0 0 0-.917-.996ZM17 17a1 1 0 1 1 1-1 1 1 0 0 1-1 1ZM8 5h4v2H8v17h4v2H8a2.003 2.003 0 0 1-2-2V7a2.003 2.003 0 0 1 2-2Z"
        })
    });
var $03eee656541254fd$export$2e2bcd8739ae039 = $03eee656541254fd$var$SvgGlyphiconsBasic657Door;




const $fe456fc80859887f$var$SvgGlyphiconsBasic658Bicycle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.986 14a5.965 5.965 0 0 0-2.286.455l-1.607-2.571 1.202-3.209.283.077a.85.85 0 0 0 1.063-.68l.18-1.082a.85.85 0 0 0-.839-.99h-4.145a.85.85 0 0 0-.224 1.67l1.744.477L20.29 11h-8.966l.603-1.658a1 1 0 0 0-.776-1.328l-3-.5a1 1 0 0 0-.328 1.972l1.814.303-1.569 4.314a6.008 6.008 0 1 0 1.879.684l.379-1.042 6.954 6.962c.006.005.013.007.019.012a.994.994 0 0 0 .285.19c.023.01.045.017.069.026a.988.988 0 0 0 .334.065h2.09a5.997 5.997 0 1 0 5.91-7Zm-15 6a4 4 0 1 1-4-4c.13 0 .251.026.377.038l-1.316 3.62a1 1 0 1 0 1.879.684l1.322-3.636A3.996 3.996 0 0 1 10.986 20Zm6.609-1.807L12.407 13h7.133Zm2.482.807h-.648l1.781-4.756.798 1.277A5.987 5.987 0 0 0 20.077 19Zm3.014-1.745L24.181 19h-2.053a3.986 3.986 0 0 1 .963-1.745ZM25.986 24a3.996 3.996 0 0 1-3.858-3h3.858a1 1 0 0 0 .848-1.53l-2.042-3.268A3.948 3.948 0 0 1 25.986 16a4 4 0 0 1 0 8Z"
        })
    });
var $fe456fc80859887f$export$2e2bcd8739ae039 = $fe456fc80859887f$var$SvgGlyphiconsBasic658Bicycle;




const $c43b3cd50b87f384$var$SvgGlyphiconsBasic659Id = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.895 18.233 6 18.215v2.01c-.035.002-.07.01-.105.01a2.003 2.003 0 0 1-1.97-1.654L2.364 9.718A2.001 2.001 0 0 1 3.985 7.4l14.772-2.604a1.996 1.996 0 0 1 2.317 1.622L21.706 10h-2.03l-.57-3.233L4.333 9.37ZM27 14v9a2.003 2.003 0 0 1-2 2H10a2.003 2.003 0 0 1-2-2v-9a2.003 2.003 0 0 1 2-2h15a2.003 2.003 0 0 1 2 2Zm-12 4.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Z"
        })
    });
var $c43b3cd50b87f384$export$2e2bcd8739ae039 = $c43b3cd50b87f384$var$SvgGlyphiconsBasic659Id;




const $796d9287548d34b1$var$SvgGlyphiconsBasic66Tag = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.042 17.142 15.192 5.293A1 1 0 0 0 14.485 5H6a1 1 0 0 0-1 1v8.485a1 1 0 0 0 .293.707l11.85 11.85a1 1 0 0 0 1.413 0l8.486-8.486a1 1 0 0 0 0-1.414ZM11 13a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $796d9287548d34b1$export$2e2bcd8739ae039 = $796d9287548d34b1$var$SvgGlyphiconsBasic66Tag;




const $234d41b2f941af78$var$SvgGlyphiconsBasic660Payment = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 20a5.997 5.997 0 0 1-5-2.69V24a2.003 2.003 0 0 0 2 2h18a2.003 2.003 0 0 0 2-2v-8H15.65A6.005 6.005 0 0 1 10 20Zm9 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5Zm8-9.5v1H15.65a6.024 6.024 0 0 0-2.34-3H25a2.003 2.003 0 0 1 2 2ZM4.097 12.96a3.49 3.49 0 1 1 3.715-4.541 6.011 6.011 0 0 0-3.715 4.54ZM10 10a4 4 0 1 1-4 4 4 4 0 0 1 4-4Z"
        })
    });
var $234d41b2f941af78$export$2e2bcd8739ae039 = $234d41b2f941af78$var$SvgGlyphiconsBasic660Payment;




const $fde500b33c576d29$var$SvgGlyphiconsBasic661LegalSectionSign = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.992 23.29A4.39 4.39 0 0 1 16.638 28H12a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h2.582A1.41 1.41 0 0 0 18 23.609a1.384 1.384 0 0 0-.931-1.338l-4.921-1.64a4.512 4.512 0 0 1-3.094-3.502 4.337 4.337 0 0 1 1.772-4.229 6.357 6.357 0 0 0 2.524 1.573l.686.228-1.18.472a1.362 1.362 0 0 0 .075 2.556l4.964 1.655a4.463 4.463 0 0 1 3.097 3.907Zm1.954-8.419a4.512 4.512 0 0 0-3.094-3.501l-4.92-1.64A1.384 1.384 0 0 1 14 8.39 1.41 1.41 0 0 1 15.418 7H18v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4.638a4.39 4.39 0 0 0-4.354 4.71 4.463 4.463 0 0 0 3.097 3.906l4.964 1.655a1.362 1.362 0 0 1 .075 2.556l-1.18.472.686.228a6.357 6.357 0 0 1 2.524 1.573 4.337 4.337 0 0 0 1.772-4.229Z"
        })
    });
var $fde500b33c576d29$export$2e2bcd8739ae039 = $fde500b33c576d29$var$SvgGlyphiconsBasic661LegalSectionSign;




const $bd0853ca36dd2bf5$var$SvgGlyphiconsBasic662Voicemail = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 10a5.99 5.99 0 0 0-5.188 9h-3.624A5.995 5.995 0 1 0 9 22h14a6 6 0 0 0 0-12ZM9 19a3 3 0 1 1 3-3 3.003 3.003 0 0 1-3 3Zm14 0a3 3 0 1 1 3-3 3.003 3.003 0 0 1-3 3Z"
        })
    });
var $bd0853ca36dd2bf5$export$2e2bcd8739ae039 = $bd0853ca36dd2bf5$var$SvgGlyphiconsBasic662Voicemail;




const $632ddb58b74e71eb$var$SvgGlyphiconsBasic663EqualizerDots = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 16v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm-1-6h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0 10h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0 5h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-6-5H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm6-15h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM8 25H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm12 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm6-10h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-5h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0 10h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-6 0h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-5h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm6 10h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $632ddb58b74e71eb$export$2e2bcd8739ae039 = $632ddb58b74e71eb$var$SvgGlyphiconsBasic663EqualizerDots;




const $3360716cb4b84e97$var$SvgGlyphiconsBasic664EqualizerBars = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 15v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm4-8h-1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm5 4h-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Zm5-7h-1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm5 10h-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
    });
var $3360716cb4b84e97$export$2e2bcd8739ae039 = $3360716cb4b84e97$var$SvgGlyphiconsBasic664EqualizerBars;




const $3ae45e82dec6c03a$var$SvgGlyphiconsBasic665Taxi = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.165 15.383-1.49-6.46A3.962 3.962 0 0 0 22 6h-2.6l-.24-1.196A1 1 0 0 0 18.18 4h-4.36a1 1 0 0 0-.98.804L12.6 6H10a3.962 3.962 0 0 0-3.675 2.923l-1.49 6.46A1.997 1.997 0 0 0 4 17v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2h16v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V17a1.997 1.997 0 0 0-.835-1.617ZM8.274 9.373A1.967 1.967 0 0 1 10 8h12a1.967 1.967 0 0 1 1.726 1.373L24.794 14H7.206ZM10 19.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm16 0a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Z"
        })
    });
var $3ae45e82dec6c03a$export$2e2bcd8739ae039 = $3ae45e82dec6c03a$var$SvgGlyphiconsBasic665Taxi;




const $beed7be8805a7475$var$SvgGlyphiconsBasic666TransportMixed = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m29.816 16.18-1.141-4.257A3.962 3.962 0 0 0 25 9h-4v2h4a1.967 1.967 0 0 1 1.726 1.373L27.794 16H21v6a3.963 3.963 0 0 1-.546 2H27v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8a2.004 2.004 0 0 0-1.184-1.82ZM29 19.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm-11.323 8.62a.5.5 0 0 1-.326.88H14.36a1 1 0 0 1-.903-.571L12.303 26h2.9ZM4.379 26h2.9l-1.153 2.429a1 1 0 0 1-.903.571H2.23a.5.5 0 0 1-.325-.88ZM14 4H6a5.015 5.015 0 0 0-5 5v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a5.015 5.015 0 0 0-5-5ZM7 18.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm10 0a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm0-6.5a1.003 1.003 0 0 1-1 1H4a1.003 1.003 0 0 1-1-1V9a3.009 3.009 0 0 1 3-3h8a3.009 3.009 0 0 1 3 3Z"
        })
    });
var $beed7be8805a7475$export$2e2bcd8739ae039 = $beed7be8805a7475$var$SvgGlyphiconsBasic666TransportMixed;




const $8837ba367fc49eef$var$SvgGlyphiconsBasic667Metro = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11.379 26h2.9l-1.153 2.429a1 1 0 0 1-.903.571H9.23a.5.5 0 0 1-.325-.88Zm8.824 0h-2.9l1.153 2.429a1 1 0 0 0 .903.571h2.992a.5.5 0 0 0 .326-.88ZM24 13v9a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-9a5.015 5.015 0 0 1 5-5h6a5.015 5.015 0 0 1 5 5Zm-10 6.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm8 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm0-6.5a3.009 3.009 0 0 0-3-3h-6a3.009 3.009 0 0 0-3 3v2a1.003 1.003 0 0 0 1 1h10a1.003 1.003 0 0 0 1-1Zm4-9H6a2 2 0 0 0-2 2v15a1 1 0 0 0 2 0v-8a7.008 7.008 0 0 1 7-7h6a7.008 7.008 0 0 1 7 7v8a1 1 0 0 0 2 0V6a2 2 0 0 0-2-2Z"
        })
    });
var $8837ba367fc49eef$export$2e2bcd8739ae039 = $8837ba367fc49eef$var$SvgGlyphiconsBasic667Metro;




const $7f996e9ca16524ca$var$SvgGlyphiconsBasic668CarRental = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24.816 17.18-1.141-4.257A3.962 3.962 0 0 0 20 10h-8a3.962 3.962 0 0 0-3.675 2.923L7.184 17.18A2.004 2.004 0 0 0 6 19v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2h12v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8a2.004 2.004 0 0 0-1.184-1.82Zm-14.542-3.807A1.967 1.967 0 0 1 12 12h8a1.967 1.967 0 0 1 1.726 1.373L22.794 17H9.206ZM12 20.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm12 0a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5ZM11.996 7.877A3.985 3.985 0 0 0 16.446 6H21l2-1.5v-1L21 2h-4.555a3.993 3.993 0 0 0-7.334 2.959 3.966 3.966 0 0 0 2.885 2.918ZM11 3.5a.501.501 0 0 1 .5-.5h1a.501.501 0 0 1 .5.5v1a.502.502 0 0 1-.5.5h-1a.502.502 0 0 1-.5-.5Z"
        })
    });
var $7f996e9ca16524ca$export$2e2bcd8739ae039 = $7f996e9ca16524ca$var$SvgGlyphiconsBasic668CarRental;




const $9f91c74c024738d2$var$SvgGlyphiconsBasic669Tram = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.19 4.309a1 1 0 0 1 .224-1.397l.476-.344A2.985 2.985 0 0 1 11.647 2h8.706a2.98 2.98 0 0 1 1.756.568l.477.344a1 1 0 0 1-1.172 1.621l-.476-.344A.992.992 0 0 0 20.353 4H20v2.08A6.962 6.962 0 0 0 19 6h-1V4h-4v2h-1a6.962 6.962 0 0 0-1 .08V4h-.353a.997.997 0 0 0-.586.19l-.475.343a1.002 1.002 0 0 1-1.397-.224ZM8.904 28.12a.5.5 0 0 0 .325.88h2.993a1 1 0 0 0 .903-.571L14.279 26h-2.9ZM20.203 26h-2.9l1.153 2.429a1 1 0 0 0 .903.571h2.992a.5.5 0 0 0 .326-.88ZM24 13v9a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-9a5.015 5.015 0 0 1 5-5h6a5.015 5.015 0 0 1 5 5Zm-10 6.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm8 0a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Zm0-6.5a3.009 3.009 0 0 0-3-3h-6a3.009 3.009 0 0 0-3 3v2a1.003 1.003 0 0 0 1 1h10a1.003 1.003 0 0 0 1-1Z"
        })
    });
var $9f91c74c024738d2$export$2e2bcd8739ae039 = $9f91c74c024738d2$var$SvgGlyphiconsBasic669Tram;




const $1ba3ae6d59f73c7d$var$SvgGlyphiconsBasic67Tags = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.042 18.556-8.486 8.485a1 1 0 0 1-1.414 0l-1.076-1.208 7.126-7.126a1 1 0 0 0 0-1.414L14.9 5h3.56a1 1 0 0 1 .737.324l10.845 11.818a1 1 0 0 1 0 1.414Zm-7 0-8.486 8.485a1 1 0 0 1-1.414 0L2.263 15.186A1 1 0 0 1 2 14.51V6a1 1 0 0 1 1-1h8.46a1 1 0 0 1 .737.324l10.845 11.818a1 1 0 0 1 0 1.414ZM10 11a2 2 0 1 0-2 2 2 2 0 0 0 2-2Z"
        })
    });
var $1ba3ae6d59f73c7d$export$2e2bcd8739ae039 = $1ba3ae6d59f73c7d$var$SvgGlyphiconsBasic67Tags;




const $5332d8c1b1cb3ae1$var$SvgGlyphiconsBasic670Dashboard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.911 25.004a1.443 1.443 0 0 1-2.235-.018.994.994 0 0 1-.312-.208l-2.122-2.122a1 1 0 0 1 1.414-1.414l1.352 1.352A8.83 8.83 0 0 0 24.935 18H23a1 1 0 0 1 0-2h1.937c-.008-.076-.008-.151-.018-.228a8.852 8.852 0 0 0-1.896-4.38l-1.366 1.366a1 1 0 0 1-1.414-1.414l1.367-1.367a8.887 8.887 0 0 0-4.558-1.918L17 8.055V10a1 1 0 0 1-2 0V8.058a8.863 8.863 0 0 0-4.61 1.919l1.368 1.367a.994.994 0 0 1 .292.7l5.164 3.776a1.713 1.713 0 1 1-2.394 2.394l-3.775-5.164a.996.996 0 0 1-.701-.292L8.977 11.39A9.01 9.01 0 0 0 7.058 16H9a1 1 0 0 1 0 2H7.063a8.946 8.946 0 0 0 1.927 4.596l1.354-1.354a1 1 0 0 1 1.414 1.414l-2.122 2.122a.991.991 0 0 1-.307.204 1.445 1.445 0 0 1-2.238.022A11.986 11.986 0 0 1 17.388 5.078a11.976 11.976 0 0 1 7.523 19.926Z"
        })
    });
var $5332d8c1b1cb3ae1$export$2e2bcd8739ae039 = $5332d8c1b1cb3ae1$var$SvgGlyphiconsBasic670Dashboard;




const $84426e335e9bde1b$var$SvgGlyphiconsBasic671Mountains = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.812 25.774-10.5-19a1.5 1.5 0 0 0-2.625 0l-5.136 9.294-.35-.468a1.556 1.556 0 0 0-2.401 0l-7.5 10A1.5 1.5 0 0 0 3.5 28h26a1.5 1.5 0 0 0 1.312-2.226Zm-16.33-2.28-4.286-1.429a.5.5 0 0 0-.381.028l-1.92.96a.5.5 0 0 1-.624-.747l3.329-4.44a.5.5 0 0 1 .8 0l3.64 4.853a.5.5 0 0 1-.558.775Zm8.336-6.174-4.552-2.192a.5.5 0 0 0-.506.042l-2.206 1.564a.5.5 0 0 1-.727-.65l3.735-6.759a.5.5 0 0 1 .876 0l4.035 7.302a.5.5 0 0 1-.655.693Z"
        })
    });
var $84426e335e9bde1b$export$2e2bcd8739ae039 = $84426e335e9bde1b$var$SvgGlyphiconsBasic671Mountains;




const $bf3da30bc3736444$var$SvgGlyphiconsBasic672Forest = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.434 21.087a2.484 2.484 0 0 0-.362.913H2.213a.504.504 0 0 1-.368-.806L5.595 15h-1.05a.503.503 0 0 1-.383-.785l2.984-4.622a.448.448 0 0 1 .765 0l1.402 2.17-1.678 2.298a2.524 2.524 0 0 0 .305 3.323ZM9 25H7.474A2.432 2.432 0 0 1 6 24.482V25l-.638 1.276a.5.5 0 0 0 .447.724h3.382a.5.5 0 0 0 .447-.724Zm21.155-3.806L26.405 15h1.108a.503.503 0 0 0 .383-.785L24.91 9.593a.448.448 0 0 0-.765 0l-1.428 2.212 1.65 2.258a2.525 2.525 0 0 1-.308 3.32l2.507 3.705a2.481 2.481 0 0 1 .36.912h2.86a.504.504 0 0 0 .368-.806ZM26 25v-.518a2.432 2.432 0 0 1-1.474.518H23l-.638 1.276a.5.5 0 0 0 .447.724h3.382a.5.5 0 0 0 .447-.724Zm-8 1v-3h6.527a.502.502 0 0 0 .384-.791l-4.172-6.161h1.64a.503.503 0 0 0 .373-.806L18.192 9h.865a.502.502 0 0 0 .388-.785l-3.028-4.622a.458.458 0 0 0-.776 0l-3.028 4.622a.502.502 0 0 0 .388.785h.807l-4.56 6.242a.503.503 0 0 0 .373.806h1.64l-4.172 6.16a.502.502 0 0 0 .384.792H14v3l-.638 1.276a.5.5 0 0 0 .447.724h4.382a.5.5 0 0 0 .447-.724Z"
        })
    });
var $bf3da30bc3736444$export$2e2bcd8739ae039 = $bf3da30bc3736444$var$SvgGlyphiconsBasic672Forest;




const $dc06495cff1de605$var$SvgGlyphiconsBasic673Cableway = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m14 8.78-8.758 2.19a1 1 0 0 1-.484-1.94L14 6.72V6.5a1.497 1.497 0 0 1 2.906-.507l7.852-1.963a1 1 0 0 1 .484 1.94L17 8.03v2.262a.502.502 0 0 0 .112.315L19.05 13h-3.86l-.41-.505A3.517 3.517 0 0 1 14 10.292Zm11.895 12.504a3.008 3.008 0 0 1-.174 1.607l-1.792 4.48A1 1 0 0 1 23 28H13a1 1 0 0 1-.929-.629l-1.792-4.48a3.005 3.005 0 0 1-.174-1.606l.769-4.613A1.995 1.995 0 0 1 12.847 15h10.306a1.995 1.995 0 0 1 1.973 1.67ZM17 17.5a.5.5 0 0 0-.5-.5h-3.23a.5.5 0 0 0-.492.418l-.5 3a.5.5 0 0 0 .493.582H16.5a.5.5 0 0 0 .5-.5Zm6.722 2.918-.5-3A.5.5 0 0 0 22.73 17H19.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3.729a.5.5 0 0 0 .493-.582Z"
        })
    });
var $dc06495cff1de605$export$2e2bcd8739ae039 = $dc06495cff1de605$var$SvgGlyphiconsBasic673Cableway;




const $a75789371fcf8eb2$var$SvgGlyphiconsBasic674Canister = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6.732 10.682 5.318 9.268a.5.5 0 0 1 0-.707l3.243-3.243a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1 0 .707l-3.243 3.243a.5.5 0 0 1-.707 0ZM25 10v15a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V14.828a2 2 0 0 1 .586-1.414l5.828-5.828A2 2 0 0 1 14.828 7H22a3 3 0 0 1 3 3Zm-2 0a1 1 0 0 0-1-1h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1Z"
        })
    });
var $a75789371fcf8eb2$export$2e2bcd8739ae039 = $a75789371fcf8eb2$var$SvgGlyphiconsBasic674Canister;




const $6960b491a94b0098$var$SvgGlyphiconsBasic675MotorOil = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Zm-1 4.5V25a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-8.302a3 3 0 0 1 1.457-2.572L18 9h4.5a.5.5 0 0 1 .5.5Zm-5.776 3.465a1 1 0 0 0-1.372-.343l-5.367 3.219a1 1 0 0 0 1.03 1.715l5.366-3.22a1 1 0 0 0 .343-1.371Z"
        })
    });
var $6960b491a94b0098$export$2e2bcd8739ae039 = $6960b491a94b0098$var$SvgGlyphiconsBasic675MotorOil;




const $3f2b7658cb48cdbe$var$SvgGlyphiconsBasic676CarBattery = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 8h-6V7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1ZM13 7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1h6Zm14 4v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1Zm-14 4.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5Zm11 0a.5.5 0 0 0-.5-.5H22v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V15h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H20v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V17h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $3f2b7658cb48cdbe$export$2e2bcd8739ae039 = $3f2b7658cb48cdbe$var$SvgGlyphiconsBasic676CarBattery;




const $026577a5bcbbe64a$var$SvgGlyphiconsBasic677CarWheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm-1-9a1 1 0 1 1 1 1 1 1 0 0 1-1-1Zm2-3.444v-2.202a.994.994 0 0 1 1.29-.96 7.017 7.017 0 0 1 3.285 2.39.991.991 0 0 1-.515 1.52l-2.094.68a.966.966 0 0 1-.951-.19 2.989 2.989 0 0 0-.542-.394.964.964 0 0 1-.473-.844Zm-6.575-.775a7.016 7.016 0 0 1 3.288-2.386.991.991 0 0 1 1.287.96v2.201a.966.966 0 0 1-.476.846 2.987 2.987 0 0 0-.542.393.964.964 0 0 1-.949.19l-2.094-.68a.993.993 0 0 1-.514-1.524Zm2.741 6.418-1.294 1.781a.993.993 0 0 1-1.607.019 7.015 7.015 0 0 1-1.253-3.865.991.991 0 0 1 1.31-.927l2.094.68a.966.966 0 0 1 .657.714 2.982 2.982 0 0 0 .207.637.964.964 0 0 1-.114.96Zm9.824-2.063a7.016 7.016 0 0 1-1.258 3.863.991.991 0 0 1-1.604-.02l-1.295-1.781a.965.965 0 0 1-.112-.964 2.98 2.98 0 0 0 .207-.637.964.964 0 0 1 .657-.71l2.094-.68a.993.993 0 0 1 1.312.929Zm-4.48 5.02a.993.993 0 0 1-.48 1.534 7.017 7.017 0 0 1-4.062-.003.991.991 0 0 1-.477-1.532l1.294-1.781a.966.966 0 0 1 .882-.405 2.975 2.975 0 0 0 .67 0 .964.964 0 0 1 .879.405Z"
        })
    });
var $026577a5bcbbe64a$export$2e2bcd8739ae039 = $026577a5bcbbe64a$var$SvgGlyphiconsBasic677CarWheel;




const $403a1d4afaf9e728$var$SvgGlyphiconsBasic678CarWheelDefect = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.925 23.715a11.977 11.977 0 0 0-8.576-18.64A11.979 11.979 0 0 0 6.078 23.716a1.04 1.04 0 0 1 .084 1.01A1.936 1.936 0 0 0 6 25.5 2.503 2.503 0 0 0 8.5 28h15a2.503 2.503 0 0 0 2.5-2.5 1.933 1.933 0 0 0-.161-.77 1.045 1.045 0 0 1 .086-1.015ZM20.105 25h-8.21a9 9 0 1 1 8.21 0ZM15 17a1 1 0 1 1 1 1 1 1 0 0 1-1-1Zm2-3.444v-2.202a.994.994 0 0 1 1.29-.96 7.017 7.017 0 0 1 3.285 2.39.991.991 0 0 1-.515 1.52l-2.094.68a.966.966 0 0 1-.951-.19 2.989 2.989 0 0 0-.542-.394.964.964 0 0 1-.473-.844Zm-6.575-.775a7.016 7.016 0 0 1 3.288-2.386.991.991 0 0 1 1.287.96v2.201a.966.966 0 0 1-.476.846 2.987 2.987 0 0 0-.542.393.964.964 0 0 1-.949.19l-2.094-.68a.993.993 0 0 1-.514-1.524Zm12.566 4.355a7.016 7.016 0 0 1-1.259 3.863.991.991 0 0 1-1.604-.02l-1.295-1.781a.965.965 0 0 1-.112-.964 2.98 2.98 0 0 0 .207-.637.964.964 0 0 1 .657-.71l2.094-.68a.993.993 0 0 1 1.312.929Zm-9.824 2.063-1.295 1.781a.993.993 0 0 1-1.607.019 7.015 7.015 0 0 1-1.253-3.865.991.991 0 0 1 1.31-.927l2.094.68a.966.966 0 0 1 .657.714 2.982 2.982 0 0 0 .207.637.964.964 0 0 1-.114.96Zm5.343 2.957a.993.993 0 0 1-.48 1.534 7.017 7.017 0 0 1-4.062-.003.991.991 0 0 1-.477-1.532l1.294-1.781a.966.966 0 0 1 .882-.405 2.975 2.975 0 0 0 .67 0 .964.964 0 0 1 .879.405Z"
        })
    });
var $403a1d4afaf9e728$export$2e2bcd8739ae039 = $403a1d4afaf9e728$var$SvgGlyphiconsBasic678CarWheelDefect;




const $0c759a8f74a75109$var$SvgGlyphiconsBasic679CarWheelWrench = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 6v5a1 1 0 0 1-1 1h-3.232a3 3 0 0 1-1.323-.307L18 10h-1.5a2.971 2.971 0 0 0-2.525 1.82L8.923 26.974a1.5 1.5 0 0 1-2.846-.95l5.052-15.154A5.96 5.96 0 0 1 16.5 7H18l3.37-1.684A3 3 0 0 1 22.71 5H26a1 1 0 0 1 1 1Z"
        })
    });
var $0c759a8f74a75109$export$2e2bcd8739ae039 = $0c759a8f74a75109$var$SvgGlyphiconsBasic679CarWheelWrench;




const $8dfa3a15685394b3$var$SvgGlyphiconsBasic68Education = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16.914 20.64 24 17.858v5.722a.5.5 0 0 1-.32.467l-6.782 2.609a2.5 2.5 0 0 1-1.795 0L8.32 24.046A.5.5 0 0 1 8 23.58v-5.722l7.086 2.784a2.5 2.5 0 0 0 1.828 0Zm12.769-9.265L16.73 6.287a2 2 0 0 0-1.462 0L2.317 11.375a.5.5 0 0 0-.317.466v1.318a.5.5 0 0 0 .317.466l1.423.559A1.989 1.989 0 0 0 3 15.72v2.501a1.003 1.003 0 0 0-1 1V24l2-1.889L6 24v-4.778a1.003 1.003 0 0 0-1-1v-2.501l1.435-.479 8.834 3.47a2 2 0 0 0 1.462 0l12.952-5.087a.5.5 0 0 0 .317-.466v-1.318a.5.5 0 0 0-.317-.466Z"
        })
    });
var $8dfa3a15685394b3$export$2e2bcd8739ae039 = $8dfa3a15685394b3$var$SvgGlyphiconsBasic68Education;




const $af6808f03ea048e0$var$SvgGlyphiconsBasic680CarWheelWrenchAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.9 22.657a1 1 0 0 1 0 1.414l-2.829 2.828a1 1 0 0 1-1.414 0l-1.442-1.441a3 3 0 0 1-.814-1.502l-.573-2.713-2.414-2.415 1.414-1.414 2.415 2.414 2.647.531a3 3 0 0 1 1.532.82ZM6.541 10.785a3 3 0 0 0 1.502.814l2.713.573 2.415 2.414 1.414-1.414-2.414-2.415-.531-2.647a3 3 0 0 0-.82-1.532L9.343 5.1a1 1 0 0 0-1.414 0L5.101 7.93a1 1 0 0 0 0 1.414Zm14.7 1.387 2.714-.573a3 3 0 0 0 1.502-.814l1.441-1.442a1 1 0 0 0 0-1.414L24.071 5.1a1 1 0 0 0-1.414 0l-1.478 1.478a3 3 0 0 0-.82 1.532l-.53 2.647-9.072 9.071-2.647.531a3 3 0 0 0-1.532.82l-1.477 1.478a1 1 0 0 0 0 1.414l2.828 2.828a1 1 0 0 0 1.414 0l1.442-1.441a3 3 0 0 0 .814-1.502l.573-2.713Z"
        })
    });
var $af6808f03ea048e0$export$2e2bcd8739ae039 = $af6808f03ea048e0$var$SvgGlyphiconsBasic680CarWheelWrenchAlt;




const $f05d0aafe3946bcf$var$SvgGlyphiconsBasic681SuitcaseDoctor = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 7h-2a3.003 3.003 0 0 1 3-3h4a3.003 3.003 0 0 1 3 3h-2a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1Zm5.5 10H17v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V17h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H15v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V19h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm9.5-5v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V12a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3Zm-7 6a5 5 0 1 0-5 5 5 5 0 0 0 5-5Z"
        })
    });
var $f05d0aafe3946bcf$export$2e2bcd8739ae039 = $f05d0aafe3946bcf$var$SvgGlyphiconsBasic681SuitcaseDoctor;




const $ed7ae0563a8bef23$var$SvgGlyphiconsBasic682Tent = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 25h-1.547L17.148 8.538l1.722-3.046a1 1 0 1 0-1.74-.984L16 6.507l-1.13-2a1 1 0 0 0-1.74.985l1.722 3.046L5.547 25H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-17.295 0L16 15.436 21.295 25Z"
        })
    });
var $ed7ae0563a8bef23$export$2e2bcd8739ae039 = $ed7ae0563a8bef23$var$SvgGlyphiconsBasic682Tent;




const $ecb73906bea80967$var$SvgGlyphiconsBasic683KeyRounded = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 12H16.13a7.5 7.5 0 1 0 0 7h1.334l2.036-2.036 2 2 2-2 2 2 2-2 1.364 1.364L31 16.667v-2.334ZM8 16a1.003 1.003 0 0 1-1 1H6a1.003 1.003 0 0 1-1-1v-1a1.003 1.003 0 0 1 1-1h1a1.003 1.003 0 0 1 1 1Z"
        })
    });
var $ecb73906bea80967$export$2e2bcd8739ae039 = $ecb73906bea80967$var$SvgGlyphiconsBasic683KeyRounded;




const $7f87c50e838bcb4c$var$SvgGlyphiconsBasic684Flashlight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 13v13a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V13l2.5-5h-13Zm3 2.833a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0ZM23 5v1H9V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z"
        })
    });
var $7f87c50e838bcb4c$export$2e2bcd8739ae039 = $7f87c50e838bcb4c$var$SvgGlyphiconsBasic684Flashlight;




const $700a331d9414a79f$var$SvgGlyphiconsBasic685Backpack = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m6.903 11.322-.74-5.18A1 1 0 0 1 7.153 5h1.98a1 1 0 0 1 .99.859l.286 2.002a8.044 8.044 0 0 0-3.506 3.461ZM15 6h2a1 1 0 0 1 1 1 7.957 7.957 0 0 1 2 .263V7a3.003 3.003 0 0 0-3-3h-2a3.003 3.003 0 0 0-3 3v.263A7.957 7.957 0 0 1 14 7a1 1 0 0 1 1-1Zm9.847-1h-1.98a1 1 0 0 0-.99.859l-.286 2.002a8.044 8.044 0 0 1 3.506 3.461l.74-5.18A1 1 0 0 0 24.847 5ZM24 15v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V15a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6Zm-2 0a4.004 4.004 0 0 0-4-4h-4a4.004 4.004 0 0 0-4 4 1 1 0 0 0 2 0 2.003 2.003 0 0 1 2-2h4a2.003 2.003 0 0 1 2 2 1 1 0 0 0 2 0Z"
        })
    });
var $700a331d9414a79f$export$2e2bcd8739ae039 = $700a331d9414a79f$var$SvgGlyphiconsBasic685Backpack;




const $096b2a00f1220bc3$var$SvgGlyphiconsBasic686Watch = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 15h-.65a7.496 7.496 0 0 0-2.593-4.298l-1.104-5.886A1 1 0 0 0 18.67 4h-5.34a1 1 0 0 0-.983.816l-1.104 5.886a7.497 7.497 0 0 0 .014 11.606l.96 4.885a1 1 0 0 0 .98.807h5.605a1 1 0 0 0 .982-.807l.959-4.885A7.495 7.495 0 0 0 23.349 18H24a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-8 7a5.5 5.5 0 1 1 5.5-5.5A5.506 5.506 0 0 1 16 22Zm3-5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v2h1a1 1 0 0 1 1 1Z"
        })
    });
var $096b2a00f1220bc3$export$2e2bcd8739ae039 = $096b2a00f1220bc3$var$SvgGlyphiconsBasic686Watch;




const $faef1d6d0ab64c87$var$SvgGlyphiconsBasic687WatchSquared = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.446 9.045-.793-4.23A1 1 0 0 0 18.67 4h-5.34a1 1 0 0 0-.983.816l-.793 4.229A2.992 2.992 0 0 0 9 12v8a3 3 0 0 0 2.38 2.934l.836 4.259a1 1 0 0 0 .982.807h5.604a1 1 0 0 0 .982-.807l.836-4.259A3 3 0 0 0 23 20v-8a2.992 2.992 0 0 0-2.554-2.955ZM21 20a1.001 1.001 0 0 1-1 1h-8a1.001 1.001 0 0 1-1-1v-8a1.001 1.001 0 0 1 1-1h8a1.001 1.001 0 0 1 1 1Zm-2-3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v2h1a1 1 0 0 1 1 1Z"
        })
    });
var $faef1d6d0ab64c87$export$2e2bcd8739ae039 = $faef1d6d0ab64c87$var$SvgGlyphiconsBasic687WatchSquared;




const $d2675476eff723a0$var$SvgGlyphiconsBasic688SmartBracelet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 4h-6a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1 15a1.001 1.001 0 0 1-1 1h-2a1.001 1.001 0 0 1-1-1v-5a1.001 1.001 0 0 1 1-1h2a1.001 1.001 0 0 1 1 1Zm6.348-2a3.727 3.727 0 0 1-1.099 2.651 1 1 0 1 1-1.414-1.414 1.75 1.75 0 0 0 0-2.474 1 1 0 1 1 1.414-1.414A3.727 3.727 0 0 1 24.348 17Zm3.5 0a6.214 6.214 0 0 1-1.831 4.42 1 1 0 1 1-1.414-1.414 4.25 4.25 0 0 0 0-6.012 1 1 0 0 1 1.414-1.414 6.214 6.214 0 0 1 1.83 4.42Z"
        })
    });
var $d2675476eff723a0$export$2e2bcd8739ae039 = $d2675476eff723a0$var$SvgGlyphiconsBasic688SmartBracelet;




const $8cd8118e46c510ea$var$SvgGlyphiconsBasic689Lighter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.506 10.765c-2.197-2.967.484-6.313 2.95-8.51a.493.493 0 0 1 .8.212c.688 2.17 2.308 4.014 2.308 6.264a4.218 4.218 0 0 1-.95 2.828.5.5 0 0 1-.86-.436c.23-1.425-.758-2.559-1.522-3.646a.246.246 0 0 0-.378-.035 3.79 3.79 0 0 0-1.455 2.977.5.5 0 0 1-.893.346ZM24 17v-2a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v2h-1.734l-.909-1.515a.999.999 0 0 0-1.372-.342l-.471.283L6.5 5.01l-3.464 2a2 2 0 0 0-.732 2.732l5.5 9.526a2 2 0 0 0 2.732.732L13 18.577V26a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-9Z"
        })
    });
var $8cd8118e46c510ea$export$2e2bcd8739ae039 = $8cd8118e46c510ea$var$SvgGlyphiconsBasic689Lighter;




const $23669c15952d7916$var$SvgGlyphiconsBasic69Ruler = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 11h-2v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V11h-2v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V11h-2v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V11h-2v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V11H9v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V11H5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1ZM7 22.5A1.5 1.5 0 1 1 8.5 21 1.5 1.5 0 0 1 7 22.5Z"
        })
    });
var $23669c15952d7916$export$2e2bcd8739ae039 = $23669c15952d7916$var$SvgGlyphiconsBasic69Ruler;




const $30fc4c9cf0add945$var$SvgGlyphiconsBasic690MultifunctionKnife = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8.08 8.607a1.646 1.646 0 0 0-.057-1.367.268.268 0 0 1 .283-.39c.825.152 2.367.664 1.613 2.543a7.699 7.699 0 0 0-.395 1.079 6.916 6.916 0 0 0 1.078-.396c.999-.426 2.367-1.01 3.343-.034.978.978.393 2.345-.033 3.343a6.792 6.792 0 0 0-.395 1.08 6.925 6.925 0 0 0 1.082-.394c.998-.425 2.364-1.012 3.343-.032.978.979.395 2.346-.03 3.345-.076.174-.17.4-.251.616h-2.077a7.93 7.93 0 0 1 .487-1.401 6.943 6.943 0 0 0 .396-1.083 6.812 6.812 0 0 0-1.084.394c-.998.427-2.364 1.012-3.344.032-.977-.977-.393-2.344.033-3.342a6.944 6.944 0 0 0 .396-1.08 6.899 6.899 0 0 0-1.08.395c-.998.428-2.365 1.013-3.341.035-.978-.977-.388-2.342.032-3.343ZM25 4a8.613 8.613 0 0 0-5 8v6h3a5.969 5.969 0 0 1 4 1.54V10Zm2 20a4 4 0 0 1-4 4H8a4 4 0 0 1 0-8h15a4 4 0 0 1 4 4Zm-3 0a1 1 0 1 0-1 1 1 1 0 0 0 1-1Z"
        })
    });
var $30fc4c9cf0add945$export$2e2bcd8739ae039 = $30fc4c9cf0add945$var$SvgGlyphiconsBasic690MultifunctionKnife;




const $5862b6e98e3601c9$var$SvgGlyphiconsBasic691TextUnderline = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 26.5v1a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5ZM8 9h1a1 1 0 0 0 1-1V7h4v14h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1V7h4v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1Z"
        })
    });
var $5862b6e98e3601c9$export$2e2bcd8739ae039 = $5862b6e98e3601c9$var$SvgGlyphiconsBasic691TextUnderline;




const $7960cb6f078de19f$var$SvgGlyphiconsBasic692Font = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30 6v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V8h-5v17h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1V8h-5v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Zm-16 8H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h2v8H6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1v-8h2v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Z"
        })
    });
var $7960cb6f078de19f$export$2e2bcd8739ae039 = $7960cb6f078de19f$var$SvgGlyphiconsBasic692Font;




const $b59232b042f4a3a8$var$SvgGlyphiconsBasic693Superscript = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 6H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9h4v14h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1V9h4v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm8 6h-3.679a1 1 0 0 1-.999-.947 3.615 3.615 0 0 1 2.306-3.567c1.05-.373 1.05-.653 1.05-.772A.715.715 0 0 0 26.965 6a1.202 1.202 0 0 0-.95.502 1 1 0 1 1-1.529-1.29A3.169 3.169 0 0 1 26.964 4a2.718 2.718 0 0 1 2.715 2.714c0 1.81-1.791 2.447-2.38 2.657a1.359 1.359 0 0 0-.748.629H29a1 1 0 0 1 0 2Z"
        })
    });
var $b59232b042f4a3a8$export$2e2bcd8739ae039 = $b59232b042f4a3a8$var$SvgGlyphiconsBasic693Superscript;




const $4503f90bfdd5e917$var$SvgGlyphiconsBasic694Subscript = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 10V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9h4v14h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1V9h4v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1Zm4 18h-3.679a1 1 0 0 1-.999-.947 3.615 3.615 0 0 1 2.306-3.567c1.05-.373 1.05-.653 1.05-.772a.715.715 0 0 0-.714-.714 1.202 1.202 0 0 0-.95.502 1 1 0 1 1-1.529-1.29A3.169 3.169 0 0 1 23.964 20a2.718 2.718 0 0 1 2.715 2.714c0 1.81-1.791 2.447-2.38 2.657a1.359 1.359 0 0 0-.748.629H26a1 1 0 0 1 0 2Z"
        })
    });
var $4503f90bfdd5e917$export$2e2bcd8739ae039 = $4503f90bfdd5e917$var$SvgGlyphiconsBasic694Subscript;




const $34b57da8aae179fa$var$SvgGlyphiconsBasic695TextBackground = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 4H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h19a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm-3 9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1h-2v8h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-8h-2v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1Z"
        })
    });
var $34b57da8aae179fa$export$2e2bcd8739ae039 = $34b57da8aae179fa$var$SvgGlyphiconsBasic695TextBackground;




const $bda6b3ad7986678a$var$SvgGlyphiconsBasic696Header = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 8v16h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-7h-9v7h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1V8H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v6h9V8h-1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Z"
        })
    });
var $bda6b3ad7986678a$export$2e2bcd8739ae039 = $bda6b3ad7986678a$var$SvgGlyphiconsBasic696Header;




const $0317a4078e309b83$var$SvgGlyphiconsBasic697DirectionsSign = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.54 8.884-2.262 1.884a1 1 0 0 1-.64.232H12a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h7.638a1 1 0 0 1 .64.232l2.261 1.884a.5.5 0 0 1 0 .768ZM20 15h-3v-2h-3v2H7.362a1 1 0 0 0-.64.232L4.46 17.116a.5.5 0 0 0 0 .768l2.26 1.884a1 1 0 0 0 .641.232H20a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1Zm-6 13h3v-6h-3Z"
        })
    });
var $0317a4078e309b83$export$2e2bcd8739ae039 = $0317a4078e309b83$var$SvgGlyphiconsBasic697DirectionsSign;




const $05f46a47c8242041$var$SvgGlyphiconsBasic698BarbedWire = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.496 23.413a1 1 0 0 1-.91 1.083l-1.2.105.357.397a1 1 0 1 1-1.486 1.338l-.757-.841-.757.84a1 1 0 1 1-1.486-1.337l.037-.042-4.162.362.611.68a1 1 0 1 1-1.486 1.338l-.757-.841-.757.84a1 1 0 1 1-1.486-1.337l.334-.372-3.879.337.031.035a1 1 0 1 1-1.486 1.338l-.757-.841-.757.84a.996.996 0 0 1-1.692-.966l-1.464.127a.888.888 0 0 1-.088.004 1 1 0 0 1-.086-1.996l2.129-.185-.285-.317a1 1 0 1 1 1.486-1.338l.757.841.757-.84a.995.995 0 0 1 1.516 1.286l3.285-.286a1 1 0 0 1 1.685-1l.713.792.095-.009.706-.784a1 1 0 0 1 1.412-.074.989.989 0 0 1 .318.647l3.242-.282a.995.995 0 0 1 1.514-1.29l.757.84.757-.84a1.001 1.001 0 0 1 1.412-.075.987.987 0 0 1 .292.953l.452-.04a1 1 0 0 1 1.083.91ZM28 16h-1.256a1 1 0 0 0-1.487-1.336l-.757.841-.757-.84A1 1 0 0 0 22.256 16h-3.512a1 1 0 0 0-1.487-1.336l-.757.841-.757-.84A1 1 0 0 0 14.256 16h-3.512a1 1 0 0 0-1.487-1.336l-.757.841-.757-.84A1 1 0 0 0 6.256 16H4a1 1 0 0 0 0 2h2.256a1 1 0 0 0 1.487 1.336l.757-.841.757.84A1 1 0 0 0 10.744 18h3.512a1 1 0 0 0 1.487 1.336l.757-.841.757.84A1 1 0 0 0 18.744 18h3.512a1 1 0 0 0 1.487 1.336l.757-.841.757.84A1 1 0 0 0 26.744 18H28a1 1 0 0 0 0-2ZM3.999 11a.818.818 0 0 0 .084-.004l2.352-.196-.178.198a1 1 0 1 0 1.486 1.338l.757-.841.757.84a1 1 0 1 0 1.486-1.337l-.466-.518 4.938-.412a.993.993 0 0 0 1.528 1.268l.757-.841.757.84a1 1 0 1 0 1.486-1.337l-.257-.286 3.558-.296a.993.993 0 0 0 1.7.92l.756-.841.757.84a.997.997 0 0 0 1.501-1.312l.325-.027a.999.999 0 0 0 .913-1.079.98.98 0 0 0-1.079-.913l-.19.016.016-.018a1 1 0 1 0-1.486-1.338l-.757.841-.757-.84a1 1 0 1 0-1.486 1.337l.327.363-3.644.304a.999.999 0 0 0-1.683-1.005l-.757.841-.757-.84a1 1 0 1 0-1.486 1.337l.048.053-4.326.36a.982.982 0 0 0-.31-.825 1.001 1.001 0 0 0-1.412.074l-.757.841-.757-.84a1 1 0 0 0-1.412-.075.986.986 0 0 0-.183 1.228l-2.231.186A1 1 0 0 0 3.999 11Z"
        })
    });
var $05f46a47c8242041$export$2e2bcd8739ae039 = $05f46a47c8242041$var$SvgGlyphiconsBasic698BarbedWire;




const $8a8ef6a83ff79a8f$var$SvgGlyphiconsBasic699Tractor = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 20v7a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1ZM8 19H5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1Zm16-2a3.003 3.003 0 0 0-3 3v3a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-3a3.003 3.003 0 0 0-3-3H5v-2a2 2 0 0 1 2-2h2.2l.604-6.04A.986.986 0 0 1 9 6V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1a.986.986 0 0 1-.804.96L22.8 13H25a2 2 0 0 1 2 2v2Zm-9 1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm4 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm1.683-6.573L20.28 7.9A1 1 0 0 0 19.285 7h-6.57a1 1 0 0 0-.995.9l-.403 4.027A1.995 1.995 0 0 1 13 11h6a1.995 1.995 0 0 1 1.683.927Z"
        })
    });
var $8a8ef6a83ff79a8f$export$2e2bcd8739ae039 = $8a8ef6a83ff79a8f$var$SvgGlyphiconsBasic699Tractor;




const $b672579fdfd22802$var$SvgGlyphiconsBasic7UserPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.365 13.374A1.275 1.275 0 0 1 10 11.63V9c0-3 2-5 5.5-5a6.791 6.791 0 0 1 2.646.501 7.948 7.948 0 0 0 3.599 8.261 1.712 1.712 0 0 1-.11.612l-.28.752a2.991 2.991 0 0 1-1.31 1.462l-.666 3.051A3 3 0 0 1 16.448 21h-1.896a3 3 0 0 1-2.93-2.36l-.666-3.052a2.991 2.991 0 0 1-1.311-1.462ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Zm-2.931 17.372-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365Z"
        })
    });
var $b672579fdfd22802$export$2e2bcd8739ae039 = $b672579fdfd22802$var$SvgGlyphiconsBasic7UserPlus;




const $5361cd3c63f57e65$var$SvgGlyphiconsBasic70Gift = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 18h8v10H7a1 1 0 0 1-1-1Zm12 10h7a1 1 0 0 0 1-1v-9h-8Zm10-16v4H18v-2.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V16H4v-4a1 1 0 0 1 1-1h3.91l-.528-.264a2.5 2.5 0 0 1-.444-4.188l2.5-2a2.5 2.5 0 0 1 3.747.738L16 8.552l1.815-3.266a2.5 2.5 0 0 1 3.747-.738l2.5 2a2.5 2.5 0 0 1-.444 4.188L23.09 11H27a1 1 0 0 1 1 1Zm-13.5-1L12 6.5l-2.5 2Zm8-2.5-2.5-2-2.5 4.5Z"
        })
    });
var $5361cd3c63f57e65$export$2e2bcd8739ae039 = $5361cd3c63f57e65$var$SvgGlyphiconsBasic70Gift;




const $bde69fd26c2febc2$var$SvgGlyphiconsBasic700Fence = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 15v-3h-2V9.287a1 1 0 0 0-.152-.53l-1.924-3.079a.5.5 0 0 0-.848 0l-1.924 3.079a1 1 0 0 0-.152.53V12h-3V9.287a1 1 0 0 0-.152-.53l-1.924-3.079a.5.5 0 0 0-.848 0l-1.924 3.079a1 1 0 0 0-.152.53V12h-3V9.287a1 1 0 0 0-.152-.53L7.924 5.678a.5.5 0 0 0-.848 0L5.152 8.757a1 1 0 0 0-.152.53V12H3v3h2v5H3v3h2v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3h3v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3h3v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3h2v-3h-2v-5Zm-15 5h-3v-5h3Zm8 0h-3v-5h3Z"
        })
    });
var $bde69fd26c2febc2$export$2e2bcd8739ae039 = $bde69fd26c2febc2$var$SvgGlyphiconsBasic700Fence;




const $bdc77d1ca65e0543$var$SvgGlyphiconsBasic701IceCream = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.425 7.962A3.983 3.983 0 0 1 20.62 14h-3.97a5.938 5.938 0 0 0-1.225-6.038ZM20.915 16H8.085a.5.5 0 0 0-.474.658l.325.974A2 2 0 0 0 9.833 19h.667l2.772 8.316a1 1 0 0 0 .949.684h.558a1 1 0 0 0 .949-.684L18.5 19h.667a2 2 0 0 0 1.897-1.368l.325-.974a.5.5 0 0 0-.474-.658Zm-7.097-9.294a5.996 5.996 0 0 1 3.01-1.59 3.732 3.732 0 0 0-6.616.942 5.846 5.846 0 0 1 3.606.648ZM15 12a4 4 0 0 0-8 0 3.959 3.959 0 0 0 .555 2h6.89A3.959 3.959 0 0 0 15 12Z"
        })
    });
var $bdc77d1ca65e0543$export$2e2bcd8739ae039 = $bdc77d1ca65e0543$var$SvgGlyphiconsBasic701IceCream;




const $a7e386af53d064a1$var$SvgGlyphiconsBasic702IceCreamOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m21.389 16.658-.325.974A2 2 0 0 1 19.167 19H18.5l-2.772 8.316a1 1 0 0 1-.949.684h-.558a1 1 0 0 1-.949-.684l-1.155-3.466 7.85-7.85h.948a.5.5 0 0 1 .474.658Zm-7.571-9.952a5.996 5.996 0 0 1 3.01-1.59 3.732 3.732 0 0 0-6.616.942 5.846 5.846 0 0 1 3.606.648ZM27.215 2.94a1.5 1.5 0 0 0-2.121 0l-4.802 4.802a3.92 3.92 0 0 0-4.867.221 5.987 5.987 0 0 1 1.501 3.145l-2.146 2.146A3.824 3.824 0 0 0 15 12a4 4 0 0 0-8 0 3.959 3.959 0 0 0 .555 2h6.478l-2 2H8.085a.5.5 0 0 0-.474.658l.325.974a1.994 1.994 0 0 0 1.223 1.242l-6.22 6.22a1.5 1.5 0 1 0 2.122 2.12L27.215 5.062a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $a7e386af53d064a1$export$2e2bcd8739ae039 = $a7e386af53d064a1$var$SvgGlyphiconsBasic702IceCreamOff;




const $fba6af1ce614ac43$var$SvgGlyphiconsBasic703RemoteControl = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 12h-6a2 2 0 0 0-2 2v10a4 4 0 0 0 4 4h2a4 4 0 0 0 4-4V14a2 2 0 0 0-2-2Zm-3 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3Zm1-3a1 1 0 1 1-1-1 1.001 1.001 0 0 1 1 1Zm-5.42-9.603a1 1 0 0 1 0-1.414 6.25 6.25 0 0 1 8.84 0 1 1 0 1 1-1.414 1.414 4.25 4.25 0 0 0-6.012 0 1 1 0 0 1-1.414 0Zm7.071 1.354a1 1 0 1 1-1.414 1.414 1.79 1.79 0 0 0-2.474 0 1 1 0 0 1-1.414-1.414 3.84 3.84 0 0 1 5.302 0Z"
        })
    });
var $fba6af1ce614ac43$export$2e2bcd8739ae039 = $fba6af1ce614ac43$var$SvgGlyphiconsBasic703RemoteControl;




const $1b0f36b527fd8e96$var$SvgGlyphiconsBasic704Pills = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.533 19.506a7.002 7.002 0 0 0-1.172-1.998 2.996 2.996 0 0 0-.704-3.094l-3.535-3.536L17 15h-3.071l-2-2A5 5 0 0 1 19 5.929L26.071 13a4.996 4.996 0 0 1 .462 6.506ZM25 22a5.006 5.006 0 0 1-5 5H10a5 5 0 0 1 0-10h10a5.006 5.006 0 0 1 5 5Zm-10-3h-5a3 3 0 0 0 0 6h5Z"
        })
    });
var $1b0f36b527fd8e96$export$2e2bcd8739ae039 = $1b0f36b527fd8e96$var$SvgGlyphiconsBasic704Pills;




const $3da31b8d447a4be3$var$SvgGlyphiconsBasic705Medicine = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.83 9.349-.282-.186A1.002 1.002 0 0 0 20 9h-8a1.002 1.002 0 0 0-.548.163l-.282.186A6.973 6.973 0 0 0 8 15.207V26a2.003 2.003 0 0 0 2 2h12a2.003 2.003 0 0 0 2-2V15.207a6.973 6.973 0 0 0-3.17-5.858ZM21 21.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5ZM11 6V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1Z"
        })
    });
var $3da31b8d447a4be3$export$2e2bcd8739ae039 = $3da31b8d447a4be3$var$SvgGlyphiconsBasic705Medicine;




const $0678e942ee75e6f0$var$SvgGlyphiconsBasic706Park = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 25a1 1 0 0 1-1 1v2h-2v-2H6v2H4v-2a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1Zm14.897-13.557a4.466 4.466 0 0 0-4.027-5.406 3.985 3.985 0 0 0-7.748.026A4.446 4.446 0 0 0 15.5 6a4.495 4.495 0 0 0-4.156 6.219A5.992 5.992 0 0 0 18 21.651V26l-.638 1.276a.5.5 0 0 0 .447.724h4.382a.5.5 0 0 0 .447-.724L22 26v-4.349a5.994 5.994 0 0 0 5.897-10.208ZM5 11a1.004 1.004 0 0 0 .316-.052l3-1a1 1 0 0 0-.632-1.896L5 8.946l-2.684-.894a1 1 0 0 0-.632 1.896l3 1A1.004 1.004 0 0 0 5 11Zm1.553-6.105 2 1a1.001 1.001 0 0 0 .894 0l2-1a1 1 0 1 0-.894-1.79L9 3.882l-1.553-.777a1 1 0 0 0-.894 1.79Z"
        })
    });
var $0678e942ee75e6f0$export$2e2bcd8739ae039 = $0678e942ee75e6f0$var$SvgGlyphiconsBasic706Park;




const $8798f681ec8c12c4$var$SvgGlyphiconsBasic707DogTags = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.146 22.59a14.252 14.252 0 0 1-3.345 3.447 3.973 3.973 0 0 0 .199-1.22v-9.925l3.22 5.578a1.99 1.99 0 0 1-.074 2.12ZM22 12.184v12.632a1.99 1.99 0 0 1-1.124 1.8A13.855 13.855 0 0 1 15 28a13.855 13.855 0 0 1-5.876-1.384A1.99 1.99 0 0 1 8 24.816V12.184a1.99 1.99 0 0 1 1.124-1.8c.175-.084.374-.172.584-.262L5.293 5.707a1 1 0 0 1 1.414-1.414l5.118 5.118A12.919 12.919 0 0 1 15 9a13.198 13.198 0 0 1 3.955.631l5.338-5.338a1 1 0 0 1 1.414 1.414l-4.739 4.739A1.983 1.983 0 0 1 22 12.184ZM17 14a1.974 1.974 0 0 0-2.512-1.926l.719.719a1 1 0 1 1-1.414 1.414l-.719-.719A1.997 1.997 0 1 0 17 14Z"
        })
    });
var $8798f681ec8c12c4$export$2e2bcd8739ae039 = $8798f681ec8c12c4$var$SvgGlyphiconsBasic707DogTags;




const $4bf2a1618d1f97ab$var$SvgGlyphiconsBasic708LuggageAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.576 9a5.004 5.004 0 0 0-1.391-1.822A1.98 1.98 0 0 1 22 7h2a2.003 2.003 0 0 1 2 2v1h-2V9ZM10 5h4v1h2V5a2.003 2.003 0 0 0-2-2h-4a2.003 2.003 0 0 0-2 2v1h2Zm18 7h-5v2h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H23v7a4.951 4.951 0 0 1-1.026 3H25v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a2.006 2.006 0 0 0 2-2V14a2.006 2.006 0 0 0-2-2Zm-7-1v12a3.002 3.002 0 0 1-2 2.815V27a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H9v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-1a3.009 3.009 0 0 1-3-3V11a3.009 3.009 0 0 1 3-3h12a3.009 3.009 0 0 1 3 3Zm-7 .5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5Z"
        })
    });
var $4bf2a1618d1f97ab$export$2e2bcd8739ae039 = $4bf2a1618d1f97ab$var$SvgGlyphiconsBasic708LuggageAlt;




const $38418fa0e8144dc6$var$SvgGlyphiconsBasic709LawnMower = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.5 21a3.478 3.478 0 0 0-2.598 1.174l-9.63-2.568-7.44-11.16a1 1 0 0 0-.516-.394l-3-1a1 1 0 0 0-.632 1.896l2.674.892 4.199 6.297-4.524-1.74a1 1 0 0 0-1.324.67l-1.331 4.88A4 4 0 0 0 6.237 25h3.813a3.483 3.483 0 0 0 6.9 0h6.1a3.493 3.493 0 1 0 3.45-4Zm-13 5a1.5 1.5 0 1 1 1.5-1.5 1.502 1.502 0 0 1-1.5 1.5Zm13 0a1.5 1.5 0 1 1 1.5-1.5 1.502 1.502 0 0 1-1.5 1.5ZM24 20.13l-9-2.4v-1.29a2 2 0 0 1 2.392-1.961l5 1.2A2 2 0 0 1 24 17.639Z"
        })
    });
var $38418fa0e8144dc6$export$2e2bcd8739ae039 = $38418fa0e8144dc6$var$SvgGlyphiconsBasic709LawnMower;




const $1d4a6e78f5e399af$var$SvgGlyphiconsBasic71Umbrella = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28 17-.001.021a4.946 4.946 0 0 0-7.033 1.047 6.996 6.996 0 0 0-9.932 0A4.946 4.946 0 0 0 4 17.021L4 17A11.994 11.994 0 0 1 15 5.05V4a1 1 0 0 1 2 0v1.05A11.994 11.994 0 0 1 28 17Zm-13 8a2.003 2.003 0 0 1-2.338 1.972A2.079 2.079 0 0 1 11 24.888V24a1 1 0 0 0-2 0v.822a4.121 4.121 0 0 0 3.6 4.158A4.005 4.005 0 0 0 17 25v-7h-2Z"
        })
    });
var $1d4a6e78f5e399af$export$2e2bcd8739ae039 = $1d4a6e78f5e399af$var$SvgGlyphiconsBasic71Umbrella;




const $ec21d2ef8bf3299b$var$SvgGlyphiconsBasic710BrickWall = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 5H4a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM13 7h6v2h-6Zm6 10h-6v-2h6Zm4 2v2h-6v-2Zm-8 0v2H9v-2Zm-6-6v-2h6v2Zm8 0v-2h6v2ZM5 7h6v2H5Zm0 4h2v2H5Zm0 4h6v2H5Zm0 4h2v2H5Zm6 6H5v-2h6Zm8 0h-6v-2h6Zm8 0h-6v-2h6Zm0-4h-2v-2h2Zm0-4h-6v-2h6Zm0-4h-2v-2h2Zm0-4h-6V7h6Z"
        })
    });
var $ec21d2ef8bf3299b$export$2e2bcd8739ae039 = $ec21d2ef8bf3299b$var$SvgGlyphiconsBasic710BrickWall;




const $8f62f5b380fff67a$var$SvgGlyphiconsBasic711VotingUrn = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 9v5H5V9a1 1 0 0 1 1-1h4.222l2 2H11.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.672l2-2H26a1 1 0 0 1 1 1ZM7 27a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V16H7Zm9-17 4.475-4.475L16.5 1.55 11.55 6.5l3.5 3.5Z"
        })
    });
var $8f62f5b380fff67a$export$2e2bcd8739ae039 = $8f62f5b380fff67a$var$SvgGlyphiconsBasic711VotingUrn;




const $6b41be15fe10a80e$var$SvgGlyphiconsBasic712Government = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.89 13h-9.78A5 5 0 0 1 15 9.1V4.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H17v2.1a5 5 0 0 1 3.89 3.9ZM28 19v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h4v-2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2h4a1 1 0 0 1 1 1ZM8 20.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm5-3a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm4 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm4 0a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm5 3a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z"
        })
    });
var $6b41be15fe10a80e$export$2e2bcd8739ae039 = $6b41be15fe10a80e$var$SvgGlyphiconsBasic712Government;




const $9d7a5dcabfb82c82$var$SvgGlyphiconsBasic713Announcement = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m10.13 20.133 2.953.909-.934 5.137a1 1 0 0 1-.984.821H9a1 1 0 0 1-1-1v-6h1.248a3.003 3.003 0 0 1 .882.133ZM9.248 11H6a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h3.248a5.003 5.003 0 0 1 1.47.221L23 22V7l-12.281 3.779a5.003 5.003 0 0 1-1.47.221ZM27 5h-1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $9d7a5dcabfb82c82$export$2e2bcd8739ae039 = $9d7a5dcabfb82c82$var$SvgGlyphiconsBasic713Announcement;




const $2b2949926fc8d250$var$SvgGlyphiconsBasic714Dustbin = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 7H7V5.057a1 1 0 0 1 1.055-.998l16 .889a1 1 0 0 1 .945.998Zm-2.5 12a5.455 5.455 0 0 1 2.5.607V9H6v2a1 1 0 0 0 1 1h.82a1 1 0 0 1 .979.794l2.867 13.618A2 2 0 0 0 13.623 28h4.638a5.497 5.497 0 0 1 4.239-9Zm3.5 5.5a3.5 3.5 0 1 1-3.5-3.5 3.5 3.5 0 0 1 3.5 3.5Zm-2 0a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5Z"
        })
    });
var $2b2949926fc8d250$export$2e2bcd8739ae039 = $2b2949926fc8d250$var$SvgGlyphiconsBasic714Dustbin;




const $ef94a1c05d8fbc01$var$SvgGlyphiconsBasic715Feather = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.945 5.144c-.514 5.386-4.52 10.654-7.942 14.248a1.98 1.98 0 0 1-1.438.608H16a1 1 0 0 0 0 2h1a1 1 0 0 1 0 2h-1a21.06 21.06 0 0 1-5.27-.784 68.015 68.015 0 0 0-2.878 4.308 1 1 0 1 1-1.704-1.048A69.31 69.31 0 0 1 7.39 24.54 52.163 52.163 0 0 1 18.1 13.8a1 1 0 1 0-1.222-1.584 56.074 56.074 0 0 0-8.742 8.18A15.796 15.796 0 0 1 7 15a1 1 0 0 1 2 0 1 1 0 0 0 2 0v-2.453a1.973 1.973 0 0 1 .632-1.459c3.281-3 8.615-6.69 15.283-7.058a1.004 1.004 0 0 1 1.03 1.114Z"
        })
    });
var $ef94a1c05d8fbc01$export$2e2bcd8739ae039 = $ef94a1c05d8fbc01$var$SvgGlyphiconsBasic715Feather;




const $7e256743de4a8020$var$SvgGlyphiconsBasic716Recycling = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 24v2a1 1 0 0 1-1 1H6.423a2 2 0 0 1-1.732-1l-1.212-2.098a2 2 0 0 1 0-2l2.244-3.886-1.977-1.142a.5.5 0 0 1 .037-.885l6.425-3.038a.5.5 0 0 1 .712.411l.582 7.084a.5.5 0 0 1-.748.474l-1.567-.905L7.464 23H11a1 1 0 0 1 1 1Zm4-15.785 1.63 2.823-1.884 1.088a.5.5 0 0 0 .037.885l6.425 3.038a.5.5 0 0 0 .712-.411l.582-7.084a.5.5 0 0 0-.748-.474l-1.66.958L18.762 5a2 2 0 0 0-1.732-1h-2.06a2 2 0 0 0-1.732 1l-2.515 4.355a1 1 0 0 0 .366 1.366l1.732 1a1 1 0 0 0 1.366-.366Zm12.52 13.687-2.426-4.204a1 1 0 0 0-1.366-.366l-1.732 1a1 1 0 0 0-.366 1.366L24.536 23H21v-2.046a.5.5 0 0 0-.785-.41l-5.843 4.045a.5.5 0 0 0 0 .822l5.843 4.046a.5.5 0 0 0 .785-.411V27h4.577a2 2 0 0 0 1.732-1l1.211-2.098a2 2 0 0 0 0-2Z"
        })
    });
var $7e256743de4a8020$export$2e2bcd8739ae039 = $7e256743de4a8020$var$SvgGlyphiconsBasic716Recycling;




const $5e4ac5bb964eaf41$var$SvgGlyphiconsBasic717HomeFire = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.66 15.66a.785.785 0 0 1-.555 1.34H24v10.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V17H4.895a.785.785 0 0 1-.555-1.34L15.47 4.53a.75.75 0 0 1 1.06 0l2.016 2.016C16.453 12.798 20.928 16 26.41 14.41Zm-.777-2.83c-.3.056-.498-.195-.276-.41a3.04 3.04 0 0 0 .956-1.91c.11-.92-.512-1.843-1.04-2.966a.246.246 0 0 0-.454.017c-.649 1.616-2.34 2.119-2.616 3.664a1.305 1.305 0 0 0 .27 1.178c.166.189.017.472-.283.425a3.786 3.786 0 0 1-3.338-4.045c0-1.522 1.685-3.092 1.545-4.744a.246.246 0 0 1 .38-.222 2.99 2.99 0 0 1 1.116 2.603.254.254 0 0 0 .436.216c1.51-1.57.454-3.828 2.241-5.629a.253.253 0 0 1 .43.194c-.04 2.268 3.416 4.676 3.64 7.4a3.661 3.661 0 0 1-3.007 4.23Z"
        })
    });
var $5e4ac5bb964eaf41$export$2e2bcd8739ae039 = $5e4ac5bb964eaf41$var$SvgGlyphiconsBasic717HomeFire;




const $f34d28a0d9844ed5$var$SvgGlyphiconsBasic718HomeFlood = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m6.74 11.168 6.886-7.748a.5.5 0 0 1 .748 0l6.886 7.748a.5.5 0 0 1-.373.832H19v5.083a1.38 1.38 0 0 0-.763.224L16 18.797V15.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v1.965l-2 1.333-1-.667V12H7.113a.5.5 0 0 1-.373-.832ZM4.555 22.832 7 21.202l2.237 1.491a1.41 1.41 0 0 0 1.526 0L13 21.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L19 21.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L25 21.203l2.445 1.629a1 1 0 0 0 1.11-1.664l-2.792-1.861a1.41 1.41 0 0 0-1.526 0L22 20.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L16 20.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L10 20.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0l-2.792 1.861a1 1 0 1 0 1.11 1.664Zm21.208 1.475a1.41 1.41 0 0 0-1.526 0L22 25.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L16 25.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L10 25.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0l-2.792 1.861a1 1 0 1 0 1.11 1.664L7 26.202l2.237 1.491a1.41 1.41 0 0 0 1.526 0L13 26.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L19 26.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L25 26.203l2.445 1.629a1 1 0 0 0 1.11-1.664Z"
        })
    });
var $f34d28a0d9844ed5$export$2e2bcd8739ae039 = $f34d28a0d9844ed5$var$SvgGlyphiconsBasic718HomeFlood;




const $1c14308c92940f87$var$SvgGlyphiconsBasic719Water = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.555 26.168a1 1 0 1 1-1.11 1.664L22 26.202l-2.237 1.491a1.41 1.41 0 0 1-1.526 0L16 26.203l-2.237 1.49a1.41 1.41 0 0 1-1.526 0L10 26.203l-2.445 1.629a1 1 0 0 1-1.11-1.664l2.792-1.861a1.41 1.41 0 0 1 1.526 0L13 25.797l2.237-1.49a1.41 1.41 0 0 1 1.526 0L19 25.797l2.237-1.49a1.41 1.41 0 0 1 1.526 0Zm.208-6.861a1.41 1.41 0 0 0-1.526 0L22 20.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L16 20.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L10 20.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0l-2.792 1.861a1 1 0 1 0 1.11 1.664L7 21.202l2.237 1.491a1.41 1.41 0 0 0 1.526 0L13 21.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L19 21.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L25 21.203l2.445 1.629a1 1 0 0 0 1.11-1.664Zm-4.526-5L19 15.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L13 15.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0l-2.792 1.861a1 1 0 1 0 1.11 1.664L10 16.202l2.237 1.491a1.41 1.41 0 0 0 1.526 0L16 16.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L22 16.203l2.445 1.629a1 1 0 0 0 1.11-1.664l-2.792-1.861a1.41 1.41 0 0 0-1.526 0ZM4.555 12.832 7 11.202l2.237 1.491a1.41 1.41 0 0 0 1.526 0L13 11.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L19 11.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L25 11.203l2.445 1.629a1 1 0 0 0 1.11-1.664l-2.792-1.861a1.41 1.41 0 0 0-1.526 0L22 10.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L16 10.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L10 10.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0l-2.792 1.861a1 1 0 1 0 1.11 1.664Zm3-5L10 6.202l2.237 1.491a1.41 1.41 0 0 0 1.526 0L16 6.203l2.237 1.49a1.41 1.41 0 0 0 1.526 0L22 6.203l2.445 1.629a1 1 0 1 0 1.11-1.664l-2.792-1.861a1.41 1.41 0 0 0-1.526 0L19 5.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L13 5.797l-2.237-1.49a1.41 1.41 0 0 0-1.526 0L6.445 6.168a1 1 0 0 0 1.11 1.664Z"
        })
    });
var $1c14308c92940f87$export$2e2bcd8739ae039 = $1c14308c92940f87$var$SvgGlyphiconsBasic719Water;




const $f1a9abb3a8775c87$var$SvgGlyphiconsBasic72Book = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 24a1.001 1.001 0 0 0 1 1h16v2a1 1 0 0 1-1 1H10a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h15a1 1 0 0 1 1 1v18H10a1.001 1.001 0 0 0-1 1Z"
        })
    });
var $f1a9abb3a8775c87$export$2e2bcd8739ae039 = $f1a9abb3a8775c87$var$SvgGlyphiconsBasic72Book;




const $0a8dedc95044372b$var$SvgGlyphiconsBasic720HomeForSale = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 9v1a1 1 0 0 1-1 1h-3v2h-2v-2h-5v2h-2v-2h-5v17H7V11H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3h17a1 1 0 0 1 1 1Zm-2 6.5v10a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5Zm-2.398 5.073-3.426-3.398a.25.25 0 0 0-.352 0l-3.426 3.398a.25.25 0 0 0 .176.427H17v2.75a.25.25 0 0 0 .25.25h1.5a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v1.5a.25.25 0 0 0 .25.25h1.5a.25.25 0 0 0 .25-.25V21h.426a.25.25 0 0 0 .176-.427Z"
        })
    });
var $0a8dedc95044372b$export$2e2bcd8739ae039 = $0a8dedc95044372b$var$SvgGlyphiconsBasic720HomeForSale;




const $afc156cb30d18b6f$var$SvgGlyphiconsBasic721Campfire = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m6.735 24.295 6.103 2.034-6.205 2.068a2 2 0 0 1-1.266-3.794l1.172-.391c.066.026.128.06.196.083Zm19.898.308-4.308-1.436 2.308-.77a2 2 0 0 0-1.266-3.794l-1.772.59A7.947 7.947 0 0 1 16 21.2a7.963 7.963 0 0 1-5.756-2.06l-1.611-.537a2 2 0 0 0-1.266 3.795l18 6a2 2 0 0 0 1.266-3.795Zm-12.89-6.092a.343.343 0 0 0 .385-.537 3.014 3.014 0 0 1-.01-2.548c.689-1.37 2.405-1.916 3.308-3.77a.247.247 0 0 1 .458.013c.454 1.426 1.663 2.009 1.663 3.543a6.621 6.621 0 0 1-1.223 2.805.338.338 0 0 0 .397.512 5.429 5.429 0 0 0 3.259-5.456c-.343-3.785-4.63-6.537-4.275-9.601a.251.251 0 0 0-.421-.217c-2.76 2.568-.998 5.87-3.46 8.058a.248.248 0 0 1-.399-.253 3.975 3.975 0 0 0-1.633-3.923.255.255 0 0 0-.373.271c.346 2.346-1.405 3.596-1.405 5.913a5.616 5.616 0 0 0 3.73 5.19Z"
        })
    });
var $afc156cb30d18b6f$export$2e2bcd8739ae039 = $afc156cb30d18b6f$var$SvgGlyphiconsBasic721Campfire;




const $fd93f4875813f12b$var$SvgGlyphiconsBasic722Fireplace = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 8h-4.4L21 4H11L9.4 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V13h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm-4 17H9V14a1 1 0 0 1 1-1h5.052c.111-.135.218-.27.348-.402a2.232 2.232 0 0 1 1.595-.666A2.232 2.232 0 0 1 18.907 13H22a1 1 0 0 1 1 1Zm-2.11-3.4a4.898 4.898 0 0 1-.083 1.4h-2.26a9.948 9.948 0 0 0-1.025-2.456.246.246 0 0 0-.453.017A9 9 0 0 1 15.076 23h-3.822a5.041 5.041 0 0 1-.152-1.217c0-1.522 1.685-3.092 1.545-4.744a.246.246 0 0 1 .38-.222 2.99 2.99 0 0 1 1.116 2.603.254.254 0 0 0 .436.216c1.51-1.57.454-3.828 2.241-5.629a.253.253 0 0 1 .43.194c-.04 2.268 3.416 4.676 3.64 7.4Z"
        })
    });
var $fd93f4875813f12b$export$2e2bcd8739ae039 = $fd93f4875813f12b$var$SvgGlyphiconsBasic722Fireplace;




const $00c34fe04340b700$var$SvgGlyphiconsBasic723Basket = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.303 12H8.697l3.555-5.332a1.5 1.5 0 0 1 2.496 1.664Zm7.394 0h3.606l-3.555-5.332a1.5 1.5 0 0 0-2.496 1.664ZM28 15v2a1 1 0 0 1-1 1h-1.5l-.82 8.199A2 2 0 0 1 22.69 28H9.31a2 2 0 0 1-1.99-1.801L6.5 18H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-16 8h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Z"
        })
    });
var $00c34fe04340b700$export$2e2bcd8739ae039 = $00c34fe04340b700$var$SvgGlyphiconsBasic723Basket;




const $af029475ada6460a$var$SvgGlyphiconsBasic724BasketIn = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 14H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1.5l.82 8.199A2 2 0 0 0 9.31 28h13.38a2 2 0 0 0 1.99-1.801L25.5 18H27a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM12 25h-2v-2h2Zm0-5h-2v-2h2Zm5 5h-2v-2h2Zm0-5h-2v-2h2Zm5 5h-2v-2h2Zm0-5h-2v-2h2ZM11.337 6.795A.5.5 0 0 1 11.741 6h2.096l.602-3.57a.5.5 0 0 1 .495-.43h1.132a.5.5 0 0 1 .495.43L17.163 6h2.096a.5.5 0 0 1 .404.795l-3.76 5.151a.5.5 0 0 1-.807 0ZM5.224 12l-1.662-1.33a1.5 1.5 0 0 1 1.875-2.34l4.59 3.67Zm23.213-1.33L26.777 12h-4.803l4.588-3.67a1.5 1.5 0 1 1 1.875 2.34Z"
        })
    });
var $af029475ada6460a$export$2e2bcd8739ae039 = $af029475ada6460a$var$SvgGlyphiconsBasic724BasketIn;




const $e2605a0dc841b71c$var$SvgGlyphiconsBasic725BasketOut = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m11.337 7.205 3.76-5.151a.5.5 0 0 1 .807 0l3.759 5.151a.5.5 0 0 1-.404.795h-2.096l-.602 3.57a.5.5 0 0 1-.495.43h-1.132a.5.5 0 0 1-.495-.43L13.837 8h-2.096a.5.5 0 0 1-.404-.795ZM28 15v2a1 1 0 0 1-1 1h-1.5l-.82 8.199A2 2 0 0 1 22.69 28H9.31a2 2 0 0 1-1.99-1.801L6.5 18H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-16 8h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Zm-11.974-6L5.437 8.33a1.5 1.5 0 0 0-1.875 2.34L5.224 12Zm18.645-3.438a1.5 1.5 0 0 0-2.109-.233L21.974 12h4.802l1.661-1.33a1.5 1.5 0 0 0 .234-2.107Z"
        })
    });
var $e2605a0dc841b71c$export$2e2bcd8739ae039 = $e2605a0dc841b71c$var$SvgGlyphiconsBasic725BasketOut;




const $e630732bb785221c$var$SvgGlyphiconsBasic726BasketCheckout = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 8.5v-2a.5.5 0 0 1 .5-.5H18V3.741a.5.5 0 0 1 .795-.404l5.151 3.76a.5.5 0 0 1 0 .807l-5.151 3.759a.5.5 0 0 1-.795-.404V9H9.5a.5.5 0 0 1-.5-.5ZM28 15v2a1 1 0 0 1-1 1h-1.5l-.82 8.199A2 2 0 0 1 22.69 28H9.31a2 2 0 0 1-1.99-1.801L6.5 18H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-16 8h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Z"
        })
    });
var $e630732bb785221c$export$2e2bcd8739ae039 = $e630732bb785221c$var$SvgGlyphiconsBasic726BasketCheckout;




const $bed418614c8db35d$var$SvgGlyphiconsBasic727BasketCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10.298 8.33a.5.5 0 0 1-.005-.665l1.174-1.342a.5.5 0 0 1 .645-.093L14.5 7.75l5.859-5.123a.5.5 0 0 1 .669.01l1.123 1.04a.5.5 0 0 1 .043.688l-6.706 8.005a1 1 0 0 1-1.509.028ZM28 15v2a1 1 0 0 1-1 1h-1.5l-.82 8.199A2 2 0 0 1 22.69 28H9.31a2 2 0 0 1-1.99-1.801L6.5 18H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1Zm-16 8h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Zm5 5h-2v2h2Zm0-5h-2v2h2Z"
        })
    });
var $bed418614c8db35d$export$2e2bcd8739ae039 = $bed418614c8db35d$var$SvgGlyphiconsBasic727BasketCheck;




const $bcd76765f8945e72$var$SvgGlyphiconsBasic728Firefighters = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.58 14.636c1.509-1.57.453-3.828 2.24-5.629a.253.253 0 0 1 .43.194c-.04 2.268 3.416 4.676 3.64 7.4a3.661 3.661 0 0 1-3.007 4.23c-.3.055-.498-.196-.276-.41a3.04 3.04 0 0 0 .956-1.91c.11-.92-.512-1.844-1.04-2.967a.246.246 0 0 0-.454.017c-.649 1.616-2.34 2.119-2.616 3.664a1.305 1.305 0 0 0 .27 1.178c.166.189.017.472-.283.425a3.786 3.786 0 0 1-3.338-4.045c0-1.522 1.685-3.092 1.545-4.744a.246.246 0 0 1 .38-.222 2.99 2.99 0 0 1 1.116 2.603.254.254 0 0 0 .436.216ZM27 8.121V15.5c0 7.815-9.88 13.106-10.302 13.327a1.497 1.497 0 0 1-1.396 0C14.88 28.607 5 23.315 5 15.5V8.121a2.505 2.505 0 0 1 1.454-2.27A23.567 23.567 0 0 1 16 4a23.567 23.567 0 0 1 9.546 1.85A2.505 2.505 0 0 1 27 8.122Zm-3 .327A21.336 21.336 0 0 0 16 7a21.336 21.336 0 0 0-8 1.448V15.5c0 4.567 5.24 8.634 7.991 10.273C18.051 24.526 24 20.49 24 15.5Z"
        })
    });
var $bcd76765f8945e72$export$2e2bcd8739ae039 = $bcd76765f8945e72$var$SvgGlyphiconsBasic728Firefighters;




const $f674651fcbb8acb9$var$SvgGlyphiconsBasic729Police = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.863 15.006-1.383 1.005-1.306.948.499 1.535.526 1.621a.331.331 0 0 1-.51.371l-1.38-1.002-1.305-.949-1.305.949-1.38 1.002a.331.331 0 0 1-.51-.37l.527-1.622.498-1.535-1.306-.948-1.383-1.005a.331.331 0 0 1 .195-.6h3.323l.498-1.534.528-1.625a.331.331 0 0 1 .63 0l.528 1.625.499 1.535h3.322a.331.331 0 0 1 .195.6Zm5.069-.716A12.327 12.327 0 0 1 27 18.5c0 5.828-9.352 9.934-10.418 10.383a1.504 1.504 0 0 1-1.164 0C14.352 28.433 5 24.328 5 18.5a12.327 12.327 0 0 1 1.068-4.21 2.478 2.478 0 0 0-.564-2.665l-.393-.393a1.5 1.5 0 0 1 0-2.12l4-4a1.5 1.5 0 0 1 1.617-.334 16.152 16.152 0 0 0 10.544 0 1.5 1.5 0 0 1 1.617.333l4 4a1.5 1.5 0 0 1 0 2.121l-.393.393a2.478 2.478 0 0 0-.564 2.665ZM24 18.5a9.528 9.528 0 0 0-.857-3.104 5.466 5.466 0 0 1 .62-5.166L21.437 7.9a19.522 19.522 0 0 1-10.872 0l-2.328 2.33a5.466 5.466 0 0 1 .621 5.166A9.528 9.528 0 0 0 8 18.5c0 3.008 5.415 6.151 8 7.357 2.585-1.206 8-4.35 8-7.357Z"
        })
    });
var $f674651fcbb8acb9$export$2e2bcd8739ae039 = $f674651fcbb8acb9$var$SvgGlyphiconsBasic729Police;




const $c4ebaab91d10a8d9$var$SvgGlyphiconsBasic73Bookmark = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 6v20.586a1 1 0 0 1-1.707.707L16.5 20.5l-6.793 6.793A1 1 0 0 1 8 26.586V6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2Z"
        })
    });
var $c4ebaab91d10a8d9$export$2e2bcd8739ae039 = $c4ebaab91d10a8d9$var$SvgGlyphiconsBasic73Bookmark;




const $c1a920682864a8e2$var$SvgGlyphiconsBasic730Ambulance = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 15v2a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1Zm5-6.5v15a3.504 3.504 0 0 1-3.5 3.5H8.55a3.504 3.504 0 0 1-3.5-3.5v-15A3.504 3.504 0 0 1 8.55 5H23.5A3.504 3.504 0 0 1 27 8.5Zm-3 0a.501.501 0 0 0-.5-.5H8.55a.501.501 0 0 0-.5.5v15a.501.501 0 0 0 .5.5H23.5a.501.501 0 0 0 .5-.5Z"
        })
    });
var $c1a920682864a8e2$export$2e2bcd8739ae039 = $c1a920682864a8e2$var$SvgGlyphiconsBasic730Ambulance;




const $1b65e5f8fb9d97d9$var$SvgGlyphiconsBasic731Ear = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.5 13.5c0 3.69-1.9 5.644-3.576 7.368a13.207 13.207 0 0 0-2.582 3.303c-1.235 2.47-3.194 3.886-5.374 3.886a5.286 5.286 0 0 1-4.685-2.356A1.5 1.5 0 0 1 12.82 24.1a2.347 2.347 0 0 0 2.148.957c.987 0 1.993-.833 2.69-2.228a16.005 16.005 0 0 1 3.115-4.05c1.583-1.63 2.727-2.807 2.727-5.279a7.501 7.501 0 0 0-14.905-1.202 1.5 1.5 0 0 1-2.961-.477A10.5 10.5 0 0 1 26.5 13.5ZM12 19a1.5 1.5 0 0 0 0 3 5 5 0 0 0 1.79-9.669 2.501 2.501 0 0 1 4.59 1.939 1.5 1.5 0 1 0 2.855.92A5.5 5.5 0 1 0 10.5 13.5 1.5 1.5 0 0 0 12 15a2 2 0 0 1 0 4Z"
        })
    });
var $1b65e5f8fb9d97d9$export$2e2bcd8739ae039 = $1b65e5f8fb9d97d9$var$SvgGlyphiconsBasic731Ear;




const $29663ae7d72fccd8$var$SvgGlyphiconsBasic732EarOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.04 10.428a10.462 10.462 0 0 1 .46 3.072c0 3.69-1.9 5.644-3.576 7.368a13.207 13.207 0 0 0-2.582 3.303c-1.235 2.47-3.194 3.886-5.374 3.886a5.34 5.34 0 0 1-4.481-2.077l2.132-2.132a1.5 1.5 0 0 1 .201.252 2.347 2.347 0 0 0 2.148.957c.987 0 1.993-.833 2.69-2.228a16.005 16.005 0 0 1 3.114-4.05c1.584-1.63 2.728-2.807 2.728-5.279 0-.171-.014-.34-.026-.508Zm1.675-5.367L5.56 27.215a1.5 1.5 0 0 1-2.122-2.121l9.719-9.719A1.983 1.983 0 0 0 12 15a1.5 1.5 0 0 1-1.5-1.5A5.507 5.507 0 0 1 16 8a5.443 5.443 0 0 1 3.362 1.17l1.421-1.42a7.476 7.476 0 0 0-12.188 4.548 1.5 1.5 0 0 1-2.961-.477 10.484 10.484 0 0 1 17.282-6.203l2.678-2.679a1.5 1.5 0 0 1 2.12 2.122Zm-10.507 6.264A2.47 2.47 0 0 0 16 11a2.503 2.503 0 0 0-2.21 1.331 5.001 5.001 0 0 1 1.5.912Z"
        })
    });
var $29663ae7d72fccd8$export$2e2bcd8739ae039 = $29663ae7d72fccd8$var$SvgGlyphiconsBasic732EarOff;




const $02dbd515d9f366d4$var$SvgGlyphiconsBasic733TheaterMasks = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17 6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v5c0 4.559 3.464 7.963 5.128 9.335a2.97 2.97 0 0 0 3.744 0C13.536 18.963 17 15.56 17 11ZM5 9.073a.927.927 0 0 1 .512-.83l1.89-.944a.927.927 0 0 1 1.07.173l.256.257A.927.927 0 0 1 9 8.384v.929a.927.927 0 0 1-1.152.899l-.737-.184A.93.93 0 0 0 6.886 10h-.959A.927.927 0 0 1 5 9.073Zm8.113 6.758A5.282 5.282 0 0 1 10 17a5.282 5.282 0 0 1-3.113-1.17.986.986 0 0 1 .943-1.707 6.432 6.432 0 0 0 4.34 0 .986.986 0 0 1 .943 1.708Zm.96-5.831h-.959a.93.93 0 0 0-.225.028l-.737.184a.927.927 0 0 1-1.152-.9v-.928a.927.927 0 0 1 .272-.656l.256-.256a.927.927 0 0 1 1.07-.173l1.89.945A.927.927 0 0 1 14.073 10ZM27 11h-8a11.38 11.38 0 0 1-.76 4.035l1.507-.565a.927.927 0 0 1 1.253.868v.778a.927.927 0 0 1-.272.656l-.39.39a.928.928 0 0 1-.809.26l-1.754-.293a.907.907 0 0 1-.422-.204 16.963 16.963 0 0 1-2.146 2.97c.761 3.6 3.497 6.266 4.92 7.44a2.97 2.97 0 0 0 3.745 0C25.536 25.963 29 22.56 29 18v-5a2 2 0 0 0-2-2Zm-2.83 12.377a6.432 6.432 0 0 0-4.34 0 .986.986 0 0 1-.943-1.708A5.281 5.281 0 0 1 22 20.5a5.281 5.281 0 0 1 3.113 1.17.986.986 0 0 1-.943 1.707ZM27 16.215a.927.927 0 0 1-.775.914l-1.754.293a.928.928 0 0 1-.808-.26l-.391-.39a.927.927 0 0 1-.272-.656v-.778a.927.927 0 0 1 1.253-.868l2.145.804a.927.927 0 0 1 .602.868Z"
        })
    });
var $02dbd515d9f366d4$export$2e2bcd8739ae039 = $02dbd515d9f366d4$var$SvgGlyphiconsBasic733TheaterMasks;




const $0b4093f6cd505be1$var$SvgGlyphiconsBasic734Kettlebell = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m22.506 13.842.914-1.827a5.527 5.527 0 0 0 .58-2.46V8.77a4.469 4.469 0 0 0-3.684-4.426A25.183 25.183 0 0 0 16 4a25.183 25.183 0 0 0-4.316.343A4.469 4.469 0 0 0 8 8.769v.787a5.534 5.534 0 0 0 .58 2.46l.899 1.796a8.975 8.975 0 0 0 1.3 13.511 3.835 3.835 0 0 0 2.232.677h5.97a3.891 3.891 0 0 0 2.28-.706 8.925 8.925 0 0 0 1.245-13.452ZM21 9.556a2.51 2.51 0 0 1-.264 1.118l-.667 1.334a8.777 8.777 0 0 0-3.79-1.004 8.972 8.972 0 0 0-4.362.976l-.653-1.305A2.517 2.517 0 0 1 11 9.555V8.77a1.474 1.474 0 0 1 1.201-1.471A22.24 22.24 0 0 1 16 7a22.24 22.24 0 0 1 3.799.298A1.474 1.474 0 0 1 21 8.768Z"
        })
    });
var $0b4093f6cd505be1$export$2e2bcd8739ae039 = $0b4093f6cd505be1$var$SvgGlyphiconsBasic734Kettlebell;




const $214f3a2cdeb18f22$var$SvgGlyphiconsBasic735Ticket = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.5 9H24V5a1 1 0 0 0-1-1h-3.85a3.481 3.481 0 0 1-6.3 0H9a1 1 0 0 0-1 1v4h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H8v16a1 1 0 0 0 1 1h3.85a3.481 3.481 0 0 1 6.3 0H23a1 1 0 0 0 1-1V11h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM15 10.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm5 0a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Z"
        })
    });
var $214f3a2cdeb18f22$export$2e2bcd8739ae039 = $214f3a2cdeb18f22$var$SvgGlyphiconsBasic735Ticket;




const $dd12f58ec7be21bc$var$SvgGlyphiconsBasic736TicketParking = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.5 9H24V5a1 1 0 0 0-1-1h-3.85a3.481 3.481 0 0 1-6.3 0H9a1 1 0 0 0-1 1v4h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H8v16a1 1 0 0 0 1 1h3.85a3.481 3.481 0 0 1 6.3 0H23a1 1 0 0 0 1-1V11h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm-10 2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5Zm4 10H15v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h2.9a3.565 3.565 0 0 1 3.525 2.765A3.506 3.506 0 0 1 16.5 21ZM20 10.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm-2 7a1.502 1.502 0 0 1-1.5 1.5H15v-3h1.5a1.502 1.502 0 0 1 1.5 1.5Z"
        })
    });
var $dd12f58ec7be21bc$export$2e2bcd8739ae039 = $dd12f58ec7be21bc$var$SvgGlyphiconsBasic736TicketParking;




const $ecb84f04849b2df5$var$SvgGlyphiconsBasic737ParkingMeter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 26h4v2h-4Zm5.802-18.188a.564.564 0 0 0-.681.293l-.93 2.032c.512.06 1.02.136 1.523.237l.447-1.914a.564.564 0 0 0-.36-.648ZM16 16h-1v2h1a1 1 0 0 0 0-2Zm9-9v5.197a6 6 0 0 1-.211 1.578l-2.186 8.014A3 3 0 0 1 19.709 24H12.29a3 3 0 0 1-2.894-2.21l-2.186-8.015A6 6 0 0 1 7 12.197V7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3Zm-6.058 9.402A3.08 3.08 0 0 0 15.882 14H13.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V20h1a3.005 3.005 0 0 0 2.942-3.598Zm2.309-9.66a18.945 18.945 0 0 0-10.502 0 1.009 1.009 0 0 0-.67 1.352l1.363 3.289a1 1 0 0 0 .924.617h7.268a1 1 0 0 0 .924-.617l1.362-3.29a1.009 1.009 0 0 0-.67-1.35Z"
        })
    });
var $ecb84f04849b2df5$export$2e2bcd8739ae039 = $ecb84f04849b2df5$var$SvgGlyphiconsBasic737ParkingMeter;




const $1e7ddd5f92191e8e$var$SvgGlyphiconsBasic738Parking = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18.776 15.568A2.436 2.436 0 0 1 16.518 17H14v-5h2.5a2.517 2.517 0 0 1 2.276 3.568ZM27 7v18a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2ZM16.5 9h-5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V20h2.5a5.246 5.246 0 0 0 5.5-5.5A5.246 5.246 0 0 0 16.5 9Z"
        })
    });
var $1e7ddd5f92191e8e$export$2e2bcd8739ae039 = $1e7ddd5f92191e8e$var$SvgGlyphiconsBasic738Parking;




const $d112d3a9e8dea936$var$SvgGlyphiconsBasic739Check = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.376 9.705 13.225 25.682a1 1 0 0 1-1.476.023l-7.152-7.573a1 1 0 0 1-.054-1.311l.952-1.19a1 1 0 0 1 1.228-.27L12 18 24.797 7.099a1 1 0 0 1 1.356.054l1.181 1.181a1 1 0 0 1 .042 1.37Z"
        })
    });
var $d112d3a9e8dea936$export$2e2bcd8739ae039 = $d112d3a9e8dea936$var$SvgGlyphiconsBasic739Check;




const $ac2c3326b8ec58a9$var$SvgGlyphiconsBasic74Wifi = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.832 18.139a1.01 1.01 0 0 1 .203 1.477l-.645.769a.988.988 0 0 1-1.313.188 8.982 8.982 0 0 0-10.154 0 .988.988 0 0 1-1.313-.188l-.645-.769a1.01 1.01 0 0 1 .203-1.477 11.981 11.981 0 0 1 13.664 0Zm-3.95 4.627a6.132 6.132 0 0 0-5.764 0 .99.99 0 0 0-.25 1.502l2.75 3.277a.5.5 0 0 0 .765 0l2.75-3.277a.99.99 0 0 0-.251-1.502ZM16 10a18.015 18.015 0 0 0-10.76 3.577.991.991 0 0 0-.145 1.428l.645.768a.989.989 0 0 0 1.339.175 14.973 14.973 0 0 1 17.842 0 .989.989 0 0 0 1.339-.175l.645-.768a.991.991 0 0 0-.145-1.428A18.015 18.015 0 0 0 16 10Zm14.626-1.025a23.986 23.986 0 0 0-29.252 0 .998.998 0 0 0-.14 1.429l.645.768a1.002 1.002 0 0 0 1.383.136 20.986 20.986 0 0 1 25.476 0 1.002 1.002 0 0 0 1.383-.136l.645-.768a.998.998 0 0 0-.14-1.429Z"
        })
    });
var $ac2c3326b8ec58a9$export$2e2bcd8739ae039 = $ac2c3326b8ec58a9$var$SvgGlyphiconsBasic74Wifi;




const $42d4fdc7e48ef092$var$SvgGlyphiconsBasic740Hash = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.06 11h-3.755l.833-4.83A1 1 0 0 0 22.152 5h-2.029a1 1 0 0 0-.985.83L18.247 11h-2.942l.833-4.83A1 1 0 0 0 15.152 5h-2.029a1 1 0 0 0-.985.83L11.247 11h-4.1a1 1 0 0 0-.985.83l-.345 2A1 1 0 0 0 6.803 15h3.754l-.517 3h-4.1a1 1 0 0 0-.985.83l-.345 2A1 1 0 0 0 5.596 22H9.35l-.833 4.83A1 1 0 0 0 9.503 28h2.029a1 1 0 0 0 .985-.83L13.41 22h2.941l-.833 4.83a1 1 0 0 0 .986 1.17h2.029a1 1 0 0 0 .985-.83L20.41 22h4.099a1 1 0 0 0 .985-.83l.345-2a1 1 0 0 0-.985-1.17h-3.755l.518-3h4.099a1 1 0 0 0 .985-.83l.345-2a1 1 0 0 0-.986-1.17Zm-9.02 7h-2.942l.518-3h2.941Z"
        })
    });
var $42d4fdc7e48ef092$export$2e2bcd8739ae039 = $42d4fdc7e48ef092$var$SvgGlyphiconsBasic740Hash;




const $897eaa24073b59a3$var$SvgGlyphiconsBasic741AlignTop = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 9v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm12-5H5a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2Zm0 5v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm-2 1h-6v6h6Z"
        })
    });
var $897eaa24073b59a3$export$2e2bcd8739ae039 = $897eaa24073b59a3$var$SvgGlyphiconsBasic741AlignTop;




const $b00abaaad5b16127$var$SvgGlyphiconsBasic742AlignBottom = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5 23V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Zm22 3H5a1 1 0 0 0 0 2h22a1 1 0 0 0 0-2Zm-10-3v-8a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1Zm2-1h6v-6h-6Z"
        })
    });
var $b00abaaad5b16127$export$2e2bcd8739ae039 = $b00abaaad5b16127$var$SvgGlyphiconsBasic742AlignBottom;




const $6600cd0799c4826e$var$SvgGlyphiconsBasic743AlignHorizontal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 15h-1v-3a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v3h-2V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8h2v3a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3h1a1 1 0 0 0 0-2Zm-3 4h-6v-6h6Z"
        })
    });
var $6600cd0799c4826e$export$2e2bcd8739ae039 = $6600cd0799c4826e$var$SvgGlyphiconsBasic743AlignHorizontal;




const $f4575ce44041ce54$var$SvgGlyphiconsBasic744AlignLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 18v8a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1ZM5 4a1 1 0 0 0-1 1v22a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1Zm3 10V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Zm2-1h6V7h-6Z"
        })
    });
var $f4575ce44041ce54$export$2e2bcd8739ae039 = $f4575ce44041ce54$var$SvgGlyphiconsBasic744AlignLeft;




const $fc4d85f2b4bab7e8$var$SvgGlyphiconsBasic745AlignVertical = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 18h-8v-2h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-3V5a1 1 0 0 0-2 0v1h-3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3v2H7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Zm-12-4V8h6v6Z"
        })
    });
var $fc4d85f2b4bab7e8$export$2e2bcd8739ae039 = $fc4d85f2b4bab7e8$var$SvgGlyphiconsBasic745AlignVertical;




const $793d0e48f09b5f7c$var$SvgGlyphiconsBasic746AlignRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 18v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1Zm3-14a1 1 0 0 0-1 1v22a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1Zm-3 2v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm-2 1h-6v6h6Z"
        })
    });
var $793d0e48f09b5f7c$export$2e2bcd8739ae039 = $793d0e48f09b5f7c$var$SvgGlyphiconsBasic746AlignRight;




const $144235d8954528f7$var$SvgGlyphiconsBasic747ReflectY = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6.709 9.293A1 1 0 0 0 5.002 10v12a1 1 0 0 0 1.707.707l6-6a1 1 0 0 0 0-1.414Zm.293 10.293v-7.172L10.588 16Zm20-9.586v12a1 1 0 0 1-1.707.707l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.707.707ZM17 25.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-4v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-12v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0 4v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0 4v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $144235d8954528f7$export$2e2bcd8739ae039 = $144235d8954528f7$var$SvgGlyphiconsBasic747ReflectY;




const $76de35a40e6ac143$var$SvgGlyphiconsBasic748ReflectX = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.293 12.709a1 1 0 0 0 1.414 0l6-6A1 1 0 0 0 22 5.002H10a1 1 0 0 0-.707 1.707Zm4.293-5.707L16 10.588l-3.586-3.586Zm3.121 18.293A1 1 0 0 1 22 27.002H10a1 1 0 0 1-.707-1.707l6-6a1 1 0 0 1 1.414 0ZM14.5 15a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5Zm12.5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm-8.5-.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5ZM7 15.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm16 0v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm-14 1v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5Z"
        })
    });
var $76de35a40e6ac143$export$2e2bcd8739ae039 = $76de35a40e6ac143$var$SvgGlyphiconsBasic748ReflectX;




const $4079dff3cb040259$var$SvgGlyphiconsBasic749ResizeHorizontal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 14v3a1 1 0 0 1-1 1h-3v1.945a1 1 0 0 1-1.617.786l-5.666-4.444a1 1 0 0 1 0-1.574l5.666-4.444a1 1 0 0 1 1.617.786V13h3a1 1 0 0 1 1 1Zm13.283.713-5.666-4.444a1 1 0 0 0-1.617.786V13h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3v1.945a1 1 0 0 0 1.617.786l5.666-4.444a1 1 0 0 0 0-1.574Z"
        })
    });
var $4079dff3cb040259$export$2e2bcd8739ae039 = $4079dff3cb040259$var$SvgGlyphiconsBasic749ResizeHorizontal;




const $3d0646cca8e8ae7f$var$SvgGlyphiconsBasic75Cup = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 26v1a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm5.595-18.74A2.98 2.98 0 0 0 25 6h-2V5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v1H7a2.98 2.98 0 0 0-2.595 1.26 2.979 2.979 0 0 0-.074 2.885l2.518 5.538A6.07 6.07 0 0 0 12 19h2v2h-1a1 1 0 0 0-1 1v1h8v-1a1 1 0 0 0-1-1h-1v-2h2a6.07 6.07 0 0 0 5.151-3.317l2.518-5.538a2.978 2.978 0 0 0-.074-2.884ZM12 17a4.181 4.181 0 0 1-3.331-2.145c-.513-1.105-2.518-5.538-2.518-5.538a1.061 1.061 0 0 1-.064-.973A1.06 1.06 0 0 1 7 8h2v1.059a7.277 7.277 0 0 0 1.169 3.623L13.279 17Zm13.849-7.683s-2.104 4.643-2.518 5.538A4.553 4.553 0 0 1 20 17h-1.28l3.111-4.318A7.277 7.277 0 0 0 23 9.059V8h2a1.06 1.06 0 0 1 .913.344 1.06 1.06 0 0 1-.064.973Z"
        })
    });
var $3d0646cca8e8ae7f$export$2e2bcd8739ae039 = $3d0646cca8e8ae7f$var$SvgGlyphiconsBasic75Cup;




const $ad4f474f2a99b890$var$SvgGlyphiconsBasic750ResizeVertical = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m20.731 22.617-4.444 5.666a1 1 0 0 1-1.574 0l-4.444-5.666A1 1 0 0 1 11.055 21H13v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3h1.945a1 1 0 0 1 .786 1.617ZM11.055 11H13v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3h1.945a1 1 0 0 0 .786-1.617l-4.444-5.666a1 1 0 0 0-1.574 0L10.27 9.383A1 1 0 0 0 11.055 11Z"
        })
    });
var $ad4f474f2a99b890$export$2e2bcd8739ae039 = $ad4f474f2a99b890$var$SvgGlyphiconsBasic750ResizeVertical;




const $ecf4d77ab3f582ea$var$SvgGlyphiconsBasic751CallRedirect = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.647 6.646a.5.5 0 0 1 0-.707l2.146-2.146-.706-.706a.444.444 0 0 1 .227-.75l3.532-.706a.445.445 0 0 1 .523.523l-.706 3.532a.444.444 0 0 1-.75.227l-.706-.706-2.146 2.147a.5.5 0 0 1-.708 0Zm-.462 12.6a1 1 0 0 0-1.414 0l-1.807 1.807a1.004 1.004 0 0 1-1.321.082 40.758 40.758 0 0 1-4.584-4.077 40.737 40.737 0 0 1-4.076-4.583 1.004 1.004 0 0 1 .082-1.322l1.806-1.806a1 1 0 0 0 0-1.414l-2.828-2.83a1 1 0 0 0-1.414 0L6.876 6.858a5 5 0 0 0-1.183 5.2c.694 1.971 2.365 4.872 5.93 8.438s6.466 5.235 8.438 5.93a5.001 5.001 0 0 0 5.2-1.183l1.753-1.753a1 1 0 0 0 0-1.415ZM28 10h-6V4h2V2h-2a2.003 2.003 0 0 0-2 2v6a2.003 2.003 0 0 0 2 2h6a2.003 2.003 0 0 0 2-2V8h-2Z"
        })
    });
var $ecf4d77ab3f582ea$export$2e2bcd8739ae039 = $ecf4d77ab3f582ea$var$SvgGlyphiconsBasic751CallRedirect;




const $8a35dd81783d8260$var$SvgGlyphiconsBasic752CallIp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0ZM21.5 10h1a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5ZM31 3v2a2 2 0 0 1-2 2h-2v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5H29a2 2 0 0 1 2 2Zm-2 .5a.5.5 0 0 0-.5-.5H27v2h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $8a35dd81783d8260$export$2e2bcd8739ae039 = $8a35dd81783d8260$var$SvgGlyphiconsBasic752CallIp;




const $46fe0e8db4d255bf$var$SvgGlyphiconsBasic753CallRecord = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0ZM32 6a6 6 0 1 1-6-6 6.007 6.007 0 0 1 6 6Zm-2 0a4 4 0 1 0-4 4 4.004 4.004 0 0 0 4-4Zm-4-2a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
        })
    });
var $46fe0e8db4d255bf$export$2e2bcd8739ae039 = $46fe0e8db4d255bf$var$SvgGlyphiconsBasic753CallRecord;




const $a469906da540a66f$var$SvgGlyphiconsBasic754CallMusic = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0ZM31.371 1.75l-3-1.2A1 1 0 0 0 27 1.477v5.536a1.053 1.053 0 0 1-.765.973l-1.68.647a1.97 1.97 0 0 0-1.553 1.768 2.238 2.238 0 0 0 2.487 2.362l1.022-.193A2.54 2.54 0 0 0 29 9.834V4.8l1.629.651A1 1 0 0 0 32 4.523V2.677a1 1 0 0 0-.629-.928Z"
        })
    });
var $a469906da540a66f$export$2e2bcd8739ae039 = $a469906da540a66f$var$SvgGlyphiconsBasic754CallMusic;




const $dd8554c857e3c525$var$SvgGlyphiconsBasic755CallData = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0Zm4.71-19.471L28.803.372A.5.5 0 0 0 28 .769V2h-4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H28v1.231a.5.5 0 0 0 .804.397l2.919-2.23a.5.5 0 0 0 0-.795ZM29.5 7H25V5.769a.5.5 0 0 0-.804-.397l-2.919 2.23a.5.5 0 0 0 0 .795l2.92 2.231a.5.5 0 0 0 .803-.397V9h4.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
        })
    });
var $dd8554c857e3c525$export$2e2bcd8739ae039 = $dd8554c857e3c525$var$SvgGlyphiconsBasic755CallData;




const $6abcf13139b82e8b$var$SvgGlyphiconsBasic756CallPause = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0ZM23.5 10h2a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5Zm7-9h-2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5Z"
        })
    });
var $6abcf13139b82e8b$export$2e2bcd8739ae039 = $6abcf13139b82e8b$var$SvgGlyphiconsBasic756CallPause;




const $7c70b4bfe3d8e5ad$var$SvgGlyphiconsBasic757CallIncoming = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0Zm3.23-11.831a6 6 0 1 1 0-8.486 6 6 0 0 1 0 8.486Zm-1.768-6.01-.707-.708a.5.5 0 0 0-.707 0l-1.768 1.768-.812-.812a.5.5 0 0 0-.852.318l-.234 3.272a.5.5 0 0 0 .534.534l3.272-.234a.5.5 0 0 0 .318-.852l-.812-.812 1.768-1.768a.5.5 0 0 0 0-.707Z"
        })
    });
var $7c70b4bfe3d8e5ad$export$2e2bcd8739ae039 = $7c70b4bfe3d8e5ad$var$SvgGlyphiconsBasic757CallIncoming;




const $c4da3362883208f9$var$SvgGlyphiconsBasic758CallOutgoing = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0Zm3.23-11.831a6 6 0 1 1 0-8.486 6 6 0 0 1 0 8.486Zm-1.638-6.314a.5.5 0 0 0-.534-.534l-3.272.234a.5.5 0 0 0-.318.852l.812.812-1.768 1.768a.5.5 0 0 0 0 .707l.707.707a.5.5 0 0 0 .707 0l1.768-1.768.812.812a.5.5 0 0 0 .852-.318Z"
        })
    });
var $c4da3362883208f9$export$2e2bcd8739ae039 = $c4da3362883208f9$var$SvgGlyphiconsBasic758CallOutgoing;




const $e46a5c02732480ba$var$SvgGlyphiconsBasic759CallVideo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0ZM21 9h5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1Zm10.188-7.35L29 3.4v3.2l2.188 1.75A.5.5 0 0 0 32 7.96V2.04a.5.5 0 0 0-.812-.39Z"
        })
    });
var $e46a5c02732480ba$export$2e2bcd8739ae039 = $e46a5c02732480ba$var$SvgGlyphiconsBasic759CallVideo;




const $40fb218e56443fd4$var$SvgGlyphiconsBasic76Stroller = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m25.73 17.053 1.855-4.947a3 3 0 0 0-.036-2.198l-1.512-3.664a1 1 0 0 0-.487-.518L22.207 4.1A1 1 0 0 0 21.77 4h-5.107a.5.5 0 0 0-.48.637L18 11h-7.61A4.973 4.973 0 0 0 8.01 9.782L4.196 9.02a1 1 0 0 0-.392 1.96l3.443.69 2.547 6.898-.546 2.457a3.503 3.503 0 1 0 1.952.433L11.747 19h3.839l3.847 3.847A3.46 3.46 0 0 0 19 24.5a3.5 3.5 0 1 0 3.5-3.5 3.46 3.46 0 0 0-1.653.433L18.414 19h4.507a3 3 0 0 0 2.809-1.947ZM9.5 26a1.5 1.5 0 1 1 1.5-1.5A1.502 1.502 0 0 1 9.5 26Zm13-3a1.5 1.5 0 1 1-1.5 1.5 1.502 1.502 0 0 1 1.5-1.5Z"
        })
    });
var $40fb218e56443fd4$export$2e2bcd8739ae039 = $40fb218e56443fd4$var$SvgGlyphiconsBasic76Stroller;




const $5871b079587ba96e$var$SvgGlyphiconsBasic760CallLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.013 22.074a1 1 0 0 1 0 1.415l-1.752 1.753a5.001 5.001 0 0 1-5.2 1.182c-1.972-.694-4.873-2.364-8.438-5.93s-5.236-6.466-5.93-8.438a5 5 0 0 1 1.183-5.2l1.753-1.752a1 1 0 0 1 1.414 0l2.828 2.829a1 1 0 0 1 0 1.414l-1.806 1.806a1.004 1.004 0 0 0-.082 1.322 40.737 40.737 0 0 0 4.076 4.583 40.758 40.758 0 0 0 4.584 4.077 1.004 1.004 0 0 0 1.321-.082l1.807-1.807a1 1 0 0 1 1.414 0ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $5871b079587ba96e$export$2e2bcd8739ae039 = $5871b079587ba96e$var$SvgGlyphiconsBasic760CallLock;




const $5a2964e31abfd56a$var$SvgGlyphiconsBasic761Sync = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m23.317 16.691-1.997 2.997a.445.445 0 0 1-.74 0l-1.998-2.997a.445.445 0 0 1 .37-.691h1.025c0-.08.019-.157.014-.238a3.966 3.966 0 0 0-1.16-2.585 4.011 4.011 0 0 0-.177-.167 3.972 3.972 0 0 0-2.892-1.001 3.869 3.869 0 0 0-1.374.347.51.51 0 0 1-.645-.166l-.57-.856a.495.495 0 0 1 .174-.717 6.001 6.001 0 0 1 8.64 5.026c.007.12-.01.237-.01.357h.97a.445.445 0 0 1 .37.691Zm-5.06 3.12a.51.51 0 0 0-.645-.167 3.866 3.866 0 0 1-1.374.347 3.998 3.998 0 0 1-4.23-3.753s.014-.158.015-.238h1.025a.445.445 0 0 0 .37-.691l-1.998-2.997a.445.445 0 0 0-.74 0L8.683 15.31a.444.444 0 0 0 .37.69l.97.001c0 .12-.018.237-.01.357a5.951 5.951 0 0 0 1.74 3.879l.07.07a6 6 0 0 0 6.83 1.077.495.495 0 0 0 .175-.718Zm6.228 4.674a12 12 0 1 1 0-16.97 11.96 11.96 0 0 1 0 16.97Zm-2.12-14.85a9 9 0 1 0 0 12.73 8.972 8.972 0 0 0 0-12.73Z"
        })
    });
var $5a2964e31abfd56a$export$2e2bcd8739ae039 = $5a2964e31abfd56a$var$SvgGlyphiconsBasic761Sync;




const $d1b237aaaaeebc52$var$SvgGlyphiconsBasic762SyncAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m18.257 19.81.57.856a.495.495 0 0 1-.175.717 6 6 0 0 1-6.828-1.077l-.072-.07a5.951 5.951 0 0 1-1.74-3.879c-.007-.12.01-.237.01-.357h-.97a.444.444 0 0 1-.37-.691l1.998-2.997a.445.445 0 0 1 .74 0l1.998 2.997a.445.445 0 0 1-.37.691h-1.025c0 .08-.014.238-.014.238a3.998 3.998 0 0 0 4.229 3.753 3.866 3.866 0 0 0 1.374-.347.51.51 0 0 1 .645.166Zm.695-3.81a.445.445 0 0 0-.37.691l1.998 2.997a.445.445 0 0 0 .74 0l1.997-2.997a.445.445 0 0 0-.37-.691h-.97c0-.12.018-.237.01-.357A6.019 6.019 0 0 0 21.654 14H19.5c-.019 0-.037-.003-.056-.004a3.96 3.96 0 0 1 .547 1.766c.005.08-.013.158-.014.238Zm-3.309-5.988a5.988 5.988 0 0 0-2.296.605.495.495 0 0 0-.175.717l.57.856a.51.51 0 0 0 .646.166 3.869 3.869 0 0 1 1.374-.347 3.997 3.997 0 0 1 .6.023 3.492 3.492 0 0 1-.325-2.024c-.131 0-.262-.003-.394.004ZM24.763 14a9.052 9.052 0 1 1-7.305-6.87l1.654-2.706A12.003 12.003 0 1 0 27.817 14Zm7.046-2.767A1.5 1.5 0 0 1 30.5 12h-11a1.5 1.5 0 0 1-1.28-2.282l5.5-9a1.5 1.5 0 0 1 2.56 0l5.5 9a1.503 1.503 0 0 1 .029 1.515ZM26 8.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Zm0-5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5Z"
        })
    });
var $d1b237aaaaeebc52$export$2e2bcd8739ae039 = $d1b237aaaaeebc52$var$SvgGlyphiconsBasic762SyncAlert;




const $4e1535dda682a6bb$var$SvgGlyphiconsBasic763SyncCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.987 15.643c.008.12-.01.237-.01.357h.97a.445.445 0 0 1 .37.691l-1.997 2.997a.445.445 0 0 1-.74 0l-1.998-2.997a.445.445 0 0 1 .37-.691h1.025c0-.08.019-.157.014-.238a3.966 3.966 0 0 0-1.16-2.585 4.011 4.011 0 0 0-.177-.167 3.972 3.972 0 0 0-2.892-1.001 3.869 3.869 0 0 0-1.374.347.51.51 0 0 1-.645-.166l-.57-.856a.495.495 0 0 1 .175-.717 6.001 6.001 0 0 1 8.64 5.026Zm-10.234 4.593.065.064a6 6 0 0 0 6.834 1.084.496.496 0 0 0 .175-.719l-.57-.855a.51.51 0 0 0-.645-.166 3.866 3.866 0 0 1-1.374.347 3.998 3.998 0 0 1-4.23-3.753s.014-.158.015-.238h1.025a.445.445 0 0 0 .37-.691l-1.998-2.997a.445.445 0 0 0-.74 0L8.683 15.31a.444.444 0 0 0 .37.69l.97.001c0 .12-.018.237-.01.357a5.951 5.951 0 0 0 1.74 3.879ZM26 14a7.987 7.987 0 0 1-1.264-.11 9.036 9.036 0 1 1-6.626-6.627A7.982 7.982 0 0 1 18 6a7.973 7.973 0 0 1 .209-1.788 12 12 0 1 0 9.578 9.58A7.974 7.974 0 0 1 26 14Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-2.852-2.234-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.096l-.433.554a.297.297 0 0 0 .027.377l2.233 2.236a.83.83 0 0 0 1.298-.1L29.2 4.118a.254.254 0 0 0-.052-.352Z"
        })
    });
var $4e1535dda682a6bb$export$2e2bcd8739ae039 = $4e1535dda682a6bb$var$SvgGlyphiconsBasic763SyncCheck;




const $972776479f6a3961$var$SvgGlyphiconsBasic764ModalWindow = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-12A3.504 3.504 0 0 0 9 7.5v12a3.504 3.504 0 0 0 3.5 3.5h12a3.504 3.504 0 0 0 3.5-3.5v-12A3.504 3.504 0 0 0 24.5 4Zm.5 15.5a.506.506 0 0 1-.5.5h-12a.506.506 0 0 1-.5-.5v-12a.506.506 0 0 1 .5-.5h12a.506.506 0 0 1 .5.5ZM7.5 25h15.45a3.495 3.495 0 0 1-3.45 3h-12A3.504 3.504 0 0 1 4 24.5v-12a3.495 3.495 0 0 1 3-3.45V24.5a.506.506 0 0 0 .5.5ZM22 16v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1Z"
        })
    });
var $972776479f6a3961$export$2e2bcd8739ae039 = $972776479f6a3961$var$SvgGlyphiconsBasic764ModalWindow;




const $0ee8fd63883361e1$var$SvgGlyphiconsBasic765Gas = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 18.5a8.58 8.58 0 0 1-3.46 7.184.498.498 0 0 1-.751-.617c1.859-3.72-.618-6.463-2.45-9.072a.5.5 0 0 0-.767-.067c-1.775 1.788-3.788 4.07-2.528 7.612a.501.501 0 0 1-.813.533C5.32 17.56 11.888 9.255 17.385 4.52a.495.495 0 0 1 .8.27C19.414 9.429 23 13.766 23 18.5Z"
        })
    });
var $0ee8fd63883361e1$export$2e2bcd8739ae039 = $0ee8fd63883361e1$var$SvgGlyphiconsBasic765Gas;




const $ce6ef28531121793$var$SvgGlyphiconsBasic766WastePipe = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 12.31V10a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v2.31a9 9 0 1 0 12 0Zm-.291 8.53a8.873 8.873 0 0 0-3.233-.857 4.721 4.721 0 0 0-2.708 1.023 4.01 4.01 0 0 1-2.397.9 5.11 5.11 0 0 1-3.17-1.395 5.997 5.997 0 1 1 11.508.329ZM8 6V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z"
        })
    });
var $ce6ef28531121793$export$2e2bcd8739ae039 = $ce6ef28531121793$var$SvgGlyphiconsBasic766WastePipe;




const $f37c9a2014ed6281$var$SvgGlyphiconsBasic767WastePipeEnd = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 5v14a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm-6 1H4v12h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm8 9.761v2.052c1.543 1.86 1 2.878 1 4.187a3 3 0 0 0 6 0c0-1.51-2.232-5.232-7-6.239Z"
        })
    });
var $f37c9a2014ed6281$export$2e2bcd8739ae039 = $f37c9a2014ed6281$var$SvgGlyphiconsBasic767WastePipeEnd;




const $b081607f07b70f6c$var$SvgGlyphiconsBasic768Toilet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11 15h16v1c0 3.866-3 6-6 7s-3 5-3 5h-7v-3.307a2.033 2.033 0 0 0-1.487-1.918A5.002 5.002 0 0 1 6 18V5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1Zm15-4H13v2h14v-1a1 1 0 0 0-1-1Z"
        })
    });
var $b081607f07b70f6c$export$2e2bcd8739ae039 = $b081607f07b70f6c$var$SvgGlyphiconsBasic768Toilet;




const $334516b8094d4270$var$SvgGlyphiconsBasic769DrinkingWater = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 11H4V7h6V5H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v2h3a5.006 5.006 0 0 1 5 5v2h-4v-2a1 1 0 0 0-1-1Zm9.98 6.196-2 10A1 1 0 0 1 23 28h-7a1 1 0 0 1-.98-.804l-2-10A1 1 0 0 1 14 16h11a1 1 0 0 1 .98 1.196Zm-2.2.804h-8.56l.4 2h7.76Z"
        })
    });
var $334516b8094d4270$export$2e2bcd8739ae039 = $334516b8094d4270$var$SvgGlyphiconsBasic769DrinkingWater;




const $32b60f0ea67fbd29$var$SvgGlyphiconsBasic77Headphones = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 16v7.459a3 3 0 0 1-2.507 2.959l-2.329.388A1 1 0 0 1 22 25.82v-6.64a1 1 0 0 1 1.164-.986L25 18.5V16a9 9 0 0 0-18 0v2.5l1.836-.306A1 1 0 0 1 10 19.18v6.64a1 1 0 0 1-1.164.986l-2.33-.388A3 3 0 0 1 4 23.458V16a12 12 0 0 1 24 0Z"
        })
    });
var $32b60f0ea67fbd29$export$2e2bcd8739ae039 = $32b60f0ea67fbd29$var$SvgGlyphiconsBasic77Headphones;




const $e385a38ab76eb4d2$var$SvgGlyphiconsBasic770DrinkingWaterOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.443 19.534C23.529 21.542 25 22.254 25 24a3 3 0 0 1-6 0c0-1.747 1.47-2.458 2.557-4.466a.5.5 0 0 1 .886 0ZM24 12l-.003-.03L20 15.967V17h4Zm3.215-9.06a1.5 1.5 0 0 0-2.121 0l-4.375 4.375A4.865 4.865 0 0 0 19 7h-6V5h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v2H4v4h13.033L2.94 25.094a1.5 1.5 0 1 0 2.122 2.12L27.215 5.062a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $e385a38ab76eb4d2$export$2e2bcd8739ae039 = $e385a38ab76eb4d2$var$SvgGlyphiconsBasic770DrinkingWaterOff;




const $985bebe7806ac47b$var$SvgGlyphiconsBasic771Apple = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.311 25.911a4.652 4.652 0 0 1-5.459 1.73L16 27.16l-1.852.48a4.652 4.652 0 0 1-5.459-1.729C6.529 22.087 4.25 16.6 7.75 12.8c1.995-2.166 4.72-1.862 6.695-1.2l-1.1-3.715a1 1 0 0 1 .675-1.243l.96-.284a1 1 0 0 1 1.242.675l1.35 4.561c1.974-.657 4.688-.954 6.678 1.206 3.5 3.8 1.22 9.287-.939 13.111Zm.517-22.74a4.68 4.68 0 0 0-5.656 5.657 4.68 4.68 0 0 0 5.656-5.656Z"
        })
    });
var $985bebe7806ac47b$export$2e2bcd8739ae039 = $985bebe7806ac47b$var$SvgGlyphiconsBasic771Apple;




const $08abbaedc001b336$var$SvgGlyphiconsBasic772Neighborhood = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.905 16H29v5.5a.5.5 0 0 1-.5.5H23v-4h3.227a1 1 0 0 0 .747-1.664l-4.185-4.708 2.333-2.692a.5.5 0 0 1 .756 0l5.405 6.237a.5.5 0 0 1-.378.827Zm-25.88.336 4.186-4.708-2.333-2.692a.5.5 0 0 0-.756 0L.717 15.173a.5.5 0 0 0 .378.827H3v5.5a.5.5 0 0 0 .5.5H9v-4H5.773a1 1 0 0 1-.747-1.664Zm18.235-1.168L16.374 7.42a.5.5 0 0 0-.748 0L8.74 15.168a.5.5 0 0 0 .373.832H11v7.5a.5.5 0 0 0 .5.5H14v-3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V24h2.5a.5.5 0 0 0 .5-.5V16h1.887a.5.5 0 0 0 .373-.832Z"
        })
    });
var $08abbaedc001b336$export$2e2bcd8739ae039 = $08abbaedc001b336$var$SvgGlyphiconsBasic772Neighborhood;




const $aaddf367bcf6f39e$var$SvgGlyphiconsBasic773Temperature = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 18.835V8.085a4 4 0 0 0-8 0v10.75a5.5 5.5 0 1 0 8 0Zm-4 6.25a2.498 2.498 0 0 1-1-4.788v-6.212a1 1 0 0 1 2 0v6.212a2.498 2.498 0 0 1-1 4.788Z"
        })
    });
var $aaddf367bcf6f39e$export$2e2bcd8739ae039 = $aaddf367bcf6f39e$var$SvgGlyphiconsBasic773Temperature;




const $5f487a4a0e0c3377$var$SvgGlyphiconsBasic774TemperatureAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m31.78 10.718-5.5-9a1.5 1.5 0 0 0-2.56 0l-5.5 9A1.5 1.5 0 0 0 19.5 13h11a1.5 1.5 0 0 0 1.28-2.282ZM26 10.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-3a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm-10 .586a4 4 0 0 0-8 0v10.749a5.5 5.5 0 1 0 8 0Zm-4 17a2.498 2.498 0 0 1-1-4.789v-6.212a1 1 0 0 1 2 0v6.212a2.498 2.498 0 0 1-1 4.788Z"
        })
    });
var $5f487a4a0e0c3377$export$2e2bcd8739ae039 = $5f487a4a0e0c3377$var$SvgGlyphiconsBasic774TemperatureAlert;




const $a8d484f8801b1f0e$var$SvgGlyphiconsBasic775TemperatureSet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m21.65 4.188 2.96-3.7a.5.5 0 0 1 .78 0l2.96 3.7a.5.5 0 0 1-.39.812h-5.92a.5.5 0 0 1-.39-.812ZM27.96 7h-5.92a.5.5 0 0 0-.39.812l2.96 3.7a.5.5 0 0 0 .78 0l2.96-3.7A.5.5 0 0 0 27.96 7ZM17 18.835a5.5 5.5 0 1 1-8 0V8.085a4 4 0 0 1 8 0Zm-1.5 3.75a2.502 2.502 0 0 0-1.5-2.288v-6.212a1 1 0 0 0-2 0v6.212a2.499 2.499 0 1 0 3.5 2.288Z"
        })
    });
var $a8d484f8801b1f0e$export$2e2bcd8739ae039 = $a8d484f8801b1f0e$var$SvgGlyphiconsBasic775TemperatureSet;




const $5785f0a2068dd5ee$var$SvgGlyphiconsBasic776TemperatureLow = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31.196 9a1 1 0 0 1-1.366.366L27 7.732V11a1 1 0 0 1-2 0V7.732l-2.83 1.634a1 1 0 1 1-1-1.732L24 6l-2.83-1.634a1 1 0 1 1 1-1.732L25 4.268V1a1 1 0 0 1 2 0v3.268l2.83-1.634a1 1 0 1 1 1 1.732L28 6l2.83 1.634A1 1 0 0 1 31.196 9ZM17 18.835a5.5 5.5 0 1 1-8 0V8.085a4 4 0 0 1 8 0Zm-1.5 3.75a2.502 2.502 0 0 0-1.5-2.288v-2.212a1 1 0 0 0-2 0v2.212a2.499 2.499 0 1 0 3.5 2.288Z"
        })
    });
var $5785f0a2068dd5ee$export$2e2bcd8739ae039 = $5785f0a2068dd5ee$var$SvgGlyphiconsBasic776TemperatureLow;




const $da131bc52817658c$var$SvgGlyphiconsBasic777TemperatureHigh = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.5 7H21a1 1 0 0 1 0-2h.5a1 1 0 0 1 0 2Zm.612 1.474-.354.354a1 1 0 1 0 1.414 1.414l.354-.354a1 1 0 1 0-1.414-1.414Zm1.06-6.716a1 1 0 0 0-1.414 1.414l.354.354a1 1 0 1 0 1.414-1.414ZM26 2.5a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v.5a1 1 0 0 0 1 1Zm3.18 1.32a.997.997 0 0 0 .708-.294l.354-.354a1 1 0 0 0-1.414-1.414l-.354.354a1 1 0 0 0 .707 1.707ZM31 5h-.5a1 1 0 0 0 0 2h.5a1 1 0 0 0 0-2Zm-5 4.5a1 1 0 0 0-1 1v.5a1 1 0 0 0 2 0v-.5a1 1 0 0 0-1-1Zm3.888-1.026a1 1 0 1 0-1.414 1.414l.354.354a1 1 0 0 0 1.414-1.414ZM26 4a2 2 0 1 0 2 2 2.002 2.002 0 0 0-2-2Zm-9 14.835a5.5 5.5 0 1 1-8 0V8.085a4 4 0 0 1 8 0Zm-1.5 3.75a2.502 2.502 0 0 0-1.5-2.288V8.085a1 1 0 0 0-2 0v12.212a2.499 2.499 0 1 0 3.5 2.288Z"
        })
    });
var $da131bc52817658c$export$2e2bcd8739ae039 = $da131bc52817658c$var$SvgGlyphiconsBasic777TemperatureHigh;




const $cdb08c1fa51c4c72$var$SvgGlyphiconsBasic778Tornado = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.917 13.95a3.054 3.054 0 0 1-1.41.983A24.386 24.386 0 0 1 16 16a1 1 0 0 0 0 2 30.335 30.335 0 0 0 3.987-.254.35.35 0 0 1 .29.603c-2.186 2.063-3.789 4.292-2.624 7.764a.673.673 0 0 1-.635.887h-.725a.802.802 0 0 1-.52-.196c-6.69-5.83-3.023-6.974-3.41-11.034a3.648 3.648 0 0 0-1-1.83.187.187 0 0 1 .168-.312A29.219 29.219 0 0 0 16 14a26.46 26.46 0 0 0 4.548-.383 1 1 0 1 0-.346-1.97C14.212 12.694 5.097 11 5.097 7.716 5.125 5.24 11.746 4 16 4c3.262 0 6.974.434 9.137 1.79a.209.209 0 0 1 .013.343 9.55 9.55 0 0 1-3.254 1.329 21.025 21.025 0 0 1-4.365.532 1 1 0 0 0 .022 2h.021a23.041 23.041 0 0 0 4.787-.587 11.047 11.047 0 0 0 4.056-1.731.233.233 0 0 1 .369.134 7.385 7.385 0 0 1-1.869 6.14Zm-3.364 11.155-2 1a1 1 0 0 0 .894 1.79l2-1a1 1 0 0 0-.894-1.79Zm-8.106 1-2-1a1 1 0 1 0-.894 1.79l2 1a1 1 0 0 0 .894-1.79Zm7.846-4.812-1 1a1 1 0 1 0 1.414 1.414l1-1a1 1 0 0 0-1.414-1.414Z"
        })
    });
var $cdb08c1fa51c4c72$export$2e2bcd8739ae039 = $cdb08c1fa51c4c72$var$SvgGlyphiconsBasic778Tornado;




const $34e9d375870e043f$var$SvgGlyphiconsBasic779IceLolly = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 9v9a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V9a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5Zm-8 17a2 2 0 0 0 4 0v-4h-4Z"
        })
    });
var $34e9d375870e043f$export$2e2bcd8739ae039 = $34e9d375870e043f$var$SvgGlyphiconsBasic779IceLolly;




const $e8cc67ac3a82fd71$var$SvgGlyphiconsBasic78Headset = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 16v7.459a3 3 0 0 1-2 2.827V27a3.003 3.003 0 0 1-3 3h-3.277A1.992 1.992 0 0 1 18 31h-1a2 2 0 0 1 0-4h1a1.992 1.992 0 0 1 1.723 1H23a1.001 1.001 0 0 0 1-1v-.333l-.836.139A1 1 0 0 1 22 25.82v-6.64a1 1 0 0 1 1.164-.986L25 18.5V16a9 9 0 0 0-18 0v2.5l1.836-.306A1 1 0 0 1 10 19.18v6.64a1 1 0 0 1-1.164.986l-2.33-.388A3 3 0 0 1 4 23.458V16a12 12 0 0 1 24 0Z"
        })
    });
var $e8cc67ac3a82fd71$export$2e2bcd8739ae039 = $e8cc67ac3a82fd71$var$SvgGlyphiconsBasic78Headset;




const $5d6dd889308cfd80$var$SvgGlyphiconsBasic780IceLollyEaten = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 22h4v4a2 2 0 0 1-4 0Zm6.5-12A5.5 5.5 0 0 1 15 4.5c0-.17.02-.334.036-.5H15a5 5 0 0 0-5 5v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9.781a5.42 5.42 0 0 1-1.5.219Z"
        })
    });
var $5d6dd889308cfd80$export$2e2bcd8739ae039 = $5d6dd889308cfd80$var$SvgGlyphiconsBasic780IceLollyEaten;




const $c188e72cd632eac1$var$SvgGlyphiconsBasic781Milk = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 6V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1Zm8.682 8.694-1.364-2.388A9.985 9.985 0 0 1 18.155 9h-5.31a9.985 9.985 0 0 1-1.163 3.306l-1.364 2.388A10 10 0 0 0 9 19.656V26a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-6.344a10 10 0 0 0-1.318-4.962Z"
        })
    });
var $c188e72cd632eac1$export$2e2bcd8739ae039 = $c188e72cd632eac1$var$SvgGlyphiconsBasic781Milk;




const $28259d9fc7192217$var$SvgGlyphiconsBasic782Egg = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.5 5C11 5 7 12 7 18s3.806 10 8.5 10S24 24 24 18 20 5 15.5 5Zm0 4c-.51 0-1.512.72-2.505 2.304a.998.998 0 0 1-.848.468.987.987 0 0 1-.53-.153.999.999 0 0 1-.315-1.378C12.06 9.031 13.616 7 15.5 7a1 1 0 0 1 0 2Z"
        })
    });
var $28259d9fc7192217$export$2e2bcd8739ae039 = $28259d9fc7192217$var$SvgGlyphiconsBasic782Egg;




const $2f73a4bcb4d33573$var$SvgGlyphiconsBasic783Wheat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.013 27.458q.252-5.196 5.45-5.445a.51.51 0 0 1 .524.525q-.25 5.197-5.445 5.45a.514.514 0 0 1-.53-.53Zm0-7q.252-5.196 5.45-5.445a.51.51 0 0 1 .524.525q-.25 5.197-5.445 5.45a.514.514 0 0 1-.53-.53Zm0-6.991c.162-3.333 1.886-4.342 4.457-4.456a.503.503 0 0 1 .519.52c-.114 2.57-1.123 4.294-4.456 4.456a.504.504 0 0 1-.52-.52Zm-2.555 14.52q-5.195-.252-5.445-5.45a.51.51 0 0 1 .525-.524q5.197.25 5.45 5.445a.514.514 0 0 1-.53.53Zm0-7q-5.195-.252-5.445-5.45a.51.51 0 0 1 .525-.524q5.197.25 5.45 5.445a.514.514 0 0 1-.53.53Zm.009-7c-3.332-.162-4.342-1.886-4.455-4.457a.503.503 0 0 1 .519-.519c2.57.114 4.294 1.123 4.456 4.456a.504.504 0 0 1-.52.52Zm1.166-4.337c-2.242-2.471-1.737-4.404 0-6.302a.503.503 0 0 1 .735 0c1.737 1.898 2.242 3.83 0 6.302a.504.504 0 0 1-.736 0Z"
        })
    });
var $2f73a4bcb4d33573$export$2e2bcd8739ae039 = $2f73a4bcb4d33573$var$SvgGlyphiconsBasic783Wheat;




const $64ac57ec594a96cb$var$SvgGlyphiconsBasic784Corn = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 17.5a.735.735 0 0 1-.478.645C21 19.406 21 24 21 24a5 5 0 0 1-10 0 18.33 18.33 0 0 1 13.5-6.993.49.49 0 0 1 .5.493Zm-14.47 3.965a5.117 5.117 0 0 0-3.052-3.32A.735.735 0 0 1 7 17.5a.488.488 0 0 1 .5-.493 13.767 13.767 0 0 1 6.285 1.634 21.665 21.665 0 0 0-3.256 2.824Zm5.165-4.032A19.269 19.269 0 0 1 21 15.425V8a5 5 0 0 0-10 0v7.45a14.795 14.795 0 0 1 4.695 1.983ZM17 5.684c0-.276.213-.428.454-.294a2.997 2.997 0 0 1 1.156 1.156c.134.241-.018.454-.294.454H17.5a.5.5 0 0 1-.5-.5ZM17 9.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5Zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5Zm-3.61-6.954a2.997 2.997 0 0 1 1.156-1.156c.241-.135.454.018.454.294V6.5a.5.5 0 0 1-.5.5h-.816c-.276 0-.428-.213-.294-.454ZM13 9.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5Zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5Z"
        })
    });
var $64ac57ec594a96cb$export$2e2bcd8739ae039 = $64ac57ec594a96cb$var$SvgGlyphiconsBasic784Corn;




const $6e3c4a67ee87e65e$var$SvgGlyphiconsBasic785Soya = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.373 20.742 18.776 7.518c-.61-1.754-4.38-2.982-5.765-3.38a.987.987 0 0 0-.926.206C11.16 5.146 9 7.207 9 9v14c0 2.284 1.987 5 3.5 5 1.179 0 2.644-1.65 3.234-3.459a.497.497 0 0 1 .835-.214c1.403 1.558 4.006 2.68 5.14 2.287 1.429-.497 2.414-3.715 1.664-5.872ZM14 22.5a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0Zm0-6a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0Zm0-6a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0Z"
        })
    });
var $6e3c4a67ee87e65e$export$2e2bcd8739ae039 = $6e3c4a67ee87e65e$var$SvgGlyphiconsBasic785Soya;




const $be2662964c2c1b22$var$SvgGlyphiconsBasic786Nuts = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.977 23.821c-1.65 1.65-3.29 2.486-4.874 2.486l-.122-.001a5.466 5.466 0 0 1-3.561-1.648 9.768 9.768 0 0 0 4.08-7.787 20.1 20.1 0 0 0-.612-4.883c.9.094 1.779.264 2.565.416a14.35 14.35 0 0 0 2.136.307.92.92 0 0 1 .718.268.999.999 0 0 1 .315.699 14.878 14.878 0 0 0 .318 2.012c.501 2.524 1.187 5.98-.963 8.131Zm-6.533-6.95c0 5.274-5.457 7.732-8.08 8.913-.354.16-.667.301-.917.426a1.001 1.001 0 0 1-.894 0c-.25-.125-.563-.266-.917-.426-2.623-1.181-8.08-3.64-8.08-8.913 0-5.33 2.383-9.262 3.4-9.766A13.812 13.812 0 0 1 12 5.844a13.564 13.564 0 0 1 6.043 1.26c1.018.505 3.401 4.436 3.401 9.767Zm-5.136 3.86a1.002 1.002 0 0 0-1.386-.285A18.503 18.503 0 0 1 13 21.528V20.5a1 1 0 0 0-2 0v1.03a18.614 18.614 0 0 1-1.922-1.084 1 1 0 1 0-1.101 1.67 24.828 24.828 0 0 0 3.51 1.859 1.421 1.421 0 0 0 1.025 0 24.792 24.792 0 0 0 3.511-1.859 1.001 1.001 0 0 0 .285-1.386Z"
        })
    });
var $be2662964c2c1b22$export$2e2bcd8739ae039 = $be2662964c2c1b22$var$SvgGlyphiconsBasic786Nuts;




const $88b67b76cadd4044$var$SvgGlyphiconsBasic787Carrot = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.895 9.593-5.744 1.73-1.474-1.474 1.73-5.744a1 1 0 1 1 1.914.577l-.682 2.265 1.846-1.846A1 1 0 0 1 26.9 6.515L25.053 8.36l2.265-.682a1 1 0 1 1 .577 1.914ZM9.793 25.207a1 1 0 0 1 1.414-1.414l.613.613a.4.4 0 0 0 .547.045l1.752-1.034a.5.5 0 0 0 .1-.784l-1.426-1.426a1 1 0 0 1 1.414-1.414l1.973 1.973a.5.5 0 0 0 .608.077l1.734-1.023a.5.5 0 0 0 .1-.784l-2.829-2.829a1 1 0 0 1 1.414-1.414l3.376 3.376a.5.5 0 0 0 .608.077l.473-.279a3 3 0 0 0 .598-4.705l-4.524-4.524a3 3 0 0 0-4.705.598L4.09 25.499a1.5 1.5 0 0 0 .232 1.823l.39.39a1.289 1.289 0 0 0 1.701.25s3.161-1.861 3.385-1.997a.389.389 0 0 0 .09-.664Z"
        })
    });
var $88b67b76cadd4044$export$2e2bcd8739ae039 = $88b67b76cadd4044$var$SvgGlyphiconsBasic787Carrot;




const $5872812f352bd6e4$var$SvgGlyphiconsBasic788Meat = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 7h-1V6a2 2 0 0 0-4 0v2.172l-2.37 2.37c-.626.59-1.82.618-3.334.644-2.531.043-6 .103-9.117 3.221a8.313 8.313 0 0 0-2.205 5.81 7.823 7.823 0 0 0 2.206 5.605v.001a7.852 7.852 0 0 0 5.6 2.179 8.422 8.422 0 0 0 5.807-2.175c3.28-3.23 3.352-6.659 3.405-9.164.032-1.539.059-2.754.724-3.493.092-.103.16-.198.24-.298L23.828 11H26a2 2 0 0 0 0-4Zm-15.849 9.303a7.005 7.005 0 0 0-1.144.932 3.7 3.7 0 0 0-.885 1.73 1 1 0 1 1-1.943-.472 5.713 5.713 0 0 1 1.414-2.672 9.035 9.035 0 0 1 1.47-1.198 1 1 0 1 1 1.088 1.68Z"
        })
    });
var $5872812f352bd6e4$export$2e2bcd8739ae039 = $5872812f352bd6e4$var$SvgGlyphiconsBasic788Meat;




const $8eef32891506835a$var$SvgGlyphiconsBasic789Seafood = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11 12h4a1.978 1.978 0 0 0 1.126-.35 2.025 2.025 0 0 1 .717-.297L18.8 6.627a1.001 1.001 0 0 0-.7-1.362A11.31 11.31 0 0 0 15.678 5H7a1 1 0 0 0-1 1v1a5 5 0 0 0 5 5ZM9 6a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm3.486 15.871-1.085 2.62a.5.5 0 0 1-.52.305L4.866 24.1A.977.977 0 0 1 4 23.13v-.248a.977.977 0 0 1 .877-.972l7.096-.727a.5.5 0 0 1 .513.688Zm-8.122-2.578a.977.977 0 0 1 1.025-1.647l3.054 1.42a.25.25 0 0 1-.08.476l-3.272.336Zm14.457 6.13a1.006 1.006 0 0 1-.73 1.372A10.815 10.815 0 0 1 16 27a10.528 10.528 0 0 1-2.091-.214 1.006 1.006 0 0 1-.726-1.37l1.724-4.164a.505.505 0 0 1 .532-.3 5.11 5.11 0 0 0 1.124-.001.505.505 0 0 1 .53.3Zm7.967-7.319a1 1 0 0 1-1.366.716l-4.164-1.724a.505.505 0 0 1-.3-.53 5.034 5.034 0 0 0-.003-1.126.505.505 0 0 1 .3-.535l4.167-1.725a1.003 1.003 0 0 1 1.366.708 9.269 9.269 0 0 1 .162 1.051 10.946 10.946 0 0 1-.162 3.165Zm-1.693 4.051a11.058 11.058 0 0 1-2.94 2.94 1.007 1.007 0 0 1-1.492-.449l-1.712-4.133a.505.505 0 0 1 .166-.59 4.967 4.967 0 0 0 .807-.805.505.505 0 0 1 .59-.166l4.131 1.711a1.007 1.007 0 0 1 .45 1.492Zm-5.992-10.048a.505.505 0 0 1-.164-.589l1.694-4.092a1.007 1.007 0 0 1 1.489-.452 11.26 11.26 0 0 1 2.936 2.872 1.006 1.006 0 0 1-.442 1.503l-4.137 1.713a.505.505 0 0 1-.588-.163 5.031 5.031 0 0 0-.788-.792Z"
        })
    });
var $8eef32891506835a$export$2e2bcd8739ae039 = $8eef32891506835a$var$SvgGlyphiconsBasic789Seafood;




const $7da6c9ee3e14188e$var$SvgGlyphiconsBasic79TriangleEmptyAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m30.304 25.759-12.5-22a1.5 1.5 0 0 0-2.608 0l-12.5 22A1.5 1.5 0 0 0 4 28h25a1.5 1.5 0 0 0 1.304-2.241ZM6.577 25 16.5 7.536 26.423 25ZM18 22v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm-2-9h1a1 1 0 0 1 1 1v3l-.628 2.586a.5.5 0 0 1-.492.414h-.76a.5.5 0 0 1-.492-.414L15 17v-3a1 1 0 0 1 1-1Z"
        })
    });
var $7da6c9ee3e14188e$export$2e2bcd8739ae039 = $7da6c9ee3e14188e$var$SvgGlyphiconsBasic79TriangleEmptyAlert;




const $5a8a8b1b3db0a3aa$var$SvgGlyphiconsBasic790Fish = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.251 20.39-3.046-3.48a.5.5 0 0 1 0-.66l2.967-3.39a.5.5 0 0 0 .071-.553l-.44-.88a.5.5 0 0 0-.65-.233l-4.754 2.113a1.004 1.004 0 0 1-1.02-.127 17.188 17.188 0 0 0-3.572-2.127 2.018 2.018 0 0 1-1.224-2.13l.335-2.352A.5.5 0 0 0 16.424 6h-1.01a1 1 0 0 0-.707.293l-3.753 3.753a.987.987 0 0 1-.465.256 11.98 11.98 0 0 0-7.211 5.678A.95.95 0 0 0 3.32 17a11.694 11.694 0 0 0 8.276 4.914 1.004 1.004 0 0 1 .6.282l3.511 3.511a1 1 0 0 0 .707.293H17.5a.5.5 0 0 0 .5-.5v-3.068a1.984 1.984 0 0 1 1.166-1.812 18.246 18.246 0 0 0 1.763-.908.988.988 0 0 1 .907-.055l5.396 2.399a.5.5 0 0 0 .65-.233l.44-.88a.5.5 0 0 0-.07-.553ZM8 15.5a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
        })
    });
var $5a8a8b1b3db0a3aa$export$2e2bcd8739ae039 = $5a8a8b1b3db0a3aa$var$SvgGlyphiconsBasic790Fish;




const $608ee7522e63e7fe$var$SvgGlyphiconsBasic791SquareEmail = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 15v2a1 1 0 0 1-1 1h-1a2 2 0 0 1 0-4h1a1 1 0 0 1 1 1Zm10-7.5v17a3.504 3.504 0 0 1-3.5 3.5h-17A3.504 3.504 0 0 1 4 24.5v-17A3.504 3.504 0 0 1 7.5 4h17A3.504 3.504 0 0 1 28 7.5ZM24 14a6 6 0 0 0-6-6h-2a8.009 8.009 0 0 0-7.982 8.548A8.19 8.19 0 0 0 16.283 24H19a4.968 4.968 0 0 0 2.553-.698.98.98 0 0 0 .212-1.536l-.045-.046a1 1 0 0 0-1.223-.119A2.978 2.978 0 0 1 19 22h-3a6.007 6.007 0 0 1-5.95-6.79A6.14 6.14 0 0 1 16.21 10H18a4 4 0 0 1 4 4v3a1 1 0 0 1-2 0v-4a.998.998 0 0 0-1.713-.699A2.965 2.965 0 0 0 17 12h-1a4.004 4.004 0 0 0-3.98 4.399A4.12 4.12 0 0 0 16.176 20H17a2.977 2.977 0 0 0 2-.78 2.969 2.969 0 0 0 2.695.7A3.083 3.083 0 0 0 24 16.882Z"
        })
    });
var $608ee7522e63e7fe$export$2e2bcd8739ae039 = $608ee7522e63e7fe$var$SvgGlyphiconsBasic791SquareEmail;




const $d97c8cbc76ab7501$var$SvgGlyphiconsBasic792Email = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.5 5H16A11.012 11.012 0 0 0 5.05 17.06 11.214 11.214 0 0 0 16.322 27h4.464a7.158 7.158 0 0 0 4.24-1.375.997.997 0 0 0 .095-1.504l-.72-.72a1.01 1.01 0 0 0-1.283-.103 4.185 4.185 0 0 1-2.332.702H16a8.009 8.009 0 0 1-7.982-8.548A8.189 8.189 0 0 1 16.283 8H19.5a4.5 4.5 0 0 1 4.5 4.5v4a1.5 1.5 0 0 1-3 0v-4a1.498 1.498 0 0 0-2.57-1.048A4.45 4.45 0 0 0 16.5 11H16a5 5 0 0 0 0 10h.5a4.466 4.466 0 0 0 3-1.17A4.48 4.48 0 0 0 27 16.5v-4A7.5 7.5 0 0 0 19.5 5ZM18 16.5a1.502 1.502 0 0 1-1.5 1.5H16a2 2 0 0 1 0-4h.5a1.502 1.502 0 0 1 1.5 1.5Z"
        })
    });
var $d97c8cbc76ab7501$export$2e2bcd8739ae039 = $d97c8cbc76ab7501$var$SvgGlyphiconsBasic792Email;




const $c42f07fe233a0025$var$SvgGlyphiconsBasic793Paired = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 17.5v2a.5.5 0 0 1-.5.5A4.5 4.5 0 0 1 4 15.5v-4A4.5 4.5 0 0 1 8.5 7h8a4.5 4.5 0 0 1 4.5 4.5v4a4.5 4.5 0 0 1-4.5 4.5.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5 1.5 1.5 0 0 0 1.5-1.5v-4a1.5 1.5 0 0 0-1.5-1.5h-8A1.5 1.5 0 0 0 7 11.5v4A1.5 1.5 0 0 0 8.5 17a.5.5 0 0 1 .5.5ZM23.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5 1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-4a1.5 1.5 0 0 1 1.5-1.5.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5 4.5 4.5 0 0 0-4.5 4.5v4a4.5 4.5 0 0 0 4.5 4.5h8a4.5 4.5 0 0 0 4.5-4.5v-4a4.5 4.5 0 0 0-4.5-4.5Z"
        })
    });
var $c42f07fe233a0025$export$2e2bcd8739ae039 = $c42f07fe233a0025$var$SvgGlyphiconsBasic793Paired;




const $c05a40c249334f5c$var$SvgGlyphiconsBasic794PairedOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16.5 20a.494.494 0 0 1-.367-.166L21 14.967v.533a4.5 4.5 0 0 1-4.5 4.5Zm7.424-7.957-.924.924V14.5a.5.5 0 0 0 .5.5 1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-8a1.493 1.493 0 0 1-1.076-.458l-2.121 2.122A4.483 4.483 0 0 0 15.5 25h8a4.5 4.5 0 0 0 4.5-4.5v-4a4.485 4.485 0 0 0-4.076-4.457Zm3.29-6.982L5.062 27.215a1.5 1.5 0 0 1-2.122-2.121l5.137-5.137A4.485 4.485 0 0 1 4 15.5v-4A4.5 4.5 0 0 1 8.5 7h8a4.438 4.438 0 0 1 3.18 1.352l5.414-5.413a1.5 1.5 0 0 1 2.12 2.122Zm-9.638 5.397A1.493 1.493 0 0 0 16.5 10h-8A1.5 1.5 0 0 0 7 11.5v4A1.5 1.5 0 0 0 8.5 17a.5.5 0 0 1 .5.5v1.533l2-2V16.5a4.5 4.5 0 0 1 4.5-4.5.494.494 0 0 1 .367.166Z"
        })
    });
var $c05a40c249334f5c$export$2e2bcd8739ae039 = $c05a40c249334f5c$var$SvgGlyphiconsBasic794PairedOff;




const $11f17674862e690a$var$SvgGlyphiconsBasic795Set = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m8.336 12.367 6.89-8.421a1 1 0 0 1 1.548 0l6.89 8.42A1 1 0 0 1 22.89 14H9.11a1 1 0 0 1-.774-1.633ZM22.89 18H9.11a1 1 0 0 0-.774 1.633l6.89 8.421a1 1 0 0 0 1.548 0l6.89-8.42A1 1 0 0 0 22.89 18Z"
        })
    });
var $11f17674862e690a$export$2e2bcd8739ae039 = $11f17674862e690a$var$SvgGlyphiconsBasic795Set;




const $ecccd3bdeb88c1bd$var$SvgGlyphiconsBasic796SetDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24.762 12.61-7.97 10.36a1 1 0 0 1-1.585 0L7.238 12.61A1 1 0 0 1 8.031 11h15.938a1 1 0 0 1 .793 1.61Z"
        })
    });
var $ecccd3bdeb88c1bd$export$2e2bcd8739ae039 = $ecccd3bdeb88c1bd$var$SvgGlyphiconsBasic796SetDown;




const $50fe0ae1cf9739cc$var$SvgGlyphiconsBasic797ChevronLastDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.086 13.121a.5.5 0 0 1 0-.707l2.828-2.828a.5.5 0 0 1 .707 0L16 16.964l7.379-7.378a.5.5 0 0 1 .707 0l2.828 2.828a.5.5 0 0 1 0 .707L16.707 23.328a1 1 0 0 1-1.414 0ZM26 24H6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
    });
var $50fe0ae1cf9739cc$export$2e2bcd8739ae039 = $50fe0ae1cf9739cc$var$SvgGlyphiconsBasic797ChevronLastDown;




const $63eb4aff13ab4d95$var$SvgGlyphiconsBasic798ChevronLastUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m26.914 19.586-2.828 2.828a.5.5 0 0 1-.707 0L16 15.036l-7.379 7.378a.5.5 0 0 1-.707 0l-2.828-2.828a.5.5 0 0 1 0-.707L15.293 8.67a1 1 0 0 1 1.414 0L26.914 18.88a.5.5 0 0 1 0 .707ZM6 8h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1Z"
        })
    });
var $63eb4aff13ab4d95$export$2e2bcd8739ae039 = $63eb4aff13ab4d95$var$SvgGlyphiconsBasic798ChevronLastUp;




const $90060ca24e3800ee$var$SvgGlyphiconsBasic799ChevronLastLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.414 23.379a.5.5 0 0 1 0 .707l-2.828 2.828a.5.5 0 0 1-.707 0L8.672 16.707a1 1 0 0 1 0-1.414L18.879 5.086a.5.5 0 0 1 .707 0l2.828 2.828a.5.5 0 0 1 0 .707L15.036 16ZM7 5H5a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $90060ca24e3800ee$export$2e2bcd8739ae039 = $90060ca24e3800ee$var$SvgGlyphiconsBasic799ChevronLastLeft;




const $a02d4bd0612d7f14$var$SvgGlyphiconsBasic8UserMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.365 13.374A1.275 1.275 0 0 1 10 11.63V9c0-3 2-5 5.5-5a6.791 6.791 0 0 1 2.646.501 7.948 7.948 0 0 0 3.599 8.261 1.712 1.712 0 0 1-.11.612l-.28.752a2.991 2.991 0 0 1-1.31 1.462l-.666 3.051A3 3 0 0 1 16.448 21h-1.896a3 3 0 0 1-2.93-2.36l-.666-3.052a2.991 2.991 0 0 1-1.311-1.462ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Zm-2.931 17.372-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365Z"
        })
    });
var $a02d4bd0612d7f14$export$2e2bcd8739ae039 = $a02d4bd0612d7f14$var$SvgGlyphiconsBasic8UserMinus;




const $e688e37e3375a5ae$var$SvgGlyphiconsBasic80Bars = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 24v3a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm5-4h-2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Zm6-6h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1Zm6-9h-2a1 1 0 0 0-1 1v21a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $e688e37e3375a5ae$export$2e2bcd8739ae039 = $e688e37e3375a5ae$var$SvgGlyphiconsBasic80Bars;




const $361e1784f0ad3a3c$var$SvgGlyphiconsBasic800ChevronLastRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.328 15.293a1 1 0 0 1 0 1.414L13.121 26.914a.5.5 0 0 1-.707 0l-2.828-2.828a.5.5 0 0 1 0-.707L16.964 16 9.586 8.621a.5.5 0 0 1 0-.707l2.828-2.828a.5.5 0 0 1 .707 0ZM27 5h-2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
        })
    });
var $361e1784f0ad3a3c$export$2e2bcd8739ae039 = $361e1784f0ad3a3c$var$SvgGlyphiconsBasic800ChevronLastRight;




const $e99027a38d3ceaf0$var$SvgGlyphiconsBasic801FilePlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14v13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10.263A7.968 7.968 0 0 0 26 14Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $e99027a38d3ceaf0$export$2e2bcd8739ae039 = $e99027a38d3ceaf0$var$SvgGlyphiconsBasic801FilePlus;




const $5eec0641d542d363$var$SvgGlyphiconsBasic802FileMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 14v13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10.263A7.968 7.968 0 0 0 26 14Zm6-8a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $5eec0641d542d363$export$2e2bcd8739ae039 = $5eec0641d542d363$var$SvgGlyphiconsBasic802FileMinus;




const $7a0045439c124dc3$var$SvgGlyphiconsBasic803FileRefresh = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.477 13.984c.176-.01.35-.035.523-.057V27a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9.26c-.01.042-.028.083-.038.125l-.487 2.021a5.273 5.273 0 0 0-.065 1.4l.705 3.53a2.453 2.453 0 0 0 2.4 1.967 2.423 2.423 0 0 0 1.035-.23A7.972 7.972 0 0 0 24.992 14c.16 0 .321-.005.485-.015Zm5.186-12.67a.445.445 0 0 0-.75-.227l-.687.686c-.084-.085-.155-.18-.245-.26a6.002 6.002 0 0 0-9.815 3.08l1.982.397a3.945 3.945 0 0 1 3.614-2.981c.081-.005.163-.007.243-.007a3.966 3.966 0 0 1 2.649 1.008c.06.053.102.12.158.178l-.725.725a.445.445 0 0 0 .227.75l3.532.706a.444.444 0 0 0 .523-.523Zm-2.673 7.34a3.998 3.998 0 0 1-5.644.337s-.102-.122-.158-.179l.725-.725a.445.445 0 0 0-.227-.75l-3.532-.706a.444.444 0 0 0-.523.523l.706 3.532a.445.445 0 0 0 .75.227l.687-.686c.084.085.155.18.245.26a5.951 5.951 0 0 0 3.973 1.512c.121 0 .243-.004.365-.012a6.006 6.006 0 0 0 5.477-4.58l-1.982-.397a3.965 3.965 0 0 1-.862 1.644Z"
        })
    });
var $7a0045439c124dc3$export$2e2bcd8739ae039 = $7a0045439c124dc3$var$SvgGlyphiconsBasic803FileRefresh;




const $42a2bac44fedc22d$var$SvgGlyphiconsBasic804FileLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 14h4v13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h11.176A2.976 2.976 0 0 0 19 5v6a3.003 3.003 0 0 0 3 3Zm10-9v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $42a2bac44fedc22d$export$2e2bcd8739ae039 = $42a2bac44fedc22d$var$SvgGlyphiconsBasic804FileLock;




const $1330bdeb8fe334cc$var$SvgGlyphiconsBasic805FileCloud = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.937 13H26v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1s8.382 0 9.017 0a6.427 6.427 0 0 0-2 4.185 4.866 4.866 0 0 0 .912 2.825A4.956 4.956 0 0 0 19.937 13Zm12.046-5.853a4.092 4.092 0 0 1-1.056 2.743A3.609 3.609 0 0 1 28.365 11h-8.428a2.969 2.969 0 0 1-2.377-1.148 2.83 2.83 0 0 1-.543-1.667 3.301 3.301 0 0 1 1.565-2.818 4.274 4.274 0 0 1-.01-.295 4.888 4.888 0 0 1 9.206-2.293 4.377 4.377 0 0 1 4.205 4.368Zm-2 0a2.374 2.374 0 0 0-2.37-2.37c-.083 0-.642.072-.95.112a.25.25 0 0 1-.269-.167l-.17-.498a2.97 2.97 0 0 0-2.469-2.027 2.893 2.893 0 0 0-3.183 2.875 2.84 2.84 0 0 0 .08.66l.162.686a.25.25 0 0 1-.172.296l-.674.204a1.322 1.322 0 0 0-.951 1.267.823.823 0 0 0 .173.508 1.039 1.039 0 0 0 .747.307h8.428a1.628 1.628 0 0 0 1.076-.45 2.092 2.092 0 0 0 .542-1.403Z"
        })
    });
var $1330bdeb8fe334cc$export$2e2bcd8739ae039 = $1330bdeb8fe334cc$var$SvgGlyphiconsBasic805FileCloud;




const $272944df52b1bb3e$var$SvgGlyphiconsBasic806UserRounded = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm-4 10.186V12a4 4 0 0 1 8 0v2.186a.675.675 0 0 1 .184.763l-.368 1.102a1.491 1.491 0 0 1-.932.88l-.165 1.317A2 2 0 0 1 16.734 20h-1.468a2 2 0 0 1-1.985-1.752l-.165-1.317a1.491 1.491 0 0 1-.932-.88l-.368-1.102a.675.675 0 0 1 .184-.763ZM16 25a8.978 8.978 0 0 1-6.851-3.178 1.987 1.987 0 0 1 .704-.92l1.787-1.25A3.996 3.996 0 0 0 15.266 22h1.468a3.996 3.996 0 0 0 3.626-2.348l1.787 1.25a1.986 1.986 0 0 1 .704.92A8.978 8.978 0 0 1 16 25Z"
        })
    });
var $272944df52b1bb3e$export$2e2bcd8739ae039 = $272944df52b1bb3e$var$SvgGlyphiconsBasic806UserRounded;




const $0731c19a9db2d714$var$SvgGlyphiconsBasic807UserSquared = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4ZM12 14.186V12a4 4 0 0 1 8 0v2.186a.675.675 0 0 1 .184.763l-.368 1.102a1.491 1.491 0 0 1-.932.88l-.165 1.317A2 2 0 0 1 16.734 20h-1.468a2 2 0 0 1-1.985-1.752l-.165-1.317a1.491 1.491 0 0 1-.932-.88l-.368-1.102a.675.675 0 0 1 .184-.763ZM23 24.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1.959a2 2 0 0 1 .853-1.638l1.787-1.25A3.996 3.996 0 0 0 15.266 22h1.468a3.996 3.996 0 0 0 3.626-2.348l1.787 1.25a2 2 0 0 1 .853 1.64Z"
        })
    });
var $0731c19a9db2d714$export$2e2bcd8739ae039 = $0731c19a9db2d714$var$SvgGlyphiconsBasic807UserSquared;




const $4d353c28ffee80f2$var$SvgGlyphiconsBasic808DropDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 25h4v3h-4Zm4-21h-4v3h4ZM7 14H4v4h3ZM24.5 4H22v3h2.5a.506.506 0 0 1 .5.5V10h3V7.5A3.504 3.504 0 0 0 24.5 4Zm.5 14h3v-4h-3ZM4 7.5V10h3V7.5a.506.506 0 0 1 .5-.5H10V4H7.5A3.504 3.504 0 0 0 4 7.5Zm21 17a.506.506 0 0 1-.5.5H22v3h2.5a3.504 3.504 0 0 0 3.5-3.5V22h-3Zm-18 0V22H4v2.5A3.504 3.504 0 0 0 7.5 28H10v-3H7.5a.506.506 0 0 1-.5-.5ZM19.989 15H18v-4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v4h-1.989a1 1 0 0 0-.821 1.57l3.988 5.746a1 1 0 0 0 1.643 0l3.99-5.746a1 1 0 0 0-.822-1.57Z"
        })
    });
var $4d353c28ffee80f2$export$2e2bcd8739ae039 = $4d353c28ffee80f2$var$SvgGlyphiconsBasic808DropDown;




const $acf0a845745d1eee$var$SvgGlyphiconsBasic809DropPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 7h-4V4h4Zm-4 21h4v-3h-4ZM7 14H4v4h3ZM24.5 4H22v3h2.5a.506.506 0 0 1 .5.5V10h3V7.5A3.504 3.504 0 0 0 24.5 4Zm.5 14h3v-4h-3Zm0 6.5a.506.506 0 0 1-.5.5H22v3h2.5a3.504 3.504 0 0 0 3.5-3.5V22h-3ZM7 7.5a.506.506 0 0 1 .5-.5H10V4H7.5A3.504 3.504 0 0 0 4 7.5V10h3Zm0 17V22H4v2.5A3.504 3.504 0 0 0 7.5 28H10v-3H7.5a.506.506 0 0 1-.5-.5ZM22 15a1 1 0 0 0-1-1h-3v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1Z"
        })
    });
var $acf0a845745d1eee$export$2e2bcd8739ae039 = $acf0a845745d1eee$var$SvgGlyphiconsBasic809DropPlus;




const $132edac20d040f42$var$SvgGlyphiconsBasic81Retweet = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.457 19.785-3.546 5.121a.5.5 0 0 1-.822 0l-3.546-5.121a.5.5 0 0 1 .411-.785H23V9.5a.5.5 0 0 0-.5-.5h-9.097a1 1 0 0 1-.822-.43l-1.235-1.785a.5.5 0 0 1 .41-.785H22.5A3.5 3.5 0 0 1 26 9.5V19h2.046a.5.5 0 0 1 .41.785Zm-9.038 3.646a1 1 0 0 0-.822-.431H9.5a.5.5 0 0 1-.5-.5V13h2.046a.5.5 0 0 0 .41-.785L7.912 7.094a.5.5 0 0 0-.822 0l-3.546 5.121a.5.5 0 0 0 .411.785H6v9.5A3.5 3.5 0 0 0 9.5 26h10.743a.5.5 0 0 0 .411-.785Z"
        })
    });
var $132edac20d040f42$export$2e2bcd8739ae039 = $132edac20d040f42$var$SvgGlyphiconsBasic81Retweet;




const $08cd67fd9688e39d$var$SvgGlyphiconsBasic810BlockMove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7.5 12H10v3H7.5a.506.506 0 0 0-.5.5V18H4v-2.5A3.504 3.504 0 0 1 7.5 12ZM7 24.5V22H4v2.5A3.504 3.504 0 0 0 7.5 28H10v-3H7.5a.506.506 0 0 1-.5-.5Zm10 0a.506.506 0 0 1-.5.5H14v3h2.5a3.504 3.504 0 0 0 3.5-3.5V22h-3Zm11-17v9a3.504 3.504 0 0 1-3.5 3.5h-9a3.504 3.504 0 0 1-3.5-3.5v-9A3.504 3.504 0 0 1 15.5 4h9A3.504 3.504 0 0 1 28 7.5Zm-3 0a.506.506 0 0 0-.5-.5h-9a.506.506 0 0 0-.5.5v9a.506.506 0 0 0 .5.5h9a.506.506 0 0 0 .5-.5Z"
        })
    });
var $08cd67fd9688e39d$export$2e2bcd8739ae039 = $08cd67fd9688e39d$var$SvgGlyphiconsBasic810BlockMove;




const $fb0a0404e1cfe092$var$SvgGlyphiconsBasic811FingerprintScan = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.152 21.205a51.406 51.406 0 0 1-2.424 5.06 1 1 0 0 1-1.786-.902c1.954-3.864 2.263-4.64 2.312-4.787.114-.345.417-1.259.517-1.767a1 1 0 1 1 1.962.382 18.553 18.553 0 0 1-.58 2.014Zm1.06 3.682a1.002 1.002 0 0 0-1.331.474l-.508 1.072a1 1 0 1 0 1.807.857l.508-1.071a1 1 0 0 0-.475-1.332ZM9.677 8.35a1 1 0 0 0 .65-.24 8.64 8.64 0 0 1 5.057-2.09 8.927 8.927 0 0 1 5.571 1.481 1 1 0 0 0 1.106-1.666 10.95 10.95 0 0 0-6.811-1.81A10.63 10.63 0 0 0 9.026 6.59a1 1 0 0 0 .65 1.76Zm-3.372 1.676A11.651 11.651 0 0 0 5 15.354v.96a10.92 10.92 0 0 1-.658 3.713 1 1 0 0 0 .6 1.28 1 1 0 0 0 1.28-.6A12.917 12.917 0 0 0 7 16.313v-.96a9.643 9.643 0 0 1 1.081-4.408 1 1 0 0 0-1.777-.918Zm11.449 11.83A13.016 13.016 0 0 0 19 16.313V15a3.02 3.02 0 0 0-1.223-2.404 2.956 2.956 0 0 0-2.627-.471 3.097 3.097 0 0 0-2.137 2.813 1 1 0 1 0 1.996.123 1.111 1.111 0 0 1 .713-1.02.968.968 0 0 1 .86.158A1.012 1.012 0 0 1 17 15v1.314A11.005 11.005 0 0 1 15.946 21l-.307.65a1 1 0 1 0 1.806.855ZM27 16.312V15a10.939 10.939 0 0 0-1.832-6.054 1 1 0 0 0-1.668 1.106A8.933 8.933 0 0 1 25 15v1.313A11.006 11.006 0 0 1 23.946 21l-1.404 2.966a.998.998 0 0 0 .476 1.33.978.978 0 0 0 .426.098.999.999 0 0 0 .905-.573l1.404-2.965A13.02 13.02 0 0 0 27 16.313ZM23 15a7.008 7.008 0 0 0-7.917-6.941A7.125 7.125 0 0 0 9 15.209v1.105A10.992 10.992 0 0 1 7.945 21l-1.08 2.281a1 1 0 0 0 1.809.856l1.079-2.28A13.02 13.02 0 0 0 11 16.312V15.21a5.12 5.12 0 0 1 4.338-5.166 4.942 4.942 0 0 1 3.96 1.202A5.004 5.004 0 0 1 21 15v1.313A11.006 11.006 0 0 1 19.946 21l-2.53 5.343a.998.998 0 0 0 .476 1.33.978.978 0 0 0 .426.098.999.999 0 0 0 .905-.573l2.53-5.342A13.02 13.02 0 0 0 23 16.313ZM3 7a1 1 0 0 0 1-1V4h2a1 1 0 0 0 0-2H3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1Zm26-5h-3a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Zm0 23a1 1 0 0 0-1 1v2h-2a1 1 0 0 0 0 2h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1ZM6 28H4v-2a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2Z"
        })
    });
var $fb0a0404e1cfe092$export$2e2bcd8739ae039 = $fb0a0404e1cfe092$var$SvgGlyphiconsBasic811FingerprintScan;




const $bc5a9e72f8c489cf$var$SvgGlyphiconsBasic812Fingerprint = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.152 22.205a51.406 51.406 0 0 1-2.424 5.06 1 1 0 0 1-1.786-.902c1.954-3.864 2.263-4.64 2.312-4.787.114-.345.417-1.259.517-1.767a1 1 0 1 1 1.962.382 18.553 18.553 0 0 1-.58 2.014ZM7 16.354a9.643 9.643 0 0 1 1.081-4.409 1 1 0 0 0-1.777-.918A11.651 11.651 0 0 0 5 16.354v.96a10.92 10.92 0 0 1-.658 3.713 1 1 0 0 0 .6 1.28 1 1 0 0 0 1.28-.6A12.917 12.917 0 0 0 7 17.313Zm8.213 9.533a1.002 1.002 0 0 0-1.332.474l-.508 1.072a1 1 0 1 0 1.807.857l.508-1.071a1 1 0 0 0-.475-1.332ZM16 3a1 1 0 0 0 0-2A14.908 14.908 0 0 0 1.137 17.924a1 1 0 0 0 .99.872 1.156 1.156 0 0 0 .13-.008 1.001 1.001 0 0 0 .864-1.12A12.765 12.765 0 0 1 3 16 13.015 13.015 0 0 1 16 3Zm-.751 2.025A10.63 10.63 0 0 0 9.026 7.59a1 1 0 0 0 1.3 1.521 8.64 8.64 0 0 1 5.057-2.09 8.917 8.917 0 0 1 5.571 1.481 1 1 0 0 0 1.106-1.666 10.927 10.927 0 0 0-6.811-1.81Zm8.532 4.64a1.002 1.002 0 0 0-.281 1.387A8.933 8.933 0 0 1 25 16v1.313A10.992 10.992 0 0 1 23.945 22l-1.403 2.966a1 1 0 1 0 1.807.855l1.404-2.965A13.02 13.02 0 0 0 27 17.313V16a10.939 10.939 0 0 0-1.832-6.054 1 1 0 0 0-1.387-.281Zm-.448-6.737a1 1 0 1 0-.98 1.742A13.034 13.034 0 0 1 29 16a12.87 12.87 0 0 1-.123 1.69 1 1 0 1 0 1.982.26A14.795 14.795 0 0 0 31 16a15.034 15.034 0 0 0-7.667-13.072ZM23 16a7.008 7.008 0 0 0-7.917-6.941A7.125 7.125 0 0 0 9 16.209v1.105A10.992 10.992 0 0 1 7.945 22l-1.08 2.281a1 1 0 0 0 1.809.856l1.079-2.28A13.02 13.02 0 0 0 11 17.312V16.21a5.12 5.12 0 0 1 4.338-5.166 4.942 4.942 0 0 1 3.96 1.202A5.004 5.004 0 0 1 21 16v1.313A11.006 11.006 0 0 1 19.946 22l-2.53 5.343a.998.998 0 0 0 .476 1.33.978.978 0 0 0 .426.098.999.999 0 0 0 .905-.573l2.53-5.342A13.02 13.02 0 0 0 23 17.313Zm-5.247 6.856A13.016 13.016 0 0 0 19 17.314V16a3.02 3.02 0 0 0-1.223-2.404 2.95 2.95 0 0 0-2.627-.471 3.097 3.097 0 0 0-2.137 2.813 1 1 0 1 0 1.996.123 1.111 1.111 0 0 1 .713-1.02.966.966 0 0 1 .86.158A1.012 1.012 0 0 1 17 16v1.314A11.005 11.005 0 0 1 15.946 22l-.307.65a1 1 0 1 0 1.806.855Z"
        })
    });
var $bc5a9e72f8c489cf$export$2e2bcd8739ae039 = $bc5a9e72f8c489cf$var$SvgGlyphiconsBasic812Fingerprint;




const $467acee4e259812e$var$SvgGlyphiconsBasic813FingerprintLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 17.313a12.917 12.917 0 0 1-.777 4.394 1 1 0 1 1-1.881-.68A10.92 10.92 0 0 0 5 17.313v-.96a11.651 11.651 0 0 1 1.304-5.326 1 1 0 0 1 1.777.918A9.643 9.643 0 0 0 7 16.354Zm4-1.104a5.12 5.12 0 0 1 4.338-5.166 4.942 4.942 0 0 1 3.926 1.176A2.975 2.975 0 0 1 19 11V9.69a7.096 7.096 0 0 0-3.917-.631A7.125 7.125 0 0 0 9 16.209v1.105A10.992 10.992 0 0 1 7.945 22l-1.08 2.281a1 1 0 0 0 1.809.856l1.079-2.28A13.02 13.02 0 0 0 11 17.312Zm3.733 3.982a1 1 0 1 0-1.962-.382c-.1.508-.403 1.422-.517 1.767-.049.147-.358.923-2.312 4.787a1 1 0 0 0 1.786.903 51.406 51.406 0 0 0 2.424-5.06 18.553 18.553 0 0 0 .581-2.015ZM16 3a1 1 0 0 0 0-2A14.908 14.908 0 0 0 1.137 17.924a1 1 0 0 0 .99.872 1.156 1.156 0 0 0 .13-.008 1.001 1.001 0 0 0 .864-1.12A12.765 12.765 0 0 1 3 16 13.015 13.015 0 0 1 16 3Zm-.751 2.025A10.63 10.63 0 0 0 9.026 7.59a1 1 0 0 0 1.3 1.521 8.64 8.64 0 0 1 5.057-2.09 8.902 8.902 0 0 1 3.617.5V5.427a10.966 10.966 0 0 0-3.751-.402ZM24.748 14A8.856 8.856 0 0 1 25 16v1.313A10.992 10.992 0 0 1 23.945 22l-1.403 2.966a1 1 0 1 0 1.807.855l1.404-2.965A13.02 13.02 0 0 0 27 17.313V16a10.876 10.876 0 0 0-.192-2ZM23 16a6.965 6.965 0 0 0-.301-2H22a2.982 2.982 0 0 1-1.685-.52A4.99 4.99 0 0 1 21 16v1.313A11.006 11.006 0 0 1 19.946 22l-2.53 5.343a.998.998 0 0 0 .476 1.33.978.978 0 0 0 .426.098.999.999 0 0 0 .905-.573l2.53-5.342A13.02 13.02 0 0 0 23 17.313Zm-7.787 9.887a1.001 1.001 0 0 0-1.332.474l-.508 1.072a1 1 0 1 0 1.807.857l.508-1.071a1 1 0 0 0-.475-1.332ZM28.838 14a12.045 12.045 0 0 1 .039 3.69 1 1 0 1 0 1.982.26 14.203 14.203 0 0 0 .006-3.95Zm-11.085 8.856A13.016 13.016 0 0 0 19 17.314V16a3.02 3.02 0 0 0-1.223-2.404 2.95 2.95 0 0 0-2.627-.471 3.097 3.097 0 0 0-2.137 2.813 1 1 0 1 0 1.996.123 1.111 1.111 0 0 1 .713-1.02.968.968 0 0 1 .86.158A1.012 1.012 0 0 1 17 16v1.314A11.005 11.005 0 0 1 15.946 22l-.307.65a1 1 0 1 0 1.806.855ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-4-2.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V4h3Z"
        })
    });
var $467acee4e259812e$export$2e2bcd8739ae039 = $467acee4e259812e$var$SvgGlyphiconsBasic813FingerprintLock;




const $2e9f26aca0aabdcc$var$SvgGlyphiconsBasic814FingerprintCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.152 22.205a51.406 51.406 0 0 1-2.424 5.06 1 1 0 0 1-1.786-.902c1.954-3.864 2.263-4.64 2.312-4.787.114-.345.417-1.259.517-1.767a1 1 0 1 1 1.962.382 18.553 18.553 0 0 1-.58 2.014ZM7 16.354a9.643 9.643 0 0 1 1.081-4.409 1 1 0 0 0-1.777-.918A11.651 11.651 0 0 0 5 16.354v.96a10.92 10.92 0 0 1-.658 3.713 1 1 0 0 0 .6 1.28 1 1 0 0 0 1.28-.6A12.917 12.917 0 0 0 7 17.313ZM16 3a1 1 0 0 0 0-2A14.908 14.908 0 0 0 1.137 17.924a1 1 0 0 0 .99.872 1.156 1.156 0 0 0 .13-.008 1.001 1.001 0 0 0 .864-1.12A12.765 12.765 0 0 1 3 16 13.015 13.015 0 0 1 16 3Zm-.751 2.025A10.63 10.63 0 0 0 9.026 7.59a1 1 0 0 0 1.3 1.521 8.64 8.64 0 0 1 5.057-2.09 8.927 8.927 0 0 1 2.726.237A7.986 7.986 0 0 1 18 6c0-.271.014-.54.04-.803a11.038 11.038 0 0 0-2.791-.172Zm-.036 20.862a1.001 1.001 0 0 0-1.332.474l-.508 1.072a1 1 0 1 0 1.807.857l.507-1.071a1 1 0 0 0-.474-1.332Zm13.54-12.385a12.283 12.283 0 0 1 .124 4.187 1 1 0 1 0 1.982.26 14.207 14.207 0 0 0-.274-5.403 7.974 7.974 0 0 1-1.832.956Zm-11 9.354A13.016 13.016 0 0 0 19 17.314V16a3.02 3.02 0 0 0-1.223-2.404 2.95 2.95 0 0 0-2.627-.471 3.097 3.097 0 0 0-2.137 2.813 1 1 0 1 0 1.996.123 1.111 1.111 0 0 1 .713-1.02.967.967 0 0 1 .86.158A1.012 1.012 0 0 1 17 16v1.314A11.005 11.005 0 0 1 15.946 22l-.307.65a1 1 0 1 0 1.806.855ZM26 14a7.982 7.982 0 0 1-1.277-.112A8.855 8.855 0 0 1 25 16v1.313A10.992 10.992 0 0 1 23.945 22l-1.403 2.966a1 1 0 1 0 1.807.855l1.404-2.965A13.02 13.02 0 0 0 27 17.313V16a10.882 10.882 0 0 0-.2-2.04c-.263.026-.53.04-.8.04Zm-3 2a6.982 6.982 0 0 0-.62-2.875 8.044 8.044 0 0 1-3.499-3.492 7.104 7.104 0 0 0-3.798-.574A7.125 7.125 0 0 0 9 16.209v1.105A10.992 10.992 0 0 1 7.945 22l-1.08 2.281a1 1 0 0 0 1.809.856l1.079-2.28A13.02 13.02 0 0 0 11 17.312V16.21a5.12 5.12 0 0 1 4.338-5.166 4.945 4.945 0 0 1 3.96 1.202A5.004 5.004 0 0 1 21 16v1.313A11.006 11.006 0 0 1 19.946 22l-2.53 5.343a.998.998 0 0 0 .476 1.33.978.978 0 0 0 .426.098.999.999 0 0 0 .905-.573l2.53-5.342A13.02 13.02 0 0 0 23 17.313ZM20 6a6 6 0 1 1 6 6 6 6 0 0 1-6-6Zm2.56.557 2.233 2.236a.83.83 0 0 0 1.298-.1L29.2 4.118a.254.254 0 0 0-.052-.352l-.512-.378a.297.297 0 0 0-.377.026l-3.15 2.961-1.766-.845a.323.323 0 0 0-.377.095l-.433.555a.297.297 0 0 0 .027.377Z"
        })
    });
var $2e9f26aca0aabdcc$export$2e2bcd8739ae039 = $2e9f26aca0aabdcc$var$SvgGlyphiconsBasic814FingerprintCheck;




const $6e86f8befe099434$var$SvgGlyphiconsBasic815FingerprintRemove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M7 17.313a12.917 12.917 0 0 1-.777 4.394 1 1 0 1 1-1.881-.68A10.92 10.92 0 0 0 5 17.313v-.96a11.651 11.651 0 0 1 1.304-5.326 1 1 0 0 1 1.777.918A9.643 9.643 0 0 0 7 16.354ZM16 3a1 1 0 0 0 0-2A14.908 14.908 0 0 0 1.137 17.924a1 1 0 0 0 .99.872 1.156 1.156 0 0 0 .13-.008 1.001 1.001 0 0 0 .864-1.12A12.765 12.765 0 0 1 3 16 13.015 13.015 0 0 1 16 3Zm-.751 2.025A10.63 10.63 0 0 0 9.026 7.59a1 1 0 0 0 1.3 1.521 8.64 8.64 0 0 1 5.057-2.09 8.928 8.928 0 0 1 2.726.237A7.986 7.986 0 0 1 18 6c0-.271.014-.539.04-.803a11.04 11.04 0 0 0-2.791-.172Zm-.516 15.166a1 1 0 1 0-1.963-.382c-.1.508-.402 1.422-.516 1.767-.049.147-.359.923-2.312 4.787a1 1 0 0 0 1.786.903 51.406 51.406 0 0 0 2.424-5.06 18.553 18.553 0 0 0 .581-2.015ZM26 14a7.982 7.982 0 0 1-1.277-.112A8.855 8.855 0 0 1 25 16v1.313A10.992 10.992 0 0 1 23.945 22l-1.403 2.966a1 1 0 1 0 1.807.855l1.404-2.965A13.02 13.02 0 0 0 27 17.313V16a10.882 10.882 0 0 0-.2-2.04c-.263.026-.53.04-.8.04Zm2.753-.498a12.283 12.283 0 0 1 .124 4.187 1 1 0 1 0 1.982.26 14.207 14.207 0 0 0-.274-5.403 7.974 7.974 0 0 1-1.832.956Zm-13.54 12.385a1.002 1.002 0 0 0-1.332.474l-.508 1.072a1 1 0 1 0 1.807.857l.508-1.071a1 1 0 0 0-.475-1.332ZM23 16a6.982 6.982 0 0 0-.62-2.875 8.044 8.044 0 0 1-3.498-3.492 7.106 7.106 0 0 0-3.799-.574A7.125 7.125 0 0 0 9 16.209v1.105A10.992 10.992 0 0 1 7.945 22l-1.08 2.281a1 1 0 0 0 1.809.856l1.079-2.28A13.02 13.02 0 0 0 11 17.312V16.21a5.12 5.12 0 0 1 4.338-5.166 4.945 4.945 0 0 1 3.96 1.202A5.004 5.004 0 0 1 21 16v1.313A11.006 11.006 0 0 1 19.946 22l-2.53 5.343a.998.998 0 0 0 .476 1.33.978.978 0 0 0 .426.098.999.999 0 0 0 .905-.573l2.53-5.342A13.02 13.02 0 0 0 23 17.313Zm-5.247 6.856A13.016 13.016 0 0 0 19 17.314V16a3.02 3.02 0 0 0-1.223-2.404 2.95 2.95 0 0 0-2.627-.471 3.097 3.097 0 0 0-2.137 2.813 1 1 0 1 0 1.996.123 1.111 1.111 0 0 1 .713-1.02.967.967 0 0 1 .86.158A1.012 1.012 0 0 1 17 16v1.314A11.005 11.005 0 0 1 15.946 22l-.307.65a1 1 0 1 0 1.806.855Zm4.004-12.613a6 6 0 1 1 8.486 0 6 6 0 0 1-8.486 0ZM24.586 6l-1.06 1.06a.5.5 0 0 0 0 .708l.706.707a.5.5 0 0 0 .707 0L26 7.415l1.06 1.06a.5.5 0 0 0 .708 0l.707-.707a.5.5 0 0 0 0-.707L27.415 6l1.06-1.06a.5.5 0 0 0 0-.708l-.707-.707a.5.5 0 0 0-.707 0L26 4.585l-1.06-1.06a.5.5 0 0 0-.708 0l-.707.707a.5.5 0 0 0 0 .707Z"
        })
    });
var $6e86f8befe099434$export$2e2bcd8739ae039 = $6e86f8befe099434$var$SvgGlyphiconsBasic815FingerprintRemove;




const $0874024b8fd45c38$var$SvgGlyphiconsBasic816Satellite = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.868 21.305a1 1 0 0 1 1.904-.61 5.29 5.29 0 0 0 .782 1.548 5.511 5.511 0 0 0 2.752 1.976 1 1 0 0 1-.612 1.904 7.503 7.503 0 0 1-3.746-2.686 7.27 7.27 0 0 1-1.08-2.132Zm6.196 7.148a9.496 9.496 0 0 1-8.517-8.517 1 1 0 0 0-1.99.195 11.495 11.495 0 0 0 10.312 10.312c.033.003.067.005.099.005a1 1 0 0 0 .096-1.995ZM9.99 7.161a.5.5 0 0 0 .707 0l2.828-2.828a.5.5 0 0 0 0-.708l-1.414-1.414a.5.5 0 0 0-.707 0L8.575 5.04a.5.5 0 0 0 0 .707Zm2.12 2.121 1.415 1.415a.5.5 0 0 0 .707 0l2.829-2.829a.5.5 0 0 0 0-.707l-1.415-1.414a.5.5 0 0 0-.707 0l-2.828 2.828a.5.5 0 0 0 0 .707ZM29.79 19.89l-1.415-1.414a.5.5 0 0 0-.707 0l-2.828 2.828a.5.5 0 0 0 0 .707l1.414 1.415a.5.5 0 0 0 .707 0l2.829-2.829a.5.5 0 0 0 0-.707Zm-3.536-3.535-1.414-1.415a.5.5 0 0 0-.707 0l-2.829 2.829a.5.5 0 0 0 0 .707l1.415 1.414a.5.5 0 0 0 .707 0l2.828-2.828a.5.5 0 0 0 0-.707Zm-1.768-6.01-2.828-2.83a1 1 0 0 0-1.414 0l-5.657 5.658a.992.992 0 0 0-.288.68 5.763 5.763 0 0 1 3.85 3.85.992.992 0 0 0 .68-.288l5.657-5.657a1 1 0 0 0 0-1.414Zm-14.447 6.01a.491.491 0 0 0-.024.731l4.9 4.9a.49.49 0 0 0 .731-.023 4 4 0 0 0-5.607-5.608Z"
        })
    });
var $0874024b8fd45c38$export$2e2bcd8739ae039 = $0874024b8fd45c38$var$SvgGlyphiconsBasic816Satellite;




const $a05ef91db72be3de$var$SvgGlyphiconsBasic817SatelliteDish = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.656 26.737A1 1 0 0 1 13.69 28H5.309a1 1 0 0 1-.965-1.263l1.894-6.944a10.96 10.96 0 0 0 7.393 3.188ZM16.06 12.06a1.5 1.5 0 0 0-2.122-2.122l-.585.586 2.12 2.121ZM7.152 7.15a.5.5 0 0 0-.772.075A8.988 8.988 0 0 0 18.774 19.62a.5.5 0 0 0 .074-.772Zm14.98-3.283A11.523 11.523 0 0 0 15.13.557a1 1 0 0 0-.195 1.99 9.496 9.496 0 0 1 8.517 8.517 1 1 0 0 0 .994.903c.032 0 .066-.002.099-.005a1 1 0 0 0 .897-1.093 11.523 11.523 0 0 0-3.311-7Zm-2.08 3.695a7.503 7.503 0 0 0-3.746-2.686 1 1 0 0 0-.612 1.904 5.511 5.511 0 0 1 2.752 1.976 5.29 5.29 0 0 1 .782 1.548.998.998 0 0 0 .952.695.977.977 0 0 0 .304-.048 1 1 0 0 0 .648-1.257 7.27 7.27 0 0 0-1.08-2.132Z"
        })
    });
var $a05ef91db72be3de$export$2e2bcd8739ae039 = $a05ef91db72be3de$var$SvgGlyphiconsBasic817SatelliteDish;




const $194107e4c8c49d32$var$SvgGlyphiconsBasic818SatelliteDishAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.095 22.954a10.947 10.947 0 0 1-2.482-.49L11.382 24H10v-1.761a10.997 10.997 0 0 1-3.592-2.291l-3.303 6.605a1 1 0 0 0 1.79.894L5.618 26H8a1 1 0 0 0 2 0h2.382l.723 1.447a1 1 0 0 0 1.79-.894ZM8 24H6.618L8 21.236Zm7.475-11.354-2.121-2.12.585-.587a1.5 1.5 0 0 1 2.122 2.122Zm3.373 6.202a.5.5 0 0 1-.074.772A8.988 8.988 0 0 1 6.38 7.226a.5.5 0 0 1 .772-.074Zm2.284-9.153a1 1 0 0 1-.648 1.257.977.977 0 0 1-.304.048.998.998 0 0 1-.952-.695 5.29 5.29 0 0 0-.782-1.548 5.511 5.511 0 0 0-2.752-1.976 1 1 0 0 1 .612-1.904 7.503 7.503 0 0 1 3.746 2.686 7.27 7.27 0 0 1 1.08 2.132Zm4.311 1.174a1 1 0 0 1-.897 1.093 1.13 1.13 0 0 1-.099.005 1 1 0 0 1-.994-.903 9.496 9.496 0 0 0-8.517-8.517 1 1 0 0 1 .195-1.99 11.495 11.495 0 0 1 10.312 10.312Z"
        })
    });
var $194107e4c8c49d32$export$2e2bcd8739ae039 = $194107e4c8c49d32$var$SvgGlyphiconsBasic818SatelliteDishAlt;




const $c54367086e3615f8$var$SvgGlyphiconsBasic819Robot = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13 23a1 1 0 0 1-1-1v-9h8v9a1 1 0 0 1-1 1Zm11-10h-2v7a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1ZM7 14v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-7H8a1 1 0 0 0-1 1Zm7 11h-2a1 1 0 0 0-1 1v2h4v-2a1 1 0 0 0-1-1Zm6 0h-2a1 1 0 0 0-1 1v2h4v-2a1 1 0 0 0-1-1Zm2-15a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-7-3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1Zm5 0a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1Z"
        })
    });
var $c54367086e3615f8$export$2e2bcd8739ae039 = $c54367086e3615f8$var$SvgGlyphiconsBasic819Robot;




const $08754fdb712d5bac$var$SvgGlyphiconsBasic82Refresh = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 15.836A12 12 0 0 1 16.714 27.98c-.244.014-.488.022-.73.022a11.893 11.893 0 0 1-7.172-2.395L7.425 27.17a.5.5 0 0 1-.86-.214l-1.477-6.051a.5.5 0 0 1 .546-.615l6.184.747a.5.5 0 0 1 .314.828l-1.318 1.486a8.998 8.998 0 0 0 14.184-7.553 1.072 1.072 0 0 1 .318-.834 1.034 1.034 0 0 1 .808-.261l1.009.122a1.085 1.085 0 0 1 .617.324.93.93 0 0 1 .25.687Zm-21.316 1.2a1.072 1.072 0 0 0 .318-.834 8.996 8.996 0 0 1 14.184-7.553l-1.318 1.486a.5.5 0 0 0 .314.828l6.184.747a.5.5 0 0 0 .546-.615l-1.478-6.051a.5.5 0 0 0-.86-.214l-1.387 1.564A11.893 11.893 0 0 0 16.016 4c-.243 0-.487.007-.73.022A12 12 0 0 0 4 16.164a.93.93 0 0 0 .25.687 1.085 1.085 0 0 0 .616.324l1.01.122a1.034 1.034 0 0 0 .807-.26Z"
        })
    });
var $08754fdb712d5bac$export$2e2bcd8739ae039 = $08754fdb712d5bac$var$SvgGlyphiconsBasic82Refresh;




const $cd6e0e5dc9bf7d6c$var$SvgGlyphiconsBasic820Radar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.506 7.545c-.01-.01-.012-.021-.02-.03a11.92 11.92 0 0 0-6.02-3.258c-.018-.004-.036-.01-.055-.013-.332-.068-.67-.116-1.008-.155-.063-.007-.124-.021-.188-.027A12.24 12.24 0 0 0 16 4a12 12 0 0 0 0 24c.409 0 .814-.021 1.215-.062.064-.006.125-.02.188-.027.339-.04.676-.087 1.008-.155.019-.003.037-.01.055-.013a11.92 11.92 0 0 0 6.02-3.258c.008-.009.011-.02.02-.03a11.975 11.975 0 0 0 0-16.91Zm-6.461 18.243-.035.009c-.277.057-.56.096-.844.129-.052.006-.102.018-.153.023a10 10 0 1 1 0-19.898c.051.005.101.017.153.023.284.033.567.072.844.13l.035.008a9.967 9.967 0 0 1 4.28 2.05L20.9 9.685a7.996 7.996 0 1 0 .755 11.971 1 1 0 0 0-1.414-1.414 6.003 6.003 0 1 1-.77-9.129l-1.45 1.452A3.962 3.962 0 0 0 16 12a4 4 0 1 0 2.828 6.828 1 1 0 0 0-1.414-1.414 2.013 2.013 0 1 1-.902-3.34l-.787.787a1 1 0 1 0 1.414 1.414l6.6-6.6a9.991 9.991 0 0 1-5.694 16.113Z"
        })
    });
var $cd6e0e5dc9bf7d6c$export$2e2bcd8739ae039 = $cd6e0e5dc9bf7d6c$var$SvgGlyphiconsBasic820Radar;




const $90e86423cbccddfe$var$SvgGlyphiconsBasic821BatteryCharging = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 8h-19A2.502 2.502 0 0 0 4 10.5v11A2.502 2.502 0 0 0 6.5 24h19a2.502 2.502 0 0 0 2.5-2.5v-11A2.502 2.502 0 0 0 25.5 8ZM25 21H7V11h18Zm7-7v4a1 1 0 0 1-1 1h-1v-6h1a1 1 0 0 1 1 1Zm-12.655 1h-3.238l.399-2H23v6h-5.906l2.648-3.196a.5.5 0 0 0-.397-.804Zm-4.967 4H9v-6h4.876l-2.394 3.2a.5.5 0 0 0 .4.8h3.002Z"
        })
    });
var $90e86423cbccddfe$export$2e2bcd8739ae039 = $90e86423cbccddfe$var$SvgGlyphiconsBasic821BatteryCharging;




const $0141e22139c6d823$var$SvgGlyphiconsBasic822BatteryCharged = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 8h-19A2.502 2.502 0 0 0 4 10.5v11A2.502 2.502 0 0 0 6.5 24h19a2.502 2.502 0 0 0 2.5-2.5v-11A2.502 2.502 0 0 0 25.5 8ZM25 21H7V11h18Zm7-7v4a1 1 0 0 1-1 1h-1v-6h1a1 1 0 0 1 1 1Zm-9 5H9v-6h14Z"
        })
    });
var $0141e22139c6d823$export$2e2bcd8739ae039 = $0141e22139c6d823$var$SvgGlyphiconsBasic822BatteryCharged;




const $5f53514b9c80a2fd$var$SvgGlyphiconsBasic823BatteryThreeQuarters = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 8h-19A2.502 2.502 0 0 0 4 10.5v11A2.502 2.502 0 0 0 6.5 24h19a2.502 2.502 0 0 0 2.5-2.5v-11A2.502 2.502 0 0 0 25.5 8ZM25 21H7V11h18Zm7-7v4a1 1 0 0 1-1 1h-1v-6h1a1 1 0 0 1 1 1Zm-12 5H9v-6h11Z"
        })
    });
var $5f53514b9c80a2fd$export$2e2bcd8739ae039 = $5f53514b9c80a2fd$var$SvgGlyphiconsBasic823BatteryThreeQuarters;




const $4381ce4ab309a3ce$var$SvgGlyphiconsBasic824BatteryHalf = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 8h-19A2.502 2.502 0 0 0 4 10.5v11A2.502 2.502 0 0 0 6.5 24h19a2.502 2.502 0 0 0 2.5-2.5v-11A2.502 2.502 0 0 0 25.5 8ZM25 21H7V11h18Zm7-7v4a1 1 0 0 1-1 1h-1v-6h1a1 1 0 0 1 1 1Zm-16 5H9v-6h7Z"
        })
    });
var $4381ce4ab309a3ce$export$2e2bcd8739ae039 = $4381ce4ab309a3ce$var$SvgGlyphiconsBasic824BatteryHalf;




const $d88a2b16705fe245$var$SvgGlyphiconsBasic825BatteryQuarter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 8h-19A2.502 2.502 0 0 0 4 10.5v11A2.502 2.502 0 0 0 6.5 24h19a2.502 2.502 0 0 0 2.5-2.5v-11A2.502 2.502 0 0 0 25.5 8ZM25 21H7V11h18Zm7-7v4a1 1 0 0 1-1 1h-1v-6h1a1 1 0 0 1 1 1Zm-19 5H9v-6h4Z"
        })
    });
var $d88a2b16705fe245$export$2e2bcd8739ae039 = $d88a2b16705fe245$var$SvgGlyphiconsBasic825BatteryQuarter;




const $d0f7a6806c3c314b$var$SvgGlyphiconsBasic826BatteryLow = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.5 8h-19A2.502 2.502 0 0 0 4 10.5v11A2.502 2.502 0 0 0 6.5 24h19a2.502 2.502 0 0 0 2.5-2.5v-11A2.502 2.502 0 0 0 25.5 8ZM25 21H7V11h18Zm7-7v4a1 1 0 0 1-1 1h-1v-6h1a1 1 0 0 1 1 1Zm-21 5H9v-6h2Z"
        })
    });
var $d0f7a6806c3c314b$export$2e2bcd8739ae039 = $d0f7a6806c3c314b$var$SvgGlyphiconsBasic826BatteryLow;




const $513e0d01bde4ba08$var$SvgGlyphiconsBasic827ArrowThinDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24.475 19.354-7.768 7.768a1 1 0 0 1-1.414 0l-7.768-7.768a.5.5 0 0 1 0-.707l2.121-2.122a.5.5 0 0 1 .708 0L14 20.17V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v15.171l3.646-3.646a.5.5 0 0 1 .708 0l2.121 2.121a.5.5 0 0 1 0 .708Z"
        })
    });
var $513e0d01bde4ba08$export$2e2bcd8739ae039 = $513e0d01bde4ba08$var$SvgGlyphiconsBasic827ArrowThinDown;




const $0842df720f849d44$var$SvgGlyphiconsBasic828ArrowThinUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m24.475 13.354-2.121 2.121a.5.5 0 0 1-.708 0L18 11.83V27a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V11.829l-3.646 3.646a.5.5 0 0 1-.708 0l-2.121-2.121a.5.5 0 0 1 0-.707l7.768-7.769a1 1 0 0 1 1.414 0l7.768 7.768a.5.5 0 0 1 0 .708Z"
        })
    });
var $0842df720f849d44$export$2e2bcd8739ae039 = $0842df720f849d44$var$SvgGlyphiconsBasic828ArrowThinUp;




const $5aa69d829e2372da$var$SvgGlyphiconsBasic829ArrowThinLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 15v2a1 1 0 0 1-1 1H11.829l3.646 3.646a.5.5 0 0 1 0 .707l-2.121 2.122a.5.5 0 0 1-.708 0l-7.768-7.768a1 1 0 0 1 0-1.414l7.768-7.768a.5.5 0 0 1 .708 0l2.121 2.121a.5.5 0 0 1 0 .707L11.829 14H27a1 1 0 0 1 1 1Z"
        })
    });
var $5aa69d829e2372da$export$2e2bcd8739ae039 = $5aa69d829e2372da$var$SvgGlyphiconsBasic829ArrowThinLeft;




const $1aa1254d2b410613$var$SvgGlyphiconsBasic83Roundabout = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20.74 8.35a9.461 9.461 0 0 0-1.897-.888 8.868 8.868 0 0 0-8.025 1.191l1.314 1.482a.5.5 0 0 1-.314.828l-6.184.747a.5.5 0 0 1-.546-.615l1.478-6.051a.5.5 0 0 1 .86-.214l1.389 1.566A12.103 12.103 0 0 1 10.63 5.27a11.968 11.968 0 0 1 9.16-.655 13.338 13.338 0 0 1 2.414 1.117.986.986 0 0 1 .373 1.232l-.399.935a.99.99 0 0 1-1.437.453ZM7.006 15.72a9.461 9.461 0 0 0 .18 2.088 8.869 8.869 0 0 0 5.044 6.355l.625-1.88a.5.5 0 0 1 .875-.142l3.739 4.982a.5.5 0 0 1-.26.78l-5.98 1.746a.5.5 0 0 1-.614-.637l.662-1.987a12.101 12.101 0 0 1-1.884-1.008 11.968 11.968 0 0 1-5.147-7.606 13.337 13.337 0 0 1-.24-2.648.986.986 0 0 1 .88-.94l1.01-.121a.99.99 0 0 1 1.11 1.018Zm13.249 8.211a9.46 9.46 0 0 0 1.719-1.199 8.868 8.868 0 0 0 2.98-7.546l-1.94.398a.5.5 0 0 1-.56-.686l2.445-5.73a.5.5 0 0 1 .806-.164l4.502 4.305a.5.5 0 0 1-.246.85l-2.05.421a12.102 12.102 0 0 1 .069 2.136 11.968 11.968 0 0 1-4.014 8.26 13.338 13.338 0 0 1-2.174 1.532.986.986 0 0 1-1.253-.292l-.61-.814a.99.99 0 0 1 .326-1.47Z"
        })
    });
var $1aa1254d2b410613$export$2e2bcd8739ae039 = $1aa1254d2b410613$var$SvgGlyphiconsBasic83Roundabout;




const $9ce94b84106f3f7d$var$SvgGlyphiconsBasic830ArrowThinRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.122 16.707-7.768 7.768a.5.5 0 0 1-.708 0l-2.121-2.121a.5.5 0 0 1 0-.707L20.171 18H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h15.171l-3.646-3.646a.5.5 0 0 1 0-.707l2.121-2.122a.5.5 0 0 1 .708 0l7.768 7.768a1 1 0 0 1 0 1.414Z"
        })
    });
var $9ce94b84106f3f7d$export$2e2bcd8739ae039 = $9ce94b84106f3f7d$var$SvgGlyphiconsBasic830ArrowThinRight;




const $d5655a4aa7fcb8b9$var$SvgGlyphiconsBasic831Male = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 4h-7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.879l-3.816 3.816a9.526 9.526 0 1 0 2.121 2.12L25 9.122V12a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM13.5 25a6.5 6.5 0 1 1 6.5-6.5 6.508 6.508 0 0 1-6.5 6.5Z"
        })
    });
var $d5655a4aa7fcb8b9$export$2e2bcd8739ae039 = $d5655a4aa7fcb8b9$var$SvgGlyphiconsBasic831Male;




const $7355db1fcc4dbb7f$var$SvgGlyphiconsBasic832Female = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 13.5a9.5 9.5 0 1 0-11 9.37V25h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2v-2.13a9.507 9.507 0 0 0 8-9.37ZM15.5 20a6.5 6.5 0 1 1 6.5-6.5 6.508 6.508 0 0 1-6.5 6.5Z"
        })
    });
var $7355db1fcc4dbb7f$export$2e2bcd8739ae039 = $7355db1fcc4dbb7f$var$SvgGlyphiconsBasic832Female;




const $954a4f6f008b203a$var$SvgGlyphiconsBasic833VirginFemale = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 14.5a8.495 8.495 0 0 0-3.868-7.117 7.516 7.516 0 0 0 2.562-3.762A.496.496 0 0 0 23.21 3h-2.151a.504.504 0 0 0-.458.31 4.47 4.47 0 0 1-8.2 0 .504.504 0 0 0-.457-.31H9.79a.496.496 0 0 0-.485.621 7.516 7.516 0 0 0 2.562 3.762A8.488 8.488 0 0 0 15 22.859V25h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2v-2.14a8.51 8.51 0 0 0 7-8.36Zm-14 0a5.5 5.5 0 1 1 5.5 5.5 5.507 5.507 0 0 1-5.5-5.5Z"
        })
    });
var $954a4f6f008b203a$export$2e2bcd8739ae039 = $954a4f6f008b203a$var$SvgGlyphiconsBasic833VirginFemale;




const $88656c1ba0c47dea$var$SvgGlyphiconsBasic834Intersex = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 3h-6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1.879l-2.6 2.6A7.994 7.994 0 1 0 15 22.854V25h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2v-2.146a7.977 7.977 0 0 0 5.305-12.038L26 8.12V10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM16.5 20a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5Z"
        })
    });
var $88656c1ba0c47dea$export$2e2bcd8739ae039 = $88656c1ba0c47dea$var$SvgGlyphiconsBasic834Intersex;




const $58ee02e1ed237497$var$SvgGlyphiconsBasic835Transgender = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 2h-6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1.879l-4.974 4.974a6.44 6.44 0 0 0-6.81 0L12.12 9l.793-.793a1 1 0 0 0 0-1.414l-.707-.707a1 1 0 0 0-1.414 0L10 6.879 8.121 5H10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7.121L7.879 9l-.793.793a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414 0l.793-.793.974.974A6.478 6.478 0 0 0 15 21.818V24h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2v-2.182a6.478 6.478 0 0 0 4.026-9.723L27 7.121V9a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1ZM16.5 19a3.5 3.5 0 1 1 3.5-3.5 3.504 3.504 0 0 1-3.5 3.5Z"
        })
    });
var $58ee02e1ed237497$export$2e2bcd8739ae039 = $58ee02e1ed237497$var$SvgGlyphiconsBasic835Transgender;




const $5e0c2a717a89b249$var$SvgGlyphiconsBasic836Lesbian = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29.4 10.722A7.993 7.993 0 0 0 18.214 4.71a.496.496 0 0 0-.142.781 10.026 10.026 0 0 1 1.121 1.593.504.504 0 0 0 .622.22 4.821 4.821 0 0 1 2.955-.134A4.996 4.996 0 0 1 21.5 17a4.969 4.969 0 0 1-3.72-1.692A7.999 7.999 0 1 0 9 19.854V23H7a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2v-3.158a8.227 8.227 0 0 0 1.746-.537.505.505 0 0 0 .18-.801 10.027 10.027 0 0 1-1.12-1.588.504.504 0 0 0-.62-.221 4.819 4.819 0 0 1-2.959.134A4.996 4.996 0 0 1 10.5 7a4.969 4.969 0 0 1 3.72 1.692A7.988 7.988 0 0 0 20 19.854V23h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2v-3.146a8.01 8.01 0 0 0 6.4-9.132Z"
        })
    });
var $5e0c2a717a89b249$export$2e2bcd8739ae039 = $5e0c2a717a89b249$var$SvgGlyphiconsBasic836Lesbian;




const $801e612dcc38bbb0$var$SvgGlyphiconsBasic837Gay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M32 9v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.879l-2.695 2.695a7.99 7.99 0 1 1-13.666 8.278.488.488 0 0 1 .257-.706 9.965 9.965 0 0 0 1.746-.834.51.51 0 0 1 .692.168A4.992 4.992 0 1 0 19.5 15a4.866 4.866 0 0 0-2.164.518A8.028 8.028 0 1 1 14.27 7.61L16.879 5H15a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V7.121l-2.706 2.707.04.065a.499.499 0 0 1-.254.733 9.93 9.93 0 0 0-1.716.827.51.51 0 0 1-.693-.168 5.01 5.01 0 1 0-2.024 7.21A7.98 7.98 0 0 1 24.279 13.6l2.6-2.6H25a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
        })
    });
var $801e612dcc38bbb0$export$2e2bcd8739ae039 = $801e612dcc38bbb0$var$SvgGlyphiconsBasic837Gay;




const $ce325b6b54ebf63f$var$SvgGlyphiconsBasic838Hetero = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 4v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V8.121l-2.247 2.247a7.502 7.502 0 1 1-13.05.978A4.499 4.499 0 1 0 9.5 19a4.236 4.236 0 0 0 1.122-.157.497.497 0 0 1 .576.238 9.502 9.502 0 0 0 1.131 1.617.507.507 0 0 1-.202.816 7.84 7.84 0 0 1-1.127.322V24h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2H6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2v-2.151a7.502 7.502 0 1 1 9-7.349 7.426 7.426 0 0 1-.702 3.154A4.499 4.499 0 1 0 19.5 10a4.228 4.228 0 0 0-1.115.155.498.498 0 0 1-.577-.238 9.585 9.585 0 0 0-1.126-1.626.507.507 0 0 1 .205-.813 7.439 7.439 0 0 1 6.745.77L25.879 6H24a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
        })
    });
var $ce325b6b54ebf63f$export$2e2bcd8739ae039 = $ce325b6b54ebf63f$var$SvgGlyphiconsBasic838Hetero;




const $9a101602904ccbfb$var$SvgGlyphiconsBasic839Other = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 3h-6a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1.879L20 8.879l-.793-.793a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414l.793.793-1.142 1.142a8.485 8.485 0 1 0 2.304 1.938L20 13.12l.793.793a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414L22.121 11 25 8.121V10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM12.5 25a5.5 5.5 0 1 1 5.5-5.5 5.507 5.507 0 0 1-5.5 5.5Z"
        })
    });
var $9a101602904ccbfb$export$2e2bcd8739ae039 = $9a101602904ccbfb$var$SvgGlyphiconsBasic839Other;




const $2d97e5654f96c170$var$SvgGlyphiconsBasic84Random = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29.906 22.089a.5.5 0 0 1 0 .822l-5.121 3.546a.5.5 0 0 1-.785-.411V24h-2.672a3.477 3.477 0 0 1-2.474-1.025l-3.44-3.44 2.121-2.12 3.44 3.439a.503.503 0 0 0 .353.146H24v-2.046a.5.5 0 0 1 .785-.41ZM21.328 11H24v2.046a.5.5 0 0 0 .785.41l5.121-3.545a.5.5 0 0 0 0-.822l-5.121-3.546a.5.5 0 0 0-.785.411V8h-2.671a3.501 3.501 0 0 0-2.476 1.025L14 13.88 9.146 9.025A3.499 3.499 0 0 0 6.672 8H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.672a.5.5 0 0 1 .353.146L11.88 16l-4.854 4.854a.5.5 0 0 1-.353.146H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.672a3.499 3.499 0 0 0 2.474-1.025l11.829-11.829a.5.5 0 0 1 .353-.146Z"
        })
    });
var $2d97e5654f96c170$export$2e2bcd8739ae039 = $2d97e5654f96c170$var$SvgGlyphiconsBasic84Random;




const $e05473745707d96e$var$SvgGlyphiconsBasic840Unknown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 23.5v.5h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2v1.5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V27h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2v-.5c0-3.69 2.231-5.603 4.023-7.139C20.687 14.936 22 13.811 22 11.5A4.357 4.357 0 0 0 17.5 7a5.46 5.46 0 0 0-3.928 1.65 20.53 20.53 0 0 1-.358.35H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.968c.186-.178.344-.33.43-.418A8.436 8.436 0 0 1 17.5 4a7.346 7.346 0 0 1 7.5 7.5c0 3.69-2.231 5.603-4.023 7.139C19.313 20.064 18 21.189 18 23.5Z"
        })
    });
var $e05473745707d96e$export$2e2bcd8739ae039 = $e05473745707d96e$var$SvgGlyphiconsBasic840Unknown;




const $c4b1aa4fa8467292$var$SvgGlyphiconsBasic841SquarePlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4ZM22 17a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1Z"
        })
    });
var $c4b1aa4fa8467292$export$2e2bcd8739ae039 = $c4b1aa4fa8467292$var$SvgGlyphiconsBasic841SquarePlus;




const $0ff2e32a37920f7d$var$SvgGlyphiconsBasic842SquareMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4ZM22 17a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z"
        })
    });
var $0ff2e32a37920f7d$export$2e2bcd8739ae039 = $0ff2e32a37920f7d$var$SvgGlyphiconsBasic842SquareMinus;




const $1cc86020c9810652$var$SvgGlyphiconsBasic843SquareRemove = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-3.197 14.475a.5.5 0 0 1 0 .707l-2.121 2.121a.5.5 0 0 1-.707 0L16 18.828l-2.475 2.475a.5.5 0 0 1-.707 0l-2.121-2.121a.5.5 0 0 1 0-.707L13.172 16l-2.475-2.475a.5.5 0 0 1 0-.707l2.121-2.121a.5.5 0 0 1 .707 0L16 13.17l2.475-2.474a.5.5 0 0 1 .707 0l2.121 2.12a.5.5 0 0 1 0 .708L18.828 16Z"
        })
    });
var $1cc86020c9810652$export$2e2bcd8739ae039 = $1cc86020c9810652$var$SvgGlyphiconsBasic843SquareRemove;




const $c362e54d0183d148$var$SvgGlyphiconsBasic844SquareCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-1.93 8.4-7.292 8.628a1 1 0 0 1-1.507.025l-3.89-4.312a.5.5 0 0 1 .007-.677l1.137-1.215a.5.5 0 0 1 .633-.08l2.611 1.662 6.573-5.695a.5.5 0 0 1 .671.015l1.019.964a.5.5 0 0 1 .038.686Z"
        })
    });
var $c362e54d0183d148$export$2e2bcd8739ae039 = $c362e54d0183d148$var$SvgGlyphiconsBasic844SquareCheck;




const $bdb7913f79835b52$var$SvgGlyphiconsBasic845SquareQuestion = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4ZM18 22a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm2.75-8.886c0 1.38-.867 2.082-1.956 2.825a3.518 3.518 0 0 0-1.473 1.721.491.491 0 0 1-.472.34h-2.062a.502.502 0 0 1-.494-.58 3.269 3.269 0 0 1 .66-1.601 10.465 10.465 0 0 1 2.327-1.857 1.016 1.016 0 0 0 .47-.848V13a1.001 1.001 0 0 0-1-1h-1.5a1 1 0 0 0-1 1 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1 4 4 0 0 1 4-4h1.5c2.283 0 4 1.164 4 4Z"
        })
    });
var $bdb7913f79835b52$export$2e2bcd8739ae039 = $bdb7913f79835b52$var$SvgGlyphiconsBasic845SquareQuestion;




const $87ee00ee94790fe5$var$SvgGlyphiconsBasic846SquareInfo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-6.075 10.916L16.6 21h1.26a.5.5 0 0 1 .485.621l-.25 1a.5.5 0 0 1-.485.379H14a1.408 1.408 0 0 1-1.425-1.916L14.4 15h-.76a.5.5 0 0 1-.485-.621l.25-1A.5.5 0 0 1 13.89 13H17a1.408 1.408 0 0 1 1.425 1.916Zm.145-3.334a.5.5 0 0 1-.494.418H15.59a.5.5 0 0 1-.493-.582l.333-2A.5.5 0 0 1 15.924 9h2.486a.5.5 0 0 1 .493.582Z"
        })
    });
var $87ee00ee94790fe5$export$2e2bcd8739ae039 = $87ee00ee94790fe5$var$SvgGlyphiconsBasic846SquareInfo;




const $df6af8aee6f3a927$var$SvgGlyphiconsBasic847SquareAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4ZM18 22a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm0-9-.92 4.598a.5.5 0 0 1-.49.402h-1.18a.5.5 0 0 1-.491-.402L14 13v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Z"
        })
    });
var $df6af8aee6f3a927$export$2e2bcd8739ae039 = $df6af8aee6f3a927$var$SvgGlyphiconsBasic847SquareAlert;




const $fc74b0a27451bb00$var$SvgGlyphiconsBasic848Subtitles = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 5h-18A3.504 3.504 0 0 0 3 8.5v12A3.504 3.504 0 0 0 6.5 24h5.45l2.264 3.771a1.5 1.5 0 0 0 2.572 0L19.05 24h5.45a3.504 3.504 0 0 0 3.5-3.5v-12A3.504 3.504 0 0 0 24.5 5Zm.5 15.5a.501.501 0 0 1-.5.5h-6.3a1.5 1.5 0 0 0-1.286.729L15.5 24.085l-1.414-2.356A1.5 1.5 0 0 0 12.8 21H6.5a.501.501 0 0 1-.5-.5v-12a.501.501 0 0 1 .5-.5h18a.501.501 0 0 1 .5.5ZM17 17v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm-5 0v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm10 0v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z"
        })
    });
var $fc74b0a27451bb00$export$2e2bcd8739ae039 = $fc74b0a27451bb00$var$SvgGlyphiconsBasic848Subtitles;




const $a1a353d4e3cc9e51$var$SvgGlyphiconsBasic849ComputerNetwork = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17 14v-2a1 1 0 0 0-1-1h-1V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v6H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1Zm-4-4H8V6h5Zm14 14h-1v-6a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v6h-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm-3-1h-5v-4h5Zm-10 0a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-5a1 1 0 0 1 2 0v4h4a1 1 0 0 1 1 1Zm4-15a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V9h-4a1 1 0 0 1-1-1Z"
        })
    });
var $a1a353d4e3cc9e51$export$2e2bcd8739ae039 = $a1a353d4e3cc9e51$var$SvgGlyphiconsBasic849ComputerNetwork;




const $c799fb724d8e0584$var$SvgGlyphiconsBasic85Heating = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.046 10h-2.214a8.732 8.732 0 0 1-.98 3.314 5.869 5.869 0 0 0-.732 3.016 5.875 5.875 0 0 0 .733 3.019 8.754 8.754 0 0 1 1.027 4.316 8.913 8.913 0 0 1-.713 3.741.992.992 0 0 1-.914.594h-1.42a.746.746 0 0 1-.676-1.068 7.316 7.316 0 0 0 .723-3.267 5.874 5.874 0 0 0-.733-3.019 8.754 8.754 0 0 1-1.027-4.316 8.74 8.74 0 0 1 1.028-4.314A6.053 6.053 0 0 0 24.82 10h-1.866a.5.5 0 0 1-.41-.785l3.545-5.121a.5.5 0 0 1 .822 0l3.546 5.121a.5.5 0 0 1-.411.785ZM16.91 4.094a.5.5 0 0 0-.822 0l-3.546 5.121a.5.5 0 0 0 .411.785h1.866a6.053 6.053 0 0 1-.672 2.016 8.74 8.74 0 0 0-1.028 4.314 8.754 8.754 0 0 0 1.027 4.316 5.874 5.874 0 0 1 .733 3.019 7.316 7.316 0 0 1-.723 3.267.746.746 0 0 0 .677 1.068h1.419a.992.992 0 0 0 .914-.594 8.913 8.913 0 0 0 .713-3.741 8.754 8.754 0 0 0-1.027-4.316 5.875 5.875 0 0 1-.733-3.019 5.869 5.869 0 0 1 .732-3.016 8.732 8.732 0 0 0 .98-3.314h2.214a.5.5 0 0 0 .41-.785Zm-10 0a.5.5 0 0 0-.822 0L2.543 9.215a.5.5 0 0 0 .411.785H4.82a6.053 6.053 0 0 1-.672 2.016A8.74 8.74 0 0 0 3.12 16.33a8.754 8.754 0 0 0 1.028 4.316 5.874 5.874 0 0 1 .732 3.019 7.316 7.316 0 0 1-.723 3.266A.746.746 0 0 0 4.834 28h1.419a.992.992 0 0 0 .914-.594 8.913 8.913 0 0 0 .713-3.741 8.754 8.754 0 0 0-1.027-4.316 5.875 5.875 0 0 1-.733-3.019 5.869 5.869 0 0 1 .732-3.016A8.732 8.732 0 0 0 7.832 10h2.214a.5.5 0 0 0 .41-.785Z"
        })
    });
var $c799fb724d8e0584$export$2e2bcd8739ae039 = $c799fb724d8e0584$var$SvgGlyphiconsBasic85Heating;




const $e96ce62195143d46$var$SvgGlyphiconsBasic850ComputerNetworkAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 15h11a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1V5a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v6h-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1Zm3-9h5v4h-5Zm0 18h-1v-6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm-3-1H5v-4h5Zm19 1h-1v-6a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v6h-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm-3-1h-5v-4h5Z"
        })
    });
var $e96ce62195143d46$export$2e2bcd8739ae039 = $e96ce62195143d46$var$SvgGlyphiconsBasic850ComputerNetworkAlt;




const $ab2a606ae62ffc23$var$SvgGlyphiconsBasic851SubtitlesOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1c0-.015.008-.027.008-.042l.95-.95c.015 0 .027-.008.042-.008Zm6.951-7.984L25 10.966V20.5a.501.501 0 0 1-.5.5h-6.3a1.5 1.5 0 0 0-1.286.729L15.5 24.085l-1.357-2.261-2.187 2.186 2.258 3.762a1.5 1.5 0 0 0 2.572 0L19.05 24h5.45a3.504 3.504 0 0 0 3.5-3.5v-12a3.458 3.458 0 0 0-.049-.484Zm-.736-2.955L5.06 27.215a1.5 1.5 0 0 1-2.122-2.121l1.662-1.662A3.495 3.495 0 0 1 3 20.5v-12A3.504 3.504 0 0 1 6.5 5h16.533l2.06-2.06a1.5 1.5 0 0 1 2.122 2.12ZM20.033 8H6.5a.501.501 0 0 0-.5.5v12a.501.501 0 0 0 .5.5h.533l2.28-2.28A.992.992 0 0 1 9 18v-1a1 1 0 0 1 1-1h1a.991.991 0 0 1 .72.313Z"
        })
    });
var $ab2a606ae62ffc23$export$2e2bcd8739ae039 = $ab2a606ae62ffc23$var$SvgGlyphiconsBasic851SubtitlesOff;




const $33d74fb52e45565e$var$SvgGlyphiconsBasic852SubtitlesPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5ZM26 14a8.043 8.043 0 0 1-1-.07v6.57a.501.501 0 0 1-.5.5h-6.3a1.5 1.5 0 0 0-1.286.729L15.5 24.085l-1.414-2.356A1.5 1.5 0 0 0 12.8 21H6.5a.501.501 0 0 1-.5-.5v-12a.501.501 0 0 1 .5-.5h11.763A7.96 7.96 0 0 1 18 6a8.009 8.009 0 0 1 .07-1H6.5A3.504 3.504 0 0 0 3 8.5v12A3.504 3.504 0 0 0 6.5 24h5.45l2.264 3.771a1.5 1.5 0 0 0 2.572 0L19.05 24h5.45a3.504 3.504 0 0 0 3.5-3.5v-6.763A7.963 7.963 0 0 1 26 14Zm-6 5h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm-5-3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-5 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $33d74fb52e45565e$export$2e2bcd8739ae039 = $33d74fb52e45565e$var$SvgGlyphiconsBasic852SubtitlesPlus;




const $d989e5b262d584e1$var$SvgGlyphiconsBasic853SubtitlesMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5ZM20 19h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm6-5a8.043 8.043 0 0 1-1-.07v6.57a.501.501 0 0 1-.5.5h-6.3a1.5 1.5 0 0 0-1.286.729L15.5 24.085l-1.414-2.356A1.5 1.5 0 0 0 12.8 21H6.5a.501.501 0 0 1-.5-.5v-12a.501.501 0 0 1 .5-.5h11.763A7.96 7.96 0 0 1 18 6a8.009 8.009 0 0 1 .07-1H6.5A3.504 3.504 0 0 0 3 8.5v12A3.504 3.504 0 0 0 6.5 24h5.45l2.264 3.771a1.5 1.5 0 0 0 2.572 0L19.05 24h5.45a3.504 3.504 0 0 0 3.5-3.5v-6.763A7.963 7.963 0 0 1 26 14Zm-11 2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-5 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
        })
    });
var $d989e5b262d584e1$export$2e2bcd8739ae039 = $d989e5b262d584e1$var$SvgGlyphiconsBasic853SubtitlesMinus;




const $56ccd67343c2662c$var$SvgGlyphiconsBasic854AudioDescriptionD = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 5h-18A3.504 3.504 0 0 0 3 8.5v12A3.504 3.504 0 0 0 6.5 24h5.45l2.264 3.771a1.5 1.5 0 0 0 2.572 0L19.05 24h5.45a3.504 3.504 0 0 0 3.5-3.5v-12A3.504 3.504 0 0 0 24.5 5Zm.5 15.5a.501.501 0 0 1-.5.5h-6.3a1.5 1.5 0 0 0-1.286.729L15.5 24.085l-1.414-2.356A1.5 1.5 0 0 0 12.8 21H6.5a.501.501 0 0 1-.5-.5v-12a.501.501 0 0 1 .5-.5h18a.501.501 0 0 1 .5.5ZM12 11h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2a3.003 3.003 0 0 0 3-3v-1a3.003 3.003 0 0 0-3-3Zm1 4a1 1 0 0 1-1 1h-1v-3h1a1 1 0 0 1 1 1Zm5.521-2.246a3.425 3.425 0 0 1 0 3.492 1 1 0 1 1-1.73-1.002 1.43 1.43 0 0 0 0-1.488 1 1 0 1 1 1.73-1.002Zm3.467-2.001a7.445 7.445 0 0 1 0 7.494 1 1 0 0 1-.866.5 1 1 0 0 1-.864-1.502 5.448 5.448 0 0 0 0-5.49 1 1 0 1 1 1.73-1.002Z"
        })
    });
var $56ccd67343c2662c$export$2e2bcd8739ae039 = $56ccd67343c2662c$var$SvgGlyphiconsBasic854AudioDescriptionD;




const $d40d5d51519e0aef$var$SvgGlyphiconsBasic855AudioDescription = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 5h-18A3.504 3.504 0 0 0 3 8.5v12A3.504 3.504 0 0 0 6.5 24h5.45l2.264 3.771a1.5 1.5 0 0 0 2.572 0L19.05 24h5.45a3.504 3.504 0 0 0 3.5-3.5v-12A3.504 3.504 0 0 0 24.5 5Zm.5 15.5a.501.501 0 0 1-.5.5h-6.3a1.5 1.5 0 0 0-1.286.729L15.5 24.085l-1.414-2.356A1.5 1.5 0 0 0 12.8 21H6.5a.501.501 0 0 1-.5-.5v-12a.501.501 0 0 1 .5-.5h18a.501.501 0 0 1 .5.5Zm-6.479-7.746a3.425 3.425 0 0 1 0 3.492 1 1 0 1 1-1.73-1.002 1.43 1.43 0 0 0 0-1.488 1 1 0 1 1 1.73-1.002Zm3.467-2.001a7.445 7.445 0 0 1 0 7.494 1 1 0 0 1-.866.5 1 1 0 0 1-.864-1.502 5.448 5.448 0 0 0 0-5.49 1 1 0 1 1 1.73-1.002Zm-11.246 1.002a5.448 5.448 0 0 0 0 5.49 1 1 0 1 1-1.73 1.002 7.445 7.445 0 0 1 0-7.494 1 1 0 1 1 1.73 1.002Zm3.467 2a1.43 1.43 0 0 0 0 1.49 1 1 0 1 1-1.73 1.001A3.492 3.492 0 0 1 12 14.5a3.452 3.452 0 0 1 .479-1.746 1 1 0 1 1 1.73 1.002Z"
        })
    });
var $d40d5d51519e0aef$export$2e2bcd8739ae039 = $d40d5d51519e0aef$var$SvgGlyphiconsBasic855AudioDescription;




const $00fe4b955e3a1d55$var$SvgGlyphiconsBasic856SquarePlay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-4.34 12.822-5.665 3.226a1 1 0 0 1-1.495-.87v-6.451a1 1 0 0 1 1.495-.87l5.665 3.227a1 1 0 0 1 0 1.738Z"
        })
    });
var $00fe4b955e3a1d55$export$2e2bcd8739ae039 = $00fe4b955e3a1d55$var$SvgGlyphiconsBasic856SquarePlay;




const $b10c7124ec619f4a$var$SvgGlyphiconsBasic857SquareDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-3.69 12.57-3.989 5.746a1 1 0 0 1-1.643 0L11.19 16.57A1 1 0 0 1 12.01 15H14v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4h1.989a1 1 0 0 1 .821 1.57Z"
        })
    });
var $b10c7124ec619f4a$export$2e2bcd8739ae039 = $b10c7124ec619f4a$var$SvgGlyphiconsBasic857SquareDown;




const $5c8097319a80945c$var$SvgGlyphiconsBasic858SquareUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-4.511 13H18v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-4h-1.989a1 1 0 0 1-.821-1.57l3.989-5.746a1 1 0 0 1 1.643 0l3.988 5.746A1 1 0 0 1 19.99 17Z"
        })
    });
var $5c8097319a80945c$export$2e2bcd8739ae039 = $5c8097319a80945c$var$SvgGlyphiconsBasic858SquareUp;




const $689c15a7cee65ba0$var$SvgGlyphiconsBasic859SquareLeft = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4ZM22 17a1 1 0 0 1-1 1h-4v1.989a1 1 0 0 1-1.57.821l-5.746-3.988a1 1 0 0 1 0-1.644l5.746-3.988a1 1 0 0 1 1.57.821V14h4a1 1 0 0 1 1 1Z"
        })
    });
var $689c15a7cee65ba0$export$2e2bcd8739ae039 = $689c15a7cee65ba0$var$SvgGlyphiconsBasic859SquareLeft;




const $c0c35c16052e9f99$var$SvgGlyphiconsBasic86Reload = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m19.873 10.138 1.318-1.483a8.924 8.924 0 0 0-6.254-1.592 9.017 9.017 0 0 0-7.428 11.945 8.89 8.89 0 0 0 5.762 5.579 9.018 9.018 0 0 0 10.662-4.346.988.988 0 0 1 1.252-.437l.926.385a1.008 1.008 0 0 1 .502 1.401 11.993 11.993 0 1 1-3.414-15.194l1.385-1.558a.5.5 0 0 1 .86.214l1.472 6.052a.5.5 0 0 1-.546.615l-6.184-.753a.5.5 0 0 1-.313-.828Z"
        })
    });
var $c0c35c16052e9f99$export$2e2bcd8739ae039 = $c0c35c16052e9f99$var$SvgGlyphiconsBasic86Reload;




const $2077d4928894a146$var$SvgGlyphiconsBasic860SquareRight = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-2.184 12.822L16.57 20.81A1 1 0 0 1 15 19.99V18h-4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h4v-1.989a1 1 0 0 1 1.57-.821l5.746 3.988a1 1 0 0 1 0 1.644Z"
        })
    });
var $2077d4928894a146$export$2e2bcd8739ae039 = $2077d4928894a146$var$SvgGlyphiconsBasic860SquareRight;




const $265becc94a985484$var$SvgGlyphiconsBasic861VrInside = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26 7H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.654a2 2 0 0 0 1.857-1.257l.994-2.486A2 2 0 0 1 15.362 20h1.292a2 2 0 0 1 1.857 1.257l.994 2.486A2 2 0 0 0 21.362 25H26a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2ZM11.5 17a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5Zm9 0a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5Z"
        })
    });
var $265becc94a985484$export$2e2bcd8739ae039 = $265becc94a985484$var$SvgGlyphiconsBasic861VrInside;




const $34ad639e081bf291$var$SvgGlyphiconsBasic862Vr = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 7a36.422 36.422 0 0 0-4 .22V6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1.22A36.423 36.423 0 0 0 16 7Zm14 6h-1v6h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM1 14v4a1 1 0 0 0 1 1h1v-6H2a1 1 0 0 0-1 1Zm26-.916v7.217a3 3 0 0 1-1.457 2.573l-2.13 1.279a3 3 0 0 1-2.886.11l-3.185-1.592a3 3 0 0 0-2.684 0l-3.185 1.592a3 3 0 0 1-2.885-.11l-2.131-1.279A3 3 0 0 1 5 20.301v-7.217a2.992 2.992 0 0 1 2.122-2.87A30.882 30.882 0 0 1 16 9a30.882 30.882 0 0 1 8.878 1.214A2.992 2.992 0 0 1 27 13.084Zm-2.71-.959A28.831 28.831 0 0 0 16 11a29.951 29.951 0 0 0-7.513.91A2 2 0 0 0 7 13.846V16a1 1 0 0 0 2 0l-.005-2.155A27.925 27.925 0 0 1 16 13a26.858 26.858 0 0 1 7.71 1.04 1 1 0 1 0 .58-1.915Z"
        })
    });
var $34ad639e081bf291$export$2e2bcd8739ae039 = $34ad639e081bf291$var$SvgGlyphiconsBasic862Vr;




const $2f1f0967240f4e8d$var$SvgGlyphiconsBasic863UserVr = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 24.237V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.763a1.578 1.578 0 0 1 .931-1.365l5.136-2.705A5.024 5.024 0 0 0 14.553 23h1.894a5.023 5.023 0 0 0 4.486-2.833l5.136 2.705A1.578 1.578 0 0 1 27 24.237ZM20.41 6.53C19.584 4.962 17.908 4 15.5 4c-2.408 0-4.084.962-4.91 2.53A24.556 24.556 0 0 1 15.5 6a24.544 24.544 0 0 1 4.91.53Zm-1.426 10.302-3.265-.733a1.015 1.015 0 0 0-.219-.024.986.986 0 0 0-.22.025l-3.264.732a2.982 2.982 0 0 1-.659.073c-.04 0-.077-.01-.117-.011l.381 1.745A3 3 0 0 0 14.552 21h1.896a3 3 0 0 0 2.93-2.36l.381-1.746c-.039.002-.077.011-.116.011a2.982 2.982 0 0 1-.659-.073Zm-8.325-2.211a1 1 0 0 0 .918.26l3.266-.733a2.994 2.994 0 0 1 1.314 0l3.266.733a1 1 0 0 0 .918-.26l1.056-1.033a2 2 0 0 0 .603-1.43v-1.624a2.004 2.004 0 0 0-1.568-1.953A22.798 22.798 0 0 0 15.5 8a22.798 22.798 0 0 0-4.932.58A2.004 2.004 0 0 0 9 10.535v1.624a2 2 0 0 0 .603 1.43Z"
        })
    });
var $2f1f0967240f4e8d$export$2e2bcd8739ae039 = $2f1f0967240f4e8d$var$SvgGlyphiconsBasic863UserVr;




const $e1ae0986e8b2b61a$var$SvgGlyphiconsBasic864UserVrPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.603 13.588A2 2 0 0 1 9 12.158v-1.624a2.004 2.004 0 0 1 1.568-1.953A22.798 22.798 0 0 1 15.5 8a21.012 21.012 0 0 1 2.815.2 8.022 8.022 0 0 0 3.557 4.64 1.99 1.99 0 0 1-.475.748l-1.056 1.033a1 1 0 0 1-.918.26l-3.266-.733a2.994 2.994 0 0 0-1.314 0l-3.266.733a1 1 0 0 1-.918-.26Zm8.405-7.439C18.007 6.1 18 6.05 18 6a7.996 7.996 0 0 1 .146-1.501A6.717 6.717 0 0 0 15.5 4c-2.408 0-4.084.962-4.91 2.53A24.556 24.556 0 0 1 15.5 6a22.464 22.464 0 0 1 2.508.15Zm.976 10.683-3.265-.733a1.015 1.015 0 0 0-.219-.024.986.986 0 0 0-.22.025l-3.264.732a2.982 2.982 0 0 1-.659.073c-.04 0-.077-.01-.117-.011l.381 1.745A3 3 0 0 0 14.552 21h1.896a3 3 0 0 0 2.93-2.36l.381-1.746c-.039.002-.077.011-.116.011a2.982 2.982 0 0 1-.659-.073Zm7.085 6.04-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $e1ae0986e8b2b61a$export$2e2bcd8739ae039 = $e1ae0986e8b2b61a$var$SvgGlyphiconsBasic864UserVrPlus;




const $e070bb42d1ce67cf$var$SvgGlyphiconsBasic865UserVrMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.5 6a24.556 24.556 0 0 0-4.91.53C11.417 4.962 13.093 4 15.5 4a6.717 6.717 0 0 1 2.646.499A7.996 7.996 0 0 0 18 6c0 .05.007.1.008.15A22.464 22.464 0 0 0 15.5 6Zm-4.84 8.62a1 1 0 0 0 .917.261l3.266-.733a2.994 2.994 0 0 1 1.314 0l3.266.733a1 1 0 0 0 .918-.26l1.056-1.033a1.99 1.99 0 0 0 .475-.748 8.022 8.022 0 0 1-3.557-4.64A21.012 21.012 0 0 0 15.5 8a22.798 22.798 0 0 0-4.932.58A2.004 2.004 0 0 0 9 10.535v1.624a2 2 0 0 0 .603 1.43Zm8.324 2.212-3.265-.733a1.015 1.015 0 0 0-.219-.024.986.986 0 0 0-.22.025l-3.264.732a2.982 2.982 0 0 1-.659.073c-.04 0-.077-.01-.117-.011l.381 1.745A3 3 0 0 0 14.552 21h1.896a3 3 0 0 0 2.93-2.36l.381-1.746c-.039.002-.077.011-.116.011a2.982 2.982 0 0 1-.659-.073Zm7.085 6.04-5.136-2.705A5.023 5.023 0 0 1 16.447 23h-1.894a5.024 5.024 0 0 1-4.486-2.833l-5.136 2.705A1.578 1.578 0 0 0 4 24.237V27a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-2.763a1.578 1.578 0 0 0-.931-1.365ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $e070bb42d1ce67cf$export$2e2bcd8739ae039 = $e070bb42d1ce67cf$var$SvgGlyphiconsBasic865UserVrMinus;




const $f866f1ac44855e23$var$SvgGlyphiconsBasic866ViewFull = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 11h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-6 1a3.003 3.003 0 0 0-3 3v2a3 3 0 0 0 6 0v-2a3.003 3.003 0 0 0-3-3Zm1 5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0Zm-7.5-2h-1c-.171 0-.5.044-.5.044A1.046 1.046 0 0 1 16.044 14H17.5a1 1 0 0 0 0-2h-1.456A3.047 3.047 0 0 0 13 15.044v2.504c0 .017.009.031.01.048A2.497 2.497 0 0 0 15.5 20h1a2.5 2.5 0 0 0 0-5Zm0 3h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1ZM12 14.5a2.476 2.476 0 0 1-.512 1.5A2.476 2.476 0 0 1 12 17.5 2.502 2.502 0 0 1 9.5 20h-2a1 1 0 0 1 0-2h2a.5.5 0 0 0 0-1H9a1 1 0 0 1 0-2h.5a.5.5 0 0 0 0-1h-2a1 1 0 0 1 0-2h2a2.502 2.502 0 0 1 2.5 2.5ZM8.539 9.514a.872.872 0 0 1-.025-1.085 11.499 11.499 0 0 1 7.484-3.38L16 3.954a.5.5 0 0 1 .784-.411l4.12 2.549a.5.5 0 0 1 0 .822L16.78 9.457a.5.5 0 0 1-.784-.412V8.06A11.749 11.749 0 0 0 9.529 9.65a.807.807 0 0 1-.99-.137Zm14.923 12.972a.872.872 0 0 1 .024 1.085 11.499 11.499 0 0 1-7.484 3.38L16 28.046a.5.5 0 0 1-.784.411l-4.12-2.549a.5.5 0 0 1 0-.822l4.124-2.543a.5.5 0 0 1 .784.412v.986a11.749 11.749 0 0 0 6.468-1.592.807.807 0 0 1 .99.137Z"
        })
    });
var $f866f1ac44855e23$export$2e2bcd8739ae039 = $f866f1ac44855e23$var$SvgGlyphiconsBasic866ViewFull;




const $a185790af6433480$var$SvgGlyphiconsBasic867ViewHalf = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 11h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-12.5 1h-1a2.502 2.502 0 0 0-2.5 2.5 2.476 2.476 0 0 0 .512 1.5A2.476 2.476 0 0 0 12 17.5a2.502 2.502 0 0 0 2.5 2.5h1a2.502 2.502 0 0 0 2.5-2.5 2.476 2.476 0 0 0-.512-1.5A2.476 2.476 0 0 0 18 14.5a2.502 2.502 0 0 0-2.5-2.5Zm-1 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1Zm1 4h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1Zm6.5-6a3.003 3.003 0 0 0-3 3v2a3 3 0 0 0 6 0v-2a3.003 3.003 0 0 0-3-3Zm1 5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0Zm-13-4v6a1 1 0 0 1-2 0v-3.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2A1 1 0 0 1 10 13ZM8.539 9.514a.872.872 0 0 1-.025-1.085 11.499 11.499 0 0 1 7.484-3.38L16 3.954a.5.5 0 0 1 .784-.411l4.12 2.549a.5.5 0 0 1 0 .822L16.78 9.457a.5.5 0 0 1-.784-.412V8.06A11.749 11.749 0 0 0 9.529 9.65a.807.807 0 0 1-.99-.137Zm14.923 12.972a.872.872 0 0 1 .024 1.085 11.499 11.499 0 0 1-7.484 3.38L16 28.046a.5.5 0 0 1-.784.411l-4.12-2.549a.5.5 0 0 1 0-.822l4.124-2.543a.5.5 0 0 1 .784.412v.986a11.749 11.749 0 0 0 6.468-1.592.807.807 0 0 1 .99.137Z"
        })
    });
var $a185790af6433480$export$2e2bcd8739ae039 = $a185790af6433480$var$SvgGlyphiconsBasic867ViewHalf;




const $633674e569bfd3c8$var$SvgGlyphiconsBasic868Puzzle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 17v10a1 1 0 0 1-1 1H17a1 1 0 0 1-1-1v-2.283a1.444 1.444 0 0 0-1.467-1.467 1.51 1.51 0 0 0-1.194.618 2.996 2.996 0 0 1-5.29-2.415 3.017 3.017 0 0 1 2.466-2.415 2.985 2.985 0 0 1 2.826 1.097 1.518 1.518 0 0 0 1.192.615A1.365 1.365 0 0 0 16 19.283V17a1 1 0 0 1 1-1h2.283a1.365 1.365 0 0 1 1.467 1.467 1.518 1.518 0 0 1-.615 1.192 2.984 2.984 0 0 0-1.097 2.826A3 3 0 0 0 25 21a2.98 2.98 0 0 0-1.132-2.34 1.51 1.51 0 0 1-.618-1.193A1.444 1.444 0 0 1 24.716 16H27a1 1 0 0 1 1 1ZM8.75 14.533a1.51 1.51 0 0 0-.618-1.194 2.996 2.996 0 0 1 2.415-5.29 3.017 3.017 0 0 1 2.415 2.466 2.984 2.984 0 0 1-1.097 2.826 1.518 1.518 0 0 0-.615 1.192A1.365 1.365 0 0 0 12.717 16H15a1 1 0 0 0 1-1v-2.283a1.365 1.365 0 0 1 1.467-1.467 1.518 1.518 0 0 1 1.192.615 2.985 2.985 0 0 0 2.826 1.097A3 3 0 0 0 21 7a2.98 2.98 0 0 0-2.34 1.132 1.51 1.51 0 0 1-1.193.618A1.444 1.444 0 0 1 16 7.283V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2.284a1.444 1.444 0 0 0 1.466-1.467Z"
        })
    });
var $633674e569bfd3c8$export$2e2bcd8739ae039 = $633674e569bfd3c8$var$SvgGlyphiconsBasic868Puzzle;




const $07e035cf3635c8bc$var$SvgGlyphiconsBasic869DoorOpen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m29.752 16.832-6.197 4.131A1 1 0 0 1 22 20.131V11.87a1 1 0 0 1 1.555-.833l6.197 4.132a1 1 0 0 1 0 1.664ZM10 11.869a1 1 0 0 0-1.555-.833l-6.197 4.132a1 1 0 0 0 0 1.664l6.197 4.131A1 1 0 0 0 10 20.131ZM20.5 24H20V8h.5a1.5 1.5 0 0 0 0-3h-2A1.5 1.5 0 0 0 17 6.5v19a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 0-3Zm-7-19h-2a1.5 1.5 0 0 0 0 3h.5v16h-.5a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 13.5 5Z"
        })
    });
var $07e035cf3635c8bc$export$2e2bcd8739ae039 = $07e035cf3635c8bc$var$SvgGlyphiconsBasic869DoorOpen;




const $08573f99e23c279c$var$SvgGlyphiconsBasic87Tv = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 26v1a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Zm7-19.5v15a1.5 1.5 0 0 1-1.5 1.5h-25A1.5 1.5 0 0 1 2 21.5v-15A1.5 1.5 0 0 1 3.5 5h25A1.5 1.5 0 0 1 30 6.5ZM27 8H5v12h22Z"
        })
    });
var $08573f99e23c279c$export$2e2bcd8739ae039 = $08573f99e23c279c$var$SvgGlyphiconsBasic87Tv;




const $3018c9e8884be977$var$SvgGlyphiconsBasic870DoorClose = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 25.5a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-19A1.5 1.5 0 0 1 18.5 5h2a1.5 1.5 0 0 1 0 3H20v16h.5a1.5 1.5 0 0 1 1.5 1.5ZM13.5 5h-2a1.5 1.5 0 0 0 0 3h.5v16h-.5a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 0 1.5-1.5v-19A1.5 1.5 0 0 0 13.5 5ZM9.752 15.168l-6.197-4.132A1 1 0 0 0 2 11.87v8.262a1 1 0 0 0 1.555.832l6.197-4.131a1 1 0 0 0 0-1.664Zm18.693-4.132-6.197 4.132a1 1 0 0 0 0 1.664l6.197 4.131A1 1 0 0 0 30 20.131V11.87a1 1 0 0 0-1.555-.833Z"
        })
    });
var $3018c9e8884be977$export$2e2bcd8739ae039 = $3018c9e8884be977$var$SvgGlyphiconsBasic870DoorClose;




const $4c60f44bc9d84b0b$var$SvgGlyphiconsBasic871Package = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22.955 14.261 11.067 6.194l3.961-2.377 12 8ZM9.177 7.328 5.028 9.817l12 8 4.037-2.422ZM4 19.535l12 8v-8l-12-8Zm20-3.569v2.717a.5.5 0 0 1-.243.429l-1 .6a.5.5 0 0 1-.757-.429v-2.117l-4 2.4v8l10-6v-8Z"
        })
    });
var $4c60f44bc9d84b0b$export$2e2bcd8739ae039 = $4c60f44bc9d84b0b$var$SvgGlyphiconsBasic871Package;




const $52898fad6113d16d$var$SvgGlyphiconsBasic872OneDayDelivery = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.013 9.984v4.3a1.947 1.947 0 0 1 .913 2.227l1.61 1.61a1 1 0 1 1-1.415 1.415l-1.61-1.61a1.99 1.99 0 0 1-1.498-3.655V9.984a1 1 0 1 1 2 0Zm7.339 2.685a8.99 8.99 0 0 1-14.905 9.49.503.503 0 0 0-.786.045l-1.15 1.662a.507.507 0 0 0 .054.645 11.949 11.949 0 0 0 9.964 3.393 12.085 12.085 0 0 0 10.078-8.892 11.753 11.753 0 0 0-.19-6.667.505.505 0 0 0-.482-.345h-2.113a.496.496 0 0 0-.47.669ZM9.046 15H7.059A9.01 9.01 0 0 1 16 7c.163 0 .324.005.484.015a.495.495 0 0 0 .516-.5V4.516a.498.498 0 0 0-.464-.5A9.208 9.208 0 0 0 16 4 12.01 12.01 0 0 0 4.05 15H1.955a.5.5 0 0 0-.41.785l3.545 5.121a.5.5 0 0 0 .822 0l3.546-5.121A.5.5 0 0 0 9.046 15ZM21.015 4.502A1.202 1.202 0 0 1 21.964 4a.715.715 0 0 1 .715.714c0 .119 0 .4-1.051.772a3.615 3.615 0 0 0-2.306 3.567 1 1 0 0 0 1 .947H24a1 1 0 0 0 0-2h-2.45a1.359 1.359 0 0 1 .749-.629c.589-.21 2.38-.847 2.38-2.657A2.718 2.718 0 0 0 21.964 2a3.169 3.169 0 0 0-2.479 1.213 1 1 0 1 0 1.53 1.289ZM31 7a1 1 0 0 1-1 1v1a1 1 0 0 1-2 0V8h-2a1 1 0 0 1-.8-1.6l3-4A1 1 0 0 1 30 3v3a1 1 0 0 1 1 1Zm-3-1.586L27.545 6H28Z"
        })
    });
var $52898fad6113d16d$export$2e2bcd8739ae039 = $52898fad6113d16d$var$SvgGlyphiconsBasic872OneDayDelivery;




const $e9aff2e75e71112e$var$SvgGlyphiconsBasic873Forklift = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31 11.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm0 8.5a1 1 0 0 1-1 1h-7v2a1 1 0 0 1-1 1c-.018 0-.033-.01-.051-.01a3.502 3.502 0 1 1-6.899.01h-3.1a3.501 3.501 0 1 1-6.9 0H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3V8a2.003 2.003 0 0 1 2-2h4.395a3.991 3.991 0 0 1 3.328 1.781L21 14.197V5a1 1 0 0 1 2 0v14h7a1 1 0 0 1 1 1Zm-21 4.5A1.5 1.5 0 1 0 8.5 26a1.502 1.502 0 0 0 1.5-1.5Zm10 0a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5Zm0-8.197L15.059 8.89A1.997 1.997 0 0 0 13.395 8H9v7h1.54a1 1 0 0 1 .76.35L13.57 18H20Z"
        })
    });
var $e9aff2e75e71112e$export$2e2bcd8739ae039 = $e9aff2e75e71112e$var$SvgGlyphiconsBasic873Forklift;




const $9fd259405cc18a38$var$SvgGlyphiconsBasic874TransportTrolley = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 8.5v-4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5Zm.5 9.5h9a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5Zm18-7h-6a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5Zm.5 10a1 1 0 0 1-1 1h-2.056a3.5 3.5 0 1 1-4.888 0h-7.112a3.5 3.5 0 1 1-4.888 0H6a1 1 0 0 1-1-1V7.535L2.445 5.832a1 1 0 1 1 1.11-1.664l3 2A1 1 0 0 1 7 7v13h20a1 1 0 0 1 1 1Zm-16 3.5a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5Zm12 0a1.5 1.5 0 1 0-1.5 1.5 1.502 1.502 0 0 0 1.5-1.5Z"
        })
    });
var $9fd259405cc18a38$export$2e2bcd8739ae039 = $9fd259405cc18a38$var$SvgGlyphiconsBasic874TransportTrolley;




const $9798a94b393b9f02$var$SvgGlyphiconsBasic875SimpleTrolley = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 20.5v-6a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5Zm9 3.5a1 1 0 0 1-1 1H12.95A3.492 3.492 0 1 1 8 21.35V18a1 1 0 0 1 .553-.895L12 15.382V7.535L9.445 5.832a1 1 0 1 1 1.11-1.664l3 2A1 1 0 0 1 14 7v16h10a1 1 0 0 1 1 1Zm-14 .5A1.5 1.5 0 1 0 9.5 26a1.502 1.502 0 0 0 1.5-1.5Zm1-6.882-2 1v2.432a3.48 3.48 0 0 1 2 1.006Z"
        })
    });
var $9798a94b393b9f02$export$2e2bcd8739ae039 = $9798a94b393b9f02$var$SvgGlyphiconsBasic875SimpleTrolley;




const $b6255ed7e2cb18c6$var$SvgGlyphiconsBasic876PalettePackage = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 20.5v-6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5Zm11-6v6a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5ZM12.5 12h7a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5Zm15 11h-23a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V25h6v2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V25h6v2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Z"
        })
    });
var $b6255ed7e2cb18c6$export$2e2bcd8739ae039 = $b6255ed7e2cb18c6$var$SvgGlyphiconsBasic876PalettePackage;




const $e42cce689b0810c8$var$SvgGlyphiconsBasic877Warehouse = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.66 15.66 16.53 4.53a.75.75 0 0 0-1.06 0L4.34 15.66A.785.785 0 0 0 4.895 17H7v10.5a.5.5 0 0 0 .5.5H10v-2h12v2h2.5a.5.5 0 0 0 .5-.5V17h2.105a.785.785 0 0 0 .555-1.34ZM22 22v2H10v-2Zm0-4v2H10v-2Z"
        })
    });
var $e42cce689b0810c8$export$2e2bcd8739ae039 = $e42cce689b0810c8$var$SvgGlyphiconsBasic877Warehouse;




const $e4610e2b3dd1cd0f$var$SvgGlyphiconsBasic878ThisSideUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.149 10.414 9.19 4.833a1 1 0 0 1 1.62 0l4.041 5.58a1 1 0 0 1-.81 1.587H12v9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-9H5.959a1 1 0 0 1-.81-1.586ZM17.959 12H20v9a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h2.041a1 1 0 0 0 .81-1.586L22.81 4.833a1 1 0 0 0-1.62 0l-4.041 5.58a1 1 0 0 0 .81 1.587ZM27 24H5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
    });
var $e4610e2b3dd1cd0f$export$2e2bcd8739ae039 = $e4610e2b3dd1cd0f$var$SvgGlyphiconsBasic878ThisSideUp;




const $77dfd5ec59a19a1e$var$SvgGlyphiconsBasic879TerminalEmpty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 14.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Zm-6-3.539a.5.5 0 0 0-.314-.464l-5-2A.5.5 0 0 0 9 8.962v1.076a.5.5 0 0 0 .314.465l2.494.997-2.494.997a.5.5 0 0 0-.314.464v1.077a.5.5 0 0 0 .686.464l5-2a.5.5 0 0 0 .314-.464ZM28 7.5v17a3.504 3.504 0 0 1-3.5 3.5h-17A3.504 3.504 0 0 1 4 24.5v-17A3.504 3.504 0 0 1 7.5 4h17A3.504 3.504 0 0 1 28 7.5Zm-3 0a.506.506 0 0 0-.5-.5h-17a.506.506 0 0 0-.5.5v17a.506.506 0 0 0 .5.5h17a.506.506 0 0 0 .5-.5Z"
        })
    });
var $77dfd5ec59a19a1e$export$2e2bcd8739ae039 = $77dfd5ec59a19a1e$var$SvgGlyphiconsBasic879TerminalEmpty;




const $d9e1184385d5b6b6$var$SvgGlyphiconsBasic88BookLog = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 23h16V5a1 1 0 0 0-1-1H10a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h15a1 1 0 0 0 1-1v-2H10a1 1 0 0 1 0-2Zm1.272-8.59.475-.594a.5.5 0 0 1 .614-.135L15 15l6.399-5.45a.5.5 0 0 1 .677.026l.591.591a.5.5 0 0 1 .021.685l-6.713 7.58a1 1 0 0 1-1.476.023l-3.2-3.389a.5.5 0 0 1-.027-.656Z"
        })
    });
var $d9e1184385d5b6b6$export$2e2bcd8739ae039 = $d9e1184385d5b6b6$var$SvgGlyphiconsBasic88BookLog;




const $096c1b2039de1eb3$var$SvgGlyphiconsBasic880Terminal = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-17A3.504 3.504 0 0 0 4 7.5v17A3.504 3.504 0 0 0 7.5 28h17a3.504 3.504 0 0 0 3.5-3.5v-17A3.504 3.504 0 0 0 24.5 4Zm-9.814 8.503-5 2A.5.5 0 0 1 9 14.037v-1.077a.5.5 0 0 1 .314-.464l2.494-.997-2.494-.997A.5.5 0 0 1 9 10.038V8.962a.5.5 0 0 1 .686-.465l5 2a.5.5 0 0 1 .314.464v1.077a.5.5 0 0 1-.314.465ZM21 15.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5Z"
        })
    });
var $096c1b2039de1eb3$export$2e2bcd8739ae039 = $096c1b2039de1eb3$var$SvgGlyphiconsBasic880Terminal;




const $28d03289d4eda628$var$SvgGlyphiconsBasic881Candle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.506 11.765c-2.197-2.967.484-6.313 2.95-8.51a.493.493 0 0 1 .8.212c.688 2.17 2.308 4.014 2.308 6.264a4.218 4.218 0 0 1-.95 2.828.5.5 0 0 1-.86-.436c.23-1.425-.758-2.559-1.522-3.646a.246.246 0 0 0-.378-.035 3.79 3.79 0 0 0-1.455 2.977.5.5 0 0 1-.893.346ZM24.382 24H7.618a1 1 0 0 0-.894 1.447L8 28h16l1.276-2.553A1 1 0 0 0 24.382 24ZM21 16a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v6h10Z"
        })
    });
var $28d03289d4eda628$export$2e2bcd8739ae039 = $28d03289d4eda628$var$SvgGlyphiconsBasic881Candle;




const $26d33b5b14f5d099$var$SvgGlyphiconsBasic882Balloon = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 14c0-5-3-10-8-10S8 9 8 14c0 4.757 2.72 10.408 7.29 10.947L13.6 27.2a.5.5 0 0 0 .4.8h4a.5.5 0 0 0 .4-.8l-1.69-2.253C21.28 24.408 24 18.757 24 14Zm-11.208-3.24A6.465 6.465 0 0 0 12 14a1 1 0 0 1-2 0 8.47 8.47 0 0 1 1.071-4.257 1 1 0 1 1 1.721 1.018Z"
        })
    });
var $26d33b5b14f5d099$export$2e2bcd8739ae039 = $26d33b5b14f5d099$var$SvgGlyphiconsBasic882Balloon;




const $dc26c7a75f5b4643$var$SvgGlyphiconsBasic883Balloons = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6 14a13.322 13.322 0 0 0 3.73 9.412.491.491 0 0 1-.48.588h-2.5a.5.5 0 0 1-.4-.8l.527-.703C3.807 21.832 2 18.483 2 15.125c0-3.497 1.958-6.34 5.263-6.707A12.4 12.4 0 0 0 6 14Zm24 1.125c0-3.497-1.958-6.34-5.263-6.707A12.4 12.4 0 0 1 26 14a13.322 13.322 0 0 1-3.73 9.412.491.491 0 0 0 .48.588h2.5a.5.5 0 0 0 .4-.8l-.527-.703c3.07-.665 4.877-4.014 4.877-7.372Zm-13.284 8.83L18.4 26.2a.5.5 0 0 1-.4.8h-4a.5.5 0 0 1-.4-.8l1.684-2.245C10.717 23.5 8 18.755 8 14c0-5 3-9 8-9s8 4 8 9c0 4.755-2.717 9.5-7.284 9.955ZM12.44 9.392a1 1 0 0 0-1.369.351A8.47 8.47 0 0 0 10 14a1 1 0 0 0 2 0 6.465 6.465 0 0 1 .792-3.24.999.999 0 0 0-.352-1.368Z"
        })
    });
var $dc26c7a75f5b4643$export$2e2bcd8739ae039 = $dc26c7a75f5b4643$var$SvgGlyphiconsBasic883Balloons;




const $da468d83b504b330$var$SvgGlyphiconsBasic884Missile = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.18 12.305-5.278 5.278a1 1 0 0 1-.797.289l-2.332.012-5.363 5.363-5.657-5.657 5.363-5.363.012-2.331a1 1 0 0 1 .289-.798l5.278-5.278a.5.5 0 0 1 .851.308l.493 5.419-2.003 2.003a1 1 0 0 0 1.414 1.414l2.003-2.003 5.419.493a.5.5 0 0 1 .308.851Zm-21.872 7.73a4 4 0 0 0 5.656 5.657l1.032-1.031-5.657-5.657Z"
        })
    });
var $da468d83b504b330$export$2e2bcd8739ae039 = $da468d83b504b330$var$SvgGlyphiconsBasic884Missile;




const $cb06d5f83f05ce92$var$SvgGlyphiconsBasic885StepBack = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 21.5V23a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-1.5a4.5 4.5 0 0 0-4.5-4.5H13v2.08a1 1 0 0 1-1.573.818L4.885 15.32a1 1 0 0 1 0-1.638l6.542-4.58a1 1 0 0 1 1.573.82V12h5.5a9.5 9.5 0 0 1 9.5 9.5Z"
        })
    });
var $cb06d5f83f05ce92$export$2e2bcd8739ae039 = $cb06d5f83f05ce92$var$SvgGlyphiconsBasic885StepBack;




const $c0fd570131c21f61$var$SvgGlyphiconsBasic886StepForward = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.115 15.32-6.542 4.578A1 1 0 0 1 19 19.08V17h-5.5A4.5 4.5 0 0 0 9 21.5V23a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1.5a9.5 9.5 0 0 1 9.5-9.5H19V9.92a1 1 0 0 1 1.573-.819l6.542 4.58a1 1 0 0 1 0 1.638Z"
        })
    });
var $c0fd570131c21f61$export$2e2bcd8739ae039 = $c0fd570131c21f61$var$SvgGlyphiconsBasic886StepForward;




const $cb0486ae2e0f3296$var$SvgGlyphiconsBasic887Undo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.982 17.548A8.19 8.19 0 0 1 19.717 25H10a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h10a3.005 3.005 0 0 0 2.942-3.598A3.08 3.08 0 0 0 19.882 14H13v2.08a1 1 0 0 1-1.573.818L4.885 12.32a1 1 0 0 1 0-1.638l6.542-4.58a1 1 0 0 1 1.573.82V9h7a8.009 8.009 0 0 1 7.982 8.548Z"
        })
    });
var $cb0486ae2e0f3296$export$2e2bcd8739ae039 = $cb0486ae2e0f3296$var$SvgGlyphiconsBasic887Undo;




const $03f1c4e1789e3562$var$SvgGlyphiconsBasic888Redo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 16.08V14h-6.882a3.08 3.08 0 0 0-3.06 2.402A3.005 3.005 0 0 0 12 20h10a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-9.717a8.19 8.19 0 0 1-8.265-7.452A8.009 8.009 0 0 1 12 9h7V6.92a1 1 0 0 1 1.573-.819l6.542 4.58a1 1 0 0 1 0 1.638l-6.542 4.58a1 1 0 0 1-1.573-.82Z"
        })
    });
var $03f1c4e1789e3562$export$2e2bcd8739ae039 = $03f1c4e1789e3562$var$SvgGlyphiconsBasic888Redo;




const $200758ec6ae82b21$var$SvgGlyphiconsBasic889ThreeDimensional = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.965 9.74a.966.966 0 0 0-.037-.09.995.995 0 0 0-.061-.147 8.744 8.744 0 0 0-.156-.205 1.023 1.023 0 0 0-.093-.074.984.984 0 0 0-.103-.081l-10-6a1.003 1.003 0 0 0-1.03 0l-10 6a1.013 1.013 0 0 0-.102.08 1.022 1.022 0 0 0-.094.075.992.992 0 0 0-.086.112.993.993 0 0 0-.07.093 1 1 0 0 0-.06.143c-.012.032-.03.062-.038.094A1 1 0 0 0 5 10v11a1 1 0 0 0 .485.857l10 6 .011.005.01.008a.973.973 0 0 0 .165.067c.023.008.045.022.07.028a.975.975 0 0 0 .518 0c.025-.006.046-.02.07-.028a.973.973 0 0 0 .164-.067l.01-.008.012-.005 10-6A1 1 0 0 0 27 21V10a1 1 0 0 0-.035-.26ZM15 25.233l-8-4.8v-8.666l8 4.8Zm1-10.4L7.944 10 16 5.166 24.056 10Zm9 5.6-8 4.8v-8.667l8-4.8Z"
        })
    });
var $200758ec6ae82b21$export$2e2bcd8739ae039 = $200758ec6ae82b21$var$SvgGlyphiconsBasic889ThreeDimensional;




const $9b1bb59fe3a243f6$var$SvgGlyphiconsBasic89BookAddress = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 4H10a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h15a1 1 0 0 0 1-1v-2H10a1 1 0 0 1 0-2h16V5a1 1 0 0 0-1-1Zm-4.937 14.492a.508.508 0 0 1-.508.508h-7.11a.508.508 0 0 1-.508-.508v-.966a1.016 1.016 0 0 1 .47-.857l1.561-.993-.147-1.177a1.481 1.481 0 0 1-.771-.811l-.11-.326a.74.74 0 0 1 .055-.636v-1.83a3.005 3.005 0 1 1 6.01 0v1.83a.74.74 0 0 1 .054.636l-.109.326a1.481 1.481 0 0 1-.771.81l-.147 1.178 1.56.993a1.016 1.016 0 0 1 .47.857ZM31 20v3a1 1 0 0 1-1 1h-2v-5h2a1 1 0 0 1 1 1Zm0-7v3a1 1 0 0 1-1 1h-2v-5h2a1 1 0 0 1 1 1Zm0-7v3a1 1 0 0 1-1 1h-2V5h2a1 1 0 0 1 1 1Z"
        })
    });
var $9b1bb59fe3a243f6$export$2e2bcd8739ae039 = $9b1bb59fe3a243f6$var$SvgGlyphiconsBasic89BookAddress;




const $bbf118f263a91e80$var$SvgGlyphiconsBasic890ThreeDimensionalFull = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m5 10.566 10 6v11l-9.515-5.709A1 1 0 0 1 5 21Zm11.515-7.423a1.003 1.003 0 0 0-1.03 0L6 8.833l10 6 10-6ZM17 16.566v11l9.515-5.709A1 1 0 0 0 27 21V10.566Z"
        })
    });
var $bbf118f263a91e80$export$2e2bcd8739ae039 = $bbf118f263a91e80$var$SvgGlyphiconsBasic890ThreeDimensionalFull;




const $7a872d9d8d2a0703$var$SvgGlyphiconsBasic891Factory = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 14H6V8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm18 6.5v7a.5.5 0 0 1-.5.5h-23a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5V23h2v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5ZM9 18.25a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25Zm5 0a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25Zm5 0a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25ZM16 4.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V14h4Z"
        })
    });
var $7a872d9d8d2a0703$export$2e2bcd8739ae039 = $7a872d9d8d2a0703$var$SvgGlyphiconsBasic891Factory;




const $88e7c8d7613f8176$var$SvgGlyphiconsBasic892FactoryAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m10 13.58-4-2.25V4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5Zm18 4.005V27.5a.5.5 0 0 1-.5.5h-23a.5.5 0 0 1-.5-.5V13.355a.5.5 0 0 1 .745-.436L12 17v-3.645a.5.5 0 0 1 .745-.436L20 17v-3.645a.5.5 0 0 1 .745-.436l6.745 3.794a1 1 0 0 1 .51.872ZM9 20.25a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25Zm5 0a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25Zm5 0a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25Zm5 0a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .25.25h2.5a.25.25 0 0 0 .25-.25Z"
        })
    });
var $88e7c8d7613f8176$export$2e2bcd8739ae039 = $88e7c8d7613f8176$var$SvgGlyphiconsBasic892FactoryAlt;




const $30756d31931edd2d$var$SvgGlyphiconsBasic893UserWorker = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 25.237V27a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1.763a1.578 1.578 0 0 1 .931-1.365l5.136-2.705A5.024 5.024 0 0 0 14.553 24h1.894a5.023 5.023 0 0 0 4.486-2.833l5.136 2.705A1.578 1.578 0 0 1 27 25.237ZM9.645 15.126a2.992 2.992 0 0 0 1.31 1.462l.666 3.051A3 3 0 0 0 14.552 22h1.896a3 3 0 0 0 2.93-2.36l.666-3.052a2.992 2.992 0 0 0 1.311-1.462l.28-.752a1.729 1.729 0 0 0 .077-.374H9.288a1.729 1.729 0 0 0 .077.374ZM8 12h15a1 1 0 0 0 0-2h-1.025a7.988 7.988 0 0 0-2.16-5.536l-1.393 2.224a.5.5 0 0 1-.623.193l-.43-.186a.5.5 0 0 1-.277-.612L18 3.27V3a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v.271l.908 2.812a.5.5 0 0 1-.278.612l-.43.186a.5.5 0 0 1-.622-.193l-1.394-2.224A7.988 7.988 0 0 0 9.025 10H8a1 1 0 0 0 0 2Z"
        })
    });
var $30756d31931edd2d$export$2e2bcd8739ae039 = $30756d31931edd2d$var$SvgGlyphiconsBasic893UserWorker;




const $c81bbcadddf75851$var$SvgGlyphiconsBasic894Barrel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 14a1.5 1.5 0 0 0 0-3H24V7h.5a1.5 1.5 0 0 0 0-3h-17a1.5 1.5 0 0 0 0 3H8v4h-.5a1.5 1.5 0 0 0 0 3H8v4h-.5a1.5 1.5 0 0 0 0 3H8v4h-.5a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3H24v-4h.5a1.5 1.5 0 0 0 0-3H24v-4ZM12 24.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $c81bbcadddf75851$export$2e2bcd8739ae039 = $c81bbcadddf75851$var$SvgGlyphiconsBasic894Barrel;




const $f0833454f96a201d$var$SvgGlyphiconsBasic895DiceOne = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3Zm-8 13a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $f0833454f96a201d$export$2e2bcd8739ae039 = $f0833454f96a201d$var$SvgGlyphiconsBasic895DiceOne;




const $4bd010afe59d948a$var$SvgGlyphiconsBasic896DiceTwo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3Zm-14 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm12 12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $4bd010afe59d948a$export$2e2bcd8739ae039 = $4bd010afe59d948a$var$SvgGlyphiconsBasic896DiceTwo;




const $375efc673bd66bb2$var$SvgGlyphiconsBasic897DiceThree = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3Zm-14 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $375efc673bd66bb2$export$2e2bcd8739ae039 = $375efc673bd66bb2$var$SvgGlyphiconsBasic897DiceThree;




const $8fb80baf49cce994$var$SvgGlyphiconsBasic898DiceFour = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3ZM10 24a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm12 12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $8fb80baf49cce994$export$2e2bcd8739ae039 = $8fb80baf49cce994$var$SvgGlyphiconsBasic898DiceFour;




const $8aad33a033e3df24$var$SvgGlyphiconsBasic899DiceFive = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3ZM10 24a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 6a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $8aad33a033e3df24$export$2e2bcd8739ae039 = $8aad33a033e3df24$var$SvgGlyphiconsBasic899DiceFive;




const $b1366a905054ade1$var$SvgGlyphiconsBasic9Film = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 5H5a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM9 25H6v-2h3Zm0-4H6v-2h3Zm0-4H6v-2h3Zm0-4H6v-2h3Zm0-4H6V7h3Zm12 16H11v-8h10Zm0-10H11V7h10Zm5 10h-3v-2h3Zm0-4h-3v-2h3Zm0-4h-3v-2h3Zm0-4h-3v-2h3Zm0-4h-3V7h3Z"
        })
    });
var $b1366a905054ade1$export$2e2bcd8739ae039 = $b1366a905054ade1$var$SvgGlyphiconsBasic9Film;




const $9b2b4caa4f9176d5$var$SvgGlyphiconsBasic90Building = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 4H8a2 2 0 0 0-2 2v21a1 1 0 0 0 1 1h6v-3a1.003 1.003 0 0 1 1-1h3a1.003 1.003 0 0 1 1 1v3h6a1 1 0 0 0 1-1V6a2 2 0 0 0-2-2ZM12 20.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm5 10a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm5 10a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Z"
        })
    });
var $9b2b4caa4f9176d5$export$2e2bcd8739ae039 = $9b2b4caa4f9176d5$var$SvgGlyphiconsBasic90Building;




const $466279c8c5dd10fc$var$SvgGlyphiconsBasic900DiceSix = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 5H8a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3ZM10 24a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-12a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $466279c8c5dd10fc$export$2e2bcd8739ae039 = $466279c8c5dd10fc$var$SvgGlyphiconsBasic900DiceSix;




const $c0725d6b0880632f$var$SvgGlyphiconsBasic901SlightlySmiling = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm-5-11.5v-1a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0Zm10-1v1a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0Zm-.227 5.868a.998.998 0 0 1 .016 1.246A6.542 6.542 0 0 1 16 22a6.542 6.542 0 0 1-4.79-2.386 1 1 0 0 1 1.236-1.509A9.38 9.38 0 0 0 16 19a9.38 9.38 0 0 0 3.554-.895 1 1 0 0 1 1.22.263Z"
        })
    });
var $c0725d6b0880632f$export$2e2bcd8739ae039 = $c0725d6b0880632f$var$SvgGlyphiconsBasic901SlightlySmiling;




const $4bcfd88228be33bc$var$SvgGlyphiconsBasic902SlightlyFrowning = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9Zm-5-11.5v-1a1.5 1.5 0 0 1 3 0v1a1.5 1.5 0 0 1-3 0Zm10-1v1a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 3 0Zm-.21 6.886a1 1 0 0 1-1.236 1.509A9.38 9.38 0 0 0 16 20a9.38 9.38 0 0 0-3.554.895 1 1 0 0 1-1.235-1.509A6.542 6.542 0 0 1 16 17a6.542 6.542 0 0 1 4.79 2.386Z"
        })
    });
var $4bcfd88228be33bc$export$2e2bcd8739ae039 = $4bcfd88228be33bc$var$SvgGlyphiconsBasic902SlightlyFrowning;




const $1c727252b8ac52a2$var$SvgGlyphiconsBasic903Pool = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12 12 0 0 0 16 4Zm0 16a6 6 0 1 1 6-6 6 6 0 0 1-6 6Zm.5-10h-1a2.502 2.502 0 0 0-2.5 2.5 2.476 2.476 0 0 0 .512 1.5A2.476 2.476 0 0 0 13 15.5a2.502 2.502 0 0 0 2.5 2.5h1a2.502 2.502 0 0 0 2.5-2.5 2.476 2.476 0 0 0-.512-1.5A2.476 2.476 0 0 0 19 12.5a2.502 2.502 0 0 0-2.5-2.5Zm-1 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1Zm1 4h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 1 0 1Z"
        })
    });
var $1c727252b8ac52a2$export$2e2bcd8739ae039 = $1c727252b8ac52a2$var$SvgGlyphiconsBasic903Pool;




const $f6c44e73b4291934$var$SvgGlyphiconsBasic904Tennis = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15.35 26.969A10.954 10.954 0 0 1 5.03 16.651a15.878 15.878 0 0 0 7.434-4.186A15.878 15.878 0 0 0 16.65 5.03 10.953 10.953 0 0 1 26.97 15.349a15.843 15.843 0 0 0-11.62 11.62Zm-4.3-15.918a13.913 13.913 0 0 0 3.527-5.947 10.947 10.947 0 0 0-9.473 9.473 13.912 13.912 0 0 0 5.947-3.526Zm9.9 9.898a13.913 13.913 0 0 0-3.527 5.947 10.947 10.947 0 0 0 9.473-9.472 13.916 13.916 0 0 0-5.947 3.525Z"
        })
    });
var $f6c44e73b4291934$export$2e2bcd8739ae039 = $f6c44e73b4291934$var$SvgGlyphiconsBasic904Tennis;




const $4ebd767c822d31e9$var$SvgGlyphiconsBasic905Badminton = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m28.873 18.052-3.349-1.116.462-1.71a1 1 0 0 0-.907-1.26l-2.64-.155-.162-3.14a1 1 0 0 0-.948-.948l-3.14-.162-.156-2.64a1 1 0 0 0-1.259-.907l-1.71.462-1.116-3.349a.953.953 0 0 0-.966-.684 1 1 0 0 0-.941.717L7.374 18.97l-1.86 1.86a4 4 0 0 0 5.658 5.656l1.86-1.86L28.84 19.96a1 1 0 0 0 .033-1.907Zm-17.91-1.09-.555-.554a.5.5 0 0 1-.103-.556l1.103-2.483a.5.5 0 0 1 .81-.15l.735.733a.5.5 0 0 1 .083.597l-1.283 2.303a.5.5 0 0 1-.79.11Zm2.174 2.175-.274-.274a.5.5 0 0 1-.033-.67l1.613-1.972a.5.5 0 0 1 .74-.037l.633.632a.5.5 0 0 1-.037.74l-1.972 1.614a.5.5 0 0 1-.67-.033Zm5.494 1.455-2.482 1.103a.5.5 0 0 1-.557-.103l-.555-.554a.5.5 0 0 1 .11-.79l2.304-1.284a.5.5 0 0 1 .597.083l.733.734a.5.5 0 0 1-.15.81Z"
        })
    });
var $4ebd767c822d31e9$export$2e2bcd8739ae039 = $4ebd767c822d31e9$var$SvgGlyphiconsBasic905Badminton;




const $d17e7da226f015a5$var$SvgGlyphiconsBasic906Restart = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.308 22.022a.498.498 0 0 1-.009.689l-1.413 1.414a.507.507 0 0 1-.727-.007 11.973 11.973 0 0 1-1.6-2.201.508.508 0 0 1 .217-.695l1.78-.91a.498.498 0 0 1 .66.205 8.981 8.981 0 0 0 1.092 1.505Zm-2.262-5.08a8.954 8.954 0 0 1 0-1.86.498.498 0 0 0-.413-.552l-1.975-.312a.508.508 0 0 0-.584.435 11.944 11.944 0 0 0 .002 2.723.507.507 0 0 0 .585.433l1.974-.315a.498.498 0 0 0 .411-.553Zm7.078 7.86a9.045 9.045 0 0 1-1.772-.574.498.498 0 0 0-.653.222l-.905 1.783a.507.507 0 0 0 .234.689 12.026 12.026 0 0 0 2.586.838.507.507 0 0 0 .593-.42l.314-1.974a.498.498 0 0 0-.397-.563Zm6.177-.352a.498.498 0 0 0-.653-.222 9.045 9.045 0 0 1-1.772.575.498.498 0 0 0-.397.563l.314 1.974a.507.507 0 0 0 .593.42 12.026 12.026 0 0 0 2.586-.838.507.507 0 0 0 .234-.69ZM5.762 10.804l1.784.904a.498.498 0 0 0 .657-.206 8.967 8.967 0 0 1 1.09-1.508.498.498 0 0 0-.01-.689l-1.417-1.41a.507.507 0 0 0-.727.009 11.959 11.959 0 0 0-1.595 2.206.508.508 0 0 0 .218.694ZM17 4.051V1.954a.5.5 0 0 0-.785-.41l-5.121 3.545a.5.5 0 0 0 0 .822l5.121 3.546A.5.5 0 0 0 17 9.046V7.059a8.993 8.993 0 0 1 5.692 14.953.498.498 0 0 0 .01.69l1.415 1.414a.503.503 0 0 0 .722-.007A11.987 11.987 0 0 0 17 4.05Z"
        })
    });
var $d17e7da226f015a5$export$2e2bcd8739ae039 = $d17e7da226f015a5$var$SvgGlyphiconsBasic906Restart;




const $8cf0d5b70ba02da4$var$SvgGlyphiconsBasic907Replay = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9.308 22.022a.498.498 0 0 1-.009.689l-1.413 1.414a.507.507 0 0 1-.727-.007 11.973 11.973 0 0 1-1.6-2.201.508.508 0 0 1 .217-.695l1.78-.91a.498.498 0 0 1 .66.205 8.981 8.981 0 0 0 1.092 1.505Zm-2.262-5.08a8.954 8.954 0 0 1 0-1.86.498.498 0 0 0-.413-.552l-1.975-.312a.508.508 0 0 0-.584.435 11.944 11.944 0 0 0 .002 2.723.507.507 0 0 0 .585.433l1.974-.315a.498.498 0 0 0 .411-.553Zm7.078 7.86a9.045 9.045 0 0 1-1.772-.574.498.498 0 0 0-.653.222l-.905 1.783a.507.507 0 0 0 .234.689 12.026 12.026 0 0 0 2.586.838.507.507 0 0 0 .593-.42l.314-1.974a.498.498 0 0 0-.397-.563Zm6.177-.352a.498.498 0 0 0-.653-.222 9.045 9.045 0 0 1-1.772.575.498.498 0 0 0-.397.563l.314 1.974a.507.507 0 0 0 .593.42 12.026 12.026 0 0 0 2.586-.838.507.507 0 0 0 .234-.69Zm-.347-9.387-4.497-2.309a1 1 0 0 0-1.457.89v4.617a1 1 0 0 0 1.457.89l4.497-2.309a1 1 0 0 0 0-1.779ZM5.762 10.804l1.784.904a.498.498 0 0 0 .657-.206 8.967 8.967 0 0 1 1.09-1.508.498.498 0 0 0-.01-.689l-1.417-1.41a.507.507 0 0 0-.727.009 11.959 11.959 0 0 0-1.595 2.206.508.508 0 0 0 .218.694ZM17 4.051V1.954a.5.5 0 0 0-.785-.41l-5.121 3.545a.5.5 0 0 0 0 .822l5.121 3.546A.5.5 0 0 0 17 9.046V7.059a8.993 8.993 0 0 1 5.692 14.953.498.498 0 0 0 .01.69l1.415 1.414a.503.503 0 0 0 .722-.007A11.987 11.987 0 0 0 17 4.05Z"
        })
    });
var $8cf0d5b70ba02da4$export$2e2bcd8739ae039 = $8cf0d5b70ba02da4$var$SvgGlyphiconsBasic907Replay;




const $e453371275f71512$var$SvgGlyphiconsBasic908Honeycombs = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28.49 12.379 25 10.416V6.25a1 1 0 0 0-.51-.871l-4-2.25a.997.997 0 0 0-.98 0L16 5.103l-3.51-1.974a.997.997 0 0 0-.98 0l-4 2.25A1 1 0 0 0 7 6.25v4.166l-3.49 1.963a1 1 0 0 0-.51.871v4.5a1 1 0 0 0 .51.871L7 20.584v4.166a1 1 0 0 0 .51.871l4 2.25a.997.997 0 0 0 .98 0L16 25.897l3.51 1.974a.997.997 0 0 0 .98 0l4-2.25a1 1 0 0 0 .51-.871v-4.166l3.49-1.963a1 1 0 0 0 .51-.871v-4.5a1 1 0 0 0-.51-.871ZM19 17.165l-3 1.688-3-1.688v-3.33l3-1.688 3 1.688Zm1-12.018 3 1.688v3.33l-3 1.688-3-1.688v-3.33ZM9 6.835l3-1.688 3 1.688v3.33l-3 1.688-3-1.688Zm-4 7 3-1.688 3 1.688v3.33l-3 1.688-3-1.688Zm7 12.018-3-1.688v-3.33l3-1.688 3 1.688v3.33Zm11-1.688-3 1.688-3-1.688v-3.33l3-1.688 3 1.688Zm4-7-3 1.688-3-1.688v-3.33l3-1.688 3 1.688Z"
        })
    });
var $e453371275f71512$export$2e2bcd8739ae039 = $e453371275f71512$var$SvgGlyphiconsBasic908Honeycombs;




const $3b38eaf6d5b6a673$var$SvgGlyphiconsBasic909Honeybee = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M30.58 7.57a3.481 3.481 0 0 0-3.14-.521l-5.233 1.794 2.574-3.218a1 1 0 0 0-1.562-1.25L20.007 8.39a3.995 3.995 0 0 0-1.054-.86 2.962 2.962 0 0 0-.253-.816l1.007-1.007a1 1 0 0 0-1.414-1.414L17.286 5.3a2.906 2.906 0 0 0-2.572 0l-1.007-1.007a1 1 0 0 0-1.414 1.414L13.3 6.714a2.962 2.962 0 0 0-.253.817 3.995 3.995 0 0 0-1.054.86L8.781 4.374a1 1 0 1 0-1.562 1.25l2.575 3.219-5.265-1.805A3.501 3.501 0 0 0 0 10.385v.379a2.985 2.985 0 0 0 1.658 2.683l1.412.706a4.967 4.967 0 0 0 3.819.27l.043-.014 4.46-1.718a4.1 4.1 0 0 0 .365.633 3.952 3.952 0 0 0-.63.913l-2.443.815a1 1 0 0 0-.646.674l-2 7a1.001 1.001 0 0 0 .688 1.236A1.029 1.029 0 0 0 7 24a1.001 1.001 0 0 0 .96-.726l1.855-6.492.828-.276-.262 2.622a8.97 8.97 0 0 0 2.592 7.26L14.586 28a2.002 2.002 0 0 0 2.828 0l1.612-1.612a8.97 8.97 0 0 0 2.592-7.26l-.262-2.622.828.276 1.854 6.492A1.001 1.001 0 0 0 25 24a1.029 1.029 0 0 0 .275-.038 1.001 1.001 0 0 0 .688-1.236l-2-7a1 1 0 0 0-.646-.674l-2.443-.815a3.952 3.952 0 0 0-.63-.913 4.1 4.1 0 0 0 .365-.633l4.46 1.718.043.015a4.967 4.967 0 0 0 3.819-.27l1.412-.707A2.985 2.985 0 0 0 32 10.764v-.38a3.466 3.466 0 0 0-1.42-2.814ZM12.725 15.8a1.988 1.988 0 0 1 .576-1.208A3.856 3.856 0 0 0 15 15h2a3.856 3.856 0 0 0 1.699-.408 1.988 1.988 0 0 1 .576 1.209l.113 1.13h-6.776Zm4.887 9.174L16 26.586l-1.612-1.612c-.014-.014-.025-.03-.039-.043h3.302c-.014.013-.025.029-.039.043Zm1.778-3.043h-6.78a6.98 6.98 0 0 1-.264-2h7.309a6.98 6.98 0 0 1-.265 2ZM17 13h-2a1.994 1.994 0 0 1-1.737-1.029l.096-.037a1 1 0 0 0-.035-1.88l-.063-.022A1.994 1.994 0 0 1 15 9h2a1.994 1.994 0 0 1 1.74 1.032l-.064.022a1 1 0 0 0-.035 1.88l.096.037A1.994 1.994 0 0 1 17 13Z"
        })
    });
var $3b38eaf6d5b6a673$export$2e2bcd8739ae039 = $3b38eaf6d5b6a673$var$SvgGlyphiconsBasic909Honeybee;




const $459be536fdfbd951$var$SvgGlyphiconsBasic91Eyedropper = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.607 5.393a4.012 4.012 0 0 0-5.657 0L17.414 8.93 16 7.515a1 1 0 0 0-1.414 0l-.707.707a1 1 0 0 0 0 1.414l.707.707-5.718 5.718a8.445 8.445 0 0 0-1.342 2.157 8.745 8.745 0 0 1-.779 1.378l-1.06 1.06a4.108 4.108 0 0 0 0 5.657 3.883 3.883 0 0 0 2.78 1.133c.078 0 .156-.002.235-.006a4.064 4.064 0 0 0 2.64-1.127l1.061-1.06a8.798 8.798 0 0 1 1.378-.78 8.411 8.411 0 0 0 2.158-1.341l5.718-5.718.707.707a1 1 0 0 0 1.414 0l.707-.707a1 1 0 0 0 0-1.414l-.707-.707-.707-.707 3.536-3.536a4.012 4.012 0 0 0 0-5.657ZM13.818 21.011a8.798 8.798 0 0 1-1.378.779 8.411 8.411 0 0 0-2.158 1.342l-1.06 1.06a1.122 1.122 0 0 1-.682.252.932.932 0 0 1-.732-.252 1.13 1.13 0 0 1 0-1.414l1.06-1.06a8.443 8.443 0 0 0 1.342-2.158 8.814 8.814 0 0 1 .78-1.378l5.717-5.718 2.829 2.83Z"
        })
    });
var $459be536fdfbd951$export$2e2bcd8739ae039 = $459be536fdfbd951$var$SvgGlyphiconsBasic91Eyedropper;




const $d5dd7acf6190c9e9$var$SvgGlyphiconsBasic910Honey = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8 7V6a1 1 0 0 1 1-1h5.667l-.228-.684A1 1 0 0 1 15.387 3h1.226a1 1 0 0 1 .948 1.316L17.333 5H23a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Zm16.504 5.504S23 11 23 10h-2a1 1 0 0 0-1 1v3a1 1 0 0 1-2 0v-2a1 1 0 0 0-2 0 1 1 0 0 1-2 0v-1a1 1 0 0 0-1-1H9c0 1-1.504 2.504-1.504 2.504a8 8 0 0 0-1.932 8.187l1.98 5.942A2 2 0 0 0 9.442 28h13.116a2 2 0 0 0 1.898-1.367l1.98-5.942a8 8 0 0 0-1.932-8.187Z"
        })
    });
var $d5dd7acf6190c9e9$export$2e2bcd8739ae039 = $d5dd7acf6190c9e9$var$SvgGlyphiconsBasic910Honey;




const $b5a9b0682ced1a0a$var$SvgGlyphiconsBasic911Fan = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 13.702v2.399a3 3 0 0 1-5.641 1.422 3.405 3.405 0 0 0-3.61-1.66.5.5 0 0 0-.324.821l3.308 3.91A4.5 4.5 0 0 1 18.298 28h-2.399a3 3 0 0 1-1.422-5.641 3.405 3.405 0 0 0 1.66-3.61.5.5 0 0 0-.821-.324l-3.91 3.308A4.5 4.5 0 0 1 4 18.298v-2.399a2.998 2.998 0 0 1 5.641-1.422 3.4 3.4 0 0 0 3.606 1.66.501.501 0 0 0 .328-.821l-3.308-3.91A4.5 4.5 0 0 1 13.702 4h2.399a3 3 0 0 1 1.422 5.641 3.405 3.405 0 0 0-1.66 3.61.5.5 0 0 0 .821.324l3.91-3.308A4.5 4.5 0 0 1 28 13.702Z"
        })
    });
var $b5a9b0682ced1a0a$export$2e2bcd8739ae039 = $b5a9b0682ced1a0a$var$SvgGlyphiconsBasic911Fan;




const $a90a67831de3de47$var$SvgGlyphiconsBasic912Wind = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 18h-20a1.5 1.5 0 0 1 0-3h20c2.225 0 3.5-.911 3.5-2.5a2.45 2.45 0 0 0-3.146-2.4 1.5 1.5 0 0 1-.775-2.898A5.393 5.393 0 0 1 24.5 7a5.507 5.507 0 0 1 5.5 5.5c0 2.737-2.01 5.5-6.5 5.5ZM20 8.5a4.495 4.495 0 0 0-7.845-3.002 1.5 1.5 0 0 0 2.233 2.004A1.482 1.482 0 0 1 15.5 7 1.502 1.502 0 0 1 17 8.5c0 .524 0 1.5-2 1.5H6.5a1.5 1.5 0 0 0 0 3H15c3.687 0 5-2.324 5-4.5Zm7 16c0-2.733-1.963-4.5-5-4.5H9.5a1.5 1.5 0 0 0 0 3H22c2 0 2 1.05 2 1.5a1.502 1.502 0 0 1-1.5 1.5 1.482 1.482 0 0 1-1.112-.502 1.5 1.5 0 0 0-2.233 2.004A4.495 4.495 0 0 0 27 24.5Z"
        })
    });
var $a90a67831de3de47$export$2e2bcd8739ae039 = $a90a67831de3de47$var$SvgGlyphiconsBasic912Wind;




const $6146889e78f4d6e1$var$SvgGlyphiconsBasic913Rechargeable = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17.8 10.597 17.25 15h2.748a.5.5 0 0 1 .373.832l-5.301 5.965a.5.5 0 0 1-.87-.394L14.75 17h-2.748a.5.5 0 0 1-.373-.832l5.301-5.965a.5.5 0 0 1 .87.394ZM30.046 15h-2.097A11.975 11.975 0 0 0 7.564 7.49a.505.505 0 0 0-.054.644l1.153 1.665a.5.5 0 0 0 .781.044A8.991 8.991 0 0 1 24.941 15h-1.987a.5.5 0 0 0-.41.785l3.545 5.121a.5.5 0 0 0 .822 0l3.546-5.121a.5.5 0 0 0-.411-.785Zm-6.71 7.201a.5.5 0 0 0-.78-.044A8.99 8.99 0 0 1 7.059 17h1.987a.5.5 0 0 0 .41-.785l-3.545-5.121a.5.5 0 0 0-.822 0l-3.546 5.121a.5.5 0 0 0 .411.785h2.097a11.975 11.975 0 0 0 20.385 7.51.505.505 0 0 0 .054-.644Z"
        })
    });
var $6146889e78f4d6e1$export$2e2bcd8739ae039 = $6146889e78f4d6e1$var$SvgGlyphiconsBasic913Rechargeable;




const $d4760f4e728285f0$var$SvgGlyphiconsBasic914MobilePhoneLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 13.816V22H11V7h8V5a2.976 2.976 0 0 1 .176-1H10.5A2.503 2.503 0 0 0 8 6.5v19a2.503 2.503 0 0 0 2.5 2.5h11a2.503 2.503 0 0 0 2.5-2.5V14h-2a2.965 2.965 0 0 1-1-.184ZM17 25.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM31 4h-1V2a2.003 2.003 0 0 0-2-2h-3a2.003 2.003 0 0 0-2 2v2h-1a1.003 1.003 0 0 0-1 1v6a1.003 1.003 0 0 0 1 1h9a1.003 1.003 0 0 0 1-1V5a1.003 1.003 0 0 0-1-1Zm-3 0h-3V2.25a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25Z"
        })
    });
var $d4760f4e728285f0$export$2e2bcd8739ae039 = $d4760f4e728285f0$var$SvgGlyphiconsBasic914MobilePhoneLock;




const $4b60419f3afc96ba$var$SvgGlyphiconsBasic915MobilePhoneCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 22H11V7h7.07A8.009 8.009 0 0 1 18 6a7.96 7.96 0 0 1 .263-2H10.5A2.503 2.503 0 0 0 8 6.5v19a2.503 2.503 0 0 0 2.5 2.5h11a2.503 2.503 0 0 0 2.5-2.5V13.737a7.974 7.974 0 0 1-3-1.502Zm-4 3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM26 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm3.2 4.118-3.11 4.575a.83.83 0 0 1-1.297.1L22.56 6.557a.297.297 0 0 1-.027-.377l.433-.555a.323.323 0 0 1 .377-.095l1.766.845 3.15-2.96a.297.297 0 0 1 .377-.027l.512.378a.254.254 0 0 1 .052.352Z"
        })
    });
var $4b60419f3afc96ba$export$2e2bcd8739ae039 = $4b60419f3afc96ba$var$SvgGlyphiconsBasic915MobilePhoneCheck;




const $e6fc16bb8dd64138$var$SvgGlyphiconsBasic916MobilePhoneCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31.706 5.638a.498.498 0 0 0-.379-.472l-1.156-.289a4.414 4.414 0 0 0-.43-1.041l.618-1.031a.497.497 0 0 0-.043-.582 5.822 5.822 0 0 0-.542-.539.504.504 0 0 0-.586-.046l-1.029.617a4.324 4.324 0 0 0-1.04-.429L26.83.67a.497.497 0 0 0-.47-.379c-.221-.005-.49-.006-.715 0a.498.498 0 0 0-.472.379l-.29 1.157a4.348 4.348 0 0 0-1.04.429l-1.03-.618a.497.497 0 0 0-.581.042 5.789 5.789 0 0 0-.54.54.504.504 0 0 0-.047.587l.618 1.03a4.361 4.361 0 0 0-.43 1.041l-1.157.29a.497.497 0 0 0-.379.47c-.005.221-.006.49 0 .715a.498.498 0 0 0 .379.472l1.157.29a4.347 4.347 0 0 0 .429 1.04l-.619 1.03a.497.497 0 0 0 .043.581 5.817 5.817 0 0 0 .54.54.504.504 0 0 0 .588.047l1.029-.618a4.404 4.404 0 0 0 1.04.431l.29 1.156a.497.497 0 0 0 .47.38c.222.005.491.005.716 0a.498.498 0 0 0 .472-.38l.29-1.156a4.417 4.417 0 0 0 1.041-.432l1.03.62a.497.497 0 0 0 .582-.043 5.858 5.858 0 0 0 .539-.542.504.504 0 0 0 .046-.586l-.617-1.029a4.523 4.523 0 0 0 .43-1.04l1.156-.289a.497.497 0 0 0 .379-.47c.005-.222.006-.491 0-.716ZM26 8.143a2.147 2.147 0 1 1 2.148-2.149A2.15 2.15 0 0 1 26 8.143ZM21 22H11V7h7.575a7.497 7.497 0 0 1-.075-1 7.464 7.464 0 0 1 .279-2H10.5A2.503 2.503 0 0 0 8 6.5v19a2.503 2.503 0 0 0 2.5 2.5h11a2.503 2.503 0 0 0 2.5-2.5V13.221a7.48 7.48 0 0 1-3-1.646Zm-4 3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $e6fc16bb8dd64138$export$2e2bcd8739ae039 = $e6fc16bb8dd64138$var$SvgGlyphiconsBasic916MobilePhoneCogwheel;




const $a2ec5e6c098ab957$var$SvgGlyphiconsBasic917MobilePhoneAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 22H11V7h7.07A8.009 8.009 0 0 1 18 6a7.96 7.96 0 0 1 .263-2H10.5A2.503 2.503 0 0 0 8 6.5v19a2.503 2.503 0 0 0 2.5 2.5h11a2.503 2.503 0 0 0 2.5-2.5V13.737a7.974 7.974 0 0 1-3-1.502Zm-4 3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5ZM26 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm1 9.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Zm0-5a3.943 3.943 0 0 1-.149.978l-.399 1.283a.362.362 0 0 1-.324.239h-.256a.362.362 0 0 1-.324-.239l-.4-1.283A3.943 3.943 0 0 1 25 4.5v-2a.502.502 0 0 1 .5-.5h1a.502.502 0 0 1 .5.5Z"
        })
    });
var $a2ec5e6c098ab957$export$2e2bcd8739ae039 = $a2ec5e6c098ab957$var$SvgGlyphiconsBasic917MobilePhoneAlert;




const $a7a8ee2087c71495$var$SvgGlyphiconsBasic918PowerPlantWind = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.834 9.076a1 1 0 1 1 .332-1.972 6.964 6.964 0 0 1 2.325.848 1 1 0 1 1-.998 1.733 4.982 4.982 0 0 0-1.659-.609Zm5.753-3.887a10.972 10.972 0 0 0-5.488-2.133 1.01 1.01 0 0 0-1.094.896 1 1 0 0 0 .896 1.094A8.97 8.97 0 0 1 24.39 6.79a1 1 0 0 0 1.197-1.602ZM16.59 17.544l-.956-.786a1 1 0 0 0-1.27 0l-.956.786-1.355 8.13a3.999 3.999 0 0 0-.054.657V27a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-.669a3.999 3.999 0 0 0-.054-.658Zm4.205-3.47-.31-.177-3.962-1.4a.518.518 0 0 1-.325-.564l.767-4.129.002-.36-.822-4.619A1 1 0 0 0 15.162 2h-.324a1 1 0 0 0-.984.825l-.822 4.62.002.36.767 4.128a.518.518 0 0 1-.325.563l-3.961 1.4-.31.178-3.59 3.02a.998.998 0 0 0-.222 1.264l.162.282a1 1 0 0 0 .866.5 1.015 1.015 0 0 0 .34-.059l4.407-1.596.312-.182 3.198-2.734a.513.513 0 0 1 .644 0l3.2 2.737.306.177 4.41 1.598a1.015 1.015 0 0 0 .341.06 1 1 0 0 0 .866-.501l.162-.282a.998.998 0 0 0-.222-1.263Z"
        })
    });
var $a7a8ee2087c71495$export$2e2bcd8739ae039 = $a7a8ee2087c71495$var$SvgGlyphiconsBasic918PowerPlantWind;




const $2705813beac9af5f$var$SvgGlyphiconsBasic919PowerPlantSolar = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M8 17a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1ZM9 3V2a1 1 0 0 0-2 0v1a1 1 0 0 0 2 0ZM3 9a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1Zm.757 5.657.708-.707a1 1 0 1 0-1.414-1.416l-.708.707a1 1 0 0 0 1.414 1.416Zm.709-9.192a1.002 1.002 0 0 0-.001-1.415l-.708-.707a1 1 0 0 0-1.414 1.416l.708.707a1.002 1.002 0 0 0 1.415-.001ZM23 26h-2v-2h-3v2h-2a1 1 0 1 0 0 2h7a1 1 0 0 0 0-2Zm5-19.833v14.666A1.143 1.143 0 0 1 26.882 22H12.118A1.143 1.143 0 0 1 11 20.833V6.167A1.143 1.143 0 0 1 12.118 5h14.764A1.143 1.143 0 0 1 28 6.167ZM16 17h-3v3h3Zm0-5h-3v3h3Zm0-5h-3v3h3Zm5 10h-3v3h3Zm0-5h-3v3h3Zm0-5h-3v3h3Zm5 10h-3v3h3Zm0-5h-3v3h3Zm0-5h-3v3h3ZM9 5.153A3.762 3.762 0 0 0 8 5a4 4 0 0 0 0 8 3.945 3.945 0 0 0 1-.142v-2.136A1.976 1.976 0 0 1 8 11a2 2 0 0 1 0-4 1.976 1.976 0 0 1 1 .278Z"
        })
    });
var $2705813beac9af5f$export$2e2bcd8739ae039 = $2705813beac9af5f$var$SvgGlyphiconsBasic919PowerPlantSolar;




const $fe58764786105a4d$var$SvgGlyphiconsBasic92Contrast = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm0 21a9 9 0 0 1 0-18Z"
        })
    });
var $fe58764786105a4d$export$2e2bcd8739ae039 = $fe58764786105a4d$var$SvgGlyphiconsBasic92Contrast;




const $8b90f376ad0cbee0$var$SvgGlyphiconsBasic920PowerPlantWater = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4.41 18.105a12 12 0 1 1 22.098 2.66l-1.676-1.1a9.997 9.997 0 0 0-8.815-14.669 10.068 10.068 0 0 0-2.605.345 10 10 0 0 0-7.071 12.247 10.062 10.062 0 0 0 .833 2.1l-1.671 1.12a11.97 11.97 0 0 1-1.094-2.703Zm-1.242 10.45a1 1 0 0 1 .277-1.387l2.792-1.861a1.41 1.41 0 0 1 1.526 0L10 26.797l2.237-1.49a1.41 1.41 0 0 1 1.526 0L16 26.797l2.237-1.49a1.41 1.41 0 0 1 1.526 0L22 26.797l2.237-1.49a1.41 1.41 0 0 1 1.526 0l2.792 1.861a1 1 0 1 1-1.11 1.664L25 27.202l-2.237 1.491a1.41 1.41 0 0 1-1.526 0L19 27.203l-2.237 1.49a1.41 1.41 0 0 1-1.526 0L13 27.203l-2.237 1.49a1.41 1.41 0 0 1-1.526 0L7 27.203l-2.445 1.629a1 1 0 0 1-1.387-.277Zm3-5a1 1 0 0 1 .277-1.387l2.792-1.861a1.41 1.41 0 0 1 1.526 0L13 21.797l2.237-1.49a1.41 1.41 0 0 1 1.526 0L19 21.797l2.237-1.49a1.41 1.41 0 0 1 1.526 0l2.792 1.861a1 1 0 1 1-1.11 1.664L22 22.202l-2.237 1.491a1.41 1.41 0 0 1-1.526 0L16 22.203l-2.237 1.49a1.41 1.41 0 0 1-1.526 0L10 22.203l-2.445 1.629a1.002 1.002 0 0 1-1.387-.277Zm17.118-7.79-.297-.284a7.592 7.592 0 0 0-3.63-1.93.503.503 0 0 1-.198-.898 4.784 4.784 0 0 1 1.545-.78l.399-.12a1 1 0 0 0 .67-1.25l-.235-.763a1 1 0 0 0-1.235-.667l-.393.115a7.595 7.595 0 0 0-3.484 2.175.503.503 0 0 1-.877-.254 4.793 4.793 0 0 1 .095-1.752l.095-.405a1 1 0 0 0-.752-1.203l-.776-.177a1 1 0 0 0-1.194.738l-.097.396a7.595 7.595 0 0 0 .145 4.11.503.503 0 0 1-.658.634 4.755 4.755 0 0 1-1.455-.948l-.31-.297a1 1 0 0 0-1.42.04l-.548.584a1 1 0 0 0 .038 1.405l.297.285a7.635 7.635 0 0 0 3.628 1.932.503.503 0 0 1 .197.899 4.781 4.781 0 0 1-1.542.777s-.21.066-.399.126c-.087.026-.079.09-.01.136L13 19.798l2.237-1.491a1.41 1.41 0 0 1 1.526 0L19 19.797c.22.147.275-.085.276-.183a7.638 7.638 0 0 0-.343-2.43.503.503 0 0 1 .658-.634 4.754 4.754 0 0 1 1.455.948l.31.297a1 1 0 0 0 1.42-.04l.548-.584a1 1 0 0 0-.038-1.406Z"
        })
    });
var $8b90f376ad0cbee0$export$2e2bcd8739ae039 = $8b90f376ad0cbee0$var$SvgGlyphiconsBasic920PowerPlantWater;




const $0e87668d336586d8$var$SvgGlyphiconsBasic921RewindFive = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 20h-2a1 1 0 0 1 0-2h2a.5.5 0 0 0 0-1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2h-2v1h1a2.5 2.5 0 0 1 0 5Zm0-16V1.954a.5.5 0 0 0-.785-.41L11 4.46V1.954a.5.5 0 0 0-.785-.41L5.094 5.088a.5.5 0 0 0 0 .822l5.121 3.546A.5.5 0 0 0 11 9.046V6.539l4.215 2.918A.5.5 0 0 0 16 9.046V7a9.01 9.01 0 0 1 8.996 9.26 9.1 9.1 0 0 1-8.736 8.736 8.994 8.994 0 0 1-8.339-12.955.495.495 0 0 0-.156-.632l-1.653-1.144a.502.502 0 0 0-.728.169 11.902 11.902 0 0 0-1.266 7.255A12 12 0 1 0 16 4Z"
        })
    });
var $0e87668d336586d8$export$2e2bcd8739ae039 = $0e87668d336586d8$var$SvgGlyphiconsBasic921RewindFive;




const $b64eee5b2ff38074$var$SvgGlyphiconsBasic922RewindTen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 19v-3.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2A1 1 0 0 1 14 13v6a1 1 0 0 1-2 0Zm4-15V1.954a.5.5 0 0 0-.785-.41L11 4.46V1.954a.5.5 0 0 0-.785-.41L5.094 5.088a.5.5 0 0 0 0 .822l5.121 3.546A.5.5 0 0 0 11 9.046V6.539l4.215 2.918A.5.5 0 0 0 16 9.046V7a9.01 9.01 0 0 1 8.996 9.26 9.1 9.1 0 0 1-8.736 8.736 8.994 8.994 0 0 1-8.339-12.955.495.495 0 0 0-.156-.632l-1.653-1.144a.502.502 0 0 0-.728.17 11.902 11.902 0 0 0-1.266 7.254A12 12 0 1 0 16 4Zm0 13v-2a3 3 0 0 1 6 0v2a3 3 0 0 1-6 0Zm2 0a1 1 0 0 0 2 0v-2a1 1 0 0 0-2 0Z"
        })
    });
var $b64eee5b2ff38074$export$2e2bcd8739ae039 = $b64eee5b2ff38074$var$SvgGlyphiconsBasic922RewindTen;




const $39268ed771636d02$var$SvgGlyphiconsBasic923RewindFifteen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19.5 17.5a.501.501 0 0 0-.5-.5h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2h-2v1h1a2.5 2.5 0 0 1 0 5h-2a1 1 0 0 1 0-2h2a.501.501 0 0 0 .5-.5ZM13 20a1 1 0 0 0 1-1v-6a1 1 0 0 0-1.707-.707l-2 2a1 1 0 0 0 1.414 1.414l.293-.293V19a1 1 0 0 0 1 1Zm3-16V1.954a.5.5 0 0 0-.785-.41L11 4.46V1.954a.5.5 0 0 0-.785-.41L5.094 5.088a.5.5 0 0 0 0 .822l5.121 3.546A.5.5 0 0 0 11 9.046V6.539l4.215 2.918A.5.5 0 0 0 16 9.046V7a9.01 9.01 0 0 1 8.996 9.26 9.1 9.1 0 0 1-8.736 8.736 8.994 8.994 0 0 1-8.339-12.955.495.495 0 0 0-.156-.632l-1.653-1.144a.502.502 0 0 0-.728.17 11.902 11.902 0 0 0-1.266 7.254A12 12 0 1 0 16 4Z"
        })
    });
var $39268ed771636d02$export$2e2bcd8739ae039 = $39268ed771636d02$var$SvgGlyphiconsBasic923RewindFifteen;




const $99dcfb0fe825c137$var$SvgGlyphiconsBasic924RewindThirty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 16a11.999 11.999 0 1 1-22.616-5.566.502.502 0 0 1 .728-.17l1.653 1.145a.495.495 0 0 1 .156.632 8.994 8.994 0 0 0 8.34 12.955 9.1 9.1 0 0 0 8.735-8.736A9.01 9.01 0 0 0 16 7v2.046a.5.5 0 0 1-.785.41L11 6.54v2.507a.5.5 0 0 1-.785.41L5.094 5.912a.5.5 0 0 1 0-.822l5.121-3.546a.5.5 0 0 1 .785.411v2.507l4.215-2.918a.5.5 0 0 1 .785.411V4a12.013 12.013 0 0 1 12 12Zm-12 1v-2a3 3 0 0 1 6 0v2a3 3 0 0 1-6 0Zm2 0a1 1 0 0 0 2 0v-2a1 1 0 0 0-2 0Zm-5.5 1H11a1 1 0 0 0 0 2h1.5a2.502 2.502 0 0 0 2.5-2.5 2.476 2.476 0 0 0-.512-1.5A2.476 2.476 0 0 0 15 14.5a2.502 2.502 0 0 0-2.5-2.5H11a1 1 0 0 0 0 2h1.5a.5.5 0 0 1 0 1H12a1 1 0 0 0 0 2h.5a.5.5 0 0 1 0 1Z"
        })
    });
var $99dcfb0fe825c137$export$2e2bcd8739ae039 = $99dcfb0fe825c137$var$SvgGlyphiconsBasic924RewindThirty;




const $218d55adc610fd5f$var$SvgGlyphiconsBasic925ForwardFive = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16.5 17.5a.501.501 0 0 0-.5-.5h-2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2h-2v1h1a2.5 2.5 0 0 1 0 5h-2a1 1 0 0 1 0-2h2a.501.501 0 0 0 .5-.5Zm10.116-7.066a.502.502 0 0 0-.728-.17l-1.653 1.145a.495.495 0 0 0-.156.632 8.994 8.994 0 0 1-8.34 12.955 9.1 9.1 0 0 1-8.735-8.736A9.01 9.01 0 0 1 16 7v2.046a.5.5 0 0 0 .785.41L21 6.54v2.507a.5.5 0 0 0 .785.41l5.121-3.545a.5.5 0 0 0 0-.822l-5.121-3.546a.5.5 0 0 0-.785.411v2.507l-4.215-2.918a.5.5 0 0 0-.785.411V4a12.03 12.03 0 1 0 10.616 6.434Z"
        })
    });
var $218d55adc610fd5f$export$2e2bcd8739ae039 = $218d55adc610fd5f$var$SvgGlyphiconsBasic925ForwardFive;




const $c89253352204f1fe$var$SvgGlyphiconsBasic926ForwardTen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 19v-3.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2A1 1 0 0 1 14 13v6a1 1 0 0 1-2 0Zm10-4v2a3 3 0 0 1-6 0v-2a3 3 0 0 1 6 0Zm-2 0a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0Zm6.616-4.566a.502.502 0 0 0-.728-.17l-1.653 1.145a.495.495 0 0 0-.156.632 8.994 8.994 0 0 1-8.34 12.955 9.1 9.1 0 0 1-8.735-8.736A9.01 9.01 0 0 1 16 7v2.046a.5.5 0 0 0 .785.41L21 6.54v2.507a.5.5 0 0 0 .785.41l5.121-3.545a.5.5 0 0 0 0-.822l-5.121-3.546a.5.5 0 0 0-.785.411v2.507l-4.215-2.918a.5.5 0 0 0-.785.411V4a12.03 12.03 0 1 0 10.616 6.434Z"
        })
    });
var $c89253352204f1fe$export$2e2bcd8739ae039 = $c89253352204f1fe$var$SvgGlyphiconsBasic926ForwardTen;




const $0447b3f41e76f8a0$var$SvgGlyphiconsBasic927ForwardFifteen = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12 19v-3.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2A1 1 0 0 1 14 13v6a1 1 0 0 1-2 0Zm7-1h-2a1 1 0 0 0 0 2h2a2.5 2.5 0 0 0 0-5h-1v-1h2a1 1 0 0 0 0-2h-3a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a.5.5 0 0 1 0 1Zm7.616-7.566a.502.502 0 0 0-.728-.17l-1.653 1.145a.495.495 0 0 0-.156.632 8.994 8.994 0 0 1-8.34 12.955 9.1 9.1 0 0 1-8.735-8.736A9.01 9.01 0 0 1 16 7v2.046a.5.5 0 0 0 .785.41L21 6.54v2.507a.5.5 0 0 0 .785.41l5.121-3.545a.5.5 0 0 0 0-.822l-5.121-3.546a.5.5 0 0 0-.785.411v2.507l-4.215-2.918a.5.5 0 0 0-.785.411V4a12.03 12.03 0 1 0 10.616 6.434Z"
        })
    });
var $0447b3f41e76f8a0$export$2e2bcd8739ae039 = $0447b3f41e76f8a0$var$SvgGlyphiconsBasic927ForwardFifteen;




const $e11ed9977000d038$var$SvgGlyphiconsBasic928ForwardThirty = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 12a3.003 3.003 0 0 0-3 3v2a3 3 0 0 0 6 0v-2a3.003 3.003 0 0 0-3-3Zm1 5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0Zm-5-2.5a2.476 2.476 0 0 1-.512 1.5A2.476 2.476 0 0 1 15 17.5a2.502 2.502 0 0 1-2.5 2.5H11a1 1 0 0 1 0-2h1.5a.5.5 0 0 0 0-1H12a1 1 0 0 1 0-2h.5a.5.5 0 0 0 0-1H11a1 1 0 0 1 0-2h1.5a2.502 2.502 0 0 1 2.5 2.5Zm12.882 3.19A12 12 0 1 1 16 4V1.954a.5.5 0 0 1 .785-.41L21 4.46V1.954a.5.5 0 0 1 .785-.41l5.121 3.545a.5.5 0 0 1 0 .822l-5.121 3.546A.5.5 0 0 1 21 9.046V6.539l-4.215 2.918A.5.5 0 0 1 16 9.046V7a9.01 9.01 0 0 0-8.996 9.26 9.1 9.1 0 0 0 8.736 8.736 8.994 8.994 0 0 0 8.339-12.955.495.495 0 0 1 .156-.632l1.653-1.144a.502.502 0 0 1 .728.17 11.902 11.902 0 0 1 1.266 7.254Z"
        })
    });
var $e11ed9977000d038$export$2e2bcd8739ae039 = $e11ed9977000d038$var$SvgGlyphiconsBasic928ForwardThirty;




const $770f373b022e967f$var$SvgGlyphiconsBasic929Passport = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14.633 17h2.734a8.066 8.066 0 0 1-1.364 3.808A8.075 8.075 0 0 1 14.633 17Zm1.364-5.808A8.066 8.066 0 0 0 14.633 15h2.734a8.075 8.075 0 0 0-1.37-3.808ZM11.101 15h1.519a10.349 10.349 0 0 1 .806-3.264A4.998 4.998 0 0 0 11.101 15Zm0 2a4.998 4.998 0 0 0 2.325 3.264A10.349 10.349 0 0 1 12.62 17Zm7.473 3.264A4.998 4.998 0 0 0 20.899 17H19.38a10.349 10.349 0 0 1-.806 3.264ZM29 4h-1.351A3.46 3.46 0 0 1 28 5.5V6h1v20h-1v.5a3.46 3.46 0 0 1-.351 1.5H29a2.003 2.003 0 0 0 2-2V6a2.003 2.003 0 0 0-2-2Zm-3 1.5v21a1.502 1.502 0 0 1-1.5 1.5h-17A1.502 1.502 0 0 1 6 26.5v-21A1.502 1.502 0 0 1 7.5 4h17A1.502 1.502 0 0 1 26 5.5ZM23 16a7 7 0 1 0-7 7 7 7 0 0 0 7-7Zm-4.426-4.264A10.349 10.349 0 0 1 19.38 15H20.9a4.998 4.998 0 0 0-2.325-3.264Z"
        })
    });
var $770f373b022e967f$export$2e2bcd8739ae039 = $770f373b022e967f$var$SvgGlyphiconsBasic929Passport;




const $d35f11cc3e4aed5c$var$SvgGlyphiconsBasic93Drop = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 13.5a3.5 3.5 0 0 1-7 0c0-1.784 1.415-3.411 2.624-5.628a.997.997 0 0 1 1.752 0C26.586 10.089 28 11.716 28 13.5ZM13.406 6.07C16.356 12.078 20.8 15.402 20.8 20a8.151 8.151 0 0 1-8.3 8 8.151 8.151 0 0 1-8.3-8c0-4.598 4.443-7.922 7.394-13.93a1.003 1.003 0 0 1 1.812 0Zm-2.556 6.945a1 1 0 0 0-1.395.235 29.61 29.61 0 0 0-2.504 3.919 1 1 0 0 0 1.799.875 28.169 28.169 0 0 1 2.336-3.635 1 1 0 0 0-.236-1.394Z"
        })
    });
var $d35f11cc3e4aed5c$export$2e2bcd8739ae039 = $d35f11cc3e4aed5c$var$SvgGlyphiconsBasic93Drop;




const $63dcfab713e6ac45$var$SvgGlyphiconsBasic930PassportAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31.213 7.188 28 19.178V5.5a3.474 3.474 0 0 0-.26-1.313l2.059.551a2.002 2.002 0 0 1 1.414 2.45ZM19.578 2 12.412.08a2.007 2.007 0 0 0-2.45 1.414L9.828 2Zm-3.58 9.192A8.066 8.066 0 0 0 14.632 15h2.734a8.075 8.075 0 0 0-1.37-3.808ZM11.1 15h1.519a10.349 10.349 0 0 1 .806-3.264A4.998 4.998 0 0 0 11.101 15Zm4.902 5.808A8.066 8.066 0 0 0 17.367 17h-2.734a8.075 8.075 0 0 0 1.37 3.808Zm2.57-.544A4.998 4.998 0 0 0 20.9 17H19.38a10.349 10.349 0 0 1-.806 3.264ZM26 5.5v21a1.502 1.502 0 0 1-1.5 1.5h-17A1.502 1.502 0 0 1 6 26.5v-21A1.502 1.502 0 0 1 7.5 4h17A1.502 1.502 0 0 1 26 5.5ZM23 16a7 7 0 1 0-7 7 7 7 0 0 0 7-7Zm-4.426-4.264A10.349 10.349 0 0 1 19.38 15H20.9a4.998 4.998 0 0 0-2.325-3.264ZM11.1 17a4.998 4.998 0 0 0 2.325 3.264A10.349 10.349 0 0 1 12.62 17Z"
        })
    });
var $63dcfab713e6ac45$export$2e2bcd8739ae039 = $63dcfab713e6ac45$var$SvgGlyphiconsBasic930PassportAlt;




const $4042a064e89da912$var$SvgGlyphiconsBasic931SpeechBubbleQuestion = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 20v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm1.94-7.014c.218 3.012-1.77 2.955-2.119 4.574a.558.558 0 0 1-.544.439h-2.713a.51.51 0 0 1-.5-.577c.28-2.255 2.568-2.342 2.613-3.887a1.06 1.06 0 0 0-1.174-1.035 1.503 1.503 0 0 0-1.435 1.06.595.595 0 0 1-.566.435l-1.9-.005a.464.464 0 0 1-.472-.501A4.563 4.563 0 0 1 15.515 9.3c2.11.006 4.236 1.084 4.425 3.686ZM17.37 24.9a9.02 9.02 0 0 1-5.85-1.1l-.54-.31-3.37.9.74-2.77.16-.6-.31-.54a8.992 8.992 0 1 1 9.17 4.42ZM15.99 28a12.477 12.477 0 0 0 1.82-.13A12.003 12.003 0 1 0 4.14 14.19a11.868 11.868 0 0 0 1.16 7.23l-1.22 4.55a1.584 1.584 0 0 0 .39 1.56 1.565 1.565 0 0 0 1.56.39l4.55-1.22a11.884 11.884 0 0 0 5.41 1.3Z"
        })
    });
var $4042a064e89da912$export$2e2bcd8739ae039 = $4042a064e89da912$var$SvgGlyphiconsBasic931SpeechBubbleQuestion;




const $1aa02108484d9ed8$var$SvgGlyphiconsBasic932SpeechBubbleInfo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m18.806 10.164-.167 1a1 1 0 0 1-.986.836H16.18a1 1 0 0 1-.986-1.165l.167-1A1 1 0 0 1 16.347 9h1.473a1 1 0 0 1 .986 1.164Zm-.38 4.752L16.6 21h1.26a.5.5 0 0 1 .485.621l-.25 1a.5.5 0 0 1-.485.379H14a1.408 1.408 0 0 1-1.425-1.916L14.4 15h-.76a.5.5 0 0 1-.485-.621l.25-1A.5.5 0 0 1 13.89 13H17a1.408 1.408 0 0 1 1.425 1.916ZM17.37 24.9a9.02 9.02 0 0 1-5.85-1.1l-.54-.31-3.37.9.74-2.77.16-.6-.31-.54a8.992 8.992 0 1 1 9.17 4.42ZM15.99 28a12.477 12.477 0 0 0 1.82-.13A12.003 12.003 0 1 0 4.14 14.19a11.868 11.868 0 0 0 1.16 7.23l-1.22 4.55a1.584 1.584 0 0 0 .39 1.56 1.565 1.565 0 0 0 1.56.39l4.55-1.22a11.884 11.884 0 0 0 5.41 1.3Z"
        })
    });
var $1aa02108484d9ed8$export$2e2bcd8739ae039 = $1aa02108484d9ed8$var$SvgGlyphiconsBasic932SpeechBubbleInfo;




const $61053a4b8516670a$var$SvgGlyphiconsBasic933SpeechBubbleAlert = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 20v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1ZM17 9h-2a1 1 0 0 0-1 1v3l.919 4.598a.5.5 0 0 0 .49.402h1.18a.5.5 0 0 0 .49-.402L18 13 18 10a1 1 0 0 0-1-1Zm.37 15.9a9.02 9.02 0 0 1-5.85-1.1l-.54-.31-3.37.9.74-2.77.16-.6-.31-.54a8.992 8.992 0 1 1 9.17 4.42ZM15.99 28a12.477 12.477 0 0 0 1.82-.13A12.003 12.003 0 1 0 4.14 14.19a11.868 11.868 0 0 0 1.16 7.23l-1.22 4.55a1.584 1.584 0 0 0 .39 1.56 1.565 1.565 0 0 0 1.56.39l4.55-1.22a11.884 11.884 0 0 0 5.41 1.3Z"
        })
    });
var $61053a4b8516670a$export$2e2bcd8739ae039 = $61053a4b8516670a$var$SvgGlyphiconsBasic933SpeechBubbleAlert;




const $c7efd87c794ab733$var$SvgGlyphiconsBasic934ReloadAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.51 7.564a11.983 11.983 0 0 1-8.995 20.426A11.995 11.995 0 0 1 15 4.05V1.955a.5.5 0 0 1 .785-.41l5.121 3.545a.5.5 0 0 1 0 .822l-5.121 3.546A.5.5 0 0 1 15 9.046V7.059a8.998 8.998 0 0 0 1.26 17.937 9.106 9.106 0 0 0 8.734-9.316 8.974 8.974 0 0 0-2.835-6.233.503.503 0 0 1 .045-.786l1.663-1.15a.505.505 0 0 1 .643.053Z"
        })
    });
var $c7efd87c794ab733$export$2e2bcd8739ae039 = $c7efd87c794ab733$var$SvgGlyphiconsBasic934ReloadAlt;




const $dbb6f5a034faf267$var$SvgGlyphiconsBasic935PowerCordPlug = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 11.5V16a6.995 6.995 0 0 1-6 6.92V28h-4v-5.08A6.995 6.995 0 0 1 8 16v-4.5A1.5 1.5 0 0 1 9.5 10H11V5.5a1.5 1.5 0 0 1 3 0V10h4V5.5a1.5 1.5 0 0 1 3 0V10h1.5a1.5 1.5 0 0 1 1.5 1.5Z"
        })
    });
var $dbb6f5a034faf267$export$2e2bcd8739ae039 = $dbb6f5a034faf267$var$SvgGlyphiconsBasic935PowerCordPlug;




const $37a80cf66e92e060$var$SvgGlyphiconsBasic936PowerCordPlugOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M13.212 22.755 24 11.967V16a6.995 6.995 0 0 1-6 6.92V28h-4v-5.08a6.953 6.953 0 0 1-.788-.165ZM27.215 2.939a1.5 1.5 0 0 0-2.121 0L21 7.033V5.5a1.5 1.5 0 0 0-3 0V10h-4V5.5a1.5 1.5 0 0 0-3 0V10H9.5A1.5 1.5 0 0 0 8 11.5V16a6.91 6.91 0 0 0 .804 3.229L2.94 25.094a1.5 1.5 0 1 0 2.122 2.12L27.215 5.062a1.5 1.5 0 0 0 0-2.122Z"
        })
    });
var $37a80cf66e92e060$export$2e2bcd8739ae039 = $37a80cf66e92e060$var$SvgGlyphiconsBasic936PowerCordPlugOff;




const $caf932bcb7bebd36$var$SvgGlyphiconsBasic937WirelessCharging = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 7a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Zm3.858 8.835-4.06 4.503a.5.5 0 0 1-.869-.392L15.27 17h-2.756a.5.5 0 0 1-.371-.835l4.06-4.504a.5.5 0 0 1 .869.393L16.73 15h2.756a.5.5 0 0 1 .371.835ZM16 3a13 13 0 1 0 13 13A13.015 13.015 0 0 0 16 3Zm0 24a11 11 0 1 1 11-11 11.012 11.012 0 0 1-11 11Z"
        })
    });
var $caf932bcb7bebd36$export$2e2bcd8739ae039 = $caf932bcb7bebd36$var$SvgGlyphiconsBasic937WirelessCharging;




const $c276a242c3b318e4$var$SvgGlyphiconsBasic938TvStreaming = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 26v1a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Zm5.5-21h-25A1.5 1.5 0 0 0 2 6.5v3a.5.5 0 0 0 .5.5H3a11.244 11.244 0 0 1 1.444.098A.486.486 0 0 0 5 9.602V8h22v12H15.398a.486.486 0 0 0-.495.556A11.25 11.25 0 0 1 15 22v.5a.5.5 0 0 0 .5.5h13a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 28.5 5ZM3 14a8.01 8.01 0 0 1 8 8 1 1 0 0 0 2 0A10.012 10.012 0 0 0 3 12a1 1 0 0 0 0 2Zm0 2a1 1 0 0 0 0 2 4.004 4.004 0 0 1 4 4 1 1 0 0 0 2 0 6.007 6.007 0 0 0-6-6Zm0 4a1 1 0 0 0-1 .999A1.024 1.024 0 0 0 3 22a1.029 1.029 0 0 0 1 1 1 1 0 0 0 1-1 2.003 2.003 0 0 0-2-2Z"
        })
    });
var $c276a242c3b318e4$export$2e2bcd8739ae039 = $c276a242c3b318e4$var$SvgGlyphiconsBasic938TvStreaming;




const $7a6aa98240c2853b$var$SvgGlyphiconsBasic939Cheque = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m22.997 15.377-3.137 1.6a.619.619 0 0 1-.851-.852l1.6-3.136Zm7.63-8.975-1.044-1.044a1.223 1.223 0 0 0-1.73 0l-6.573 6.573 2.774 2.774 6.573-6.573a1.223 1.223 0 0 0 0-1.73ZM8.5 17h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm0 4h15a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5ZM26 15.614V23H6V13h12.358l.727-1.426a4 4 0 0 1 .734-1.01L24.383 6H6a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-9.386Z"
        })
    });
var $7a6aa98240c2853b$export$2e2bcd8739ae039 = $7a6aa98240c2853b$var$SvgGlyphiconsBasic939Cheque;




const $241d7f223882877e$var$SvgGlyphiconsBasic94Crop = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M20 11H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h12a1 1 0 0 1 1 1v10h-4Zm7 9H11v-7H7v10a1 1 0 0 0 1 1h12v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
        })
    });
var $241d7f223882877e$export$2e2bcd8739ae039 = $241d7f223882877e$var$SvgGlyphiconsBasic94Crop;




const $52f8e9ae9bab8a39$var$SvgGlyphiconsBasic940ChequeOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 21h-8.533l2-2H23.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5Zm4.497-13.03L22.967 13H26v10H12.967l-2 2H26a2 2 0 0 0 2-2V8l-.003-.03Zm-.782-2.91L5.06 27.216a1.5 1.5 0 0 1-2.122-2.121l1.253-1.252A1.984 1.984 0 0 1 4 23V8a2 2 0 0 1 2-2h16.033l3.06-3.06a1.5 1.5 0 0 1 2.122 2.12ZM6 22.034l2-2V19.5a.5.5 0 0 1 .5-.5h.533l2-2H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h4.533l2-2H6Z"
        })
    });
var $52f8e9ae9bab8a39$export$2e2bcd8739ae039 = $52f8e9ae9bab8a39$var$SvgGlyphiconsBasic940ChequeOff;




const $823c5561b320ec62$var$SvgGlyphiconsBasic941BuildingsMixed = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4H6a2 2 0 0 0-2 2v21.5a.5.5 0 0 0 .5.5H8v-3a1.003 1.003 0 0 1 1-1h4a1.003 1.003 0 0 1 1 1v3h3.5a.5.5 0 0 0 .5-.5V6a2 2 0 0 0-2-2Zm-6 16.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm5 10a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM30.887 21H29v6.5a.5.5 0 0 1-.5.5H26v-3.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V28h-2V16.5l3.626-4.08a.5.5 0 0 1 .748 0l6.886 7.748a.5.5 0 0 1-.373.832Z"
        })
    });
var $823c5561b320ec62$export$2e2bcd8739ae039 = $823c5561b320ec62$var$SvgGlyphiconsBasic941BuildingsMixed;




const $28611fb99e7e52be$var$SvgGlyphiconsBasic942BuildingsCity = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 4H11a2 2 0 0 0-2 2v21.5a.5.5 0 0 0 .5.5H13v-3a1.003 1.003 0 0 1 1-1h4a1.003 1.003 0 0 1 1 1v3h3.5a.5.5 0 0 0 .5-.5V6a2 2 0 0 0-2-2Zm-6 16.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm5 10a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm10-.5v17.5a.5.5 0 0 1-.5.5H25v-3h1.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H25v-2h1.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H25v-2h1.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H25V8h3a2 2 0 0 1 2 2ZM7 28H2.5a.5.5 0 0 1-.5-.5V13a2 2 0 0 1 2-2h3v4H5.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H7v2H5.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H7Z"
        })
    });
var $28611fb99e7e52be$export$2e2bcd8739ae039 = $28611fb99e7e52be$var$SvgGlyphiconsBasic942BuildingsCity;




const $10bdcaeded46250c$var$SvgGlyphiconsBasic943BuildingsPark = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M31.355 19.162A2.978 2.978 0 0 1 28 23.816V26l.638 1.276a.5.5 0 0 1-.447.724h-2.382a.5.5 0 0 1-.447-.724L26 26v-2.184a2.982 2.982 0 0 1-3.355-4.654A2.49 2.49 0 0 1 24.5 15c.017 0 .033.005.05.005a2.5 2.5 0 0 1 4.9 0c.017 0 .033-.005.05-.005a2.49 2.49 0 0 1 1.855 4.162Zm-9.039-7.214 3-1a1 1 0 0 0-.632-1.896L22 9.946l-2-.666v2.107l1.684.561a.993.993 0 0 0 .632 0Zm1.237-6.053 2 1a1.001 1.001 0 0 0 .894 0l2-1a1 1 0 0 0-.894-1.79L26 4.882l-1.553-.777a1 1 0 1 0-.894 1.79ZM18 6v21.5a.5.5 0 0 1-.5.5H14v-3a1.003 1.003 0 0 0-1-1H9a1.003 1.003 0 0 0-1 1v3H4.5a.5.5 0 0 1-.5-.5V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Zm-8 12.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm0-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm0-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm5 10a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm0-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Zm0-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5Z"
        })
    });
var $10bdcaeded46250c$export$2e2bcd8739ae039 = $10bdcaeded46250c$var$SvgGlyphiconsBasic943BuildingsPark;




const $83b6ccdc5fe1536c$var$SvgGlyphiconsBasic944Highway = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m17.167 8-.145-3.48a.5.5 0 0 1 .5-.52h1.088a.5.5 0 0 1 .485.379L20 8Zm4.583 7h-4.292l.522 12.52a.5.5 0 0 0 .5.48h5.24a1 1 0 0 0 .97-1.243ZM7.31 26.757A1 1 0 0 0 8.28 28h5.24a.5.5 0 0 0 .5-.48L14.542 15H10.25Zm7.668-22.236a.5.5 0 0 0-.5-.521H13.39a.5.5 0 0 0-.485.379L12 8h2.833ZM3 10v3h1a1 1 0 0 1 1 1v3.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V14a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V14a1 1 0 0 1 1-1h1v-3Z"
        })
    });
var $83b6ccdc5fe1536c$export$2e2bcd8739ae039 = $83b6ccdc5fe1536c$var$SvgGlyphiconsBasic944Highway;




const $56a79e59cb5c84d1$var$SvgGlyphiconsBasic945TrafficLights = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25.676 8.737 23 11.19V7h2a1 1 0 0 1 .676 1.737Zm-20.608 5.9a1 1 0 0 0 .256 1.1L8 18.19V14H6a1 1 0 0 0-.932.638Zm0-7a1 1 0 0 0 .256 1.1L8 11.19V7H6a1 1 0 0 0-.932.638ZM25 21h-2v4.19l2.676-2.453A1 1 0 0 0 25 21Zm-19.932.638a1 1 0 0 0 .256 1.1L8 25.19V21H6a1 1 0 0 0-.932.638ZM25 14h-2v4.19l2.676-2.453A1 1 0 0 0 25 14Zm-4-7v19a2.003 2.003 0 0 1-2 2h-7a2.003 2.003 0 0 1-2-2V7a2.003 2.003 0 0 1 2-2h7a2.003 2.003 0 0 1 2 2Zm-3 16.5a2.5 2.5 0 1 0-2.5 2.5 2.5 2.5 0 0 0 2.5-2.5Zm0-7a2.5 2.5 0 1 0-2.5 2.5 2.5 2.5 0 0 0 2.5-2.5Zm0-7a2.5 2.5 0 1 0-2.5 2.5A2.5 2.5 0 0 0 18 9.5Z"
        })
    });
var $56a79e59cb5c84d1$export$2e2bcd8739ae039 = $56a79e59cb5c84d1$var$SvgGlyphiconsBasic945TrafficLights;




const $9e8416c406c75ee3$var$SvgGlyphiconsBasic946TrafficLightsOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M5.324 8.737A1 1 0 0 1 6 7h2v4.19ZM8 18.19V14H6a1 1 0 0 0-.676 1.737ZM25 21h-2v4.19l2.676-2.453A1 1 0 0 0 25 21Zm0-7h-2v4.19l2.676-2.453A1 1 0 0 0 25 14Zm-9.5 7a2.54 2.54 0 1 1-2.413 1.88L10 25.967V26a2.003 2.003 0 0 0 2 2h7a2.003 2.003 0 0 0 2-2V14.967l-6.12 6.12A2.476 2.476 0 0 1 15.5 21ZM27.215 5.06 5.06 27.216a1.5 1.5 0 0 1-2.122-2.121l2.373-2.372A.998.998 0 0 1 6 21h1.033L10 18.033V7a2.003 2.003 0 0 1 2-2h7a2.003 2.003 0 0 1 2 2v.033l4.094-4.094a1.5 1.5 0 0 1 2.12 2.122ZM16.12 11.914l1.793-1.793a2.54 2.54 0 1 0-1.793 1.793Z"
        })
    });
var $9e8416c406c75ee3$export$2e2bcd8739ae039 = $9e8416c406c75ee3$var$SvgGlyphiconsBasic946TrafficLightsOff;




const $8ad56762b8b66455$var$SvgGlyphiconsBasic947CircleMore = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm-6 14a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $8ad56762b8b66455$export$2e2bcd8739ae039 = $8ad56762b8b66455$var$SvgGlyphiconsBasic947CircleMore;




const $5de06b1b85d4bc86$var$SvgGlyphiconsBasic948SquareMore = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 5h-15A3.504 3.504 0 0 0 5 8.5v15A3.504 3.504 0 0 0 8.5 27h15a3.504 3.504 0 0 0 3.5-3.5v-15A3.504 3.504 0 0 0 23.5 5ZM10 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm6 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
        })
    });
var $5de06b1b85d4bc86$export$2e2bcd8739ae039 = $5de06b1b85d4bc86$var$SvgGlyphiconsBasic948SquareMore;




const $4df7feeb045550aa$var$SvgGlyphiconsBasic949CircleMenu = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12.013 12.013 0 0 0 16 4Zm5 16.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Z"
        })
    });
var $4df7feeb045550aa$export$2e2bcd8739ae039 = $4df7feeb045550aa$var$SvgGlyphiconsBasic949CircleMenu;




const $4b00a4634fb42602$var$SvgGlyphiconsBasic95VectorPath = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v1H11V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v10H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-1V11ZM6 6h3v3H6Zm3 20H6v-3h3Zm12-4v1H11v-1a1 1 0 0 0-1-1H9V11h1a1 1 0 0 0 1-1V9h10v1a1 1 0 0 0 1 1h1v10h-1a1 1 0 0 0-1 1Zm5 4h-3v-3h3ZM23 9V6h3v3Z"
        })
    });
var $4b00a4634fb42602$export$2e2bcd8739ae039 = $4b00a4634fb42602$var$SvgGlyphiconsBasic95VectorPath;




const $01620e0665951448$var$SvgGlyphiconsBasic950SquareMenu = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23.5 5h-15A3.504 3.504 0 0 0 5 8.5v15A3.504 3.504 0 0 0 8.5 27h15a3.504 3.504 0 0 0 3.5-3.5v-15A3.504 3.504 0 0 0 23.5 5ZM21 20.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Zm0-4a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5Z"
        })
    });
var $01620e0665951448$export$2e2bcd8739ae039 = $01620e0665951448$var$SvgGlyphiconsBasic950SquareMenu;




const $d850313033b2f3f5$var$SvgGlyphiconsBasic951ListLetters = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 24v1a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Zm3-7H15a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-4-6h-8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm4-6H15a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-15.614 6.614-2.464-5.9a1 1 0 0 0-1.846 0l-2.464 5.9a1 1 0 0 0 1.846.772L7.037 11h1.925l.578 1.386a1 1 0 1 0 1.846-.772ZM7.668 9.5l.33-.927.331.927Zm2.526 11.173A2.468 2.468 0 0 0 10.5 19.5 2.502 2.502 0 0 0 8 17H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.5a2.492 2.492 0 0 0 1.694-4.327ZM7 19h1a.5.5 0 0 1 0 1H7Zm1.5 4H7v-1h1.5a.5.5 0 0 1 0 1Z"
        })
    });
var $d850313033b2f3f5$export$2e2bcd8739ae039 = $d850313033b2f3f5$var$SvgGlyphiconsBasic951ListLetters;




const $ff003a29113b17dc$var$SvgGlyphiconsBasic952ListNumbers = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M14 13v-1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1Zm9 10h-8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm4-6H15a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-12H15a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM10 23H7.55a1.359 1.359 0 0 1 .749-.629c.589-.21 2.38-.847 2.38-2.657A2.718 2.718 0 0 0 7.964 17a3.169 3.169 0 0 0-2.479 1.213 1 1 0 1 0 1.53 1.289A1.202 1.202 0 0 1 7.964 19a.715.715 0 0 1 .715.714c0 .119 0 .4-1.051.772a3.615 3.615 0 0 0-2.306 3.567 1 1 0 0 0 1 .947H10a1 1 0 0 0 0-2ZM6.707 8.707 7 8.414V12a1 1 0 0 0 2 0V6a1 1 0 0 0-1.707-.707l-2 2a1 1 0 0 0 1.414 1.414Z"
        })
    });
var $ff003a29113b17dc$export$2e2bcd8739ae039 = $ff003a29113b17dc$var$SvgGlyphiconsBasic952ListNumbers;




const $30d37fc089a6aeb7$var$SvgGlyphiconsBasic953InitialLetter = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 12v1a1 1 0 0 1-1 1H15a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Zm-1-7H15a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm0 18H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm0-6H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-15.614-5.386-2.464-5.9a1 1 0 0 0-1.846 0l-2.464 5.9a1 1 0 0 0 1.846.772L7.037 11h1.925l.578 1.386a1 1 0 1 0 1.846-.772ZM7.668 9.5l.33-.927.331.927Z"
        })
    });
var $30d37fc089a6aeb7$export$2e2bcd8739ae039 = $30d37fc089a6aeb7$var$SvgGlyphiconsBasic953InitialLetter;




const $3a147d0937885da7$var$SvgGlyphiconsBasic954Brain = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 16a3.003 3.003 0 0 1-3 3 1 1 0 0 1 0-2 1 1 0 0 0 1-1 1 1 0 0 1 2 0Zm6 0a2.997 2.997 0 0 1-1.062 2.288A3.99 3.99 0 0 1 29 21v1.002a4 4 0 0 1-3.405 3.955A4.994 4.994 0 0 1 21 29h-1a5.297 5.297 0 0 1-4-1.847A5.297 5.297 0 0 1 12 29h-1a4.994 4.994 0 0 1-4.595-3.043A4 4 0 0 1 3 22.002V21a4.002 4.002 0 0 1 1.062-2.713A2.991 2.991 0 0 1 3 16v-2a3.006 3.006 0 0 1 2-2.83V10a4.004 4.004 0 0 1 4-4h1a3.003 3.003 0 0 1 3-3h1.5a2.95 2.95 0 0 1 1.5.413A2.95 2.95 0 0 1 17.5 3H19a3.003 3.003 0 0 1 3 3h1a4.004 4.004 0 0 1 4 4v1.17A3.006 3.006 0 0 1 29 14ZM15 5.147A.92.92 0 0 0 14.5 5H13a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H9a2.003 2.003 0 0 0-2 2v2a1 1 0 0 1-1 1 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 1 1 0 0 1 1 1.006l-.001.17a.998.998 0 0 1-.667.937A2.004 2.004 0 0 0 5 21v1.002A1.999 1.999 0 0 0 6.998 24H10a1 1 0 0 1 0 2H8.775A2.984 2.984 0 0 0 11 27h1a3.189 3.189 0 0 0 3-2.085V23a1 1 0 0 0-1-1h-1a2.977 2.977 0 0 1-2-.78A2.977 2.977 0 0 1 9 22a1 1 0 0 1 0-2 1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1 1 1 0 0 1 0-2 3.003 3.003 0 0 1 3 3v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1 1 1 0 0 1 0-2 1 1 0 0 0 0-2 2.977 2.977 0 0 1-2-.78 2.977 2.977 0 0 1-2 .78 1 1 0 0 1 0-2 1 1 0 0 0 1-1 1 1 0 0 1 2 0 1 1 0 0 0 1 1 2.965 2.965 0 0 1 1 .184ZM27 14a1 1 0 0 0-1-1 1 1 0 0 1-1-1v-2a2.003 2.003 0 0 0-2-2h-3a1 1 0 0 1 0-2 1 1 0 0 0-1-1h-1.5a.92.92 0 0 0-.5.148v7.036A2.965 2.965 0 0 1 18 12h1a1 1 0 0 0 1-1 1 1 0 0 1 2 0 1 1 0 0 0 1 1 1 1 0 0 1 0 2 2.977 2.977 0 0 1-2-.78 2.977 2.977 0 0 1-2 .78h-1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1a2.977 2.977 0 0 1 2 .78 2.977 2.977 0 0 1 2-.78 1 1 0 0 1 0 2 1 1 0 0 0-1 1 1 1 0 0 1-2 0 1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v.915A3.189 3.189 0 0 0 20 27h1a2.996 2.996 0 0 0 2.898-2.25.999.999 0 0 1 .968-.75h.135A1.999 1.999 0 0 0 27 22.002V21a2.003 2.003 0 0 0-2-2 1 1 0 0 1 0-2h1a1 1 0 0 0 1-1Z"
        })
    });
var $3a147d0937885da7$export$2e2bcd8739ae039 = $3a147d0937885da7$var$SvgGlyphiconsBasic954Brain;




const $1fccb0fc80648000$var$SvgGlyphiconsBasic955BrainAi = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M6.975 12a2.995 2.995 0 0 0 2.815-2h.77L13 12.44V9.61l-1.318-1.318A1 1 0 0 0 10.975 8H9.79a2.995 2.995 0 1 0-2.815 4Zm0-4a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm.826 8.965a.958.958 0 0 0 .174.035H13v-2H7.975a.958.958 0 0 0-.174.035 3 3 0 1 0 0 1.93ZM3.975 16a1 1 0 1 1 1 1 1 1 0 0 1-1-1ZM29 14a3.006 3.006 0 0 0-2-2.83V10a4.004 4.004 0 0 0-4-4h-1a3.003 3.003 0 0 0-3-3h-1.5A2.506 2.506 0 0 0 15 5.5v19.71c0 1.887 1.488 3.79 4.813 3.79H21a4.994 4.994 0 0 0 4.595-3.044A4.007 4.007 0 0 0 29 22v-1a3.99 3.99 0 0 0-1.062-2.712A2.997 2.997 0 0 0 29 16Zm-2 2a1 1 0 0 1-1 1h-1a1 1 0 0 0 0 2 2.003 2.003 0 0 1 2 2v1a2.003 2.003 0 0 1-2 2h-.134a.999.999 0 0 0-.968.75A2.996 2.996 0 0 1 21 27h-1.187C18.078 27 17 26.314 17 25.21V24a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1 1 1 0 0 0 2 0 1 1 0 0 1 1-1 1 1 0 0 0 0-2 2.977 2.977 0 0 0-2 .78 2.977 2.977 0 0 0-2-.78h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1a2.977 2.977 0 0 0 2-.78 2.977 2.977 0 0 0 2 .78 1 1 0 0 0 0-2 1 1 0 0 1-1-1 1 1 0 0 0-2 0 1 1 0 0 1-1 1h-1a2.965 2.965 0 0 0-1 .184V5.5a.506.506 0 0 1 .5-.5H19a1 1 0 0 1 1 1v1a1 1 0 0 0 1 1h2a2.003 2.003 0 0 1 2 2v2a1 1 0 0 0 1 1 1 1 0 0 1 1 1Zm-4 0a3.003 3.003 0 0 1-3 3 1 1 0 0 1 0-2 1 1 0 0 0 1-1 1 1 0 0 1 2 0Zm-10 3.56L10.56 22h-.77a3 3 0 1 0 0 2h1.185a1 1 0 0 0 .707-.293L13 22.389ZM6.975 24a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
        })
    });
var $1fccb0fc80648000$export$2e2bcd8739ae039 = $1fccb0fc80648000$var$SvgGlyphiconsBasic955BrainAi;




const $ef3766e3532b1048$var$SvgGlyphiconsBasic956ArtificialIntelligence = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M15 8.816V12a1 1 0 0 0 2 0V8.816a3 3 0 1 0-2 0ZM16 5a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm11 8a3 3 0 1 0 3 3 3.003 3.003 0 0 0-3-3Zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1ZM8 16a3 3 0 1 0-3 3 3.003 3.003 0 0 0 3-3Zm-3 1a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm12 6.184V20a1 1 0 0 0-2 0v3.184a3 3 0 1 0 2 0ZM16 27a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm8-5.816V20a1 1 0 0 0-.293-.707L20.414 16l3.293-3.293A1 1 0 0 0 24 12v-1.184a3 3 0 1 0-2 0v.77L18.586 15h-5.172L10 11.586v-.77a3 3 0 1 0-2 0V12a1 1 0 0 0 .293.707L11.586 16l-3.293 3.293A1 1 0 0 0 8 20v1.184a3 3 0 1 0 2 0v-.77L13.414 17h5.172L22 20.414v.77a3 3 0 1 0 2 0ZM23 7a1 1 0 1 1-1 1 1 1 0 0 1 1-1ZM9 7a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm0 18a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm14 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
        })
    });
var $ef3766e3532b1048$export$2e2bcd8739ae039 = $ef3766e3532b1048$var$SvgGlyphiconsBasic956ArtificialIntelligence;




const $ef489cbc6fde5b26$var$SvgGlyphiconsBasic957Microchip = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.5 12h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5ZM25 9v14a2.003 2.003 0 0 1-2 2H9a2.003 2.003 0 0 1-2-2V9a2.003 2.003 0 0 1 2-2h14a2.003 2.003 0 0 1 2 2Zm-4 13a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1Zm9-12a1 1 0 0 0-1-1h-2v2h2a1 1 0 0 0 1-1Zm-9 19a1 1 0 0 0 2 0v-2h-2Zm-4 0a1 1 0 0 0 2 0v-2h-2Zm-4 0a1 1 0 0 0 2 0v-2h-2Zm-4 0a1 1 0 0 0 2 0v-2H9Zm20-8h-2v2h2a1 1 0 0 0 0-2Zm0-8h-2v2h2a1 1 0 0 0 0-2Zm0 4h-2v2h2a1 1 0 0 0 0-2ZM2 22a1 1 0 0 0 1 1h2v-2H3a1 1 0 0 0-1 1ZM19 3a1 1 0 0 0-2 0v2h2ZM2 18a1 1 0 0 0 1 1h2v-2H3a1 1 0 0 0-1 1ZM23 3a1 1 0 0 0-2 0v2h2Zm-8 0a1 1 0 0 0-2 0v2h2ZM2 14a1 1 0 0 0 1 1h2v-2H3a1 1 0 0 0-1 1Zm0-4a1 1 0 0 0 1 1h2V9H3a1 1 0 0 0-1 1Zm9-7a1 1 0 0 0-2 0v2h2Z"
        })
    });
var $ef489cbc6fde5b26$export$2e2bcd8739ae039 = $ef489cbc6fde5b26$var$SvgGlyphiconsBasic957Microchip;




const $59c632d15d02223a$var$SvgGlyphiconsBasic958FilterOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4.43 27.57a1.51 1.51 0 0 1-.43.084 1.5 1.5 0 0 1-1.06-2.56l9.605-9.606-7.292-8.204A1 1 0 0 1 5 6.62V5a1 1 0 0 1 1-1h18.033l1.06-1.06a1.5 1.5 0 0 1 2.122 0 1.483 1.483 0 0 1 .356 1.49 1.461 1.461 0 0 0-.632.355L4.785 26.94a1.463 1.463 0 0 0-.356.632ZM13 22.968v3.952a.5.5 0 0 0 .82.384l4.82-4.017a1 1 0 0 0 .36-.768v-5.551Z"
        })
    });
var $59c632d15d02223a$export$2e2bcd8739ae039 = $59c632d15d02223a$var$SvgGlyphiconsBasic958FilterOff;




const $9a4bde592fc506ed$var$SvgGlyphiconsBasic959BookLibrarySearch = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18 5a6.99 6.99 0 0 1 .078-.984C18.05 4.013 18.028 4 18 4h-5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8.586A6.946 6.946 0 0 1 18 5Zm-1 20.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-18a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm10.254 4.12a6.935 6.935 0 0 1-6.233-.869l2.942 16.69a1 1 0 0 0 1.159.81l4.924-.868a1 1 0 0 0 .81-1.158l-2.354-13.358Zm.967 14.054-1.97.348a.5.5 0 0 1-.579-.406l-.173-.985a.5.5 0 0 1 .405-.579l1.97-.347a.5.5 0 0 1 .58.405l.173.985a.5.5 0 0 1-.406.58ZM9 4H4a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM8 25.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm0-18a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5Zm23.622 2.583-2.411-2.41A4.99 4.99 0 1 0 25 10a4.957 4.957 0 0 0 2.673-.79l2.41 2.412a.5.5 0 0 0 .708 0l.83-.831a.5.5 0 0 0 0-.707ZM22 5a3 3 0 1 1 3 3 3.003 3.003 0 0 1-3-3Z"
        })
    });
var $9a4bde592fc506ed$export$2e2bcd8739ae039 = $9a4bde592fc506ed$var$SvgGlyphiconsBasic959BookLibrarySearch;




const $b733eed2ccfabd0f$var$SvgGlyphiconsBasic96VectorPathCircle = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 13h-1.549A11.547 11.547 0 0 0 19 5.549V4a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v1.549A11.547 11.547 0 0 0 4.549 13H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.549A11.547 11.547 0 0 0 12 27.451V29a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1.549A11.547 11.547 0 0 0 26.451 20H28a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM7 18H4v-3h3Zm7-13h3v3h-3Zm3 23h-3v-3h3Zm6-8h.237A8.542 8.542 0 0 1 19 24.237V24a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v.237A8.542 8.542 0 0 1 7.763 20H8a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-.237A8.542 8.542 0 0 1 12 8.763V9a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-.237A8.542 8.542 0 0 1 23.237 13H23a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Zm4-2h-3v-3h3Z"
        })
    });
var $b733eed2ccfabd0f$export$2e2bcd8739ae039 = $b733eed2ccfabd0f$var$SvgGlyphiconsBasic96VectorPathCircle;




const $06f9cec9b0dceb8c$var$SvgGlyphiconsBasic960FilesQueue = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M10 10V8a1 1 0 0 1 1-1h5v5.172l-1.586-1.586A2 2 0 0 0 13 10Zm14.414.585A2 2 0 0 1 25 12v7h2a1 1 0 0 0 1-1V9h-5.172ZM23.5 7H28l-5-5v4.5a.5.5 0 0 0 .5.5Zm-4.086-1.414L21 7.172V2h-5a1 1 0 0 0-1 1v2h3a2 2 0 0 1 1.414.586ZM18 11.5a.5.5 0 0 0 .5.5H23l-5-5Zm1.414 4.085A2 2 0 0 1 20 17v7h2a1 1 0 0 0 1-1v-9h-5.172ZM18 17l-5-5v4.5a.5.5 0 0 0 .5.5ZM6 12h5v6a1 1 0 0 0 1 1h6v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1Z"
        })
    });
var $06f9cec9b0dceb8c$export$2e2bcd8739ae039 = $06f9cec9b0dceb8c$var$SvgGlyphiconsBasic960FilesQueue;




const $9f039d6d917efb55$var$SvgGlyphiconsBasic961CloudOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27.215 5.06a1.5 1.5 0 0 0-2.121-2.12l-4.491 4.49A8.965 8.965 0 0 0 5.5 14c0 .265.013.532.038.8A5.938 5.938 0 0 0 2.5 20a5.034 5.034 0 0 0 .968 2.965 4.164 4.164 0 0 0 .782.818l-1.31 1.31a1.5 1.5 0 1 0 2.12 2.122ZM6.405 21.63a1.57 1.57 0 0 1-.49-.4A2.014 2.014 0 0 1 5.5 20a2.972 2.972 0 0 1 2.138-2.852l.898-.271a.5.5 0 0 0 .343-.593l-.214-.913a5.979 5.979 0 0 1 6.444-7.34 5.82 5.82 0 0 1 3.355 1.538ZM30.5 18a7.452 7.452 0 0 1-1.928 5 6.5 6.5 0 0 1-4.619 2H10.967l3-3h9.986a3.502 3.502 0 0 0 2.393-1.01A4.455 4.455 0 0 0 27.5 18a4.99 4.99 0 0 0-4.576-4.957l2.486-2.486A8.006 8.006 0 0 1 30.5 18Z"
        })
    });
var $9f039d6d917efb55$export$2e2bcd8739ae039 = $9f039d6d917efb55$var$SvgGlyphiconsBasic961CloudOff;




const $b5a6f4ad29e7e114$var$SvgGlyphiconsBasic962Trending = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 9v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2.172l-7.793 7.793a1 1 0 0 1-1.414 0L12 18.828l-4.879 4.879a1 1 0 0 1-1.414 0l-1.414-1.414a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0l3.793 3.793L22.172 12H20a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1Z"
        })
    });
var $b5a6f4ad29e7e114$export$2e2bcd8739ae039 = $b5a6f4ad29e7e114$var$SvgGlyphiconsBasic962Trending;




const $c794f770bf1853c4$var$SvgGlyphiconsBasic963Disappearing = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 15v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2.172L16.5 14.328l-3.793 3.793a1 1 0 0 1-1.414 0l-7-7a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0L12 13.172l3.793-3.793a1 1 0 0 1 1.414 0L25 17.172V15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Z"
        })
    });
var $c794f770bf1853c4$export$2e2bcd8739ae039 = $c794f770bf1853c4$var$SvgGlyphiconsBasic963Disappearing;




const $56259810bb96ade9$var$SvgGlyphiconsBasic964Layers = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 16a1.5 1.5 0 0 1-.804 1.33l-10.5 5.5a1.504 1.504 0 0 1-1.392 0l-10.5-5.5a1.5 1.5 0 0 1 0-2.66l.711-.372 3.233 1.694-.016.008 6.804 3.563a1 1 0 0 0 .928 0L23.268 16l-.016-.008 3.233-1.694.711.373A1.5 1.5 0 0 1 28 16Zm-.804 4.67-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 22l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658ZM4.804 11.33l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.66l-10.5-5.5a1.5 1.5 0 0 0-1.392 0l-10.5 5.5a1.5 1.5 0 0 0 0 2.66Z"
        })
    });
var $56259810bb96ade9$export$2e2bcd8739ae039 = $56259810bb96ade9$var$SvgGlyphiconsBasic964Layers;




const $25ed1b93b13b361f$var$SvgGlyphiconsBasic965LayersPlus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 22a1.5 1.5 0 0 1-.804 1.33l-10.5 5.5a1.504 1.504 0 0 1-1.392 0l-10.5-5.5a1.5 1.5 0 0 1 0-2.66l.711-.372 3.233 1.694-.016.008 6.804 3.563a1 1 0 0 0 .928 0L23.268 22l-.016-.008 3.233-1.694.711.373A1.5 1.5 0 0 1 28 22ZM4.804 11.33l10.5 5.5a1.504 1.504 0 0 0 1.392 0l6.434-3.371a7.946 7.946 0 0 1-4.865-9.466l-1.569-.822a1.5 1.5 0 0 0-1.392 0l-10.5 5.5a1.5 1.5 0 0 0 0 2.658Zm22.392 3.34-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 16l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V5h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H25v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V7h1.5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $25ed1b93b13b361f$export$2e2bcd8739ae039 = $25ed1b93b13b361f$var$SvgGlyphiconsBasic965LayersPlus;




const $4d75775530d72a71$var$SvgGlyphiconsBasic966LayersMinus = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 10a1.5 1.5 0 0 1 .804-1.33l10.5-5.5a1.5 1.5 0 0 1 1.392 0l1.57.823a7.946 7.946 0 0 0 4.864 9.466l-6.434 3.37a1.504 1.504 0 0 1-1.392 0l-10.5-5.5A1.5 1.5 0 0 1 4 10Zm23.196 4.67-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 16l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658Zm0 6-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 22l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3-.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5Z"
        })
    });
var $4d75775530d72a71$export$2e2bcd8739ae039 = $4d75775530d72a71$var$SvgGlyphiconsBasic966LayersMinus;




const $9fef1567a601050b$var$SvgGlyphiconsBasic967LayersLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 10a1.5 1.5 0 0 1 .804-1.33l10.5-5.5a1.5 1.5 0 0 1 1.392 0l2.369 1.242A2.977 2.977 0 0 0 19 5v6a3.003 3.003 0 0 0 3 3h.097l-5.4 2.83a1.504 1.504 0 0 1-1.393 0l-10.5-5.5A1.5 1.5 0 0 1 4 10Zm23.196 10.67-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 22l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658Zm0-6-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 16l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658ZM32 5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-7-1h3V2.25a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
        })
    });
var $9fef1567a601050b$export$2e2bcd8739ae039 = $9fef1567a601050b$var$SvgGlyphiconsBasic967LayersLock;




const $2812c1bfa0e9bef4$var$SvgGlyphiconsBasic968LayersDown = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 10a1.5 1.5 0 0 1 .804-1.33l10.5-5.5a1.5 1.5 0 0 1 1.392 0l1.57.823a7.946 7.946 0 0 0 4.864 9.466l-6.434 3.37a1.504 1.504 0 0 1-1.392 0l-10.5-5.5A1.5 1.5 0 0 1 4 10Zm23.196 4.67-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 16l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658Zm0 6-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 22l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3.852 0H27V3.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V6h-1.148a.5.5 0 0 0-.378.827l2.148 2.48a.5.5 0 0 0 .756 0l2.148-2.48A.5.5 0 0 0 28.148 6Z"
        })
    });
var $2812c1bfa0e9bef4$export$2e2bcd8739ae039 = $2812c1bfa0e9bef4$var$SvgGlyphiconsBasic968LayersDown;




const $1c2399e4e53552eb$var$SvgGlyphiconsBasic969LayersUp = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 10a1.5 1.5 0 0 1 .804-1.33l10.5-5.5a1.5 1.5 0 0 1 1.392 0l1.57.823a7.946 7.946 0 0 0 4.864 9.466l-6.434 3.37a1.504 1.504 0 0 1-1.392 0l-10.5-5.5A1.5 1.5 0 0 1 4 10Zm23.196 4.67-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 16l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658Zm0 6-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 22l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658ZM32 6a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-3.474-.827-2.148-2.48a.5.5 0 0 0-.756 0l-2.148 2.48a.5.5 0 0 0 .378.827H25v2.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V6h1.148a.5.5 0 0 0 .378-.827Z"
        })
    });
var $1c2399e4e53552eb$export$2e2bcd8739ae039 = $1c2399e4e53552eb$var$SvgGlyphiconsBasic969LayersUp;




const $49605780bd923541$var$SvgGlyphiconsBasic97VectorPathPentagon = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M29 11h-4.762L19 7.19V4a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v3.38L7.474 11H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2.086l1.682 5.047A.986.986 0 0 0 6 24v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1h6v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a.986.986 0 0 0-.768-.953L26.915 18H29a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM7 16H4v-3h3Zm7-11h3v3h-3Zm-3 23H8v-3h3Zm8-4v1h-6v-1a1 1 0 0 0-1-1H9.914l-1.682-5.047A.986.986 0 0 0 9 17v-3.379L13.526 10h4.236L23 13.81V17a.986.986 0 0 0 .768.953L22.086 23H20a1 1 0 0 0-1 1Zm5 4h-3v-3h3Zm4-12h-3v-3h3Z"
        })
    });
var $49605780bd923541$export$2e2bcd8739ae039 = $49605780bd923541$var$SvgGlyphiconsBasic97VectorPathPentagon;




const $54ea854ec9451fa9$var$SvgGlyphiconsBasic970LayersCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4 10a1.5 1.5 0 0 1 .804-1.33l10.5-5.5a1.5 1.5 0 0 1 1.392 0l2.023 1.06a7.467 7.467 0 0 0 5.007 8.917l-7.03 3.682a1.504 1.504 0 0 1-1.392 0l-10.5-5.5A1.5 1.5 0 0 1 4 10Zm23.196 4.67-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 16l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658Zm0 6-.711-.372-3.233 1.694.016.008-6.804 3.563a1 1 0 0 1-.928 0L8.732 22l.016-.008-3.233-1.694-.711.373a1.5 1.5 0 0 0 0 2.658l10.5 5.5a1.504 1.504 0 0 0 1.392 0l10.5-5.5a1.5 1.5 0 0 0 0-2.658Zm4.131-13.846-1.156.29a4.523 4.523 0 0 1-.43 1.04l.617 1.028a.504.504 0 0 1-.046.586 5.854 5.854 0 0 1-.539.542.497.497 0 0 1-.582.043l-1.03-.62a4.417 4.417 0 0 1-1.042.432l-.29 1.156a.498.498 0 0 1-.471.38c-.225.005-.494.004-.716 0a.497.497 0 0 1-.47-.38l-.29-1.156a4.404 4.404 0 0 1-1.04-.43l-1.03.617a.504.504 0 0 1-.586-.047 5.815 5.815 0 0 1-.541-.54.497.497 0 0 1-.043-.58l.619-1.032a4.347 4.347 0 0 1-.429-1.04l-1.157-.289a.498.498 0 0 1-.38-.472 15.948 15.948 0 0 1 .001-.715.497.497 0 0 1 .379-.47l1.157-.29a4.361 4.361 0 0 1 .43-1.041l-.618-1.03a.503.503 0 0 1 .047-.587 5.804 5.804 0 0 1 .54-.54.497.497 0 0 1 .58-.042l1.032.618a4.348 4.348 0 0 1 1.04-.429l.29-1.157a.498.498 0 0 1 .471-.38c.225-.004.494-.004.715.001a.497.497 0 0 1 .47.38l.29 1.156a4.324 4.324 0 0 1 1.04.429l1.029-.617a.504.504 0 0 1 .586.046 5.854 5.854 0 0 1 .542.539.497.497 0 0 1 .043.582l-.619 1.031a4.414 4.414 0 0 1 .43 1.041l1.157.29a.498.498 0 0 1 .38.471c.005.225.004.494-.001.716a.497.497 0 0 1-.379.47Zm-3.179-.83A2.147 2.147 0 1 0 26 8.143a2.15 2.15 0 0 0 2.148-2.149Z"
        })
    });
var $54ea854ec9451fa9$export$2e2bcd8739ae039 = $54ea854ec9451fa9$var$SvgGlyphiconsBasic970LayersCogwheel;




const $9089eaccac1703f4$var$SvgGlyphiconsBasic971AxesThreeDimensional = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 21v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1.825L15.5 18.886 9.175 25H11a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.93l7-6.766V9.12l-1.293 1.293a1 1 0 0 1-1.414 0l-.707-.707a1 1 0 0 1 0-1.414l4.207-4.207a1 1 0 0 1 1.414 0l4.207 4.207a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414 0L17 9.121v7.043l7 6.766V21a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z"
        })
    });
var $9089eaccac1703f4$export$2e2bcd8739ae039 = $9089eaccac1703f4$var$SvgGlyphiconsBasic971AxesThreeDimensional;




const $cae790c97da8a0d3$var$SvgGlyphiconsBasic972AxesTwoDimensional = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.914 25.207-4.207 4.207a1 1 0 0 1-1.414 0l-.707-.707a1 1 0 0 1 0-1.414L22.879 26H7.5A1.5 1.5 0 0 1 6 24.5V9.121l-1.293 1.293a1 1 0 0 1-1.414 0l-.707-.707a1 1 0 0 1 0-1.414l4.207-4.207a1 1 0 0 1 1.414 0l4.207 4.207a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414 0L9 9.121V23h13.879l-1.293-1.293a1 1 0 0 1 0-1.414l.707-.707a1 1 0 0 1 1.414 0l4.207 4.207a1 1 0 0 1 0 1.414Z"
        })
    });
var $cae790c97da8a0d3$export$2e2bcd8739ae039 = $cae790c97da8a0d3$var$SvgGlyphiconsBasic972AxesTwoDimensional;




const $0c47f9c1d236dc6b$var$SvgGlyphiconsBasic973Rulers = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 5v5a1 1 0 0 1-1 1H11v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4v-2h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4v-2h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4v-2h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4v-2h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H4V6h1.5a.5.5 0 0 0 .5-.5V4h2v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4h2v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4h2v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4h2v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4h2v1.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4h1a1 1 0 0 1 1 1Z"
        })
    });
var $0c47f9c1d236dc6b$export$2e2bcd8739ae039 = $0c47f9c1d236dc6b$var$SvgGlyphiconsBasic973Rulers;




const $1480103c9cc209c2$var$SvgGlyphiconsBasic974SpellCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4.663 17.87a1.002 1.002 0 0 0 1.277-.606l.478-1.336h2.09l.477 1.336a.999.999 0 0 0 .942.664.986.986 0 0 0 .336-.059.998.998 0 0 0 .605-1.277l-2.464-6.9a1 1 0 0 0-1.883 0l-2.463 6.9a.998.998 0 0 0 .605 1.277Zm3.13-3.942h-.661l.33-.927Zm6.17 4h2.5a2.502 2.502 0 0 0 2.5-2.5v-1a2.486 2.486 0 0 0-.805-1.827 2.468 2.468 0 0 0 .306-1.173 2.502 2.502 0 0 0-2.5-2.5h-2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1Zm3-2.5a.501.501 0 0 1-.5.5h-1.5v-2h1.5a.501.501 0 0 1 .5.5Zm-2-4.5h1a.5.5 0 0 1 0 1h-1Zm6 4v-3a3.003 3.003 0 0 1 3-3h2a1 1 0 0 1 0 2h-2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 1 0 2h-2a3.003 3.003 0 0 1-3-3Zm6.768 8.34a1 1 0 0 1-1.413.05 5.431 5.431 0 0 1-.614-.714c-.385-.508-.498-.604-.715-.604-.21 0-.321.096-.7.6a2.797 2.797 0 0 1-2.3 1.4 2.798 2.798 0 0 1-2.3-1.4c-.378-.504-.49-.6-.7-.6s-.321.096-.7.6a2.797 2.797 0 0 1-2.3 1.4 2.795 2.795 0 0 1-2.298-1.4c-.377-.504-.488-.6-.697-.6-.21 0-.321.096-.7.6a2.797 2.797 0 0 1-2.3 1.4 2.797 2.797 0 0 1-2.3-1.4c-.379-.504-.489-.6-.699-.6-.215 0-.327.096-.71.602a5.515 5.515 0 0 1-.598.699 1 1 0 0 1-1.375-1.453 3.487 3.487 0 0 0 .377-.453A2.814 2.814 0 0 1 6.995 20a2.798 2.798 0 0 1 2.299 1.4c.379.504.49.6.7.6s.321-.096.7-.6a2.797 2.797 0 0 1 2.3-1.4 2.795 2.795 0 0 1 2.299 1.4c.377.505.487.6.696.6.21 0 .322-.096.7-.6a2.797 2.797 0 0 1 2.3-1.4 2.797 2.797 0 0 1 2.3 1.4c.379.504.49.6.7.6.21 0 .322-.096.7-.6a2.796 2.796 0 0 1 2.3-1.4 2.82 2.82 0 0 1 2.309 1.395 3.523 3.523 0 0 0 .384.46 1 1 0 0 1 .05 1.413Z"
        })
    });
var $1480103c9cc209c2$export$2e2bcd8739ae039 = $1480103c9cc209c2$var$SvgGlyphiconsBasic974SpellCheck;




const $0147cd51a7b1a8bf$var$SvgGlyphiconsBasic975SpellCheckCheck = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M4.663 17.87a1.002 1.002 0 0 0 1.277-.606l.478-1.336h2.09l.477 1.336a.999.999 0 0 0 .942.664.986.986 0 0 0 .336-.059.998.998 0 0 0 .605-1.277l-2.464-6.9a1 1 0 0 0-1.883 0l-2.463 6.9a.998.998 0 0 0 .605 1.277ZM7.463 13l.33.927h-.661Zm13.5 1.927v-2.72a7.998 7.998 0 0 0 2 1.19v1.53a1 1 0 0 0 1 1h2a1 1 0 0 1 0 2h-2a3.003 3.003 0 0 1-3-3Zm-7 3h2.5a2.502 2.502 0 0 0 2.5-2.5v-1a2.486 2.486 0 0 0-.805-1.827 2.468 2.468 0 0 0 .306-1.173 2.502 2.502 0 0 0-2.5-2.5h-2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1Zm1-7h1a.5.5 0 0 1 0 1h-1Zm0 3h1.5a.501.501 0 0 1 .5.5v1a.501.501 0 0 1-.5.5h-1.5Zm12.719 7.927a1 1 0 1 1-1.364 1.462 5.431 5.431 0 0 1-.614-.713c-.385-.508-.498-.604-.715-.604-.21 0-.321.096-.7.6a2.797 2.797 0 0 1-2.3 1.4 2.798 2.798 0 0 1-2.3-1.4c-.378-.504-.49-.6-.7-.6s-.321.096-.7.6a2.797 2.797 0 0 1-2.3 1.4 2.795 2.795 0 0 1-2.298-1.4c-.377-.504-.488-.6-.697-.6-.21 0-.321.096-.7.6a2.797 2.797 0 0 1-2.3 1.4 2.797 2.797 0 0 1-2.3-1.4c-.379-.504-.489-.6-.699-.6-.215 0-.327.096-.71.602a5.515 5.515 0 0 1-.598.699 1 1 0 0 1-1.375-1.453 3.487 3.487 0 0 0 .377-.453A2.814 2.814 0 0 1 6.995 20a2.798 2.798 0 0 1 2.299 1.4c.379.504.49.6.7.6s.321-.096.7-.6a2.797 2.797 0 0 1 2.3-1.4 2.795 2.795 0 0 1 2.299 1.4c.377.505.487.6.696.6.21 0 .322-.096.7-.6a2.797 2.797 0 0 1 2.3-1.4 2.797 2.797 0 0 1 2.3 1.4c.379.504.49.6.7.6.21 0 .322-.096.7-.6a2.796 2.796 0 0 1 2.3-1.4 2.82 2.82 0 0 1 2.309 1.395 3.523 3.523 0 0 0 .384.46ZM26 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm3.2 4.118-3.11 4.575a.83.83 0 0 1-1.297.1L22.56 6.557a.297.297 0 0 1-.027-.377l.433-.555a.323.323 0 0 1 .377-.095l1.766.845 3.15-2.96a.297.297 0 0 1 .377-.027l.512.378a.254.254 0 0 1 .052.352Z"
        })
    });
var $0147cd51a7b1a8bf$export$2e2bcd8739ae039 = $0147cd51a7b1a8bf$var$SvgGlyphiconsBasic975SpellCheckCheck;




const $41d26e23e984c31a$var$SvgGlyphiconsBasic976GlobeData = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4.006a1.032 1.032 0 0 0-.69.182A.89.89 0 0 0 15 5v9.5a.5.5 0 0 1-.5.5H5a.957.957 0 0 0-.78.255.994.994 0 0 0-.215.745 12.144 12.144 0 0 0 14.106 11.813 12.06 12.06 0 0 0 9.693-9.655C29.166 10.628 23.224 4.234 16 4.006ZM6.84 20a9.909 9.909 0 0 1-.79-3h2.977a17.33 17.33 0 0 0 .372 3Zm1.18 2h1.995a9.932 9.932 0 0 0 2.127 3.224A10.045 10.045 0 0 1 8.019 22ZM15 25.06A9.087 9.087 0 0 1 12.195 22H15ZM15 20h-3.565a14.638 14.638 0 0 1-.412-3H15Zm8.98-10h-1.995a9.933 9.933 0 0 0-2.128-3.224A10.044 10.044 0 0 1 23.981 10ZM17 6.94A9.089 9.089 0 0 1 19.805 10H17ZM17 12h3.565a14.637 14.637 0 0 1 .412 3H17Zm0 5h3.977a14.637 14.637 0 0 1-.412 3H17Zm0 8.06V22h2.805A9.089 9.089 0 0 1 17 25.06Zm2.857.164A9.933 9.933 0 0 0 21.985 22h1.996a10.044 10.044 0 0 1-4.124 3.224ZM25.16 20h-2.558a17.324 17.324 0 0 0 .372-3h2.976a9.909 9.909 0 0 1-.79 3Zm-2.186-5a17.324 17.324 0 0 0-.372-3h2.558a9.909 9.909 0 0 1 .79 3ZM6 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5Zm4-4a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5ZM5.5 9h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5ZM7 4.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5ZM3.5 4h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5Zm9.5 7.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $41d26e23e984c31a$export$2e2bcd8739ae039 = $41d26e23e984c31a$var$SvgGlyphiconsBasic976GlobeData;




const $b3c4602958c1ebbd$var$SvgGlyphiconsBasic977MapSatellite = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m22.839 17.94 1.414 1.414a.5.5 0 0 1 0 .707l-2.828 2.828a.5.5 0 0 1-.707 0l-1.415-1.414a.5.5 0 0 1 0-.707l2.829-2.829a.5.5 0 0 1 .707 0Zm-5.596-6.425-4.657 4.657a.992.992 0 0 0-.288.68 5.763 5.763 0 0 1 3.85 3.85.992.992 0 0 0 .68-.288l4.657-4.657a1 1 0 0 0 0-1.414l-2.828-2.828a1 1 0 0 0-1.414 0Zm-9.229 8.57 4.9 4.9a.49.49 0 0 0 .731-.023 4 4 0 0 0-5.607-5.608.491.491 0 0 0-.024.731Zm4.218-6.388 2.829-2.829a.5.5 0 0 0 0-.707l-1.415-1.414a.5.5 0 0 0-.707 0l-2.828 2.828a.5.5 0 0 0 0 .707l1.414 1.415a.5.5 0 0 0 .707 0Zm13.849-1.881C25.379 11.039 22 7.5 22 4.5a4.5 4.5 0 0 1 9 0c0 3-3.38 6.539-4.08 7.316a.569.569 0 0 1-.84 0ZM26.5 7A2.5 2.5 0 1 0 24 4.5 2.5 2.5 0 0 0 26.5 7Zm0 7a2.619 2.619 0 0 1-.5-.051L26.003 26H6V6h14.183A6.72 6.72 0 0 1 20 4.5c0-.169.013-.334.025-.5H6a2.003 2.003 0 0 0-2 2v20a2.003 2.003 0 0 0 2 2h20a2.003 2.003 0 0 0 2-2V13.519a2.536 2.536 0 0 1-1.5.481Z"
        })
    });
var $b3c4602958c1ebbd$export$2e2bcd8739ae039 = $b3c4602958c1ebbd$var$SvgGlyphiconsBasic977MapSatellite;




const $780c15c337722e3a$var$SvgGlyphiconsBasic978MapCadastral = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21.679 18.714a.715.715 0 0 0-.715-.714 1.202 1.202 0 0 0-.95.502 1 1 0 1 1-1.529-1.29A3.169 3.169 0 0 1 20.964 16a2.718 2.718 0 0 1 2.715 2.714c0 1.81-1.791 2.447-2.38 2.657a1.359 1.359 0 0 0-.748.629H23a1 1 0 0 1 0 2h-3.679a1 1 0 0 1-.999-.947 3.615 3.615 0 0 1 2.306-3.567c1.05-.373 1.05-.653 1.05-.772ZM11 16a1 1 0 0 0 1-1V9a1 1 0 0 0-1.707-.707l-2 2a1 1 0 0 0 1.414 1.414l.293-.293V15a1 1 0 0 0 1 1Zm15.08-4.184C25.38 11.039 22 7.5 22 4.5a4.5 4.5 0 0 1 9 0c0 3-3.38 6.539-4.08 7.316a.569.569 0 0 1-.84 0ZM26.5 7A2.5 2.5 0 1 0 24 4.5 2.5 2.5 0 0 0 26.5 7Zm0 7a2.536 2.536 0 0 0 1.5-.481V26a2.003 2.003 0 0 1-2 2H6a2.003 2.003 0 0 1-2-2V6a2.003 2.003 0 0 1 2-2h14.025a6.507 6.507 0 0 0-.025.5 6.72 6.72 0 0 0 .183 1.5H6v10.586l3.5 3.5L21.121 8.465a16.531 16.531 0 0 0 1.072 1.756L10.914 21.5l4.5 4.5h10.588l-.001-12.051A2.619 2.619 0 0 0 26.5 14ZM12.586 26 6 19.414V26Z"
        })
    });
var $780c15c337722e3a$export$2e2bcd8739ae039 = $780c15c337722e3a$var$SvgGlyphiconsBasic978MapCadastral;




const $8697c5b9253bfab4$var$SvgGlyphiconsBasic979MapAerial = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M26.08 11.816C25.38 11.039 22 7.5 22 4.5a4.5 4.5 0 0 1 9 0c0 3-3.38 6.539-4.08 7.316a.569.569 0 0 1-.84 0ZM26.5 7A2.5 2.5 0 1 0 24 4.5 2.5 2.5 0 0 0 26.5 7Zm-3.96 7.852a.5.5 0 0 0 .408-.143l.722-.722a.5.5 0 0 0-.156-.813l-3.281-1.407-1.407-3.28a.5.5 0 0 0-.813-.157l-.722.722a.5.5 0 0 0-.143.409l.348 3.13-2.742 1.958-2.001-4.676a1 1 0 0 0-1.626-.313l-.737.736a1 1 0 0 0-.287.818l.797 7.158-1.557 1.556a2 2 0 0 0 2.829 2.829l1.556-1.557 7.158.796a1 1 0 0 0 .818-.286l.736-.737a1 1 0 0 0-.313-1.626l-4.676-2.001 1.958-2.742ZM26.5 14a2.619 2.619 0 0 1-.5-.051L26.003 26H6V6h14.183A6.72 6.72 0 0 1 20 4.5c0-.169.013-.334.025-.5H6a2.003 2.003 0 0 0-2 2v20a2.003 2.003 0 0 0 2 2h20a2.003 2.003 0 0 0 2-2V13.519a2.536 2.536 0 0 1-1.5.481Z"
        })
    });
var $8697c5b9253bfab4$export$2e2bcd8739ae039 = $8697c5b9253bfab4$var$SvgGlyphiconsBasic979MapAerial;




const $cfc15205092cbf00$var$SvgGlyphiconsBasic98VectorPathLine = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 3h-5a1 1 0 0 0-1 1v3.879L7.879 22H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3.879L24.121 10H28a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM8 27H5v-3h3ZM27 8h-3V5h3Z"
        })
    });
var $cfc15205092cbf00$export$2e2bcd8739ae039 = $cfc15205092cbf00$var$SvgGlyphiconsBasic98VectorPathLine;




const $6fa5a978d1016925$var$SvgGlyphiconsBasic980MapTourist = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 18v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0Zm6.5 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Zm10.58-10.184C25.38 11.039 22 7.5 22 4.5a4.5 4.5 0 0 1 9 0c0 3-3.38 6.539-4.08 7.316a.569.569 0 0 1-.84 0ZM26.5 7A2.5 2.5 0 1 0 24 4.5 2.5 2.5 0 0 0 26.5 7ZM12.707 8.293a1 1 0 0 0-1.414 0l-.793.793-.793-.793a1 1 0 0 0-1.414 1.414l.793.793-.793.793a1 1 0 1 0 1.414 1.414l.793-.793.793.793a1 1 0 0 0 1.414-1.414l-.793-.793.793-.793a1 1 0 0 0 0-1.414ZM21.5 24h.5a2 2 0 0 0 2-2v-.5a1 1 0 0 0-2 0v.5h-.5a1 1 0 0 0 0 2Zm0-6h.5v.5a1 1 0 0 0 2 0V18a2 2 0 0 0-2-2h-.5a1 1 0 0 0 0 2Zm-3-10H18a2 2 0 0 0-2 2v.5a1 1 0 0 0 2 0V10h.5a1 1 0 0 0 0-2ZM9 22a2 2 0 0 0 2 2h.5a1 1 0 0 0 0-2H11v-.5a1 1 0 0 0-2 0Zm10.5-6a1 1 0 0 0-1-1H18v-1a1 1 0 0 0-2 0v1a2 2 0 0 0 2 2h.5a1 1 0 0 0 1-1Zm7-2a2.619 2.619 0 0 1-.5-.051L26.003 26H6V6h14.183A6.72 6.72 0 0 1 20 4.5c0-.169.013-.334.025-.5H6a2.003 2.003 0 0 0-2 2v20a2.003 2.003 0 0 0 2 2h20a2.003 2.003 0 0 0 2-2V13.519a2.536 2.536 0 0 1-1.5.481Z"
        })
    });
var $6fa5a978d1016925$export$2e2bcd8739ae039 = $6fa5a978d1016925$var$SvgGlyphiconsBasic980MapTourist;




const $86e851d54a31173d$var$SvgGlyphiconsBasic981Cookie = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M16 4a12 12 0 1 0 12 12A12 12 0 0 0 16 4Zm4 4a1 1 0 1 1-1 1 1 1 0 0 1 1-1ZM8 12.5A1.5 1.5 0 1 1 9.5 14 1.5 1.5 0 0 1 8 12.5Zm4 8.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm4 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm1.5-10a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm3 6a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm3.5-5a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
        })
    });
var $86e851d54a31173d$export$2e2bcd8739ae039 = $86e851d54a31173d$var$SvgGlyphiconsBasic981Cookie;




const $547c84e2dbfa9d64$var$SvgGlyphiconsBasic982CookieAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M23 8.5A1.5 1.5 0 1 1 21.5 7 1.5 1.5 0 0 1 23 8.5Zm4-.5a1 1 0 1 0 1 1 1 1 0 0 0-1-1Zm-2-4a1 1 0 1 0 1 1 1 1 0 0 0-1-1Zm3 12A12 12 0 1 1 12.151 4.642a1.5 1.5 0 0 1 1.933 1.068 2.998 2.998 0 0 0 2.646 2.278 1.5 1.5 0 0 1 1.337 1.2A3.51 3.51 0 0 0 21.5 12a3.444 3.444 0 0 0 1.71-.458 1.5 1.5 0 0 1 1.623.084A1.981 1.981 0 0 0 26 12l.124-.003a1.504 1.504 0 0 1 1.524 1.137A11.896 11.896 0 0 1 28 16ZM9.5 14A1.5 1.5 0 1 0 8 12.5 1.5 1.5 0 0 0 9.5 14Zm4.5 5a2 2 0 1 0-2 2 2 2 0 0 0 2-2Zm3 5a1 1 0 1 0-1 1 1 1 0 0 0 1-1Zm2-10.5a1.5 1.5 0 1 0-1.5 1.5 1.5 1.5 0 0 0 1.5-1.5Zm3 6a1.5 1.5 0 1 0-1.5 1.5 1.5 1.5 0 0 0 1.5-1.5Zm3-4.5a1 1 0 1 0-1 1 1 1 0 0 0 1-1Z"
        })
    });
var $547c84e2dbfa9d64$export$2e2bcd8739ae039 = $547c84e2dbfa9d64$var$SvgGlyphiconsBasic982CookieAlt;




const $7ab8851a4658acf9$var$SvgGlyphiconsBasic983Cookies = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M12.5 10a8.5 8.5 0 1 0 8.5 8.5 8.5 8.5 0 0 0-8.5-8.5Zm-4 11a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 8.5 21Zm1.5-6a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm3 10a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm2.5-4a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm1.5-5a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm1.5-12a9.49 9.49 0 0 0-7.868 4.176 10.47 10.47 0 0 1 11.683 14.02A9.498 9.498 0 0 0 18.5 4Zm3 6A1.5 1.5 0 1 1 23 8.5a1.5 1.5 0 0 1-1.5 1.5Zm3.5 6a1 1 0 1 1 1-1 1 1 0 0 1-1 1Z"
        })
    });
var $7ab8851a4658acf9$export$2e2bcd8739ae039 = $7ab8851a4658acf9$var$SvgGlyphiconsBasic983Cookies;




const $549227679c7f8ab4$var$SvgGlyphiconsBasic984CashRegister = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M27 16.472a2 2 0 0 0-.211-.894l-1.513-3.025a1 1 0 0 0-.894-.553H22v-2h3a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H14.986a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1H18v2H7.618a1 1 0 0 0-.894.553L5.21 15.578a2 2 0 0 0-.211.894V20h22ZM15.986 6H24v2h-8.014ZM27 22H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-10 3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $549227679c7f8ab4$export$2e2bcd8739ae039 = $549227679c7f8ab4$var$SvgGlyphiconsBasic984CashRegister;




const $fa4b26494309ed70$var$SvgGlyphiconsBasic985CashRegisterAlt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m27.276 19.553-1-2a1 1 0 0 0-.894-.553H18v-2h5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h5v2H6.618a1 1 0 0 0-.894.553l-1 2a.986.986 0 0 0-.101.447h22.754a.986.986 0 0 0-.1-.447ZM10 13V6h12v7Zm17 9H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-10 3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5Z"
        })
    });
var $fa4b26494309ed70$export$2e2bcd8739ae039 = $fa4b26494309ed70$var$SvgGlyphiconsBasic985CashRegisterAlt;




const $64f94a611db138b3$var$SvgGlyphiconsBasic986HardDriveNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 22H8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Zm0 3.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5ZM26 14v6.556A3.954 3.954 0 0 0 24 20H8a3.954 3.954 0 0 0-2 .556V7a3 3 0 0 1 3-3h9.263A7.968 7.968 0 0 0 26 14Zm0-14a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm0 10a4.005 4.005 0 0 1-4-4 3.954 3.954 0 0 1 .567-2.019l5.452 5.452A3.955 3.955 0 0 1 26 10Zm3.433-1.981-5.452-5.452A3.955 3.955 0 0 1 26 2a4.005 4.005 0 0 1 4 4 3.954 3.954 0 0 1-.567 2.019Z"
        })
    });
var $64f94a611db138b3$export$2e2bcd8739ae039 = $64f94a611db138b3$var$SvgGlyphiconsBasic986HardDriveNo;




const $0036e3a323a8da06$var$SvgGlyphiconsBasic987SwitchOff = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M21 7H11a9 9 0 0 0 0 18h10a9 9 0 0 0 0-18Zm0 15H11a6 6 0 0 1 0-12h10a6 6 0 0 1 0 12Zm-6-6a4 4 0 1 1-4-4 4.004 4.004 0 0 1 4 4Z"
        })
    });
var $0036e3a323a8da06$export$2e2bcd8739ae039 = $0036e3a323a8da06$var$SvgGlyphiconsBasic987SwitchOff;




const $993cfdfb04fbdf90$var$SvgGlyphiconsBasic988SwitchOn = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M25 16a4 4 0 1 1-4-4 4.004 4.004 0 0 1 4 4Zm5 0a9.01 9.01 0 0 1-9 9H11a9 9 0 0 1 0-18h10a9.01 9.01 0 0 1 9 9Zm-3 0a6 6 0 1 0-6 6 6.007 6.007 0 0 0 6-6Z"
        })
    });
var $993cfdfb04fbdf90$export$2e2bcd8739ae039 = $993cfdfb04fbdf90$var$SvgGlyphiconsBasic988SwitchOn;




const $6e8234614bac513c$var$SvgGlyphiconsBasic989Receipt = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M11 9.5v-1a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5ZM14.5 20h-3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm-3-6h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5Zm9.5 2.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5ZM24 28a1 1 0 0 1-.555-.168l-2.391-1.595-1.929 1.544a1.004 1.004 0 0 1-1.25 0L16 26.281l-1.875 1.5a1.004 1.004 0 0 1-1.25 0l-1.929-1.544-2.391 1.595A1 1 0 0 1 7 27V6a2.003 2.003 0 0 1 2-2h14a2.003 2.003 0 0 1 2 2v21a1 1 0 0 1-1 1Zm-8-4a1.003 1.003 0 0 1 .625.219l1.875 1.5 1.875-1.5a1 1 0 0 1 1.18-.051l1.445.964V6H9v19.132l1.445-.964a1 1 0 0 1 1.18.05L13.5 25.72l1.875-1.501A1.003 1.003 0 0 1 16 24Z"
        })
    });
var $6e8234614bac513c$export$2e2bcd8739ae039 = $6e8234614bac513c$var$SvgGlyphiconsBasic989Receipt;




const $e6168fd55fa37abe$var$SvgGlyphiconsBasic99VectorPathCurve = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M28 3h-5a1 1 0 0 0-1 1v1.329a20.977 20.977 0 0 0-11.06 5.61A20.981 20.981 0 0 0 5.328 22H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-.62a17.78 17.78 0 0 1 4.68-8.94A17.784 17.784 0 0 1 22 8.38V9a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM8 27H5v-3h3ZM27 8h-3V5h3Z"
        })
    });
var $e6168fd55fa37abe$export$2e2bcd8739ae039 = $e6168fd55fa37abe$var$SvgGlyphiconsBasic99VectorPathCurve;




const $e6a3d01a45355165$var$SvgGlyphiconsBasic990Invoice = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M9 9.5v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5Zm0 4v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5Zm0 4v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5Zm0 4v-1a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5Zm8-5a2.503 2.503 0 0 1 2-2.45v-.55a1 1 0 0 1 2 0v.5a1 1 0 0 1 0 2h-1.5a.5.5 0 0 0 0 1h.5a2.498 2.498 0 0 1 1 4.788v.712a1 1 0 0 1-2 0V22h-.5a1 1 0 0 1 0-2H20a.5.5 0 0 0 0-1h-.5a2.502 2.502 0 0 1-2.5-2.5ZM25 28H7a2.003 2.003 0 0 1-2-2V6a2.003 2.003 0 0 1 2-2h18a2.003 2.003 0 0 1 2 2v20a2.003 2.003 0 0 1-2 2ZM7 6v20h18.002L25 6Z"
        })
    });
var $e6a3d01a45355165$export$2e2bcd8739ae039 = $e6a3d01a45355165$var$SvgGlyphiconsBasic990Invoice;




const $96edf2f90ddaf8b3$var$SvgGlyphiconsBasic991UsbDevice = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24 13h-1V5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v8H8a1 1 0 0 0-1 1v11a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3V14a1 1 0 0 0-1-1ZM11 6h10v7H11Zm2 2h2v2h-2Zm6 0v2h-2V8Z"
        })
    });
var $96edf2f90ddaf8b3$export$2e2bcd8739ae039 = $96edf2f90ddaf8b3$var$SvgGlyphiconsBasic991UsbDevice;




const $4f489c28aa9adb2b$var$SvgGlyphiconsBasic992UsbDeviceLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 14h3v11a3.003 3.003 0 0 1-3 3H10a3.003 3.003 0 0 1-3-3V14a1 1 0 0 1 1-1h1V5a1 1 0 0 1 1-1h9.176A2.976 2.976 0 0 0 19 5v1h-8v7h8.78A2.982 2.982 0 0 0 22 14Zm-7-4V8h-2v2Zm2 0h2V8h-2Zm15-5v6a1.003 1.003 0 0 1-1 1h-9a1.003 1.003 0 0 1-1-1V5a1.003 1.003 0 0 1 1-1h1V2a2.003 2.003 0 0 1 2-2h3a2.003 2.003 0 0 1 2 2v2h1a1.003 1.003 0 0 1 1 1Zm-7-1h3V2.25a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
        })
    });
var $4f489c28aa9adb2b$export$2e2bcd8739ae039 = $4f489c28aa9adb2b$var$SvgGlyphiconsBasic992UsbDeviceLock;




const $e43e201af8d60786$var$SvgGlyphiconsBasic993UsbDeviceNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M18.263 8A7.94 7.94 0 0 0 19 9.864V10h-2V8ZM21 12.235V13H11V6h7a7.96 7.96 0 0 1 .263-2H10a1 1 0 0 0-1 1v8H8a1 1 0 0 0-1 1v11a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3V14c0-.025-.013-.047-.014-.072A7.956 7.956 0 0 1 21 12.235ZM15 10V8h-2v2Zm17-4a6 6 0 1 1-6-6 6 6 0 0 1 6 6Zm-6 4a3.955 3.955 0 0 0 2.02-.567l-5.453-5.452A3.954 3.954 0 0 0 22 6a4.005 4.005 0 0 0 4 4Zm4-4a4.005 4.005 0 0 0-4-4 3.955 3.955 0 0 0-2.02.567l5.453 5.452A3.954 3.954 0 0 0 30 6Z"
        })
    });
var $e43e201af8d60786$export$2e2bcd8739ae039 = $e43e201af8d60786$var$SvgGlyphiconsBasic993UsbDeviceNo;




const $3cf07fbef24487f8$var$SvgGlyphiconsBasic994UsbDeviceCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M17 8h1.778q.095.345.222.675V10h-2Zm6 4.872a6.848 6.848 0 0 1-2-1.293V13H11V6h7.5a7.488 7.488 0 0 1 .278-2H10a1 1 0 0 0-1 1v8H8a1 1 0 0 0-1 1v11a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3V14a.98.98 0 0 0-.226-.609 7.568 7.568 0 0 1-1.774-.52ZM15 10V8h-2v2Zm16.327-3.176-1.156.29a4.523 4.523 0 0 1-.43 1.04l.617 1.028a.504.504 0 0 1-.046.586 5.854 5.854 0 0 1-.539.542.497.497 0 0 1-.582.043l-1.03-.62a4.417 4.417 0 0 1-1.042.432l-.29 1.156a.498.498 0 0 1-.471.38c-.225.005-.494.004-.716-.001a.497.497 0 0 1-.47-.379l-.29-1.156a4.404 4.404 0 0 1-1.04-.43l-1.03.617a.504.504 0 0 1-.586-.047 5.815 5.815 0 0 1-.541-.54.497.497 0 0 1-.043-.58l.619-1.032a4.347 4.347 0 0 1-.429-1.04l-1.157-.289a.498.498 0 0 1-.38-.472 15.948 15.948 0 0 1 .001-.715.497.497 0 0 1 .379-.47l1.157-.29a4.361 4.361 0 0 1 .43-1.041l-.618-1.03a.503.503 0 0 1 .047-.587 5.804 5.804 0 0 1 .54-.54.497.497 0 0 1 .58-.042l1.032.618a4.348 4.348 0 0 1 1.04-.429l.29-1.157a.498.498 0 0 1 .471-.38c.225-.004.494-.004.715.001a.497.497 0 0 1 .47.38l.29 1.156a4.324 4.324 0 0 1 1.04.429l1.029-.617a.504.504 0 0 1 .586.046 5.854 5.854 0 0 1 .542.539.497.497 0 0 1 .043.582l-.619 1.031a4.414 4.414 0 0 1 .43 1.041l1.157.29a.498.498 0 0 1 .38.471c.005.225.004.494-.001.716a.497.497 0 0 1-.379.47Zm-3.179-.83A2.147 2.147 0 1 0 26 8.143a2.15 2.15 0 0 0 2.148-2.149Z"
        })
    });
var $3cf07fbef24487f8$export$2e2bcd8739ae039 = $3cf07fbef24487f8$var$SvgGlyphiconsBasic994UsbDeviceCogwheel;




const $85780142eb4a1207$var$SvgGlyphiconsBasic995UsbDeviceEject = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "m23.168 5.183 3.445-4.21a.5.5 0 0 1 .774 0l3.445 4.21a.5.5 0 0 1-.387.817h-6.89a.5.5 0 0 1-.387-.817ZM19 10V8h-2v2Zm5 3h-1v-1.05A3.135 3.135 0 0 1 21 10v3H11V6h10v-.718A1.778 1.778 0 0 1 21.55 4H10a1 1 0 0 0-1 1v8H8a1 1 0 0 0-1 1v11a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3V14a1 1 0 0 0-1-1Zm-9-3V8h-2v2Zm15.5-2h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
        })
    });
var $85780142eb4a1207$export$2e2bcd8739ae039 = $85780142eb4a1207$var$SvgGlyphiconsBasic995UsbDeviceEject;




const $f969aa32e102f57f$var$SvgGlyphiconsBasic996MemoryCard = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M24.5 4h-13A1.5 1.5 0 0 0 10 5.5v6l-3.4 2.55a1.5 1.5 0 0 0-.6 1.2V26.5A1.5 1.5 0 0 0 7.5 28h17a1.5 1.5 0 0 0 1.5-1.5v-21A1.5 1.5 0 0 0 24.5 4ZM15 11h-2V6h2Zm4 0h-2V6h2Zm4 0h-2V6h2Z"
        })
    });
var $f969aa32e102f57f$export$2e2bcd8739ae039 = $f969aa32e102f57f$var$SvgGlyphiconsBasic996MemoryCard;




const $1b74f1862603858d$var$SvgGlyphiconsBasic997MemoryCardLock = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M22 14a3.003 3.003 0 0 1-3-3h-2V6h2V5a2.976 2.976 0 0 1 .176-1H11.5A1.5 1.5 0 0 0 10 5.5v6l-3.4 2.55a1.5 1.5 0 0 0-.6 1.2V26.5A1.5 1.5 0 0 0 7.5 28H25a1 1 0 0 0 1-1V14Zm-7-3h-2V6h2Zm16-7h-1V2a2.003 2.003 0 0 0-2-2h-3a2.003 2.003 0 0 0-2 2v2h-1a1.003 1.003 0 0 0-1 1v6a1.003 1.003 0 0 0 1 1h9a1.003 1.003 0 0 0 1-1V5a1.003 1.003 0 0 0-1-1Zm-6-1.75a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25V4h-3Z"
        })
    });
var $1b74f1862603858d$export$2e2bcd8739ae039 = $1b74f1862603858d$var$SvgGlyphiconsBasic997MemoryCardLock;




const $4877796e43b2b664$var$SvgGlyphiconsBasic998MemoryCardNo = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 9.864V11h-2V6h1a7.96 7.96 0 0 1 .263-2H11.5A1.5 1.5 0 0 0 10 5.5v6l-3.4 2.55a1.5 1.5 0 0 0-.6 1.2V26.5A1.5 1.5 0 0 0 7.5 28h17a1.5 1.5 0 0 0 1.5-1.5V14a8.004 8.004 0 0 1-7-4.136ZM15 11h-2V6h2ZM26 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm-4 6a3.954 3.954 0 0 1 .567-2.019l5.452 5.452A3.955 3.955 0 0 1 26 10a4.005 4.005 0 0 1-4-4Zm7.433 2.019-5.452-5.452A3.955 3.955 0 0 1 26 2a4.005 4.005 0 0 1 4 4 3.954 3.954 0 0 1-.567 2.019Z"
        })
    });
var $4877796e43b2b664$export$2e2bcd8739ae039 = $4877796e43b2b664$var$SvgGlyphiconsBasic998MemoryCardNo;




const $7f4f2951a7e9bf87$var$SvgGlyphiconsBasic999MemoryCardCogwheel = (props)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
            d: "M19 8.675V11h-2V6h1.5a7.488 7.488 0 0 1 .278-2H11.5A1.5 1.5 0 0 0 10 5.5v6l-3.4 2.55a1.5 1.5 0 0 0-.6 1.2V26.5A1.5 1.5 0 0 0 7.5 28h17a1.5 1.5 0 0 0 1.5-1.5v-13a7.496 7.496 0 0 1-7-4.825ZM15 11h-2V6h2Zm16.706-4.646c.005-.222.006-.491 0-.716a.498.498 0 0 0-.379-.472l-1.156-.289a4.414 4.414 0 0 0-.43-1.041l.618-1.031a.497.497 0 0 0-.043-.582 5.854 5.854 0 0 0-.542-.539.504.504 0 0 0-.586-.046l-1.029.617a4.324 4.324 0 0 0-1.04-.429L26.83.67a.497.497 0 0 0-.47-.379 15.93 15.93 0 0 0-.715 0 .498.498 0 0 0-.472.379l-.29 1.157a4.348 4.348 0 0 0-1.04.429l-1.03-.619a.497.497 0 0 0-.581.043 5.804 5.804 0 0 0-.54.54.503.503 0 0 0-.047.587l.618 1.03a4.361 4.361 0 0 0-.43 1.041l-1.157.29a.497.497 0 0 0-.379.47c-.005.221-.006.49 0 .715a.498.498 0 0 0 .379.472l1.157.29a4.347 4.347 0 0 0 .429 1.04l-.619 1.03a.497.497 0 0 0 .043.581 5.815 5.815 0 0 0 .54.54.504.504 0 0 0 .588.047l1.029-.618a4.404 4.404 0 0 0 1.04.431l.29 1.156a.497.497 0 0 0 .47.38c.222.004.491.005.716 0a.498.498 0 0 0 .472-.38l.29-1.156a4.417 4.417 0 0 0 1.041-.432l1.03.62a.497.497 0 0 0 .582-.043 5.854 5.854 0 0 0 .539-.542.504.504 0 0 0 .046-.586l-.617-1.029a4.523 4.523 0 0 0 .43-1.04l1.156-.289a.497.497 0 0 0 .379-.47ZM26 8.143a2.147 2.147 0 1 1 2.148-2.149A2.15 2.15 0 0 1 26 8.143Z"
        })
    });
var $7f4f2951a7e9bf87$export$2e2bcd8739ae039 = $7f4f2951a7e9bf87$var$SvgGlyphiconsBasic999MemoryCardCogwheel;







const $ab70f9113dab70ed$export$423bb2cf04f7e0bb = async ()=>{
    try {
        return await (0, ($parcel$interopDefault($8zHUo$axios))).get((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).status).then((res)=>res);
    } catch (e) {
        return [];
    }
};
const $ab70f9113dab70ed$export$7f0ed83521fba7cb = async (resource, id, jwt)=>(0, ($parcel$interopDefault($8zHUo$axios))).get((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud + "/" + resource + "/" + id, {
        headers: {
            Authorization: `Bearer ${jwt}`
        }
    }).then((res)=>res);
const $ab70f9113dab70ed$export$3ac1f382cf85e39b = async (resource, jwt)=>(0, ($parcel$interopDefault($8zHUo$axios))).get((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud + "/" + resource, {
        headers: {
            Authorization: `Bearer ${jwt}`
        }
    }).then((res)=>res);
const $ab70f9113dab70ed$export$5239e329ba02d09b = async (resource, jsonPath, jwt)=>(0, ($parcel$interopDefault($8zHUo$axios))).get((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud + "/" + resource + "/" + jsonPath, {
        headers: {
            Authorization: `Bearer ${jwt}`
        }
    }).then((res)=>res);
const $ab70f9113dab70ed$export$f80d1eb87df81586 = async (link)=>(0, ($parcel$interopDefault($8zHUo$axios))).get(link).then((res)=>res);
const $ab70f9113dab70ed$export$880a166440c2a826 = async (link, jwt)=>(0, ($parcel$interopDefault($8zHUo$axios))).get(link, {
        headers: {
            Authorization: `bearer ${jwt}`
        }
    }).then((res)=>res);




function $57877cc6648422f5$export$cc7de1bcbd27d0a2() {
    return (0, $8zHUo$tanstackreactquery.useQuery)([
        "status"
    ], ()=>(0, $ab70f9113dab70ed$export$423bb2cf04f7e0bb)());
}










const $b8f3178562702f6a$var$Status = ({ fqcn_bui: fqcn_bui  })=>{
    const { isLoading: isLoading , isSuccess: isSuccess , data: data , isRefetching: isRefetching , isError: isError , refetch: refetch , status: status  } = (0, $57877cc6648422f5$export$cc7de1bcbd27d0a2)();
    const { isLoading: isLoadingToken , isSuccess: isSuccessGetToken , mutate: getToken , data: dataToken  } = (0, $d8558f4cea2fd4d3$export$f6e31faba1d0ca28)();
    const copyToken = (token)=>{
        window.navigator.clipboard.writeText(`bearer ${token}`);
        (0, ($parcel$interopDefault($8zHUo$reacthottoast))).success("copied");
    };
    (0, $8zHUo$react.useEffect)(()=>{
        //@ts-ignore
        if ((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).status && !data?.data.Status) refetch();
    }, [
        (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).status,
        data
    ]);
    //@ts-ignore
    if (isLoading || isRefetching || !data?.data.Status) return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $9d897b2068c8ec05$export$2e2bcd8739ae039), {
        isLoading: true
    });
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "flex flex-col min-h-screen",
        style: {
            fontFamily: "Roboto"
        },
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, ($parcel$interopDefault($8zHUo$nexthead))), {
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("title", {
                        children: "Status"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("meta", {
                        name: "description",
                        content: "phpreaction prototype"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$reacthottoast.Toaster), {}),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("main", {
                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, ""),
                className: "flex flex-col pt-10 items-center h-screen bg-gray-100",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("h1", {
                        className: "text-2xl font-medium p-3 pt-2 pb-7",
                        children: "Backend Status "
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "__TAble flex flex-col space-y-2 p-3 border border-gray-300 shadow-sm rounded-lg bg-white ",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                className: "__HEADER grid grid-cols-5 gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "endpoint", "endpoint-text"),
                                        className: "text-sm font-medium text-gray-600 ",
                                        children: "Endpoint"
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: "text-sm font-medium text-gray-600 ",
                                        children: "Status Code"
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: "text-sm font-medium text-gray-600 ",
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: "text-sm font-medium text-gray-600 ",
                                        children: "Sumarry"
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: "text-sm font-medium text-gray-600 ",
                                        children: "Documentation"
                                    })
                                ]
                            }),
                            (isLoading || isRefetching) && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                className: "__Row_Loding grid grid-cols-5 gap-4 animate-pulse",
                                children: [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5
                                ].map((i)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: `${i == 1 ? "w-40 md:w-72" : "w-28 md:w-36"} h-2 bg-gray-200`
                                    }, i))
                            }),
                            !isLoading && !isRefetching && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                className: "__Row grid grid-cols-5 gap-4 ",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: " font-medium text-gray-800 md:text-base text-sm",
                                        children: "/api/login_check"
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "status", "status"),
                                        className: " font-medium text-gray-800 md:text-base text-sm",
                                        children: //@ts-ignore
                                        data?.status
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: " font-medium text-gray-800 md:text-base text-sm ",
                                        children: //@ts-ignore
                                        data?.data.Status
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        children: //@ts-ignore
                                        data?.data.Status.toLowerCase() == "ok" ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $d112d3a9e8dea936$export$2e2bcd8739ae039), {
                                                fill: "green",
                                                className: "w-10 h-10 text-green-600"
                                            })
                                        }) : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $dceed6addde58781$export$2e2bcd8739ae039), {
                                                fill: "green",
                                                className: "w-10 h-10 text-red-600"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                                        href: (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).documentation,
                                        className: " font-medium text-blue-700 underline md:text-base text-xs md:w-auto w-2 ",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $f1a9abb3a8775c87$export$2e2bcd8739ae039), {
                                            fill: "black",
                                            className: "w-10 h-10"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "__Actions w-full p-10 flex justify-center",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: " w-80 p-3 space-y-4",
                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                className: "grid grid-cols-2 gap-10",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        title: "Test Api",
                                        onClick: ()=>refetch()
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        variant: "secondary",
                                        title: "Get Token",
                                        onClick: ()=>getToken({
                                                username: "admin",
                                                password: "phpc"
                                            })
                                    })
                                ]
                            })
                        })
                    }),
                    isLoadingToken && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-80 h-3 bg-gray-300 animate-pulse"
                    }),
                    isSuccessGetToken && dataToken && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "flex flex-col items-center container",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                children: "Token"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                onClick: ()=>copyToken(dataToken.token),
                                className: "__Token flex flex-col space-y-2 p-3 border border-gray-300 shadow-sm rounded-lg bg-white cursor-pointer hover:text-gray-700 ",
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                    className: "overflow-hidden truncate w-80",
                                    children: "bearer " + dataToken.token
                                })
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("span", {
                                onClick: ()=>copyToken(dataToken.token),
                                className: "text-sm font-light text-gray-500 p-1 italic flex items-stretch space-x-1",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: "self-center",
                                        children: "Click to copy"
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$ae118f79ed05e2c0), {
                                        className: "w-5 h-5 text-gray-500"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("footer", {
                className: ""
            })
        ]
    });
};
var $b8f3178562702f6a$export$2e2bcd8739ae039 = $b8f3178562702f6a$var$Status;


















const $fb3e40c1425686ec$var$sizes = {
    xlarge: "p-4  w-full h-56  text-lg",
    large: "p-3 w-96 h-40 text-base ",
    medium: "p-2 w-80 h-28 text-sm ",
    small: "p-2 w-60 h-20 text-sm ",
    xsmall: "p-1 w-44  h-16 text-xs ",
    auto: "p-1 w-auto h-auto"
};
const $fb3e40c1425686ec$var$borders = {
    primary: "focus:border-blue-500 focus:outline-none",
    urgent: "focus:outline-none border-red-500"
};
const $fb3e40c1425686ec$var$right_className = (size, isDisabled)=>`${$fb3e40c1425686ec$var$sizes[size]} font-medium border text-gray-700 text-gray-700 rounded-lg ${isDisabled && "opacity-80"} disabled:text-accent-disabled disabled:bg-accent-hover `;
const $fb3e40c1425686ec$var$TextArea = ({ size: size = "auto" , isDisabled: isDisabled = false , className: className , border: border = "primary" , ...props })=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("textarea", {
        disabled: isDisabled,
        className: `${className} ${$fb3e40c1425686ec$var$borders[border]} ${$fb3e40c1425686ec$var$right_className(size, isDisabled)}`,
        ...props,
        "data-testid": "textarea"
    });
};
var $fb3e40c1425686ec$export$2e2bcd8739ae039 = $fb3e40c1425686ec$var$TextArea;



//interceptors for  api calls



const $c7d5b4ea505ed32f$var$axiosConfigApiInstance = (0, ($parcel$interopDefault($8zHUo$axios))).create();
// set the base url
$c7d5b4ea505ed32f$var$axiosConfigApiInstance.defaults.baseURL = (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud;
// would be usefull if we have a way to store the token
// Request interceptor for API calls
$c7d5b4ea505ed32f$var$axiosConfigApiInstance.interceptors.request.use(async (config)=>{
    let jwt = (0, $8zHUo$cookiesnext.getCookie)("token", {
        sameSite: "none",
        secure: true
    });
    config.headers = {
        Authorization: `Bearer ` + jwt
    };
    return config;
}, (error)=>{
    Promise.reject(error);
});
$c7d5b4ea505ed32f$var$axiosConfigApiInstance.interceptors.response.use((response)=>{
    return response;
}, async (error)=>{
    const status = error.response ? error.response.status : null;
    const original_req = error.config;
    original_req.headers["Conent-Type"] = `application/json; Charset=UTF-8`;
    // retry untill not status 401
    if (status == 401) {
        if (!window.location.href.includes("login")) {
            (0, $8zHUo$cookiesnext.deleteCookie)("token");
            window.location.href = "/login?from=" + window.location.pathname;
        }
    }
    return Promise.reject(error);
});
var $c7d5b4ea505ed32f$export$2e2bcd8739ae039 // Set default headers to common_axios ( as Instance )
 = $c7d5b4ea505ed32f$var$axiosConfigApiInstance;


const $64fb6a6b423817c8$export$c542b5e295206b2a = ()=>{
    return "hello ";
};
const $64fb6a6b423817c8$var$checker_multi = (value, field, Default)=>{
    if (value != null || value != undefined) {
        // case of muliple values '?id[]=2&id[]=3'
        if (value.toString().split(",").length > 1) {
            let exp = "";
            let arr = value.toString().split(",");
            for(let i = 0; i < arr.length; i++){
                exp = exp + field + "[]=" + arr[i];
                if (i < arr.length - 1) exp = exp + "&";
            }
            return exp;
        }
        // case simple value
        return value + "&";
    }
    return Default ?? "";
};
const $64fb6a6b423817c8$var$get_specifics = (obj)=>{
    if (!obj) return "";
    // returned epression
    let exp = "";
    // lets get the object keys as an array elements : {id:1,tenant:2} =>['id','tenant']
    let arr_props = Object.keys(obj);
    // now We will iterate through the keys of the object aka elements of the array of props
    for(let i = 0; i < arr_props.length; i++){
        // in case the property value is not '2,3' but only a single value
        //@ts-ignore
        if (obj[arr_props[i]].toString().split(",").length == 1) {
            exp = exp + arr_props[i] + "[]=" + //@ts-ignore
            $64fb6a6b423817c8$var$checker_multi(obj[arr_props[i]].toString(), arr_props[i], "");
            continue;
        }
        //@ts-ignore
        exp = exp + $64fb6a6b423817c8$var$checker_multi(obj[arr_props[i]].toString(), arr_props[i], "");
        if (i < arr_props.length - 1) exp = exp + "&";
    }
    return exp;
};
const $64fb6a6b423817c8$export$1b5b3a9374f6630e = (resource, filters)=>{
    const { q: q , id: id , specific: specific , page: page , pageSize: pageSize , limit: limit , offset: offset , sort: sort , order: order , qField: qField  } = filters;
    // SEARCH COLUMN IS __HARDCODED
    let query_params = `page=${$64fb6a6b423817c8$var$checker_multi(page, "page", 1)}&range=${$64fb6a6b423817c8$var$checker_multi(pageSize, "range", 25)}&limit=${$64fb6a6b423817c8$var$checker_multi(limit)}&order%5B${sort}%5D=${order}&offset=${$64fb6a6b423817c8$var$checker_multi(offset)}&id[]=${$64fb6a6b423817c8$var$checker_multi(id)}&${$64fb6a6b423817c8$var$get_specifics(specific)}`;
    if (q) query_params += `&search=${$64fb6a6b423817c8$var$checker_multi(q, "")}`;
    return query_params;
};
function $64fb6a6b423817c8$export$5ea1bdf6a9d3779f(formData, formInputs) {
    let newFormData = {};
    formInputs.forEach((item)=>{
        if (item.type == "text") {
            if (item.prefixOnSubmit) // @ts-ignore
            newFormData[item.name] = // @ts-ignore
            item.prefixOnSubmit + formData[item.name];
            else newFormData[item.name] = formData[item.name];
        }
        if (item.type == "select_async") {
            if (item.prefixOnSubmit) // @ts-ignore
            newFormData[item.name] = // @ts-ignore
            item.prefixOnSubmit + formData[item.name].id;
            else newFormData[item.name] = formData[item.name].id;
        }
    });
    return newFormData;
}


const $686ab0e2fb05f109$export$6079a388768cd3b7 = async (resource, filters, raw)=>{
    let url = `/${resource}?${(0, $64fb6a6b423817c8$export$1b5b3a9374f6630e)(resource, filters)}`;
    return (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).get(url).then((res)=>{
        if (raw) return res.data;
        return res.data["hydra:member"];
    });
};
const $686ab0e2fb05f109$export$7d1eefcddaeba55b = async (resource, id)=>(0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).get(`/${resource}/${id}`).then((res)=>res.data);
const $686ab0e2fb05f109$export$1041b7558d56f2f9 = (resource, data)=>(0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).post(`/${resource}`, data).then((res)=>res.data["hydra:member"] ?? res.data);
const $686ab0e2fb05f109$export$c1f5dc8a6d873266 = (resource, id)=>(0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).delete(`/${resource}/${id}`).then((res)=>res.data["hydra:member"]);
const $686ab0e2fb05f109$export$b9757da0c8d7c3bb = (resource, data)=>(0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).put(`/${resource}/${data.id}`, data).then((res)=>res.data["hydra:member"]);





function $49eb772184ca2f2b$export$ad6724ecf32710ae(resource, filters, raw) {
    return (0, $8zHUo$tanstackreactquery.useQuery)([
        resource,
        "list",
        filters,
        raw
    ], ()=>(0, $686ab0e2fb05f109$export$6079a388768cd3b7)(resource, filters, raw));
}
function $49eb772184ca2f2b$export$35d0477f0729096c(resource, resource_id) {
    return (0, $8zHUo$tanstackreactquery.useQuery)([
        resource,
        "detail",
        resource_id
    ], ()=>(0, $686ab0e2fb05f109$export$7d1eefcddaeba55b)(resource, resource_id));
}
function $49eb772184ca2f2b$export$5edc9d665968dd86(resource) {
    const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
    return (0, $8zHUo$tanstackreactquery.useMutation)([
        resource
    ], (data)=>(0, $686ab0e2fb05f109$export$1041b7558d56f2f9)(resource, data), {
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries([
                resource
            ]);
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).success("Successfuly created!");
        },
        onError: (data, variables)=>{
            queryClient.invalidateQueries([
                resource
            ]);
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).error("Something went wrong!");
        }
    });
}
function $49eb772184ca2f2b$export$74524c73191a667c(resource) {
    const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
    return (0, $8zHUo$tanstackreactquery.useMutation)([
        resource
    ], (data)=>(0, $686ab0e2fb05f109$export$b9757da0c8d7c3bb)(resource, data), {
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries([
                resource
            ]);
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).success("Successfuly updated!");
        },
        onError: (data, variables)=>{
            queryClient.invalidateQueries([
                resource
            ]);
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).error("Something went wrong!");
        }
    });
}
function $49eb772184ca2f2b$export$60acb8fd13afd60d(resource) {
    const queryClient = (0, $8zHUo$tanstackreactquery.useQueryClient)();
    return (0, $8zHUo$tanstackreactquery.useMutation)([
        resource
    ], (id)=>(0, $686ab0e2fb05f109$export$c1f5dc8a6d873266)(resource, id), {
        onSuccess: (data, variables)=>{
            queryClient.invalidateQueries([
                resource
            ]);
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).success("Successfuly deleted!");
        },
        onError: (data, variables)=>{
            queryClient.invalidateQueries([
                resource
            ]);
            (0, ($parcel$interopDefault($8zHUo$reacthottoast))).error("Something went wrong!");
        }
    });
}








const $97ed0b91844f103f$export$3070bd282ec37ea8 = (userAgent)=>{
    let os = "Unknown";
    if (/windows/i.test(userAgent)) {
        os = "Windows";
        const versionMatch = userAgent.match(/Windows NT (\d+(\.\d+)?)/i);
        if (versionMatch) os += ` ${versionMatch[1]}`;
    } else if (/android/i.test(userAgent)) {
        os = "Android";
        const versionMatch = userAgent.match(/Android (\d+(\.\d+)?)/i);
        if (versionMatch) os += ` ${versionMatch[1]}`;
    } else if (/linux/i.test(userAgent)) os = "Linux";
    else if (/iphone|ipad|ipod/i.test(userAgent)) {
        os = "iOS";
        const versionMatch = userAgent.match(/OS (\d+(_\d+)?(_\d+)?)/i);
        if (versionMatch) os += ` ${versionMatch[1].replace(/_/g, ".")}`;
    } else if (/mac/i.test(userAgent)) {
        os = "Mac OS";
        const versionMatch = userAgent.match(/Mac OS X (\d+(_\d+)?(_\d+)?)/i);
        if (versionMatch) os += ` ${versionMatch[1].replace(/_/g, ".")}`;
    }
    return os;
};


const $2c3aefaf773f11ee$export$2d31490a0c05f094 = (userAgent)=>{
    let name = "Unknown";
    let version = "";
    if (/edge/i.test(userAgent)) name = "Edge";
    else if (/chrome/i.test(userAgent)) name = "Chrome";
    else if (/safari/i.test(userAgent)) name = "Safari";
    else if (/firefox/i.test(userAgent)) name = "Firefox";
    else if (/MSIE|Trident/i.test(userAgent)) name = "IE";
    const versionMatch = userAgent.match(/(version|chrome|firefox|safari|rv|msie)\/(\d+(\.\d+)?)/i);
    if (versionMatch) version = versionMatch[2];
    return `${name} ${version}`;
};


const $2d29678395c15724$var$phonePattern = /^\(\d{3}\) \d{3}-\d{4}( #\d*)?$/;
const $2d29678395c15724$var$validationSchema = $8zHUo$yup.object().shape({
    firstName: $8zHUo$yup.string().required("First name is required"),
    lastName: $8zHUo$yup.string().required("Last name is required"),
    clientUserCoordinatesEmail: $8zHUo$yup.string().email("Invalid email address").required("Email is required"),
    clientUserCoordinatesPhone: $8zHUo$yup.string().matches($2d29678395c15724$var$phonePattern, "Invalid phone number format").required("Phone number is required"),
    url: $8zHUo$yup.string().matches(/^(https?|ftp):\/\/[^\s$.?#]+\.[^\s]+$/, "Invalid URL").required("URL is required"),
    clientDemand: $8zHUo$yup.string().required("Demand or Problem is required"),
    type: $8zHUo$yup.object().shape({
        label: $8zHUo$yup.string().required("Type is required"),
        value: $8zHUo$yup.string().required("Type value is required")
    }),
    impact: $8zHUo$yup.object().shape({
        label: $8zHUo$yup.string().required("Impact is required"),
        value: $8zHUo$yup.string().required("Impact value is required")
    })
});
const $2d29678395c15724$var$Feedback = ({ ticketUrl: ticketUrl , feedbackUrl: feedbackUrl , fqcn_bui: fqcn_bui , testFields: testFields , ...props })=>{
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    const { query: query , isReady: isReady  } = (0, $8zHUo$nextrouter.useRouter)();
    const [reload, setReload] = (0, $8zHUo$react.useState)(false);
    const [hasToken, setHasToken] = (0, $8zHUo$react.useState)(false);
    const { data: dataCreate , isLoading: isLoadingCreate , isSuccess: isSuccessCreate , mutate: create_ticket  } = (0, $49eb772184ca2f2b$export$5edc9d665968dd86)("tickets");
    const { mutate: create_file  } = (0, $49eb772184ca2f2b$export$5edc9d665968dd86)("files");
    const [more, setMore] = (0, $8zHUo$react.useState)(false);
    const [btnDisabled, setBtnDisabled] = (0, $8zHUo$react.useState)(false);
    const [types, setTypes] = (0, $8zHUo$react.useState)([]);
    const [impacts, setImpacts] = (0, $8zHUo$react.useState)([]);
    const formik = (0, $8zHUo$formik.useFormik)({
        initialValues: {
            firstName: "",
            lastName: "",
            clientUserName: "",
            clientDemand: "",
            clientUserCoordinatesEmail: "",
            clientUserCoordinatesPhone: "",
            url: "",
            type: {
                label: "",
                value: ""
            },
            impact: {
                label: "",
                value: ""
            },
            clientUrgency: false,
            fillType: "Manual",
            clientFee: false,
            status: "/api/v1/ticket_statuses/1",
            access: (0, ($parcel$interopDefault($8zHUo$crypto))).randomBytes(16).toString("hex"),
            devNote: "",
            screenshot: "",
            qaNote: "",
            clientContextBrowser: "",
            clientContextOS: ""
        },
        validationSchema: $2d29678395c15724$var$validationSchema,
        onSubmit: async (values)=>{
            try {
                create_ticket({
                    ...values,
                    impact: `/api/v1/ticket_impacts/${values.impact.value}`,
                    type: `/api/v1/ticket_types/${values.type.value}`,
                    clientUserName: `${values.firstName} ${values.lastName}`
                });
            } catch (err) {
                console.error("err", err);
            }
            setReload(false);
        }
    });
    const captureScreenshot = ()=>{
        // let parentBody = window?.parent?.document?.body;
        (0, ($parcel$interopDefault($8zHUo$html2canvas)))(// parentBody ||
        document.body, {
            logging: true,
            onclone: (doc)=>{
                const formElement = doc.getElementById("feedback__form");
                if (formElement) formElement.style.visibility = "hidden";
            }
        }).then((canvas)=>{
            const screenshotUrl = canvas.toDataURL();
            formik.setFieldValue("screenshot", screenshotUrl?.toString());
            return screenshotUrl;
        }).catch((error)=>{
            console.error("Error capturing screenshot:", error);
        });
        return "";
    };
    const handleFormReset = ()=>{
        const userAgent = navigator.userAgent;
        formik.resetForm();
        const { firstName: firstName = "" , lastName: lastName = "" , demand: demand = "" , email: email = "" , phone: phone = "" , type: queryType , impact: queryImpact , screenshot: screenshot = "" , status: status = "/api/v1/ticket_statuses/1" , url: url , clientUrgency: clientUrgency = false  } = query;
        const typeValue = queryType || types.length > 0 ? types[0] : "";
        const impactValue = queryImpact || impacts.length > 0 ? impacts[0] : "";
        formik.setValues({
            ...formik.values,
            firstName: formik.values.firstName || firstName || "",
            lastName: formik.values.lastName || lastName || "",
            clientUserName: `${firstName} ${lastName}`,
            clientDemand: formik.values.clientDemand || demand || "",
            clientUserCoordinatesEmail: formik.values.clientUserCoordinatesEmail || email || "",
            clientUserCoordinatesPhone: formik.values.clientUserCoordinatesPhone || phone || "",
            type: typeValue,
            impact: impactValue,
            clientUrgency: formik.values.clientUrgency || Boolean(clientUrgency) || false,
            url: formik.values.url ? formik.values.url : url || window?.location?.ancestorOrigins?.length > 0 ? window?.location?.ancestorOrigins?.[0] : window?.location?.href || "",
            fillType: "Manual",
            clientFee: false,
            status: status || "/api/v1/ticket_statuses/1",
            access: (0, ($parcel$interopDefault($8zHUo$crypto))).randomBytes(16).toString("hex"),
            devNote: "",
            screenshot: formik.values.screenshot || screenshot || "",
            qaNote: "",
            clientContextOS: (0, $97ed0b91844f103f$export$3070bd282ec37ea8)(userAgent),
            clientContextBrowser: (0, $2c3aefaf773f11ee$export$2d31490a0c05f094)(userAgent)
        });
    };
    (0, $8zHUo$react.useEffect)(()=>{
        if (isSuccessCreate && formik.values.screenshot) {
            const dataScreenshot = {
                file: formik.values.screenshot,
                fileName: "screenshot",
                ticket: dataCreate["@id"]
            };
            create_file(dataScreenshot);
            handleFormReset();
        }
    }, [
        isSuccessCreate,
        formik.values.screenshot
    ]);
    const fetchTicketImpactOptions = async (input)=>{
        if (hasToken && (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud) {
            const res = await (0, $686ab0e2fb05f109$export$6079a388768cd3b7)("ticket_impacts", {
                id: input
            }, false);
            const updated = res.map((i)=>({
                    label: t(i.impact),
                    value: i.id
                }));
            setImpacts(updated);
            return updated;
        }
        return [];
    };
    const fetchTicketTypeOptions = async (input)=>{
        if (hasToken && (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud) {
            const res = await (0, $686ab0e2fb05f109$export$6079a388768cd3b7)("ticket_types", {
                id: input
            }, false);
            const updated = res.map((i)=>({
                    label: t(i.type),
                    value: i.id
                }));
            setTypes(updated);
            return updated;
        }
        return [];
    };
    (0, $8zHUo$react.useEffect)(()=>{
        const initializeFormValues = async ()=>{
            await fetchTicketTypeOptions("");
            await fetchTicketImpactOptions("");
        };
        if (hasToken && (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud) initializeFormValues();
    }, [
        hasToken,
        (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud
    ]);
    (0, $8zHUo$react.useEffect)(()=>{
        if (!isReady) return;
        if (!formik.values.screenshot && window?.location?.ancestorOrigins?.length <= 0) captureScreenshot();
        handleFormReset();
        // Height calculation and message posting to parent window
        const height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        if (window.top) {
            window.top.postMessage({
                loaded: true,
                height: height
            }, "*");
            window.addEventListener("message", receiveMessage, true);
        }
    }, [
        isReady,
        query,
        types,
        impacts
    ]);
    (0, $8zHUo$react.useEffect)(()=>{
        if (!formik.values.firstName || !formik.values.lastName || !formik.values.clientUserCoordinatesEmail || !formik.values.clientUserCoordinatesPhone || !formik.values.url || !formik.values.clientDemand) setBtnDisabled(true);
        else setBtnDisabled(false);
    }, [
        formik.values
    ]);
    (0, $8zHUo$react.useEffect)(()=>{
        if ((0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud && !hasToken) (0, $d8558f4cea2fd4d3$export$584b2531a4ea43a)({
            username: "ticket-user-for-client-feedback" ?? "",
            password: "cuteIvory80!" ?? ""
        }).then((data)=>{
            (0, $8zHUo$cookiesnext.setCookie)("token", data.token, {
                sameSite: "none",
                secure: true
            });
            setHasToken(true);
        });
    }, [
        (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud,
        hasToken
    ]);
    const handleReload = async ()=>{
        setReload(true);
        formik.setValues({
            ...formik.values,
            clientDemand: "",
            clientUrgency: false
        });
    };
    const receiveMessage = (event)=>{
        if (event.data.credentials) {
            const { username: username , password: password  } = event.data.credentials;
            (0, $d8558f4cea2fd4d3$export$584b2531a4ea43a)({
                username: username,
                password: password
            }).then((data)=>{
                (0, $8zHUo$cookiesnext.setCookie)("token", data.token, {
                    sameSite: "none",
                    secure: true
                });
                setHasToken(true);
            });
        } else for(let key in event.data)formik.setFieldValue(key, event.data[key]);
    };
    const formatPhoneNumber = (value)=>{
        const phoneNumber = value.replace(/\D/g, "");
        let formattedPhoneNumber = "";
        if (phoneNumber.length <= 10) formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        else formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})(\d*)/, "($1) $2-$3 #$4");
        return formattedPhoneNumber;
    };
    const urgency = formik.values.clientUrgency;
    if (!(0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud || !hasToken) return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $9d897b2068c8ec05$export$2e2bcd8739ae039), {
        isLoading: true
    });
    if (isSuccessCreate && !reload) return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        style: {
            fontFamily: "Roboto"
        },
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                    href: "https://phpreaction.com/",
                    passHref: true,
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $59ff00cb4a4db4e4$export$2e2bcd8739ae039), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                    className: "flex flex-col text-center space-y-4 mx-16",
                    children: [
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                            className: "font-semibold",
                            children: t("Your request/description has been received.")
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                            className: "font-semibold",
                            children: t("You will receive a follow up shortly.")
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("span", {
                            className: "bg-blue-phpr text-white font-bold p-2 rounded-lg",
                            children: [
                                t("Note the confirmation number :"),
                                " ",
                                dataCreate ? dataCreate["uniqueId"] : ""
                            ]
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("span", {
                            className: "font-semibold",
                            children: [
                                t("View/manage your ticket here :"),
                                "\xa0",
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                                    href: `${ticketUrl}/ticket/${dataCreate["id"]}/anonymous?access=${dataCreate["access"]}`,
                                    children: t("Click here to view ticket")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "button", "new"),
                    className: "mt-6 font-semibold",
                    title: t("New Ticket"),
                    size: "large",
                    onClick: ()=>{
                        handleReload();
                    }
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: "text-center bg-gradient-to-b from-dark_gray to-black pt-5",
        style: {
            fontFamily: "Roboto"
        },
        id: "feedback__form",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("form", {
                onSubmit: formik.handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "grid grid-cols-2 justify-items-start w-full",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                                href: "https://phpreaction.com/",
                                passHref: true,
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $59ff00cb4a4db4e4$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                className: "justify-self-end",
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                    className: "flex flex-row",
                                    children: [
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                            className: "grid self-center mr-1",
                                            children: [
                                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                                    className: "font-semibold text-lg",
                                                    children: t("Emergency")
                                                }),
                                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                                                    href: "https://phpreaction.com/tarifs/plans-de-support/",
                                                    legacyBehavior: true,
                                                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                                                        className: `${urgency ? "text-red-600 hover:text-red-500" : ""}`,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        children: t("Support plan")
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                            className: `hover:bg-red-400 rounded-lg grid self-center ${urgency ? "hover:bg-red-800" : ""}`,
                                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $7da6c9ee3e14188e$export$2e2bcd8739ae039), {
                                                className: `w-10 h-10 ${urgency ? "filter-red" : ""}`,
                                                onClick: ()=>{
                                                    formik.setFieldValue("clientUrgency", !urgency);
                                                },
                                                style: {
                                                    filter: urgency ? "invert(14%) sepia(71%) saturate(5707%) hue-rotate(351deg) brightness(97%) contrast(112%)" : ""
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $acfe242336feac07$export$2e2bcd8739ae039), {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "select", "type"),
                                size: "xlarge",
                                variant: "async",
                                defaultOptions: true,
                                cacheOptions: true,
                                loadOptions: fetchTicketTypeOptions,
                                onChange: (data)=>{
                                    formik.setFieldValue("type", data);
                                },
                                placeholder: t("Type"),
                                value: formik.values.type ?? "",
                                border: `${urgency ? "urgent" : "primary"}`
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $acfe242336feac07$export$2e2bcd8739ae039), {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "select", "impact"),
                                size: "xlarge",
                                variant: "async",
                                defaultOptions: true,
                                cacheOptions: true,
                                loadOptions: fetchTicketImpactOptions,
                                onChange: (data)=>{
                                    formik.setFieldValue("impact", data);
                                },
                                placeholder: t("Impacte / Impact"),
                                value: formik.values.impact ?? "",
                                border: `${urgency ? "urgent" : "primary"}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $fb3e40c1425686ec$export$2e2bcd8739ae039), {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "text-area", "demand"),
                                placeholder: t("Request or Problem*"),
                                size: "xlarge",
                                onChange: formik.handleChange("clientDemand"),
                                onBlur: formik.handleBlur("clientDemand"),
                                value: formik.values.clientDemand,
                                className: `mb-0`,
                                border: `${urgency ? "urgent" : "primary"}`
                            }),
                            formik.touched.clientDemand && formik.errors.clientDemand ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                className: "text-red-500 text-left -mt-1",
                                children: formik.errors.clientDemand
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ce350b8ddb52fbc0$export$2e2bcd8739ae039), {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "input", "firstName"),
                                        size: "xlarge",
                                        onChange: formik.handleChange("firstName"),
                                        onBlur: formik.handleBlur("firstName"),
                                        placeholder: t("First name*"),
                                        required: true,
                                        type: "text",
                                        value: formik.values.firstName,
                                        border: `${urgency ? "urgent" : "primary"}`
                                    }),
                                    formik.touched.firstName && formik.errors.firstName ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                        className: "text-red-500 text-left -mt-4",
                                        children: formik.errors.firstName
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ce350b8ddb52fbc0$export$2e2bcd8739ae039), {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "input", "lastName"),
                                        size: "xlarge",
                                        onChange: formik.handleChange("lastName"),
                                        onBlur: formik.handleBlur("lastName"),
                                        placeholder: t("Last name*"),
                                        required: true,
                                        type: "text",
                                        value: formik.values.lastName,
                                        border: `${urgency ? "urgent" : "primary"}`
                                    }),
                                    formik.touched.lastName && formik.errors.lastName ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                        className: "text-red-500 text-left -mt-4",
                                        children: formik.errors.lastName
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "flex flex-col md:flex-row md:space-x-4",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ce350b8ddb52fbc0$export$2e2bcd8739ae039), {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "input", "email"),
                                        size: "xlarge",
                                        onChange: formik.handleChange("clientUserCoordinatesEmail"),
                                        onBlur: formik.handleBlur("clientUserCoordinatesEmail"),
                                        placeholder: t("Email Address*"),
                                        required: true,
                                        type: "email",
                                        value: formik.values.clientUserCoordinatesEmail,
                                        icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $d97c8cbc76ab7501$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6"
                                        }),
                                        iconPosition: "right",
                                        border: `${urgency ? "urgent" : "primary"}`
                                    }),
                                    formik.touched.clientUserCoordinatesEmail && formik.errors.clientUserCoordinatesEmail ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                        className: "text-red-500 text-left -mt-4",
                                        children: formik.errors.clientUserCoordinatesEmail
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ce350b8ddb52fbc0$export$2e2bcd8739ae039), {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "input", "phone"),
                                        size: "xlarge",
                                        onChange: (e)=>{
                                            const formattedPhoneNumber = formatPhoneNumber(e.target.value);
                                            formik.setFieldValue("clientUserCoordinatesPhone", formattedPhoneNumber);
                                        },
                                        onBlur: formik.handleBlur("clientUserCoordinatesPhone"),
                                        placeholder: t("Phone*"),
                                        required: true,
                                        type: "tel",
                                        value: formik.values.clientUserCoordinatesPhone,
                                        icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $c621c088191d8a83$export$2e2bcd8739ae039), {
                                            className: "w-6 h-6"
                                        }),
                                        iconPosition: "right",
                                        border: `${urgency ? "urgent" : "primary"}`
                                    }),
                                    formik.touched.clientUserCoordinatesPhone && formik.errors.clientUserCoordinatesPhone ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                        className: "text-red-500 text-left -mt-4",
                                        children: formik.errors.clientUserCoordinatesPhone
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        children: more && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, $8zHUo$reactjsxruntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $ce350b8ddb52fbc0$export$2e2bcd8739ae039), {
                                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "input", "url"),
                                    size: "xl-full",
                                    onChange: formik.handleChange("url"),
                                    onBlur: formik.handleBlur("url"),
                                    placeholder: t("URL*"),
                                    required: true,
                                    type: "url",
                                    value: formik.values.url,
                                    border: `${urgency ? "urgent" : "primary"}`
                                }),
                                formik.touched.url && formik.errors.url ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                                    className: "text-red-500 text-left -mt-4",
                                    children: formik.errors.url
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 space-y-2 md:space-x-0 w-full",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                                icon: more ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $158d7a26243dbb39$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5"
                                }) : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $464b3fd36ff0bd1a$export$2e2bcd8739ae039), {
                                    className: "w-5 h-5"
                                }),
                                onClick: ()=>setMore(!more),
                                type: "button",
                                className: "md:justify-self-start",
                                bgcolor: "gray-200",
                                color: "gray-500"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "button", "submit"),
                                title: t("Send"),
                                size: "xlarge",
                                className: "md:justify-self-end",
                                variant: `${urgency ? "urgent" : "primary"}`,
                                disabled: btnDisabled || isLoadingCreate,
                                isLoading: isLoadingCreate,
                                type: "submit"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $2d29678395c15724$export$2e2bcd8739ae039 = $2d29678395c15724$var$Feedback;





const $ba56bb58a40c98c6$var$types = {
    "Probl\xe9matique / Problem": 1,
    "Am\xe9lioration / Improvement": 2,
    "Ajout de fonctionnalit\xe9 / Addition of functionality": 3,
    Suggestion: 4,
    Question: 5
};
const $ba56bb58a40c98c6$var$impacts = {
    "Futile / Trivial": 2,
    "Mineur / Minor": 3,
    "Majeur / Major": 4,
    "Critique / Critical": 5
};
const $ba56bb58a40c98c6$var$FeedbackIframe = ({ firstName: firstName , lastName: lastName , demand: demand , email: email , phone: phone , url: url , feedbackUrl: feedbackUrl , type: type , impact: impact , token: token , username: username , password: password , fqcn_bui: fqcn_bui , qaNote: qaNote , ...props })=>{
    let qs = `?firstName=${firstName ?? ""}&lastName=${lastName ?? ""}&demand=${demand ?? ""}&email=${email ?? ""}&phone=${phone ?? ""}&url=${url}&type=${type ?? ""}&impact=${impact ?? ""}`;
    const iframeUrl = feedbackUrl + qs;
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("iframe", {
        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "frame"),
        className: "shadow shadow-lg w-full",
        src: iframeUrl,
        "data-html2canvas-ignore": "true",
        ...props
    });
};
var $ba56bb58a40c98c6$export$2e2bcd8739ae039 = $ba56bb58a40c98c6$var$FeedbackIframe;






// eslint-disable-next-line react/display-name
const $57a30357babe1d4b$var$LinkButton = /*#__PURE__*/ (0, ($parcel$interopDefault($8zHUo$react))).forwardRef(({ onClick: onClick , href: href , id: id , variant: variant , size: size , title: title , icon: icon , className: className  }, ref)=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
        href: href,
        ref: ref,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
            id: id,
            variant: variant,
            size: size,
            title: title,
            icon: icon,
            className: className
        })
    });
});
var $57a30357babe1d4b$export$2e2bcd8739ae039 = $57a30357babe1d4b$var$LinkButton;






const $9332f8245db3249e$var$arrayOptions = [
    {
        label: "Canada",
        value: "CA"
    },
    {
        label: "France",
        value: "FR"
    },
    {
        label: "United States",
        value: "USA"
    }
];
const $9332f8245db3249e$var$TestContainerAsyncSelect = (props)=>{
    const [isLoading, setIsLoading] = (0, $8zHUo$react.useState)(false);
    const [options, setOptions] = (0, $8zHUo$react.useState)([]);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $acfe242336feac07$export$2e2bcd8739ae039), {
        variant: "async",
        size: "large",
        cacheOptions: true,
        loadOptions: (input, callback)=>{
            setTimeout(()=>{
                callback($9332f8245db3249e$var$arrayOptions.filter((i)=>i.label.toLocaleLowerCase().includes(input.toLocaleLowerCase())));
            }, 1000);
        },
        onChange: (data)=>console.log({
                data: data
            }),
        onInputChange: (input)=>console.log({
                input: input
            }),
        defaultOptions: options,
        isLoading: isLoading,
        onMenuOpen: ()=>{
            setOptions([]);
            setIsLoading(true);
            setTimeout(()=>{
                setOptions($9332f8245db3249e$var$arrayOptions);
                setIsLoading(false);
            }, 1000);
        }
    });
};
var $9332f8245db3249e$export$2e2bcd8739ae039 = $9332f8245db3249e$var$TestContainerAsyncSelect;










const $f5cf44f19e560728$var$BreadcrumbItem = ({ href: href , children: children , id: id  })=>{
    if (href) return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
        href: href,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
            id: id,
            className: "text-inherit hover:text-inherit flex items-center ",
            children: children
        })
    });
    // in case we have just page name
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
        id: id,
        className: "text-inherit hover:text-inherit flex items-center ",
        children: children
    });
};
var $f5cf44f19e560728$export$2e2bcd8739ae039 = $f5cf44f19e560728$var$BreadcrumbItem;




function $ef737b92ca32bfc5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("svg", {
        className: " w-60 h-20 object-cover",
        viewBox: "0 0 108 119",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.24",
                        d: "M97.0751 21.4205C96.364 11.7768 88.9394 3.0381 79.5952 0.834877C71.1574 -1.15693 62.3364 1.80667 53.696 1.14274C50.343 0.883096 47.0379 0.078215 43.6738 -0.00709504C39.9761 -0.0734735 36.3128 0.716874 32.9669 2.30287C29.621 3.88886 26.6822 6.22804 24.3775 9.13962C18.9979 16.046 15.2912 24.6067 14.3774 33.3343C11.5771 60.1327 1.66175 66.8277 0.471621 74.4611C-4.13047 103.949 25.9397 117.717 49.8456 118.93C71.6475 120.043 100.774 106.159 104.437 101.452C109.732 94.635 108.192 77.5286 105.819 69.2127C103.917 62.5363 100.97 55.9117 100.406 48.9386C99.9417 43.156 100.487 39.7474 98.2247 34.0205C96.6403 30.0331 97.3846 25.6156 97.0751 21.4205Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M31.5294 92.6912L12.9699 97.9952L5.43488 71.2895L5.84755 70.6664L19.6502 67.2243L22.6679 68.2295L24.9486 69.3682L31.9421 92.068L31.5294 92.6912Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M99.1274 44.4577C99.1288 46.3655 98.7566 48.2549 98.032 50.0178C97.3074 51.7808 96.2446 53.3826 94.9045 54.7316C93.5643 56.0807 91.9731 57.1505 90.2219 57.8799C88.4706 58.6094 86.5937 58.9841 84.6984 58.9826H30.7445C26.951 59.0272 23.2927 57.5657 20.562 54.9146C17.8313 52.2636 16.248 48.6363 16.1549 44.8185C16.0619 41.0006 17.4667 37.2996 20.065 34.5169C22.6632 31.7342 26.2459 30.0939 30.037 29.9513C30.6022 26.7128 32.2817 23.778 34.7812 21.6613C37.2807 19.5446 40.4407 18.3812 43.707 18.3751H45.5493C48.776 18.3769 51.9019 19.5071 54.3924 21.5723C55.8067 17.9181 58.4465 14.8772 61.8542 12.9766C65.262 11.076 69.2229 10.4355 73.0505 11.1662C76.8781 11.8968 80.3312 13.9525 82.8112 16.977C85.2913 20.0014 86.6419 23.8041 86.6292 27.7258C86.6365 28.5091 86.5711 29.2914 86.4339 30.0625C89.932 30.4851 93.1551 32.1831 95.494 34.8355C97.8329 37.4879 99.1255 40.911 99.1274 44.4577Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M99.1274 44.4577C99.1288 46.3655 98.7566 48.2549 98.032 50.0178C97.3074 51.7808 96.2446 53.3826 94.9045 54.7316C93.5643 56.0807 91.9731 57.1505 90.2219 57.8799C88.4706 58.6094 86.5937 58.9841 84.6984 58.9826H30.7445C26.951 59.0272 23.2927 57.5657 20.562 54.9146C17.8313 52.2636 16.248 48.6363 16.1549 44.8185C16.0619 41.0006 17.4667 37.2996 20.065 34.5169C22.6632 31.7342 26.2459 30.0939 30.037 29.9513C30.6022 26.7128 32.2817 23.778 34.7812 21.6613C37.2807 19.5446 40.4407 18.3812 43.707 18.3751H45.5493C48.776 18.3769 51.9019 19.5071 54.3924 21.5723C55.8067 17.9181 58.4465 14.8772 61.8542 12.9766C65.262 11.076 69.2229 10.4355 73.0505 11.1662C76.8781 11.8968 80.3312 13.9525 82.8112 16.977C85.2913 20.0014 86.6419 23.8041 86.6292 27.7258C86.6365 28.5091 86.5711 29.2914 86.4339 30.0625C89.932 30.4851 93.1551 32.1831 95.494 34.8355C97.8329 37.4879 99.1255 40.911 99.1274 44.4577Z",
                        fill: "url(#paint0_linear)"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M98.9211 40.2774C98.9203 42.119 98.5482 43.9413 97.8275 45.634C97.1068 47.3267 96.0523 48.8546 94.728 50.1251C92.0035 52.756 88.3706 54.2188 84.5953 54.2052H31.0246C23.0952 54.2052 16.6729 47.9887 16.6729 40.2848C16.675 38.4428 17.0476 36.6203 17.7682 34.9272C18.4888 33.2341 19.5426 31.7054 20.866 30.4334C23.42 27.9655 26.7834 26.5246 30.3208 26.383C30.8129 23.6475 32.1547 21.1397 34.1528 19.2207C36.7718 16.6872 40.2664 15.2774 43.8986 15.289H45.7409C48.9253 15.2855 52.0177 16.3636 54.5177 18.349C56.9127 12.3662 62.8929 8.12666 69.9305 8.12666C79.0942 8.12666 86.5113 15.3335 86.5113 24.2391C86.5179 24.9856 86.4525 25.7309 86.316 26.4646C93.42 27.2992 98.9211 33.1633 98.9211 40.2774Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M30.6486 77.6024H21.496C21.2028 77.6024 20.9217 77.4852 20.7144 77.2765C20.5071 77.0678 20.3906 76.7848 20.3906 76.4897C20.3906 76.1945 20.5071 75.9115 20.7144 75.7028C20.9217 75.4941 21.2028 75.3769 21.496 75.3769H30.6486C31.3268 75.3769 31.9772 75.1057 32.4568 74.623C32.9363 74.1402 33.2057 73.4855 33.2057 72.8028V56.9425C33.2057 56.6474 33.3222 56.3644 33.5295 56.1557C33.7368 55.947 34.0179 55.8298 34.3111 55.8298C34.6043 55.8298 34.8854 55.947 35.0927 56.1557C35.3 56.3644 35.4165 56.6474 35.4165 56.9425V72.8139C35.4145 74.0852 34.9112 75.3037 34.0172 76.2016C33.1231 77.0995 31.9115 77.6034 30.6486 77.6024Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M85.2807 77.6024H76.1281C74.8665 77.6014 73.6567 77.0967 72.7643 76.199C71.8718 75.3013 71.3695 74.0839 71.3676 72.8139V56.9425C71.3676 56.6474 71.484 56.3644 71.6913 56.1557C71.8986 55.947 72.1798 55.8298 72.4729 55.8298C72.7661 55.8298 73.0473 55.947 73.2546 56.1557C73.4619 56.3644 73.5783 56.6474 73.5783 56.9425V72.8139C73.5783 73.4966 73.8477 74.1513 74.3273 74.6341C74.8069 75.1168 75.4573 75.388 76.1355 75.388H85.2881C85.5812 75.388 85.8624 75.5053 86.0697 75.7139C86.277 75.9226 86.3934 76.2057 86.3934 76.5008C86.3934 76.7959 86.277 77.0789 86.0697 77.2876C85.8624 77.4963 85.5812 77.6135 85.2881 77.6135L85.2807 77.6024Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.8345 98.1287C54.5414 98.1287 54.2602 98.0115 54.0529 97.8028C53.8456 97.5942 53.7291 97.3111 53.7291 97.016V58.1888C53.7291 57.8937 53.8456 57.6107 54.0529 57.402C54.2602 57.1933 54.5414 57.0761 54.8345 57.0761C55.1277 57.0761 55.4089 57.1933 55.6162 57.402C55.8235 57.6107 55.9399 57.8937 55.9399 58.1888V97.0197C55.9389 97.3142 55.822 97.5963 55.6149 97.8041C55.4077 98.012 55.1271 98.1287 54.8345 98.1287Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.5141 18.3491L58.2797 22.2697C58.2797 22.2697 60.6195 8.12304 75.3617 9.09484C75.3617 9.09484 61.4927 4.1654 54.5141 18.3491Z",
                        fill: "url(#paint1_linear)"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M30.3208 26.3831C30.3208 26.3831 32.9995 26.0826 35.5492 29.2057C35.5492 29.2057 36.0983 16.5947 46.7395 16.3758C46.7395 16.3758 42.3805 13.5717 36.3046 17.5183C30.8624 21.0493 30.3208 26.3831 30.3208 26.3831Z",
                        fill: "url(#paint2_linear)"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M31.9419 92.068L13.3825 97.372L5.84741 70.6663L20.0627 66.6011L23.0804 67.6025L25.3612 68.745L31.9419 92.068Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M20.0038 66.6011L23.2094 70.6811L25.4202 68.6708C25.4202 68.6708 22.4835 67.1463 20.0038 66.6011Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.1",
                        d: "M23.2094 70.67C23.2094 70.67 24.499 70.1767 24.9375 70.5662C25.376 70.9556 30.984 92.3573 30.984 92.3573L31.942 92.0643L25.4055 68.6597L23.2094 70.67Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M10.2542 75.6774L22.9772 72.2835L23.2351 73.0995L10.5269 76.549L10.2542 75.6774Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M11.0796 78.5371L23.8026 75.1433L24.0605 75.9593L11.3523 79.4088L11.0796 78.5371Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M11.9087 81.4005L24.628 78.0067L24.8896 78.819L12.1776 82.2684L11.9087 81.4005Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M12.734 84.2603L25.457 80.8664L25.715 81.6787L13.0067 85.1282L12.734 84.2603Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M44.2118 92.4835L64.9268 95.588L61.43 114.775L40.4535 111.103L44.2118 92.4835Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M44.0239 92.105L64.7389 95.2096L61.2422 114.397L40.2656 110.725L44.0239 92.105Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M44.2118 92.4835L64.363 95.6436L60.8958 113.922L40.623 110.347L44.2118 92.4835Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M45.6413 94.338L43.6111 105.692L52.8595 101.493L55.903 105.807L53.7622 107.735L58.5375 104.631L60.6783 107.431L62.8227 97.2905L45.6413 94.338Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M88.6188 89.4011L82.2112 80.4621L89.9489 68.4037L97.7308 78.9525C97.7308 78.9525 99.7205 82.7877 97.8229 84.5459C95.9254 86.304 93.9725 84.0637 94.0941 83.2403C94.2157 82.4168 96.7433 79.1602 96.7433 79.1602L92.1965 73.0995L85.4721 83.0474L90.4316 90.3766C91.537 92.3833 90.9216 95.0242 88.8988 96.0887C88.521 96.3073 88.0977 96.4339 87.6626 96.4584C87.2276 96.4829 86.7929 96.4045 86.3932 96.2296C83.9982 95.1837 88.6188 89.4011 88.6188 89.4011Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M88.9284 89.2973L82.5209 80.3583L90.2586 68.2999L98.0405 78.8487C98.0405 78.8487 100.03 82.6839 98.1326 84.442C96.235 86.2002 94.2822 83.9599 94.4038 83.1364C94.5254 82.313 97.053 79.0564 97.053 79.0564L92.5172 72.9994L85.7928 82.9473L90.756 90.2765C91.8614 92.2831 91.2424 94.924 89.2195 95.9886C88.8418 96.2072 88.4184 96.3338 87.9834 96.3583C87.5483 96.3827 87.1136 96.3044 86.714 96.1295C84.3116 95.0798 88.9284 89.2973 88.9284 89.2973Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        opacity: "0.44",
                        d: "M89.3743 89.2306L82.9704 80.2879L90.7081 68.2332L98.49 78.7782C98.49 78.7782 100.476 82.6135 98.5822 84.3753C96.6883 86.1371 94.7317 83.8931 94.8533 83.066C94.9749 82.2389 97.5026 78.9859 97.5026 78.9859L92.9557 72.9252L86.2276 82.8731L91.1908 90.2024C92.2962 92.2127 91.6809 94.8499 89.6543 95.9144C89.2775 96.1338 88.8547 96.2609 88.4201 96.2854C87.9855 96.3099 87.5512 96.2311 87.1525 96.0554C84.7574 95.0094 89.3743 89.2306 89.3743 89.2306Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.9046 77.2946C56.8073 77.2946 58.3497 75.7419 58.3497 73.8266C58.3497 71.9112 56.8073 70.3585 54.9046 70.3585C53.0019 70.3585 51.4595 71.9112 51.4595 73.8266C51.4595 75.7419 53.0019 77.2946 54.9046 77.2946Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M54.9046 78.3999C54.0051 78.4006 53.1255 78.1327 52.3772 77.6301C51.6289 77.1274 51.0455 76.4126 50.7009 75.5761C50.3563 74.7396 50.266 73.819 50.4413 72.9308C50.6166 72.0426 51.0498 71.2267 51.6859 70.5864C52.322 69.946 53.1325 69.51 54.0148 69.3335C54.8972 69.1571 55.8117 69.248 56.6427 69.5949C57.4736 69.9418 58.1837 70.529 58.683 71.2823C59.1824 72.0355 59.4485 72.921 59.4478 73.8265C59.4458 75.0389 58.9666 76.201 58.115 77.0582C57.2634 77.9155 56.109 78.3979 54.9046 78.3999ZM54.9046 71.4675C54.4412 71.4675 53.9881 71.6059 53.6027 71.8651C53.2173 72.1243 52.917 72.4927 52.7396 72.9238C52.5622 73.3549 52.5158 73.8292 52.6062 74.2868C52.6967 74.7444 52.9199 75.1647 53.2476 75.4946C53.5753 75.8245 53.9929 76.0492 54.4475 76.1402C54.902 76.2313 55.3732 76.1845 55.8014 76.006C56.2296 75.8274 56.5956 75.5251 56.8531 75.1371C57.1106 74.7492 57.2481 74.2931 57.2481 73.8265C57.2481 73.2009 57.0012 72.6009 56.5617 72.1585C56.1222 71.7161 55.5262 71.4675 54.9046 71.4675Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M72.6756 71.7494C74.5783 71.7494 76.1207 70.1967 76.1207 68.2814C76.1207 66.366 74.5783 64.8134 72.6756 64.8134C70.7729 64.8134 69.2304 66.366 69.2304 68.2814C69.2304 70.1967 70.7729 71.7494 72.6756 71.7494Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M72.6755 72.8547C71.7762 72.8547 70.8972 72.5863 70.1494 72.0833C69.4017 71.5804 68.8189 70.8656 68.4748 70.0292C68.1307 69.1929 68.0406 68.2726 68.2161 67.3847C68.3915 66.4969 68.8245 65.6813 69.4604 65.0412C70.0963 64.4011 70.9065 63.9651 71.7885 63.7885C72.6705 63.6119 73.5847 63.7026 74.4155 64.049C75.2463 64.3954 75.9565 64.9821 76.4561 65.7348C76.9557 66.4875 77.2224 67.3724 77.2224 68.2777C77.2214 69.4913 76.742 70.6549 75.8895 71.513C75.037 72.3712 73.8811 72.8537 72.6755 72.8547ZM72.6755 65.9187C72.212 65.9187 71.759 66.057 71.3736 66.3162C70.9882 66.5754 70.6879 66.9439 70.5105 67.3749C70.3331 67.806 70.2867 68.2803 70.3771 68.7379C70.4676 69.1955 70.6907 69.6158 71.0185 69.9457C71.3462 70.2756 71.7638 70.5003 72.2183 70.5913C72.6729 70.6824 73.1441 70.6356 73.5723 70.4571C74.0005 70.2785 74.3665 69.9762 74.624 69.5883C74.8815 69.2003 75.0189 68.7442 75.0189 68.2777C75.0151 67.6542 74.7666 67.0576 74.3276 66.6179C73.8887 66.1781 73.2948 65.9307 72.6755 65.9298V65.9187Z",
                        fill: "#687EFD"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M34.3775 71.7494C36.2802 71.7494 37.8227 70.1967 37.8227 68.2814C37.8227 66.366 36.2802 64.8134 34.3775 64.8134C32.4749 64.8134 30.9324 66.366 30.9324 68.2814C30.9324 70.1967 32.4749 71.7494 34.3775 71.7494Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("path", {
                        d: "M34.3775 72.8547C33.4781 72.8554 32.5987 72.5876 31.8505 72.0851C31.1022 71.5827 30.5189 70.8681 30.1742 70.0318C29.8295 69.1955 29.7389 68.2751 29.9139 67.387C30.089 66.4989 30.5217 65.683 31.1575 65.0425C31.7932 64.402 32.6034 63.9657 33.4855 63.7888C34.3676 63.6119 35.282 63.7023 36.113 64.0486C36.944 64.395 37.6544 64.9816 38.1541 65.7344C38.6539 66.4872 38.9207 67.3722 38.9207 68.2777C38.9187 69.4903 38.4396 70.6528 37.5881 71.5107C36.7366 72.3685 35.5822 72.8518 34.3775 72.8547ZM34.3775 65.9187C33.9141 65.9187 33.461 66.057 33.0756 66.3162C32.6902 66.5754 32.3899 66.9439 32.2125 67.3749C32.0351 67.806 31.9887 68.2803 32.0791 68.7379C32.1696 69.1955 32.3928 69.6158 32.7205 69.9457C33.0482 70.2756 33.4658 70.5003 33.9204 70.5913C34.3749 70.6824 34.8461 70.6356 35.2743 70.4571C35.7025 70.2785 36.0685 69.9762 36.326 69.5883C36.5835 69.2003 36.721 68.7442 36.721 68.2777C36.7171 67.6542 36.4686 67.0576 36.0296 66.6179C35.5907 66.1781 34.9968 65.9307 34.3775 65.9298V65.9187Z",
                        fill: "#687EFD"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("linearGradient", {
                        id: "paint0_linear",
                        x1: "57.5317",
                        y1: "37.3324",
                        x2: "61.7172",
                        y2: "202.087",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                offset: "0.95"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("linearGradient", {
                        id: "paint1_linear",
                        x1: "5065.86",
                        y1: "535.505",
                        x2: "3163.62",
                        y2: "2027.2",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                offset: "0.95"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("linearGradient", {
                        id: "paint2_linear",
                        x1: "2899.65",
                        y1: "798.882",
                        x2: "1435.84",
                        y2: "1716.7",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("stop", {
                                offset: "0.95"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("clipPath", {
                        id: "clip0",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("rect", {
                            width: "108",
                            height: "119",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
}






const $914ff39ce18c573d$var$BreadcrumbWrapper = ({ children: children , isExpanded: isExpanded , id: id  })=>{
    const [isExpand, setIsExpand] = (0, $8zHUo$react.useState)(isExpanded);
    // lets remove the new line from children
    const ChildrenArray = (0, ($parcel$interopDefault($8zHUo$react))).Children.toArray(children).filter((item)=>item != "\n");
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        id: id,
        "data-testid": "breadcrumb",
        className: "flex items-center space-x-1 capitalize text-xs font-medium text-gray-400",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                "data-testid": `breadcrumb-item-1`,
                className: " flex items-center space-x-1 text-gray-400 hover:text-gray-600",
                children: [
                    ChildrenArray[0],
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$744aedc8c31adee6), {
                        className: "w-3 h-3 transform -rotate-90 "
                    })
                ]
            }),
            ChildrenArray.length > 5 && !isExpand && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex items-center space-x-1",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                        onClick: ()=>{
                            setIsExpand(true);
                        },
                        className: "text-gray-400 hover:text-gray-600 cursor-pointer ",
                        children: "..."
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$744aedc8c31adee6), {
                        className: "w-3 h-3 transform -rotate-90 "
                    })
                ]
            }),
            (ChildrenArray.length < 5 || isExpand) && ChildrenArray.slice(1, ChildrenArray.length - 1).map((item)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                    "data-testid": `breadcrumb-item-${ChildrenArray.indexOf(item) + 1}`,
                    className: "flex items-center space-x-1 ",
                    children: [
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                            className: "text-gray-400 hover:text-gray-600 cursor-pointer ",
                            children: item
                        }),
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$744aedc8c31adee6), {
                            className: "w-3 h-3 transform -rotate-90 "
                        })
                    ]
                }, ChildrenArray.indexOf(item))),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                "data-testid": `breadcrumb-item-${ChildrenArray.length}`,
                className: " text-gray-500",
                children: ChildrenArray[ChildrenArray.length - 1]
            })
        ]
    });
};
var $914ff39ce18c573d$export$2e2bcd8739ae039 = $914ff39ce18c573d$var$BreadcrumbWrapper;


const $d931a28748357de7$var$Breadcrumb = ({ nav: nav , id: id  })=>{
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $914ff39ce18c573d$export$2e2bcd8739ae039), {
        id: id,
        children: nav.map((item)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $f5cf44f19e560728$export$2e2bcd8739ae039), {
                id: id + "-" + item.label.toLowerCase(),
                href: item.url,
                children: t(`${item.label}`)
            }, nav.indexOf(item)))
    });
};
var $d931a28748357de7$export$2e2bcd8739ae039 = $d931a28748357de7$var$Breadcrumb;







const $c72cc7078ff265fd$var$CardMain = ({ title: title , children: children , loading: loading = false , rows: rows = 3 , cols: cols = 1 , visible: visible = true , initialWidth: initialWidth , id: id  })=>{
    if (!visible) return null;
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: " md:w-auto w-full bg-white pt-2 pb-5 px-4 border-b border-r border-l border-gray-200 shadow-sm rounded-lg ",
        id: id,
        children: [
            loading ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "flex flex-col py-2",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                    className: "w-32 h-4 bg-gray-200 animate-pulse"
                })
            }) : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: `${title && "pt-2 pb-4"}  pt-1`,
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                    className: "text-lg text-gray-700 capitalize font-medium w-full border-b ",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: `${initialWidth}`,
                children: loading ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    className: "flex flex-col space-y-4",
                    children: Array(rows).fill(3).map((e)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                className: `p-2 grid grid-cols-${cols} gap-6 `,
                                children: Array(cols).fill(3).map((col)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        className: `bg-gray-200 animate-pulse rounded-md h-6 `
                                    }, Math.floor(Math.random() * 10000)))
                            })
                        }, Math.floor(Math.random() * 10000)))
                }) : children
            })
        ]
    });
};
var $c72cc7078ff265fd$export$2e2bcd8739ae039 = $c72cc7078ff265fd$var$CardMain;








const $297cf2030b5a81ff$var$TableRegular = ({ columns: columns , dataSource: dataSource , loading: loading , ...props })=>{
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: "relative ",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$antdlibtableTable))), {
            ...props,
            loading: loading,
            dataSource: dataSource,
            columns: columns,
            locale: {
                triggerDesc: t("Click to sort by descending"),
                triggerAsc: t("Click to sort by ascending"),
                cancelSort: t("Click to cancel sorting")
            }
        })
    });
};
var $297cf2030b5a81ff$export$2e2bcd8739ae039 = $297cf2030b5a81ff$var$TableRegular;







const $3269c668a5bedaa4$var$TableSidebox = ({ columns: columns , data: data , options: options , title: title  })=>{
    const [isVisible, setIsVisible] = (0, $8zHUo$react.useState)(false);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "flex flex-col bg-gray-50 border border-gray-100 p-3 w-full rounded-md",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "Title flex justify-between cursor-pointer hover:opacity-75 ",
                onClick: ()=>setIsVisible(!isVisible),
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                        className: " text-gray-500 ",
                        children: title
                    }),
                    isVisible ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                        onClick: ()=>setIsVisible(!isVisible),
                        className: "",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$744aedc8c31adee6), {
                            className: "w-4 h-4 text-gray-400 hover:text-gray-600"
                        })
                    }) : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                        onClick: ()=>setIsVisible(!isVisible),
                        className: "",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$59f995884fc5e26a), {
                            className: "w-4 h-4 text-gray-400 hover:text-gray-600"
                        })
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "md:w-full w-80 md:overflow-x-auto overflow-x-scroll",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$antdlibtableTable))), {
                    ...options,
                    rowSelection: {},
                    pagination: {
                        position: [
                            "bottomLeft"
                        ]
                    },
                    columns: columns,
                    dataSource: data
                })
            })
        ]
    });
};
var $3269c668a5bedaa4$export$2e2bcd8739ae039 = $3269c668a5bedaa4$var$TableSidebox;







const $cd8d8c08d73cec8e$var$rightMaxHeightTransition = {
    xsmall: "max-h-10   ",
    small: "max-h-20    ",
    medium: "max-h-40  ",
    tall: "max-h-48  ",
    xtall: "max-h-96  ",
    screen: "max-h-screen  "
};
const $cd8d8c08d73cec8e$var$Collapse = ({ children: children , icon: icon , isHeaderHighlighted: isHeaderHighlighted = false , colored: colored = true , ChevronOrientation: ChevronOrientation = "down" , border: border = false , isExpanded: isExpanded = false , title: title , maxHeight: maxHeight = "medium" , id: id , iconLink: iconLink  })=>{
    const [isVisible, setIsVisible] = (0, $8zHUo$react.useState)(isExpanded);
    (0, $8zHUo$react.useEffect)(()=>{
        setIsVisible(isExpanded);
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        id: id,
        className: `flex flex-col   ${border && "border"} rounded-lg  w-full `,
        "data-testid": "expander",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("button", {
                className: `flex   items-center justify-between py-3
                 ${isVisible && isHeaderHighlighted && "bg-gray-100"} 
                 ${isHeaderHighlighted && "bg-gray-100"} 
                 hover:bg-gray-100`,
                type: "button",
                "data-testid": "expander-button",
                id: id + "-button",
                onClick: ()=>setIsVisible(!isVisible),
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "flex items-center space-x-2 text-gray-700 px-1",
                        children: [
                            iconLink ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                                    href: iconLink,
                                    children: icon
                                })
                            }) : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                children: icon
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: `transform  
                ${ChevronOrientation == "right" && "-rotate-90  "} 
                ${isVisible && "rotate-180   "}
                  transition-transform duration-200 ease-linear  `,
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$59f995884fc5e26a), {
                            className: "w-4 h-5 text-gray-600"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                id: "wrapper",
                className: `
              ${isVisible ? $cd8d8c08d73cec8e$var$rightMaxHeightTransition[maxHeight] : "max-h-0 "} 
              ${colored && "bg-zinc-100"} `,
                children: [
                    isVisible && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                        "data-testid": "expander-isopened",
                        className: `h-0 w-0 `
                    }),
                    children
                ]
            })
        ]
    });
};
var $cd8d8c08d73cec8e$export$2e2bcd8739ae039 = $cd8d8c08d73cec8e$var$Collapse;





const $5dfea0bb116ddcc5$var$Header = (props)=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("header", {
        className: "flex items-center justify-end w-full p-1 border-b bg-gray-50 ",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
            className: "p-1 flex items-center space-x-2 px-3",
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    className: " flex items-center justify-center w-8 h-8 border rounded-full text-xs text-gray-600 font-medium bg-white",
                    children: "J"
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                    className: "text-gray-600 font-medium text-sm",
                    children: "John "
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$59f995884fc5e26a), {
                    className: "w-3 h-3 text-gray-400"
                })
            ]
        })
    });
};
var $5dfea0bb116ddcc5$export$2e2bcd8739ae039 = $5dfea0bb116ddcc5$var$Header;








// default

var $0b429255aad33af6$export$2e2bcd8739ae039 = (0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039);


// eslint-disable-next-line import/no-unresolved


const $afff8ad084a50781$var$types = {
    "Probl\xe9matique / Problem": 1,
    "Am\xe9lioration / Improvement": 2,
    "Ajout de fonctionnalit\xe9 / Addition of functionality": 3,
    Suggestion: 4,
    Question: 5
};
const $afff8ad084a50781$var$impacts = {
    "Futile / Trivial": 2,
    "Mineur / Minor": 3,
    "Majeur / Major": 4,
    "Critique / Critical": 5
};
const $afff8ad084a50781$var$Feedback = ({ firstName: firstName , lastName: lastName , demand: demand , email: email , phone: phone , url: url = window.location.href , type: type , impact: impact , ...props })=>{
    let baseUrl = "https://ticket-feedback.phpcreation.com/feedback";
    let qs = `?form[firstName]=${firstName ?? ""}&form[lastName]=${lastName ?? ""}&form[demand]=${demand ?? ""}&form[email]=${email ?? ""}&form[phone]=${phone ?? ""}&form[url]=${url ?? ""}&form[type]=${type ?? ""}&form[impact]=${impact ?? ""}`;
    const iframeUrl = baseUrl + qs;
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
            "data-testid": "iframe",
            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("iframe", {
                id: "frame",
                src: "https://dev.ticket-feedback.phpr.link/feedback" ?? "",
                width: 1000,
                height: 1000,
                ...props
            })
        })
    });
};
var $afff8ad084a50781$export$2e2bcd8739ae039 = $afff8ad084a50781$var$Feedback;






const $bd4a4726b6240f52$var$Footer = ({ fqcn_bui: fqcn_bui  })=>{
    const router = (0, $8zHUo$nextrouter.useRouter)();
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    const [isOpen, setIsOpen] = (0, $8zHUo$react.useState)(false);
    return(// Bottom of the screen
    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: "static bottom-0 w-full print:hidden",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("footer", {
            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer"),
            className: "flex items-center justify-center w-full p-2 border-t border-gray-200 flex-col",
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8945e51c91a55fa1$export$2e2bcd8739ae039), {
                    isOpen: isOpen,
                    handleClose: ()=>setIsOpen(false)
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "logo"),
                    className: "__Language",
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $4b45582cae2595be$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    className: "__Language",
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $0b429255aad33af6$export$2e2bcd8739ae039), {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "report-button"),
                        size: "xsmall",
                        title: t(`Report a Problem`),
                        onClick: ()=>setIsOpen(true),
                        bgcolor: "transparent",
                        color: "gray-500"
                    })
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("span", {
                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "powered-text"),
                    className: "text-xs font-medium text-gray-500 flex md:order-none order-last w-full justify-center",
                    children: [
                        t(`Powered`),
                        " ",
                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                            href: "https://phpcreation.com/",
                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                                target: "_blank",
                                className: "text-gray-500 hover:text-gray-500",
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("b", {
                                    children: "\xa0PHPCreation Inc."
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
var $bd4a4726b6240f52$export$2e2bcd8739ae039 = $bd4a4726b6240f52$var$Footer;







const $1a5096178588becb$var$TestContainerModal = (props)=>{
    const [isOpen, setIsOpen] = (0, $8zHUo$react.useState)(false);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "py-2 space-y-2",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                className: "text-gray-500 ",
                children: "Click here to open the modal "
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5fdb2d257c0eb8fa$export$2e2bcd8739ae039), {
                onClick: ()=>setIsOpen(true),
                variant: "primary",
                size: "small",
                title: "Open Modal"
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $c6ca657a0ac608c7$export$2e2bcd8739ae039), {
                title: "Default Modal",
                handleCancel: ()=>setIsOpen(false),
                hanldleOK: ()=>{
                    setIsOpen(false);
                },
                isOpen: isOpen,
                handleClose: ()=>setIsOpen(false),
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                    children: "this is a modal"
                })
            })
        ]
    });
};
var $1a5096178588becb$export$2e2bcd8739ae039 = $1a5096178588becb$var$TestContainerModal;






const $370bcc888ab41098$var$sizes = {
    xlarge: "p-2  w-full h-60 text-base",
    large: "p-2 w-96 h-40 text-base ",
    medium: "p-2 w-80 h-28 text-sm ",
    small: "p-2 w-60 h-20 text-sm ",
    xsmall: "p-1 w-44  h-16 text-xs ",
    auto: "p-1 w-auto h-auto",
    full: "w-full h-full"
};
const $370bcc888ab41098$var$CodeEditor = ({ defaultLanguage: defaultLanguage = "javascript" , size: size = "medium" , isDisabled: isDisabled = false , ...props })=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        "data-testid": "ide",
        className: `${$370bcc888ab41098$var$sizes[size]} border rounded-lg`,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$monacoeditorreact))), {
            defaultLanguage: defaultLanguage,
            options: {
                ...props.options,
                readOnly: isDisabled
            },
            ...props
        })
    });
};
var $370bcc888ab41098$export$2e2bcd8739ae039 = $370bcc888ab41098$var$CodeEditor;





const $1461237555295b62$var$RichTextEditor = ({ isDisabled: isDisabled = false , ...props })=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$tinymcetinymcereact.Editor), {
        disabled: isDisabled,
        tinymceScriptSrc: "/assets/libs/tinymce/tinymce.min.js",
        init: {
            // height: 500,
            menubar: false,
            plugins: [
                "advlist",
                "autolink",
                "lists",
                "link",
                "image",
                "charmap",
                "preview",
                "anchor",
                "searchreplace",
                "visualblocks",
                "code",
                "fullscreen",
                "insertdatetime",
                "media",
                "table",
                "code",
                "help",
                "wordcount"
            ],
            toolbar: "undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | image | code",
            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            ...props.init
        },
        ...props
    });
};
var $1461237555295b62$export$2e2bcd8739ae039 = $1461237555295b62$var$RichTextEditor;







var $6f63888b1c41df70$export$2e2bcd8739ae039 = (0, $fb3e40c1425686ec$export$2e2bcd8739ae039);


const $aecc8624ff6c67d5$var$DemoRich = ()=>{
    const [content, setContent] = (0, ($parcel$interopDefault($8zHUo$react))).useState("");
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $1461237555295b62$export$2e2bcd8739ae039), {
                initialValue: "initial value",
                onEditorChange: (v)=>{
                    setContent(v);
                }
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex flex-col space-y-2 py-3",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("label", {
                        onClick: ()=>console.log({
                                content: content
                            }),
                        children: "output:"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        className: "text-gray-600 text-sm border border-r-gray-50 rounded-lg shadow-md p-3 ",
                        children: content
                    })
                ]
            })
        ]
    });
};
var $aecc8624ff6c67d5$export$2e2bcd8739ae039 = $aecc8624ff6c67d5$var$DemoRich;





const $10f76c162c1d212a$var$DemoRich = ()=>{
    const [content, setContent] = (0, ($parcel$interopDefault($8zHUo$react))).useState("");
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $370bcc888ab41098$export$2e2bcd8739ae039), {
                size: "xlarge",
                language: "javascript",
                onChange: (v)=>{
                    if (v) setContent(v);
                }
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex flex-col space-y-2 py-3",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("label", {
                        onClick: ()=>console.log({
                                content: content
                            }),
                        children: "output:"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        className: "text-gray-600 text-sm border border-r-gray-50 rounded-lg shadow-md p-3 ",
                        children: content
                    })
                ]
            })
        ]
    });
};
var $10f76c162c1d212a$export$2e2bcd8739ae039 = $10f76c162c1d212a$var$DemoRich;





const $29684f8cc6c5104d$var$rightSize = {
    small: "tranform scale-75 ",
    medium: "",
    large: "tranform scale-125"
};
const $29684f8cc6c5104d$var$Toggle = ({ title: title , size: size = "medium" , ...rest })=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: `${$29684f8cc6c5104d$var$rightSize[size]}`,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$antd.Switch), {
            ...rest
        })
    });
};
var $29684f8cc6c5104d$export$2e2bcd8739ae039 = $29684f8cc6c5104d$var$Toggle;






const $e99b308431b3fe4c$var$Tour = (props)=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$reactjsxruntime.Fragment), {
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$reactjoyride))), {
            styles: props.styles ? props.styles : {
                options: {
                    arrowColor: "#fff",
                    backgroundColor: "#fff",
                    overlayColor: "rgba(0, 0, 0, 0.5)",
                    primaryColor: "#3d6ae4",
                    spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
                    textColor: "#333"
                }
            },
            ...props
        })
    });
};
var $e99b308431b3fe4c$export$2e2bcd8739ae039 = $e99b308431b3fe4c$var$Tour;






const $2ccd6e4903b02b82$var$steps_dev_show_1 = [
    {
        target: "#a",
        content: "Hi! I am letter A",
        title: "Tutorial",
        disableBeacon: true,
        placement: "top",
        disableScrollParentFix: true
    },
    {
        target: "#b",
        title: "Tutorial",
        content: "Hola! I am letter B",
        placement: "top"
    },
    {
        target: "#c",
        title: "Tutorial",
        content: "Salut ! I am letter C",
        placement: "top"
    }
];
const $2ccd6e4903b02b82$var$TourTestContainer = ({ steps: steps , ...props })=>{
    const [run, setRun] = (0, $8zHUo$react.useState)(false);
    const handleCallback = (data)=>{
        const { action: action , type: type , index: index , status: status  } = data;
        if (// If close button clicked then close the tour
        action === (0, $8zHUo$reactjoyride.ACTIONS).CLOSE || // If skipped or end tour, then close the tour
        status === (0, $8zHUo$reactjoyride.STATUS).SKIPPED && run || status === (0, $8zHUo$reactjoyride.STATUS).FINISHED) setRun(false);
    };
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "p-6 flex flex-col border shadow-md",
        "data-testid": "root",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                    className: "px-10 py-2 bg-blue-phpr text-gray-50 rounded-lg font-medium text-sm",
                    onClick: ()=>setRun(!run),
                    children: "Start"
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex justify-between items-center p-2",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "a",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "A"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "b",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "B"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "c",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $e99b308431b3fe4c$export$2e2bcd8739ae039), {
                callback: handleCallback,
                steps: $2ccd6e4903b02b82$var$steps_dev_show_1,
                run: run,
                ...props
            })
        ]
    });
};
var $2ccd6e4903b02b82$export$2e2bcd8739ae039 = $2ccd6e4903b02b82$var$TourTestContainer;






const $0dd51487be0e45df$var$TourControlledTest = ({ steps: steps , ...props })=>{
    const [isClickBtn1, setIsClickBtn1] = (0, $8zHUo$react.useState)(false);
    const [isClickBtn2, setIsClickBtn2] = (0, $8zHUo$react.useState)(false);
    // Casual tour
    const [stepIndex, setStepIndex] = (0, $8zHUo$react.useState)(0);
    // Controlled tour
    const [runControlled, setRunControlled] = (0, ($parcel$interopDefault($8zHUo$react))).useState(false);
    const [stepsControlled, setStepsControlled] = (0, $8zHUo$react.useState)([
        {
            target: "#z-2",
            content: "Hi there, Welcome onboard a Controlled tour, you will be asked to perform some actions to advance in the tour! Happy Tour!",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "#a-2",
            content: "mission 1 : click the button to continue to step 2 ",
            disableOverlayClose: true,
            showSkipButton: false,
            hideBackButton: true,
            hideCloseButton: true,
            hideFooter: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "#b-2",
            content: "Great ! Now mission 2 : click   the button to continue to step 3 ",
            disableOverlayClose: true,
            showSkipButton: false,
            hideBackButton: true,
            hideCloseButton: true,
            hideFooter: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "#c-2",
            content: " Mission Completed !You are done! Thanks",
            title: "Controlled Tuto",
            placement: "top-start"
        }
    ]);
    const handleControlledCallback = (data)=>{
        const { status: status , type: type , index: index , action: action , lifecycle: lifecycle  } = data;
        console.log({
            data: data
        });
        console.log(`------------step:${index}---------------`);
        if (index == 3 && lifecycle == (0, $8zHUo$reactjoyride.LIFECYCLE).COMPLETE) {
            setRunControlled(false);
            setStepIndex(0);
        }
        if ([
            (0, $8zHUo$reactjoyride.STATUS).FINISHED,
            (0, $8zHUo$reactjoyride.STATUS).SKIPPED
        ].includes(status)) {
            // Need to set our running state to false, so we can restart if we click start again.
            setRunControlled(false);
            setStepIndex(0);
        }
        if (index == 0 && action == (0, $8zHUo$reactjoyride.ACTIONS).NEXT) return setStepIndex(1);
        if (index == 1 && isClickBtn1) return setTimeout(()=>setRunControlled(true), 300);
        if (index == 2 && isClickBtn2) return setTimeout(()=>setRunControlled(true), 300);
        // if (isClickBtn1) return helpersControlled.current.next();
        console.groupCollapsed(type);
        console.log(data);
        console.groupEnd();
    };
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "p-6 flex flex-col border shadow-md",
        id: "z-2",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                    className: "px-10 py-2 bg-blue-phpr text-gray-50 rounded-lg font-medium text-sm",
                    onClick: ()=>setRunControlled(!runControlled),
                    children: "Start"
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex justify-between items-center p-4 mt-10",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                        onClick: ()=>{
                            setIsClickBtn1(!isClickBtn1);
                            setStepIndex(2);
                        },
                        id: "a-2",
                        className: "p-2 font-bold text-lg text-gray-600 border hover:border-blue-phpr shadow-sm rounded-lg px-4 ",
                        children: "button1"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                        id: "b-2",
                        onClick: ()=>{
                            setIsClickBtn2(!isClickBtn2), setStepIndex(3);
                        },
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "Button2"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        id: "c-2",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "FinishLine"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $e99b308431b3fe4c$export$2e2bcd8739ae039), {
                callback: handleControlledCallback,
                steps: stepsControlled,
                run: runControlled,
                continuous: true,
                stepIndex: stepIndex,
                ...props
            })
        ]
    });
};
var $0dd51487be0e45df$export$2e2bcd8739ae039 = $0dd51487be0e45df$var$TourControlledTest;








const $105abc3b490cb9f5$var$steps_dev_show_1 = [
    {
        target: "#a-1",
        title: "Tutorial",
        content: "Hi! I am letter A",
        disableBeacon: true,
        placement: "top",
        disableScrollParentFix: true
    },
    {
        target: "#b-1",
        title: "Tutorial",
        placement: "top",
        content: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                    children: "This is an image"
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextimage))), {
                    src: "/logo-black-trans.png",
                    width: 300,
                    height: 300,
                    alt: "logo"
                })
            ]
        })
    },
    {
        target: "#c-1",
        title: "Tutorial Variant",
        placement: "top-end",
        content: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                    className: "font-medium text-lg text-teal-600",
                    children: "Interactive Select"
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $acfe242336feac07$export$2e2bcd8739ae039), {
                    options: [
                        {
                            label: "USA",
                            value: "USA"
                        },
                        {
                            label: "Spain",
                            value: "spain"
                        }
                    ]
                })
            ]
        })
    }
];
const $105abc3b490cb9f5$var$TourBasicInteractive = ({ steps: steps , ...props })=>{
    console.log(props);
    const [run, setRun] = (0, $8zHUo$react.useState)(false);
    const handleCallback = (data)=>{
        const { action: action , type: type , index: index , status: status  } = data;
        if (// If close button clicked then close the tour
        action === (0, $8zHUo$reactjoyride.ACTIONS).CLOSE || // If skipped or end tour, then close the tour
        status === (0, $8zHUo$reactjoyride.STATUS).SKIPPED && run || status === (0, $8zHUo$reactjoyride.STATUS).FINISHED) setRun(false);
    };
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "p-6 flex flex-col border shadow-md",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                    className: "px-10 py-2 bg-blue-phpr text-gray-50 rounded-lg font-medium text-sm",
                    onClick: ()=>setRun(!run),
                    children: "Start"
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex justify-between items-center p-2",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "a-1",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "A"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "b-1",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "B"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "c-1",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $e99b308431b3fe4c$export$2e2bcd8739ae039), {
                callback: handleCallback,
                steps: $105abc3b490cb9f5$var$steps_dev_show_1,
                run: run,
                ...props
            })
        ]
    });
};
var $105abc3b490cb9f5$export$2e2bcd8739ae039 = $105abc3b490cb9f5$var$TourBasicInteractive;






const $c7ed335d56a3ffe6$var$steps_dev_show_1 = [
    {
        target: "#a-4",
        content: "Hi! I am letter A",
        title: "Tutorial #1",
        disableBeacon: true,
        placement: "top",
        disableScrollParentFix: true
    },
    {
        target: "#b-4",
        title: "Tutorial #1",
        content: "Salut ! I am letter C",
        placement: "top"
    },
    {
        target: "#z-4-1",
        title: "Tutorial #1",
        content: "Tutorial 1 finished",
        placement: "center"
    }
];
const $c7ed335d56a3ffe6$var$steps_dev_show_2 = [
    {
        target: "#c-4",
        content: "Hi! I am letter C",
        title: "Tutorial #2",
        disableBeacon: true,
        placement: "top",
        disableScrollParentFix: true
    },
    {
        target: "#d-4",
        title: "Tutorial #2",
        content: "Salut ! I am letter D",
        placement: "top"
    },
    {
        target: "#z-4-1",
        title: "Tutorial #2",
        content: "Tour 2 finsihed!",
        placement: "center"
    }
];
const $c7ed335d56a3ffe6$var$TourTestContainer = ({ steps: steps , ...props })=>{
    console.log(props);
    const [run_tuto_1, setRun_tuto_1] = (0, $8zHUo$react.useState)(false);
    const [run_tuto_2, setRun_tuto_2] = (0, $8zHUo$react.useState)(false);
    const handleCallback_tuto_1 = (data)=>{
        const { action: action , type: type , index: index , status: status  } = data;
        if (// If close button clicked then close the tour
        action === (0, $8zHUo$reactjoyride.ACTIONS).CLOSE || // If skipped or end tour, then close the tour
        status === (0, $8zHUo$reactjoyride.STATUS).SKIPPED && run_tuto_1 || status === (0, $8zHUo$reactjoyride.STATUS).FINISHED) {
            setRun_tuto_1(false);
            setTimeout(()=>{
                setRun_tuto_2(true);
            }, 600);
        }
    };
    const handleCallback_tuto_2 = (data)=>{
        const { action: action , type: type , index: index , status: status  } = data;
        if (// If close button clicked then close the tour
        action === (0, $8zHUo$reactjoyride.ACTIONS).CLOSE || // If skipped or end tour, then close the tour
        status === (0, $8zHUo$reactjoyride.STATUS).SKIPPED && run_tuto_2 || status === (0, $8zHUo$reactjoyride.STATUS).FINISHED) setRun_tuto_2(false);
    };
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "p-6 flex flex-col border shadow-md",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                id: "z-4-1",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                    className: "px-10 py-2 bg-blue-phpr text-gray-50 rounded-lg font-medium text-sm",
                    onClick: ()=>setRun_tuto_1(!run_tuto_1),
                    children: "Start"
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex justify-between items-center p-2",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "a-4",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "A"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "b-4",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "B"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "flex justify-between items-center p-2",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "c-4",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "C"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                        id: "d-4",
                        className: "p-2 font-bold text-lg text-gray-600 border shadow-sm rounded-lg px-4 ",
                        children: "D"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $e99b308431b3fe4c$export$2e2bcd8739ae039), {
                callback: handleCallback_tuto_1,
                steps: $c7ed335d56a3ffe6$var$steps_dev_show_1,
                run: run_tuto_1,
                ...props,
                continuous: true
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $e99b308431b3fe4c$export$2e2bcd8739ae039), {
                callback: handleCallback_tuto_2,
                steps: $c7ed335d56a3ffe6$var$steps_dev_show_2,
                run: run_tuto_2,
                ...props,
                continuous: true
            })
        ]
    });
};
var $c7ed335d56a3ffe6$export$2e2bcd8739ae039 = $c7ed335d56a3ffe6$var$TourTestContainer;







const $1a4e641a86266fe1$var$TourMultiplePage1 = ({ steps: steps , ...props })=>{
    const router = (0, $8zHUo$nextrouter.useRouter)();
    const { index: index  } = router.query;
    const [isClickBtn1, setIsClickBtn1] = (0, $8zHUo$react.useState)(false);
    const [isClickBtn2, setIsClickBtn2] = (0, $8zHUo$react.useState)(false);
    // Casual tour
    const [stepIndex, setStepIndex] = (0, $8zHUo$react.useState)(index ? Number(index) : 0);
    // Controlled tour
    const [runControlled, setRunControlled] = (0, ($parcel$interopDefault($8zHUo$react))).useState(!!index);
    const [stepsControlled, setStepsControlled] = (0, $8zHUo$react.useState)([
        {
            target: "#z-3",
            title: "multiple pages tuto",
            content: "Hi there, Welcome onboard a Controlled tour,You will be able to ride a tour with multiple pages! Happy Tour!",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "#a-3",
            title: "multiple pages tuto",
            content: "mission 1 : click the button to navigate to the next page ",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "#a-3",
            content: "mission 1 : click the button to continue to step 2 ",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "#a-3",
            content: "mission 1 : click the button to continue to step 2 ",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        }
    ]);
    const handleControlledCallback = (data)=>{
        const { status: status , type: type , index: index , action: action , lifecycle: lifecycle  } = data;
        console.log({
            data: data
        });
        console.log(`------------step:${index}---------------`);
        if ([
            (0, $8zHUo$reactjoyride.ACTIONS).CLOSE,
            (0, $8zHUo$reactjoyride.ACTIONS).STOP
        ].includes(action)) {
            // Need to set our running state to false, so we can restart if we click start again.
            setRunControlled(false);
            console.log("stop");
            setStepIndex(0);
        }
        if ([
            (0, $8zHUo$reactjoyride.STATUS).FINISHED,
            (0, $8zHUo$reactjoyride.STATUS).SKIPPED
        ].includes(status)) {
            // Need to set our running state to false, so we can restart if we click start again.
            setRunControlled(false);
            console.log("stop");
            setStepIndex(0);
        }
        if ([
            (0, $8zHUo$reactjoyride.STATUS).FINISHED,
            (0, $8zHUo$reactjoyride.STATUS).SKIPPED
        ].includes(status)) {
            // Need to set our running state to false, so we can restart if we click start again.
            setRunControlled(false);
            setStepIndex(0);
        }
        if (index == 0 && action == (0, $8zHUo$reactjoyride.ACTIONS).NEXT) return setStepIndex(1);
        if (index == 1 && action == (0, $8zHUo$reactjoyride.ACTIONS).PREV) return setStepIndex(0);
        if (index == 1 && action == (0, $8zHUo$reactjoyride.ACTIONS).NEXT && lifecycle == (0, $8zHUo$reactjoyride.LIFECYCLE).COMPLETE) return setTimeout(()=>{
            setRunControlled(true);
            router.push("/dev/components/Tours/tour-second-page?index=2");
        });
        if (index == 1 && isClickBtn1) return setTimeout(()=>{
            setRunControlled(true);
            router.push("/dev/components/Tours/tour-second-page?index=2");
        });
        if (index == 3 && lifecycle == (0, $8zHUo$reactjoyride.LIFECYCLE).COMPLETE) {
            setRunControlled(false);
            setStepIndex(0);
        }
        // if (isClickBtn1) return helpersControlled.current.next();
        console.groupCollapsed(type);
        console.log(data);
        console.groupEnd();
    };
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "p-6 flex flex-col border shadow-md",
        id: "z-3",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                    className: "px-10 py-2 bg-blue-phpr text-gray-50 rounded-lg font-medium text-sm",
                    onClick: ()=>setRunControlled(!runControlled),
                    children: "Start"
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "flex justify-between items-center p-4 mt-10",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                    onClick: ()=>{
                        setIsClickBtn1(!isClickBtn1);
                        setStepIndex(2);
                    },
                    id: "a-3",
                    className: "p-2 font-bold text-lg text-gray-600 border hover:border-blue-phpr shadow-sm rounded-lg px-4 ",
                    children: "Next Page"
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $e99b308431b3fe4c$export$2e2bcd8739ae039), {
                callback: handleControlledCallback,
                steps: stepsControlled,
                run: runControlled,
                continuous: true,
                stepIndex: stepIndex,
                ...props
            })
        ]
    });
};
var $1a4e641a86266fe1$export$2e2bcd8739ae039 = $1a4e641a86266fe1$var$TourMultiplePage1;







const $ed9993b237e0ea73$var$TourMultiplePage1 = ({ steps: steps , ...props })=>{
    const router = (0, $8zHUo$nextrouter.useRouter)();
    const { index: index  } = router.query;
    const [isClickBtn1, setIsClickBtn1] = (0, $8zHUo$react.useState)(false);
    // Casual tour
    const [stepIndex, setStepIndex] = (0, $8zHUo$react.useState)(index ? Number(index) : 2);
    // Controlled tour
    const [runControlled, setRunControlled] = (0, ($parcel$interopDefault($8zHUo$react))).useState(true);
    const [stepsControlled, setStepsControlled] = (0, $8zHUo$react.useState)([
        {
            target: "#z-3-2",
            title: "multiple pages tuto page-2",
            content: "Hi there, Welcome onboard a Controlled tour,You will be able to ride a tour with multiple pages! Happy Tour!",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "body",
            content: "next",
            placement: "top"
        },
        {
            target: "#z-3-2",
            title: "multiple pages tuto page-2",
            content: "Hi there, Welcome onboard a Controlled tour,You will be able to ride a tour with multiple pages! Happy Tour!",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        },
        {
            target: "#z-3-2",
            title: "multiple pages tuto page-2",
            content: "Well done!  ",
            disableBeacon: true,
            showSkipButton: false,
            disableOverlayClose: true,
            spotlightClicks: true,
            placement: "top"
        }
    ]);
    const handleControlledCallback = (data)=>{
        const { status: status , type: type , index: index , action: action , lifecycle: lifecycle  } = data;
        if ([
            (0, $8zHUo$reactjoyride.STATUS).FINISHED,
            (0, $8zHUo$reactjoyride.STATUS).SKIPPED
        ].includes(status)) {
            // Need to set our running state to false, so we can restart if we click start again.
            setRunControlled(false);
            setStepIndex(0);
        }
        if (index == 0 && action == (0, $8zHUo$reactjoyride.ACTIONS).NEXT) return setStepIndex(1);
        if (index == 1 && action == (0, $8zHUo$reactjoyride.ACTIONS).NEXT) return setStepIndex(2);
        if (index == 2 && action == (0, $8zHUo$reactjoyride.ACTIONS).PREV) router.push("/dev/components/Tours/tour?index=1");
        if (index == 2 && action == (0, $8zHUo$reactjoyride.ACTIONS).NEXT) {
            setStepIndex(3);
            return setTimeout(()=>setRunControlled(true), 300);
        }
        if (index == 3 && action == (0, $8zHUo$reactjoyride.ACTIONS).PREV) {
            setStepIndex(2);
            return setTimeout(()=>setRunControlled(true), 300);
        }
        if (index == 3 && action == (0, $8zHUo$reactjoyride.ACTIONS).NEXT) setRunControlled(false);
        console.groupCollapsed(type);
        console.log(data);
        console.groupEnd();
    };
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "p-6 flex flex-col border ",
        id: "z-3-2",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                id: "beta-3-2",
                className: "flex justify-center items-center p-4 mt-10 ",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("p", {
                    className: "text-lg font-medium text-blue-600",
                    children: "You are done !"
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $e99b308431b3fe4c$export$2e2bcd8739ae039), {
                showProgress: true,
                callback: handleControlledCallback,
                steps: stepsControlled,
                run: runControlled,
                continuous: true,
                stepIndex: stepIndex,
                ...props
            })
        ]
    });
};
var $ed9993b237e0ea73$export$2e2bcd8739ae039 = $ed9993b237e0ea73$var$TourMultiplePage1;







const $af2f8657ba9541a3$var$Home = (props)=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: "flex justify-between",
        "data-testid": "home-skeleton",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: "__SIDEBAR relative md:block hidden w-60 h-screen bg-gray-100 ring-2 ring-gray-100 ",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-full flex justify-center p-3 ",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: "w-24 h-10 bg-gray-300 rounded-full"
                        })
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: " flex flex-col space-y-4 py-20 ",
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5
                        ].map((i)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                className: "h-8 w-full bg-gray-200 "
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "absolute bottom-10 left-10",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: "h-6 w-20 bg-gray-200 rounded "
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("main", {
                className: "__Main flex-auto w-full h-full flex flex-col items-center animate-pulse p-4 space-y-5",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("header", {
                        className: "___MENU flex md:hidden justify-start w-full pb-4 ",
                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                            className: "w-14 h-6 bg-gray-300 "
                        })
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-60 h-4 md:mt-20 mt-6 py-2 rounded bg-gray-200"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-96 h-3 rounded bg-gray-200"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-96 h-3 rounded bg-gray-200"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "w-60 h-2 rounded bg-gray-200"
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "__Boxes pt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 xl:gap-20",
                        children: [
                            1,
                            2,
                            3
                        ].map((i)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("section", {
                                className: "w-72 flex flex-col items-center space-y-5 p-5 py-10 rounded border-2 border-gray-200 ",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "w-full h-2 bg-gray-300 rounded-lg "
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "w-full h-20 bg-gray-300 rounded-sm "
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "w-full h-2 bg-gray-300 rounded-lg "
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "w-full h-2 bg-gray-300 rounded-lg "
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "w-full h-2 bg-gray-300 rounded-lg "
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "w-20 mt-4 h-6 bg-gray-300 rounded-lg"
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
};
var $af2f8657ba9541a3$export$2e2bcd8739ae039 = $af2f8657ba9541a3$var$Home;













var $91fd5d3edb8dc255$export$2e2bcd8739ae039 = (0, $d931a28748357de7$export$2e2bcd8739ae039);
















const $8369c02fd6901fee$var$SidebarItem = ({ icon: icon , label: label , href: href , isMinimized: isMinimized , isHighlight: isHighlight , id: id  })=>{
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
        href: href,
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("a", {
            id: id,
            className: `flex  items-center h-9  space-x-2  hover:bg-slate-100 py-2 px-4  ${!isMinimized && isHighlight && "bg-slate-100"} `,
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    className: `${isHighlight ? "text-blue-600" : "text-gray-400"}`,
                    children: icon
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                    className: `capitalize md:text-sm  text-base font-medium text-gray-600 hover:text-gray-900 
             ${isMinimized ? " opacity-0 w-0 overflow-hidden" : "opacity-100"} transition-all duration-600 delay-300 `,
                    children: t(label)
                })
            ]
        })
    });
};
var $8369c02fd6901fee$export$2e2bcd8739ae039 = $8369c02fd6901fee$var$SidebarItem;





const $78be94a38c86ee48$var$SidebarDashboard = ({ page: page , fqcn_bui: fqcn_bui , appNav: appNav  })=>{
    const router = (0, $8zHUo$nextdistclientrouter.useRouter)();
    const [isOpen, setIsOpen] = (0, $8zHUo$react.useState)(false);
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    // const isSSR = useIsSSR();
    const ISSERVER = typeof window === "undefined";
    const [isMinimized, toggleMinimized] = (0, $8zHUo$react.useState)(!ISSERVER && // need type fix
    //@ts-ignore
    JSON.parse(localStorage?.getItem("sidebar")));
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
        className: `${isMinimized ? "w-16" : "w-40"}  transition-all ease-in-out duration-500 overflow-y-scroll`,
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: ` flex flex-col  fixed  ${isMinimized ? "w-16" : "w-40"} bg-white min-h-screen border-r border-r-gray-200 shadow-sm transition-all ease-in-out duration-500 `,
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: "__LOGO flex h-14 items-center justify-center py-2 -ml-2",
                        children: [
                            !isMinimized && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                                href: "/dashboard",
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header", "logo-image"),
                                    className: " border border-gray-100 rounded-xl transform scale-[0.53] hover:bg-gray-50 ",
                                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $59ff00cb4a4db4e4$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header", "close-button"),
                                onClick: ()=>{
                                    toggleMinimized(!isMinimized);
                                    localStorage.setItem("sidebar", JSON.stringify(!isMinimized));
                                },
                                className: "hover:text-gray-400",
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$94155298424a8522), {
                                    className: "w-5 h-5 text-gray-600 hover:text-inherit"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "links"),
                        className: "__Items flex flex-col space-y-2 py-3 ",
                        children: appNav.map((item)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8369c02fd6901fee$export$2e2bcd8739ae039), {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "links", item.label + "-link"),
                                icon: item.icon,
                                label: item.label,
                                href: item.url,
                                isMinimized: isMinimized,
                                isHighlight: item.label.toLocaleLowerCase() == page.toLocaleLowerCase()
                            }, appNav.indexOf(item)))
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer"),
                        className: "__User fixed bottom-12",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer", "logout-link"),
                                onClick: ()=>{
                                    // let first clear the token
                                    (0, $8zHUo$cookiesnext.removeCookies)("token");
                                    router.push("/login");
                                },
                                className: " flex flex-1 cursor-pointer items-center space-x-3 text-gray-400 hover:text-gray-700 py-5 px-4 z-50 ",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$e567233157f95aa8), {
                                        className: "w-4 h-4 text-gray-400"
                                    }),
                                    !isMinimized && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                        children: t(`Log out`)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                className: "__Bug-report",
                                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("button", {
                                    id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer", "bugreport-link"),
                                    className: " flex items-center h-9 space-x-2 px-4 text-gray-400 hover:text-gray-600",
                                    onClick: ()=>setIsOpen(true),
                                    children: [
                                        /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$8617ab0e4aa15e01), {
                                            className: "text-inherit w-4 h-4"
                                        }),
                                        !isMinimized && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                            className: "font-medium text-xs",
                                            children: t(`Report a problem`)
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8945e51c91a55fa1$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                handleClose: ()=>setIsOpen(false)
            })
        ]
    });
};
var $78be94a38c86ee48$export$2e2bcd8739ae039 = $78be94a38c86ee48$var$SidebarDashboard;














const $07c3f6e7f7081d88$var$SidebarDashboardMobile = ({ appNav: appNav , page: page , fqcn_bui: fqcn_bui  })=>{
    const router = (0, $8zHUo$nextdistclientrouter.useRouter)();
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    const [isOpen, setIsOpen] = (0, $8zHUo$react.useState)(false);
    const [isMobileOpened, setIsMobileOpened] = (0, $8zHUo$react.useState)(false);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, $8zHUo$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "absolute top-4 left-2 rounded-lg pt-1 z-50 ",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                    onClick: ()=>setIsMobileOpened(!isMobileOpened),
                    className: "hover:text-gray-400",
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$94155298424a8522), {
                        className: "w-6 h-6 text-gray-600 hover:text-inherit"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        className: `fixed top-0 bottom-0  left-0 ${isMobileOpened ? "w-56" : "w-0 transform -translate-x-10 overflow-hidden"}  transition-all duration-500 ease-in-out    bg-white`,
                        style: {
                            zIndex: 1000
                        },
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header"),
                                className: "__LOGO flex h-14 items-center justify-between px-5 py-2",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nextlink))), {
                                        href: "/dashboard",
                                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("a", {
                                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header", "logo-image"),
                                            className: " border border-gray-100 rounded-xl transform scale-[0.70] hover:bg-gray-50 ",
                                            children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $59ff00cb4a4db4e4$export$2e2bcd8739ae039), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("button", {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header", "close-button"),
                                        onClick: ()=>setIsMobileOpened(!isMobileOpened),
                                        className: "hover:text-gray-400",
                                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$94155298424a8522), {
                                            className: "w-5 h-5 text-gray-600 hover:text-inherit"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "links"),
                                className: `__Items flex flex-col space-y-2 py-3 ${isMobileOpened ? "opacity-100" : "opacity-0"}  transition-all duration-300 delay-100 ease-linear`,
                                children: appNav.map((item)=>/*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8369c02fd6901fee$export$2e2bcd8739ae039), {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "links", item.label + "-link"),
                                        icon: item.icon,
                                        label: item.label,
                                        href: item.url,
                                        isMinimized: false,
                                        isHighlight: item.label.toLocaleLowerCase() == page.toLocaleLowerCase()
                                    }, appNav.indexOf(item)))
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer"),
                                className: "__User absolute bottom-10",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer", "logout-link"),
                                        onClick: ()=>{
                                            // let first clear the token
                                            (0, $8zHUo$cookiesnext.removeCookies)("token");
                                            router.push("/login");
                                        },
                                        className: " flex flex-1 cursor-pointer items-center space-x-3 text-gray-400 hover:text-gray-700 p-5 ",
                                        children: [
                                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$e567233157f95aa8), {
                                                className: "w-4 h-4 text-gray-400"
                                            }),
                                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                                children: "Log out"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "__Bug-report",
                                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("button", {
                                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "footer", "bugreport-link"),
                                            className: " flex items-center h-9 space-x-2 px-5 text-gray-400 hover:text-gray-600",
                                            onClick: ()=>{
                                                setIsOpen(true);
                                                setIsMobileOpened(false);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$8617ab0e4aa15e01), {
                                                    className: "text-inherit w-4 h-4"
                                                }),
                                                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("span", {
                                                    className: "font-medium text-xs",
                                                    children: t(`Report a problem`)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    isMobileOpened && /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                        className: "fixed top-0 right-0 left-0 bottom-0 backdrop-brightness-75 z-50 ",
                        onClick: ()=>setIsMobileOpened(false)
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8945e51c91a55fa1$export$2e2bcd8739ae039), {
                        isOpen: isOpen,
                        handleClose: ()=>setIsOpen(false)
                    })
                ]
            })
        ]
    });
};
var $07c3f6e7f7081d88$export$2e2bcd8739ae039 = $07c3f6e7f7081d88$var$SidebarDashboardMobile;


const $5a923ab70f6d5e4c$var$SidebarMain = ({ page: page , appNav: appNav , Logo: Logo , LogoMinimized: LogoMinimized , fqcn_bui: fqcn_bui  })=>{
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("nav", {
        className: "print:hidden",
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: `hidden md:block`,
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $78be94a38c86ee48$export$2e2bcd8739ae039), {
                    fqcn_bui: fqcn_bui,
                    page: page,
                    Logo: Logo,
                    LogoMinimized: LogoMinimized,
                    appNav: appNav
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                className: "block md:hidden",
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $07c3f6e7f7081d88$export$2e2bcd8739ae039), {
                    appNav: appNav,
                    fqcn_bui: fqcn_bui,
                    page: page,
                    Logo: Logo,
                    LogoMinimized: LogoMinimized
                })
            })
        ]
    });
};
var $5a923ab70f6d5e4c$export$2e2bcd8739ae039 = $5a923ab70f6d5e4c$var$SidebarMain;


const $347e58672d17cf52$var$PageLayout = ({ title: title , breadcrumbNav: breadcrumbNav , appNav: appNav , fqcn_bui: fqcn_bui , children: children , pageTitle: pageTitle  })=>{
    const { t: t  } = (0, $82c7348de3dc7374$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, $8zHUo$reactjsxruntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, ($parcel$interopDefault($8zHUo$nexthead))), {
                children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("title", {
                    children: t(pageTitle || title)
                })
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                className: " min-h-screen w-full ml-0 flex bg-grayish",
                children: [
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $5a923ab70f6d5e4c$export$2e2bcd8739ae039), {
                        appNav: appNav,
                        page: t(title),
                        fqcn_bui: {
                            Bundle: "appBundle",
                            Unit: "main",
                            Interface: "menu"
                        }
                    }),
                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, ""),
                        className: "__MIddle flex flex-col min-h-screen flex-1 w-full ",
                        children: [
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("header", {
                                id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header"),
                                className: "__Header flex flex-col space-y-0 pt-4 pl-10 lg:pl-5 ",
                                children: [
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                                        className: "__Title h-10 flex flex-col mb-[0.5px] ",
                                        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("h1", {
                                            id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header", "title"),
                                            className: "capitalize text-xl md:text-xl font-medium text-gray-700 ",
                                            children: t(title)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $91fd5d3edb8dc255$export$2e2bcd8739ae039), {
                                        nav: breadcrumbNav,
                                        id: (0, $14899fc8b120af69$export$c11f7f0cac96af2a)(fqcn_bui, "header", "breadcrumbs")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("main", {
                                className: "flex-grow p-4",
                                children: children
                            }),
                            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $bd4a4726b6240f52$export$2e2bcd8739ae039), {
                                fqcn_bui: {
                                    Bundle: "appBundle",
                                    Unit: "main",
                                    Interface: "footer"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$reacthottoast.Toaster), {
                position: "bottom-right",
                toastOptions: {
                    style: {
                        color: "#fff",
                        backgroundColor: "#000"
                    }
                }
            })
        ]
    });
};
var $347e58672d17cf52$export$2e2bcd8739ae039 = $347e58672d17cf52$var$PageLayout;









const $b5d8fc0c2957cad4$var$FrameContainer = ({ isOpen: isOpen , handleClose: handleClose , children: children  })=>{
    return isOpen ? /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
        className: "flex justify-center z-50 relative w-full",
        children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)("div", {
            className: "absolute bottom-0 w-full small-mobile-v:w-full mobile-v:w-10/12 mobile-h:w-8/12",
            children: [
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $0b429255aad33af6$export$2e2bcd8739ae039), {
                        onClick: handleClose,
                        size: "small",
                        bgcolor: "transparent",
                        icon: /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $89c98702a6323988$export$403194946ee83bdf), {
                            className: "w-10 h-10"
                        }),
                        className: "w-full",
                        color: "black"
                    })
                }),
                /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)("div", {
                    children: children
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$reactjsxruntime.Fragment), {});
};
var $b5d8fc0c2957cad4$export$2e2bcd8739ae039 = $b5d8fc0c2957cad4$var$FrameContainer;






//






var $c95adea1dc38c354$exports = {};
$c95adea1dc38c354$exports = JSON.parse('{"Add":"Add","Add ":"Add ","add":"Add","Filters":"Filters","filters":"filters","Filter":"Filter","filter":"filter","Stack":"Stack","stack":"stack","Log in":"Log in","Log out":"Log out","Forgot password?":"Forgot password?","Username":"Username","Password":"Password","Loading...":"Loading...","For dev":"For development purposes, the following credentials are valid in order to access the application.","Powered":"Powered by ","Authenticated":"Authenticated","Wrong Data":"Wrong Data","Success!":"Success!","Dashboard":"Dashboard","Report a problem":"Report a problem","Bug report":"Bug report","Welcome on Board":"Welcome on Board","Manage":"Manage","Selected fields":"Selected fields","Selected actions":"Selected actions","Cancel":"Cancel","Confirm":"Confirm","Delete ":"Delete ","Duplicate ":"Duplicate ","Edit ":"Edit ","edit ":"edit ","Edit":"Edit","edit":"edit","Create":"Create","Name":"Name","name":"name","Do you really want to delete this":"Do you really want to delete this ","new":"new","Home":"Home","search":"Search","fileds":"Fileds","exports":"Exports","Actions":"Actions","actions":"actions","Action":"Action","action":"action","print":"Print","clear":"clear","apply":"apply","show":"show","delete":"delete","duplicate":"duplicate","Quick":"Quick","detailed":"detailed","Tour":"Tour","value":"value","Value":"Value","id":"id","information":"information","select Id from the list":"select Id from the list","input the name":"input the name","input the value":"input the value","input the stack":"input the value","Click to sort by descending":"Click to sort by descending","Click to sort by ascending":"Click to sort by ascending","Click to cancel sorting":"Click to cancel sorting","Support plan":"Support plan","Emergency":"Emergency","Request or Problem*":"Request or Problem*","First name*":"First name*","Last name*":"Last name*","Email Address*":"Email Address*","Phone*":"Phone*","URL*":"URL*","Send":"Send","Your request/description has been received.":"Your request/description has been received.","You will receive a follow up shortly.":"You will receive a follow up shortly.","Note the confirmation number :":"Note the confirmation number :","View/manage your ticket here :":"View/manage your ticket here :","Click here to view ticket":"Click here to view ticket","New Ticket":"New Ticket"}');


var $f07e6a0fc979bd24$exports = {};
$f07e6a0fc979bd24$exports = JSON.parse('{"Add":"Ajouter","Add ":"Ajouter un ","add":"Ajout","Filters":"Filtres","filters":"filtres","Filter":"Filtre","filter":"filtre","Stack":"Paquet","stack":"paquet","Log in":"S\'authentifier","Log out":"Se d\xe9connecter","Forgot password?":"Mot de passe oubli\xe9?","Username":"Nom d\'utilisateur","Password":"Mot de passe","Loading...":"Chargement...","For dev":"Les informations d\'identification suivantes sont fournies aux d\xe9veloppeurs pour naviguer l\'application.","Powered":"Un produit de ","Authenticated":"Authentifi\xe9","Wrong Data":"Donn\xe9es erron\xe9es","Success!":"Succ\xe8s!","Dashboard":"Tableau de bord","Report a problem":"Signaler un probl\xe8me","Bug report":"Signaler une erreur","Welcome on Board":"Bienvenue!","Manage":"G\xe9rer","Selected fields":"Champs s\xe9lectionn\xe9","Selected actions":"Actions s\xe9lectionn\xe9","Cancel":"Annuler","Confirm":"Confirmer","Delete ":"Supprimer ","Duplicate ":"Dupliquer ","Edit ":"Modifier ","edit ":"modifier ","Edit":"Modifier","edit":"modifier","Create":"Cr\xe9er","Name":"Nom","name":"nom","Do you really want to delete this":"Voulez-vous vraiment supprimer ce ","new":"nouveau","Home":"Accueil","search":"Chercher","fileds":"Champs","exports":"Exporter","Actions":"Actions","actions":"actions","Action":"Action","action":"action","print":"Imprimer","clear":"effacer","apply":"Appliquer","show":"afficher","delete":"supprimer","duplicate":"dupliquer","Quick":"Rapide","detailed":"D\xe9taill\xe9","Tour":"Guide","value":"valeur","Value":"Valeur","id":"id","information":"informations","select Id from the list":"s\xe9lectionn\xe9 un id a partir de la liste","input the name":"saisir le nom","input the value":"saisir la valeur","input the stack":"saisir le paquet","Click to sort by descending":"Cliquez pour trier par ordre d\xe9croissant","Click to sort by ascending":"Cliquez pour trier par ordre croissant","Click to cancel sorting":"Cliquez pour annuler le triage","tickets":"billets","Open ticket":"Ouvrir billet","Close ticket":"Fermer billet","Support plan":"Plan de support","Emergency":"Urgence","Request or Problem*":"Demande ou Probl\xe8me*","First name*":"Pr\xe9nom*","Last name*":"Nom*","Email Address*":"Adresse Courriel*","Phone*":"T\xe9l\xe9phone*","URL*":"URL*","Send":"Envoyer","Your request/description has been received.":"Votre demande/description de probl\xe9matique a bien \xe9t\xe9 re\xe7ue","You will receive a follow up shortly.":"Vous recevrez un suivi sous peu","Note the confirmation number :":"Notez le num\xe9ro de confirmation suivant","View/manage your ticket here :":"Consultez/g\xe9rez votre ticket au lien suivant","Click here to view ticket":"Cliquez ici pour voir le ticket","New Ticket":"Nouveau Ticket"}');


var $097b622f1a57422e$exports = {};
$097b622f1a57422e$exports = JSON.parse('{"Add":"Add","Add ":"Add ","add":"Add","Filters":"Filters","filters":"filters","Filter":"Filter","filter":"filter","Stack":"Stack","stack":"stack","Log in":"Log in","Log out":"Log out","Forgot password?":"Forgot password?","Username":"Username","Password":"Password","Loading...":"Loading...","For dev":"For development purposes, the following credentials are valid in order to access the application.","Powered":"Powered by ","Authenticated":"Authenticated","Wrong Data":"Wrong Data","Success!":"Success!","Dashboard":"Dashboard","Report a problem":"Report a problem","Bug report":"Bug report","Welcome on Board":"Welcome on Board","Manage":"Manage","Selected fields":"Selected fields","Selected actions":"Selected actions","Cancel":"Cancel","Confirm":"Confirm","Delete ":"Delete ","Duplicate ":"Duplicate ","Edit ":"Edit ","edit ":"edit ","Edit":"Edit","edit":"edit","Create":"Create","Name":"Name","name":"name","Do you really want to delete this":"Do you really want to delete this ","new":"new","Home":"Home","search":"Search","fileds":"Fileds","exports":"Exports","Actions":"Actions","actions":"actions","Action":"Action","action":"action","print":"Print","clear":"clear","apply":"apply","show":"show","delete":"delete","duplicate":"duplicate","Quick":"Quick","detailed":"detailed","Tour":"Tour","value":"value","Value":"Value","id":"id","information":"information","select Id from the list":"select Id from the list","input the name":"input the name","input the value":"input the value","input the stack":"input the value","Click to sort by descending":"Click to sort by descending","Click to sort by ascending":"Click to sort by ascending","Click to cancel sorting":"Click to cancel sorting","Support plan":"Plan de support / Support plan","Emergency":"Urgence /\xa0Emergency","Request or Problem*":"Demande ou Probl\xe8me* / Request or Problem*","First name*":"Pr\xe9nom* / First name*","Last name*":"Nom* / Last name*","Email Address*":"Adresse Courriel* / Email Address*","Phone*":"T\xe9l\xe9phone* / Phone*","URL*":"URL*","Send":"Envoyer / Send","Your request/description has been received.":"Votre demande/description de probl\xe9matique a bien \xe9t\xe9 re\xe7ue / Your request/description has been received.","You will receive a follow up shortly.":"Vous recevrez un suivi sous peu / You will receive a follow up shortly.","Note the confirmation number :":"Notez le num\xe9ro de confirmation suivant / Note the confirmation number :","View/manage your ticket here :":"Consultez/g\xe9rez votre ticket au lien suivant / View/manage your ticket here :","Click here to view ticket":"Cliquez ici pour voir le ticket / Click here to view ticket","New Ticket":"Nouveau Ticket / New Ticket"}');




const $c022715bc9d219e1$var$messages = {
    en: (/*@__PURE__*/$parcel$interopDefault($c95adea1dc38c354$exports)),
    fr: (/*@__PURE__*/$parcel$interopDefault($f07e6a0fc979bd24$exports)),
    bi: (/*@__PURE__*/$parcel$interopDefault($097b622f1a57422e$exports))
};
const $c022715bc9d219e1$var$AppContext = ({ children: children , endpoints: endpoints , extraMessages: extraMessages  })=>{
    const { locale: locale  } = (0, $8zHUo$nextrouter.useRouter)();
    const [queryClient] = (0, ($parcel$interopDefault($8zHUo$react))).useState(()=>new (0, $8zHUo$tanstackreactquery.QueryClient)({
            defaultOptions: {
                queries: {
                    staleTime: 30000,
                    retry: false,
                    refetchOnWindowFocus: true,
                    refetchOnMount: true
                }
            }
        }));
    (0, $8zHUo$react.useEffect)(()=>{
        (0, $35515d2b18f14e87$export$c5a13a81cd4fc74d)(endpoints);
        (0, $c7d5b4ea505ed32f$export$2e2bcd8739ae039).defaults.baseURL = (0, $35515d2b18f14e87$export$30dba1e0a1cb02c9).crud;
        if (extraMessages) {
            Object.assign($c022715bc9d219e1$var$messages.en, extraMessages.en);
            Object.assign($c022715bc9d219e1$var$messages.fr, extraMessages.fr);
            Object.assign($c022715bc9d219e1$var$messages.bi, extraMessages.bi);
        }
    }, []);
    return /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsxs)((0, $8zHUo$tanstackreactquery.QueryClientProvider), {
        client: queryClient,
        children: [
            // issue: local can be undefined,but this is already hundled by Next.js
            //@ts-ignore
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$reactintl.IntlProvider), {
                locale: locale,
                messages: $c022715bc9d219e1$var$messages[locale],
                children: children
            }),
            /*#__PURE__*/ (0, $8zHUo$reactjsxruntime.jsx)((0, $8zHUo$tanstackreactquerydevtools.ReactQueryDevtools), {
                initialIsOpen: false
            })
        ]
    });
};
var // export default MyApp;
$c022715bc9d219e1$export$2e2bcd8739ae039 = $c022715bc9d219e1$var$AppContext;


$parcel$exportWildcard(module.exports, $dc63f80450721a53$exports);
$parcel$exportWildcard(module.exports, $355f333c554f9d5c$exports);
$parcel$exportWildcard(module.exports, $89c98702a6323988$exports);


//# sourceMappingURL=index.js.map
